var moo = (function () {
  'use strict';

  var hasOwnProperty = Object.prototype.hasOwnProperty
  var toString = Object.prototype.toString
  var hasSticky = typeof new RegExp().sticky === 'boolean'

  /***************************************************************************/

  function isRegExp(o) { return o && toString.call(o) === '[object RegExp]' }
  function isObject(o) { return o && typeof o === 'object' && !isRegExp(o) && !Array.isArray(o) }

  function reEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
  }
  function reGroups(s) {
    var re = new RegExp('|' + s)
    return re.exec('').length - 1
  }
  function reCapture(s) {
    return '(' + s + ')'
  }
  function reUnion(regexps) {
    if (!regexps.length) return '(?!)'
    var source = regexps.map(function (s) {
      return "(?:" + s + ")"
    }).join('|')
    return "(?:" + source + ")"
  }

  function regexpOrLiteral(obj) {
    if (typeof obj === 'string') {
      return '(?:' + reEscape(obj) + ')'

    } else if (isRegExp(obj)) {
      // TODO: consider /u support
      if (obj.ignoreCase) throw new Error('RegExp /i flag not allowed')
      if (obj.global) throw new Error('RegExp /g flag is implied')
      if (obj.sticky) throw new Error('RegExp /y flag is implied')
      if (obj.multiline) throw new Error('RegExp /m flag is implied')
      return obj.source

    } else {
      throw new Error('Not a pattern: ' + obj)
    }
  }

  function pad(s, length) {
    if (s.length > length) {
      return s
    }
    return Array(length - s.length + 1).join(" ") + s
  }

  function lastNLines(string, numLines) {
    var position = string.length
    var lineBreaks = 0;
    while (true) {
      var idx = string.lastIndexOf("\n", position - 1)
      if (idx === -1) {
        break;
      } else {
        lineBreaks++
      }
      position = idx
      if (lineBreaks === numLines) {
        break;
      }
      if (position === 0) {
        break;
      }
    }
    var startPosition =
      lineBreaks < numLines ?
        0 :
        position + 1
    return string.substring(startPosition).split("\n")
  }

  function objectToRules(object) {
    var keys = Object.getOwnPropertyNames(object)
    var result = []
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i]
      var thing = object[key]
      var rules = [].concat(thing)
      if (key === 'include') {
        for (var j = 0; j < rules.length; j++) {
          result.push({ include: rules[j] })
        }
        continue
      }
      var match = []
      rules.forEach(function (rule) {
        if (isObject(rule)) {
          if (match.length) result.push(ruleOptions(key, match))
          result.push(ruleOptions(key, rule))
          match = []
        } else {
          match.push(rule)
        }
      })
      if (match.length) result.push(ruleOptions(key, match))
    }
    return result
  }

  function arrayToRules(array) {
    var result = []
    for (var i = 0; i < array.length; i++) {
      var obj = array[i]
      if (obj.include) {
        var include = [].concat(obj.include)
        for (var j = 0; j < include.length; j++) {
          result.push({ include: include[j] })
        }
        continue
      }
      if (!obj.type) {
        throw new Error('Rule has no type: ' + JSON.stringify(obj))
      }
      result.push(ruleOptions(obj.type, obj))
    }
    return result
  }

  function ruleOptions(type, obj) {
    if (!isObject(obj)) {
      obj = { match: obj }
    }
    if (obj.include) {
      throw new Error('Matching rules cannot also include states')
    }

    // nb. error and fallback imply lineBreaks
    var options = {
      defaultType: type,
      lineBreaks: !!obj.error || !!obj.fallback,
      pop: false,
      next: null,
      push: null,
      error: false,
      fallback: false,
      value: null,
      type: null,
      shouldThrow: false,
    }

    // Avoid Object.assign(), so we support IE9+
    for (var key in obj) {
      if (hasOwnProperty.call(obj, key)) {
        options[key] = obj[key]
      }
    }

    // type transform cannot be a string
    if (typeof options.type === 'string' && type !== options.type) {
      throw new Error("Type transform cannot be a string (type '" + options.type + "' for token '" + type + "')")
    }

    // convert to array
    var match = options.match
    options.match = Array.isArray(match) ? match : match ? [match] : []
    options.match.sort(function (a, b) {
      return isRegExp(a) && isRegExp(b) ? 0
        : isRegExp(b) ? -1 : isRegExp(a) ? +1 : b.length - a.length
    })
    return options
  }

  function toRules(spec) {
    return Array.isArray(spec) ? arrayToRules(spec) : objectToRules(spec)
  }

  var defaultErrorRule = ruleOptions('error', { lineBreaks: true, shouldThrow: true })
  function compileRules(rules, hasStates) {
    var errorRule = null
    var fast = Object.create(null)
    var fastAllowed = true
    var unicodeFlag = null
    var groups = []
    var parts = []

    // If there is a fallback rule, then disable fast matching
    for (var i = 0; i < rules.length; i++) {
      if (rules[i].fallback) {
        fastAllowed = false
      }
    }

    for (var i = 0; i < rules.length; i++) {
      var options = rules[i]

      if (options.include) {
        // all valid inclusions are removed by states() preprocessor
        throw new Error('Inheritance is not allowed in stateless lexers')
      }

      if (options.error || options.fallback) {
        // errorRule can only be set once
        if (errorRule) {
          if (!options.fallback === !errorRule.fallback) {
            throw new Error("Multiple " + (options.fallback ? "fallback" : "error") + " rules not allowed (for token '" + options.defaultType + "')")
          } else {
            throw new Error("fallback and error are mutually exclusive (for token '" + options.defaultType + "')")
          }
        }
        errorRule = options
      }

      var match = options.match.slice()
      if (fastAllowed) {
        while (match.length && typeof match[0] === 'string' && match[0].length === 1) {
          var word = match.shift()
          fast[word.charCodeAt(0)] = options
        }
      }

      // Warn about inappropriate state-switching options
      if (options.pop || options.push || options.next) {
        if (!hasStates) {
          throw new Error("State-switching options are not allowed in stateless lexers (for token '" + options.defaultType + "')")
        }
        if (options.fallback) {
          throw new Error("State-switching options are not allowed on fallback tokens (for token '" + options.defaultType + "')")
        }
      }

      // Only rules with a .match are included in the RegExp
      if (match.length === 0) {
        continue
      }
      fastAllowed = false

      groups.push(options)

      // Check unicode flag is used everywhere or nowhere
      for (var j = 0; j < match.length; j++) {
        var obj = match[j]
        if (!isRegExp(obj)) {
          continue
        }

        if (unicodeFlag === null) {
          unicodeFlag = obj.unicode
        } else if (unicodeFlag !== obj.unicode && options.fallback === false) {
          throw new Error('If one rule is /u then all must be')
        }
      }

      // convert to RegExp
      var pat = reUnion(match.map(regexpOrLiteral))

      // validate
      var regexp = new RegExp(pat)
      if (regexp.test("")) {
        throw new Error("RegExp matches empty string: " + regexp)
      }
      var groupCount = reGroups(pat)
      if (groupCount > 0) {
        throw new Error("RegExp has capture groups: " + regexp + "\nUse (?: … ) instead")
      }

      // try and detect rules matching newlines
      if (!options.lineBreaks && regexp.test('\n')) {
        throw new Error('Rule should declare lineBreaks: ' + regexp)
      }

      // store regex
      parts.push(reCapture(pat))
    }


    // If there's no fallback rule, use the sticky flag so we only look for
    // matches at the current index.
    //
    // If we don't support the sticky flag, then fake it using an irrefutable
    // match (i.e. an empty pattern).
    var fallbackRule = errorRule && errorRule.fallback
    var flags = hasSticky && !fallbackRule ? 'ym' : 'gm'
    var suffix = hasSticky || fallbackRule ? '' : '|'

    if (unicodeFlag === true) flags += "u"
    var combined = new RegExp(reUnion(parts) + suffix, flags)
    return { regexp: combined, groups: groups, fast: fast, error: errorRule || defaultErrorRule }
  }

  function compile(rules) {
    var result = compileRules(toRules(rules))
    return new Lexer({ start: result }, 'start')
  }

  function checkStateGroup(g, name, map) {
    var state = g && (g.push || g.next)
    if (state && !map[state]) {
      throw new Error("Missing state '" + state + "' (in token '" + g.defaultType + "' of state '" + name + "')")
    }
    if (g && g.pop && +g.pop !== 1) {
      throw new Error("pop must be 1 (in token '" + g.defaultType + "' of state '" + name + "')")
    }
  }
  function compileStates(states, start) {
    var all = states.$all ? toRules(states.$all) : []
    delete states.$all

    var keys = Object.getOwnPropertyNames(states)
    if (!start) start = keys[0]

    var ruleMap = Object.create(null)
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i]
      ruleMap[key] = toRules(states[key]).concat(all)
    }
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i]
      var rules = ruleMap[key]
      var included = Object.create(null)
      for (var j = 0; j < rules.length; j++) {
        var rule = rules[j]
        if (!rule.include) continue
        var splice = [j, 1]
        if (rule.include !== key && !included[rule.include]) {
          included[rule.include] = true
          var newRules = ruleMap[rule.include]
          if (!newRules) {
            throw new Error("Cannot include nonexistent state '" + rule.include + "' (in state '" + key + "')")
          }
          for (var k = 0; k < newRules.length; k++) {
            var newRule = newRules[k]
            if (rules.indexOf(newRule) !== -1) continue
            splice.push(newRule)
          }
        }
        rules.splice.apply(rules, splice)
        j--
      }
    }

    var map = Object.create(null)
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i]
      map[key] = compileRules(ruleMap[key], true)
    }

    for (var i = 0; i < keys.length; i++) {
      var name = keys[i]
      var state = map[name]
      var groups = state.groups
      for (var j = 0; j < groups.length; j++) {
        checkStateGroup(groups[j], name, map)
      }
      var fastKeys = Object.getOwnPropertyNames(state.fast)
      for (var j = 0; j < fastKeys.length; j++) {
        checkStateGroup(state.fast[fastKeys[j]], name, map)
      }
    }

    return new Lexer(map, start)
  }

  function keywordTransform(map) {

    // Use a JavaScript Map to map keywords to their corresponding token type
    // unless Map is unsupported, then fall back to using an Object:
    var isMap = typeof Map !== 'undefined'
    var reverseMap = isMap ? new Map : Object.create(null)

    var types = Object.getOwnPropertyNames(map)
    for (var i = 0; i < types.length; i++) {
      var tokenType = types[i]
      var item = map[tokenType]
      var keywordList = Array.isArray(item) ? item : [item]
      keywordList.forEach(function (keyword) {
        if (typeof keyword !== 'string') {
          throw new Error("keyword must be string (in keyword '" + tokenType + "')")
        }
        if (isMap) {
          reverseMap.set(keyword, tokenType)
        } else {
          reverseMap[keyword] = tokenType
        }
      })
    }
    return function (k) {
      return isMap ? reverseMap.get(k) : reverseMap[k]
    }
  }

  /***************************************************************************/

  var Lexer = function (states, state) {
    this.startState = state
    this.states = states
    this.buffer = ''
    this.stack = []
    this.reset()
  }

  Lexer.prototype.reset = function (data, info) {
    this.buffer = data || ''
    this.index = 0
    this.line = info ? info.line : 1
    this.col = info ? info.col : 1
    this.queuedToken = info ? info.queuedToken : null
    this.queuedText = info ? info.queuedText : "";
    this.queuedThrow = info ? info.queuedThrow : null
    this.setState(info ? info.state : this.startState)
    this.stack = info && info.stack ? info.stack.slice() : []
    return this
  }

  Lexer.prototype.save = function () {
    return {
      line: this.line,
      col: this.col,
      state: this.state,
      stack: this.stack.slice(),
      queuedToken: this.queuedToken,
      queuedText: this.queuedText,
      queuedThrow: this.queuedThrow,
    }
  }

  Lexer.prototype.setState = function (state) {
    if (!state || this.state === state) return
    this.state = state
    var info = this.states[state]
    this.groups = info.groups
    this.error = info.error
    this.re = info.regexp
    this.fast = info.fast
  }

  Lexer.prototype.popState = function () {
    this.setState(this.stack.pop())
  }

  Lexer.prototype.pushState = function (state) {
    this.stack.push(this.state)
    this.setState(state)
  }

  var eat = hasSticky ? function (re, buffer) { // assume re is /y
    return re.exec(buffer)
  } : function (re, buffer) { // assume re is /g
    var match = re.exec(buffer)
    // will always match, since we used the |(?:) trick
    if (match[0].length === 0) {
      return null
    }
    return match
  }

  Lexer.prototype._getGroup = function (match) {
    var groupCount = this.groups.length
    for (var i = 0; i < groupCount; i++) {
      if (match[i + 1] !== undefined) {
        return this.groups[i]
      }
    }
    throw new Error('Cannot find token type for matched text')
  }

  function tokenToString() {
    return this.value
  }

  Lexer.prototype.next = function () {
    var index = this.index

    // If a fallback token matched, we don't need to re-run the RegExp
    if (this.queuedGroup) {
      var token = this._token(this.queuedGroup, this.queuedText, index)
      this.queuedGroup = null
      this.queuedText = ""
      return token
    }

    var buffer = this.buffer
    if (index === buffer.length) {
      return // EOF
    }

    // Fast matching for single characters
    var group = this.fast[buffer.charCodeAt(index)]
    if (group) {
      return this._token(group, buffer.charAt(index), index)
    }

    // Execute RegExp
    var re = this.re
    re.lastIndex = index
    var match = eat(re, buffer)

    // Error tokens match the remaining buffer
    var error = this.error
    if (match == null) {
      return this._token(error, buffer.slice(index, buffer.length), index)
    }

    var group = this._getGroup(match)
    var text = match[0]

    if (error.fallback && match.index !== index) {
      this.queuedGroup = group
      this.queuedText = text

      // Fallback tokens contain the unmatched portion of the buffer
      return this._token(error, buffer.slice(index, match.index), index)
    }

    return this._token(group, text, index)
  }

  Lexer.prototype._token = function (group, text, offset) {
    // count line breaks
    var lineBreaks = 0
    if (group.lineBreaks) {
      var matchNL = /\n/g
      var nl = 1
      if (text === '\n') {
        lineBreaks = 1
      } else {
        while (matchNL.exec(text)) { lineBreaks++; nl = matchNL.lastIndex }
      }
    }

    var token = {
      type: (typeof group.type === 'function' && group.type(text)) || group.defaultType,
      value: typeof group.value === 'function' ? group.value(text) : text,
      text: text,
      toString: tokenToString,
      offset: offset,
      lineBreaks: lineBreaks,
      line: this.line,
      col: this.col,
    }
    // nb. adding more props to token object will make V8 sad!

    var size = text.length
    this.index += size
    this.line += lineBreaks
    if (lineBreaks !== 0) {
      this.col = size - nl + 1
    } else {
      this.col += size
    }

    // throw, if no rule with {error: true}
    if (group.shouldThrow) {
      var err = new Error(this.formatError(token, "invalid syntax"))
      throw err;
    }

    if (group.pop) this.popState()
    else if (group.push) this.pushState(group.push)
    else if (group.next) this.setState(group.next)

    return token
  }

  if (typeof Symbol !== 'undefined' && Symbol.iterator) {
    var LexerIterator = function (lexer) {
      this.lexer = lexer
    }

    LexerIterator.prototype.next = function () {
      var token = this.lexer.next()
      return { value: token, done: !token }
    }

    LexerIterator.prototype[Symbol.iterator] = function () {
      return this
    }

    Lexer.prototype[Symbol.iterator] = function () {
      return new LexerIterator(this)
    }
  }

  Lexer.prototype.formatError = function (token, message) {
    if (token == null) {
      // An undefined token indicates EOF
      var text = this.buffer.slice(this.index)
      var token = {
        text: text,
        offset: this.index,
        lineBreaks: text.indexOf('\n') === -1 ? 0 : 1,
        line: this.line,
        col: this.col,
      }
    }

    var numLinesAround = 2
    var firstDisplayedLine = Math.max(token.line - numLinesAround, 1)
    var lastDisplayedLine = token.line + numLinesAround
    var lastLineDigits = String(lastDisplayedLine).length
    var displayedLines = lastNLines(
      this.buffer,
      (this.line - token.line) + numLinesAround + 1
    )
      .slice(0, 5)
    var errorLines = []
    errorLines.push(message + " at line " + token.line + " col " + token.col + ":")
    errorLines.push("")
    for (var i = 0; i < displayedLines.length; i++) {
      var line = displayedLines[i]
      var lineNo = firstDisplayedLine + i
      errorLines.push(pad(String(lineNo), lastLineDigits) + "  " + line);
      if (lineNo === token.line) {
        errorLines.push(pad("", lastLineDigits + token.col + 1) + "^")
      }
    }
    return errorLines.join("\n")
  }

  Lexer.prototype.clone = function () {
    return new Lexer(this.states, this.state)
  }

  Lexer.prototype.has = function (tokenType) {
    return true
  }


  return {
    compile: compile,
    states: compileStates,
    error: Object.freeze({ error: true }),
    fallback: Object.freeze({ fallback: true }),
    keywords: keywordTransform,
  }

}());
;
/**
 * Minified by jsDelivr using Terser v5.3.5.
 * Original file: /npm/nearley@2.20.1/lib/nearley.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
!function (t, e) { "object" == typeof module && module.exports ? module.exports = e() : t.nearley = e() }(this || window, (function () { function t(e, r, i) { return this.id = ++t.highestId, this.name = e, this.symbols = r, this.postprocess = i, this } function e(t, e, r, i) { this.rule = t, this.dot = e, this.reference = r, this.data = [], this.wantedBy = i, this.isComplete = this.dot === t.symbols.length } function r(t, e) { this.grammar = t, this.index = e, this.states = [], this.wants = {}, this.scannable = [], this.completed = {} } function i(t, e) { this.rules = t, this.start = e || this.rules[0].name; var r = this.byName = {}; this.rules.forEach((function (t) { r.hasOwnProperty(t.name) || (r[t.name] = []), r[t.name].push(t) })) } function n() { this.reset("") } function s(t, e, s) { if (t instanceof i) { var o = t; s = e } else o = i.fromCompiled(t, e); for (var a in this.grammar = o, this.options = { keepHistory: !1, lexer: o.lexer || new n }, s || {}) this.options[a] = s[a]; this.lexer = this.options.lexer, this.lexerState = void 0; var h = new r(o, 0); this.table = [h]; h.wants[o.start] = [], h.predict(o.start), h.process(), this.current = 0 } function o(t) { var e = typeof t; if ("string" === e) return t; if ("object" === e) { if (t.literal) return JSON.stringify(t.literal); if (t instanceof RegExp) return t.toString(); if (t.type) return "%" + t.type; if (t.test) return "<" + String(t.test) + ">"; throw new Error("Unknown symbol type: " + t) } } return t.highestId = 0, t.prototype.toString = function (t) { var e = void 0 === t ? this.symbols.map(o).join(" ") : this.symbols.slice(0, t).map(o).join(" ") + " ● " + this.symbols.slice(t).map(o).join(" "); return this.name + " → " + e }, e.prototype.toString = function () { return "{" + this.rule.toString(this.dot) + "}, from: " + (this.reference || 0) }, e.prototype.nextState = function (t) { var r = new e(this.rule, this.dot + 1, this.reference, this.wantedBy); return r.left = this, r.right = t, r.isComplete && (r.data = r.build(), r.right = void 0), r }, e.prototype.build = function () { var t = [], e = this; do { t.push(e.right.data), e = e.left } while (e.left); return t.reverse(), t }, e.prototype.finish = function () { this.rule.postprocess && (this.data = this.rule.postprocess(this.data, this.reference, s.fail)) }, r.prototype.process = function (t) { for (var e = this.states, r = this.wants, i = this.completed, n = 0; n < e.length; n++) { var o = e[n]; if (o.isComplete) { if (o.finish(), o.data !== s.fail) { for (var a = o.wantedBy, h = a.length; h--;) { var l = a[h]; this.complete(l, o) } if (o.reference === this.index) { var p = o.rule.name; (this.completed[p] = this.completed[p] || []).push(o) } } } else { if ("string" != typeof (p = o.rule.symbols[o.dot])) { this.scannable.push(o); continue } if (r[p]) { if (r[p].push(o), i.hasOwnProperty(p)) { var u = i[p]; for (h = 0; h < u.length; h++) { var f = u[h]; this.complete(o, f) } } } else r[p] = [o], this.predict(p) } } }, r.prototype.predict = function (t) { for (var r = this.grammar.byName[t] || [], i = 0; i < r.length; i++) { var n = r[i], s = this.wants[t], o = new e(n, 0, this.index, s); this.states.push(o) } }, r.prototype.complete = function (t, e) { var r = t.nextState(e); this.states.push(r) }, i.fromCompiled = function (e, r) { var n = e.Lexer; e.ParserStart && (r = e.ParserStart, e = e.ParserRules); var s = new i(e = e.map((function (e) { return new t(e.name, e.symbols, e.postprocess) })), r); return s.lexer = n, s }, n.prototype.reset = function (t, e) { this.buffer = t, this.index = 0, this.line = e ? e.line : 1, this.lastLineBreak = e ? -e.col : 0 }, n.prototype.next = function () { if (this.index < this.buffer.length) { var t = this.buffer[this.index++]; return "\n" === t && (this.line += 1, this.lastLineBreak = this.index), { value: t } } }, n.prototype.save = function () { return { line: this.line, col: this.index - this.lastLineBreak } }, n.prototype.formatError = function (t, e) { var r = this.buffer; if ("string" == typeof r) { var i = r.split("\n").slice(Math.max(0, this.line - 5), this.line), n = r.indexOf("\n", this.index); -1 === n && (n = r.length); var s = this.index - this.lastLineBreak, o = String(this.line).length; return e += " at line " + this.line + " col " + s + ":\n\n", e += i.map((function (t, e) { return a(this.line - i.length + e + 1, o) + " " + t }), this).join("\n"), e += "\n" + a("", o + s) + "^\n" } return e + " at index " + (this.index - 1); function a(t, e) { var r = String(t); return Array(e - r.length + 1).join(" ") + r } }, s.fail = {}, s.prototype.feed = function (t) { var e, i = this.lexer; for (i.reset(t, this.lexerState); ;) { try { if (!(e = i.next())) break } catch (t) { var s = new r(this.grammar, this.current + 1); throw this.table.push(s), (h = new Error(this.reportLexerError(t))).offset = this.current, h.token = t.token, h } var o = this.table[this.current]; this.options.keepHistory || delete this.table[this.current - 1]; var a = this.current + 1; s = new r(this.grammar, a); this.table.push(s); for (var h, l = void 0 !== e.text ? e.text : e.value, p = i.constructor === n ? e.value : e, u = o.scannable, f = u.length; f--;) { var c = u[f], y = c.rule.symbols[c.dot]; if (y.test ? y.test(p) : y.type ? y.type === e.type : y.literal === l) { var m = c.nextState({ data: p, token: e, isToken: !0, reference: a - 1 }); s.states.push(m) } } if (s.process(), 0 === s.states.length) throw (h = new Error(this.reportError(e))).offset = this.current, h.token = e, h; this.options.keepHistory && (o.lexerState = i.save()), this.current++ } return o && (this.lexerState = i.save()), this.results = this.finish(), this }, s.prototype.reportLexerError = function (t) { var e, r, i = t.token; return i ? (e = "input " + JSON.stringify(i.text[0]) + " (lexer error)", r = this.lexer.formatError(i, "Syntax error")) : (e = "input (lexer error)", r = t.message), this.reportErrorCommon(r, e) }, s.prototype.reportError = function (t) { var e = (t.type ? t.type + " token: " : "") + JSON.stringify(void 0 !== t.value ? t.value : t), r = this.lexer.formatError(t, "Syntax error"); return this.reportErrorCommon(r, e) }, s.prototype.reportErrorCommon = function (t, e) { var r = []; r.push(t); var i = this.table.length - 2, n = this.table[i], s = n.states.filter((function (t) { var e = t.rule.symbols[t.dot]; return e && "string" != typeof e })); 0 === s.length ? (r.push("Unexpected " + e + ". I did not expect any more input. Here is the state of my parse table:\n"), this.displayStateStack(n.states, r)) : (r.push("Unexpected " + e + ". Instead, I was expecting to see one of the following:\n"), s.map((function (t) { return this.buildFirstStateStack(t, []) || [t] }), this).forEach((function (t) { var e = t[0], i = e.rule.symbols[e.dot], n = this.getSymbolDisplay(i); r.push("A " + n + " based on:"), this.displayStateStack(t, r) }), this)); return r.push(""), r.join("\n") }, s.prototype.displayStateStack = function (t, e) { for (var r, i = 0, n = 0; n < t.length; n++) { var s = t[n], o = s.rule.toString(s.dot); o === r ? i++ : (i > 0 && e.push("    ^ " + i + " more lines identical to this"), i = 0, e.push("    " + o)), r = o } }, s.prototype.getSymbolDisplay = function (t) { return function (t) { var e = typeof t; if ("string" === e) return t; if ("object" === e) { if (t.literal) return JSON.stringify(t.literal); if (t instanceof RegExp) return "character matching " + t; if (t.type) return t.type + " token"; if (t.test) return "token matching " + String(t.test); throw new Error("Unknown symbol type: " + t) } }(t) }, s.prototype.buildFirstStateStack = function (t, e) { if (-1 !== e.indexOf(t)) return null; if (0 === t.wantedBy.length) return [t]; var r = t.wantedBy[0], i = [t].concat(e), n = this.buildFirstStateStack(r, i); return null === n ? null : [t].concat(n) }, s.prototype.save = function () { var t = this.table[this.current]; return t.lexerState = this.lexerState, t }, s.prototype.restore = function (t) { var e = t.index; this.current = e, this.table[e] = t, this.table.splice(e + 1), this.lexerState = t.lexerState, this.results = this.finish() }, s.prototype.rewind = function (t) { if (!this.options.keepHistory) throw new Error("set option `keepHistory` to enable rewinding"); this.restore(this.table[t]) }, s.prototype.finish = function () { var t = [], e = this.grammar.start; return this.table[this.table.length - 1].states.forEach((function (r) { r.rule.name === e && r.dot === r.rule.symbols.length && 0 === r.reference && r.data !== s.fail && t.push(r) })), t.map((function (t) { return t.data })) }, { Parser: s, Grammar: i, Rule: t } }));
//# sourceMappingURL=/sm/dcbcaf46b820f08097a26578b7032019ac981a93bc4d02b191e641de97e3bd20.map;
/**
 * React v15.5.0
 *
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */
!function(t){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=t();else if("function"==typeof define&&define.amd)define([],t);else{var e;e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,e.React=t()}}(function(){return function t(e,n,r){function o(a,u){if(!n[a]){if(!e[a]){var s="function"==typeof require&&require;if(!u&&s)return s(a,!0);if(i)return i(a,!0);var c=new Error("Cannot find module '"+a+"'");throw c.code="MODULE_NOT_FOUND",c}var l=n[a]={exports:{}};e[a][0].call(l.exports,function(t){var n=e[a][1][t];return o(n||t)},l,l.exports,t,e,n,r)}return n[a].exports}for(var i="function"==typeof require&&require,a=0;a<r.length;a++)o(r[a]);return o}({1:[function(t,e,n){"use strict";function r(t){var e={"=":"=0",":":"=2"};return"$"+(""+t).replace(/[=:]/g,function(t){return e[t]})}function o(t){var e={"=0":"=","=2":":"};return(""+("."===t[0]&&"$"===t[1]?t.substring(2):t.substring(1))).replace(/(=0|=2)/g,function(t){return e[t]})}var i={escape:r,unescape:o};e.exports=i},{}],2:[function(t,e,n){"use strict";var r=t(20),o=(t(24),function(t){var e=this;if(e.instancePool.length){var n=e.instancePool.pop();return e.call(n,t),n}return new e(t)}),i=function(t,e){var n=this;if(n.instancePool.length){var r=n.instancePool.pop();return n.call(r,t,e),r}return new n(t,e)},a=function(t,e,n){var r=this;if(r.instancePool.length){var o=r.instancePool.pop();return r.call(o,t,e,n),o}return new r(t,e,n)},u=function(t,e,n,r){var o=this;if(o.instancePool.length){var i=o.instancePool.pop();return o.call(i,t,e,n,r),i}return new o(t,e,n,r)},s=function(t){var e=this;t instanceof e||r("25"),t.destructor(),e.instancePool.length<e.poolSize&&e.instancePool.push(t)},c=o,l=function(t,e){var n=t;return n.instancePool=[],n.getPooled=e||c,n.poolSize||(n.poolSize=10),n.release=s,n},p={addPoolingTo:l,oneArgumentPooler:o,twoArgumentPooler:i,threeArgumentPooler:a,fourArgumentPooler:u};e.exports=p},{20:20,24:24}],3:[function(t,e,n){"use strict";var r=t(26),o=t(4),i=t(6),a=t(14),u=t(5),s=t(8),c=t(9),l=t(13),p=t(16),f=t(19),d=(t(25),c.createElement),h=c.createFactory,y=c.cloneElement,v=r,m={Children:{map:o.map,forEach:o.forEach,count:o.count,toArray:o.toArray,only:f},Component:i,PureComponent:a,createElement:d,cloneElement:y,isValidElement:c.isValidElement,PropTypes:l,createClass:u.createClass,createFactory:h,createMixin:function(t){return t},DOM:s,version:p,__spread:v};e.exports=m},{13:13,14:14,16:16,19:19,25:25,26:26,4:4,5:5,6:6,8:8,9:9}],4:[function(t,e,n){"use strict";function r(t){return(""+t).replace(E,"$&/")}function o(t,e){this.func=t,this.context=e,this.count=0}function i(t,e,n){var r=t.func,o=t.context;r.call(o,e,t.count++)}function a(t,e,n){if(null==t)return t;var r=o.getPooled(e,n);m(t,i,r),o.release(r)}function u(t,e,n,r){this.result=t,this.keyPrefix=e,this.func=n,this.context=r,this.count=0}function s(t,e,n){var o=t.result,i=t.keyPrefix,a=t.func,u=t.context,s=a.call(u,e,t.count++);Array.isArray(s)?c(s,o,n,v.thatReturnsArgument):null!=s&&(y.isValidElement(s)&&(s=y.cloneAndReplaceKey(s,i+(!s.key||e&&e.key===s.key?"":r(s.key)+"/")+n)),o.push(s))}function c(t,e,n,o,i){var a="";null!=n&&(a=r(n)+"/");var c=u.getPooled(e,a,o,i);m(t,s,c),u.release(c)}function l(t,e,n){if(null==t)return t;var r=[];return c(t,r,null,e,n),r}function p(t,e,n){return null}function f(t,e){return m(t,p,null)}function d(t){var e=[];return c(t,e,null,v.thatReturnsArgument),e}var h=t(2),y=t(9),v=t(22),m=t(21),g=h.twoArgumentPooler,b=h.fourArgumentPooler,E=/\/+/g;o.prototype.destructor=function(){this.func=null,this.context=null,this.count=0},h.addPoolingTo(o,g),u.prototype.destructor=function(){this.result=null,this.keyPrefix=null,this.func=null,this.context=null,this.count=0},h.addPoolingTo(u,b);var _={forEach:a,map:l,mapIntoWithKeyPrefixInternal:c,count:f,toArray:d};e.exports=_},{2:2,21:21,22:22,9:9}],5:[function(t,e,n){"use strict";function r(t){return t}function o(t,e){var n=E.hasOwnProperty(e)?E[e]:null;P.hasOwnProperty(e)&&"OVERRIDE_BASE"!==n&&f("73",e),t&&"DEFINE_MANY"!==n&&"DEFINE_MANY_MERGED"!==n&&f("74",e)}function i(t,e){if(e){"function"==typeof e&&f("75"),y.isValidElement(e)&&f("76");var n=t.prototype,r=n.__reactAutoBindPairs;e.hasOwnProperty(g)&&_.mixins(t,e.mixins);for(var i in e)if(e.hasOwnProperty(i)&&i!==g){var a=e[i],u=n.hasOwnProperty(i);if(o(u,i),_.hasOwnProperty(i))_[i](t,a);else{var l=E.hasOwnProperty(i),p="function"==typeof a,d=p&&!l&&!u&&!1!==e.autobind;if(d)r.push(i,a),n[i]=a;else if(u){var h=E[i];(!l||"DEFINE_MANY_MERGED"!==h&&"DEFINE_MANY"!==h)&&f("77",h,i),"DEFINE_MANY_MERGED"===h?n[i]=s(n[i],a):"DEFINE_MANY"===h&&(n[i]=c(n[i],a))}else n[i]=a}}}}function a(t,e){if(e)for(var n in e){var r=e[n];if(e.hasOwnProperty(n)){var o=n in _;o&&f("78",n);var i=n in t;i&&f("79",n),t[n]=r}}}function u(t,e){t&&e&&"object"==typeof t&&"object"==typeof e||f("80");for(var n in e)e.hasOwnProperty(n)&&(void 0!==t[n]&&f("81",n),t[n]=e[n]);return t}function s(t,e){return function(){var n=t.apply(this,arguments),r=e.apply(this,arguments);if(null==n)return r;if(null==r)return n;var o={};return u(o,n),u(o,r),o}}function c(t,e){return function(){t.apply(this,arguments),e.apply(this,arguments)}}function l(t,e){return e.bind(t)}function p(t){for(var e=t.__reactAutoBindPairs,n=0;n<e.length;n+=2){var r=e[n],o=e[n+1];t[r]=l(t,o)}}var f=t(20),d=t(26),h=t(6),y=t(9),v=(t(12),t(11)),m=t(23),g=(t(24),t(25),"mixins"),b=[],E={mixins:"DEFINE_MANY",statics:"DEFINE_MANY",propTypes:"DEFINE_MANY",contextTypes:"DEFINE_MANY",childContextTypes:"DEFINE_MANY",getDefaultProps:"DEFINE_MANY_MERGED",getInitialState:"DEFINE_MANY_MERGED",getChildContext:"DEFINE_MANY_MERGED",render:"DEFINE_ONCE",componentWillMount:"DEFINE_MANY",componentDidMount:"DEFINE_MANY",componentWillReceiveProps:"DEFINE_MANY",shouldComponentUpdate:"DEFINE_ONCE",componentWillUpdate:"DEFINE_MANY",componentDidUpdate:"DEFINE_MANY",componentWillUnmount:"DEFINE_MANY",updateComponent:"OVERRIDE_BASE"},_={displayName:function(t,e){t.displayName=e},mixins:function(t,e){if(e)for(var n=0;n<e.length;n++)i(t,e[n])},childContextTypes:function(t,e){t.childContextTypes=d({},t.childContextTypes,e)},contextTypes:function(t,e){t.contextTypes=d({},t.contextTypes,e)},getDefaultProps:function(t,e){t.getDefaultProps?t.getDefaultProps=s(t.getDefaultProps,e):t.getDefaultProps=e},propTypes:function(t,e){t.propTypes=d({},t.propTypes,e)},statics:function(t,e){a(t,e)},autobind:function(){}},P={replaceState:function(t,e){this.updater.enqueueReplaceState(this,t),e&&this.updater.enqueueCallback(this,e,"replaceState")},isMounted:function(){return this.updater.isMounted(this)}},x=function(){};d(x.prototype,h.prototype,P);var N={createClass:function(t){var e=r(function(t,n,r){this.__reactAutoBindPairs.length&&p(this),this.props=t,this.context=n,this.refs=m,this.updater=r||v,this.state=null;var o=this.getInitialState?this.getInitialState():null;("object"!=typeof o||Array.isArray(o))&&f("82",e.displayName||"ReactCompositeComponent"),this.state=o});e.prototype=new x,e.prototype.constructor=e,e.prototype.__reactAutoBindPairs=[],b.forEach(i.bind(null,e)),i(e,t),e.getDefaultProps&&(e.defaultProps=e.getDefaultProps()),e.prototype.render||f("83");for(var n in E)e.prototype[n]||(e.prototype[n]=null);return e},injection:{injectMixin:function(t){b.push(t)}}};e.exports=N},{11:11,12:12,20:20,23:23,24:24,25:25,26:26,6:6,9:9}],6:[function(t,e,n){"use strict";function r(t,e,n){this.props=t,this.context=e,this.refs=a,this.updater=n||i}var o=t(20),i=t(11),a=(t(17),t(23));t(24),t(25);r.prototype.isReactComponent={},r.prototype.setState=function(t,e){"object"!=typeof t&&"function"!=typeof t&&null!=t&&o("85"),this.updater.enqueueSetState(this,t),e&&this.updater.enqueueCallback(this,e,"setState")},r.prototype.forceUpdate=function(t){this.updater.enqueueForceUpdate(this),t&&this.updater.enqueueCallback(this,t,"forceUpdate")};e.exports=r},{11:11,17:17,20:20,23:23,24:24,25:25}],7:[function(t,e,n){"use strict";var r={current:null};e.exports=r},{}],8:[function(t,e,n){"use strict";var r=t(9),o=r.createFactory,i={a:o("a"),abbr:o("abbr"),address:o("address"),area:o("area"),article:o("article"),aside:o("aside"),audio:o("audio"),b:o("b"),base:o("base"),bdi:o("bdi"),bdo:o("bdo"),big:o("big"),blockquote:o("blockquote"),body:o("body"),br:o("br"),button:o("button"),canvas:o("canvas"),caption:o("caption"),cite:o("cite"),code:o("code"),col:o("col"),colgroup:o("colgroup"),data:o("data"),datalist:o("datalist"),dd:o("dd"),del:o("del"),details:o("details"),dfn:o("dfn"),dialog:o("dialog"),div:o("div"),dl:o("dl"),dt:o("dt"),em:o("em"),embed:o("embed"),fieldset:o("fieldset"),figcaption:o("figcaption"),figure:o("figure"),footer:o("footer"),form:o("form"),h1:o("h1"),h2:o("h2"),h3:o("h3"),h4:o("h4"),h5:o("h5"),h6:o("h6"),head:o("head"),header:o("header"),hgroup:o("hgroup"),hr:o("hr"),html:o("html"),i:o("i"),iframe:o("iframe"),img:o("img"),input:o("input"),ins:o("ins"),kbd:o("kbd"),keygen:o("keygen"),label:o("label"),legend:o("legend"),li:o("li"),link:o("link"),main:o("main"),map:o("map"),mark:o("mark"),menu:o("menu"),menuitem:o("menuitem"),meta:o("meta"),meter:o("meter"),nav:o("nav"),noscript:o("noscript"),object:o("object"),ol:o("ol"),optgroup:o("optgroup"),option:o("option"),output:o("output"),p:o("p"),param:o("param"),picture:o("picture"),pre:o("pre"),progress:o("progress"),q:o("q"),rp:o("rp"),rt:o("rt"),ruby:o("ruby"),s:o("s"),samp:o("samp"),script:o("script"),section:o("section"),select:o("select"),small:o("small"),source:o("source"),span:o("span"),strong:o("strong"),style:o("style"),sub:o("sub"),summary:o("summary"),sup:o("sup"),table:o("table"),tbody:o("tbody"),td:o("td"),textarea:o("textarea"),tfoot:o("tfoot"),th:o("th"),thead:o("thead"),time:o("time"),title:o("title"),tr:o("tr"),track:o("track"),u:o("u"),ul:o("ul"),var:o("var"),video:o("video"),wbr:o("wbr"),circle:o("circle"),clipPath:o("clipPath"),defs:o("defs"),ellipse:o("ellipse"),g:o("g"),image:o("image"),line:o("line"),linearGradient:o("linearGradient"),mask:o("mask"),path:o("path"),pattern:o("pattern"),polygon:o("polygon"),polyline:o("polyline"),radialGradient:o("radialGradient"),rect:o("rect"),stop:o("stop"),svg:o("svg"),text:o("text"),tspan:o("tspan")};e.exports=i},{9:9}],9:[function(t,e,n){"use strict";function r(t){return void 0!==t.ref}function o(t){return void 0!==t.key}var i=t(26),a=t(7),u=(t(25),t(17),Object.prototype.hasOwnProperty),s=t(10),c={key:!0,ref:!0,__self:!0,__source:!0},l=function(t,e,n,r,o,i,a){return{$$typeof:s,type:t,key:e,ref:n,props:a,_owner:i}};l.createElement=function(t,e,n){var i,s={},p=null,f=null;if(null!=e){r(e)&&(f=e.ref),o(e)&&(p=""+e.key),void 0===e.__self?null:e.__self,void 0===e.__source?null:e.__source;for(i in e)u.call(e,i)&&!c.hasOwnProperty(i)&&(s[i]=e[i])}var d=arguments.length-2;if(1===d)s.children=n;else if(d>1){for(var h=Array(d),y=0;y<d;y++)h[y]=arguments[y+2];s.children=h}if(t&&t.defaultProps){var v=t.defaultProps;for(i in v)void 0===s[i]&&(s[i]=v[i])}return l(t,p,f,0,0,a.current,s)},l.createFactory=function(t){var e=l.createElement.bind(null,t);return e.type=t,e},l.cloneAndReplaceKey=function(t,e){return l(t.type,e,t.ref,t._self,t._source,t._owner,t.props)},l.cloneElement=function(t,e,n){var s,p=i({},t.props),f=t.key,d=t.ref,h=(t._self,t._source,t._owner);if(null!=e){r(e)&&(d=e.ref,h=a.current),o(e)&&(f=""+e.key);var y;t.type&&t.type.defaultProps&&(y=t.type.defaultProps);for(s in e)u.call(e,s)&&!c.hasOwnProperty(s)&&(void 0===e[s]&&void 0!==y?p[s]=y[s]:p[s]=e[s])}var v=arguments.length-2;if(1===v)p.children=n;else if(v>1){for(var m=Array(v),g=0;g<v;g++)m[g]=arguments[g+2];p.children=m}return l(t.type,f,d,0,0,h,p)},l.isValidElement=function(t){return"object"==typeof t&&null!==t&&t.$$typeof===s},e.exports=l},{10:10,17:17,25:25,26:26,7:7}],10:[function(t,e,n){"use strict";var r="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103;e.exports=r},{}],11:[function(t,e,n){"use strict";var r=(t(25),{isMounted:function(t){return!1},enqueueCallback:function(t,e){},enqueueForceUpdate:function(t){},enqueueReplaceState:function(t,e){},enqueueSetState:function(t,e){}});e.exports=r},{25:25}],12:[function(t,e,n){"use strict";var r={};e.exports=r},{}],13:[function(t,e,n){"use strict";var r=t(9),o=r.isValidElement,i=t(28);e.exports=i(o)},{28:28,9:9}],14:[function(t,e,n){"use strict";function r(t,e,n){this.props=t,this.context=e,this.refs=s,this.updater=n||u}function o(){}var i=t(26),a=t(6),u=t(11),s=t(23);o.prototype=a.prototype,r.prototype=new o,r.prototype.constructor=r,i(r.prototype,a.prototype),r.prototype.isPureReactComponent=!0,e.exports=r},{11:11,23:23,26:26,6:6}],15:[function(t,e,n){"use strict";var r=t(26),o=t(3),i=r(o,{__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:t(7)}});e.exports=i},{26:26,3:3,7:7}],16:[function(t,e,n){"use strict";e.exports="15.5.0"},{}],17:[function(t,e,n){"use strict";e.exports=!1},{}],18:[function(t,e,n){"use strict";function r(t){var e=t&&(o&&t[o]||t[i]);if("function"==typeof e)return e}var o="function"==typeof Symbol&&Symbol.iterator,i="@@iterator";e.exports=r},{}],19:[function(t,e,n){"use strict";function r(t){return i.isValidElement(t)||o("143"),t}var o=t(20),i=t(9);t(24);e.exports=r},{20:20,24:24,9:9}],20:[function(t,e,n){"use strict";function r(t){for(var e=arguments.length-1,n="Minified React error #"+t+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant="+t,r=0;r<e;r++)n+="&args[]="+encodeURIComponent(arguments[r+1]);n+=" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";var o=new Error(n);throw o.name="Invariant Violation",o.framesToPop=1,o}e.exports=r},{}],21:[function(t,e,n){"use strict";function r(t,e){return t&&"object"==typeof t&&null!=t.key?c.escape(t.key):e.toString(36)}function o(t,e,n,i){var f=typeof t;if("undefined"!==f&&"boolean"!==f||(t=null),null===t||"string"===f||"number"===f||"object"===f&&t.$$typeof===u)return n(i,t,""===e?l+r(t,0):e),1;var d,h,y=0,v=""===e?l:e+p;if(Array.isArray(t))for(var m=0;m<t.length;m++)d=t[m],h=v+r(d,m),y+=o(d,h,n,i);else{var g=s(t);if(g){var b,E=g.call(t);if(g!==t.entries)for(var _=0;!(b=E.next()).done;)d=b.value,h=v+r(d,_++),y+=o(d,h,n,i);else for(;!(b=E.next()).done;){var P=b.value;P&&(d=P[1],h=v+c.escape(P[0])+p+r(d,0),y+=o(d,h,n,i))}}else if("object"===f){var x=String(t);a("31","[object Object]"===x?"object with keys {"+Object.keys(t).join(", ")+"}":x,"")}}return y}function i(t,e,n){return null==t?0:o(t,"",e,n)}var a=t(20),u=(t(7),t(10)),s=t(18),c=(t(24),t(1)),l=(t(25),"."),p=":";e.exports=i},{1:1,10:10,18:18,20:20,24:24,25:25,7:7}],22:[function(t,e,n){"use strict";function r(t){return function(){return t}}var o=function(){};o.thatReturns=r,o.thatReturnsFalse=r(!1),o.thatReturnsTrue=r(!0),o.thatReturnsNull=r(null),o.thatReturnsThis=function(){return this},o.thatReturnsArgument=function(t){return t},e.exports=o},{}],23:[function(t,e,n){"use strict";var r={};e.exports=r},{}],24:[function(t,e,n){"use strict";function r(t,e,n,r,i,a,u,s){if(o(e),!t){var c;if(void 0===e)c=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[n,r,i,a,u,s],p=0;c=new Error(e.replace(/%s/g,function(){return l[p++]})),c.name="Invariant Violation"}throw c.framesToPop=1,c}}var o=function(t){};e.exports=r},{}],25:[function(t,e,n){"use strict";var r=t(22),o=r;e.exports=o},{22:22}],26:[function(t,e,n){"use strict";function r(t){if(null===t||void 0===t)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(t)}var o=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,a=Object.prototype.propertyIsEnumerable;e.exports=function(){try{if(!Object.assign)return!1;var t=new String("abc");if(t[5]="de","5"===Object.getOwnPropertyNames(t)[0])return!1;for(var e={},n=0;n<10;n++)e["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(e).map(function(t){return e[t]}).join(""))return!1;var r={};return"abcdefghijklmnopqrst".split("").forEach(function(t){r[t]=t}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},r)).join("")}catch(t){return!1}}()?Object.assign:function(t,e){for(var n,u,s=r(t),c=1;c<arguments.length;c++){n=Object(arguments[c]);for(var l in n)i.call(n,l)&&(s[l]=n[l]);if(o){u=o(n);for(var p=0;p<u.length;p++)a.call(n,u[p])&&(s[u[p]]=n[u[p]])}}return s}},{}],27:[function(t,e,n){"use strict";function r(t,e,n,r,o){}t(24),t(25),t(29);e.exports=r},{24:24,25:25,29:29}],28:[function(t,e,n){"use strict";var r=(t(22),t(24)),o=(t(25),t(29),t(27));e.exports=function(t){function e(t){this.message=t,this.stack=""}var n,i=("function"==typeof Symbol&&Symbol.iterator,function(){r(!1,"React.PropTypes type checking code is stripped in production.")});i.isRequired=i;var a=function(){return i};return n={array:i,bool:i,func:i,number:i,object:i,string:i,symbol:i,any:i,arrayOf:a,element:i,instanceOf:a,node:i,objectOf:a,oneOf:a,oneOfType:a,shape:a},e.prototype=Error.prototype,n.checkPropTypes=o,n.PropTypes=n,n}},{22:22,24:24,25:25,27:27,29:29}],29:[function(t,e,n){"use strict";e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},{}]},{},[15])(15)});;
/**
 * ReactDOM v15.5.0
 *
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */
!function(e){if("object"==typeof exports&&"undefined"!=typeof module)module.exports=e(require("react"));else if("function"==typeof define&&define.amd)define(["react"],e);else{var t;t="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,t.ReactDOM=e(t.React)}}(function(e){return function(t){return function(){return function e(t,n,r){function o(i,s){if(!n[i]){if(!t[i]){var u="function"==typeof require&&require;if(!s&&u)return u(i,!0);if(a)return a(i,!0);var l=new Error("Cannot find module '"+i+"'");throw l.code="MODULE_NOT_FOUND",l}var c=n[i]={exports:{}};t[i][0].call(c.exports,function(e){var n=t[i][1][e];return o(n||e)},c,c.exports,e,t,n,r)}return n[i].exports}for(var a="function"==typeof require&&require,i=0;i<r.length;i++)o(r[i]);return o}({1:[function(e,t,n){"use strict";var r={Properties:{"aria-current":0,"aria-details":0,"aria-disabled":0,"aria-hidden":0,"aria-invalid":0,"aria-keyshortcuts":0,"aria-label":0,"aria-roledescription":0,"aria-autocomplete":0,"aria-checked":0,"aria-expanded":0,"aria-haspopup":0,"aria-level":0,"aria-modal":0,"aria-multiline":0,"aria-multiselectable":0,"aria-orientation":0,"aria-placeholder":0,"aria-pressed":0,"aria-readonly":0,"aria-required":0,"aria-selected":0,"aria-sort":0,"aria-valuemax":0,"aria-valuemin":0,"aria-valuenow":0,"aria-valuetext":0,"aria-atomic":0,"aria-busy":0,"aria-live":0,"aria-relevant":0,"aria-dropeffect":0,"aria-grabbed":0,"aria-activedescendant":0,"aria-colcount":0,"aria-colindex":0,"aria-colspan":0,"aria-controls":0,"aria-describedby":0,"aria-errormessage":0,"aria-flowto":0,"aria-labelledby":0,"aria-owns":0,"aria-posinset":0,"aria-rowcount":0,"aria-rowindex":0,"aria-rowspan":0,"aria-setsize":0},DOMAttributeNames:{},DOMPropertyNames:{}};t.exports=r},{}],2:[function(e,t,n){"use strict";var r=e(33),o=e(131),a={focusDOMComponent:function(){o(r.getNodeFromInstance(this))}};t.exports=a},{131:131,33:33}],3:[function(e,t,n){"use strict";function r(e){return(e.ctrlKey||e.altKey||e.metaKey)&&!(e.ctrlKey&&e.altKey)}function o(e){switch(e){case"topCompositionStart":return w.compositionStart;case"topCompositionEnd":return w.compositionEnd;case"topCompositionUpdate":return w.compositionUpdate}}function a(e,t){return"topKeyDown"===e&&t.keyCode===y}function i(e,t){switch(e){case"topKeyUp":return-1!==g.indexOf(t.keyCode);case"topKeyDown":return t.keyCode!==y;case"topKeyPress":case"topMouseDown":case"topBlur":return!0;default:return!1}}function s(e){var t=e.detail;return"object"==typeof t&&"data"in t?t.data:null}function u(e,t,n,r){var u,l;if(_?u=o(e):P?i(e,n)&&(u=w.compositionEnd):a(e,n)&&(u=w.compositionStart),!u)return null;E&&(P||u!==w.compositionStart?u===w.compositionEnd&&P&&(l=P.getData()):P=h.getPooled(r));var c=m.getPooled(u,t,n,r);if(l)c.data=l;else{var p=s(n);null!==p&&(c.data=p)}return d.accumulateTwoPhaseDispatches(c),c}function l(e,t){switch(e){case"topCompositionEnd":return s(t);case"topKeyPress":return t.which!==x?null:(k=!0,T);case"topTextInput":var n=t.data;return n===T&&k?null:n;default:return null}}function c(e,t){if(P){if("topCompositionEnd"===e||!_&&i(e,t)){var n=P.getData();return h.release(P),P=null,n}return null}switch(e){case"topPaste":return null;case"topKeyPress":return t.which&&!r(t)?String.fromCharCode(t.which):null;case"topCompositionEnd":return E?null:t.data;default:return null}}function p(e,t,n,r){var o;if(!(o=b?l(e,n):c(e,n)))return null;var a=v.getPooled(w.beforeInput,t,n,r);return a.data=o,d.accumulateTwoPhaseDispatches(a),a}var d=e(19),f=e(123),h=e(20),m=e(78),v=e(82),g=[9,13,27,32],y=229,_=f.canUseDOM&&"CompositionEvent"in window,C=null;f.canUseDOM&&"documentMode"in document&&(C=document.documentMode);var b=f.canUseDOM&&"TextEvent"in window&&!C&&!function(){var e=window.opera;return"object"==typeof e&&"function"==typeof e.version&&parseInt(e.version(),10)<=12}(),E=f.canUseDOM&&(!_||C&&C>8&&C<=11),x=32,T=String.fromCharCode(x),w={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:["topBlur","topCompositionEnd","topKeyDown","topKeyPress","topKeyUp","topMouseDown"]},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",captured:"onCompositionStartCapture"},dependencies:["topBlur","topCompositionStart","topKeyDown","topKeyPress","topKeyUp","topMouseDown"]},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:["topBlur","topCompositionUpdate","topKeyDown","topKeyPress","topKeyUp","topMouseDown"]}},k=!1,P=null,S={eventTypes:w,extractEvents:function(e,t,n,r){return[u(e,t,n,r),p(e,t,n,r)]}};t.exports=S},{123:123,19:19,20:20,78:78,82:82}],4:[function(e,t,n){"use strict";function r(e,t){return e+t.charAt(0).toUpperCase()+t.substring(1)}var o={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridRow:!0,gridColumn:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},a=["Webkit","ms","Moz","O"];Object.keys(o).forEach(function(e){a.forEach(function(t){o[r(t,e)]=o[e]})});var i={background:{backgroundAttachment:!0,backgroundColor:!0,backgroundImage:!0,backgroundPositionX:!0,backgroundPositionY:!0,backgroundRepeat:!0},backgroundPosition:{backgroundPositionX:!0,backgroundPositionY:!0},border:{borderWidth:!0,borderStyle:!0,borderColor:!0},borderBottom:{borderBottomWidth:!0,borderBottomStyle:!0,borderBottomColor:!0},borderLeft:{borderLeftWidth:!0,borderLeftStyle:!0,borderLeftColor:!0},borderRight:{borderRightWidth:!0,borderRightStyle:!0,borderRightColor:!0},borderTop:{borderTopWidth:!0,borderTopStyle:!0,borderTopColor:!0},font:{fontStyle:!0,fontVariant:!0,fontWeight:!0,fontSize:!0,lineHeight:!0,fontFamily:!0},outline:{outlineWidth:!0,outlineStyle:!0,outlineColor:!0}},s={isUnitlessNumber:o,shorthandPropertyExpansions:i};t.exports=s},{}],5:[function(e,t,n){"use strict";var r=e(4),o=e(123),a=(e(58),e(125),e(94)),i=e(136),s=e(140),u=(e(142),s(function(e){return i(e)})),l=!1,c="cssFloat";if(o.canUseDOM){var p=document.createElement("div").style;try{p.font=""}catch(e){l=!0}void 0===document.documentElement.style.cssFloat&&(c="styleFloat")}var d={createMarkupForStyles:function(e,t){var n="";for(var r in e)if(e.hasOwnProperty(r)){var o=e[r];null!=o&&(n+=u(r)+":",n+=a(r,o,t)+";")}return n||null},setValueForStyles:function(e,t,n){var o=e.style;for(var i in t)if(t.hasOwnProperty(i)){var s=a(i,t[i],n);if("float"!==i&&"cssFloat"!==i||(i=c),s)o[i]=s;else{var u=l&&r.shorthandPropertyExpansions[i];if(u)for(var p in u)o[p]="";else o[i]=""}}}};t.exports=d},{123:123,125:125,136:136,140:140,142:142,4:4,58:58,94:94}],6:[function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var o=e(112),a=e(24),i=(e(137),function(){function e(t){r(this,e),this._callbacks=null,this._contexts=null,this._arg=t}return e.prototype.enqueue=function(e,t){this._callbacks=this._callbacks||[],this._callbacks.push(e),this._contexts=this._contexts||[],this._contexts.push(t)},e.prototype.notifyAll=function(){var e=this._callbacks,t=this._contexts,n=this._arg;if(e&&t){e.length!==t.length&&o("24"),this._callbacks=null,this._contexts=null;for(var r=0;r<e.length;r++)e[r].call(t[r],n);e.length=0,t.length=0}},e.prototype.checkpoint=function(){return this._callbacks?this._callbacks.length:0},e.prototype.rollback=function(e){this._callbacks&&this._contexts&&(this._callbacks.length=e,this._contexts.length=e)},e.prototype.reset=function(){this._callbacks=null,this._contexts=null},e.prototype.destructor=function(){this.reset()},e}());t.exports=a.addPoolingTo(i)},{112:112,137:137,24:24}],7:[function(e,t,n){"use strict";function r(e){var t=e.nodeName&&e.nodeName.toLowerCase();return"select"===t||"input"===t&&"file"===e.type}function o(e){var t=T.getPooled(S.change,M,e,w(e));C.accumulateTwoPhaseDispatches(t),x.batchedUpdates(a,t)}function a(e){_.enqueueEvents(e),_.processEventQueue(!1)}function i(e,t){N=e,M=t,N.attachEvent("onchange",o)}function s(){N&&(N.detachEvent("onchange",o),N=null,M=null)}function u(e,t){if("topChange"===e)return t}function l(e,t,n){"topFocus"===e?(s(),i(t,n)):"topBlur"===e&&s()}function c(e,t){N=e,M=t,O=e.value,I=Object.getOwnPropertyDescriptor(e.constructor.prototype,"value"),Object.defineProperty(N,"value",D),N.attachEvent?N.attachEvent("onpropertychange",d):N.addEventListener("propertychange",d,!1)}function p(){N&&(delete N.value,N.detachEvent?N.detachEvent("onpropertychange",d):N.removeEventListener("propertychange",d,!1),N=null,M=null,O=null,I=null)}function d(e){if("value"===e.propertyName){var t=e.srcElement.value;t!==O&&(O=t,o(e))}}function f(e,t){if("topInput"===e)return t}function h(e,t,n){"topFocus"===e?(p(),c(t,n)):"topBlur"===e&&p()}function m(e,t){if(("topSelectionChange"===e||"topKeyUp"===e||"topKeyDown"===e)&&N&&N.value!==O)return O=N.value,M}function v(e){return e.nodeName&&"input"===e.nodeName.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)}function g(e,t){if("topClick"===e)return t}function y(e,t){if(null!=e){var n=e._wrapperState||t._wrapperState;if(n&&n.controlled&&"number"===t.type){var r=""+t.value;t.getAttribute("value")!==r&&t.setAttribute("value",r)}}}var _=e(16),C=e(19),b=e(123),E=e(33),x=e(71),T=e(80),w=e(102),k=e(109),P=e(110),S={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:["topBlur","topChange","topClick","topFocus","topInput","topKeyDown","topKeyUp","topSelectionChange"]}},N=null,M=null,O=null,I=null,R=!1;b.canUseDOM&&(R=k("change")&&(!document.documentMode||document.documentMode>8));var A=!1;b.canUseDOM&&(A=k("input")&&(!document.documentMode||document.documentMode>11));var D={get:function(){return I.get.call(this)},set:function(e){O=""+e,I.set.call(this,e)}},L={eventTypes:S,extractEvents:function(e,t,n,o){var a,i,s=t?E.getNodeFromInstance(t):window;if(r(s)?R?a=u:i=l:P(s)?A?a=f:(a=m,i=h):v(s)&&(a=g),a){var c=a(e,t);if(c){var p=T.getPooled(S.change,c,n,o);return p.type="change",C.accumulateTwoPhaseDispatches(p),p}}i&&i(e,s,t),"topBlur"===e&&y(t,s)}};t.exports=L},{102:102,109:109,110:110,123:123,16:16,19:19,33:33,71:71,80:80}],8:[function(e,t,n){"use strict";function r(e,t){return Array.isArray(t)&&(t=t[1]),t?t.nextSibling:e.firstChild}function o(e,t,n){c.insertTreeBefore(e,t,n)}function a(e,t,n){Array.isArray(t)?s(e,t[0],t[1],n):m(e,t,n)}function i(e,t){if(Array.isArray(t)){var n=t[1];t=t[0],u(e,t,n),e.removeChild(n)}e.removeChild(t)}function s(e,t,n,r){for(var o=t;;){var a=o.nextSibling;if(m(e,o,r),o===n)break;o=a}}function u(e,t,n){for(;;){var r=t.nextSibling;if(r===n)break;e.removeChild(r)}}function l(e,t,n){var r=e.parentNode,o=e.nextSibling;o===t?n&&m(r,document.createTextNode(n),o):n?(h(o,n),u(r,o,t)):u(r,e,t)}var c=e(9),p=e(13),d=(e(33),e(58),e(93)),f=e(114),h=e(115),m=d(function(e,t,n){e.insertBefore(t,n)}),v=p.dangerouslyReplaceNodeWithMarkup,g={dangerouslyReplaceNodeWithMarkup:v,replaceDelimitedText:l,processUpdates:function(e,t){for(var n=0;n<t.length;n++){var s=t[n];switch(s.type){case"INSERT_MARKUP":o(e,s.content,r(e,s.afterNode));break;case"MOVE_EXISTING":a(e,s.fromNode,r(e,s.afterNode));break;case"SET_MARKUP":f(e,s.content);break;case"TEXT_CONTENT":h(e,s.content);break;case"REMOVE_NODE":i(e,s.fromNode)}}}};t.exports=g},{114:114,115:115,13:13,33:33,58:58,9:9,93:93}],9:[function(e,t,n){"use strict";function r(e){if(h){var t=e.node,n=e.children;if(n.length)for(var r=0;r<n.length;r++)m(t,n[r],null);else null!=e.html?p(t,e.html):null!=e.text&&f(t,e.text)}}function o(e,t){e.parentNode.replaceChild(t.node,e),r(t)}function a(e,t){h?e.children.push(t):e.node.appendChild(t.node)}function i(e,t){h?e.html=t:p(e.node,t)}function s(e,t){h?e.text=t:f(e.node,t)}function u(){return this.node.nodeName}function l(e){return{node:e,children:[],html:null,text:null,toString:u}}var c=e(10),p=e(114),d=e(93),f=e(115),h="undefined"!=typeof document&&"number"==typeof document.documentMode||"undefined"!=typeof navigator&&"string"==typeof navigator.userAgent&&/\bEdge\/\d/.test(navigator.userAgent),m=d(function(e,t,n){11===t.node.nodeType||1===t.node.nodeType&&"object"===t.node.nodeName.toLowerCase()&&(null==t.node.namespaceURI||t.node.namespaceURI===c.html)?(r(t),e.insertBefore(t.node,n)):(e.insertBefore(t.node,n),r(t))});l.insertTreeBefore=m,l.replaceChildWithTree=o,l.queueChild=a,l.queueHTML=i,l.queueText=s,t.exports=l},{10:10,114:114,115:115,93:93}],10:[function(e,t,n){"use strict";var r={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};t.exports=r},{}],11:[function(e,t,n){"use strict";function r(e,t){return(e&t)===t}var o=e(112),a=(e(137),{MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,injectDOMPropertyConfig:function(e){var t=a,n=e.Properties||{},i=e.DOMAttributeNamespaces||{},u=e.DOMAttributeNames||{},l=e.DOMPropertyNames||{},c=e.DOMMutationMethods||{};e.isCustomAttribute&&s._isCustomAttributeFunctions.push(e.isCustomAttribute);for(var p in n){s.properties.hasOwnProperty(p)&&o("48",p);var d=p.toLowerCase(),f=n[p],h={attributeName:d,attributeNamespace:null,propertyName:p,mutationMethod:null,mustUseProperty:r(f,t.MUST_USE_PROPERTY),hasBooleanValue:r(f,t.HAS_BOOLEAN_VALUE),hasNumericValue:r(f,t.HAS_NUMERIC_VALUE),hasPositiveNumericValue:r(f,t.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:r(f,t.HAS_OVERLOADED_BOOLEAN_VALUE)};if(h.hasBooleanValue+h.hasNumericValue+h.hasOverloadedBooleanValue<=1||o("50",p),u.hasOwnProperty(p)){var m=u[p];h.attributeName=m}i.hasOwnProperty(p)&&(h.attributeNamespace=i[p]),l.hasOwnProperty(p)&&(h.propertyName=l[p]),c.hasOwnProperty(p)&&(h.mutationMethod=c[p]),s.properties[p]=h}}}),i=":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",s={ID_ATTRIBUTE_NAME:"data-reactid",ROOT_ATTRIBUTE_NAME:"data-reactroot",ATTRIBUTE_NAME_START_CHAR:i,ATTRIBUTE_NAME_CHAR:i+"\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",properties:{},getPossibleStandardName:null,_isCustomAttributeFunctions:[],isCustomAttribute:function(e){for(var t=0;t<s._isCustomAttributeFunctions.length;t++)if((0,s._isCustomAttributeFunctions[t])(e))return!0;return!1},injection:a};t.exports=s},{112:112,137:137}],12:[function(e,t,n){"use strict";function r(e){return!!l.hasOwnProperty(e)||!u.hasOwnProperty(e)&&(s.test(e)?(l[e]=!0,!0):(u[e]=!0,!1))}function o(e,t){return null==t||e.hasBooleanValue&&!t||e.hasNumericValue&&isNaN(t)||e.hasPositiveNumericValue&&t<1||e.hasOverloadedBooleanValue&&!1===t}var a=e(11),i=(e(33),e(58),e(111)),s=(e(142),new RegExp("^["+a.ATTRIBUTE_NAME_START_CHAR+"]["+a.ATTRIBUTE_NAME_CHAR+"]*$")),u={},l={},c={createMarkupForID:function(e){return a.ID_ATTRIBUTE_NAME+"="+i(e)},setAttributeForID:function(e,t){e.setAttribute(a.ID_ATTRIBUTE_NAME,t)},createMarkupForRoot:function(){return a.ROOT_ATTRIBUTE_NAME+'=""'},setAttributeForRoot:function(e){e.setAttribute(a.ROOT_ATTRIBUTE_NAME,"")},createMarkupForProperty:function(e,t){var n=a.properties.hasOwnProperty(e)?a.properties[e]:null;if(n){if(o(n,t))return"";var r=n.attributeName;return n.hasBooleanValue||n.hasOverloadedBooleanValue&&!0===t?r+'=""':r+"="+i(t)}return a.isCustomAttribute(e)?null==t?"":e+"="+i(t):null},createMarkupForCustomAttribute:function(e,t){return r(e)&&null!=t?e+"="+i(t):""},setValueForProperty:function(e,t,n){var r=a.properties.hasOwnProperty(t)?a.properties[t]:null;if(r){var i=r.mutationMethod;if(i)i(e,n);else{if(o(r,n))return void this.deleteValueForProperty(e,t);if(r.mustUseProperty)e[r.propertyName]=n;else{var s=r.attributeName,u=r.attributeNamespace;u?e.setAttributeNS(u,s,""+n):r.hasBooleanValue||r.hasOverloadedBooleanValue&&!0===n?e.setAttribute(s,""):e.setAttribute(s,""+n)}}}else if(a.isCustomAttribute(t))return void c.setValueForAttribute(e,t,n)},setValueForAttribute:function(e,t,n){r(t)&&(null==n?e.removeAttribute(t):e.setAttribute(t,""+n))},deleteValueForAttribute:function(e,t){e.removeAttribute(t)},deleteValueForProperty:function(e,t){var n=a.properties.hasOwnProperty(t)?a.properties[t]:null;if(n){var r=n.mutationMethod;if(r)r(e,void 0);else if(n.mustUseProperty){var o=n.propertyName;n.hasBooleanValue?e[o]=!1:e[o]=""}else e.removeAttribute(n.attributeName)}else a.isCustomAttribute(t)&&e.removeAttribute(t)}};t.exports=c},{11:11,111:111,142:142,33:33,58:58}],13:[function(e,t,n){"use strict";var r=e(112),o=e(9),a=e(123),i=e(128),s=e(129),u=(e(137),{dangerouslyReplaceNodeWithMarkup:function(e,t){if(a.canUseDOM||r("56"),t||r("57"),"HTML"===e.nodeName&&r("58"),"string"==typeof t){var n=i(t,s)[0];e.parentNode.replaceChild(n,e)}else o.replaceChildWithTree(e,t)}});t.exports=u},{112:112,123:123,128:128,129:129,137:137,9:9}],14:[function(e,t,n){"use strict";var r=["ResponderEventPlugin","SimpleEventPlugin","TapEventPlugin","EnterLeaveEventPlugin","ChangeEventPlugin","SelectEventPlugin","BeforeInputEventPlugin"];t.exports=r},{}],15:[function(e,t,n){"use strict";var r=e(19),o=e(33),a=e(84),i={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},s={eventTypes:i,extractEvents:function(e,t,n,s){if("topMouseOver"===e&&(n.relatedTarget||n.fromElement))return null;if("topMouseOut"!==e&&"topMouseOver"!==e)return null;var u;if(s.window===s)u=s;else{var l=s.ownerDocument;u=l?l.defaultView||l.parentWindow:window}var c,p;if("topMouseOut"===e){c=t;var d=n.relatedTarget||n.toElement;p=d?o.getClosestInstanceFromNode(d):null}else c=null,p=t;if(c===p)return null;var f=null==c?u:o.getNodeFromInstance(c),h=null==p?u:o.getNodeFromInstance(p),m=a.getPooled(i.mouseLeave,c,n,s);m.type="mouseleave",m.target=f,m.relatedTarget=h;var v=a.getPooled(i.mouseEnter,p,n,s);return v.type="mouseenter",v.target=h,v.relatedTarget=f,r.accumulateEnterLeaveDispatches(m,v,c,p),[m,v]}};t.exports=s},{19:19,33:33,84:84}],16:[function(e,t,n){"use strict";function r(e){return"button"===e||"input"===e||"select"===e||"textarea"===e}function o(e,t,n){switch(e){case"onClick":case"onClickCapture":case"onDoubleClick":case"onDoubleClickCapture":case"onMouseDown":case"onMouseDownCapture":case"onMouseMove":case"onMouseMoveCapture":case"onMouseUp":case"onMouseUpCapture":return!(!n.disabled||!r(t));default:return!1}}var a=e(112),i=e(17),s=e(18),u=e(50),l=e(91),c=e(98),p=(e(137),{}),d=null,f=function(e,t){e&&(s.executeDispatchesInOrder(e,t),e.isPersistent()||e.constructor.release(e))},h=function(e){return f(e,!0)},m=function(e){return f(e,!1)},v=function(e){return"."+e._rootNodeID},g={injection:{injectEventPluginOrder:i.injectEventPluginOrder,injectEventPluginsByName:i.injectEventPluginsByName},putListener:function(e,t,n){"function"!=typeof n&&a("94",t,typeof n);var r=v(e);(p[t]||(p[t]={}))[r]=n;var o=i.registrationNameModules[t];o&&o.didPutListener&&o.didPutListener(e,t,n)},getListener:function(e,t){var n=p[t];if(o(t,e._currentElement.type,e._currentElement.props))return null;var r=v(e);return n&&n[r]},deleteListener:function(e,t){var n=i.registrationNameModules[t];n&&n.willDeleteListener&&n.willDeleteListener(e,t);var r=p[t];r&&delete r[v(e)]},deleteAllListeners:function(e){var t=v(e);for(var n in p)if(p.hasOwnProperty(n)&&p[n][t]){var r=i.registrationNameModules[n];r&&r.willDeleteListener&&r.willDeleteListener(e,n),delete p[n][t]}},extractEvents:function(e,t,n,r){for(var o,a=i.plugins,s=0;s<a.length;s++){var u=a[s];if(u){var c=u.extractEvents(e,t,n,r);c&&(o=l(o,c))}}return o},enqueueEvents:function(e){e&&(d=l(d,e))},processEventQueue:function(e){var t=d;d=null,e?c(t,h):c(t,m),d&&a("95"),u.rethrowCaughtError()},__purge:function(){p={}},__getListenerBank:function(){return p}};t.exports=g},{112:112,137:137,17:17,18:18,50:50,91:91,98:98}],17:[function(e,t,n){"use strict";function r(){if(s)for(var e in u){var t=u[e],n=s.indexOf(e);if(n>-1||i("96",e),!l.plugins[n]){t.extractEvents||i("97",e),l.plugins[n]=t;var r=t.eventTypes;for(var a in r)o(r[a],t,a)||i("98",a,e)}}}function o(e,t,n){l.eventNameDispatchConfigs.hasOwnProperty(n)&&i("99",n),l.eventNameDispatchConfigs[n]=e;var r=e.phasedRegistrationNames;if(r){for(var o in r)if(r.hasOwnProperty(o)){var s=r[o];a(s,t,n)}return!0}return!!e.registrationName&&(a(e.registrationName,t,n),!0)}function a(e,t,n){l.registrationNameModules[e]&&i("100",e),l.registrationNameModules[e]=t,l.registrationNameDependencies[e]=t.eventTypes[n].dependencies}var i=e(112),s=(e(137),null),u={},l={plugins:[],eventNameDispatchConfigs:{},registrationNameModules:{},registrationNameDependencies:{},possibleRegistrationNames:null,injectEventPluginOrder:function(e){s&&i("101"),s=Array.prototype.slice.call(e),r()},injectEventPluginsByName:function(e){var t=!1;for(var n in e)if(e.hasOwnProperty(n)){var o=e[n];u.hasOwnProperty(n)&&u[n]===o||(u[n]&&i("102",n),u[n]=o,t=!0)}t&&r()},getPluginModuleForEvent:function(e){var t=e.dispatchConfig;if(t.registrationName)return l.registrationNameModules[t.registrationName]||null;if(void 0!==t.phasedRegistrationNames){var n=t.phasedRegistrationNames;for(var r in n)if(n.hasOwnProperty(r)){var o=l.registrationNameModules[n[r]];if(o)return o}}return null},_resetEventPlugins:function(){s=null;for(var e in u)u.hasOwnProperty(e)&&delete u[e];l.plugins.length=0;var t=l.eventNameDispatchConfigs;for(var n in t)t.hasOwnProperty(n)&&delete t[n];var r=l.registrationNameModules;for(var o in r)r.hasOwnProperty(o)&&delete r[o]}};t.exports=l},{112:112,137:137}],18:[function(e,t,n){"use strict";function r(e){return"topMouseUp"===e||"topTouchEnd"===e||"topTouchCancel"===e}function o(e){return"topMouseMove"===e||"topTouchMove"===e}function a(e){return"topMouseDown"===e||"topTouchStart"===e}function i(e,t,n,r){var o=e.type||"unknown-event";e.currentTarget=g.getNodeFromInstance(r),t?m.invokeGuardedCallbackWithCatch(o,n,e):m.invokeGuardedCallback(o,n,e),e.currentTarget=null}function s(e,t){var n=e._dispatchListeners,r=e._dispatchInstances;if(Array.isArray(n))for(var o=0;o<n.length&&!e.isPropagationStopped();o++)i(e,t,n[o],r[o]);else n&&i(e,t,n,r);e._dispatchListeners=null,e._dispatchInstances=null}function u(e){var t=e._dispatchListeners,n=e._dispatchInstances;if(Array.isArray(t)){for(var r=0;r<t.length&&!e.isPropagationStopped();r++)if(t[r](e,n[r]))return n[r]}else if(t&&t(e,n))return n;return null}function l(e){var t=u(e);return e._dispatchInstances=null,e._dispatchListeners=null,t}function c(e){var t=e._dispatchListeners,n=e._dispatchInstances;Array.isArray(t)&&h("103"),e.currentTarget=t?g.getNodeFromInstance(n):null;var r=t?t(e):null;return e.currentTarget=null,e._dispatchListeners=null,e._dispatchInstances=null,r}function p(e){return!!e._dispatchListeners}var d,f,h=e(112),m=e(50),v=(e(137),e(142),{injectComponentTree:function(e){d=e},injectTreeTraversal:function(e){f=e}}),g={isEndish:r,isMoveish:o,isStartish:a,executeDirectDispatch:c,executeDispatchesInOrder:s,executeDispatchesInOrderStopAtTrue:l,hasDispatches:p,getInstanceFromNode:function(e){return d.getInstanceFromNode(e)},getNodeFromInstance:function(e){return d.getNodeFromInstance(e)},isAncestor:function(e,t){return f.isAncestor(e,t)},getLowestCommonAncestor:function(e,t){return f.getLowestCommonAncestor(e,t)},getParentInstance:function(e){return f.getParentInstance(e)},traverseTwoPhase:function(e,t,n){return f.traverseTwoPhase(e,t,n)},traverseEnterLeave:function(e,t,n,r,o){return f.traverseEnterLeave(e,t,n,r,o)},injection:v};t.exports=g},{112:112,137:137,142:142,50:50}],19:[function(e,t,n){"use strict";function r(e,t,n){var r=t.dispatchConfig.phasedRegistrationNames[n];return g(e,r)}function o(e,t,n){var o=r(e,n,t);o&&(n._dispatchListeners=m(n._dispatchListeners,o),n._dispatchInstances=m(n._dispatchInstances,e))}function a(e){e&&e.dispatchConfig.phasedRegistrationNames&&h.traverseTwoPhase(e._targetInst,o,e)}function i(e){if(e&&e.dispatchConfig.phasedRegistrationNames){var t=e._targetInst,n=t?h.getParentInstance(t):null;h.traverseTwoPhase(n,o,e)}}function s(e,t,n){if(n&&n.dispatchConfig.registrationName){var r=n.dispatchConfig.registrationName,o=g(e,r);o&&(n._dispatchListeners=m(n._dispatchListeners,o),n._dispatchInstances=m(n._dispatchInstances,e))}}function u(e){e&&e.dispatchConfig.registrationName&&s(e._targetInst,null,e)}function l(e){v(e,a)}function c(e){v(e,i)}function p(e,t,n,r){h.traverseEnterLeave(n,r,s,e,t)}function d(e){v(e,u)}var f=e(16),h=e(18),m=e(91),v=e(98),g=(e(142),f.getListener),y={accumulateTwoPhaseDispatches:l,accumulateTwoPhaseDispatchesSkipTarget:c,accumulateDirectDispatches:d,accumulateEnterLeaveDispatches:p};t.exports=y},{142:142,16:16,18:18,91:91,98:98}],20:[function(e,t,n){"use strict";function r(e){this._root=e,this._startText=this.getText(),this._fallbackText=null}var o=e(143),a=e(24),i=e(106);o(r.prototype,{destructor:function(){this._root=null,this._startText=null,this._fallbackText=null},getText:function(){return"value"in this._root?this._root.value:this._root[i()]},getData:function(){if(this._fallbackText)return this._fallbackText;var e,t,n=this._startText,r=n.length,o=this.getText(),a=o.length;for(e=0;e<r&&n[e]===o[e];e++);var i=r-e;for(t=1;t<=i&&n[r-t]===o[a-t];t++);var s=t>1?1-t:void 0;return this._fallbackText=o.slice(e,s),this._fallbackText}}),a.addPoolingTo(r),t.exports=r},{106:106,143:143,24:24}],21:[function(e,t,n){"use strict";var r=e(11),o=r.injection.MUST_USE_PROPERTY,a=r.injection.HAS_BOOLEAN_VALUE,i=r.injection.HAS_NUMERIC_VALUE,s=r.injection.HAS_POSITIVE_NUMERIC_VALUE,u=r.injection.HAS_OVERLOADED_BOOLEAN_VALUE,l={isCustomAttribute:RegExp.prototype.test.bind(new RegExp("^(data|aria)-["+r.ATTRIBUTE_NAME_CHAR+"]*$")),Properties:{accept:0,acceptCharset:0,accessKey:0,action:0,allowFullScreen:a,allowTransparency:0,alt:0,as:0,async:a,autoComplete:0,autoPlay:a,capture:a,cellPadding:0,cellSpacing:0,charSet:0,challenge:0,checked:o|a,cite:0,classID:0,className:0,cols:s,colSpan:0,content:0,contentEditable:0,contextMenu:0,controls:a,coords:0,crossOrigin:0,data:0,dateTime:0,default:a,defer:a,dir:0,disabled:a,download:u,draggable:0,encType:0,form:0,formAction:0,formEncType:0,formMethod:0,formNoValidate:a,formTarget:0,frameBorder:0,headers:0,height:0,hidden:a,high:0,href:0,hrefLang:0,htmlFor:0,httpEquiv:0,icon:0,id:0,inputMode:0,integrity:0,is:0,keyParams:0,keyType:0,kind:0,label:0,lang:0,list:0,loop:a,low:0,manifest:0,marginHeight:0,marginWidth:0,max:0,maxLength:0,media:0,mediaGroup:0,method:0,min:0,minLength:0,multiple:o|a,muted:o|a,name:0,nonce:0,noValidate:a,open:a,optimum:0,pattern:0,placeholder:0,playsInline:a,poster:0,preload:0,profile:0,radioGroup:0,readOnly:a,referrerPolicy:0,rel:0,required:a,reversed:a,role:0,rows:s,rowSpan:i,sandbox:0,scope:0,scoped:a,scrolling:0,seamless:a,selected:o|a,shape:0,size:s,sizes:0,span:s,spellCheck:0,src:0,srcDoc:0,srcLang:0,srcSet:0,start:i,step:0,style:0,summary:0,tabIndex:0,target:0,title:0,type:0,useMap:0,value:0,width:0,wmode:0,wrap:0,about:0,datatype:0,inlist:0,prefix:0,property:0,resource:0,typeof:0,vocab:0,autoCapitalize:0,autoCorrect:0,autoSave:0,color:0,itemProp:0,itemScope:a,itemType:0,itemID:0,itemRef:0,results:0,security:0,unselectable:0},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMPropertyNames:{},DOMMutationMethods:{value:function(e,t){if(null==t)return e.removeAttribute("value");"number"!==e.type||!1===e.hasAttribute("value")?e.setAttribute("value",""+t):e.validity&&!e.validity.badInput&&e.ownerDocument.activeElement!==e&&e.setAttribute("value",""+t)}}};t.exports=l},{11:11}],22:[function(e,t,n){"use strict";function r(e){var t={"=":"=0",":":"=2"};return"$"+(""+e).replace(/[=:]/g,function(e){return t[e]})}function o(e){var t={"=0":"=","=2":":"};return(""+("."===e[0]&&"$"===e[1]?e.substring(2):e.substring(1))).replace(/(=0|=2)/g,function(e){return t[e]})}var a={escape:r,unescape:o};t.exports=a},{}],23:[function(e,t,n){"use strict";function r(e){null!=e.checkedLink&&null!=e.valueLink&&s("87")}function o(e){r(e),(null!=e.value||null!=e.onChange)&&s("88")}function a(e){r(e),(null!=e.checked||null!=e.onChange)&&s("89")}function i(e){if(e){var t=e.getName();if(t)return" Check the render method of `"+t+"`."}return""}var s=e(112),u=e(64),l=e(145),c=e(120),p=l(c.isValidElement),d=(e(137),e(142),{button:!0,checkbox:!0,image:!0,hidden:!0,radio:!0,reset:!0,submit:!0}),f={value:function(e,t,n){return!e[t]||d[e.type]||e.onChange||e.readOnly||e.disabled?null:new Error("You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`.")},checked:function(e,t,n){return!e[t]||e.onChange||e.readOnly||e.disabled?null:new Error("You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`.")},onChange:p.func},h={},m={checkPropTypes:function(e,t,n){for(var r in f){if(f.hasOwnProperty(r))var o=f[r](t,r,e,"prop",null,u);o instanceof Error&&!(o.message in h)&&(h[o.message]=!0,i(n))}},getValue:function(e){return e.valueLink?(o(e),e.valueLink.value):e.value},getChecked:function(e){return e.checkedLink?(a(e),e.checkedLink.value):e.checked},executeOnChange:function(e,t){return e.valueLink?(o(e),e.valueLink.requestChange(t.target.value)):e.checkedLink?(a(e),e.checkedLink.requestChange(t.target.checked)):e.onChange?e.onChange.call(void 0,t):void 0}};t.exports=m},{112:112,120:120,137:137,142:142,145:145,64:64}],24:[function(e,t,n){"use strict";var r=e(112),o=(e(137),function(e){var t=this;if(t.instancePool.length){var n=t.instancePool.pop();return t.call(n,e),n}return new t(e)}),a=function(e,t){var n=this;if(n.instancePool.length){var r=n.instancePool.pop();return n.call(r,e,t),r}return new n(e,t)},i=function(e,t,n){var r=this;if(r.instancePool.length){var o=r.instancePool.pop();return r.call(o,e,t,n),o}return new r(e,t,n)},s=function(e,t,n,r){var o=this;if(o.instancePool.length){var a=o.instancePool.pop();return o.call(a,e,t,n,r),a}return new o(e,t,n,r)},u=function(e){var t=this;e instanceof t||r("25"),e.destructor(),t.instancePool.length<t.poolSize&&t.instancePool.push(e)},l=o,c=function(e,t){var n=e;return n.instancePool=[],n.getPooled=t||l,n.poolSize||(n.poolSize=10),n.release=u,n},p={addPoolingTo:c,oneArgumentPooler:o,twoArgumentPooler:a,threeArgumentPooler:i,fourArgumentPooler:s};t.exports=p},{112:112,137:137}],25:[function(e,t,n){"use strict";function r(e){return Object.prototype.hasOwnProperty.call(e,m)||(e[m]=f++,p[e[m]]={}),p[e[m]]}var o,a=e(143),i=e(17),s=e(51),u=e(90),l=e(107),c=e(109),p={},d=!1,f=0,h={topAbort:"abort",topAnimationEnd:l("animationend")||"animationend",topAnimationIteration:l("animationiteration")||"animationiteration",topAnimationStart:l("animationstart")||"animationstart",topBlur:"blur",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",
topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",topTouchStart:"touchstart",topTransitionEnd:l("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},m="_reactListenersID"+String(Math.random()).slice(2),v=a({},s,{ReactEventListener:null,injection:{injectReactEventListener:function(e){e.setHandleTopLevel(v.handleTopLevel),v.ReactEventListener=e}},setEnabled:function(e){v.ReactEventListener&&v.ReactEventListener.setEnabled(e)},isEnabled:function(){return!(!v.ReactEventListener||!v.ReactEventListener.isEnabled())},listenTo:function(e,t){for(var n=t,o=r(n),a=i.registrationNameDependencies[e],s=0;s<a.length;s++){var u=a[s];o.hasOwnProperty(u)&&o[u]||("topWheel"===u?c("wheel")?v.ReactEventListener.trapBubbledEvent("topWheel","wheel",n):c("mousewheel")?v.ReactEventListener.trapBubbledEvent("topWheel","mousewheel",n):v.ReactEventListener.trapBubbledEvent("topWheel","DOMMouseScroll",n):"topScroll"===u?c("scroll",!0)?v.ReactEventListener.trapCapturedEvent("topScroll","scroll",n):v.ReactEventListener.trapBubbledEvent("topScroll","scroll",v.ReactEventListener.WINDOW_HANDLE):"topFocus"===u||"topBlur"===u?(c("focus",!0)?(v.ReactEventListener.trapCapturedEvent("topFocus","focus",n),v.ReactEventListener.trapCapturedEvent("topBlur","blur",n)):c("focusin")&&(v.ReactEventListener.trapBubbledEvent("topFocus","focusin",n),v.ReactEventListener.trapBubbledEvent("topBlur","focusout",n)),o.topBlur=!0,o.topFocus=!0):h.hasOwnProperty(u)&&v.ReactEventListener.trapBubbledEvent(u,h[u],n),o[u]=!0)}},trapBubbledEvent:function(e,t,n){return v.ReactEventListener.trapBubbledEvent(e,t,n)},trapCapturedEvent:function(e,t,n){return v.ReactEventListener.trapCapturedEvent(e,t,n)},supportsEventPageXY:function(){if(!document.createEvent)return!1;var e=document.createEvent("MouseEvent");return null!=e&&"pageX"in e},ensureScrollValueMonitoring:function(){if(void 0===o&&(o=v.supportsEventPageXY()),!o&&!d){var e=u.refreshScrollValues;v.ReactEventListener.monitorScrollValue(e),d=!0}}});t.exports=v},{107:107,109:109,143:143,17:17,51:51,90:90}],26:[function(e,t,n){(function(n){"use strict";function r(e,t,n,r){var o=void 0===e[n];null!=t&&o&&(e[n]=a(t,!0))}var o=e(66),a=e(108),i=(e(22),e(116)),s=e(117);e(142);void 0!==n&&n.env;var u={instantiateChildren:function(e,t,n,o){if(null==e)return null;var a={};return s(e,r,a),a},updateChildren:function(e,t,n,r,s,u,l,c,p){if(t||e){var d,f;for(d in t)if(t.hasOwnProperty(d)){f=e&&e[d];var h=f&&f._currentElement,m=t[d];if(null!=f&&i(h,m))o.receiveComponent(f,m,s,c),t[d]=f;else{f&&(r[d]=o.getHostNode(f),o.unmountComponent(f,!1));var v=a(m,!0);t[d]=v;var g=o.mountComponent(v,s,u,l,c,p);n.push(g)}}for(d in e)!e.hasOwnProperty(d)||t&&t.hasOwnProperty(d)||(f=e[d],r[d]=o.getHostNode(f),o.unmountComponent(f,!1))}},unmountChildren:function(e,t){for(var n in e)if(e.hasOwnProperty(n)){var r=e[n];o.unmountComponent(r,t)}}};t.exports=u}).call(this,void 0)},{108:108,116:116,117:117,142:142,22:22,66:66}],27:[function(e,t,n){"use strict";var r=e(8),o=e(37),a={processChildrenUpdates:o.dangerouslyProcessChildrenUpdates,replaceNodeWithMarkup:r.dangerouslyReplaceNodeWithMarkup};t.exports=a},{37:37,8:8}],28:[function(e,t,n){"use strict";var r=e(112),o=(e(137),!1),a={replaceNodeWithMarkup:null,processChildrenUpdates:null,injection:{injectEnvironment:function(e){o&&r("104"),a.replaceNodeWithMarkup=e.replaceNodeWithMarkup,a.processChildrenUpdates=e.processChildrenUpdates,o=!0}}};t.exports=a},{112:112,137:137}],29:[function(e,t,n){"use strict";function r(e){}function o(e){return!(!e.prototype||!e.prototype.isReactComponent)}function a(e){return!(!e.prototype||!e.prototype.isPureReactComponent)}var i=e(112),s=e(143),u=e(120),l=e(28),c=e(119),p=e(50),d=e(57),f=(e(58),e(62)),h=e(66),m=e(130),v=(e(137),e(141)),g=e(116),y=(e(142),{ImpureClass:0,PureClass:1,StatelessFunctional:2});r.prototype.render=function(){var e=d.get(this)._currentElement.type,t=e(this.props,this.context,this.updater);return t};var _=1,C={construct:function(e){this._currentElement=e,this._rootNodeID=0,this._compositeType=null,this._instance=null,this._hostParent=null,this._hostContainerInfo=null,this._updateBatchNumber=null,this._pendingElement=null,this._pendingStateQueue=null,this._pendingReplaceState=!1,this._pendingForceUpdate=!1,this._renderedNodeType=null,this._renderedComponent=null,this._context=null,this._mountOrder=0,this._topLevelWrapper=null,this._pendingCallbacks=null,this._calledComponentWillUnmount=!1},mountComponent:function(e,t,n,s){this._context=s,this._mountOrder=_++,this._hostParent=t,this._hostContainerInfo=n;var l,c=this._currentElement.props,p=this._processContext(s),f=this._currentElement.type,h=e.getUpdateQueue(),v=o(f),g=this._constructComponent(v,c,p,h);v||null!=g&&null!=g.render?a(f)?this._compositeType=y.PureClass:this._compositeType=y.ImpureClass:(l=g,null===g||!1===g||u.isValidElement(g)||i("105",f.displayName||f.name||"Component"),g=new r(f),this._compositeType=y.StatelessFunctional),g.props=c,g.context=p,g.refs=m,g.updater=h,this._instance=g,d.set(g,this);var C=g.state;void 0===C&&(g.state=C=null),("object"!=typeof C||Array.isArray(C))&&i("106",this.getName()||"ReactCompositeComponent"),this._pendingStateQueue=null,this._pendingReplaceState=!1,this._pendingForceUpdate=!1;var b;return b=g.unstable_handleError?this.performInitialMountWithErrorHandling(l,t,n,e,s):this.performInitialMount(l,t,n,e,s),g.componentDidMount&&e.getReactMountReady().enqueue(g.componentDidMount,g),b},_constructComponent:function(e,t,n,r){return this._constructComponentWithoutOwner(e,t,n,r)},_constructComponentWithoutOwner:function(e,t,n,r){var o=this._currentElement.type;return e?new o(t,n,r):o(t,n,r)},performInitialMountWithErrorHandling:function(e,t,n,r,o){var a,i=r.checkpoint();try{a=this.performInitialMount(e,t,n,r,o)}catch(s){r.rollback(i),this._instance.unstable_handleError(s),this._pendingStateQueue&&(this._instance.state=this._processPendingState(this._instance.props,this._instance.context)),i=r.checkpoint(),this._renderedComponent.unmountComponent(!0),r.rollback(i),a=this.performInitialMount(e,t,n,r,o)}return a},performInitialMount:function(e,t,n,r,o){var a=this._instance;a.componentWillMount&&(a.componentWillMount(),this._pendingStateQueue&&(a.state=this._processPendingState(a.props,a.context))),void 0===e&&(e=this._renderValidatedComponent());var i=f.getType(e);this._renderedNodeType=i;var s=this._instantiateReactComponent(e,i!==f.EMPTY);return this._renderedComponent=s,h.mountComponent(s,r,t,n,this._processChildContext(o),0)},getHostNode:function(){return h.getHostNode(this._renderedComponent)},unmountComponent:function(e){if(this._renderedComponent){var t=this._instance;if(t.componentWillUnmount&&!t._calledComponentWillUnmount)if(t._calledComponentWillUnmount=!0,e){var n=this.getName()+".componentWillUnmount()";p.invokeGuardedCallback(n,t.componentWillUnmount.bind(t))}else t.componentWillUnmount();this._renderedComponent&&(h.unmountComponent(this._renderedComponent,e),this._renderedNodeType=null,this._renderedComponent=null,this._instance=null),this._pendingStateQueue=null,this._pendingReplaceState=!1,this._pendingForceUpdate=!1,this._pendingCallbacks=null,this._pendingElement=null,this._context=null,this._rootNodeID=0,this._topLevelWrapper=null,d.remove(t)}},_maskContext:function(e){var t=this._currentElement.type,n=t.contextTypes;if(!n)return m;var r={};for(var o in n)r[o]=e[o];return r},_processContext:function(e){return this._maskContext(e)},_processChildContext:function(e){var t,n=this._currentElement.type,r=this._instance;if(r.getChildContext&&(t=r.getChildContext()),t){"object"!=typeof n.childContextTypes&&i("107",this.getName()||"ReactCompositeComponent");for(var o in t)o in n.childContextTypes||i("108",this.getName()||"ReactCompositeComponent",o);return s({},e,t)}return e},_checkContextTypes:function(e,t,n){},receiveComponent:function(e,t,n){var r=this._currentElement,o=this._context;this._pendingElement=null,this.updateComponent(t,r,e,o,n)},performUpdateIfNecessary:function(e){null!=this._pendingElement?h.receiveComponent(this,this._pendingElement,e,this._context):null!==this._pendingStateQueue||this._pendingForceUpdate?this.updateComponent(e,this._currentElement,this._currentElement,this._context,this._context):this._updateBatchNumber=null},updateComponent:function(e,t,n,r,o){var a=this._instance;null==a&&i("136",this.getName()||"ReactCompositeComponent");var s,u=!1;this._context===o?s=a.context:(s=this._processContext(o),u=!0);var l=t.props,c=n.props;t!==n&&(u=!0),u&&a.componentWillReceiveProps&&a.componentWillReceiveProps(c,s);var p=this._processPendingState(c,s),d=!0;this._pendingForceUpdate||(a.shouldComponentUpdate?d=a.shouldComponentUpdate(c,p,s):this._compositeType===y.PureClass&&(d=!v(l,c)||!v(a.state,p))),this._updateBatchNumber=null,d?(this._pendingForceUpdate=!1,this._performComponentUpdate(n,c,p,s,e,o)):(this._currentElement=n,this._context=o,a.props=c,a.state=p,a.context=s)},_processPendingState:function(e,t){var n=this._instance,r=this._pendingStateQueue,o=this._pendingReplaceState;if(this._pendingReplaceState=!1,this._pendingStateQueue=null,!r)return n.state;if(o&&1===r.length)return r[0];for(var a=s({},o?r[0]:n.state),i=o?1:0;i<r.length;i++){var u=r[i];s(a,"function"==typeof u?u.call(n,a,e,t):u)}return a},_performComponentUpdate:function(e,t,n,r,o,a){var i,s,u,l=this._instance,c=Boolean(l.componentDidUpdate);c&&(i=l.props,s=l.state,u=l.context),l.componentWillUpdate&&l.componentWillUpdate(t,n,r),this._currentElement=e,this._context=a,l.props=t,l.state=n,l.context=r,this._updateRenderedComponent(o,a),c&&o.getReactMountReady().enqueue(l.componentDidUpdate.bind(l,i,s,u),l)},_updateRenderedComponent:function(e,t){var n=this._renderedComponent,r=n._currentElement,o=this._renderValidatedComponent();if(g(r,o))h.receiveComponent(n,o,e,this._processChildContext(t));else{var a=h.getHostNode(n);h.unmountComponent(n,!1);var i=f.getType(o);this._renderedNodeType=i;var s=this._instantiateReactComponent(o,i!==f.EMPTY);this._renderedComponent=s;var u=h.mountComponent(s,e,this._hostParent,this._hostContainerInfo,this._processChildContext(t),0);this._replaceNodeWithMarkup(a,u,n)}},_replaceNodeWithMarkup:function(e,t,n){l.replaceNodeWithMarkup(e,t,n)},_renderValidatedComponentWithoutOwnerOrContext:function(){return this._instance.render()},_renderValidatedComponent:function(){var e;if(this._compositeType!==y.StatelessFunctional){c.current=this;try{e=this._renderValidatedComponentWithoutOwnerOrContext()}finally{c.current=null}}else e=this._renderValidatedComponentWithoutOwnerOrContext();return null===e||!1===e||u.isValidElement(e)||i("109",this.getName()||"ReactCompositeComponent"),e},attachRef:function(e,t){var n=this.getPublicInstance();null==n&&i("110");var r=t.getPublicInstance();(n.refs===m?n.refs={}:n.refs)[e]=r},detachRef:function(e){delete this.getPublicInstance().refs[e]},getName:function(){var e=this._currentElement.type,t=this._instance&&this._instance.constructor;return e.displayName||t&&t.displayName||e.name||t&&t.name||null},getPublicInstance:function(){var e=this._instance;return this._compositeType===y.StatelessFunctional?null:e},_instantiateReactComponent:null};t.exports=C},{112:112,116:116,119:119,120:120,130:130,137:137,141:141,142:142,143:143,28:28,50:50,57:57,58:58,62:62,66:66}],30:[function(e,t,n){"use strict";var r=e(33),o=e(47),a=e(60),i=e(66),s=e(71),u=e(72),l=e(96),c=e(103),p=e(113);e(142);o.inject();var d={findDOMNode:l,render:a.render,unmountComponentAtNode:a.unmountComponentAtNode,version:u,unstable_batchedUpdates:s.batchedUpdates,unstable_renderSubtreeIntoContainer:p};"undefined"!=typeof __REACT_DEVTOOLS_GLOBAL_HOOK__&&"function"==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject&&__REACT_DEVTOOLS_GLOBAL_HOOK__.inject({ComponentTree:{getClosestInstanceFromNode:r.getClosestInstanceFromNode,getNodeFromInstance:function(e){return e._renderedComponent&&(e=c(e)),e?r.getNodeFromInstance(e):null}},Mount:a,Reconciler:i});t.exports=d},{103:103,113:113,142:142,33:33,47:47,60:60,66:66,71:71,72:72,96:96}],31:[function(e,t,n){"use strict";function r(e){if(e){var t=e._currentElement._owner||null;if(t){var n=t.getName();if(n)return" This DOM node was rendered by `"+n+"`."}}return""}function o(e,t){t&&(Y[e._tag]&&(null!=t.children||null!=t.dangerouslySetInnerHTML)&&m("137",e._tag,e._currentElement._owner?" Check the render method of "+e._currentElement._owner.getName()+".":""),null!=t.dangerouslySetInnerHTML&&(null!=t.children&&m("60"),"object"==typeof t.dangerouslySetInnerHTML&&j in t.dangerouslySetInnerHTML||m("61")),null!=t.style&&"object"!=typeof t.style&&m("62",r(e)))}function a(e,t,n,r){if(!(r instanceof R)){var o=e._hostContainerInfo,a=o._node&&o._node.nodeType===H,s=a?o._node:o._ownerDocument;F(t,s),r.getReactMountReady().enqueue(i,{inst:e,registrationName:t,listener:n})}}function i(){var e=this;x.putListener(e.inst,e.registrationName,e.listener)}function s(){var e=this;S.postMountWrapper(e)}function u(){var e=this;O.postMountWrapper(e)}function l(){var e=this;N.postMountWrapper(e)}function c(){var e=this;e._rootNodeID||m("63");var t=U(e);switch(t||m("64"),e._tag){case"iframe":case"object":e._wrapperState.listeners=[w.trapBubbledEvent("topLoad","load",t)];break;case"video":case"audio":e._wrapperState.listeners=[];for(var n in q)q.hasOwnProperty(n)&&e._wrapperState.listeners.push(w.trapBubbledEvent(n,q[n],t));break;case"source":e._wrapperState.listeners=[w.trapBubbledEvent("topError","error",t)];break;case"img":e._wrapperState.listeners=[w.trapBubbledEvent("topError","error",t),w.trapBubbledEvent("topLoad","load",t)];break;case"form":e._wrapperState.listeners=[w.trapBubbledEvent("topReset","reset",t),w.trapBubbledEvent("topSubmit","submit",t)];break;case"input":case"select":case"textarea":e._wrapperState.listeners=[w.trapBubbledEvent("topInvalid","invalid",t)]}}function p(){M.postUpdateWrapper(this)}function d(e){G.call(Q,e)||(X.test(e)||m("65",e),Q[e]=!0)}function f(e,t){return e.indexOf("-")>=0||null!=t.is}function h(e){var t=e.type;d(t),this._currentElement=e,this._tag=t.toLowerCase(),this._namespaceURI=null,this._renderedChildren=null,this._previousStyle=null,this._previousStyleCopy=null,this._hostNode=null,this._hostParent=null,this._rootNodeID=0,this._domID=0,this._hostContainerInfo=null,this._wrapperState=null,this._topLevelWrapper=null,this._flags=0}var m=e(112),v=e(143),g=e(2),y=e(5),_=e(9),C=e(10),b=e(11),E=e(12),x=e(16),T=e(17),w=e(25),k=e(32),P=e(33),S=e(38),N=e(39),M=e(40),O=e(43),I=(e(58),e(61)),R=e(68),A=(e(129),e(95)),D=(e(137),e(109),e(141),e(118),e(142),k),L=x.deleteListener,U=P.getNodeFromInstance,F=w.listenTo,V=T.registrationNameModules,B={string:!0,number:!0},j="__html",W={children:null,dangerouslySetInnerHTML:null,suppressContentEditableWarning:null},H=11,q={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",topWaiting:"waiting"},K={area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0},z={listing:!0,pre:!0,textarea:!0},Y=v({menuitem:!0},K),X=/^[a-zA-Z][a-zA-Z:_\.\-\d]*$/,Q={},G={}.hasOwnProperty,$=1;h.displayName="ReactDOMComponent",h.Mixin={mountComponent:function(e,t,n,r){this._rootNodeID=$++,this._domID=n._idCounter++,this._hostParent=t,this._hostContainerInfo=n;var a=this._currentElement.props;switch(this._tag){case"audio":case"form":case"iframe":case"img":case"link":case"object":case"source":case"video":this._wrapperState={listeners:null},e.getReactMountReady().enqueue(c,this);break;case"input":S.mountWrapper(this,a,t),a=S.getHostProps(this,a),e.getReactMountReady().enqueue(c,this);break;case"option":N.mountWrapper(this,a,t),a=N.getHostProps(this,a);break;case"select":M.mountWrapper(this,a,t),a=M.getHostProps(this,a),e.getReactMountReady().enqueue(c,this);break;case"textarea":O.mountWrapper(this,a,t),a=O.getHostProps(this,a),e.getReactMountReady().enqueue(c,this)}o(this,a);var i,p;null!=t?(i=t._namespaceURI,p=t._tag):n._tag&&(i=n._namespaceURI,p=n._tag),(null==i||i===C.svg&&"foreignobject"===p)&&(i=C.html),i===C.html&&("svg"===this._tag?i=C.svg:"math"===this._tag&&(i=C.mathml)),this._namespaceURI=i;var d;if(e.useCreateElement){var f,h=n._ownerDocument;if(i===C.html)if("script"===this._tag){var m=h.createElement("div"),v=this._currentElement.type;m.innerHTML="<"+v+"></"+v+">",f=m.removeChild(m.firstChild)}else f=a.is?h.createElement(this._currentElement.type,a.is):h.createElement(this._currentElement.type);else f=h.createElementNS(i,this._currentElement.type);P.precacheNode(this,f),this._flags|=D.hasCachedChildNodes,this._hostParent||E.setAttributeForRoot(f),this._updateDOMProperties(null,a,e);var y=_(f);this._createInitialChildren(e,a,r,y),d=y}else{var b=this._createOpenTagMarkupAndPutListeners(e,a),x=this._createContentMarkup(e,a,r);d=!x&&K[this._tag]?b+"/>":b+">"+x+"</"+this._currentElement.type+">"}switch(this._tag){case"input":e.getReactMountReady().enqueue(s,this),a.autoFocus&&e.getReactMountReady().enqueue(g.focusDOMComponent,this);break;case"textarea":e.getReactMountReady().enqueue(u,this),a.autoFocus&&e.getReactMountReady().enqueue(g.focusDOMComponent,this);break;case"select":case"button":a.autoFocus&&e.getReactMountReady().enqueue(g.focusDOMComponent,this);break;case"option":e.getReactMountReady().enqueue(l,this)}return d},_createOpenTagMarkupAndPutListeners:function(e,t){var n="<"+this._currentElement.type;for(var r in t)if(t.hasOwnProperty(r)){var o=t[r];if(null!=o)if(V.hasOwnProperty(r))o&&a(this,r,o,e);else{"style"===r&&(o&&(o=this._previousStyleCopy=v({},t.style)),o=y.createMarkupForStyles(o,this));var i=null;null!=this._tag&&f(this._tag,t)?W.hasOwnProperty(r)||(i=E.createMarkupForCustomAttribute(r,o)):i=E.createMarkupForProperty(r,o),i&&(n+=" "+i)}}return e.renderToStaticMarkup?n:(this._hostParent||(n+=" "+E.createMarkupForRoot()),n+=" "+E.createMarkupForID(this._domID))},_createContentMarkup:function(e,t,n){var r="",o=t.dangerouslySetInnerHTML;if(null!=o)null!=o.__html&&(r=o.__html);else{var a=B[typeof t.children]?t.children:null,i=null!=a?null:t.children;if(null!=a)r=A(a);else if(null!=i){var s=this.mountChildren(i,e,n);r=s.join("")}}return z[this._tag]&&"\n"===r.charAt(0)?"\n"+r:r},_createInitialChildren:function(e,t,n,r){var o=t.dangerouslySetInnerHTML;if(null!=o)null!=o.__html&&_.queueHTML(r,o.__html);else{var a=B[typeof t.children]?t.children:null,i=null!=a?null:t.children;if(null!=a)""!==a&&_.queueText(r,a);else if(null!=i)for(var s=this.mountChildren(i,e,n),u=0;u<s.length;u++)_.queueChild(r,s[u])}},receiveComponent:function(e,t,n){var r=this._currentElement;this._currentElement=e,this.updateComponent(t,r,e,n)},updateComponent:function(e,t,n,r){var a=t.props,i=this._currentElement.props;switch(this._tag){case"input":a=S.getHostProps(this,a),i=S.getHostProps(this,i);break;case"option":a=N.getHostProps(this,a),i=N.getHostProps(this,i);break;case"select":a=M.getHostProps(this,a),i=M.getHostProps(this,i);break;case"textarea":a=O.getHostProps(this,a),i=O.getHostProps(this,i)}switch(o(this,i),this._updateDOMProperties(a,i,e),this._updateDOMChildren(a,i,e,r),this._tag){case"input":S.updateWrapper(this);break;case"textarea":O.updateWrapper(this);break;case"select":e.getReactMountReady().enqueue(p,this)}},_updateDOMProperties:function(e,t,n){var r,o,i;for(r in e)if(!t.hasOwnProperty(r)&&e.hasOwnProperty(r)&&null!=e[r])if("style"===r){var s=this._previousStyleCopy;for(o in s)s.hasOwnProperty(o)&&(i=i||{},i[o]="");this._previousStyleCopy=null}else V.hasOwnProperty(r)?e[r]&&L(this,r):f(this._tag,e)?W.hasOwnProperty(r)||E.deleteValueForAttribute(U(this),r):(b.properties[r]||b.isCustomAttribute(r))&&E.deleteValueForProperty(U(this),r);for(r in t){var u=t[r],l="style"===r?this._previousStyleCopy:null!=e?e[r]:void 0;if(t.hasOwnProperty(r)&&u!==l&&(null!=u||null!=l))if("style"===r)if(u?u=this._previousStyleCopy=v({},u):this._previousStyleCopy=null,l){for(o in l)!l.hasOwnProperty(o)||u&&u.hasOwnProperty(o)||(i=i||{},i[o]="");for(o in u)u.hasOwnProperty(o)&&l[o]!==u[o]&&(i=i||{},i[o]=u[o])}else i=u;else if(V.hasOwnProperty(r))u?a(this,r,u,n):l&&L(this,r);else if(f(this._tag,t))W.hasOwnProperty(r)||E.setValueForAttribute(U(this),r,u);else if(b.properties[r]||b.isCustomAttribute(r)){var c=U(this);null!=u?E.setValueForProperty(c,r,u):E.deleteValueForProperty(c,r)}}i&&y.setValueForStyles(U(this),i,this)},_updateDOMChildren:function(e,t,n,r){var o=B[typeof e.children]?e.children:null,a=B[typeof t.children]?t.children:null,i=e.dangerouslySetInnerHTML&&e.dangerouslySetInnerHTML.__html,s=t.dangerouslySetInnerHTML&&t.dangerouslySetInnerHTML.__html,u=null!=o?null:e.children,l=null!=a?null:t.children,c=null!=o||null!=i,p=null!=a||null!=s;null!=u&&null==l?this.updateChildren(null,n,r):c&&!p&&this.updateTextContent(""),null!=a?o!==a&&this.updateTextContent(""+a):null!=s?i!==s&&this.updateMarkup(""+s):null!=l&&this.updateChildren(l,n,r)},getHostNode:function(){return U(this)},unmountComponent:function(e){switch(this._tag){case"audio":case"form":case"iframe":case"img":case"link":case"object":case"source":case"video":var t=this._wrapperState.listeners;if(t)for(var n=0;n<t.length;n++)t[n].remove();break;case"html":case"head":case"body":m("66",this._tag)}this.unmountChildren(e),P.uncacheNode(this),x.deleteAllListeners(this),this._rootNodeID=0,this._domID=0,this._wrapperState=null},getPublicInstance:function(){return U(this)}},v(h.prototype,h.Mixin,I.Mixin),t.exports=h},{10:10,109:109,11:11,112:112,118:118,12:12,129:129,137:137,141:141,142:142,143:143,16:16,17:17,2:2,25:25,32:32,33:33,38:38,39:39,40:40,43:43,5:5,58:58,61:61,68:68,9:9,95:95}],32:[function(e,t,n){"use strict";var r={hasCachedChildNodes:1};t.exports=r},{}],33:[function(e,t,n){"use strict";function r(e,t){return 1===e.nodeType&&e.getAttribute(h)===String(t)||8===e.nodeType&&e.nodeValue===" react-text: "+t+" "||8===e.nodeType&&e.nodeValue===" react-empty: "+t+" "}function o(e){for(var t;t=e._renderedComponent;)e=t;return e}function a(e,t){var n=o(e);n._hostNode=t,t[v]=n}function i(e){var t=e._hostNode;t&&(delete t[v],e._hostNode=null)}function s(e,t){if(!(e._flags&m.hasCachedChildNodes)){var n=e._renderedChildren,i=t.firstChild;e:for(var s in n)if(n.hasOwnProperty(s)){var u=n[s],l=o(u)._domID;if(0!==l){for(;null!==i;i=i.nextSibling)if(r(i,l)){a(u,i);continue e}p("32",l)}}e._flags|=m.hasCachedChildNodes}}function u(e){if(e[v])return e[v];for(var t=[];!e[v];){if(t.push(e),!e.parentNode)return null;e=e.parentNode}for(var n,r;e&&(r=e[v]);e=t.pop())n=r,t.length&&s(r,e);return n}function l(e){var t=u(e);return null!=t&&t._hostNode===e?t:null}function c(e){if(void 0===e._hostNode&&p("33"),e._hostNode)return e._hostNode;for(var t=[];!e._hostNode;)t.push(e),e._hostParent||p("34"),e=e._hostParent;for(;t.length;e=t.pop())s(e,e._hostNode);return e._hostNode}var p=e(112),d=e(11),f=e(32),h=(e(137),d.ID_ATTRIBUTE_NAME),m=f,v="__reactInternalInstance$"+Math.random().toString(36).slice(2),g={getClosestInstanceFromNode:u,getInstanceFromNode:l,getNodeFromInstance:c,precacheChildNodes:s,precacheNode:a,uncacheNode:i};t.exports=g},{11:11,112:112,137:137,32:32}],34:[function(e,t,n){"use strict";function r(e,t){return{_topLevelWrapper:e,_idCounter:1,_ownerDocument:t?t.nodeType===o?t:t.ownerDocument:null,_node:t,_tag:t?t.nodeName.toLowerCase():null,_namespaceURI:t?t.namespaceURI:null}}var o=(e(118),9);t.exports=r},{118:118}],35:[function(e,t,n){"use strict";var r=e(143),o=e(9),a=e(33),i=function(e){this._currentElement=null,this._hostNode=null,this._hostParent=null,this._hostContainerInfo=null,this._domID=0};r(i.prototype,{mountComponent:function(e,t,n,r){var i=n._idCounter++;this._domID=i,this._hostParent=t,this._hostContainerInfo=n;var s=" react-empty: "+this._domID+" ";if(e.useCreateElement){var u=n._ownerDocument,l=u.createComment(s);return a.precacheNode(this,l),o(l)}return e.renderToStaticMarkup?"":"<!--"+s+"-->"},receiveComponent:function(){},getHostNode:function(){return a.getNodeFromInstance(this)},unmountComponent:function(){a.uncacheNode(this)}}),t.exports=i},{143:143,33:33,9:9}],36:[function(e,t,n){"use strict";var r={useCreateElement:!0,useFiber:!1};t.exports=r},{}],37:[function(e,t,n){"use strict";var r=e(8),o=e(33),a={dangerouslyProcessChildrenUpdates:function(e,t){var n=o.getNodeFromInstance(e);r.processUpdates(n,t)}};t.exports=a},{33:33,8:8}],38:[function(e,t,n){"use strict";function r(){this._rootNodeID&&d.updateWrapper(this)}function o(e){return"checkbox"===e.type||"radio"===e.type?null!=e.checked:null!=e.value}function a(e){var t=this._currentElement.props,n=l.executeOnChange(t,e);p.asap(r,this);var o=t.name;if("radio"===t.type&&null!=o){for(var a=c.getNodeFromInstance(this),s=a;s.parentNode;)s=s.parentNode;for(var u=s.querySelectorAll("input[name="+JSON.stringify(""+o)+'][type="radio"]'),d=0;d<u.length;d++){var f=u[d];if(f!==a&&f.form===a.form){var h=c.getInstanceFromNode(f);h||i("90"),p.asap(r,h)}}}return n}var i=e(112),s=e(143),u=e(12),l=e(23),c=e(33),p=e(71),d=(e(137),e(142),{getHostProps:function(e,t){var n=l.getValue(t),r=l.getChecked(t);return s({type:void 0,step:void 0,min:void 0,max:void 0},t,{defaultChecked:void 0,defaultValue:void 0,value:null!=n?n:e._wrapperState.initialValue,checked:null!=r?r:e._wrapperState.initialChecked,onChange:e._wrapperState.onChange})},mountWrapper:function(e,t){var n=t.defaultValue;e._wrapperState={initialChecked:null!=t.checked?t.checked:t.defaultChecked,initialValue:null!=t.value?t.value:n,listeners:null,onChange:a.bind(e),controlled:o(t)}},updateWrapper:function(e){var t=e._currentElement.props,n=t.checked;null!=n&&u.setValueForProperty(c.getNodeFromInstance(e),"checked",n||!1);var r=c.getNodeFromInstance(e),o=l.getValue(t);if(null!=o)if(0===o&&""===r.value)r.value="0";else if("number"===t.type){var a=parseFloat(r.value,10)||0;o!=a&&(r.value=""+o)}else o!=r.value&&(r.value=""+o);else null==t.value&&null!=t.defaultValue&&r.defaultValue!==""+t.defaultValue&&(r.defaultValue=""+t.defaultValue),null==t.checked&&null!=t.defaultChecked&&(r.defaultChecked=!!t.defaultChecked)},postMountWrapper:function(e){var t=e._currentElement.props,n=c.getNodeFromInstance(e);switch(t.type){case"submit":case"reset":break;case"color":case"date":case"datetime":case"datetime-local":case"month":case"time":case"week":n.value="",n.value=n.defaultValue;break;default:n.value=n.value}var r=n.name;""!==r&&(n.name=""),n.defaultChecked=!n.defaultChecked,n.defaultChecked=!n.defaultChecked,""!==r&&(n.name=r)}});t.exports=d},{112:112,12:12,137:137,142:142,143:143,23:23,33:33,71:71}],39:[function(e,t,n){"use strict";function r(e){var t="";return a.Children.forEach(e,function(e){null!=e&&("string"==typeof e||"number"==typeof e?t+=e:u||(u=!0))}),t}var o=e(143),a=e(120),i=e(33),s=e(40),u=(e(142),!1),l={mountWrapper:function(e,t,n){var o=null;if(null!=n){var a=n;"optgroup"===a._tag&&(a=a._hostParent),null!=a&&"select"===a._tag&&(o=s.getSelectValueContext(a))}var i=null;if(null!=o){var u;if(u=null!=t.value?t.value+"":r(t.children),i=!1,Array.isArray(o)){for(var l=0;l<o.length;l++)if(""+o[l]===u){i=!0;break}}else i=""+o===u}e._wrapperState={selected:i}},postMountWrapper:function(e){var t=e._currentElement.props;null!=t.value&&i.getNodeFromInstance(e).setAttribute("value",t.value)},getHostProps:function(e,t){var n=o({selected:void 0,children:void 0},t);null!=e._wrapperState.selected&&(n.selected=e._wrapperState.selected);var a=r(t.children);return a&&(n.children=a),n}};t.exports=l},{120:120,142:142,143:143,33:33,40:40}],40:[function(e,t,n){"use strict";function r(){if(this._rootNodeID&&this._wrapperState.pendingUpdate){this._wrapperState.pendingUpdate=!1;var e=this._currentElement.props,t=s.getValue(e);null!=t&&o(this,Boolean(e.multiple),t)}}function o(e,t,n){var r,o,a=u.getNodeFromInstance(e).options;if(t){for(r={},o=0;o<n.length;o++)r[""+n[o]]=!0;for(o=0;o<a.length;o++){var i=r.hasOwnProperty(a[o].value);a[o].selected!==i&&(a[o].selected=i)}}else{for(r=""+n,o=0;o<a.length;o++)if(a[o].value===r)return void(a[o].selected=!0);a.length&&(a[0].selected=!0)}}function a(e){var t=this._currentElement.props,n=s.executeOnChange(t,e);return this._rootNodeID&&(this._wrapperState.pendingUpdate=!0),l.asap(r,this),n}var i=e(143),s=e(23),u=e(33),l=e(71),c=(e(142),!1),p={getHostProps:function(e,t){return i({},t,{onChange:e._wrapperState.onChange,value:void 0})},mountWrapper:function(e,t){var n=s.getValue(t);e._wrapperState={pendingUpdate:!1,initialValue:null!=n?n:t.defaultValue,listeners:null,onChange:a.bind(e),wasMultiple:Boolean(t.multiple)},void 0===t.value||void 0===t.defaultValue||c||(c=!0)},getSelectValueContext:function(e){return e._wrapperState.initialValue},postUpdateWrapper:function(e){var t=e._currentElement.props;e._wrapperState.initialValue=void 0;var n=e._wrapperState.wasMultiple;e._wrapperState.wasMultiple=Boolean(t.multiple);var r=s.getValue(t);null!=r?(e._wrapperState.pendingUpdate=!1,o(e,Boolean(t.multiple),r)):n!==Boolean(t.multiple)&&(null!=t.defaultValue?o(e,Boolean(t.multiple),t.defaultValue):o(e,Boolean(t.multiple),t.multiple?[]:""))}};t.exports=p},{142:142,143:143,23:23,33:33,71:71}],41:[function(e,t,n){"use strict";function r(e,t,n,r){return e===n&&t===r}function o(e){var t=document.selection,n=t.createRange(),r=n.text.length,o=n.duplicate();o.moveToElementText(e),o.setEndPoint("EndToStart",n);var a=o.text.length;return{start:a,end:a+r}}function a(e){var t=window.getSelection&&window.getSelection();if(!t||0===t.rangeCount)return null;var n=t.anchorNode,o=t.anchorOffset,a=t.focusNode,i=t.focusOffset,s=t.getRangeAt(0);try{s.startContainer.nodeType,s.endContainer.nodeType}catch(e){return null}var u=r(t.anchorNode,t.anchorOffset,t.focusNode,t.focusOffset),l=u?0:s.toString().length,c=s.cloneRange();c.selectNodeContents(e),c.setEnd(s.startContainer,s.startOffset);var p=r(c.startContainer,c.startOffset,c.endContainer,c.endOffset),d=p?0:c.toString().length,f=d+l,h=document.createRange();h.setStart(n,o),h.setEnd(a,i);var m=h.collapsed;return{start:m?f:d,end:m?d:f}}function i(e,t){var n,r,o=document.selection.createRange().duplicate();void 0===t.end?(n=t.start,r=n):t.start>t.end?(n=t.end,r=t.start):(n=t.start,r=t.end),o.moveToElementText(e),o.moveStart("character",n),o.setEndPoint("EndToStart",o),o.moveEnd("character",r-n),o.select()}function s(e,t){if(window.getSelection){var n=window.getSelection(),r=e[c()].length,o=Math.min(t.start,r),a=void 0===t.end?o:Math.min(t.end,r);if(!n.extend&&o>a){var i=a;a=o,o=i}var s=l(e,o),u=l(e,a);if(s&&u){var p=document.createRange();p.setStart(s.node,s.offset),n.removeAllRanges(),o>a?(n.addRange(p),n.extend(u.node,u.offset)):(p.setEnd(u.node,u.offset),n.addRange(p))}}}var u=e(123),l=e(105),c=e(106),p=u.canUseDOM&&"selection"in document&&!("getSelection"in window),d={getOffsets:p?o:a,setOffsets:p?i:s};t.exports=d},{105:105,106:106,123:123}],42:[function(e,t,n){"use strict";var r=e(112),o=e(143),a=e(8),i=e(9),s=e(33),u=e(95),l=(e(137),e(118),function(e){this._currentElement=e,this._stringText=""+e,
this._hostNode=null,this._hostParent=null,this._domID=0,this._mountIndex=0,this._closingComment=null,this._commentNodes=null});o(l.prototype,{mountComponent:function(e,t,n,r){var o=n._idCounter++,a=" react-text: "+o+" ";if(this._domID=o,this._hostParent=t,e.useCreateElement){var l=n._ownerDocument,c=l.createComment(a),p=l.createComment(" /react-text "),d=i(l.createDocumentFragment());return i.queueChild(d,i(c)),this._stringText&&i.queueChild(d,i(l.createTextNode(this._stringText))),i.queueChild(d,i(p)),s.precacheNode(this,c),this._closingComment=p,d}var f=u(this._stringText);return e.renderToStaticMarkup?f:"<!--"+a+"-->"+f+"<!-- /react-text -->"},receiveComponent:function(e,t){if(e!==this._currentElement){this._currentElement=e;var n=""+e;if(n!==this._stringText){this._stringText=n;var r=this.getHostNode();a.replaceDelimitedText(r[0],r[1],n)}}},getHostNode:function(){var e=this._commentNodes;if(e)return e;if(!this._closingComment)for(var t=s.getNodeFromInstance(this),n=t.nextSibling;;){if(null==n&&r("67",this._domID),8===n.nodeType&&" /react-text "===n.nodeValue){this._closingComment=n;break}n=n.nextSibling}return e=[this._hostNode,this._closingComment],this._commentNodes=e,e},unmountComponent:function(){this._closingComment=null,this._commentNodes=null,s.uncacheNode(this)}}),t.exports=l},{112:112,118:118,137:137,143:143,33:33,8:8,9:9,95:95}],43:[function(e,t,n){"use strict";function r(){this._rootNodeID&&c.updateWrapper(this)}function o(e){var t=this._currentElement.props,n=s.executeOnChange(t,e);return l.asap(r,this),n}var a=e(112),i=e(143),s=e(23),u=e(33),l=e(71),c=(e(137),e(142),{getHostProps:function(e,t){return null!=t.dangerouslySetInnerHTML&&a("91"),i({},t,{value:void 0,defaultValue:void 0,children:""+e._wrapperState.initialValue,onChange:e._wrapperState.onChange})},mountWrapper:function(e,t){var n=s.getValue(t),r=n;if(null==n){var i=t.defaultValue,u=t.children;null!=u&&(null!=i&&a("92"),Array.isArray(u)&&(u.length<=1||a("93"),u=u[0]),i=""+u),null==i&&(i=""),r=i}e._wrapperState={initialValue:""+r,listeners:null,onChange:o.bind(e)}},updateWrapper:function(e){var t=e._currentElement.props,n=u.getNodeFromInstance(e),r=s.getValue(t);if(null!=r){var o=""+r;o!==n.value&&(n.value=o),null==t.defaultValue&&(n.defaultValue=o)}null!=t.defaultValue&&(n.defaultValue=t.defaultValue)},postMountWrapper:function(e){var t=u.getNodeFromInstance(e),n=t.textContent;n===e._wrapperState.initialValue&&(t.value=n)}});t.exports=c},{112:112,137:137,142:142,143:143,23:23,33:33,71:71}],44:[function(e,t,n){"use strict";function r(e,t){"_hostNode"in e||u("33"),"_hostNode"in t||u("33");for(var n=0,r=e;r;r=r._hostParent)n++;for(var o=0,a=t;a;a=a._hostParent)o++;for(;n-o>0;)e=e._hostParent,n--;for(;o-n>0;)t=t._hostParent,o--;for(var i=n;i--;){if(e===t)return e;e=e._hostParent,t=t._hostParent}return null}function o(e,t){"_hostNode"in e||u("35"),"_hostNode"in t||u("35");for(;t;){if(t===e)return!0;t=t._hostParent}return!1}function a(e){return"_hostNode"in e||u("36"),e._hostParent}function i(e,t,n){for(var r=[];e;)r.push(e),e=e._hostParent;var o;for(o=r.length;o-- >0;)t(r[o],"captured",n);for(o=0;o<r.length;o++)t(r[o],"bubbled",n)}function s(e,t,n,o,a){for(var i=e&&t?r(e,t):null,s=[];e&&e!==i;)s.push(e),e=e._hostParent;for(var u=[];t&&t!==i;)u.push(t),t=t._hostParent;var l;for(l=0;l<s.length;l++)n(s[l],"bubbled",o);for(l=u.length;l-- >0;)n(u[l],"captured",a)}var u=e(112);e(137);t.exports={isAncestor:o,getLowestCommonAncestor:r,getParentInstance:a,traverseTwoPhase:i,traverseEnterLeave:s}},{112:112,137:137}],45:[function(e,t,n){"use strict";var r=e(120),o=e(30),a=o;r.addons&&(r.__SECRET_INJECTED_REACT_DOM_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=a),t.exports=a},{120:120,30:30}],46:[function(e,t,n){"use strict";function r(){this.reinitializeTransaction()}var o=e(143),a=e(71),i=e(89),s=e(129),u={initialize:s,close:function(){d.isBatchingUpdates=!1}},l={initialize:s,close:a.flushBatchedUpdates.bind(a)},c=[l,u];o(r.prototype,i,{getTransactionWrappers:function(){return c}});var p=new r,d={isBatchingUpdates:!1,batchedUpdates:function(e,t,n,r,o,a){var i=d.isBatchingUpdates;return d.isBatchingUpdates=!0,i?e(t,n,r,o,a):p.perform(e,null,t,n,r,o,a)}};t.exports=d},{129:129,143:143,71:71,89:89}],47:[function(e,t,n){"use strict";function r(){x||(x=!0,y.EventEmitter.injectReactEventListener(g),y.EventPluginHub.injectEventPluginOrder(s),y.EventPluginUtils.injectComponentTree(d),y.EventPluginUtils.injectTreeTraversal(h),y.EventPluginHub.injectEventPluginsByName({SimpleEventPlugin:E,EnterLeaveEventPlugin:u,ChangeEventPlugin:i,SelectEventPlugin:b,BeforeInputEventPlugin:a}),y.HostComponent.injectGenericComponentClass(p),y.HostComponent.injectTextComponentClass(m),y.DOMProperty.injectDOMPropertyConfig(o),y.DOMProperty.injectDOMPropertyConfig(l),y.DOMProperty.injectDOMPropertyConfig(C),y.EmptyComponent.injectEmptyComponentFactory(function(e){return new f(e)}),y.Updates.injectReconcileTransaction(_),y.Updates.injectBatchingStrategy(v),y.Component.injectEnvironment(c))}var o=e(1),a=e(3),i=e(7),s=e(14),u=e(15),l=e(21),c=e(27),p=e(31),d=e(33),f=e(35),h=e(44),m=e(42),v=e(46),g=e(52),y=e(55),_=e(65),C=e(73),b=e(74),E=e(75),x=!1;t.exports={inject:r}},{1:1,14:14,15:15,21:21,27:27,3:3,31:31,33:33,35:35,42:42,44:44,46:46,52:52,55:55,65:65,7:7,73:73,74:74,75:75}],48:[function(e,t,n){"use strict";var r="function"==typeof Symbol&&Symbol.for&&Symbol.for("react.element")||60103;t.exports=r},{}],49:[function(e,t,n){"use strict";var r,o={injectEmptyComponentFactory:function(e){r=e}},a={create:function(e){return r(e)}};a.injection=o,t.exports=a},{}],50:[function(e,t,n){"use strict";function r(e,t,n){try{t(n)}catch(e){null===o&&(o=e)}}var o=null,a={invokeGuardedCallback:r,invokeGuardedCallbackWithCatch:r,rethrowCaughtError:function(){if(o){var e=o;throw o=null,e}}};t.exports=a},{}],51:[function(e,t,n){"use strict";function r(e){o.enqueueEvents(e),o.processEventQueue(!1)}var o=e(16),a={handleTopLevel:function(e,t,n,a){r(o.extractEvents(e,t,n,a))}};t.exports=a},{16:16}],52:[function(e,t,n){"use strict";function r(e){for(;e._hostParent;)e=e._hostParent;var t=p.getNodeFromInstance(e),n=t.parentNode;return p.getClosestInstanceFromNode(n)}function o(e,t){this.topLevelType=e,this.nativeEvent=t,this.ancestors=[]}function a(e){var t=f(e.nativeEvent),n=p.getClosestInstanceFromNode(t),o=n;do{e.ancestors.push(o),o=o&&r(o)}while(o);for(var a=0;a<e.ancestors.length;a++)n=e.ancestors[a],m._handleTopLevel(e.topLevelType,n,e.nativeEvent,f(e.nativeEvent))}function i(e){e(h(window))}var s=e(143),u=e(122),l=e(123),c=e(24),p=e(33),d=e(71),f=e(102),h=e(134);s(o.prototype,{destructor:function(){this.topLevelType=null,this.nativeEvent=null,this.ancestors.length=0}}),c.addPoolingTo(o,c.twoArgumentPooler);var m={_enabled:!0,_handleTopLevel:null,WINDOW_HANDLE:l.canUseDOM?window:null,setHandleTopLevel:function(e){m._handleTopLevel=e},setEnabled:function(e){m._enabled=!!e},isEnabled:function(){return m._enabled},trapBubbledEvent:function(e,t,n){return n?u.listen(n,t,m.dispatchEvent.bind(null,e)):null},trapCapturedEvent:function(e,t,n){return n?u.capture(n,t,m.dispatchEvent.bind(null,e)):null},monitorScrollValue:function(e){var t=i.bind(null,e);u.listen(window,"scroll",t)},dispatchEvent:function(e,t){if(m._enabled){var n=o.getPooled(e,t);try{d.batchedUpdates(a,n)}finally{o.release(n)}}}};t.exports=m},{102:102,122:122,123:123,134:134,143:143,24:24,33:33,71:71}],53:[function(e,t,n){"use strict";var r={logTopLevelRenders:!1};t.exports=r},{}],54:[function(e,t,n){"use strict";function r(e){return s||i("111",e.type),new s(e)}function o(e){return new u(e)}function a(e){return e instanceof u}var i=e(112),s=(e(137),null),u=null,l={injectGenericComponentClass:function(e){s=e},injectTextComponentClass:function(e){u=e}},c={createInternalComponent:r,createInstanceForText:o,isTextComponent:a,injection:l};t.exports=c},{112:112,137:137}],55:[function(e,t,n){"use strict";var r=e(11),o=e(16),a=e(18),i=e(28),s=e(49),u=e(25),l=e(54),c=e(71),p={Component:i.injection,DOMProperty:r.injection,EmptyComponent:s.injection,EventPluginHub:o.injection,EventPluginUtils:a.injection,EventEmitter:u.injection,HostComponent:l.injection,Updates:c.injection};t.exports=p},{11:11,16:16,18:18,25:25,28:28,49:49,54:54,71:71}],56:[function(e,t,n){"use strict";function r(e){return a(document.documentElement,e)}var o=e(41),a=e(126),i=e(131),s=e(132),u={hasSelectionCapabilities:function(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return t&&("input"===t&&"text"===e.type||"textarea"===t||"true"===e.contentEditable)},getSelectionInformation:function(){var e=s();return{focusedElem:e,selectionRange:u.hasSelectionCapabilities(e)?u.getSelection(e):null}},restoreSelection:function(e){var t=s(),n=e.focusedElem,o=e.selectionRange;t!==n&&r(n)&&(u.hasSelectionCapabilities(n)&&u.setSelection(n,o),i(n))},getSelection:function(e){var t;if("selectionStart"in e)t={start:e.selectionStart,end:e.selectionEnd};else if(document.selection&&e.nodeName&&"input"===e.nodeName.toLowerCase()){var n=document.selection.createRange();n.parentElement()===e&&(t={start:-n.moveStart("character",-e.value.length),end:-n.moveEnd("character",-e.value.length)})}else t=o.getOffsets(e);return t||{start:0,end:0}},setSelection:function(e,t){var n=t.start,r=t.end;if(void 0===r&&(r=n),"selectionStart"in e)e.selectionStart=n,e.selectionEnd=Math.min(r,e.value.length);else if(document.selection&&e.nodeName&&"input"===e.nodeName.toLowerCase()){var a=e.createTextRange();a.collapse(!0),a.moveStart("character",n),a.moveEnd("character",r-n),a.select()}else o.setOffsets(e,t)}};t.exports=u},{126:126,131:131,132:132,41:41}],57:[function(e,t,n){"use strict";var r={remove:function(e){e._reactInternalInstance=void 0},get:function(e){return e._reactInternalInstance},has:function(e){return void 0!==e._reactInternalInstance},set:function(e,t){e._reactInternalInstance=t}};t.exports=r},{}],58:[function(e,t,n){"use strict";t.exports={debugTool:null}},{}],59:[function(e,t,n){"use strict";var r=e(92),o=/^<\!\-\-/,a={CHECKSUM_ATTR_NAME:"data-react-checksum",addChecksumToMarkup:function(e){var t=r(e);return o.test(e)?e:e.replace(/\/?>/," "+a.CHECKSUM_ATTR_NAME+'="'+t+'"$&')},canReuseMarkup:function(e,t){var n=t.getAttribute(a.CHECKSUM_ATTR_NAME);return n=n&&parseInt(n,10),r(e)===n}};t.exports=a},{92:92}],60:[function(e,t,n){"use strict";function r(e,t){for(var n=Math.min(e.length,t.length),r=0;r<n;r++)if(e.charAt(r)!==t.charAt(r))return r;return e.length===t.length?-1:n}function o(e){return e?e.nodeType===A?e.documentElement:e.firstChild:null}function a(e){return e.getAttribute&&e.getAttribute(O)||""}function i(e,t,n,r,o){var a;if(b.logTopLevelRenders){var i=e._currentElement.props.child,s=i.type;a="React mount: "+("string"==typeof s?s:s.displayName||s.name),console.time(a)}var u=T.mountComponent(e,n,null,_(e,t),o,0);a&&console.timeEnd(a),e._renderedComponent._topLevelWrapper=e,V._mountImageIntoNode(u,t,e,r,n)}function s(e,t,n,r){var o=k.ReactReconcileTransaction.getPooled(!n&&C.useCreateElement);o.perform(i,null,e,t,o,n,r),k.ReactReconcileTransaction.release(o)}function u(e,t,n){for(T.unmountComponent(e,n),t.nodeType===A&&(t=t.documentElement);t.lastChild;)t.removeChild(t.lastChild)}function l(e){var t=o(e);if(t){var n=y.getInstanceFromNode(t);return!(!n||!n._hostParent)}}function c(e){return!(!e||e.nodeType!==R&&e.nodeType!==A&&e.nodeType!==D)}function p(e){var t=o(e),n=t&&y.getInstanceFromNode(t);return n&&!n._hostParent?n:null}function d(e){var t=p(e);return t?t._hostContainerInfo._topLevelWrapper:null}var f=e(112),h=e(9),m=e(11),v=e(120),g=e(25),y=(e(119),e(33)),_=e(34),C=e(36),b=e(53),E=e(57),x=(e(58),e(59)),T=e(66),w=e(70),k=e(71),P=e(130),S=e(108),N=(e(137),e(114)),M=e(116),O=(e(142),m.ID_ATTRIBUTE_NAME),I=m.ROOT_ATTRIBUTE_NAME,R=1,A=9,D=11,L={},U=1,F=function(){this.rootID=U++};F.prototype.isReactComponent={},F.prototype.render=function(){return this.props.child},F.isReactTopLevelWrapper=!0;var V={TopLevelWrapper:F,_instancesByReactRootID:L,scrollMonitor:function(e,t){t()},_updateRootComponent:function(e,t,n,r,o){return V.scrollMonitor(r,function(){w.enqueueElementInternal(e,t,n),o&&w.enqueueCallbackInternal(e,o)}),e},_renderNewRootComponent:function(e,t,n,r){c(t)||f("37"),g.ensureScrollValueMonitoring();var o=S(e,!1);k.batchedUpdates(s,o,t,n,r);var a=o._instance.rootID;return L[a]=o,o},renderSubtreeIntoContainer:function(e,t,n,r){return null!=e&&E.has(e)||f("38"),V._renderSubtreeIntoContainer(e,t,n,r)},_renderSubtreeIntoContainer:function(e,t,n,r){w.validateCallback(r,"ReactDOM.render"),v.isValidElement(t)||f("39","string"==typeof t?" Instead of passing a string like 'div', pass React.createElement('div') or <div />.":"function"==typeof t?" Instead of passing a class like Foo, pass React.createElement(Foo) or <Foo />.":null!=t&&void 0!==t.props?" This may be caused by unintentionally loading two independent copies of React.":"");var i,s=v.createElement(F,{child:t});if(e){var u=E.get(e);i=u._processChildContext(u._context)}else i=P;var c=d(n);if(c){var p=c._currentElement,h=p.props.child;if(M(h,t)){var m=c._renderedComponent.getPublicInstance(),g=r&&function(){r.call(m)};return V._updateRootComponent(c,s,i,n,g),m}V.unmountComponentAtNode(n)}var y=o(n),_=y&&!!a(y),C=l(n),b=_&&!c&&!C,x=V._renderNewRootComponent(s,n,b,i)._renderedComponent.getPublicInstance();return r&&r.call(x),x},render:function(e,t,n){return V._renderSubtreeIntoContainer(null,e,t,n)},unmountComponentAtNode:function(e){c(e)||f("40");var t=d(e);return t?(delete L[t._instance.rootID],k.batchedUpdates(u,t,e,!1),!0):(l(e),1===e.nodeType&&e.hasAttribute(I),!1)},_mountImageIntoNode:function(e,t,n,a,i){if(c(t)||f("41"),a){var s=o(t);if(x.canReuseMarkup(e,s))return void y.precacheNode(n,s);var u=s.getAttribute(x.CHECKSUM_ATTR_NAME);s.removeAttribute(x.CHECKSUM_ATTR_NAME);var l=s.outerHTML;s.setAttribute(x.CHECKSUM_ATTR_NAME,u);var p=e,d=r(p,l),m=" (client) "+p.substring(d-20,d+20)+"\n (server) "+l.substring(d-20,d+20);t.nodeType===A&&f("42",m)}if(t.nodeType===A&&f("43"),i.useCreateElement){for(;t.lastChild;)t.removeChild(t.lastChild);h.insertTreeBefore(t,e,null)}else N(t,e),y.precacheNode(n,t.firstChild)}};t.exports=V},{108:108,11:11,112:112,114:114,116:116,119:119,120:120,130:130,137:137,142:142,25:25,33:33,34:34,36:36,53:53,57:57,58:58,59:59,66:66,70:70,71:71,9:9}],61:[function(e,t,n){"use strict";function r(e,t,n){return{type:"INSERT_MARKUP",content:e,fromIndex:null,fromNode:null,toIndex:n,afterNode:t}}function o(e,t,n){return{type:"MOVE_EXISTING",content:null,fromIndex:e._mountIndex,fromNode:d.getHostNode(e),toIndex:n,afterNode:t}}function a(e,t){return{type:"REMOVE_NODE",content:null,fromIndex:e._mountIndex,fromNode:t,toIndex:null,afterNode:null}}function i(e){return{type:"SET_MARKUP",content:e,fromIndex:null,fromNode:null,toIndex:null,afterNode:null}}function s(e){return{type:"TEXT_CONTENT",content:e,fromIndex:null,fromNode:null,toIndex:null,afterNode:null}}function u(e,t){return t&&(e=e||[],e.push(t)),e}function l(e,t){p.processChildrenUpdates(e,t)}var c=e(112),p=e(28),d=(e(57),e(58),e(119),e(66)),f=e(26),h=(e(129),e(97)),m=(e(137),{Mixin:{_reconcilerInstantiateChildren:function(e,t,n){return f.instantiateChildren(e,t,n)},_reconcilerUpdateChildren:function(e,t,n,r,o,a){var i;return i=h(t,0),f.updateChildren(e,i,n,r,o,this,this._hostContainerInfo,a,0),i},mountChildren:function(e,t,n){var r=this._reconcilerInstantiateChildren(e,t,n);this._renderedChildren=r;var o=[],a=0;for(var i in r)if(r.hasOwnProperty(i)){var s=r[i],u=d.mountComponent(s,t,this,this._hostContainerInfo,n,0);s._mountIndex=a++,o.push(u)}return o},updateTextContent:function(e){var t=this._renderedChildren;f.unmountChildren(t,!1);for(var n in t)t.hasOwnProperty(n)&&c("118");l(this,[s(e)])},updateMarkup:function(e){var t=this._renderedChildren;f.unmountChildren(t,!1);for(var n in t)t.hasOwnProperty(n)&&c("118");l(this,[i(e)])},updateChildren:function(e,t,n){this._updateChildren(e,t,n)},_updateChildren:function(e,t,n){var r=this._renderedChildren,o={},a=[],i=this._reconcilerUpdateChildren(r,e,a,o,t,n);if(i||r){var s,c=null,p=0,f=0,h=0,m=null;for(s in i)if(i.hasOwnProperty(s)){var v=r&&r[s],g=i[s];v===g?(c=u(c,this.moveChild(v,m,p,f)),f=Math.max(v._mountIndex,f),v._mountIndex=p):(v&&(f=Math.max(v._mountIndex,f)),c=u(c,this._mountChildAtIndex(g,a[h],m,p,t,n)),h++),p++,m=d.getHostNode(g)}for(s in o)o.hasOwnProperty(s)&&(c=u(c,this._unmountChild(r[s],o[s])));c&&l(this,c),this._renderedChildren=i}},unmountChildren:function(e){var t=this._renderedChildren;f.unmountChildren(t,e),this._renderedChildren=null},moveChild:function(e,t,n,r){if(e._mountIndex<r)return o(e,t,n)},createChild:function(e,t,n){return r(n,t,e._mountIndex)},removeChild:function(e,t){return a(e,t)},_mountChildAtIndex:function(e,t,n,r,o,a){return e._mountIndex=r,this.createChild(e,n,t)},_unmountChild:function(e,t){var n=this.removeChild(e,t);return e._mountIndex=null,n}}});t.exports=m},{112:112,119:119,129:129,137:137,26:26,28:28,57:57,58:58,66:66,97:97}],62:[function(e,t,n){"use strict";var r=e(112),o=e(120),a=(e(137),{HOST:0,COMPOSITE:1,EMPTY:2,getType:function(e){return null===e||!1===e?a.EMPTY:o.isValidElement(e)?"function"==typeof e.type?a.COMPOSITE:a.HOST:void r("26",e)}});t.exports=a},{112:112,120:120,137:137}],63:[function(e,t,n){"use strict";function r(e){return!(!e||"function"!=typeof e.attachRef||"function"!=typeof e.detachRef)}var o=e(112),a=(e(137),{addComponentAsRefTo:function(e,t,n){r(n)||o("119"),n.attachRef(t,e)},removeComponentAsRefFrom:function(e,t,n){r(n)||o("120");var a=n.getPublicInstance();a&&a.refs[t]===e.getPublicInstance()&&n.detachRef(t)}});t.exports=a},{112:112,137:137}],64:[function(e,t,n){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},{}],65:[function(e,t,n){"use strict";function r(e){this.reinitializeTransaction(),this.renderToStaticMarkup=!1,this.reactMountReady=a.getPooled(null),this.useCreateElement=e}var o=e(143),a=e(6),i=e(24),s=e(25),u=e(56),l=(e(58),e(89)),c=e(70),p={initialize:u.getSelectionInformation,close:u.restoreSelection},d={initialize:function(){var e=s.isEnabled();return s.setEnabled(!1),e},close:function(e){s.setEnabled(e)}},f={initialize:function(){this.reactMountReady.reset()},close:function(){this.reactMountReady.notifyAll()}},h=[p,d,f],m={getTransactionWrappers:function(){return h},getReactMountReady:function(){return this.reactMountReady},getUpdateQueue:function(){return c},checkpoint:function(){return this.reactMountReady.checkpoint()},rollback:function(e){this.reactMountReady.rollback(e)},destructor:function(){a.release(this.reactMountReady),this.reactMountReady=null}};o(r.prototype,l,m),i.addPoolingTo(r),t.exports=r},{143:143,24:24,25:25,56:56,58:58,6:6,70:70,89:89}],66:[function(e,t,n){"use strict";function r(){o.attachRefs(this,this._currentElement)}var o=e(67),a=(e(58),e(142),{mountComponent:function(e,t,n,o,a,i){var s=e.mountComponent(t,n,o,a,i);return e._currentElement&&null!=e._currentElement.ref&&t.getReactMountReady().enqueue(r,e),s},getHostNode:function(e){return e.getHostNode()},unmountComponent:function(e,t){o.detachRefs(e,e._currentElement),e.unmountComponent(t)},receiveComponent:function(e,t,n,a){var i=e._currentElement;if(t!==i||a!==e._context){var s=o.shouldUpdateRefs(i,t);s&&o.detachRefs(e,i),e.receiveComponent(t,n,a),s&&e._currentElement&&null!=e._currentElement.ref&&n.getReactMountReady().enqueue(r,e)}},performUpdateIfNecessary:function(e,t,n){e._updateBatchNumber===n&&e.performUpdateIfNecessary(t)}});t.exports=a},{142:142,58:58,67:67}],67:[function(e,t,n){"use strict";function r(e,t,n){"function"==typeof e?e(t.getPublicInstance()):a.addComponentAsRefTo(t,e,n)}function o(e,t,n){"function"==typeof e?e(null):a.removeComponentAsRefFrom(t,e,n)}var a=e(63),i={};i.attachRefs=function(e,t){if(null!==t&&"object"==typeof t){var n=t.ref;null!=n&&r(n,e,t._owner)}},i.shouldUpdateRefs=function(e,t){var n=null,r=null;null!==e&&"object"==typeof e&&(n=e.ref,r=e._owner);var o=null,a=null;return null!==t&&"object"==typeof t&&(o=t.ref,a=t._owner),n!==o||"string"==typeof o&&a!==r},i.detachRefs=function(e,t){if(null!==t&&"object"==typeof t){var n=t.ref;null!=n&&o(n,e,t._owner)}},t.exports=i},{63:63}],68:[function(e,t,n){"use strict";function r(e){this.reinitializeTransaction(),this.renderToStaticMarkup=e,this.useCreateElement=!1,this.updateQueue=new s(this)}var o=e(143),a=e(24),i=e(89),s=(e(58),e(69)),u=[],l={enqueue:function(){}},c={getTransactionWrappers:function(){return u},getReactMountReady:function(){return l},getUpdateQueue:function(){return this.updateQueue},destructor:function(){},checkpoint:function(){},rollback:function(){}};o(r.prototype,i,c),a.addPoolingTo(r),t.exports=r},{143:143,24:24,58:58,69:69,89:89}],69:[function(e,t,n){"use strict";function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}var o=e(70),a=(e(142),function(){function e(t){r(this,e),this.transaction=t}return e.prototype.isMounted=function(e){return!1},e.prototype.enqueueCallback=function(e,t,n){this.transaction.isInTransaction()&&o.enqueueCallback(e,t,n)},e.prototype.enqueueForceUpdate=function(e){this.transaction.isInTransaction()&&o.enqueueForceUpdate(e)},e.prototype.enqueueReplaceState=function(e,t){this.transaction.isInTransaction()&&o.enqueueReplaceState(e,t)},e.prototype.enqueueSetState=function(e,t){this.transaction.isInTransaction()&&o.enqueueSetState(e,t)},e}());t.exports=a},{142:142,70:70}],70:[function(e,t,n){"use strict";function r(e){u.enqueueUpdate(e)}function o(e){var t=typeof e;if("object"!==t)return t;var n=e.constructor&&e.constructor.name||t,r=Object.keys(e);return r.length>0&&r.length<20?n+" (keys: "+r.join(", ")+")":n}function a(e,t){var n=s.get(e);return n||null}var i=e(112),s=(e(119),e(57)),u=(e(58),e(71)),l=(e(137),e(142),{isMounted:function(e){var t=s.get(e);return!!t&&!!t._renderedComponent},enqueueCallback:function(e,t,n){l.validateCallback(t,n);var o=a(e);if(!o)return null;o._pendingCallbacks?o._pendingCallbacks.push(t):o._pendingCallbacks=[t],r(o)},enqueueCallbackInternal:function(e,t){e._pendingCallbacks?e._pendingCallbacks.push(t):e._pendingCallbacks=[t],r(e)},enqueueForceUpdate:function(e){var t=a(e,"forceUpdate");t&&(t._pendingForceUpdate=!0,r(t))},enqueueReplaceState:function(e,t,n){var o=a(e,"replaceState");o&&(o._pendingStateQueue=[t],o._pendingReplaceState=!0,void 0!==n&&null!==n&&(l.validateCallback(n,"replaceState"),o._pendingCallbacks?o._pendingCallbacks.push(n):o._pendingCallbacks=[n]),r(o))},enqueueSetState:function(e,t){var n=a(e,"setState");n&&((n._pendingStateQueue||(n._pendingStateQueue=[])).push(t),r(n))},enqueueElementInternal:function(e,t,n){e._pendingElement=t,e._context=n,r(e)},validateCallback:function(e,t){e&&"function"!=typeof e&&i("122",t,o(e))}});t.exports=l},{112:112,119:119,137:137,142:142,57:57,58:58,71:71}],71:[function(e,t,n){"use strict";function r(){P.ReactReconcileTransaction&&b||c("123")}function o(){this.reinitializeTransaction(),this.dirtyComponentsLength=null,this.callbackQueue=d.getPooled(),this.reconcileTransaction=P.ReactReconcileTransaction.getPooled(!0)}function a(e,t,n,o,a,i){return r(),b.batchedUpdates(e,t,n,o,a,i)}function i(e,t){return e._mountOrder-t._mountOrder}function s(e){var t=e.dirtyComponentsLength;t!==g.length&&c("124",t,g.length),g.sort(i),y++;for(var n=0;n<t;n++){var r=g[n],o=r._pendingCallbacks;r._pendingCallbacks=null;var a;if(h.logTopLevelRenders){var s=r;r._currentElement.type.isReactTopLevelWrapper&&(s=r._renderedComponent),a="React update: "+s.getName(),console.time(a)}if(m.performUpdateIfNecessary(r,e.reconcileTransaction,y),a&&console.timeEnd(a),o)for(var u=0;u<o.length;u++)e.callbackQueue.enqueue(o[u],r.getPublicInstance())}}function u(e){if(r(),!b.isBatchingUpdates)return void b.batchedUpdates(u,e);g.push(e),null==e._updateBatchNumber&&(e._updateBatchNumber=y+1)}function l(e,t){b.isBatchingUpdates||c("125"),_.enqueue(e,t),C=!0}var c=e(112),p=e(143),d=e(6),f=e(24),h=e(53),m=e(66),v=e(89),g=(e(137),[]),y=0,_=d.getPooled(),C=!1,b=null,E={initialize:function(){this.dirtyComponentsLength=g.length},close:function(){this.dirtyComponentsLength!==g.length?(g.splice(0,this.dirtyComponentsLength),w()):g.length=0}},x={initialize:function(){this.callbackQueue.reset()},close:function(){this.callbackQueue.notifyAll()}},T=[E,x];p(o.prototype,v,{getTransactionWrappers:function(){return T},destructor:function(){this.dirtyComponentsLength=null,d.release(this.callbackQueue),this.callbackQueue=null,P.ReactReconcileTransaction.release(this.reconcileTransaction),this.reconcileTransaction=null},perform:function(e,t,n){return v.perform.call(this,this.reconcileTransaction.perform,this.reconcileTransaction,e,t,n)}}),f.addPoolingTo(o);var w=function(){for(;g.length||C;){if(g.length){var e=o.getPooled();e.perform(s,null,e),o.release(e)}if(C){C=!1;var t=_;_=d.getPooled(),t.notifyAll(),d.release(t)}}},k={injectReconcileTransaction:function(e){e||c("126"),P.ReactReconcileTransaction=e},injectBatchingStrategy:function(e){e||c("127"),"function"!=typeof e.batchedUpdates&&c("128"),"boolean"!=typeof e.isBatchingUpdates&&c("129"),b=e}},P={ReactReconcileTransaction:null,batchedUpdates:a,enqueueUpdate:u,flushBatchedUpdates:w,injection:k,asap:l};t.exports=P},{112:112,137:137,143:143,24:24,53:53,6:6,66:66,89:89}],72:[function(e,t,n){"use strict";t.exports="15.5.0"},{}],73:[function(e,t,n){"use strict";var r={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},o={accentHeight:"accent-height",accumulate:0,additive:0,alignmentBaseline:"alignment-baseline",allowReorder:"allowReorder",alphabetic:0,amplitude:0,arabicForm:"arabic-form",ascent:0,attributeName:"attributeName",attributeType:"attributeType",autoReverse:"autoReverse",azimuth:0,baseFrequency:"baseFrequency",baseProfile:"baseProfile",baselineShift:"baseline-shift",bbox:0,begin:0,bias:0,by:0,calcMode:"calcMode",capHeight:"cap-height",clip:0,clipPath:"clip-path",clipRule:"clip-rule",clipPathUnits:"clipPathUnits",colorInterpolation:"color-interpolation",colorInterpolationFilters:"color-interpolation-filters",colorProfile:"color-profile",colorRendering:"color-rendering",contentScriptType:"contentScriptType",contentStyleType:"contentStyleType",cursor:0,cx:0,cy:0,d:0,decelerate:0,descent:0,diffuseConstant:"diffuseConstant",direction:0,display:0,divisor:0,dominantBaseline:"dominant-baseline",dur:0,dx:0,dy:0,edgeMode:"edgeMode",elevation:0,enableBackground:"enable-background",end:0,exponent:0,externalResourcesRequired:"externalResourcesRequired",fill:0,fillOpacity:"fill-opacity",fillRule:"fill-rule",filter:0,filterRes:"filterRes",filterUnits:"filterUnits",floodColor:"flood-color",floodOpacity:"flood-opacity",focusable:0,fontFamily:"font-family",fontSize:"font-size",fontSizeAdjust:"font-size-adjust",fontStretch:"font-stretch",fontStyle:"font-style",fontVariant:"font-variant",fontWeight:"font-weight",format:0,from:0,fx:0,fy:0,g1:0,g2:0,glyphName:"glyph-name",glyphOrientationHorizontal:"glyph-orientation-horizontal",glyphOrientationVertical:"glyph-orientation-vertical",glyphRef:"glyphRef",gradientTransform:"gradientTransform",gradientUnits:"gradientUnits",hanging:0,horizAdvX:"horiz-adv-x",horizOriginX:"horiz-origin-x",ideographic:0,imageRendering:"image-rendering",in:0,in2:0,intercept:0,k:0,k1:0,k2:0,k3:0,k4:0,kernelMatrix:"kernelMatrix",kernelUnitLength:"kernelUnitLength",kerning:0,keyPoints:"keyPoints",keySplines:"keySplines",keyTimes:"keyTimes",lengthAdjust:"lengthAdjust",letterSpacing:"letter-spacing",lightingColor:"lighting-color",limitingConeAngle:"limitingConeAngle",local:0,markerEnd:"marker-end",markerMid:"marker-mid",markerStart:"marker-start",markerHeight:"markerHeight",markerUnits:"markerUnits",markerWidth:"markerWidth",mask:0,maskContentUnits:"maskContentUnits",maskUnits:"maskUnits",mathematical:0,mode:0,numOctaves:"numOctaves",offset:0,opacity:0,operator:0,order:0,orient:0,orientation:0,origin:0,overflow:0,overlinePosition:"overline-position",overlineThickness:"overline-thickness",paintOrder:"paint-order",panose1:"panose-1",pathLength:"pathLength",patternContentUnits:"patternContentUnits",patternTransform:"patternTransform",patternUnits:"patternUnits",pointerEvents:"pointer-events",points:0,pointsAtX:"pointsAtX",pointsAtY:"pointsAtY",pointsAtZ:"pointsAtZ",preserveAlpha:"preserveAlpha",preserveAspectRatio:"preserveAspectRatio",primitiveUnits:"primitiveUnits",r:0,radius:0,refX:"refX",refY:"refY",renderingIntent:"rendering-intent",repeatCount:"repeatCount",repeatDur:"repeatDur",requiredExtensions:"requiredExtensions",requiredFeatures:"requiredFeatures",restart:0,result:0,rotate:0,rx:0,ry:0,scale:0,seed:0,shapeRendering:"shape-rendering",slope:0,spacing:0,specularConstant:"specularConstant",specularExponent:"specularExponent",speed:0,spreadMethod:"spreadMethod",startOffset:"startOffset",stdDeviation:"stdDeviation",stemh:0,stemv:0,stitchTiles:"stitchTiles",stopColor:"stop-color",stopOpacity:"stop-opacity",strikethroughPosition:"strikethrough-position",strikethroughThickness:"strikethrough-thickness",string:0,stroke:0,strokeDasharray:"stroke-dasharray",strokeDashoffset:"stroke-dashoffset",strokeLinecap:"stroke-linecap",strokeLinejoin:"stroke-linejoin",strokeMiterlimit:"stroke-miterlimit",strokeOpacity:"stroke-opacity",strokeWidth:"stroke-width",surfaceScale:"surfaceScale",systemLanguage:"systemLanguage",tableValues:"tableValues",targetX:"targetX",targetY:"targetY",textAnchor:"text-anchor",textDecoration:"text-decoration",textRendering:"text-rendering",textLength:"textLength",to:0,transform:0,u1:0,u2:0,underlinePosition:"underline-position",underlineThickness:"underline-thickness",unicode:0,unicodeBidi:"unicode-bidi",unicodeRange:"unicode-range",unitsPerEm:"units-per-em",vAlphabetic:"v-alphabetic",vHanging:"v-hanging",vIdeographic:"v-ideographic",vMathematical:"v-mathematical",values:0,vectorEffect:"vector-effect",version:0,vertAdvY:"vert-adv-y",vertOriginX:"vert-origin-x",vertOriginY:"vert-origin-y",viewBox:"viewBox",viewTarget:"viewTarget",visibility:0,widths:0,wordSpacing:"word-spacing",writingMode:"writing-mode",x:0,xHeight:"x-height",x1:0,x2:0,xChannelSelector:"xChannelSelector",xlinkActuate:"xlink:actuate",xlinkArcrole:"xlink:arcrole",xlinkHref:"xlink:href",xlinkRole:"xlink:role",xlinkShow:"xlink:show",xlinkTitle:"xlink:title",xlinkType:"xlink:type",xmlBase:"xml:base",xmlns:0,xmlnsXlink:"xmlns:xlink",xmlLang:"xml:lang",xmlSpace:"xml:space",y:0,y1:0,y2:0,yChannelSelector:"yChannelSelector",z:0,zoomAndPan:"zoomAndPan"},a={Properties:{},DOMAttributeNamespaces:{xlinkActuate:r.xlink,xlinkArcrole:r.xlink,xlinkHref:r.xlink,xlinkRole:r.xlink,xlinkShow:r.xlink,xlinkTitle:r.xlink,xlinkType:r.xlink,xmlBase:r.xml,xmlLang:r.xml,xmlSpace:r.xml},DOMAttributeNames:{}};Object.keys(o).forEach(function(e){a.Properties[e]=0,o[e]&&(a.DOMAttributeNames[e]=o[e])}),t.exports=a},{}],74:[function(e,t,n){"use strict";function r(e){if("selectionStart"in e&&u.hasSelectionCapabilities(e))return{start:e.selectionStart,end:e.selectionEnd};if(window.getSelection){var t=window.getSelection();return{anchorNode:t.anchorNode,anchorOffset:t.anchorOffset,focusNode:t.focusNode,focusOffset:t.focusOffset}}if(document.selection){var n=document.selection.createRange();return{parentElement:n.parentElement(),text:n.text,top:n.boundingTop,left:n.boundingLeft}}}function o(e,t){if(y||null==m||m!==c())return null;var n=r(m);if(!g||!d(g,n)){g=n;var o=l.getPooled(h.select,v,e,t);return o.type="select",o.target=m,a.accumulateTwoPhaseDispatches(o),o}return null}var a=e(19),i=e(123),s=e(33),u=e(56),l=e(80),c=e(132),p=e(110),d=e(141),f=i.canUseDOM&&"documentMode"in document&&document.documentMode<=11,h={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:["topBlur","topContextMenu","topFocus","topKeyDown","topKeyUp","topMouseDown","topMouseUp","topSelectionChange"]}},m=null,v=null,g=null,y=!1,_=!1,C={eventTypes:h,extractEvents:function(e,t,n,r){if(!_)return null;var a=t?s.getNodeFromInstance(t):window;switch(e){case"topFocus":(p(a)||"true"===a.contentEditable)&&(m=a,v=t,g=null);break
;case"topBlur":m=null,v=null,g=null;break;case"topMouseDown":y=!0;break;case"topContextMenu":case"topMouseUp":return y=!1,o(n,r);case"topSelectionChange":if(f)break;case"topKeyDown":case"topKeyUp":return o(n,r)}return null},didPutListener:function(e,t,n){"onSelect"===t&&(_=!0)}};t.exports=C},{110:110,123:123,132:132,141:141,19:19,33:33,56:56,80:80}],75:[function(e,t,n){"use strict";function r(e){return"."+e._rootNodeID}function o(e){return"button"===e||"input"===e||"select"===e||"textarea"===e}var a=e(112),i=e(122),s=e(19),u=e(33),l=e(76),c=e(77),p=e(80),d=e(81),f=e(83),h=e(84),m=e(79),v=e(85),g=e(86),y=e(87),_=e(88),C=e(129),b=e(99),E=(e(137),{}),x={};["abort","animationEnd","animationIteration","animationStart","blur","canPlay","canPlayThrough","click","contextMenu","copy","cut","doubleClick","drag","dragEnd","dragEnter","dragExit","dragLeave","dragOver","dragStart","drop","durationChange","emptied","encrypted","ended","error","focus","input","invalid","keyDown","keyPress","keyUp","load","loadedData","loadedMetadata","loadStart","mouseDown","mouseMove","mouseOut","mouseOver","mouseUp","paste","pause","play","playing","progress","rateChange","reset","scroll","seeked","seeking","stalled","submit","suspend","timeUpdate","touchCancel","touchEnd","touchMove","touchStart","transitionEnd","volumeChange","waiting","wheel"].forEach(function(e){var t=e[0].toUpperCase()+e.slice(1),n="on"+t,r="top"+t,o={phasedRegistrationNames:{bubbled:n,captured:n+"Capture"},dependencies:[r]};E[e]=o,x[r]=o});var T={},w={eventTypes:E,extractEvents:function(e,t,n,r){var o=x[e];if(!o)return null;var i;switch(e){case"topAbort":case"topCanPlay":case"topCanPlayThrough":case"topDurationChange":case"topEmptied":case"topEncrypted":case"topEnded":case"topError":case"topInput":case"topInvalid":case"topLoad":case"topLoadedData":case"topLoadedMetadata":case"topLoadStart":case"topPause":case"topPlay":case"topPlaying":case"topProgress":case"topRateChange":case"topReset":case"topSeeked":case"topSeeking":case"topStalled":case"topSubmit":case"topSuspend":case"topTimeUpdate":case"topVolumeChange":case"topWaiting":i=p;break;case"topKeyPress":if(0===b(n))return null;case"topKeyDown":case"topKeyUp":i=f;break;case"topBlur":case"topFocus":i=d;break;case"topClick":if(2===n.button)return null;case"topDoubleClick":case"topMouseDown":case"topMouseMove":case"topMouseUp":case"topMouseOut":case"topMouseOver":case"topContextMenu":i=h;break;case"topDrag":case"topDragEnd":case"topDragEnter":case"topDragExit":case"topDragLeave":case"topDragOver":case"topDragStart":case"topDrop":i=m;break;case"topTouchCancel":case"topTouchEnd":case"topTouchMove":case"topTouchStart":i=v;break;case"topAnimationEnd":case"topAnimationIteration":case"topAnimationStart":i=l;break;case"topTransitionEnd":i=g;break;case"topScroll":i=y;break;case"topWheel":i=_;break;case"topCopy":case"topCut":case"topPaste":i=c}i||a("86",e);var u=i.getPooled(o,t,n,r);return s.accumulateTwoPhaseDispatches(u),u},didPutListener:function(e,t,n){if("onClick"===t&&!o(e._tag)){var a=r(e),s=u.getNodeFromInstance(e);T[a]||(T[a]=i.listen(s,"click",C))}},willDeleteListener:function(e,t){if("onClick"===t&&!o(e._tag)){var n=r(e);T[n].remove(),delete T[n]}}};t.exports=w},{112:112,122:122,129:129,137:137,19:19,33:33,76:76,77:77,79:79,80:80,81:81,83:83,84:84,85:85,86:86,87:87,88:88,99:99}],76:[function(e,t,n){"use strict";function r(e,t,n,r){return o.call(this,e,t,n,r)}var o=e(80),a={animationName:null,elapsedTime:null,pseudoElement:null};o.augmentClass(r,a),t.exports=r},{80:80}],77:[function(e,t,n){"use strict";function r(e,t,n,r){return o.call(this,e,t,n,r)}var o=e(80),a={clipboardData:function(e){return"clipboardData"in e?e.clipboardData:window.clipboardData}};o.augmentClass(r,a),t.exports=r},{80:80}],78:[function(e,t,n){"use strict";function r(e,t,n,r){return o.call(this,e,t,n,r)}var o=e(80),a={data:null};o.augmentClass(r,a),t.exports=r},{80:80}],79:[function(e,t,n){"use strict";function r(e,t,n,r){return o.call(this,e,t,n,r)}var o=e(84),a={dataTransfer:null};o.augmentClass(r,a),t.exports=r},{84:84}],80:[function(e,t,n){"use strict";function r(e,t,n,r){this.dispatchConfig=e,this._targetInst=t,this.nativeEvent=n;var o=this.constructor.Interface;for(var a in o)if(o.hasOwnProperty(a)){var s=o[a];s?this[a]=s(n):"target"===a?this.target=r:this[a]=n[a]}var u=null!=n.defaultPrevented?n.defaultPrevented:!1===n.returnValue;return this.isDefaultPrevented=u?i.thatReturnsTrue:i.thatReturnsFalse,this.isPropagationStopped=i.thatReturnsFalse,this}var o=e(143),a=e(24),i=e(129),s=(e(142),["dispatchConfig","_targetInst","nativeEvent","isDefaultPrevented","isPropagationStopped","_dispatchListeners","_dispatchInstances"]),u={type:null,target:null,currentTarget:i.thatReturnsNull,eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(e){return e.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};o(r.prototype,{preventDefault:function(){this.defaultPrevented=!0;var e=this.nativeEvent;e&&(e.preventDefault?e.preventDefault():"unknown"!=typeof e.returnValue&&(e.returnValue=!1),this.isDefaultPrevented=i.thatReturnsTrue)},stopPropagation:function(){var e=this.nativeEvent;e&&(e.stopPropagation?e.stopPropagation():"unknown"!=typeof e.cancelBubble&&(e.cancelBubble=!0),this.isPropagationStopped=i.thatReturnsTrue)},persist:function(){this.isPersistent=i.thatReturnsTrue},isPersistent:i.thatReturnsFalse,destructor:function(){var e=this.constructor.Interface;for(var t in e)this[t]=null;for(var n=0;n<s.length;n++)this[s[n]]=null}}),r.Interface=u,r.augmentClass=function(e,t){var n=this,r=function(){};r.prototype=n.prototype;var i=new r;o(i,e.prototype),e.prototype=i,e.prototype.constructor=e,e.Interface=o({},n.Interface,t),e.augmentClass=n.augmentClass,a.addPoolingTo(e,a.fourArgumentPooler)},a.addPoolingTo(r,a.fourArgumentPooler),t.exports=r},{129:129,142:142,143:143,24:24}],81:[function(e,t,n){"use strict";function r(e,t,n,r){return o.call(this,e,t,n,r)}var o=e(87),a={relatedTarget:null};o.augmentClass(r,a),t.exports=r},{87:87}],82:[function(e,t,n){"use strict";function r(e,t,n,r){return o.call(this,e,t,n,r)}var o=e(80),a={data:null};o.augmentClass(r,a),t.exports=r},{80:80}],83:[function(e,t,n){"use strict";function r(e,t,n,r){return o.call(this,e,t,n,r)}var o=e(87),a=e(99),i=e(100),s=e(101),u={key:i,location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:s,charCode:function(e){return"keypress"===e.type?a(e):0},keyCode:function(e){return"keydown"===e.type||"keyup"===e.type?e.keyCode:0},which:function(e){return"keypress"===e.type?a(e):"keydown"===e.type||"keyup"===e.type?e.keyCode:0}};o.augmentClass(r,u),t.exports=r},{100:100,101:101,87:87,99:99}],84:[function(e,t,n){"use strict";function r(e,t,n,r){return o.call(this,e,t,n,r)}var o=e(87),a=e(90),i=e(101),s={screenX:null,screenY:null,clientX:null,clientY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:i,button:function(e){var t=e.button;return"which"in e?t:2===t?2:4===t?1:0},buttons:null,relatedTarget:function(e){return e.relatedTarget||(e.fromElement===e.srcElement?e.toElement:e.fromElement)},pageX:function(e){return"pageX"in e?e.pageX:e.clientX+a.currentScrollLeft},pageY:function(e){return"pageY"in e?e.pageY:e.clientY+a.currentScrollTop}};o.augmentClass(r,s),t.exports=r},{101:101,87:87,90:90}],85:[function(e,t,n){"use strict";function r(e,t,n,r){return o.call(this,e,t,n,r)}var o=e(87),a=e(101),i={touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:a};o.augmentClass(r,i),t.exports=r},{101:101,87:87}],86:[function(e,t,n){"use strict";function r(e,t,n,r){return o.call(this,e,t,n,r)}var o=e(80),a={propertyName:null,elapsedTime:null,pseudoElement:null};o.augmentClass(r,a),t.exports=r},{80:80}],87:[function(e,t,n){"use strict";function r(e,t,n,r){return o.call(this,e,t,n,r)}var o=e(80),a=e(102),i={view:function(e){if(e.view)return e.view;var t=a(e);if(t.window===t)return t;var n=t.ownerDocument;return n?n.defaultView||n.parentWindow:window},detail:function(e){return e.detail||0}};o.augmentClass(r,i),t.exports=r},{102:102,80:80}],88:[function(e,t,n){"use strict";function r(e,t,n,r){return o.call(this,e,t,n,r)}var o=e(84),a={deltaX:function(e){return"deltaX"in e?e.deltaX:"wheelDeltaX"in e?-e.wheelDeltaX:0},deltaY:function(e){return"deltaY"in e?e.deltaY:"wheelDeltaY"in e?-e.wheelDeltaY:"wheelDelta"in e?-e.wheelDelta:0},deltaZ:null,deltaMode:null};o.augmentClass(r,a),t.exports=r},{84:84}],89:[function(e,t,n){"use strict";var r=e(112),o=(e(137),{}),a={reinitializeTransaction:function(){this.transactionWrappers=this.getTransactionWrappers(),this.wrapperInitData?this.wrapperInitData.length=0:this.wrapperInitData=[],this._isInTransaction=!1},_isInTransaction:!1,getTransactionWrappers:null,isInTransaction:function(){return!!this._isInTransaction},perform:function(e,t,n,o,a,i,s,u){this.isInTransaction()&&r("27");var l,c;try{this._isInTransaction=!0,l=!0,this.initializeAll(0),c=e.call(t,n,o,a,i,s,u),l=!1}finally{try{if(l)try{this.closeAll(0)}catch(e){}else this.closeAll(0)}finally{this._isInTransaction=!1}}return c},initializeAll:function(e){for(var t=this.transactionWrappers,n=e;n<t.length;n++){var r=t[n];try{this.wrapperInitData[n]=o,this.wrapperInitData[n]=r.initialize?r.initialize.call(this):null}finally{if(this.wrapperInitData[n]===o)try{this.initializeAll(n+1)}catch(e){}}}},closeAll:function(e){this.isInTransaction()||r("28");for(var t=this.transactionWrappers,n=e;n<t.length;n++){var a,i=t[n],s=this.wrapperInitData[n];try{a=!0,s!==o&&i.close&&i.close.call(this,s),a=!1}finally{if(a)try{this.closeAll(n+1)}catch(e){}}}this.wrapperInitData.length=0}};t.exports=a},{112:112,137:137}],90:[function(e,t,n){"use strict";var r={currentScrollLeft:0,currentScrollTop:0,refreshScrollValues:function(e){r.currentScrollLeft=e.x,r.currentScrollTop=e.y}};t.exports=r},{}],91:[function(e,t,n){"use strict";function r(e,t){return null==t&&o("30"),null==e?t:Array.isArray(e)?Array.isArray(t)?(e.push.apply(e,t),e):(e.push(t),e):Array.isArray(t)?[e].concat(t):[e,t]}var o=e(112);e(137);t.exports=r},{112:112,137:137}],92:[function(e,t,n){"use strict";function r(e){for(var t=1,n=0,r=0,a=e.length,i=-4&a;r<i;){for(var s=Math.min(r+4096,i);r<s;r+=4)n+=(t+=e.charCodeAt(r))+(t+=e.charCodeAt(r+1))+(t+=e.charCodeAt(r+2))+(t+=e.charCodeAt(r+3));t%=o,n%=o}for(;r<a;r++)n+=t+=e.charCodeAt(r);return t%=o,n%=o,t|n<<16}var o=65521;t.exports=r},{}],93:[function(e,t,n){"use strict";var r=function(e){return"undefined"!=typeof MSApp&&MSApp.execUnsafeLocalFunction?function(t,n,r,o){MSApp.execUnsafeLocalFunction(function(){return e(t,n,r,o)})}:e};t.exports=r},{}],94:[function(e,t,n){"use strict";function r(e,t,n){return null==t||"boolean"==typeof t||""===t?"":isNaN(t)||0===t||a.hasOwnProperty(e)&&a[e]?""+t:("string"==typeof t&&(t=t.trim()),t+"px")}var o=e(4),a=(e(142),o.isUnitlessNumber);t.exports=r},{142:142,4:4}],95:[function(e,t,n){"use strict";function r(e){var t=""+e,n=a.exec(t);if(!n)return t;var r,o="",i=0,s=0;for(i=n.index;i<t.length;i++){switch(t.charCodeAt(i)){case 34:r="&quot;";break;case 38:r="&amp;";break;case 39:r="&#x27;";break;case 60:r="&lt;";break;case 62:r="&gt;";break;default:continue}s!==i&&(o+=t.substring(s,i)),s=i+1,o+=r}return s!==i?o+t.substring(s,i):o}function o(e){return"boolean"==typeof e||"number"==typeof e?""+e:r(e)}var a=/["'&<>]/;t.exports=o},{}],96:[function(e,t,n){"use strict";function r(e){if(null==e)return null;if(1===e.nodeType)return e;var t=i.get(e);if(t)return t=s(t),t?a.getNodeFromInstance(t):null;"function"==typeof e.render?o("44"):o("45",Object.keys(e))}var o=e(112),a=(e(119),e(33)),i=e(57),s=e(103);e(137),e(142);t.exports=r},{103:103,112:112,119:119,137:137,142:142,33:33,57:57}],97:[function(e,t,n){(function(n){"use strict";function r(e,t,n,r){if(e&&"object"==typeof e){var o=e;void 0===o[n]&&null!=t&&(o[n]=t)}}function o(e,t){if(null==e)return e;var n={};return a(e,r,n),n}var a=(e(22),e(117));e(142);void 0!==n&&n.env,t.exports=o}).call(this,void 0)},{117:117,142:142,22:22}],98:[function(e,t,n){"use strict";function r(e,t,n){Array.isArray(e)?e.forEach(t,n):e&&t.call(n,e)}t.exports=r},{}],99:[function(e,t,n){"use strict";function r(e){var t,n=e.keyCode;return"charCode"in e?0===(t=e.charCode)&&13===n&&(t=13):t=n,t>=32||13===t?t:0}t.exports=r},{}],100:[function(e,t,n){"use strict";function r(e){if(e.key){var t=a[e.key]||e.key;if("Unidentified"!==t)return t}if("keypress"===e.type){var n=o(e);return 13===n?"Enter":String.fromCharCode(n)}return"keydown"===e.type||"keyup"===e.type?i[e.keyCode]||"Unidentified":""}var o=e(99),a={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},i={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};t.exports=r},{99:99}],101:[function(e,t,n){"use strict";function r(e){var t=this,n=t.nativeEvent;if(n.getModifierState)return n.getModifierState(e);var r=a[e];return!!r&&!!n[r]}function o(e){return r}var a={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};t.exports=o},{}],102:[function(e,t,n){"use strict";function r(e){var t=e.target||e.srcElement||window;return t.correspondingUseElement&&(t=t.correspondingUseElement),3===t.nodeType?t.parentNode:t}t.exports=r},{}],103:[function(e,t,n){"use strict";function r(e){for(var t;(t=e._renderedNodeType)===o.COMPOSITE;)e=e._renderedComponent;return t===o.HOST?e._renderedComponent:t===o.EMPTY?null:void 0}var o=e(62);t.exports=r},{62:62}],104:[function(e,t,n){"use strict";function r(e){var t=e&&(o&&e[o]||e[a]);if("function"==typeof t)return t}var o="function"==typeof Symbol&&Symbol.iterator,a="@@iterator";t.exports=r},{}],105:[function(e,t,n){"use strict";function r(e){for(;e&&e.firstChild;)e=e.firstChild;return e}function o(e){for(;e;){if(e.nextSibling)return e.nextSibling;e=e.parentNode}}function a(e,t){for(var n=r(e),a=0,i=0;n;){if(3===n.nodeType){if(i=a+n.textContent.length,a<=t&&i>=t)return{node:n,offset:t-a};a=i}n=r(o(n))}}t.exports=a},{}],106:[function(e,t,n){"use strict";function r(){return!a&&o.canUseDOM&&(a="textContent"in document.documentElement?"textContent":"innerText"),a}var o=e(123),a=null;t.exports=r},{123:123}],107:[function(e,t,n){"use strict";function r(e,t){var n={};return n[e.toLowerCase()]=t.toLowerCase(),n["Webkit"+e]="webkit"+t,n["Moz"+e]="moz"+t,n["ms"+e]="MS"+t,n["O"+e]="o"+t.toLowerCase(),n}function o(e){if(s[e])return s[e];if(!i[e])return e;var t=i[e];for(var n in t)if(t.hasOwnProperty(n)&&n in u)return s[e]=t[n];return""}var a=e(123),i={animationend:r("Animation","AnimationEnd"),animationiteration:r("Animation","AnimationIteration"),animationstart:r("Animation","AnimationStart"),transitionend:r("Transition","TransitionEnd")},s={},u={};a.canUseDOM&&(u=document.createElement("div").style,"AnimationEvent"in window||(delete i.animationend.animation,delete i.animationiteration.animation,delete i.animationstart.animation),"TransitionEvent"in window||delete i.transitionend.transition),t.exports=o},{123:123}],108:[function(e,t,n){"use strict";function r(e){if(e){var t=e.getName();if(t)return" Check the render method of `"+t+"`."}return""}function o(e){return"function"==typeof e&&void 0!==e.prototype&&"function"==typeof e.prototype.mountComponent&&"function"==typeof e.prototype.receiveComponent}function a(e,t){var n;if(null===e||!1===e)n=l.create(a);else if("object"==typeof e){var s=e,u=s.type;if("function"!=typeof u&&"string"!=typeof u){var d="";d+=r(s._owner),i("130",null==u?u:typeof u,d)}"string"==typeof s.type?n=c.createInternalComponent(s):o(s.type)?(n=new s.type(s),n.getHostNode||(n.getHostNode=n.getNativeNode)):n=new p(s)}else"string"==typeof e||"number"==typeof e?n=c.createInstanceForText(e):i("131",typeof e);return n._mountIndex=0,n._mountImage=null,n}var i=e(112),s=e(143),u=e(29),l=e(49),c=e(54),p=(e(121),e(137),e(142),function(e){this.construct(e)});s(p.prototype,u,{_instantiateReactComponent:a}),t.exports=a},{112:112,121:121,137:137,142:142,143:143,29:29,49:49,54:54}],109:[function(e,t,n){"use strict";function r(e,t){if(!a.canUseDOM||t&&!("addEventListener"in document))return!1;var n="on"+e,r=n in document;if(!r){var i=document.createElement("div");i.setAttribute(n,"return;"),r="function"==typeof i[n]}return!r&&o&&"wheel"===e&&(r=document.implementation.hasFeature("Events.wheel","3.0")),r}var o,a=e(123);a.canUseDOM&&(o=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("","")),t.exports=r},{123:123}],110:[function(e,t,n){"use strict";function r(e){var t=e&&e.nodeName&&e.nodeName.toLowerCase();return"input"===t?!!o[e.type]:"textarea"===t}var o={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};t.exports=r},{}],111:[function(e,t,n){"use strict";function r(e){return'"'+o(e)+'"'}var o=e(95);t.exports=r},{95:95}],112:[function(e,t,n){"use strict";function r(e){for(var t=arguments.length-1,n="Minified React error #"+e+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant="+e,r=0;r<t;r++)n+="&args[]="+encodeURIComponent(arguments[r+1]);n+=" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";var o=new Error(n);throw o.name="Invariant Violation",o.framesToPop=1,o}t.exports=r},{}],113:[function(e,t,n){"use strict";var r=e(60);t.exports=r.renderSubtreeIntoContainer},{60:60}],114:[function(e,t,n){"use strict";var r,o=e(123),a=e(10),i=/^[ \r\n\t\f]/,s=/<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/,u=e(93),l=u(function(e,t){if(e.namespaceURI!==a.svg||"innerHTML"in e)e.innerHTML=t;else{r=r||document.createElement("div"),r.innerHTML="<svg>"+t+"</svg>";for(var n=r.firstChild;n.firstChild;)e.appendChild(n.firstChild)}});if(o.canUseDOM){var c=document.createElement("div");c.innerHTML=" ",""===c.innerHTML&&(l=function(e,t){if(e.parentNode&&e.parentNode.replaceChild(e,e),i.test(t)||"<"===t[0]&&s.test(t)){e.innerHTML=String.fromCharCode(65279)+t;var n=e.firstChild;1===n.data.length?e.removeChild(n):n.deleteData(0,1)}else e.innerHTML=t}),c=null}t.exports=l},{10:10,123:123,93:93}],115:[function(e,t,n){"use strict";var r=e(123),o=e(95),a=e(114),i=function(e,t){if(t){var n=e.firstChild;if(n&&n===e.lastChild&&3===n.nodeType)return void(n.nodeValue=t)}e.textContent=t};r.canUseDOM&&("textContent"in document.documentElement||(i=function(e,t){if(3===e.nodeType)return void(e.nodeValue=t);a(e,o(t))})),t.exports=i},{114:114,123:123,95:95}],116:[function(e,t,n){"use strict";function r(e,t){var n=null===e||!1===e,r=null===t||!1===t;if(n||r)return n===r;var o=typeof e,a=typeof t;return"string"===o||"number"===o?"string"===a||"number"===a:"object"===a&&e.type===t.type&&e.key===t.key}t.exports=r},{}],117:[function(e,t,n){"use strict";function r(e,t){return e&&"object"==typeof e&&null!=e.key?l.escape(e.key):t.toString(36)}function o(e,t,n,a){var d=typeof e;if("undefined"!==d&&"boolean"!==d||(e=null),null===e||"string"===d||"number"===d||"object"===d&&e.$$typeof===s)return n(a,e,""===t?c+r(e,0):t),1;var f,h,m=0,v=""===t?c:t+p;if(Array.isArray(e))for(var g=0;g<e.length;g++)f=e[g],h=v+r(f,g),m+=o(f,h,n,a);else{var y=u(e);if(y){var _,C=y.call(e);if(y!==e.entries)for(var b=0;!(_=C.next()).done;)f=_.value,h=v+r(f,b++),m+=o(f,h,n,a);else for(;!(_=C.next()).done;){var E=_.value;E&&(f=E[1],h=v+l.escape(E[0])+p+r(f,0),m+=o(f,h,n,a))}}else if("object"===d){var x=String(e);i("31","[object Object]"===x?"object with keys {"+Object.keys(e).join(", ")+"}":x,"")}}return m}function a(e,t,n){return null==e?0:o(e,"",t,n)}var i=e(112),s=(e(119),e(48)),u=e(104),l=(e(137),e(22)),c=(e(142),"."),p=":";t.exports=a},{104:104,112:112,119:119,137:137,142:142,22:22,48:48}],118:[function(e,t,n){"use strict";var r=(e(143),e(129)),o=(e(142),r);t.exports=o},{129:129,142:142,143:143}],119:[function(t,n,r){"use strict";var o=e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;n.exports=o.ReactCurrentOwner},{}],120:[function(t,n,r){"use strict";n.exports=e},{}],121:[function(t,n,r){"use strict";var o=e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;n.exports=o.getNextDebugID},{}],122:[function(e,t,n){"use strict";var r=e(129),o={listen:function(e,t,n){return e.addEventListener?(e.addEventListener(t,n,!1),{remove:function(){e.removeEventListener(t,n,!1)}}):e.attachEvent?(e.attachEvent("on"+t,n),{remove:function(){e.detachEvent("on"+t,n)}}):void 0},capture:function(e,t,n){return e.addEventListener?(e.addEventListener(t,n,!0),{remove:function(){e.removeEventListener(t,n,!0)}}):{remove:r}},registerDefault:function(){}};t.exports=o},{129:129}],123:[function(e,t,n){"use strict";var r=!("undefined"==typeof window||!window.document||!window.document.createElement),o={canUseDOM:r,canUseWorkers:"undefined"!=typeof Worker,canUseEventListeners:r&&!(!window.addEventListener&&!window.attachEvent),canUseViewport:r&&!!window.screen,isInWorker:!r};t.exports=o},{}],124:[function(e,t,n){"use strict";function r(e){return e.replace(o,function(e,t){return t.toUpperCase()})}var o=/-(.)/g;t.exports=r},{}],125:[function(e,t,n){"use strict";function r(e){return o(e.replace(a,"ms-"))}var o=e(124),a=/^-ms-/;t.exports=r},{124:124}],126:[function(e,t,n){"use strict";function r(e,t){return!(!e||!t)&&(e===t||!o(e)&&(o(t)?r(e,t.parentNode):"contains"in e?e.contains(t):!!e.compareDocumentPosition&&!!(16&e.compareDocumentPosition(t))))}var o=e(139);t.exports=r},{139:139}],127:[function(e,t,n){"use strict";function r(e){var t=e.length;if((Array.isArray(e)||"object"!=typeof e&&"function"!=typeof e)&&i(!1),"number"!=typeof t&&i(!1),0===t||t-1 in e||i(!1),"function"==typeof e.callee&&i(!1),e.hasOwnProperty)try{return Array.prototype.slice.call(e)}catch(e){}for(var n=Array(t),r=0;r<t;r++)n[r]=e[r];return n}function o(e){return!!e&&("object"==typeof e||"function"==typeof e)&&"length"in e&&!("setInterval"in e)&&"number"!=typeof e.nodeType&&(Array.isArray(e)||"callee"in e||"item"in e)}function a(e){return o(e)?Array.isArray(e)?e.slice():r(e):[e]}var i=e(137);t.exports=a},{137:137}],128:[function(e,t,n){"use strict";function r(e){var t=e.match(c);return t&&t[1].toLowerCase()}function o(e,t){var n=l;l||u(!1);var o=r(e),a=o&&s(o);if(a){n.innerHTML=a[1]+e+a[2];for(var c=a[0];c--;)n=n.lastChild}else n.innerHTML=e;var p=n.getElementsByTagName("script");p.length&&(t||u(!1),i(p).forEach(t));for(var d=Array.from(n.childNodes);n.lastChild;)n.removeChild(n.lastChild);return d}var a=e(123),i=e(127),s=e(133),u=e(137),l=a.canUseDOM?document.createElement("div"):null,c=/^\s*<(\w+)/;t.exports=o},{123:123,127:127,133:133,137:137}],129:[function(e,t,n){"use strict";function r(e){return function(){return e}}var o=function(){};o.thatReturns=r,o.thatReturnsFalse=r(!1),o.thatReturnsTrue=r(!0),o.thatReturnsNull=r(null),o.thatReturnsThis=function(){return this},o.thatReturnsArgument=function(e){return e},t.exports=o},{}],130:[function(e,t,n){"use strict";var r={};t.exports=r},{}],131:[function(e,t,n){"use strict";function r(e){try{e.focus()}catch(e){}}t.exports=r},{}],132:[function(e,t,n){"use strict";function r(e){if(void 0===(e=e||("undefined"!=typeof document?document:void 0)))return null;try{return e.activeElement||e.body}catch(t){return e.body}}t.exports=r},{}],133:[function(e,t,n){"use strict";function r(e){return i||a(!1),d.hasOwnProperty(e)||(e="*"),s.hasOwnProperty(e)||(i.innerHTML="*"===e?"<link />":"<"+e+"></"+e+">",s[e]=!i.firstChild),s[e]?d[e]:null}var o=e(123),a=e(137),i=o.canUseDOM?document.createElement("div"):null,s={},u=[1,'<select multiple="true">',"</select>"],l=[1,"<table>","</table>"],c=[3,"<table><tbody><tr>","</tr></tbody></table>"],p=[1,'<svg xmlns="http://www.w3.org/2000/svg">',"</svg>"],d={"*":[1,"?<div>","</div>"],area:[1,"<map>","</map>"],col:[2,"<table><tbody></tbody><colgroup>","</colgroup></table>"],legend:[1,"<fieldset>","</fieldset>"],param:[1,"<object>","</object>"],tr:[2,"<table><tbody>","</tbody></table>"],optgroup:u,option:u,caption:l,colgroup:l,tbody:l,tfoot:l,thead:l,td:c,th:c};["circle","clipPath","defs","ellipse","g","image","line","linearGradient","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","text","tspan"].forEach(function(e){d[e]=p,s[e]=!0}),t.exports=r},{123:123,137:137}],134:[function(e,t,n){"use strict";function r(e){return e.Window&&e instanceof e.Window?{x:e.pageXOffset||e.document.documentElement.scrollLeft,y:e.pageYOffset||e.document.documentElement.scrollTop}:{x:e.scrollLeft,y:e.scrollTop}}t.exports=r},{}],135:[function(e,t,n){"use strict";function r(e){return e.replace(o,"-$1").toLowerCase()}var o=/([A-Z])/g;t.exports=r},{}],136:[function(e,t,n){"use strict";function r(e){return o(e).replace(a,"-ms-")}var o=e(135),a=/^ms-/;t.exports=r},{135:135}],137:[function(e,t,n){"use strict";function r(e,t,n,r,a,i,s,u){if(o(t),!e){var l;if(void 0===t)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var c=[n,r,a,i,s,u],p=0;l=new Error(t.replace(/%s/g,function(){return c[p++]})),l.name="Invariant Violation"}throw l.framesToPop=1,l}}var o=function(e){};t.exports=r},{}],138:[function(e,t,n){"use strict";function r(e){var t=e?e.ownerDocument||e:document,n=t.defaultView||window;return!(!e||!("function"==typeof n.Node?e instanceof n.Node:"object"==typeof e&&"number"==typeof e.nodeType&&"string"==typeof e.nodeName))}t.exports=r},{}],139:[function(e,t,n){"use strict";function r(e){return o(e)&&3==e.nodeType}var o=e(138);t.exports=r},{138:138}],140:[function(e,t,n){"use strict";function r(e){var t={};return function(n){return t.hasOwnProperty(n)||(t[n]=e.call(this,n)),t[n]}}t.exports=r},{}],141:[function(e,t,n){"use strict";function r(e,t){return e===t?0!==e||0!==t||1/e==1/t:e!==e&&t!==t}function o(e,t){if(r(e,t))return!0;if("object"!=typeof e||null===e||"object"!=typeof t||null===t)return!1;var n=Object.keys(e),o=Object.keys(t);if(n.length!==o.length)return!1;for(var i=0;i<n.length;i++)if(!a.call(t,n[i])||!r(e[n[i]],t[n[i]]))return!1;return!0}var a=Object.prototype.hasOwnProperty;t.exports=o},{}],142:[function(e,t,n){"use strict";var r=e(129),o=r;t.exports=o},{129:129}],143:[function(e,t,n){"use strict";function r(e){if(null===e||void 0===e)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(e)}var o=Object.getOwnPropertySymbols,a=Object.prototype.hasOwnProperty,i=Object.prototype.propertyIsEnumerable;t.exports=function(){try{if(!Object.assign)return!1;var e=new String("abc");if(e[5]="de","5"===Object.getOwnPropertyNames(e)[0])return!1;for(var t={},n=0;n<10;n++)t["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(t).map(function(e){return t[e]}).join(""))return!1;var r={};return"abcdefghijklmnopqrst".split("").forEach(function(e){r[e]=e}),"abcdefghijklmnopqrst"===Object.keys(Object.assign({},r)).join("")}catch(e){return!1}}()?Object.assign:function(e,t){for(var n,s,u=r(e),l=1;l<arguments.length;l++){n=Object(arguments[l]);for(var c in n)a.call(n,c)&&(u[c]=n[c]);if(o){s=o(n);for(var p=0;p<s.length;p++)i.call(n,s[p])&&(u[s[p]]=n[s[p]])}}return u}},{}],144:[function(e,t,n){"use strict";function r(e,t,n,r,o){}e(137),e(142),e(146);t.exports=r},{137:137,142:142,146:146}],145:[function(e,t,n){"use strict";var r=(e(129),e(137)),o=(e(142),e(146),e(144));t.exports=function(e){function t(e){this.message=e,this.stack=""}var n,a=("function"==typeof Symbol&&Symbol.iterator,function(){r(!1,"React.PropTypes type checking code is stripped in production.")});a.isRequired=a;var i=function(){return a};return n={array:a,bool:a,func:a,number:a,object:a,string:a,symbol:a,any:a,arrayOf:i,element:a,instanceOf:i,node:a,objectOf:i,oneOf:i,oneOfType:i,shape:i},t.prototype=Error.prototype,n.checkPropTypes=o,n.PropTypes=n,n}},{129:129,137:137,142:142,144:144,146:146}],146:[function(e,t,n){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},{}]},{},[45])(45)}()}()});;
function toFractionIterative(x, epsilon = 0.0001) {

  if (typeof x !== 'number' || isNaN(x)) return null;
  if (x === 0) return [0, 1];

  const sign = x < 0 ? -1 : 1;
  const a = Math.abs(x);

  let h1 = 1, k1 = 0;
  let h2 = 0, k2 = 1;
  let b = a;
  let maxIterations = 100;

  while (maxIterations-- > 0) {
    const intPart = Math.floor(b);
    const num = intPart * h1 + h2;
    const den = intPart * k1 + k2;

    if (Math.abs(a - num / den) <= a * epsilon) {
      return [sign * num, den];
    }

    h2 = h1; k2 = k1;
    h1 = num; k1 = den;

    if (b - intPart === 0) break;
    b = 1 / (b - intPart);
  }

  return [sign * h1, k1];

  /*
    if (typeof x !== "number" || isNaN(x)) return null;
    if (x == 0) return [0, 1];
    const a = Math.abs(x);
    let n = 0;
    let d = 1;
    let r;
    let maxtries = 100000;
    while (true && maxtries-- > 0) {
      r = n / d;
      if (Math.abs((r - a) / a) < epsilon) {
        break;
      }
      if (r < a) {
        n++;
      } else {
        d++;
      }
    }
  
    if (maxtries <= 0) {
      console.log("hit max tries");
    }
  
    return [x < 0 ? -n : n, d];
    */
}

// text to number lib
var Small = {
  zero: 0,
  one: 1,
  two: 2,
  three: 3,
  four: 4,
  five: 5,
  six: 6,
  seven: 7,
  eight: 8,
  nine: 9,
  ten: 10,
  eleven: 11,
  twelve: 12,
  dozen: 12,
  thirteen: 13,
  fourteen: 14,
  fifteen: 15,
  sixteen: 16,
  seventeen: 17,
  eighteen: 18,
  nineteen: 19,
  twenty: 20,
  thirty: 30,
  forty: 40,
  fifty: 50,
  sixty: 60,
  seventy: 70,
  eighty: 80,
  ninety: 90,
};

var Magnitude = {
  thousand: 1000,
  million: 1000000,
  billion: 1000000000,
  trillion: 1000000000000,
  quadrillion: 1000000000000000,
  quintillion: 1000000000000000000,
  sextillion: 1000000000000000000000,
  septillion: 1000000000000000000000000,
  octillion: 1000000000000000000000000000,
  nonillion: 1000000000000000000000000000000,
  decillion: 1000000000000000000000000000000000,
};

function text2num(s) {
  let a, n, g;

  function feach(w) {
    var x = Small[w];
    if (x != null) {
      g = g + x;
    } else if (w == "hundred") {
      g = g * 100;
    } else {
      x = Magnitude[w];
      if (x != null) {
        n = n + g * x;
        g = 0;
      } else {
        return null;
      }
    }
  }

  a = s.toString().split(/[\s-]+/);
  n = 0;
  g = 0;
  a.forEach(feach);
  return n + g;
}

var Inflector = {

  uncountableWords: [
    'equipment', 'information', 'rice', 'money', 'species', 'series',
    'fish', 'sheep', 'moose', 'deer', 'news', 'celsius', 'fahrenheit',
    'siemens', 'hertz', 'lux'
  ],

  pluralRules: [
    [new RegExp('(m)an$', 'gi'), '$1en'],
    [new RegExp('(pe)rson$', 'gi'), '$1ople'],
    [new RegExp('(child)$', 'gi'), '$1ren'],
    [new RegExp('^(ox)$', 'gi'), '$1en'],
    [new RegExp('(ax|test)is$', 'gi'), '$1es'],
    [new RegExp('(octop|vir)us$', 'gi'), '$1i'],
    [new RegExp('(alias|status)$', 'gi'), '$1es'],
    [new RegExp('(bu)s$', 'gi'), '$1ses'],
    [new RegExp('(buffal|tomat|potat)o$', 'gi'), '$1oes'],
    [new RegExp('([ti])um$', 'gi'), '$1a'],
    [new RegExp('sis$', 'gi'), 'ses'],
    [new RegExp('(?:([^f])fe|([lr])f)$', 'gi'), '$1$2ves'],
    [new RegExp('(hive)$', 'gi'), '$1s'],
    [new RegExp('([^aeiouy]|qu)y$', 'gi'), '$1ies'],
    [new RegExp('(x|ch|ss|sh)$', 'gi'), '$1es'],
    [new RegExp('(matr|vert|ind)ix|ex$', 'gi'), '$1ices'],
    [new RegExp('([m|l])ouse$', 'gi'), '$1ice'],
    [new RegExp('(quiz)$', 'gi'), '$1zes'],

    // extra ones
    [new RegExp('(foot)$', 'gi'), 'feet'],
    [new RegExp('(goose)$', 'gi'), 'geese'],
    [new RegExp('(tooth)$', 'gi'), 'teeth'],
    [new RegExp('(louse)$', 'gi'), 'lice'],
    [new RegExp('(mouse)$', 'gi'), 'mice'],
    [new RegExp('(woman)$', 'gi'), 'women'],
    [new RegExp('(man)$', 'gi'), 'men'],
    [new RegExp('(child)$', 'gi'), 'children'],
    [new RegExp('(ox)$', 'gi'), 'oxen'],
    [new RegExp('(leaf)$', 'gi'), 'leaves'],
    [new RegExp('(calf)$', 'gi'), 'calves'],
    [new RegExp('(half)$', 'gi'), 'halves'],
    [new RegExp('(knife)$', 'gi'), 'knives'],
    [new RegExp('(wife)$', 'gi'), 'wives'],
    [new RegExp('(life)$', 'gi'), 'lives'],
    [new RegExp('(loaf)$', 'gi'), 'loaves'],
    [new RegExp('(wolf)$', 'gi'), 'wolves'],
    [new RegExp('(shelf)$', 'gi'), 'shelves'],
    [new RegExp('(thief)$', 'gi'), 'thieves'],

    [new RegExp('s$', 'gi'), 's'],
    [new RegExp('$', 'gi'), 's']

  ],

  singularRules: [
    [new RegExp('(m)en$', 'gi'), '$1an'],
    [new RegExp('(pe)ople$', 'gi'), '$1rson'],
    [new RegExp('(child)ren$', 'gi'), '$1'],
    [new RegExp('([ti])a$', 'gi'), '$1um'],
    [new RegExp('((a)naly|(b)a|(d)iagno|(p)arenthe|(p)rogno|(s)ynop|(t)he)ses$', 'gi'), '$1$2sis'],
    [new RegExp('(hive)s$', 'gi'), '$1'],
    [new RegExp('(tive)s$', 'gi'), '$1'],
    [new RegExp('(curve)s$', 'gi'), '$1'],
    [new RegExp('([lr])ves$', 'gi'), '$1f'],
    [new RegExp('([^fo])ves$', 'gi'), '$1fe'],
    [new RegExp('([^aeiouy]|qu)ies$', 'gi'), '$1y'],
    [new RegExp('(s)eries$', 'gi'), '$1eries'],
    [new RegExp('(m)ovies$', 'gi'), '$1ovie'],
    [new RegExp('(x|ch|ss|sh)es$', 'gi'), '$1'],
    [new RegExp('([m|l])ice$', 'gi'), '$1ouse'],
    [new RegExp('(bus)es$', 'gi'), '$1'],
    [new RegExp('(o)es$', 'gi'), '$1'],
    [new RegExp('(shoe)s$', 'gi'), '$1'],
    [new RegExp('(cris|ax|test)es$', 'gi'), '$1is'],
    [new RegExp('(octop|vir)i$', 'gi'), '$1us'],
    [new RegExp('(alias|status)es$', 'gi'), '$1'],
    [new RegExp('^(ox)en', 'gi'), '$1'],
    [new RegExp('(vert|ind)ices$', 'gi'), '$1ex'],
    [new RegExp('(matr)ices$', 'gi'), '$1ix'],
    [new RegExp('(quiz)zes$', 'gi'), '$1'],

    // extra ones
    [new RegExp('(feet)$', 'gi'), 'foot'],
    [new RegExp('geese$', 'gi'), 'goose'],
    [new RegExp('teeth$', 'gi'), 'tooth'],
    [new RegExp('lice$', 'gi'), 'louse'],
    [new RegExp('mice$', 'gi'), 'mouse'],
    [new RegExp('women$', 'gi'), 'woman'],
    [new RegExp('men$', 'gi'), 'man'],
    [new RegExp('children$', 'gi'), 'child'],
    [new RegExp('oxen$', 'gi'), 'ox'],
    [new RegExp('leaves$', 'gi'), 'leaf'],
    [new RegExp('calves$', 'gi'), 'calf'],
    [new RegExp('halves$', 'gi'), 'half'],
    [new RegExp('knives$', 'gi'), 'knife'],
    [new RegExp('wives$', 'gi'), 'wife'],
    [new RegExp('lives$', 'gi'), 'life'],
    [new RegExp('loaves$', 'gi'), 'loaf'],
    [new RegExp('wolves$', 'gi'), 'wolf'],
    [new RegExp('shelves$', 'gi'), 'shelf'],
    [new RegExp('thieves$', 'gi'), 'thief'],
    [new RegExp('s$', 'gi'), '']
  ],

  nonTitlecasedWords: [
    'and', 'or', 'nor', 'a', 'an', 'the', 'so', 'but', 'to', 'of', 'at',
    'by', 'from', 'into', 'on', 'onto', 'off', 'out', 'in', 'over',
    'with', 'for'
  ],

  idSuffix: new RegExp('(_ids|_id)$', 'g'),
  underbar: new RegExp('_', 'g'),
  spaceOrUnderbar: new RegExp('[\ _]', 'g'),
  uppercase: new RegExp('([A-Z])', 'g'),
  underbarPrefix: new RegExp('^_'),

  applyRules: function (str, rules, skip, override) {
    if (override) {
      str = override;
    } else {
      var ignore = (skip.indexOf(str.toLowerCase()) > -1);
      if (!ignore) {
        for (var x = 0; x < rules.length; x++) {
          if (str.match(rules[x][0])) {
            str = str.replace(rules[x][0], rules[x][1]);
            break;
          }
        }
      }
    }
    return str;
  },


  /*
  Inflector.pluralize('person')           -> 'people'
  Inflector.pluralize('octopus')          -> 'octopi'
  Inflector.pluralize('Hat')              -> 'Hats'
  Inflector.pluralize('person', 'guys')   -> 'guys'    
  */
  pluralize: function (str, plural) {
    return this.applyRules(
      str,
      this.pluralRules,
      this.uncountableWords,
      plural
    );
  },

  /*
  Inflector.singularize('person')         -> 'person'
  Inflector.singularize('octopi')         -> 'octopus'
  Inflector.singularize('hats')           -> 'hat'
  Inflector.singularize('guys', 'person') -> 'person'
  */
  singularize: function (str, singular) {
    return this.applyRules(
      str,
      this.singularRules,
      this.uncountableWords,
      singular
    );
  },
}

// mredkj.com
function NumberFormat(num, inputDecimal) {
  this.VERSION = "Number Format v1.5.4";
  this.COMMA = ",";
  this.PERIOD = ".";
  this.DASH = "-";
  this.LEFT_PAREN = "(";
  this.RIGHT_PAREN = ")";
  this.LEFT_OUTSIDE = 0;
  this.LEFT_INSIDE = 1;
  this.RIGHT_INSIDE = 2;
  this.RIGHT_OUTSIDE = 3;
  this.LEFT_DASH = 0;
  this.RIGHT_DASH = 1;
  this.PARENTHESIS = 2;
  this.NO_ROUNDING = -1;
  this.num;
  this.numOriginal;
  this.hasSeparators = false;
  this.separatorValue;
  this.inputDecimalValue;
  this.decimalValue;
  this.negativeFormat;
  this.negativeRed;
  this.hasCurrency;
  this.currencyPosition;
  this.currencyValue;
  this.places;
  this.roundToPlaces;
  this.truncate;
  this.setNumber = setNumberNF;
  this.toUnformatted = toUnformattedNF;
  this.setInputDecimal = setInputDecimalNF;
  this.setSeparators = setSeparatorsNF;
  this.setCommas = setCommasNF;
  this.setNegativeFormat = setNegativeFormatNF;
  this.setNegativeRed = setNegativeRedNF;
  this.setCurrency = setCurrencyNF;
  this.setCurrencyPrefix = setCurrencyPrefixNF;
  this.setCurrencyValue = setCurrencyValueNF;
  this.setCurrencyPosition = setCurrencyPositionNF;
  this.setPlaces = setPlacesNF;
  this.toFormatted = toFormattedNF;
  this.toPercentage = toPercentageNF;
  this.getOriginal = getOriginalNF;
  this.moveDecimalRight = moveDecimalRightNF;
  this.moveDecimalLeft = moveDecimalLeftNF;
  this.getRounded = getRoundedNF;
  this.preserveZeros = preserveZerosNF;
  this.justNumber = justNumberNF;
  this.expandExponential = expandExponentialNF;
  this.getZeros = getZerosNF;
  this.moveDecimalAsString = moveDecimalAsStringNF;
  this.moveDecimal = moveDecimalNF;
  this.addSeparators = addSeparatorsNF;
  if (inputDecimal == null) {
    this.setNumber(num, this.PERIOD);
  } else {
    this.setNumber(num, inputDecimal);
  }
  this.setCommas(true);
  this.setNegativeFormat(this.LEFT_DASH);
  this.setNegativeRed(false);
  this.setCurrency(false);
  this.setCurrencyPrefix("$");
  this.setPlaces(2);
}

function setInputDecimalNF(val) {
  this.inputDecimalValue = val;
}

function setNumberNF(num, inputDecimal) {
  if (inputDecimal != null) {
    this.setInputDecimal(inputDecimal);
  }
  this.numOriginal = num;
  this.num = this.justNumber(num);
}

function toUnformattedNF() {
  return this.num;
}

function getOriginalNF() {
  return this.numOriginal;
}

function setNegativeFormatNF(format) {
  this.negativeFormat = format;
}

function setNegativeRedNF(isRed) {
  this.negativeRed = isRed;
}

function setSeparatorsNF(isC, separator, decimal) {
  this.hasSeparators = isC;
  if (separator == null) separator = this.COMMA;
  if (decimal == null) decimal = this.PERIOD;
  if (separator == decimal) {
    this.decimalValue = decimal == this.PERIOD ? this.COMMA : this.PERIOD;
  } else {
    this.decimalValue = decimal;
  }
  this.separatorValue = separator;
}

function setCommasNF(isC) {
  this.setSeparators(isC, this.COMMA, this.PERIOD);
}

function setCurrencyNF(isC) {
  this.hasCurrency = isC;
}

function setCurrencyValueNF(val) {
  this.currencyValue = val;
}

function setCurrencyPrefixNF(cp) {
  this.setCurrencyValue(cp);
  this.setCurrencyPosition(this.LEFT_OUTSIDE);
}

function setCurrencyPositionNF(cp) {
  this.currencyPosition = cp;
}

function setPlacesNF(p, tr) {
  this.roundToPlaces = !(p == this.NO_ROUNDING);
  this.truncate = tr != null && tr;
  this.places = p < 0 ? 0 : p;
}

function addSeparatorsNF(nStr, inD, outD, sep) {
  nStr += "";
  var dpos = nStr.indexOf(inD);
  var nStrEnd = "";
  if (dpos != -1) {
    nStrEnd = outD + nStr.substring(dpos + 1, nStr.length);
    nStr = nStr.substring(0, dpos);
  }
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(nStr)) {
    nStr = nStr.replace(rgx, "$1" + sep + "$2");
  }
  return nStr + nStrEnd;
}

function toFormattedNF() {
  var pos;
  var nNum = this.num;
  var nStr;
  var splitString = new Array(2);
  if (this.roundToPlaces) {
    nNum = this.getRounded(nNum);
    nStr = this.preserveZeros(Math.abs(nNum));
  } else {
    nStr = this.expandExponential(Math.abs(nNum));
  }
  if (this.hasSeparators) {
    nStr = this.addSeparators(nStr, this.PERIOD, this.decimalValue, this.separatorValue);
  } else {
    nStr = nStr.replace(new RegExp("\\" + this.PERIOD), this.decimalValue);
  }
  var c0 = "";
  var n0 = "";
  var c1 = "";
  var n1 = "";
  var n2 = "";
  var c2 = "";
  var n3 = "";
  var c3 = "";
  var negSignL = this.negativeFormat == this.PARENTHESIS ? this.LEFT_PAREN : this.DASH;
  var negSignR = this.negativeFormat == this.PARENTHESIS ? this.RIGHT_PAREN : this.DASH;
  if (this.currencyPosition == this.LEFT_OUTSIDE) {
    if (nNum < 0) {
      if (this.negativeFormat == this.LEFT_DASH || this.negativeFormat == this.PARENTHESIS) n1 = negSignL;
      if (this.negativeFormat == this.RIGHT_DASH || this.negativeFormat == this.PARENTHESIS) n2 = negSignR;
    }
    if (this.hasCurrency) c0 = this.currencyValue;
  } else if (this.currencyPosition == this.LEFT_INSIDE) {
    if (nNum < 0) {
      if (this.negativeFormat == this.LEFT_DASH || this.negativeFormat == this.PARENTHESIS) n0 = negSignL;
      if (this.negativeFormat == this.RIGHT_DASH || this.negativeFormat == this.PARENTHESIS) n3 = negSignR;
    }
    if (this.hasCurrency) c1 = this.currencyValue;
  } else if (this.currencyPosition == this.RIGHT_INSIDE) {
    if (nNum < 0) {
      if (this.negativeFormat == this.LEFT_DASH || this.negativeFormat == this.PARENTHESIS) n0 = negSignL;
      if (this.negativeFormat == this.RIGHT_DASH || this.negativeFormat == this.PARENTHESIS) n3 = negSignR;
    }
    if (this.hasCurrency) c2 = this.currencyValue;
  } else if (this.currencyPosition == this.RIGHT_OUTSIDE) {
    if (nNum < 0) {
      if (this.negativeFormat == this.LEFT_DASH || this.negativeFormat == this.PARENTHESIS) n1 = negSignL;
      if (this.negativeFormat == this.RIGHT_DASH || this.negativeFormat == this.PARENTHESIS) n2 = negSignR;
    }
    if (this.hasCurrency) c3 = this.currencyValue;
  }
  nStr = c0 + n0 + c1 + n1 + nStr + n2 + c2 + n3 + c3;
  if (this.negativeRed && nNum < 0) {
    nStr = '<font color="red">' + nStr + "</font>";
  }
  return nStr;
}

function toPercentageNF() {
  nNum = this.num * 100;
  nNum = this.getRounded(nNum);
  return nNum + "%";
}

function getZerosNF(places) {
  var extraZ = "";
  var i;
  for (i = 0; i < places; i++) {
    extraZ += "0";
  }
  return extraZ;
}

function expandExponentialNF(origVal) {
  if (isNaN(origVal)) return origVal;
  var newVal = parseFloat(origVal) + "";
  var eLoc = newVal.toLowerCase().indexOf("e");
  if (eLoc != -1) {
    var plusLoc = newVal.toLowerCase().indexOf("+");
    var negLoc = newVal.toLowerCase().indexOf("-", eLoc);
    var justNumber = newVal.substring(0, eLoc);
    if (negLoc != -1) {
      var places = newVal.substring(negLoc + 1, newVal.length);
      justNumber = this.moveDecimalAsString(justNumber, true, parseInt(places));
    } else {
      if (plusLoc == -1) plusLoc = eLoc;
      var places = newVal.substring(plusLoc + 1, newVal.length);
      justNumber = this.moveDecimalAsString(justNumber, false, parseInt(places));
    }
    newVal = justNumber;
  }
  return newVal;
}

function moveDecimalRightNF(val, places) {
  var newVal = "";
  if (places == null) {
    newVal = this.moveDecimal(val, false);
  } else {
    newVal = this.moveDecimal(val, false, places);
  }
  return newVal;
}

function moveDecimalLeftNF(val, places) {
  var newVal = "";
  if (places == null) {
    newVal = this.moveDecimal(val, true);
  } else {
    newVal = this.moveDecimal(val, true, places);
  }
  return newVal;
}

function moveDecimalAsStringNF(val, left, places) {
  var spaces = arguments.length < 3 ? this.places : places;
  if (spaces <= 0) return val;
  var newVal = val + "";
  var extraZ = this.getZeros(spaces);
  var re1 = new RegExp("([0-9.]+)");
  if (left) {
    newVal = newVal.replace(re1, extraZ + "$1");
    var re2 = new RegExp("(-?)([0-9]*)([0-9]{" + spaces + "})(\\.?)");
    newVal = newVal.replace(re2, "$1$2.$3");
  } else {
    var reArray = re1.exec(newVal);
    if (reArray != null) {
      newVal =
        newVal.substring(0, reArray.index) + reArray[1] + extraZ + newVal.substring(reArray.index + reArray[0].length);
    }
    var re2 = new RegExp("(-?)([0-9]*)(\\.?)([0-9]{" + spaces + "})");
    newVal = newVal.replace(re2, "$1$2$4.");
  }
  newVal = newVal.replace(/\.$/, "");
  return newVal;
}

function moveDecimalNF(val, left, places) {
  var newVal = "";
  if (places == null) {
    newVal = this.moveDecimalAsString(val, left);
  } else {
    newVal = this.moveDecimalAsString(val, left, places);
  }
  return parseFloat(newVal);
}

function getRoundedNF(val) {
  val = this.moveDecimalRight(val);
  if (this.truncate) {
    val = val >= 0 ? Math.floor(val) : Math.ceil(val);
  } else {
    val = Math.round(val);
  }
  val = this.moveDecimalLeft(val);
  return val;
}

function preserveZerosNF(val) {
  var i;
  val = this.expandExponential(val);
  if (this.places <= 0) return val;
  var decimalPos = val.indexOf(".");
  if (decimalPos == -1) {
    val += ".";
    for (i = 0; i < this.places; i++) {
      val += "0";
    }
  } else {
    var actualDecimals = val.length - 1 - decimalPos;
    var difference = this.places - actualDecimals;
    for (i = 0; i < difference; i++) {
      val += "0";
    }
  }
  return val;
}

function justNumberNF(val) {
  var newVal = val + "";
  var isPercentage = false;
  if (newVal.indexOf("%") != -1) {
    newVal = newVal.replace(/\%/g, "");
    isPercentage = true;
  }
  var re = new RegExp("[^\\" + this.inputDecimalValue + "\\d\\-\\+\\(\\)eE]", "g");
  newVal = newVal.replace(re, "");
  var tempRe = new RegExp("[" + this.inputDecimalValue + "]", "g");
  var treArray = tempRe.exec(newVal);
  if (treArray != null) {
    var tempRight = newVal.substring(treArray.index + treArray[0].length);
    newVal = newVal.substring(0, treArray.index) + this.PERIOD + tempRight.replace(tempRe, "");
  }
  if (newVal.charAt(newVal.length - 1) == this.DASH) {
    newVal = newVal.substring(0, newVal.length - 1);
    newVal = "-" + newVal;
  } else if (newVal.charAt(0) == this.LEFT_PAREN && newVal.charAt(newVal.length - 1) == this.RIGHT_PAREN) {
    newVal = newVal.substring(1, newVal.length - 1);
    newVal = "-" + newVal;
  }
  newVal = parseFloat(newVal);
  if (!isFinite(newVal)) {
    newVal = 0;
  }
  if (isPercentage) {
    newVal = this.moveDecimalLeft(newVal, 2);
  }
  return newVal;
}
/* instacalc core library */

// locals for each calculator
function InstaCalc(default_settings) {
  // merge in default settings as needed
  this.settings = {
    startcells: 7,
    maxcells: 100,
    embed: false,
    gadget: false,

    visibility: [],

    basic: true,
    round: false,

    base_url: "http://instacalc.com",
    embed_preview_url: "http://instacalc.com/embedpreview.html",
  };

  this.cells = 0;
  this.inputs = [];
  this.outputs = [];
  this.outputCache = [];
  this.outputCache.format = [];
  this.inputCache = [];
  this.titles = [];
  this.comments = [];
  this.current_row = -1; // current row being calculated

  this.lib = {
    chart: [],
  };

  this.format = {
    currency: false,
    symbol: "$",
    angle: "deg",
    decimals: 2,
  };

  this.createNumberFormat(); // initialize numeric settings
}

// util functions
InstaCalc.isdefined = function (variable) {
  return typeof variable == "undefined" ? false : true;
};

InstaCalc.isNull = function (obj) {
  if (obj === null) {
    return true;
  }

  if (InstaCalc.isdefined(obj) === false) {
    return true;
  }

  if (obj === "") {
    return true;
  }

  return false;
};

// load currency symbols & decimal precision
InstaCalc.format = {};
InstaCalc.format.currencies = {};

InstaCalc.format.currencies["BRL"] = {}; // Brazilian real - above USD since happens first
InstaCalc.format.currencies["BRL"].symbol = "R$"; // Brazilian real
InstaCalc.format.currencies["BRL"].regex = /R[$]/gi; // Brazilian real
InstaCalc.format.currencies["BRL"].decimals = 2;
InstaCalc.format.currencies["BRL"].code = "BRL";

InstaCalc.format.currencies["USD"] = {}; // US dollar
InstaCalc.format.currencies["USD"].symbol = "$"; // used for printing strings
InstaCalc.format.currencies["USD"].regex = /[$]/gi; // US dollar; NOT preceded by R for BRL
InstaCalc.format.currencies["USD"].decimals = 2; // 2 digits of precision
InstaCalc.format.currencies["USD"].code = "USD";

InstaCalc.format.currencies["GBP"] = {}; // British Pound
InstaCalc.format.currencies["GBP"].symbol = "£"; // used for printing strings
InstaCalc.format.currencies["GBP"].regex = /[£]/gi; // US dollar; NOT preceded by R for BRL
InstaCalc.format.currencies["GBP"].decimals = 2; // 2 digits of precision
InstaCalc.format.currencies["GBP"].code = "GBP";

InstaCalc.format.currencies["INR"] = {}; // Indian rupee
InstaCalc.format.currencies["INR"].symbol = "Rs. ";
//InstaCalc.format.currencies["INR"].regex = /(Rs[.]|\u20b9)/gi; // Indian rupee
InstaCalc.format.currencies["INR"].regex = /(?<!\w)(?:Rs\.|₹)(?=\s*\d)/gi; // Indian rupee -- requires digits after, word break before
InstaCalc.format.currencies["INR"].decimals = 2;
InstaCalc.format.currencies["INR"].code = "INR";

InstaCalc.format.currencies["EUR"] = {}; // Euro
InstaCalc.format.currencies["EUR"].symbol = ""; // Euro
InstaCalc.format.currencies["EUR"].regex = /\u20AC|\u0080/gi; // Euro unicode: 20AC
InstaCalc.format.currencies["EUR"].decimals = 2;
InstaCalc.format.currencies["EUR"].code = "EUR";

InstaCalc.format.currencies["JPY"] = {}; // Japanese Yen
InstaCalc.format.currencies["JPY"].symbol = "¥";
InstaCalc.format.currencies["JPY"].regex = /\u00A5/gi; // Unicode 00A5
InstaCalc.format.currencies["JPY"].decimals = 0;
InstaCalc.format.currencies["JPY"].code = "JPY";

var Unit = {};

Unit.label = ""; // label used to describe units in comment

Unit.alias = {};
Unit.alias.mph = "miles/hour";
Unit.alias.mpm = "miles/minute";
Unit.alias.fpm = "feet/minute";
Unit.alias.mpg = "miles/gallon";
//Unit.alias.mpge = "miles/33.7 kWh";

Unit.alias.mpl = "miles/liter";
Unit.alias.kmpl = "km/liter";

Unit.alias.knot = Unit.alias.knots = "nautical mile / hour";

// frames per second more common?
Unit.alias.fps = "feet/second";
Unit.alias.kps = "km/second";

Unit.alias.cfs = "cubic feet/second";
Unit.alias.cfm = "cubic feet/minute";
Unit.alias.cfh = "cubic feet/hour";
Unit.alias.cfd = "cubic feet/day";

Unit.alias.lps = "liters/second";
Unit.alias.lpm = "liters/minute";
Unit.alias.lph = "liters/hour";
Unit.alias.lpd = "liters/day";

Unit.alias.gps = "gallons/second";
Unit.alias.gpm = "gallons/minute";
Unit.alias.gph = "gallons/hour";
Unit.alias.gpd = "gallons/day";

Unit.alias.m3s = "cubic meters/second";
Unit.alias.m3m = "cubic meters/minute";
Unit.alias.m3h = "cubic meters/hour";
Unit.alias.m3d = "cubic meters/day";

Unit.alias.kph = "km/hour";
Unit.alias.kmph = "km/hour";
Unit.alias.kmh = "km/hour";

Unit.alias.rpm = "revolutions/minute";
Unit.alias.rps = "revolutions/second";

Unit.alias.bpm = "beats/minute";
Unit.alias.baud = "bits/sec";

/*
Unit.alias.bps = "bit/sec";
Unit.alias.kbps = "thousand bit/sec";
Unit.alias.mbps = "million bit/sec";
Unit.alias.gbps = "billion bit/sec";
Unit.alias.tbps = "trillion bit/sec";
*/

//Unit.alias.pbps = "1e15 bit/sec";

Unit.alias.ips = "instructions/sec";
Unit.alias.kips = "thousand instructions/sec";
Unit.alias.mips = "million instructions/sec";
Unit.alias.gips = "billion instructions/sec";

// Unit.alias.hz = "cycles/second";
/* TODO
Unit.alias.khz = "1000 times/second";
Unit.alias.mhz = "1000000 times/second";
Unit.alias.ghz = "1000000000 times/second";
*/

//Unit.alias["watt-hour"] = Unit.alias["watt hour"] = "wh";

Unit.freq = {};
Unit.freq.SI = { cycle: 1, s: -1 };
Unit.freq.base = 1;
Unit.freq.name = "frequency";
Unit.freq.hz = Unit.freq.Hertz = Unit.freq.hertz = 1;
Unit.freq.khz = 1e3 * Unit.freq.hz;
Unit.freq.mhz = 1e6 * Unit.freq.hz;
Unit.freq.ghz = 1e9 * Unit.freq.hz;
Unit.freq.thz = 1e12 * Unit.freq.hz;
Unit.freq.phz = 1e15 * Unit.freq.hz;
Unit.freq.ehz = 1e18 * Unit.freq.hz;
Unit.freq.zhz = 1e21 * Unit.freq.hz;
Unit.freq.yhz = 1e24 * Unit.freq.hz;
Unit.freq.rhz = 1e27 * Unit.freq.hz;
Unit.freq.qhz = 1e30 * Unit.freq.hz;

Unit.datarate = {};
Unit.datarate.SI = { bit: 1, s: -1 };
Unit.datarate.base = 1;
Unit.datarate.name = "data rate";
Unit.datarate.bps = 1;
Unit.datarate.kbps = 1e3 * Unit.datarate.bps;
Unit.datarate.mbps = 1e6 * Unit.datarate.bps;
Unit.datarate.gbps = 1e9 * Unit.datarate.bps;
Unit.datarate.tbps = 1e12 * Unit.datarate.bps;
Unit.datarate.pbps = 1e15 * Unit.datarate.bps;
Unit.datarate.ebps = 1e18 * Unit.datarate.bps;
Unit.datarate.zbps = 1e21 * Unit.datarate.bps;
Unit.datarate.ybps = 1e24 * Unit.datarate.bps;
Unit.datarate.rbps = 1e27 * Unit.datarate.bps;
Unit.datarate.qbps = 1e30 * Unit.datarate.bps;

Unit.datarate.KBps = 8 * Unit.datarate.kbps;
Unit.datarate.MBps = 8 * Unit.datarate.mbps;
Unit.datarate.GBps = 8 * Unit.datarate.gbps;
Unit.datarate.TBps = 8 * Unit.datarate.tbps;
Unit.datarate.PBps = 8 * Unit.datarate.pbps;
Unit.datarate.EBps = 8 * Unit.datarate.ebps;
Unit.datarate.ZBps = 8 * Unit.datarate.zbps;
Unit.datarate.YBps = 8 * Unit.datarate.ybps;
Unit.datarate.RBps = 8 * Unit.datarate.rbps;
Unit.datarate.QBps = 8 * Unit.datarate.qbps;

Unit.concentration = {};
Unit.concentration.name = "concentration";
Unit.concentration.base = 1;
Unit.concentration.pph = 10000; // hundred
Unit.concentration.pcm = 10; // per cent mille (1 part in 100,000)
Unit.concentration.ppm = 1;   // million, default
Unit.concentration.ppb = 1e-3; // billion
Unit.concentration.ppt = 1e-6; // trillion
Unit.concentration.ppq = 1e-9; // quadrillion
Unit.concentration["basis point"] = Unit.concentration["basis points"] = Unit.concentration.bp = 100; // basis point, 1/100 of a percent
Unit.concentration["percentage point"] = Unit.concentration["percentage points"] = Unit.concentration.pp = 10000; // basis point, 1/100 of a percent

// mileage efficiency
Unit.distance_per_energy = {};
Unit.distance_per_energy.name = "distance/energy";
Unit.distance_per_energy.base = 1;
Unit.distance_per_energy.SI = { "kg": -1, "m": -1, "s": 2 } // mile / kWh as SI base
Unit.distance_per_energy.mpge = 1609.344 / (33.7 * 1000 * 3600); // miles / 33.7 kWh => meters / watt-second

// angle measure
Unit.angle = {};
Unit.angle.base = 1;
Unit.angle.SI = { rad: 1 };
Unit.angle.radian = Unit.angle.radians = Unit.angle.rad = 1;
Unit.angle.degree = Unit.angle.degrees = Unit.angle.deg = (Unit.angle.radian * Math.PI) / 180.0;
Unit.angle.quadrant = Unit.angle.quadrants = Unit.angle.degree * 90;

Unit.angle.gradian = Unit.angle.gradians = Unit.angle.grad = (Unit.angle.radian * Math.PI) / 200.0;
Unit.angle.arcsecond = Unit.angle.arcseconds = Unit.angle.arcsec = Unit.angle.arcsecs = Unit.angle["arc second"] = Unit.angle["arc seconds"] = Unit.angle.degree / 3600;
Unit.angle.arcminute = Unit.angle.arcminutes = Unit.angle.arcmin = Unit.angle.arcmins = Unit.angle["arc minute"] = Unit.angle["arc minutes"] = Unit.angle.degree / 60;
Unit.angle.milliradian = Unit.angle.milliradians = Unit.angle.mrad = Unit.angle.radian / 1000;
Unit.angle.microradian = Unit.angle.microradians = Unit.angle.urad = Unit.angle['µrad'] = Unit.angle.radian * 1e-6;
Unit.angle.turn = Unit.angle.turns = 2 * Math.PI * Unit.angle.radian;
Unit.angle.revolution = Unit.angle.revolutions = Unit.angle.rev = Unit.angle.revs = Unit.angle.turn;

Unit.angle.mil_nato = Unit.angle.mils_nato = 360 * Unit.angle.degree / 6400; // NATO mil
//Unit.angle.mil = Unit.angle.mils = Unit.angle.milliradian;
Unit.angle.point = Unit.angle.points = Unit.angle.compass_point = Unit.angle.degree * (360 / 32); // Compass point
Unit.angle.hourangle = Unit.angle.hourangles = Unit.angle.degree * 15; // Astronomical hour angle

Unit.angle.name = "angle";

Unit.solid_angle = ["\\^2", "sq", "squared", "square"];
Unit.solid_angle.SI = { rad: 2 };
Unit.solid_angle.name = "solid angle";
Unit.solid_angle.base = 1;
Unit.solid_angle.steradian = Unit.solid_angle.steradians = Unit.solid_angle.sr = 1;
Unit.solid_angle["square degree"] = Unit.solid_angle["square degrees"] = Unit.solid_angle["square deg"] = Math.pow((Unit.solid_angle.steradian * Math.PI) / 180.0, 2);

Unit.length = {};
Unit.length.SI = { m: 1 };

Unit.mass = {};
Unit.mass.SI = { kg: 1 };

Unit.time = {};
Unit.time.SI = { s: 1 };

Unit.area = ["\\^2", "sq", "squared", "square"]; // words that connote a square unit
Unit.area.SI = { m: 2 };

Unit.volume = ["\\^3", "cu", "cubed", "cubic"]; // ditto for cubic units
Unit.volume.SI = { m: 3 };

Unit.liquid = {};
Unit.liquid.SI = { m: 3 };

Unit.power = {};
Unit.force = {};
Unit.torque = {};
Unit.energy = {};
Unit.data = {};
Unit.currency = {};

// scientific ones
Unit.pressure = {};

Unit.pressure.base = 1;
Unit.pressure.SI = { m: -1, kg: 1, s: -2 };

Unit.pressure.name = "pressure";
Unit.pressure.pascal = Unit.pressure.pascals = Unit.pressure.pa = Unit.pressure.Pa = Unit.pressure.base;
Unit.pressure.bar = Unit.pressure.bars = 1e5;
Unit.pressure.torr = Unit.pressure.mmHg = Unit.pressure.mmhg = 133.3223684211;
Unit.pressure.atm = Unit.pressure.atmosphere = Unit.pressure.atmospheres = 101325;
Unit.pressure.psi = Unit.pressure["pounds per square inch"] = 6894.757293168361;
Unit.pressure.psf = Unit.pressure["pounds per square foot"] = 47.880258980335;
Unit.pressure.ksc = Unit.pressure["kilogram-force per square centimeter"] = 98066.5;
Unit.pressure.mmH2O = Unit.pressure["millimeters of water"] = 9.80665;
Unit.pressure.cmH2O = Unit.pressure["centimeters of water"] = 98.0665;
Unit.pressure.inH2O = Unit.pressure["inches of water"] = 249.08891;
Unit.pressure.inHg = Unit.pressure["inches of mercury"] = 3386.388666666667;

Unit.electric_charge = {};
Unit.electric_charge.SI = { a: 1, s: 1 };
Unit.electric_charge.name = "electric charge";
Unit.electric_charge.coulomb = Unit.electric_charge.coulombs = 1;

Unit.electric_charge.Ah = Unit.electric_charge.ah = Unit.electric_charge["ampere hour"] = Unit.electric_charge["ampere hours"] = 3600;
Unit.electric_charge["amp hour"] = Unit.electric_charge["amp hours"] = 3600;
Unit.electric_charge["ah"] = 3600;
Unit.electric_charge["mah"] = 3.6;

Unit.electric_potential = {};
Unit.electric_potential.SI = { m: 2, kg: 1, s: -3, a: -1 };
Unit.electric_potential.name = "electric potential";
Unit.electric_potential.volt = Unit.electric_potential.volts = Unit.electric_potential.v = 1;

Unit.electric_capacitance = {};
Unit.electric_capacitance.SI = { m: -2, kg: -1, s: 4, a: 2 };
Unit.electric_capacitance.name = "electric capacitance";
Unit.electric_capacitance.farad = Unit.electric_capacitance.farads = 1;

Unit.electric_resistance = {};
Unit.electric_resistance.SI = { m: 2, kg: 1, s: -3, a: -2 };
Unit.electric_resistance.name = "electric resistance";
Unit.electric_resistance.ohm = Unit.electric_resistance.ohms = Unit.electric_resistance["Ω"] = 1;

Unit.electric_conductance = {};
Unit.electric_conductance.SI = { m: -2, kg: -1, s: 3, a: 2 };
Unit.electric_conductance.name = "electric conductance";
Unit.electric_conductance.siemens = 1;

Unit.electric_current = {};
Unit.electric_current.SI = { a: 1 };
Unit.electric_current.name = "electric current";
Unit.electric_current.ampere = Unit.electric_current.amperes = Unit.electric_current.amp = Unit.electric_current.amps = Unit.electric_current.a = 1;
Unit.electric_current.ma = Unit.electric_current.milliampere = Unit.electric_current.milliamp = Unit.electric_current.milliamps = Unit.electric_current.mA = 1e-3;
Unit.electric_current.Ma = Unit.electric_current.megaampere = Unit.electric_current.megaamp = Unit.electric_current.megaamps = Unit.electric_current.MA = 1e6;

Unit.magnetic_flux = {};
Unit.magnetic_flux.SI = { m: 2, kg: 1, s: -2, a: -1 };
Unit.magnetic_flux.name = "magnetic flux";
Unit.magnetic_flux.weber = Unit.magnetic_flux.webers = Unit.magnetic_flux.wb = 1;

Unit.magnetic_flux_density = {};
Unit.magnetic_flux_density.SI = { kg: 1, s: -2, a: -1 };
Unit.magnetic_flux_density.name = "magnetic flux density";
Unit.magnetic_flux_density.tesla = Unit.magnetic_flux_density.teslas = 1;

Unit.electric_inductance = {};
Unit.electric_inductance.SI = { m: 2, kg: 1, s: -2, a: -2 };
Unit.electric_inductance.name = "electric inductance";
Unit.electric_inductance.henry = Unit.electric_inductance.henrys = 1;

Unit.luminous_flux = {};
Unit.luminous_flux.SI = { cd: 1, sr: 1 };
Unit.luminous_flux.name = "luminous flux";
Unit.luminous_flux.lumen = Unit.luminous_flux.lumens = Unit.luminous_flux.lm = 1;

Unit.illuminance = {};
Unit.illuminance.SI = { cd: 1, sr: 1, m: -2 };
Unit.illuminance.name = "illuminance";
Unit.illuminance.lux = Unit.illuminance.lx = 1;
Unit.illuminance["foot-candle"] = Unit.illuminance.foot_candle = Unit.illuminance.fc = 10.7639; // 1 fc = 10.7639 lux
Unit.illuminance.phot = Unit.illuminance.ph = 1e4; // 1 phot = 10,000 lux
Unit.illuminance.nox = 1e-3; // 1 nox = 0.001 lux
Unit.illuminance.millilux = Unit.illuminance.mlx = 1e-3;
Unit.illuminance.kilolux = Unit.illuminance.klx = 1e3;
Unit.illuminance.megalux = Unit.illuminance.Mlx = 1e6;

Unit.luminous_intensity = {};
Unit.luminous_intensity.SI = { cd: 1 };
Unit.luminous_intensity.name = "luminous intensity";
Unit.luminous_intensity.candela = Unit.luminous_intensity.candelas = Unit.luminous_intensity.cd = 1;
Unit.luminous_intensity.candle = Unit.luminous_intensity.candles = 1.019; // international standard candle

Unit.radioactivity = {};
Unit.radioactivity.SI = { s: -1 };
Unit.radioactivity.name = "radioactivity";
Unit.radioactivity.becquerel = Unit.radioactivity.becquerels = Unit.radioactivity.Bq = Unit.radioactivity.bq = 1;

Unit.absorbed_dose = {};
Unit.absorbed_dose.SI = { m: 2, s: -2 };
Unit.absorbed_dose.name = "absorbed dose";
Unit.absorbed_dose.gray = Unit.absorbed_dose.grays = Unit.absorbed_dose.Gy = Unit.absorbed_dose.gy = 1;

Unit.equivalent_dose = {};
Unit.equivalent_dose.SI = { m: 2, s: -2 };
Unit.equivalent_dose.name = "equivalent dose";
Unit.equivalent_dose.sievert = Unit.equivalent_dose.sieverts = Unit.equivalent_dose.Sv = Unit.equivalent_dose.sv = 1;

Unit.catalytic_activity = {};
Unit.catalytic_activity.SI = { mol: 1, s: -1 };
Unit.catalytic_activity.name = "catalytic activity";
Unit.catalytic_activity.katal = Unit.catalytic_activity.katals = Unit.catalytic_activity.kat = 1;

Unit.amount_of_substance = {};
Unit.amount_of_substance.SI = { mol: 1 };
Unit.amount_of_substance.name = "amount of substance";
Unit.amount_of_substance.mole = Unit.amount_of_substance.moles = Unit.amount_of_substance.mol = 1;
Unit.amount_of_substance.millimole = Unit.amount_of_substance.millimoles = Unit.amount_of_substance.mmol = 1e-3;
Unit.amount_of_substance.micromole = Unit.amount_of_substance.micromoles = Unit.amount_of_substance.umol = 1e-6;
Unit.amount_of_substance.nanomole = Unit.amount_of_substance.nanomoles = Unit.amount_of_substance.nmol = 1e-9;
Unit.amount_of_substance.picomole = Unit.amount_of_substance.picomoles = Unit.amount_of_substance.pmol = 1e-12;

Unit.molar_concentration = {};
Unit.molar_concentration.SI = { mol: 1, m: -3 };
Unit.molar_concentration.name = "molar concentration";
Unit.molar_concentration.molar = Unit.molar_concentration.molars = Unit.molar_concentration["molar concentration"] = 1e3; // mol/L

Unit.radioactive_exposure = {};
Unit.radioactive_exposure.SI = { kg: -1, s: 1, a: 1 };
Unit.radioactive_exposure.name = "radioactive exposure";
Unit.radioactive_exposure.roentgen = Unit.radioactive_exposure.roentgens = 1 / 3876;

// temperature - nonlinear conversions
Unit.temperature = {};
Unit.temperature.SI = { kelvin: 1 };
Unit.temperature.name = "temperature";
Unit.temperature.conversion = "function";

// conversion functions have a FROM and TO function, relative to the base unit (Celcius, in this case)
Unit.temperature.c =
  Unit.temperature.celsius =
  Unit.temperature.celcius =
  Unit.temperature.centigrade =
  [
    function (C) {
      return C;
    },
    function (C) {
      return C;
    },
  ]; // identity
Unit.temperature.f =
  Unit.temperature.fahrenheit = [
    function (F) {
      return ((F - 32.0) * 5) / 9;
    },
    function (C) {
      return (C * 9) / 5 + 32;
    },
  ]; // Fahrenheit to Celcius
Unit.temperature.k = Unit.temperature.kelvin = [
  function (K) {
    return K - 273.15;
  },
  function (C) {
    return C + 273.15;
  },
]; // Kelvin to Celcius

// "r" is too useful to be taken by rankine
Unit.temperature.rankine = [
  function (R) {
    return (R * 5) / 9 - 273.15;
  },
  function (C) {
    return ((C + 273.15) * 9) / 5;
  },
]; // Rankine to Celcius

Unit.data.base = 1; // 1 bit
Unit.data.name = "data";
Unit.data.SI = { bit: 1 };
Unit.data.bit = Unit.data.bits = 1;
Unit.data.nibble = Unit.data.nibbles = Unit.data.nybble = Unit.data.nybbles = 4 * Unit.data.bit;

Unit.data.kilobit = Unit.data.kilobits = Unit.data.kbit = Unit.data.kbits = 1024 * Unit.data.bit;
Unit.data.megabit = Unit.data.megabits = Unit.data.mbit = Unit.data.mbits = 1024 * Unit.data.kbit;
Unit.data.gigabit = Unit.data.gigabits = Unit.data.gbit = Unit.data.gbits = 1024 * Unit.data.mbit;
Unit.data.terabit = Unit.data.terabits = Unit.data.tbit = Unit.data.tbits = 1024 * Unit.data.gbit;
Unit.data.petabit = Unit.data.petabits = Unit.data.pbit = Unit.data.pbits = 1024 * Unit.data.tbit;
Unit.data.exabit = Unit.data.exabits = Unit.data.ebit = Unit.data.ebits = 1024 * Unit.data.pbit;
Unit.data.zettabit = Unit.data.zettabits = Unit.data.zbit = Unit.data.zbits = 1024 * Unit.data.ebit;
Unit.data.yottabit = Unit.data.yottabits = Unit.data.ybit = Unit.data.ybits = 1024 * Unit.data.zbit;
Unit.data["ronnabit"] = Unit.data["ronnabits"] = Unit.data["rbit"] = Unit.data["rbits"] = 1024 * Unit.data["ybit"];
Unit.data["quettabit"] = Unit.data["quettabits"] = Unit.data["qbit"] = Unit.data["qbits"] = 1e30 * Unit.data["rbit"];

Unit.data["byte"] = Unit.data["bytes"] = 8 * Unit.data.bit;
Unit.data["kilobyte"] = Unit.data["kilobytes"] = Unit.data["kb"] = Unit.data["kbs"] = 1024 * Unit.data["byte"];
Unit.data["megabyte"] = Unit.data["megabytes"] = Unit.data["mb"] = Unit.data["mbs"] = 1024 * Unit.data.kb;
Unit.data["gigabyte"] = Unit.data["gigabytes"] = Unit.data["gb"] = Unit.data["gbs"] = 1024 * Unit.data.mb;
Unit.data["terabyte"] = Unit.data["terabytes"] = Unit.data["tb"] = Unit.data["tbs"] = 1024 * Unit.data.gb;
Unit.data["petabyte"] = Unit.data["petabytes"] = Unit.data["pb"] = Unit.data["pbs"] = 1024 * Unit.data.tb;
Unit.data["exabyte"] = Unit.data["exabytes"] = Unit.data["eb"] = Unit.data["ebs"] = 1024 * Unit.data.pb;
Unit.data["zettabyte"] = Unit.data["zettabytes"] = Unit.data["zb"] = Unit.data["zbs"] = 1024 * Unit.data.eb;
Unit.data["yottabyte"] = Unit.data["yottabytes"] = Unit.data["yb"] = Unit.data["ybs"] = 1024 * Unit.data.zb;
Unit.data["ronnabyte"] = Unit.data["ronnabytes"] = Unit.data["rbyte"] = Unit.data["rbytes"] = 1024 * Unit.data.yottabyte;
Unit.data["quettabyte"] = Unit.data["quettabytes"] = Unit.data["qbyte"] = Unit.data["qbytes"] = 1024 * Unit.data.ronnabyte;


// sigh...
Unit.data["kibibit"] = Unit.data["kibit"] = Unit.data["kbit"] = Unit.data.kbit;
Unit.data["mibibit"] = Unit.data["mibit"] = Unit.data["mbit"] = Unit.data.mbit;
Unit.data["gibibit"] = Unit.data["gibit"] = Unit.data["gbit"] = Unit.data.gbit;
Unit.data["tibibit"] = Unit.data["tibit"] = Unit.data["tbit"] = Unit.data.tbit;
Unit.data["pibibit"] = Unit.data["pibit"] = Unit.data["pbit"] = Unit.data.pbit;
Unit.data["eibibit"] = Unit.data["eibit"] = Unit.data["ebit"] = Unit.data.ebit;
Unit.data["zibibit"] = Unit.data["zibit"] = Unit.data["zbit"] = Unit.data.zbit;
Unit.data["yibibit"] = Unit.data["yibit"] = Unit.data["ybit"] = Unit.data.ybit;
Unit.data["ribibit"] = Unit.data["ribit"] = Unit.data["rbit"] = Unit.data.rbit;
Unit.data["qibibit"] = Unit.data["qibit"] = Unit.data["qbit"] = Unit.data.qbit;

Unit.data["kibibyte"] = Unit.data["kibibytes"] = Unit.data["kibyte"] = Unit.data["kbyte"] = Unit.data["kbytes"] = Unit.data["kib"] = Unit.data["kb"];
Unit.data["mebibyte"] = Unit.data["mebibytes"] = Unit.data["mibyte"] = Unit.data["mbyte"] = Unit.data["mbytes"] = Unit.data["mib"] = Unit.data["mb"];
Unit.data["gibibyte"] = Unit.data["gibibytes"] = Unit.data["gibyte"] = Unit.data["gbyte"] = Unit.data["gbytes"] = Unit.data["gib"] = Unit.data["gb"];
Unit.data["tebibyte"] = Unit.data["tebibytes"] = Unit.data["tibyte"] = Unit.data["tbyte"] = Unit.data["tbytes"] = Unit.data["tib"] = Unit.data["tb"];
Unit.data["pebibyte"] = Unit.data["pebibytes"] = Unit.data["pibyte"] = Unit.data["pbyte"] = Unit.data["pbytes"] = Unit.data["pib"] = Unit.data["pb"];
Unit.data["exbibyte"] = Unit.data["exbibytes"] = Unit.data["eibyte"] = Unit.data["ebyte"] = Unit.data["ebytes"] = Unit.data["eib"] = Unit.data["eb"];
Unit.data["zebibyte"] = Unit.data["zebibytes"] = Unit.data["zibyte"] = Unit.data["zbyte"] = Unit.data["zbytes"] = Unit.data["zib"] = Unit.data["zb"];
Unit.data["yobibyte"] = Unit.data["yobibytes"] = Unit.data["yibyte"] = Unit.data["ybyte"] = Unit.data["ybytes"] = Unit.data["yib"] = Unit.data["yb"];

Unit.data["kilobit_si"] = Unit.data["kbit_si"] = 1e3 * Unit.data["bit"];
Unit.data["megabit_si"] = Unit.data["mbit_si"] = 1e6 * Unit.data["bit"];
Unit.data["gigabit_si"] = Unit.data["gbit_si"] = 1e9 * Unit.data["bit"];
Unit.data["terabit_si"] = Unit.data["tbit_si"] = 1e12 * Unit.data["bit"];
Unit.data["petabit_si"] = Unit.data["pbit_si"] = 1e15 * Unit.data["bit"];
Unit.data["exabit_si"] = Unit.data["ebit_si"] = 1e18 * Unit.data["bit"];
Unit.data["zettabit_si"] = Unit.data["zbit_si"] = 1e21 * Unit.data["bit"];
Unit.data["yottabit_si"] = Unit.data["ybit_si"] = 1e24 * Unit.data["bit"];
Unit.data["ronnabit_si"] = Unit.data["rbit_si"] = 1e27 * Unit.data["bit"];
Unit.data["quettabit_si"] = Unit.data["qbit_si"] = 1e30 * Unit.data["bit"];


Unit.data["kilobyte_si"] = Unit.data["kb_si"] = 1e3 * Unit.data["byte"];
Unit.data["megabyte_si"] = Unit.data["mb_si"] = 1e6 * Unit.data["byte"];
Unit.data["gigabyte_si"] = Unit.data["gb_si"] = 1e9 * Unit.data["byte"];
Unit.data["terabyte_si"] = Unit.data["tb_si"] = 1e12 * Unit.data["byte"];
Unit.data["petabyte_si"] = Unit.data["pb_si"] = 1e15 * Unit.data["byte"];
Unit.data["exabyte_si"] = Unit.data["eb_si"] = 1e18 * Unit.data["byte"];
Unit.data["zettabyte_si"] = Unit.data["zb_si"] = 1e21 * Unit.data["byte"];
Unit.data["yottabyte_si"] = Unit.data["yb_si"] = 1e24 * Unit.data["byte"];
Unit.data["ronnabyte_si"] = Unit.data["rbyte_si"] = 1e27 * Unit.data["byte"];
Unit.data["quettabyte_si"] = Unit.data["qbyte_si"] = 1e30 * Unit.data["byte"];

// this is removed after currencies are loaded
Unit.currency.base = 1; // 1 dollar
Unit.currency.name = "currency";
Unit.currency.dollar = Unit.currency.dollars = 1;
Unit.currency.penny = Unit.currency.pennies = Unit.currency.cent = Unit.currency.cents = 0.01 * Unit.currency.dollars;
Unit.currency.dime = Unit.currency.dimes = 0.1 * Unit.currency.dollars;
Unit.currency.nickel = Unit.currency.nickels = 0.05 * Unit.currency.dollars;
Unit.currency.quarter = Unit.currency.quarters = 0.25 * Unit.currency.dollars;
Unit.currency.usd = Unit.currency.dollar;

Unit.constant = {};
Unit.constant.base = 1; // unity
Unit.constant.unity = 1; // unity - use as default unit for no conversion
Unit.constant.times = Unit.constant.time = 1; // time(s) per second
Unit.constant.kilotimes = Unit.constant.kilotime = 1000 * Unit.constant.time; // time(s) per second

Unit.time.base = 1; // second
Unit.time.name = "time";
Unit.time.SI = { s: 1 };

Unit.time.second = Unit.time.seconds = Unit.time.s = Unit.time.sec = Unit.time.secs = 1;

Unit.time.ps = Unit.time.picosecond = Unit.time.picoseconds = 1e-12 * Unit.time.second;
Unit.time.ns = Unit.time.nanosecond = Unit.time.nanoseconds = 1e-9 * Unit.time.second;
Unit.time.us = Unit.time.microsecond = Unit.time.microseconds = 1e-6 * Unit.time.second;
Unit.time['\u03bcs'] = Unit.time.us;

Unit.time.ms = Unit.time.millisecond = Unit.time.milliseconds = 1e-3 * Unit.time.second;

Unit.time.minute = Unit.time.minutes = Unit.time.min = Unit.time.mins = 60 * Unit.time.second;

Unit.time.hour = Unit.time.hours = Unit.time.hr = Unit.time.hrs = Unit.time.h = 60 * Unit.time.minute;

Unit.time.day = 24 * Unit.time.hour;
Unit.time.days = 24 * Unit.time.hour;
Unit.time.dy = 24 * Unit.time.hour;

Unit.time.week = 7 * Unit.time.day;
Unit.time.weeks = 7 * Unit.time.day;
Unit.time.wk = 7 * Unit.time.day;

Unit.time["work day"] = Unit.time["work days"] = 8 * Unit.time.hour;
Unit.time["work week"] = Unit.time["work weeks"] = 40 * Unit.time.hour;
Unit.time["work year"] = Unit.time["work years"] = 50 * Unit.time["work week"];

Unit.time.fortnight = 2 * Unit.time.week;
Unit.time.fortnights = 2 * Unit.time.week;

Unit.time.month = Unit.time.months = Unit.time.mo = (365 / 12) * Unit.time.day;
Unit.time.year = Unit.time.years = Unit.time.yr = Unit.time.yrs = 365 * Unit.time.day;
Unit.time.quarter = Unit.time.quarters = 3 * Unit.time.month;
Unit.time["calendar year"] = Unit.time["calendar years"] = 365 * Unit.time.day;
Unit.time["leap year"] = Unit.time["leap years"] = 366 * Unit.time.day;
Unit.time["mean year"] = Unit.time["mean years"] = 365.2425 * Unit.time.day;
Unit.time["sidereal year"] = Unit.time["sidereal years"] = 365.25636 * Unit.time.day;
Unit.time["tropical year"] = Unit.time["tropical years"] = 365.242189 * Unit.time.day;
Unit.time["solar year"] = Unit.time["solar years"] = Unit.time["tropical year"];

Unit.time.decade = Unit.time.decades = 10 * Unit.time.year;
Unit.time.century = Unit.time.centuries = 100 * Unit.time.year;
Unit.time.millenium = Unit.time.milleniums = Unit.time.millenia = 1000 * Unit.time.year;

Unit.time_inverse = { base: 1, name: "time_inverse", SI: { s: -1 } };
Unit.time_inverse.yearly = 1 / Unit.time.year;
Unit.time_inverse.annually = 1 / Unit.time.year;
Unit.time_inverse.semiannually = 2 / (Unit.time.year);
Unit.time_inverse.quarterly = 1 / (Unit.time.quarter);
Unit.time_inverse.monthly = 1 / Unit.time.month;
Unit.time_inverse.weekly = 1 / Unit.time.week;
Unit.time_inverse.daily = 1 / Unit.time.day;
Unit.time_inverse.hourly = 1 / Unit.time.hour;
Unit.time_inverse.minutely = 1 / Unit.time.minute;
Unit.time_inverse.secondly = 1 / Unit.time.second;

// area measure - grab the corresponding conversion in length and square it

// energy measure
Unit.energy.base = 1; // joule
Unit.energy.name = "energy";
Unit.energy.SI = { kg: 1, m: 2, s: -2 };
Unit.energy.joule = Unit.energy.joules = Unit.energy.j = Unit.energy.J = 1;
Unit.energy.mJ = Unit.energy.mj = 1e-3 * Unit.energy.joule;
Unit.energy.MJ = Unit.energy.Mj = 1e6 * Unit.energy.joule;
Unit.energy.tnt = Unit.energy.TNT = Unit.energy["ton TNT"] = Unit.energy["tonne TNT"] = 4.184e9 * Unit.energy.joule;
Unit.energy.kiloton = Unit.energy.kilotons = Unit.energy["kiloton TNT"] = 1000 * Unit.energy.TNT;
Unit.energy.megaton = Unit.energy.megatons = Unit.energy["megaton TNT"] = 1000 * Unit.energy.kiloton;
Unit.energy.gigaton = Unit.energy.gigatons = Unit.energy["gigaton TNT"] = 1000 * Unit.energy.megaton;

Unit.energy["electron volt"] = Unit.energy["ev"] = 1.60217646e-19 * Unit.energy.joule;
Unit.energy["watt-hour"] = Unit.energy["watthour"] = Unit.energy["watt hour"] = Unit.energy["w h"] = Unit.energy["wh"] = 3600 * Unit.energy.joule;
Unit.energy["kilowatt-hour"] =
  Unit.energy["kilowatt hour"] =
  Unit.energy["kwh"] =
  Unit.energy["kwhr"] =
  Unit.energy["kw h"] =
  3600 * 1000 * Unit.energy.joule;

Unit.energy.erg = Unit.energy.ergs = 1e-7 * Unit.energy.joule;
Unit.energy.therm = Unit.energy.therms = 105505585.262 * Unit.energy.joule;


Unit.energy["megawatt-hour"] =
  Unit.energy["megawatt hour"] =
  Unit.energy["mwh"] =
  Unit.energy["mwhr"] =
  Unit.energy["mw h"] =
  3600 * 1e6 * Unit.energy.joule;

Unit.energy["gigawatt-hour"] =
  Unit.energy["gigawatt hour"] =
  Unit.energy["gwh"] =
  Unit.energy["gwhr"] =
  Unit.energy["gw h"] =
  3600 * 1e9 * Unit.energy.joule;

Unit.energy["terawatt-hour"] =
  Unit.energy["terawatt hour"] =
  Unit.energy["twh"] =
  Unit.energy["twhr"] =
  Unit.energy["tw h"] =
  3600 * 1e12 * Unit.energy.joule;

Unit.energy["petawatt-hour"] =
  Unit.energy["petawatt hour"] =
  Unit.energy["pwh"] =
  Unit.energy["pwhr"] =
  Unit.energy["pw h"] =
  3600 * 1e15 * Unit.energy.joule;

Unit.energy["btu"] =
  Unit.energy["btus"] =
  Unit.energy["british thermal unit"] =
  Unit.energy["british thermal units"] =
  1055.05585 * Unit.energy.joule;
Unit.energy["calorie"] = Unit.energy["calories"] = Unit.energy["cal"] = Unit.energy["cals"] = 4.184 * Unit.energy.joule;

Unit.energy["kilocalorie"] =
  Unit.energy["kilocalories"] =
  Unit.energy["kcal"] =
  Unit.energy["kcals"] =
  1000 * Unit.energy.calorie;

Unit.energy["Cal"] = Unit.energy["Cals"] = 1000 * Unit.energy.calorie;

// force measure
Unit.force.base = 1; // newton
Unit.force.SI = { kg: 1, m: 1, s: -2 };

Unit.force.name = "force";
Unit.force.newton = Unit.force.newtons = Unit.force.n = 1;

Unit.force["pound-force"] =
  Unit.force["pound force"] =
  Unit.force["lb force"] =
  Unit.force["lbf"] =
  4.44822162 * Unit.force.newton;

Unit.force["kilogram-force"] = Unit.force["kilogram force"] = Unit.force["kgf"] = 9.80665 * Unit.force.newton;
Unit.force["gram-force"] = Unit.force["gram force"] = Unit.force["gf"] = 9.80665e-3 * Unit.force.newton;

Unit.force.dyne = Unit.force.dyn = 1e-5 * Unit.force.newton;

// torque measure
Unit.torque.base = 1; // newton - meter
Unit.torque.SI = { kg: 1, m: 2, s: -2 };
Unit.torque.name = "torque";
Unit.torque["newton-meter"] = Unit.torque["newton meter"] = Unit.torque["newton meters"] = Unit.torque["n m"] = 1;

Unit.torque["foot lb"] =
  Unit.torque["ft lb"] =
  Unit.torque["lbft"] =
  Unit.torque["lb ft"] =
  Unit.torque["foot lbf"] =
  Unit.torque["ft lbf"] =
  Unit.torque["foot-pound"] =
  Unit.torque["foot pound"] =
  1.35581795 * Unit.torque["n m"];
Unit.torque["foot lbs"] =
  Unit.torque["ft lbs"] =
  Unit.torque["foot-pounds"] =
  Unit.torque["foot pounds"] =
  1.35581795 * Unit.torque["n m"];

// power measure
Unit.power.base = 1; // watt
Unit.power.SI = { kg: 1, m: 2, s: -3 };
Unit.power.name = "power";

Unit.power.watt = Unit.power.watts = Unit.power.w = 1;
Unit.power.milliwatt = Unit.power.milliwatts = Unit.power.mW = 1e-3 * Unit.power.watt;
Unit.power.kilowatt = Unit.power.kilowatts = Unit.power.kw = 1e3 * Unit.power.watt;
Unit.power.megawatt = Unit.power.megawatts = Unit.power.MW = Unit.power.mw = 1e6 * Unit.power.watt; // because MWh is more common...
Unit.power.gigawatt = Unit.power.gigawatts = Unit.power.gw = 1e9 * Unit.power.watt; // hrm... megawatt (caps) vs milliwatt (small). Don't have a difference. Case issues are too easy to happen.

Unit.power.horsepower = Unit.power.hp = 745.69987158227022 * Unit.power.watt;

// liquid measure
Unit.liquid.base = 1; // have the base be a cubic METER, which is the base for AREA
Unit.liquid.name = "liquid measure";
Unit.liquid.liter =
  Unit.liquid.liters =
  Unit.liquid.litre =
  Unit.liquid.litres =
  Unit.liquid.l =
  Unit.liquid.ls =
  0.001;
Unit.liquid.ml = Unit.liquid.mls = 1e-3 * Unit.liquid.liter;
Unit.liquid.milliliter =
  Unit.liquid.milliliters =
  Unit.liquid.millilitre =
  Unit.liquid.millilitres =
  1e-3 * Unit.liquid.liter;
Unit.liquid.cc = Unit.liquid.ccs = Unit.liquid.ml;

Unit.liquid.tsp = Unit.liquid.tsps = 4.92892161 * Unit.liquid.ml;
Unit.liquid.teaspoon = Unit.liquid.teaspoons = 4.92892161 * Unit.liquid.ml;

Unit.liquid.tbsp = Unit.liquid.tbsps = 3 * Unit.liquid.tsp;
Unit.liquid.tablespoon = Unit.liquid.tablespoons = 3 * Unit.liquid.tsp;

Unit.liquid["fluid ounce"] =
  Unit.liquid["fluid ounces"] =
  Unit.liquid["fluid oz"] =
  Unit.liquid["fluid ozs"] =
  Unit.liquid["fl oz"] =
  Unit.liquid["fl ozs"] =
  2 * Unit.liquid.tablespoon;
Unit.liquid["us fluid ounce"] =
  Unit.liquid["us fluid ounces"] =
  Unit.liquid["us fluid oz"] =
  Unit.liquid["us fluid ozs"] =
  Unit.liquid["us fl oz"] =
  Unit.liquid["us fl ozs"] =
  2 * Unit.liquid.tablespoon;

Unit.liquid.cup = Unit.liquid.cups = Unit.liquid.cp = Unit.liquid.cps = 16 * Unit.liquid.tablespoon;
Unit.liquid.pint = Unit.liquid.pints = Unit.liquid.pt = Unit.liquid.pts = 2 * Unit.liquid.cup;
Unit.liquid.quart = Unit.liquid.quarts = Unit.liquid.qt = Unit.liquid.qts = 4 * Unit.liquid.cup;

Unit.liquid.gallon = Unit.liquid.gallons = Unit.liquid.gal = Unit.liquid.gals = 16 * Unit.liquid.cup;
Unit.liquid.barrel = Unit.liquid.barrels = Unit.liquid.bbl = 42 * Unit.liquid.gallon;
Unit.liquid.hogshead = Unit.liquid.hogsheads = 63 * Unit.liquid.gallon; // simpsons

// US vs Imperial
Unit.liquid["us gallon"] = Unit.liquid["us gallons"] = Unit.liquid.gallon;
Unit.liquid["us pint"] = Unit.liquid["us pints"] = Unit.liquid.pint;
Unit.liquid["us cup"] = Unit.liquid["us cups"] = Unit.liquid["us cp"] = Unit.liquid["us cps"] = Unit.liquid.cup;
Unit.liquid["metric cup"] = Unit.liquid["metric cups"] = 250 * Unit.liquid.ml;

// US fluid ounces, see above
Unit.liquid["imperial gallon"] = Unit.liquid["imperial gallons"] = 4.54609 * Unit.liquid.liter;
Unit.liquid["imperial pint"] = Unit.liquid["imperial pints"] = Unit.liquid["imperial gallon"] / 8;
Unit.liquid["imperial cup"] =
  Unit.liquid["imperial cups"] =
  Unit.liquid["imperial cp"] =
  Unit.liquid["imperial cps"] =
  Unit.liquid["imperial pint"] / 2;
Unit.liquid["imperial quart"] = Unit.liquid["imperial quarts"] = Unit.liquid["imperial gallon"] / 4;
Unit.liquid["imperial fluid ounce"] =
  Unit.liquid["imperial fluid ounces"] =
  Unit.liquid["imperial fl oz"] =
  Unit.liquid["imperial gallon"] / 160;

Unit.liquid.cuin = 16.387064 * Unit.liquid.ml;
Unit.liquid.cuft = Unit.liquid.cf = Unit.liquid.cbf = Unit.liquid.cbft = 28.316846592 * Unit.liquid.liter;
Unit.liquid.cuyd = Unit.liquid.cuyds = 27 * Unit.liquid.cuft;
Unit.liquid.ccf = Unit.liquid.ccfs = 100 * Unit.liquid.cuft; // centum cubic feet
Unit.liquid.mcf = Unit.liquid.mcfs = 1000 * Unit.liquid.cuft; // mil cubic feet
Unit.liquid.mmcf = Unit.liquid.mmcf = 1e6 * Unit.liquid.cuft; // million cubic feet
Unit.liquid.bcf = Unit.liquid.bcfs = 1e9 * Unit.liquid.cuft; // billion cubic feet
Unit.liquid.tcf = Unit.liquid.tcfs = 1e12 * Unit.liquid.cuft; // trillion cubic feet

// weights in terms of grams
Unit.mass.base = 1; // kilogram base
Unit.mass.SI = { kg: 1 };
Unit.mass.name = "mass";

Unit.mass.kilogram = Unit.mass.kilograms = 1;
Unit.mass.kg = Unit.mass.kgs = Unit.mass.kilo = Unit.mass.kilos = 1;

Unit.mass.gram = Unit.mass.grams = 1e-3 * Unit.mass.kg;
Unit.mass.g = Unit.mass.gs = Unit.mass.gram;
Unit.mass.gm = Unit.mass.gms = Unit.mass.gram;

Unit.mass.mg = Unit.mass.milligram = Unit.mass.milligrams = 1e-3 * Unit.mass.gram;
Unit.mass.mgs = 1e-3 * Unit.mass.gram;

Unit.mass.ug = 1e-6 * Unit.mass.gram;
Unit.mass.ugs = 1e-6 * Unit.mass.gram;
Unit.mass.microgram = Unit.mass.micrograms = Unit.mass['\u03bcg'] = Unit.mass.mcg = Unit.mass.ug; // μg 

// english units
Unit.mass.lb = 0.45359237 * Unit.mass.kg;
Unit.mass.lbs = 0.45359237 * Unit.mass.kg;
Unit.mass.pound = 0.45359237 * Unit.mass.kg;
Unit.mass.pounds = 0.45359237 * Unit.mass.kg;

Unit.mass.slug = Unit.mass.slugs = 14.5939029 * Unit.mass.kg;

Unit.mass.oz = Unit.mass.lb * 0.0625;
Unit.mass.ozs = Unit.mass.lb * 0.0625;
Unit.mass.ounce = Unit.mass.lb * 0.0625;
Unit.mass.ounces = Unit.mass.lb * 0.0625;

Unit.mass["troy ounce"] = 31.1034768 * Unit.mass.gram;
Unit.mass["troy ounces"] = 31.1034768 * Unit.mass.gram;
Unit.mass["troy oz"] = 31.1034768 * Unit.mass.gram;
Unit.mass["troy ozs"] = 31.1034768 * Unit.mass.gram;

Unit.mass.dram = Unit.mass.oz * 0.0625;
Unit.mass.drams = Unit.mass.oz * 0.0625;

Unit.mass.stone = Unit.mass.lb * 14;
Unit.mass.stones = Unit.mass.lb * 14;

Unit.mass.ton = Unit.mass.lb * 2000;
Unit.mass.tons = Unit.mass.lb * 2000;
Unit.mass.shortton = Unit.mass.shorttons = Unit.mass["short ton"] = Unit.mass["short tons"] = Unit.mass.ton;
Unit.mass.longton = Unit.mass.longtons = Unit.mass["long ton"] = Unit.mass["long tons"] = 2240 * Unit.mass.lb;

Unit.mass["metric ton"] = Unit.mass["metric tons"] = Unit.mass["mt"] = 1000 * Unit.mass.kg;
Unit.mass.tonne = Unit.mass.tonnes = Unit.mass["mton"] = 1000 * Unit.mass.kg;

Unit.mass.dalton = Unit.mass.daltons = Unit.mass.Da = 1.660538921e-27 * Unit.mass.kg;

// everything in terms of meters
Unit.length.base = 1; // reference unit is meter
Unit.length.name = "length"; // reference unit is meter

Unit.length.meter = 1;
Unit.length.metre = 1;
Unit.length.meters = 1;
Unit.length.m = 1;

Unit.length.km = 1e3;
Unit.length.kms = 1e3;
Unit.length.kilometer = Unit.length.kilometre = 1e3;
Unit.length.kilometers = Unit.length.kilometres = 1e3;

Unit.length.au = 149597870.691 * Unit.length.km; // from: http://en.wikipedia.org/wiki/Astronomical_unit
Unit.length["light year"] = Unit.length["lightyear"] = Unit.length["light years"] = 9460730472580.8 * Unit.length.km;
Unit.length.ly = 9460730472580.8 * Unit.length.km;

Unit.length.parsec = Unit.length.parsecs = 3.08567758e16 * Unit.length.meter;

Unit.length.cm = 1e-2;
Unit.length.cms = 1e-2;
Unit.length.centimeter = Unit.length.centimetre = 1e-2;
Unit.length.centimeters = Unit.length.centimetres = 1e-2;

Unit.length.mm = 1e-3;
Unit.length.mms = 1e-3;
Unit.length.millimeter = Unit.length.millimetre = 1e-3;
Unit.length.millimeters = Unit.length.millimetres = 1e-3;

Unit.length.um = 1e-6; // micrometer
Unit.length['\u03bcm'] = 1e-6; // μm 
Unit.length.micrometer = 1e-6; // micrometer
Unit.length.micron = 1e-6; // micrometer
Unit.length.microns = 1e-6; // micrometer

Unit.length.nm = 1e-9;
Unit.length.nanometer = Unit.length.nanometre = 1e-9;
Unit.length.nanometers = Unit.length.nanometres = 1e-9;

Unit.length.pm = 1e-12; // picometer
Unit.length.picometer = Unit.length.picometre = 1e-12; // picometer
Unit.length.picometers = Unit.length.picometres = 1e-12; // picometer

// too easy to confuse with letter "a"
// Unit.length.a = 1e-10; // 10 A = 1 nm
Unit.length.angstrom = 1e-10;
Unit.length.angstroms = 1e-10;

// English units: see http://www.infoplease.com/ipa/A0001660.html

Unit.length.inch = 0.0254;
Unit.length.inches = 0.0254;
Unit.length["in"] = 0.0254;
Unit.length["ins"] = 0.0254;

Unit.length.mil = Unit.length.mils = 1e-3 * Unit.length.inch;

Unit.length.microinch = 1e-6 * Unit.length.inch;
Unit.length.microinches = 1e-6 * Unit.length.inch;

Unit.length.foot = Unit.length.inch * 12;
Unit.length.feet = Unit.length.inch * 12;
Unit.length.ft = Unit.length.inch * 12;

Unit.length.yard = Unit.length.foot * 3;
Unit.length.yards = Unit.length.foot * 3;
Unit.length.yd = Unit.length.foot * 3;
Unit.length.yds = Unit.length.foot * 3;

Unit.length.fathom = Unit.length.foot * 6;
Unit.length.fathoms = Unit.length.foot * 6;

Unit.length.rod = Unit.length.foot * 16.5;
Unit.length.rods = Unit.length.foot * 16.5;
Unit.length.rd = Unit.length.foot * 16.5;
Unit.length.rds = Unit.length.foot * 16.5;

Unit.length.furlong = Unit.length.foot * 660;
Unit.length.furlongs = Unit.length.foot * 660;

Unit.length.mile = Unit.length.mi = Unit.length.foot * 5280;
Unit.length.miles = Unit.length.foot * 5280;

Unit.length.league = Unit.length.mile * 3;
Unit.length.leagues = Unit.length.mile * 3;

Unit.length["nautical mile"] = Unit.length["nautical miles"] = Unit.length.foot * 6076.11549;

// area
Unit.area.base = 1;
Unit.area.name = "area";
Unit.area.acre = Unit.area.acres = Unit.area.ac = Unit.length.rod * Unit.length.rod * 160;
Unit.area.hectare = Unit.area.hectares = Unit.area.ha = Unit.length.meter * Unit.length.meter * 10000;

Unit.area.sqft = Unit.area.sft = Unit.area.sf = Unit.area.sqf = Unit.area.sqfoot = Unit.area.sqfeet = Unit.length.foot * Unit.length.foot;
Unit.area.sqin = Unit.area.sqinch = Unit.area.sqinches = Unit.length.inch * Unit.length.inch;
Unit.area.sqyd = Unit.area.sy = Unit.area.syd = Unit.area.sqyard = Unit.area.sqyards = Unit.length.yard * Unit.length.yard;
Unit.area.sqmi = Unit.area.sqmile = Unit.area.sqmiles = Unit.length.mile * Unit.length.mile;
Unit.area.sqmm = Unit.length.mm * Unit.length.mm;
Unit.area.sqcm = Unit.length.cm * Unit.length.cm;
Unit.area.sqm = Unit.length.meter * Unit.length.meter;
Unit.area.sqkm = Unit.length.km * Unit.length.km;

// speed
Unit.speed = {};
Unit.speed.base = 1;
Unit.speed.name = "speed";
Unit.speed.SI = { m: 1, s: -1 };
Unit.speed.mach = 331.46; // m/s

Unit.international_unit = {};
Unit.international_unit.base = 1;
Unit.international_unit.name = "international unit";
Unit.international_unit.SI = { iu: 1 };
Unit.international_unit.iu = Unit.international_unit["international unit"] = 1;
Unit.international_unit.miu = 1e-3;
Unit.international_unit.μIU = Unit.international_unit.µU = 1e-6;

Unit.log_ratio = {};
Unit.log_ratio.base = 1;
Unit.log_ratio.name = "power ratio";
Unit.log_ratio.SI = { bel: 1 };
Unit.log_ratio.bel = 1;
Unit.log_ratio.decibel = Unit.log_ratio.db = 0.1;
Unit.log_ratio.neper = Unit.log_ratio.np = 1 / (Math.LN10 / 2);

InstaCalc.Unit = Unit;
InstaCalc.Unit._updated = new Date().toISOString();

InstaCalc.updateUnitTimeStamp = function () {
  InstaCalc.Unit._updated = new Date().toISOString();
};

InstaCalc.getUnitTimeStamp = function () {
  return InstaCalc.Unit._updated;
};

// empty to start
InstaCalc.Unit.currencies = {};

InstaCalc.Unit.currenciesLoaded = function () {
  return Object.keys(InstaCalc.Unit.currencies).length > 0;
}
InstaCalc.loadCurrencies = function (data) {
  // already loaded
  if (InstaCalc.Unit.currenciesLoaded()) {
    return;
  }

  var currencies = {};

  /* expecting a simple hash of currency code => data pairs */
  for (var i in data) {
    var code = i.toLowerCase();
    var rate = data[i];

    // make sure it's not an existing unit: CUP is cuban peso, and... cups
    // no cache, otherwise we cache the missing lookup
    if (!InstaCalc.prototype.isUnit(code, true)) {
      currencies[code] = 1.0 / parseFloat(rate);
    }
  }

  currencies.usd = 1; // base unit

  // load aliases for our money. But want to have a cleaner representation "australia dollar" or "australia money" when it comes as "Australian Dollar [AUD]"
  currencies.dollar = currencies.dollars = currencies.usd;
  currencies.penny = currencies.pennies = currencies.cent = currencies.cents = 0.01;
  currencies.dime = currencies.dimes = 0.1;
  currencies.nickel = currencies.nickels = 0.05;
  currencies.quarter = currencies.quarters = 0.25;

  delete Unit.currency; // remove the placeholder entry once real currencies loaded

  currencies.yen = currencies.jpy;
  currencies.euro = currencies.euros = currencies.eur;
  currencies["euro cent"] = currencies["euro cents"] = currencies["eur cent"] = currencies["eur cents"] = currencies.eur / 100;

  currencies.yuan = currencies.cny;
  currencies.rupee = currencies.inr;

  currencies.peso = currencies.mxn;
  // currencies.pound = currencies.gbp;     // British Pound Sterling
  currencies.pence = currencies.gbp / 100; // British Penny

  //  currencies.real = currencies.brl;      // Brazilian Real
  currencies.ruble = currencies.rub;     // Russian Ruble
  currencies.ringgit = currencies.myr;   // Malaysian Ringgit
  currencies.peso = currencies.mxn;      // Mexican Peso
  currencies.won = currencies.krw;       // South Korean Won
  //  currencies.rand = currencies.zar;      // South African Rand
  currencies.loonie = currencies.cad;    // Canadian Dollar (commonly known as Loonie)
  currencies.aussie = currencies.aud;    // Australian Dollar (commonly known as Aussie)
  currencies.baht = currencies.thb;      // Thai Baht
  //  currencies.rial = currencies.irr;      // Iranian Rial
  currencies.dirham = currencies.aed;    // United Arab Emirates Dirham
  currencies.lira = currencies.try;      // Turkish Lira
  currencies.riyal = currencies.sar;     // Saudi Riyal
  currencies.lev = currencies.bgn;       // Bulgarian Lev
  currencies.zloty = currencies.pln;     // Polish Złoty
  currencies.krona = currencies.sek;     // Swedish Krona
  currencies.franc = currencies.chf;     // Swiss Franc

  currencies.quetzal = currencies.gtq;   // Guatemalan Quetzal
  currencies.shekel = currencies.ils;    // Israeli Shekel
  currencies.dong = currencies.vnd;     // Vietnamese Dong
  currencies.dinar = currencies.kwd;    // Kuwaiti Dinar
  currencies.kuna = currencies.hrk;      // Croatian Kuna
  currencies.birr = currencies.etb;      // Ethiopian Birr
  currencies.taka = currencies.bdt;     // Bangladeshi Taka
  currencies.forint = currencies.huf;    // Hungarian Forint
  currencies.rupiah = currencies.idr;    // Indonesian Rupiah
  currencies.kyat = currencies.mmk;      // Burmese Kyat
  currencies.naira = currencies.ngn;     // Nigerian Naira
  currencies.bolivar = currencies.vef;   // Venezuelan Bolívar


  // TODO: too easily confused with lb. Need to have better unit overlap checks
  //   currencies.pound = currencies.gbp;
  currencies.rmb = currencies.cny;

  InstaCalc.Unit.currencies = currencies;

  InstaCalc.updateUnitTimeStamp();
};

// operator afterwards, like 3!
InstaCalc.parseSuffixOperator = function (str, op, fn) {
  var split = str.indexOf(op);

  if (split < 0) {
    // not found
    return str;
  }

  var front = str.substring(0, split);
  front = InstaCalc.strtrim(front); // but there could be something right up in front... add a space as separator

  var fronttoken = InstaCalc.getLastTokenGroup(front);
  front = front.substring(0, front.length - fronttoken.length);

  // false positive on "!true"
  if (!fronttoken) {
    return str;
  }

  var back = str.substring(split + 1);

  var draft = " " + front + " " + fn + "(" + fronttoken + ")" + back; // extra parens for safety in parsing numbers

  if (draft.indexOf(op) > 0) {
    // still have another one left!
    return InstaCalc.parseSuffixOperator(draft, op, fn);
  }

  return draft;
};

// parse a binary operator - set op to fn
InstaCalc.parseBinaryOperator = function (str, op, fn) {
  var split = str.indexOf(op);

  if (split < 0) {
    // not found
    return str;
  }

  var front = str.substring(0, split);
  front = InstaCalc.strtrim(front); // but there could be something right up in front... add a space as separator

  // split character is ^
  var back = str.substring(split + 1);
  back = InstaCalc.strtrim(back);

  var fronttoken = InstaCalc.getLastTokenGroup(front);
  var backtoken = InstaCalc.getFirstTokenGroup(back);

  // remove tokens from front and back... and replace appropriately.
  front = front.substring(0, front.length - fronttoken.length);
  back = back.substring(backtoken.length);

  var draft = " " + front + " " + fn + "(" + "(" + fronttoken + "),(" + backtoken + ")) " + back; // extra parens for safety in parsing numbers - parsenumber will eat neighboring numbers like power(2,2)

  if (draft.indexOf(op) > 0) {
    // still have another one left!
    return InstaCalc.parseBinaryOperator(draft, op, fn);
  }

  return draft;
};

// remove extra whitespace from front and back
InstaCalc.strtrim = function (str) {
  str = str.replace(/^\s*/, "");
  str = str.replace(/\s*$/, "");
  return str;
};

InstaCalc.strrev = function (str) {
  var i;
  var rev = "";

  if (str == "") {
    return str;
  }

  for (i = 0; i < str.length; i++) {
    rev = str.charAt(i) + rev;
  }

  return rev;
};

// token library
InstaCalc.getFirstTokenGroup = function (str) {
  var token = "";

  if (str == "") {
    return str;
  }

  str = str.replace(/^\s*/, ""); // trim whitespace from front

  // 3 choices
  // 1: a regular variable or number: 123123, xasdasd, etc. a[0] etc. just any sequence of non-spaces
  // 2: a function: foo(...)
  // 3: beginning a paren (....)

  return InstaCalc.getToken(str);
};

// similar to above -- we are passed the END of a string and asked to pull out the last token
InstaCalc.getLastTokenGroup = function (str) {
  var token = InstaCalc.getLastToken(str);
  return token;
};

InstaCalc.getLastToken = function (str) {
  // ( ( ( ... foo ..

  var tokens;

  // ends with paren: function or parenthesis expression
  if ((tokens = str.match(/[)]$/))) {
    var parens = InstaCalc.getTokenParenRev(str);

    // get rid of the parens part
    var front = str.substring(0, str.length - parens.length); // front(...)

    var fn;
    if ((fn = front.match(/([a-zA-Z]+[a-zA-Z0-9]*)$/))) {
      // yes, was a function
      return fn[1] + parens;
    }

    return parens; // just the parens
  }

  // otherwise just a number or variable
  // only allow '-3' if at beginning of word ^, or beginning of paren
  if ((tokens = str.match(/((^|[(])\s*[\-])?[a-zA-Z0-9_,.]+$/))) {
    // may have a negative dash "-" in front
    return tokens[0];
  }

  return "";
};

// match function or variable
// assumes starts with a letter
InstaCalc.getToken = function (str) {
  // is this a function? does it have a paren?

  str = str.replace(/^\s*/, "");
  var tokens;

  // function
  if ((tokens = str.match(/^([a-zA-Z0-9_,.]+)([(].*[)])/))) {
    var fn = tokens[1];
    var params = InstaCalc.getTokenParen(tokens[2]);

    if (params == -1) {
      return "";
    }

    return fn + params;
  }

  // token starting with parens
  if ((tokens = str.match(/^[(].*/))) {
    var parens = InstaCalc.getTokenParen(str);

    return parens; // could be -1 if error
  }

  // otherwise just a number or variable
  if ((tokens = str.match(/^([\-]?[a-zA-Z0-9_,.]+)/))) {
    return tokens[1];
  }

  return ""; // error
};

// assume string starts with lparen
// returns string that matches it.
InstaCalc.getTokenParen = function (str) {
  var parens = 0;
  var i = 0;
  var length;

  if (str == "") {
    return str;
  }

  for (i = 0; i < str.length; i++) {
    if (str.charAt(i) == "(") {
      parens++;
    } else if (str.charAt(i) == ")") {
      parens--;
    }

    // note -- this actually works for "backwards" parens in a reversed string: "foo)....(" . It just dips negative.

    if (parens == 0) {
      // they are evened out
      length = i + 1;
      return str.substring(0, length);
    }
  }

  return ""; // error unmatch parens
};

InstaCalc.getTokenParenRev = function (str) {
  str = InstaCalc.strrev(str); // backwards.
  str = InstaCalc.getTokenParen(str);
  return InstaCalc.strrev(str);
};

/* Core InstaCalc Engine -- plotting, parsing, execution
 Copyright 2007 Kalid Azad
 */

// extract out the title from a string
InstaCalc.findTitle = function (str) {
  if (InstaCalc.isNull(str) || !str.match(/=/)) {
    return "";
  }

  // my title = 3434
  // if (...){my title = 34343}

  var raw = str.split(/=/)[0]; // everything before the equals
  var tmp = raw.split(/[{}()]/); // anything before
  raw = tmp[tmp.length - 1]; // take last item -- everything before one of these.

  var out = raw.match(/[^{}]*/)[0];
  var trimmed = InstaCalc.strtrim(out);
  var replaced = trimmed.replace(/_/g, " ").replace("$", ""); // r517 bugfix: global replace
  return replaced;
};

/* takes function name, returns its replacement */
InstaCalc.replacefn = function (name) {
  var replace = "";

  if (InstaCalc.allowedfn[name.toUpperCase()]) {
    replace = InstaCalc.allowedfn[name.toUpperCase()];
  } else {
    replace = InstaCalc.safeprepend + name;
    //"InstaCalc.localfunctions." + name; // allow any user-defined function for now
  }

  // prefix any banned functions with underscore?

  //if (name == "") { return true; }// just parens

  return replace; // allow nearly any function -- but prefix with localfunctions
};

InstaCalc.replacekeyword = function (name) {
  var keyword = InstaCalc.keywords[name.toUpperCase()];
  if (keyword) {
    return keyword;
  }

  return name;
};

InstaCalc.replacecn = function (name) {
  if (InstaCalc.allowedcn[name]) {
    return InstaCalc.allowedcn[name];
  }

  return "";
};

/* return true if valid constant -- must match name exactly */
InstaCalc.validcn = function (name) {
  if (name === "") {
    return false;
  }

  if (InstaCalc.allowedcn[name]) {
    return true;
  }

  return false;
};

/* return true if keyword, can be in any case */
InstaCalc.validkeyword = function (name) {
  if (name === "") {
    return false;
  }
  if (InstaCalc.keywords[name.toUpperCase()]) {
    return true;
  }
  return false;
};

/* each expression is as follows
  InstaCalc.expressions[0] = [regexp, replacement]
  return index of replacement
  */
InstaCalc.validExpression = function (word) {
  var i;
  for (i = 0; i < InstaCalc.expressions.length; i++) {
    if (word.match(InstaCalc.expressions[i][0])) {
      return i; // an matched expression
    }
  }
  return -1;
};

InstaCalc.replaceExpression = function (word) {
  var i;
  for (i = 0; i < InstaCalc.expressions.length; i++) {
    if (word.match(InstaCalc.expressions[i][0])) {
      return word.replace(InstaCalc.expressions[i][0], InstaCalc.expressions[i][1]); // an matched expression
    }
  }
  return word;
};

InstaCalc.replacevariable = function (word) {
  return InstaCalc.safeprepend + word;
};

InstaCalc.cleanVariable = function (word) {
  myregexp = new RegExp(InstaCalc.safeprepend, "g");
  return word.replace(myregexp, "");
};

// return type of token: function, constant, keyword or variable
InstaCalc.tokenType = function (token) {
  if (token.match(/[(]/)) {
    // contains a paren
    return "function";
  }

  if (InstaCalc.validcn(token)) {
    // PI
    return "constant";
  }

  if (InstaCalc.validkeyword(token)) {
    // if, else
    return "keyword";
  }

  if (InstaCalc.validExpression(token) != -1) {
    // ROW1, or ROW1:ROW3
    return "expression";
  }

  return "variable";
};

InstaCalc.findString = function (token) {
  var i;
  for (i = 0; i < token.length; i++) { }
};

// have it return true/false otherwise
InstaCalc.isOperator = function (str) {
  if (str === "") {
    return false;
  }

  var c = str[0];
};

// TODO: make parser more robust. For now, just substitute in.
InstaCalc.parser = function (str) {
  var i;

  for (i = 0; i < str.length; i++) { }
};

// the truly first filter to run - replace common expressions
InstaCalc.applyFirstFilter = function (str) {
  var i;
  for (i = 0; i < InstaCalc.firstfilter.length; i++) {
    re = InstaCalc.firstfilter[i][0];
    var replace = InstaCalc.firstfilter[i][1];

    str = str.replace(re, replace);
  }

  return str;
};

// sanitize user input - replace common expressions
InstaCalc.applyPreFilter = function (str) {
  var i;
  for (i = 0; i < InstaCalc.prefilter.length; i++) {
    re = InstaCalc.prefilter[i][0];
    var replace = InstaCalc.prefilter[i][1];

    str = str.replace(re, replace);
  }

  return str;
};

InstaCalc.customOperators = function (str) {
  str = InstaCalc.parseSuffixOperator(str, "!", "FAC"); // 3! with InstaCalc.factorial(3)
  str = InstaCalc.parseBinaryOperator(str, "^", "POWER"); // replace a^b  with power(a,b)

  // wow... try for add, subtract, etc?

  // TODO: need to parse million, billion, etc. BEFORE doing the addition parsing, etc.

  //str = parseBinaryOperator(str, "/", "DIVIDE");
  //str = parseBinaryOperator(str, "*", "MULTIPLY");
  //str = parseBinaryOperator(str, "+", "ADD");
  //str = parseBinaryOperator(str, "-", "SUBTRACT");

  return str;
};

InstaCalc.applyPostFilter = function (str) {
  var i;
  for (i = 0; i < InstaCalc.postfilter.length; i++) {
    re = InstaCalc.postfilter[i][0];
    var replace = InstaCalc.postfilter[i][1];

    str = str.replace(re, replace);
  }

  return str;
};

InstaCalc.extractStrings = function (str) {
  var i;
  var instring = false;
  var curstr = ""; // current string
  var nonstr = []; // items not in a string
  var strings = [];

  // str.match(/".*[^\\]"/) use tokens like this to grab string...
  var matches = str.match(/"([\\]"|[^"])+"/g); // make sure to ignore escape characters

  if (InstaCalc.isNull(matches)) {
    return [str, []];
  }

  for (i = 0; i < matches.length; i++) {
    var name = InstaCalc.stringprepend + i;
    var value = matches[i]; // trim off the quotes at the front and back.

    str = str.replace(value, name);
    strings.push([name, value]);
  }

  return [str, strings];
};

InstaCalc.replaceStrings = function (str, strArray) {
  var i;
  for (i = 0; i < strArray.length; i++) {
    var item = strArray[i];
    str = str.replace(item[0], item[1]);
  }

  return str;
};

// return tokens that need to be parsed
InstaCalc.tokenize = function (str) {
  return str.match(/[a-zA-Z_][a-zA-Z0-9_:]*\s*[(]*/g); // no dot
};

// escape all unicode characters, replace with _34 for character codes
InstaCalc.escapeUnicode = function (str) {
  var replace = "";

  for (var i = 0; i < str.length; i++) {
    var c = str.charAt(i);
    if (str.charCodeAt(i) > 127) {
      // not ASCII
      c = "_" + str.charCodeAt(i);
    }
    replace += c;
  }

  return replace;
};

InstaCalc.prototype.scanCurrencyFormatting = function (str) {
  var tmp = InstaCalc.format.currencies;
  for (var index in tmp) {
    var cur = tmp[index];
    if (str.match(cur.regex)) {
      str = str.replace(cur.regex, "");

      this.format.currency = true;
      this.format.currencySymbol = cur.symbol;
      this.format.decimals = cur.decimals;
    }
  }

  return str;
};

/* ***************************
Sanitize user input.
   1) replace functions with appropriate calls; SIN() -> Math.sin()
   2) replace constants (PI -> Math.PI) and keywords
   3) make variables safe. Put them in the InstaCalc.locals namespace
   ******************************/

InstaCalc.prototype.cleanup = function (str) {
  if (str == null || !InstaCalc.isdefined(str) || str === "") {
    return str;
  }

  // run the preparser on all tokens
  str = this.scanCurrencyFormatting(str); // get rid of formatting stuff EARLY
  str = InstaCalc.applyFirstFilter(str); // the very first filter to run

  // trim the string --> avoid bad regexes in the later stages
  str = InstaCalc.strtrim(str);

  // extract string tokens - no processing on them
  var ret = InstaCalc.extractStrings(str);
  str = ret[0];
  var strings = ret[1]; // string replacements

  str = InstaCalc.escapeUnicode(str); // replace unicode variable names
  str = InstaCalc.replaceVariableNames(str); // before the custom operators --> otherwise net sales^2 won't work

  // str = replaceOperatorShortcuts(str); // ignore for now. watch out for things like 400m where we mean 400 million
  str = InstaCalc.customOperators(str); // needs to go above prefilter - otherwise bin(3^5) will fail.
  str = InstaCalc.applyPreFilter(str); // CHANGING for now. seems like quotes handled properly by parsing, etc.

  // won't parse properly because of quotes introduced.

  // letter or underscore followed by letters... spaces... then opening paren
  var tokens = InstaCalc.tokenize(str);

  if (InstaCalc.isNull(tokens)) {
    // nothing to parse
    return str;
  }

  var token, type, replace, re;

  for (var i = 0; i < tokens.length; i++) {
    token = tokens[i];
    // clean off any leading/trailing whitespace
    token = token.match(/\S+/)[0];
    // log("INFO: Token: " + token);

    type = InstaCalc.tokenType(token);

    if (type == "function") {
      var fnname = token.match(/\w+/)[0]; // remove the opening paren and whitespace. TODO: should be (a-zA-Z0-9) for generality?
      replace = InstaCalc.replacefn(fnname); // replacement text

      re = new RegExp("([^.\\w]|^)" + fnname + "\\s*[(]", "g"); // function preceded by non-dot, non-word character ("a"sin). BUGFIX.

      //log("INFO: str before: " + str);
      str = str.replace(re, "$1" + replace + "(");
      //log("INFO: str after: " + str);
      continue;
    }

    // constant like PI
    if (type == "constant") {
      var constant = token.match(/\w+/)[0]; // remove the any whitespace
      re = new RegExp("([^.]|^)" + constant + "\\b", "");
      str = str.replace(re, "$1" + InstaCalc.replacecn(constant));
      continue;
    }

    if (type == "keyword") {
      // keep keywords as-is
      var keyword = token.match(/\w+/)[0];
      re = new RegExp("(\\s|^)" + keyword + "\\b", ""); // important -- want it to be separated from other items
      str = str.replace(re, " " + InstaCalc.replacekeyword(keyword));
      continue;
    }

    if (type == "expression") {
      // ROW1, or ROW1:ROW3
      var expression = InstaCalc.replaceExpression(token);
      re = new RegExp("\\b" + token + "\\b", ""); // only replace once
      str = str.replace(re, expression);

      continue;
    }

    // default type: is a variable
    var newtoken = InstaCalc.safeprepend + token.toLowerCase(); // make case-insensitive variables

    // wrap variable in parens - DOES NOT work because of left-hand-side assignment
    re = new RegExp("\\b" + token + "\\b", "g"); // change to replace all instances of token /// but then gets instances where token shares name with function.

    str = str.replace(re, newtoken);
  }

  str = InstaCalc.applyPostFilter(str);
  str = InstaCalc.replaceStrings(str, strings);

  return str;
};

// group similar variable names together
InstaCalc.replaceVariableNames = function (str) {
  // net proft => net_profit
  //([^0-9]+[\w_]+)\s+([^0-9]+[\w_]+)

  // replace expressions
  str = InstaCalc.replaceExpression(str);

  // bugfix: had [\w]+ which was ignoring 1-letter variables
  while (str.match(/\b([a-zA-Z_][\w]*)\s+([a-zA-Z_][\w]*)/)) {
    str = str.replace(/\b([a-zA-Z_][\w]*)\s+([a-zA-Z_][\w]*)/, "$1_$2");
  }

  return str;
};

// 3x => 3*x,  3(a+b) => 3 * (a+b) etc.
// watch out for 1e3 => 1 * e3 (variable name)
InstaCalc.replaceOperatorShortcuts = function (str) {
  // multiplication
  while (str.match(/\b([0-9.]+)([\(a-zA-Z])/)) {
    str = str.replace(/\b(\d+)([\(a-zA-Z])/, "$1 * $2");
  }

  return str;
};

// check whether string is a comment and should be ignored
InstaCalc.iscomment = function (str) {
  // check if matches  "//"
  if (str.match(/[\/][\/]/)) {
    return true;
  } else {
    return false;
  }
};

// returns two items; the non-comment and the commented part of the string
InstaCalc.extractComment = function (str) {
  // extract out all comments, till end of line

  var a = str.match(/([\/][\/].*)/);
  var newstring;

  // IE sucks... there are errors in how it is doing the splitting
  if (!InstaCalc.isNull(a)) {
    newstring = str.split(/[\/][\/]+/)[0]; // grab the first part

    if (!InstaCalc.isNull(newstring) && InstaCalc.isdefined(newstring)) {
    } else {
      newstring = "";
    }

    //setStatus("newstring: " + newstring + "comment" + a[1]);
    // remove leading slashes
    var comment = str.match("[/][/](.*)")[1];

    return [newstring, comment];
  }

  return [str, ""];
  //return a; // a[0] is string to eval, a[1] is the comment
};

InstaCalc.prototype.reset_globals = function () {
  this.format.currency = false; // by default do not format as currency
  InstaCalc.unitlabel = ""; // clear unit label
};

// return empty calculation object
InstaCalc.blank_calc_object = function () {
  var ret = {};
  ret.comment = ""; // comment, if any
  ret.title = ""; // title for cell when hidden (if any)
  ret.input = ""; // input to evaluate
  ret.row = ""; // no row
  ret.parsed = ""; // parsed string, after cleanup ("3^2" => POWER(3,2))
  ret.eval_result = ""; // clear out previous value
  ret.final_result = ""; // result to show in output area
  return ret;
};

/* run cleanup() on the input string */
InstaCalc.prototype.parseCalculationObject = function (obj) {
  var i = obj.row;
  var user_input = obj.input;

  /* Transform string into text to execute. Load results from cache. */
  if (this.inputCache[i] != null && this.inputCache[i][0] == user_input) {
    // cache hit
    //log("INFO: hit cache: " + inputstr);
    obj.parsed = this.inputCache[i][1];

    // set formatting settings
    this.format.currency = this.outputCache.format[i].currency;
    this.format.currencySymbol = this.outputCache.format[i].currencySymbol;
    this.format.decimals = this.outputCache.format[i].decimals;
  } else {
    //log("INFO: missed cache: " + inputstr);
    obj.parsed = this.cleanup(user_input); // parse input, sanitize variables

    this.inputCache[i] = [user_input, obj.parsed];

    this.outputCache.format[i] = {}; // pull this out? should just create object normally.
    this.outputCache.format[i].currency = this.format.currency;
    this.outputCache.format[i].currencySymbol = this.format.currencySymbol;
    this.outputCache.format[i].decimals = this.format.decimals;
  }
};

// object has a "parsed" field which is to be evaluated
InstaCalc.prototype.evaluateCalculationObject = function (obj, settings) {
  function undefinedCount() {
    return Object.keys(InstaCalc.locals).filter(function (i) {
      return InstaCalc.locals[i] == undefined;
    }).length;
  }

  // BUGFIX - assigning local to undefined doesn't throw an error. Keep track of # of undefined variables;
  var undefined_start = undefinedCount();

  var ret = this.evaluateCalculation(obj.parsed);
  obj.eval_result = ret.eval_result; // get raw result

  var ret2 = this.cleanupEvalResult(ret.eval_result, settings); // clean it up
  obj.final_result = ret2.final_result;

  var undefined_end = undefinedCount();

  // if the count changed, we should redo the calculation
  if (undefined_start !== undefined_end) {
    obj.error = new ReferenceError();
    obj.status = "Undefined variable in row " + (obj.row + 1);
  }

  if (ret.error) {
    obj.error = ret.error;

    if (ret.error instanceof ReferenceError) {
      obj.status = "Waiting to define variable in row " + (obj.row + 1) + "...";
    } else {
      // some other type of error
      obj.status = "Waiting on row " + (obj.row + 1) + "...";
    }
  }

  if (ret2.error) {
    obj.error = ret2.error;
    obj.status = obj.status = "Waiting on row " + (obj.row + 1) + "...";
  }

  return obj;
};

// convert eval_result to a sanitized string
InstaCalc.prototype.cleanupEvalResult = function (eval_result, settings) {
  // console.log("input eval_result" + eval_result);

  var ret = {};
  ret.final_result = "";

  if (eval_result == "NaN" || eval_result == "undefined") {
    eval_result = ""; // variable not recognized
    ret.error = "undefined";
  }

  if (typeof eval_result == "function") {
    // we defined a function -- hide this
    eval_result = "";
  }

  // format number //  && (InstaCalc.settings.round == true)
  if (typeof eval_result == "number") {
    if (eval_result == Infinity) {
      eval_result = "Infinity";
    } else if (eval_result == -Infinity) {
      eval_result = "-Infinity";
    } else if (isNaN(eval_result)) {
      // only way to check - can't do ==
      eval_result = "Number undefined";
      ret.error = true; // my_undefined_var + 34 ... leads to isNaN on the number
    } else {
      eval_result = this.formatNumber(eval_result, settings);
      if (eval_result == Infinity) {
        eval_result = "Infinity";
      }
    }
  }

  if (typeof eval_result == "boolean") {
    // true or false
    eval_result = eval_result.toString();
  }

  // only comment string
  if (!eval_result) {
    eval_result = "";
  }

  // console.log("final eval_result" + eval_result);
  ret.final_result = eval_result;
  return ret;
};

// evaluates calculation, returns object
InstaCalc.prototype.evaluateCalculation = function (str) {
  var ret = {};
  ret.eval_result = "";

  if (!InstaCalc.isNull(str)) {
    try {
      ret.eval_result = eval(str);
    } catch (e) {
      ret.error = e;
      ret.eval_result = "";
    }
  }

  return ret;
};

// should we retry the calculation? references to other cells / undefined variables?
InstaCalc.prototype.shouldRedoCalculation = function (obj) {
  if (InstaCalc.isNull(obj)) {
    return false;
  }

  if (obj["error"] || typeof obj["eval_result"] === "undefined") {
    // has an error -- try again after vars defined
    return true;
  }

  if (obj["parsed"].match("getRowValue[(]")) {
    // references another cell
    return true;
  }

  if (obj["parsed"].match("getRowValues[(]")) {
    // references a row range
    return true;
  }

  return false;
};

InstaCalc.cache_count = 0;
InstaCalc.cache_max = 10000;
InstaCalc.cache = [];
InstaCalc.cache_hits = 0;
InstaCalc.cache_misses = 0;

InstaCalc.get_cache = function (key) {
  if (InstaCalc.cache[key]) {
    InstaCalc.cache_hits += 1;
    return InstaCalc.cache[key];
  }

  InstaCalc.cache_misses += 1;
  return false;
};

InstaCalc.clear_cache = function () {
  InstaCalc.cache = [];
  InstaCalc.cache_count = 0;
  // keep stats around for perf checking
};

InstaCalc.set_cache = function (key, value) {
  if (InstaCalc.cache_count > InstaCalc.cache_max) {
    InstaCalc.clear_cache();
  }

  InstaCalc.cache[key] = value;
  InstaCalc.cache_count += 1;

  return value;
};

// parse numeric string
InstaCalc.prototype.parseNumber = function (n) {
  // lookup this number if already there
  var cached = InstaCalc.get_cache(n);
  if (cached) {
    return cached;
  }

  if (n == Infinity || n == -Infinity) {
    return n;
  }

  var parsed = null;

  if (n.match(/^0x[0-9a-f]+/i)) {
    // parse hex numbers
    parsed = parseInt(n, 16);
  }

  if ((matches = n.toString().match(/^0b([01]+)/i))) {
    // parse binary numbers
    parsed = parseInt(matches[1], 2);
  }

  if ((matches = n.toString().match(/^0o([01234567]+)/i))) {
    // parse octal
    parsed = parseInt(matches[1], 8);
  }

  // base 10 by default
  if (!parsed) {
    // TODO: extract out this number cleanup
    var cleaned_up = n.replace(/[,]/g, "");
    parsed = parseFloat(cleaned_up);
    if (isNaN(parsed)) {
      // no processing was done, return original
      return n;
    }
  }

  var num = new NumberFormat();
  num.setInputDecimal(".");
  num.setNumber(parsed); // obj.value is '123,456,789.00001'
  num.setPlaces("-1", false);
  //num.setPlaces('10', false);
  num.setCurrencyValue("$");
  num.setCurrency(false);
  num.setCurrencyPosition(num.LEFT_OUTSIDE);
  num.setNegativeFormat(num.LEFT_DASH);
  num.setNegativeRed(false);
  num.setSeparators(false, ",", ",");
  var str = parseFloat(num.toFormatted());

  InstaCalc.set_cache(n, str);

  return str;
};

// global num to use

InstaCalc.prototype.createNumberFormat = function () {
  var num = new NumberFormat();
  num.setInputDecimal(".");

  //num.setCurrency(false);
  num.setCurrency(this.format.currency);
  num.setCurrencyPosition(num.LEFT_OUTSIDE);
  num.setNegativeFormat(num.LEFT_DASH);
  num.setNegativeRed(false);
  num.setSeparators(true, ",", ",");

  this.settings.numberFormat = {};
  this.settings.numberFormat.precisionLimitUpper = 1e15;
  this.settings.numberFormat.precisionLimitLower = 1e-11;
  this.settings.numberFormat.roundingLimit = 1e9;
  this.settings.numberFormat.precisionDefault = 15;
  this.settings.numberFormat.precisionExponential = 10;
  this.settings.numberFormat.fixedDefault = 11;

  this.num = num;
};

/* return number as formatted string */
InstaCalc.prototype.formatNumber = function (n, settings) {
  var str = n.toString();

  // if number is huge, just return.
  if (n >= this.settings.numberFormat.precisionLimitUpper) {
    // limit of precision
    return n.toPrecision(10).replace("e+", "e"); // turns to exponential, then remove extra quotes
    //return n.toExponential().toString().replace("e+", "e"); // but can't have e+... need just e
  }

  if (InstaCalc.unitlabel != "") {
    // this is a unit... no rounding else destroys precision
    if (n <= this.settings.numberFormat.precisionLimitLower) {
      return n.toString();
    }
  }

  n = parseFloat(n.toPrecision(this.settings.numberFormat.precisionDefault));

  if (this.format.currency) {
    n = n.toFixed(this.format.decimals);
  } else {
    n = n.toFixed(this.settings.numberFormat.fixedDefault); // round to 11 places; avoid bugs like 1.0 - 0.9 - 0.1
  }

  // no extra precision if a whole number
  //num.setPlaces('6', false);
  // do not round off

  // InstaCalc.settings.round === true
  if (n >= this.settings.numberFormat.roundingLimit) {
    // bug; 39.37B became 39,369,999,999.9996
    n = parseFloat(n).toPrecision(this.settings.numberFormat.precisionDefault); // was 16?
  } else {
    this.num.setPlaces("-1", false);
  }

  this.num.setPlaces("-1", false);

  if (this.format.currency) {
    this.num.setPlaces(this.format.decimals); // to fixed number of places;
    this.num.setCurrencyValue(this.format.currencySymbol);
  }

  // passed-in setting overrides all
  if (settings.rounding >= 0) {
    this.num.setPlaces(settings.rounding);
  }

  this.num.setNumber(n);

  // set number of places dynamically based on length of decimal?
  // TODO: Go through and do experiments with precision.
  //num.setPlaces('10', false);

  return this.num.toFormatted();
};

InstaCalc.prototype.getRowValue = function (i) {
  if (this.current_row == i) {
    return undefined;
  }

  return this.outputCache[i] ? this.parseNumber(this.outputCache[i]) : 0;
};

/* returns array of values from row "start" to row "end"
 uses real ROW LABELS; not the cell reference. Starts at "1"
 returns [[1,row1], [2,row2]... ]
 */
InstaCalc.prototype.getRowValues = function (start, end) {
  if (typeof start == "string") {
    start = parseInt(start, 10);
  }
  if (typeof end == "string") {
    end = parseInt(end, 10);
  }

  if (end < start) {
    return [];
  }
  if (start < 1 || end > this.cells) {
    return [];
  }

  var a = [];
  var t = [];

  for (row = start; row <= end; row++) {
    var cell = row - 1;
    var title = "Row " + row;
    var val;

    try {
      val = this.getRowValue(cell);

      // TODO: when we have charts, the title can be extracted from the row
      // title = this.getTitleText(cell);
    } catch (e) {
      val = 0;
      title = "Row " + row;
    }
    if (typeof val === "undefined") {
      val = 0;
      title = "Row " + row;
    }

    if (typeof val != "number") {
      val = this.parseNumber(val);
    }

    if (title === "") {
      title = "Row " + row;
    }

    a.push([row, val]);
    t.push([title, val]);
  }

  this.datatitles = t;
  this.data = a;

  return a;
};

InstaCalc.prototype.instacalc_compute = function (inputs, settings) {
  var outputs = new Array(inputs.length);
  this.cells = inputs.length;

  settings = settings || {};

  // ugly to have this here. but reset everything between computes.
  // clear output cache for everything...
  for (var i = 0; i < this.outputCache.length; i++) {
    this.outputCache[i] = 0;
  }

  InstaCalc.resetLocals();

  var calc = this;
  var redos = [];

  function compute(i) {
    calc.reset_globals();
    var ret = InstaCalc.blank_calc_object();
    ret.input = inputs[i]; // input to evaluate
    ret.row = i;

    calc.current_row = i; // for functions that need to row the row

    /* parse comments */
    var a = InstaCalc.extractComment(ret.input);
    ret.input = a[0]; // first result
    ret.comment = a[1].toString(); // BUGFIX: do not display comments directly - escapeHTML before display

    /* parse row title */
    ret.title = InstaCalc.findTitle(ret.input);

    calc.parseCalculationObject(ret); // do cleanup
    calc.evaluateCalculationObject(ret, settings); // do eval; errors are set here. sets final_result

    redos[i] = calc.shouldRedoCalculation(ret);

    /* Add labels for units -- determined after units have been evaluated */
    if (InstaCalc.unitlabel) {
      // has a unit label
      ret.comment = InstaCalc.unitlabel + ret.comment;
    }

    calc.outputCache[i] = ret.final_result; // cache the output value;
    ret.result = ret.final_result;

    return ret;
  }

  for (var i = 0; i < inputs.length; i++) {
    outputs[i] = compute(i);
  }

  var passes = redos.filter(function (redo) {
    return redo == true;
  }).length;
  var lines_to_redo = redos.slice(0);

  // TODO: Yes, ugly O(N^2) algo to resolve dependencies... OK for small amounts of broken refs
  for (var i = 0; i < passes; i++) {
    // resolve dependencies from bottom
    for (var j = redos.length - 1; j >= 0; j--) {
      if (redos[j]) {
        // compute sets the redo array as needed
        outputs[j] = compute(j);
      }
    }
  }
  return outputs;
};

/*********************************************
Math Constants and Functions
*********************************************/

var Unit = InstaCalc.Unit;

InstaCalc.prototype.cn = {}; // constants
InstaCalc.prototype.cn.PHI = (1 + Math.sqrt(5)) / 2;
InstaCalc.prototype.cn.MOL = 6.0221415e23;

/* container object for the instacalc functions; keep in a separate namespace */

var fn = { base: null }; // base object with format settings, etc.
function functionContainer(base) {
  fn.base = base;
  return fn;
}

// when accessing the methods, use this.fn().sin because we need to set the reference to the base
InstaCalc.prototype.fn = function () {
  this.fn.base = this.fn.base || this;
  return this.fn;
};
InstaCalc.prototype.fn.base = null;

InstaCalc.prototype.fn.tolerance = 1e-14;  // tolerance level for considering a value as zero or one

InstaCalc.prototype.fn.toleranceCheck = function (result) {
  if (Math.abs(result) < this.tolerance) return 0;
  // if result is close to one or negative one, round it
  if (Math.abs(1 - Math.abs(result)) < this.tolerance) return Math.round(result);

  return result;
}

// converts deg to radians
InstaCalc.prototype.fn.deg2rad = function (deg) {
  return (deg * Math.PI) / 180.0;
};

InstaCalc.prototype.fn.rad2deg = function (rad) {
  return (rad * 180.0) / Math.PI;
};

// convert n to radians if needed
InstaCalc.prototype.fn.autoRad = function (n) {
  return (this.base.format.angle == "rad") ? n : this.deg2rad(n);
};

InstaCalc.prototype.fn.sin = function (n) {
  if (Complex.isComplex(n)) return Complex.sin(n);

  let rad = this.autoRad(n);
  return this.toleranceCheck(Math.sin(rad));
};

InstaCalc.prototype.fn.cos = function (n) {
  if (Complex.isComplex(n)) return Complex.cos(n);

  let rad = this.autoRad(n);
  return this.toleranceCheck(Math.cos(rad));
};

InstaCalc.prototype.fn.tan = function (n) {
  if (Complex.isComplex(n)) return Complex.tan(n);

  let rad = this.autoRad(n);
  return this.toleranceCheck(Math.tan(rad));
};

InstaCalc.prototype.fn.cot = function (n) {
  if (Complex.isComplex(n)) return Complex.cot(n);

  return 1 / this.tan(n);
};

InstaCalc.prototype.fn.sec = function (n) {
  if (Complex.isComplex(n)) return Complex.sec(n);
  return 1 / this.cos(n);
};

InstaCalc.prototype.fn.csc = function (n) {
  if (Complex.isComplex(n)) return Complex.csc(n);
  return 1 / this.sin(n);
};

// return result in degrees
InstaCalc.prototype.fn.asin = function (n) {
  if (Complex.isComplex(n) || typeof n === "number" && Math.abs(n) > 1) return Complex.asin(n);
  return this.rad2deg(Math.asin(n));
};

InstaCalc.prototype.fn.acos = function (n) {
  if (Complex.isComplex(n) || typeof n === "number" && Math.abs(n) > 1) return Complex.acos(n);
  return this.rad2deg(Math.acos(n));
};

InstaCalc.prototype.fn.atan = function (n) {
  if (Complex.isComplex(n)) return Complex.atan(n);
  return this.rad2deg(Math.atan(n));
};

InstaCalc.prototype.fn.atan2 = function (y, x) {
  if (Complex.anyIsComplex(y, x)) return Complex.atan2(y, x);
  return this.rad2deg(Math.atan2(y, x));
};

InstaCalc.prototype.fn.asec = function (n) {
  if (Complex.isComplex(n)) return Complex.asec(n);
  return this.rad2deg(Math.acos(1 / n));
};

InstaCalc.prototype.fn.acsc = function (n) {
  if (Complex.isComplex(n)) return Complex.acsc(n);
  return this.rad2deg(Math.asin(1 / n));
};

InstaCalc.prototype.fn.acot = function (n) {
  if (Complex.isComplex(n)) return Complex.acot(n);
  return this.rad2deg(Math.atan(1 / n));
};

// hyperbolic functions - http://www.sosmath.com/trig/hyper/hyper01/hyper01.html
// Polyfill for IE
Math.sinh =
  Math.sinh ||
  function (x) {
    return (Math.exp(x) - Math.exp(-x)) / 2;
  };

Math.cosh =
  Math.cosh ||
  function (x) {
    return (Math.exp(x) + Math.exp(-x)) / 2;
  };

Math.tanh =
  Math.tanh ||
  function (x) {
    var a = Math.exp(+x),
      b = Math.exp(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (a + b);
  };

Math.asinh =
  Math.asinh ||
  function (x) {
    if (x === -Infinity) {
      return x;
    } else {
      return Math.log(x + Math.sqrt(x * x + 1));
    }
  };

Math.acosh =
  Math.acosh ||
  function (x) {
    return Math.log(x + Math.sqrt(x * x - 1));
  };

Math.atanh =
  Math.atanh ||
  function (x) {
    return Math.log((1 + x) / (1 - x)) / 2;
  };

InstaCalc.prototype.fn.sinh = function (n) {
  return Complex.sinh(n);
  //  return Math.sinh(n);
};

InstaCalc.prototype.fn.cosh = function (n) {
  return Complex.cosh(n);
  //  return Math.cosh(n);
};

InstaCalc.prototype.fn.tanh = function (n) {
  return Complex.tanh(n);
  //  return Math.tanh(n);
};

InstaCalc.prototype.fn.coth = function (n) {
  return Complex.coth(n);
  //  return 1 / this.tanh(n);
};

InstaCalc.prototype.fn.sech = function (n) {
  return Complex.sech(n);
  //  return 1 / this.cosh(n);
};

InstaCalc.prototype.fn.csch = function (n) {
  return Complex.csch(n);
  //  return 1 / this.sinh(n);
};

InstaCalc.prototype.fn.asinh = function (n) {
  return Complex.asinh(n);
  //  return Math.asinh(n);
};

// 2 log (sqrt((x+1)/2) + sqrt((x-1)/2))
InstaCalc.prototype.fn.acosh = function (n) {
  return Complex.acosh(n);
  //  return Math.acosh(n);
};

// (log (1+x) - log (1-x))/2
InstaCalc.prototype.fn.atanh = function (n) {
  return Complex.atanh(n);
  //  return Math.atanh(n);
};

InstaCalc.prototype.fn.asech = function (n) {
  return Complex.asech(n);
  //  return Math.acosh(1 / n);
};

InstaCalc.prototype.fn.acsch = function (n) {
  return Complex.acsch(n);
  //  return Math.asinh(1 / n);
};

InstaCalc.prototype.fn.acoth = function (n) {
  return Complex.acoth(n);
  //  return Math.atanh(1 / n);
};

/* Binet's formula: see http://en.wikipedia.org/wiki/Fibonacci_number */
InstaCalc.prototype.fn.fibonacci = function (n) {
  var t = (Math.pow(this.base.cn.PHI, n) - Math.pow(1 - this.base.cn.PHI, n)) / Math.sqrt(5);
  return Math.round(t);
};

InstaCalc.prototype.fn.factorial = function (n) {
  if (!InstaCalc.isdefined(n)) {
    return;
  }
  if (n < 0) {
    return "undefined";
  }
  if (n === 0 || n == 1) {
    return 1;
  }
  if (n > 170) {
    return "Way too big!";
  }

  var i = 1;
  n = Math.ceil(n); // round up
  while (n > 1) {
    i *= n;
    n--;
  }
  return i;
};

// stats helper functions

InstaCalc.prototype.fn.beta = function (a, b) {
  return this.gamma(a) * this.gamma(b) / this.gamma(a + b);
};

InstaCalc.prototype.fn.regularizedIncompleteBeta = function (x, a, b) {
  if (x < 0 || x > 1) return NaN;
  const bt = (x === 0 || x === 1) ? 0 :
    Math.exp(Math.log(x) * a + Math.log(1 - x) * b - Math.log(this.beta(a, b)));
  if (x < (a + 1) / (a + b + 2)) {
    return bt * this.betaCF(x, a, b) / a;
  } else {
    return 1 - bt * this.betaCF(1 - x, b, a) / b;
  }
};

InstaCalc.prototype.fn.incompleteBetaInverse = function (p, a, b) {
  var EPS = 1e-8;
  var a1 = a - 1;
  var b1 = b - 1;
  var j = 0;
  var lna, lnb, pp, t, u, err, x, al, h, w, afac;
  if (p <= 0)
    return 0;
  if (p >= 1)
    return 1;
  if (a >= 1 && b >= 1) {
    pp = (p < 0.5) ? p : 1 - p;
    t = Math.sqrt(-2 * Math.log(pp));
    x = (2.30753 + t * 0.27061) / (1 + t * (0.99229 + t * 0.04481)) - t;
    if (p < 0.5)
      x = -x;
    al = (x * x - 3) / 6;
    h = 2 / (1 / (2 * a - 1) + 1 / (2 * b - 1));
    w = (x * Math.sqrt(al + h) / h) - (1 / (2 * b - 1) - 1 / (2 * a - 1)) *
      (al + 5 / 6 - 2 / (3 * h));
    x = a / (a + b * Math.exp(2 * w));
  } else {
    lna = Math.log(a / (a + b));
    lnb = Math.log(b / (a + b));
    t = Math.exp(a * lna) / a;
    u = Math.exp(b * lnb) / b;
    w = t + u;
    if (p < t / w)
      x = Math.pow(a * w * p, 1 / a);
    else
      x = 1 - Math.pow(b * w * (1 - p), 1 / b);
  }
  afac = -this.logGamma(a) - this.logGamma(b) + this.logGamma(a + b);
  for (; j < 10; j++) {
    if (x === 0 || x === 1)
      return x;
    err = this.incompleteBeta(x, a, b) - p;
    t = Math.exp(a1 * Math.log(x) + b1 * Math.log(1 - x) + afac);
    u = err / t;
    x -= (t = u / (1 - 0.5 * Math.min(1, u * (a1 / x - b1 / (1 - x)))));
    if (x <= 0)
      x = 0.5 * (x + t);
    if (x >= 1)
      x = 0.5 * (x + t + 1);
    if (Math.abs(t) < EPS * x && j > 0)
      break;
  }
  return x;
};

// beta continued fraction
InstaCalc.prototype.fn.betaCF = function (x, a, b) {
  if (x < 0 || x > 1 || a <= 0 || b <= 0) {
    throw new Error("Invalid input parameters for betaCF");
  }

  const MAX_ITERATIONS = 200;
  const EPSILON = 1e-8;
  let qab = a + b;
  let qap = a + 1;
  let qam = a - 1;
  let c = 1;
  let d = 1 - qab * x / qap;
  if (Math.abs(d) < EPSILON) d = EPSILON;
  d = 1 / d;
  let h = d;
  for (let m = 1; m <= MAX_ITERATIONS; m++) {
    let m2 = 2 * m;
    let aa = m * (b - m) * x / ((qam + m2) * (a + m2));
    d = 1 + aa * d;
    if (Math.abs(d) < EPSILON) d = EPSILON;
    c = 1 + aa / c;
    if (Math.abs(c) < EPSILON) c = EPSILON;
    d = 1 / d;
    h *= d * c;
    aa = -(a + m) * (qab + m) * x / ((a + m2) * (qap + m2));
    d = 1 + aa * d;
    if (Math.abs(d) < EPSILON) d = EPSILON;
    c = 1 + aa / c;
    if (Math.abs(c) < EPSILON) c = EPSILON;
    d = 1 / d;
    let del = d * c;
    h *= del;
    if (Math.abs(del - 1.0) < EPSILON) break;
  }
  return h;
};

InstaCalc.prototype.fn.gamma = function (z) {
  if (!InstaCalc.isdefined(z)) {
    return;
  }

  // For positive integers, gamma(n) = (n-1)!
  if (Number.isInteger(z) && z > 0) {
    return this.factorial(z - 1);
  }

  if (z < 0.5) {
    return Math.PI / (Math.sin(Math.PI * z) * this.gamma(1 - z));
  }

  z -= 1;

  var g = 5.0;  // Using g = 5 for Lanczos approximation
  var p = [
    1.000000000190015,
    76.18009172947146,
    -86.50532032941677,
    24.01409824083091,
    -1.231739572450155,
    1.208650973866179e-3,
    -5.395239384953e-6
  ];

  var x = z + g + 0.5;
  var sum = p[0];

  for (var i = 1; i < p.length; i++) {
    sum += p[i] / (z + i);
  }

  var approx = Math.sqrt(2 * Math.PI) * Math.pow(x, z + 0.5) * Math.exp(-x) * sum;

  return approx;
};

InstaCalc.prototype.fn.gammapInv = function (p, a) {
  var j = 0;
  var a1 = a - 1;
  var EPS = 1e-8;
  var gln = this.logGamma(a);
  var x, err, t, u, pp, lna1, afac;

  if (p >= 1)
    return Math.max(100, a + 100 * Math.sqrt(a));
  if (p <= 0)
    return 0;
  if (a > 1) {
    lna1 = Math.log(a1);
    afac = Math.exp(a1 * (lna1 - 1) - gln);
    pp = (p < 0.5) ? p : 1 - p;
    t = Math.sqrt(-2 * Math.log(pp));
    x = (2.30753 + t * 0.27061) / (1 + t * (0.99229 + t * 0.04481)) - t;
    if (p < 0.5)
      x = -x;
    x = Math.max(1e-3,
      a * Math.pow(1 - 1 / (9 * a) - x / (3 * Math.sqrt(a)), 3));
  } else {
    t = 1 - a * (0.253 + a * 0.12);
    if (p < t)
      x = Math.pow(p / t, 1 / a);
    else
      x = 1 - Math.log(1 - (p - t) / (1 - t));
  }

  for (; j < 12; j++) {
    if (x <= 0)
      return 0;
    err = this.gammaLowerRegularized(a, x) - p;
    if (a > 1)
      t = afac * Math.exp(-(x - a1) + a1 * (Math.log(x) - lna1));
    else
      t = Math.exp(-x + a1 * Math.log(x) - gln);
    u = err / t;
    x -= (t = u / (1 - 0.5 * Math.min(1, u * ((a - 1) / x - 1))));
    if (x <= 0)
      x = 0.5 * (x + t);
    if (Math.abs(t) < EPS * x)
      break;
  }

  return x;
};

InstaCalc.prototype.fn.logGamma = function (x) {
  if (x <= 0) {
    return Infinity;
  }

  const c = [
    76.18009172947146,
    -86.50532032941677,
    24.01409824083091,
    -1.231739572450155,
    0.1208650973866179e-2,
    -0.5395239384953e-5
  ];

  let sum = 1.000000000190015;
  let y = x;
  const z = y + 5.5;

  for (let i = 0; i < 6; i++) {
    y += 1;
    sum += c[i] / y;
  }

  return Math.log(2.5066282746310005 * sum / x) + (x + 0.5) * Math.log(z) - z;
};

InstaCalc.prototype.fn.gammaLowerRegularized = function (a, x) {
  if (x <= 0) {
    return 0;
  }
  if (x >= a + 1) {
    return 1 - this.gammaUpperRegularized(a, x);
  }

  const maxIterations = 1000;
  const epsilon = 1e-15;

  let sum = 1 / a;
  let term = sum;
  for (let n = 1; n < maxIterations; n++) {
    term *= x / (a + n);
    sum += term;
    if (Math.abs(term) < Math.abs(sum) * epsilon) {
      break;
    }
  }

  return Math.exp(a * Math.log(x) - x - this.logGamma(a)) * sum;
};

InstaCalc.prototype.fn.gammaLowerIncomplete = function (s, x) {
  if (x <= 0 || s <= 0) return 0;
  const epsilon = 1e-10;
  const maxIterations = 1000;
  let sum = 0;
  let term = 1 / s;
  let n = 1;

  while (Math.abs(term) > epsilon && n < maxIterations) {
    sum += term;
    term *= x / (s + n);
    n++;
  }

  return Math.pow(x, s) * Math.exp(-x) * sum;
};

InstaCalc.prototype.fn.gammaUpperRegularized = function (a, x) {
  if (x <= 0) {
    return 1;
  }
  if (x < a + 1) {
    return 1 - this.gammaLowerRegularized(a, x);
  }

  const maxIterations = 1000;
  const epsilon = 1e-15;

  let b = x + 1 - a;
  let c = 1 / 1e-30;
  let d = 1 / b;
  let h = d;

  for (let i = 1; i <= maxIterations; i++) {
    const an = -i * (i - a);
    b += 2;
    d = an * d + b;
    if (Math.abs(d) < 1e-30) {
      d = 1e-30;
    }
    c = b + an / c;
    if (Math.abs(c) < 1e-30) {
      c = 1e-30;
    }
    d = 1 / d;
    const delta = d * c;
    h *= delta;
    if (Math.abs(delta - 1) < epsilon) {
      break;
    }
  }

  return Math.exp(a * Math.log(x) - x - this.logGamma(a)) * h;
};

InstaCalc.prototype.fn.logBeta = function (a, b) {
  return this.logGamma(a) + this.logGamma(b) - this.logGamma(a + b);
};

InstaCalc.prototype.fn.incompleteBeta = function (x, a, b) {
  // Factors in front of the continued fraction.
  var bt = (x === 0 || x === 1) ? 0 :
    Math.exp(this.logGamma(a + b) - this.logGamma(a) -
      this.logGamma(b) + a * Math.log(x) + b *
      Math.log(1 - x));
  if (x < 0 || x > 1)
    return false;
  if (x < (a + 1) / (a + b + 2))
    // Use continued fraction directly.
    return bt * this.betaCF(x, a, b) / a;
  // else use continued fraction after making the symmetry transformation.
  return 1 - bt * this.betaCF(1 - x, b, a) / b;
};

/* binomial function: choose k items from n, order irrelevant */
InstaCalc.prototype.fn.combination = function (n, k) {
  if (k < 0 || k > n) return 0;
  if (k === 0 || k === n) return 1;

  return this.permutation(n, k) / this.factorial(k);
};

InstaCalc.prototype.fn.permutation = function (n, k) {
  return this.factorial(n) / this.factorial(n - k);
};



/*
InstaCalc.prototype.fn.round = function (n, digits = 0) {
  if (!InstaCalc.isdefined(n)) {
    return;
  }

  var p = Math.pow(10, digits);
  return Math.round(n * p) / p;
};
*/

InstaCalc.prototype.fn.round = function (n, digits = 0) {
  if (!InstaCalc.isdefined(n)) {
    return;
  }

  if (Number.isInteger(digits)) {
    var p = Math.pow(10, digits);
    return Math.round(n * p) / p;
  } else {
    return Math.round(n / digits) * digits;
  }
};

InstaCalc.prototype.fn.square = (n) => Complex.pow(n, 2);
InstaCalc.prototype.fn.cube = (n) => Complex.pow(n, 3);
InstaCalc.prototype.fn.sqrt = (n) => Complex.pow(n, 0.5);
InstaCalc.prototype.fn.cbrt = (n) => Complex.pow(n, 1 / 3);

InstaCalc.prototype.fn.inverse = (n) => Complex.inverse(n);

/* convert sequence of binary digits to decimal */

/* change base to make all the letters lowercase...then do ascii codes for a - z? */
InstaCalc.prototype.fn.convert = function (str, base) {
  var i = 0;
  var sum = 0;

  var digits = str.split("").reverse();

  for (var i = 0; i < digits.length; i++) {
    var digit = parseInt(digits[i]);
    sum += digit * Math.pow(base, i);
  }

  return sum;
};

// signed binary conversion
InstaCalc.prototype.fn.sbin = function (n) {
  var i = 0;
  var str = "";

  for (var i = 0; i < 32; i++) {
    var digit = (n & (1 << i)) >> i;

    if (digit == 0) {
      str += "0";
    } else {
      // overflow goes to -1; so just make a 1 here
      str += "1";
    }
  }

  str = str.split("").reverse().join(""); // reverse string
  return str;
};

InstaCalc.prototype.fn.bin = function (n) {
  // show binary in groups of 8
  var tmp;
  var paddingchar = "0";
  if (n < 0) {
    // two's complement
    return this.sbin(n);
  } else {
    tmp = n.toString(2);
  }

  if (isNaN(tmp) || tmp == "") {
    return "";
  }

  var i;
  var padding = "0b"; // padding of 0's; start with 0b
  var extradigits = (8 - (tmp.length % 8)) % 8;

  for (i = 0; i < extradigits; i++) {
    padding += paddingchar;
  }

  return padding + tmp;
};

InstaCalc.prototype.fn.oct = function (n) {
  let tmp;
  if (n < 0) {
    tmp = (n >>> 0).toString(8);
  } else {
    tmp = n.toString(8);
  }

  return "0o" + tmp;
};

InstaCalc.prototype.fn.hex = function (n) {
  let tmp;
  if (n < 0) {
    // For negative numbers, use two's complement
    tmp = (n >>> 0).toString(16); // Convert to 32-bit unsigned
  } else {
    tmp = n.toString(16);
  }

  // Calculate the number of leading zeros needed and pad tmp with them
  let paddingNeeded = (4 - (tmp.length % 4)) % 4;
  let padding = "0".repeat(paddingNeeded);
  return "0x" + padding + tmp;
};

InstaCalc.prototype.fn.dec = function (n) {
  return n;
};

InstaCalc.prototype.fn.exp = (z) => Complex.exp(z); // complex exponentiation
InstaCalc.prototype.fn.log = (n) => Complex.log(n);

InstaCalc.prototype.fn.log10 = (n) => Complex.log10(n);
InstaCalc.prototype.fn.log2 = (n) => Complex.log2(n);

// from binary -- have functions to aid with parsing, which isn't easy with regular expressions
// hex and oct can be written using 0x1234abcdef or 01234567
InstaCalc.prototype.fn.frombin = function (str) {
  return this.convert(str.replace("0b", ""), 2);
};
InstaCalc.prototype.fn.fromhex = function (str) {
  return this.convert(str.replace("0x", ""), 16);
};
InstaCalc.prototype.fn.fromoct = function (str) {
  return this.convert(str.replace("0o", ""), 8);
};

// radians to degrees; 2 * PI radians = 360 degrees, so radian = 360 / (2*PI) degrees
InstaCalc.prototype.fn.deg = function (n) {
  return (n * 180) / Math.PI;
};
InstaCalc.prototype.fn.rad = function (n) {
  return (n * Math.PI) / 180;
};

// string processing functions

InstaCalc.prototype.fn.trim = function (str) {
  return str.trim();
};

// python-style print()
InstaCalc.prototype.fn.print = function (...args) {
  // Check if last argument contains options
  let sep = " ";
  let end = "";

  if (args.length > 0 && typeof args[args.length - 1] === 'object' && args[args.length - 1] !== null) {
    const options = args.pop();
    sep = options.sep !== undefined ? options.sep : sep;
    end = options.end !== undefined ? options.end : end;
  }

  // Convert all args to strings and join them
  return args.map(String).join(sep) + end;
};

// return seconds in format HH:MM:SS
InstaCalc.prototype.fn.time_old = function (n) {
  years = days = hours = minutes = seconds = 0;
  var show = false; // set to true to display previous
  if (n < 0) {
    n = Math.abs(n);
  }

  if (n >= 31536000) {
    // years - not leap year. Just 365 days.
    years = Math.floor(n / 31536000);
    n -= Math.round(years * 31536000);
  }

  if (n >= 86400) {
    // days
    days = Math.floor(n / 86400);
    n -= Math.round(days * 86400);
  }

  if (n >= 3600) {
    // hours
    hours = Math.floor(n / 3600);
    n -= Math.round(hours * 3600);
  }

  if (n >= 60) {
    minutes = Math.floor(n / 60);
    n -= Math.round(minutes * 60);
  }
  seconds = n;

  str = "";

  if (years > 0) {
    str += years + "y ";
    show = true;
  }

  if (days > 0 || show) {
    str += days + "d ";
    show = true;
  }

  if (hours > 0 || show) {
    str += hours + "h ";
    show = true;
  }

  if (minutes > 0 || show) {
    str += minutes + "m ";
    show = true;
  }

  if (seconds > 0 || show) {
    str += seconds.toPrecision(4) + "s ";
    show = true;
  }

  return str;
  /*
     // Todo: add right amount of precision. Show 0h if there are days, etc. Show if any of preceding are shown.

          if (minutes < 10) //need leading 0
              str += "" + minutes + "m ";
          else
              str += minutes + "m ";

      // only show precision if we need it
      if (seconds < 10){
              str += "" + seconds.toFixed(2) + "s";
          }
          else{
              str += seconds.toFixed(2) + "s";
          }

     return str;
     */
};

InstaCalc.prototype.fn.time = function (n) {
  n = Math.abs(n);
  let str = "";

  const units = [
    { name: 'y', length: 31536000 }, // years
    { name: 'd', length: 86400 },    // days
    { name: 'h', length: 3600 },     // hours
    { name: 'm', length: 60 },       // minutes
    { name: 's', length: 1 },        // seconds
  ];

  for (let unit of units) {
    let amount = Math.floor(n / unit.length);

    if (amount > 0) {
      // Check if the number is a whole number
      if (Number.isInteger(amount)) {
        str += `${amount}${unit.name} `;
      } else {
        str += `${amount.toPrecision(4)}${unit.name} `;
      }
      n -= amount * unit.length;
    }
  }

  return str.trim();
};

// convert timestring like 3h 15m into seconds
InstaCalc.prototype.fn.parseTime = function (timeString) {
  // Regex to match the pattern "3m 15s", "3 minutes 15 seconds", "3:15", "3:15:23" etc.
  const regex = /(\d+(\.\d+)?)\s*(y(ears?)?|d(ays?)?|h(ours?)?|m(inutes?)?|s(econds?)?|:)?/gi;

  // Multipliers to convert each unit to seconds
  const unitsInSeconds = {
    y: 31536000, // years
    d: 86400,    // days
    h: 3600,     // hours
    m: 60,       // minutes
    s: 1         // seconds
  };

  let totalSeconds = 0;

  // Special case for "3:15:23" format
  let colonGroups = timeString.split(':').reverse();
  if (colonGroups.length > 1) {
    for (let i = 0; i < colonGroups.length; i++) {
      totalSeconds += parseFloat(colonGroups[i]) * unitsInSeconds[['s', 'm', 'h'][i]];
    }
    return totalSeconds;
  }

  // Extract all matched groups from the string
  let match;
  while ((match = regex.exec(timeString)) !== null) {
    let quantity = parseFloat(match[1]);
    let unit = match[3]?.charAt(0).toLowerCase(); // Get the first letter of the unit matched

    totalSeconds += quantity * (unitsInSeconds[unit] || 0);
  }

  return totalSeconds;
};

// Helper function to extract numeric values from an array
InstaCalc.prototype.fn.extractNumericValues = function (a) {
  // see if single-dimensional array, then return that
  if (a[0] && typeof a[0] === 'number') {
    return a.map(el => [null, el]);
  }

  return a.filter(el => typeof el[1] === 'number' && !isNaN(el[1]));
};

InstaCalc.prototype.fn.extractNumericValuesAsFlatArray = function (a) {
  if (!a) {
    return [];
  }

  return this.extractNumericValues(a).map(el => el[1]);
};

InstaCalc.prototype.fn.arraymax = function (a) {
  const numericValues = this.extractNumericValues(a);

  if (numericValues.length === 0) {
    return "";
  }

  let max = numericValues[0][1];
  for (let i = 0; i < numericValues.length; i++) {
    if (numericValues[i][1] > max) {
      max = numericValues[i][1];
    }
  }
  return max;
};

InstaCalc.prototype.fn.arraymin = function (a) {
  const numericValues = this.extractNumericValues(a);

  if (numericValues.length === 0) {
    return "";
  }

  let min = numericValues[0][1];
  for (let i = 0; i < numericValues.length; i++) {
    if (numericValues[i][1] < min) {
      min = numericValues[i][1];
    }
  }
  return min;
};

InstaCalc.prototype.fn.arraysum = function (a) {
  const numericValues = this.extractNumericValues(a);

  if (numericValues.length === 0) {
    return "";
  }

  let total = 0;
  for (let i = 0; i < numericValues.length; i++) {
    total += numericValues[i][1];
  }
  return total;
};

InstaCalc.prototype.fn.arrayproduct = function (a) {
  const numericValues = this.extractNumericValues(a);

  if (numericValues.length === 0) {
    return "";
  }

  let prod = 1;
  for (let i = 0; i < numericValues.length; i++) {
    prod *= numericValues[i][1];
  }
  return prod;
};

InstaCalc.prototype.fn.arraydifference = function (a) {
  const numericValues = this.extractNumericValues(a);

  if (numericValues.length === 0) {
    return "";
  }

  let total = numericValues[0][1];
  for (let i = 1; i < numericValues.length; i++) {
    total -= numericValues[i][1];
  }
  return total;
};

InstaCalc.prototype.fn.arrayavg = function (a) {
  const numericValues = this.extractNumericValues(a);

  if (numericValues.length === 0) {
    return "";
  }

  const total = this.arraysum(numericValues);
  const average = total / numericValues.length;
  return average;
};

InstaCalc.prototype.fn.arraymedian = function (a) {
  const numericValues = this.extractNumericValues(a);

  if (numericValues.length === 0) {
    return "";
  }

  const mid = Math.floor(numericValues.length / 2),
    nums = [...numericValues].sort((a, b) => a[1] - b[1]);
  return numericValues.length % 2 !== 0 ? nums[mid][1] : (nums[mid - 1][1] + nums[mid][1]) / 2;
};

InstaCalc.prototype.fn.arraymode = function (a) {
  const numericValues = this.extractNumericValues(a);

  if (numericValues.length === 0) {
    return "";
  }

  return numericValues.sort((a, b) =>
    numericValues.filter(v => v[1] === a[1]).length - numericValues.filter(v => v[1] === b[1]).length
  ).pop()[1];
};

InstaCalc.prototype.fn.arraygeomean = function (a) {
  const numericValues = this.extractNumericValuesAsFlatArray(a);
  const product = numericValues.reduce((acc, value) => acc * value, 1);
  const geometricMean = Math.pow(product, 1 / numericValues.length);
  return geometricMean;
};

InstaCalc.prototype.fn.arrayvariance = function (a) {
  const numericValues = this.extractNumericValuesAsFlatArray(a);

  if (numericValues.length < 2) {
    return null;
  }

  const mean = this.arrayavg(a);
  const sumSquaredDeviations = numericValues.reduce((acc, val) => acc + Math.pow(val - mean, 2), 0);

  // Calculate sample variance (Excel VAR.S)
  return sumSquaredDeviations / (numericValues.length - 1);
};

InstaCalc.prototype.fn.arrayvariancePopulation = function (a) {
  const numericValues = this.extractNumericValues(a);

  if (numericValues.length === 0) {
    return null;
  }

  const sampleVariance = this.arrayvariance(a);

  // Adjust sample variance to population variance
  const populationVariance = sampleVariance * (numericValues.length - 1) / numericValues.length;
  return populationVariance;
};


// covariance of two arrays
InstaCalc.prototype.fn.arraycovariance = function (a, b) {

  const numericValuesA = this.extractNumericValuesAsFlatArray(a);
  const numericValuesB = this.extractNumericValuesAsFlatArray(b);

  if (numericValuesA.length !== numericValuesB.length || numericValuesA.length < 2) {
    return null;
  }

  const meanA = this.arrayavg(a);
  const meanB = this.arrayavg(b);

  let covariance = 0;
  for (let i = 0; i < numericValuesA.length; i++) {
    covariance += (numericValuesA[i] - meanA) * (numericValuesB[i] - meanB);
  }

  covariance /= numericValuesA.length - 1;
  return covariance;
};

// population covariance
InstaCalc.prototype.fn.arraycovariancePopulation = function (a, b) {
  let covariance = this.arraycovariance(a, b);

  if (covariance === null) {
    return null;
  }

  let length = this.extractNumericValuesAsFlatArray(a).length;
  covariance *= (length - 1) / length;

  return covariance;
};

InstaCalc.prototype.fn.arraystddev = function (a) {
  const numericValues = this.extractNumericValues(a);

  if (numericValues.length === 0) {
    return null;
  }

  return Math.sqrt(this.arrayvariance(numericValues));
};

InstaCalc.prototype.fn.arraystddevPopulation = function (a) {
  const numericValues = this.extractNumericValues(a);

  if (numericValues.length === 0) {
    return null;
  }

  return Math.sqrt(this.arrayvariancePopulation(numericValues));
};

InstaCalc.prototype.fn.arrayskewness = function (a) {
  const numericValues = this.extractNumericValues(a);
  if (numericValues.length < 3) {
    return null;
  }

  const n = numericValues.length;
  const mean = this.arrayavg(numericValues);
  const standardDeviation = Math.sqrt(this.arrayvariance(numericValues));

  if (standardDeviation === 0) {
    return 0;
  }

  let sumCubedDeviations = 0;
  for (let i = 0; i < n; i++) {
    let val = numericValues[i][1];
    sumCubedDeviations += Math.pow(val - mean, 3);
  }

  const skewness = (n * sumCubedDeviations) / ((n - 1) * (n - 2) * Math.pow(standardDeviation, 3));
  return skewness;
};

InstaCalc.prototype.fn.arraykurtosis = function (a) {
  const numericValues = this.extractNumericValues(a);
  if (numericValues.length < 4) {
    return null;
  }

  const n = numericValues.length;
  const mean = this.arrayavg(numericValues);
  const variance = this.arrayvariance(numericValues);

  let sumFourthDeviations = 0;
  for (let i = 0; i < n; i++) {
    let val = typeof numericValues[i] === 'object' ? numericValues[i][1] : numericValues[i];
    sumFourthDeviations += Math.pow(val - mean, 4);
  }

  const kurtosis = ((n * (n + 1)) / ((n - 1) * (n - 2) * (n - 3))) * (sumFourthDeviations / Math.pow(variance, 2)) - (3 * (n - 1) * (n - 1)) / ((n - 2) * (n - 3));
  return kurtosis;
};

InstaCalc.prototype.fn.arrayrange = function (a) {
  const numericValues = this.extractNumericValues(a);

  if (numericValues.length === 0) {
    return "";
  }

  const min = this.arraymin(a);
  const max = this.arraymax(a);
  return max - min;
};

InstaCalc.prototype.fn.arraycount = function (a) {
  return this.extractNumericValues(a).length;
};

InstaCalc.prototype.fn.arraysort = function (a) {
  let values = this.extractNumericValuesAsFlatArray(a);
  values.sort((a, b) => a - b);
  return values;
};

InstaCalc.prototype.fn.arrayreverse = function (a) {
  let values = this.extractNumericValuesAsFlatArray(a);
  values.reverse();
  return values;
};

// function to return the value at a given percentile in an array
InstaCalc.prototype.fn.arraypercentile = function (array, p) {
  // Extract numeric values from the array
  let values = this.extractNumericValuesAsFlatArray(array);

  if (values.length === 0) {
    return "";
  }

  // k is the percentile (0 to 1, or 0 to 100)
  let percentile = p;

  // if percentile is less than 1, assume it's 0-1 scale, otherwise 0-100
  if (percentile < 1) {
    percentile *= 100;
  }

  if (percentile < 0 || percentile > 100) {
    return "";
  }

  // Sort values
  values.sort((a, b) => a - b);

  // Excel PERCENTILE formula: position = (percentile/100) * (n-1)
  const index = (percentile / 100) * (values.length - 1);
  const lower = Math.floor(index);
  const upper = Math.ceil(index);
  const weight = index - lower;

  if (lower === upper) {
    return values[index];
  } else {
    return values[lower] * (1 - weight) + values[upper] * weight;
  }
};

// Helper function to evaluate a function with a value
InstaCalc.prototype.fn.evaluateFunction = function (fn, value) {
  if (fn && typeof fn === 'object' && fn.type === "function") {
    if (typeof IC !== 'undefined' && IC.evalUserFunction) {
      return IC.evalUserFunction(fn, [value]);
    }
  }
  return value; // fallback
};

// Helper function to validate array inputs
InstaCalc.prototype.fn.validateArrayInput = function (a, fn) {
  if (!a || !Array.isArray(a) || a.length === 0) {
    return { valid: false, error: "empty array" };
  }
  if (!fn) {
    return { valid: false, error: "no function" };
  }
  const numericValues = this.extractNumericValues(a);
  if (numericValues.length === 0) {
    return { valid: false, error: "no numeric values" };
  }
  return { valid: true, numericValues };
};

InstaCalc.prototype.fn.arraymap = function (a, fn) {
  const validation = this.validateArrayInput(a, fn);
  if (!validation.valid) {
    return "";
  }

  try {
    const results = [];
    for (let i = 0; i < validation.numericValues.length; i++) {
      const element = validation.numericValues[i];
      const value = element[1];
      const result = this.evaluateFunction(fn, value);
      results.push(result);
    }
    return results;
  } catch (error) {
    return "";
  }
};

InstaCalc.prototype.fn.arrayfilter = function (a, predicate) {
  const validation = this.validateArrayInput(a, predicate);
  if (!validation.valid) {
    return "";
  }

  try {
    const results = [];
    for (let i = 0; i < validation.numericValues.length; i++) {
      const element = validation.numericValues[i];
      const value = element[1];
      const shouldInclude = this.evaluateFunction(predicate, value);

      if (shouldInclude) {
        results.push(value);
      }
    }
    return results;
  } catch (error) {
    return "";
  }
};

InstaCalc.prototype.fn.arrayreduce = function (a, fn, initialValue) {
  const validation = this.validateArrayInput(a, fn);
  if (!validation.valid) {
    return "";
  }

  try {
    const values = validation.numericValues.map(element => element[1]);

    if (values.length === 0) {
      return initialValue !== undefined ? initialValue : "";
    }

    let accumulator;
    let startIndex;

    if (initialValue !== undefined) {
      accumulator = initialValue;
      startIndex = 0;
    } else {
      accumulator = values[0];
      startIndex = 1;
    }

    for (let i = startIndex; i < values.length; i++) {
      const currentValue = values[i];
      // For reduce, we need to pass both accumulator and current value
      if (fn && typeof fn === 'object' && fn.type === "function") {
        if (typeof IC !== 'undefined' && IC.evalUserFunction) {
          accumulator = IC.evalUserFunction(fn, [accumulator, currentValue]);
        }
      } else {
        accumulator = currentValue; // fallback
      }
    }

    return accumulator;
  } catch (error) {
    return "";
  }
};

InstaCalc.prototype.fn.arrayfind = function (a, fn) {
  const filtered = this.arrayfilter(a, fn);
  return (filtered && filtered.length > 0) ? filtered[0] : "";
};

InstaCalc.prototype.fn.sequence = function () {
  let count, start = 1, step = 1;

  // Handle object parameter: SEQUENCE({count: 10, start: 3, step: 2})
  if (arguments.length === 1 && typeof arguments[0] === 'object' && arguments[0] !== null && !Array.isArray(arguments[0])) {
    const params = arguments[0];

    // Find parameters with case-insensitive matching
    const getParam = (name) => {
      for (const key in params) {
        if (key.toLowerCase() === name.toLowerCase()) {
          return params[key];
        }
      }
      return undefined;
    };

    count = getParam('count');
    const startParam = getParam('start');
    const stepParam = getParam('step');

    start = startParam !== undefined ? startParam : 1;
    step = stepParam !== undefined ? stepParam : 1;
  }
  // Handle positional parameters: SEQUENCE(count, start, step)
  else {
    count = arguments[0];
    if (arguments.length > 1) start = arguments[1];
    if (arguments.length > 2) step = arguments[2];
  }

  // Validate inputs
  if (count === undefined || count === null || isNaN(count) || count < 0) {
    return "";
  }

  count = Math.floor(count);
  if (count === 0) {
    return [];
  }

  // Generate sequence
  const result = [];
  for (let i = 0; i < count; i++) {
    result.push(start + (i * step));
  }

  return result;
};

InstaCalc.prototype.fn.random = function (a) {
  return Math.ceil(Math.random() * a);
};

// custom functions
InstaCalc.prototype.fn.add = function (a, b) {
  return a + b;
};

InstaCalc.prototype.fn.subtract = function (a, b) {
  return a - b;
};

InstaCalc.prototype.fn.multiply = function (a, b) {
  return a * b;
};

InstaCalc.prototype.fn.divide = function (a, b) {
  return a / b;
};

InstaCalc.prototype.fn.mod = function (a, b) {
  return a % b;
};

InstaCalc.prototype.fn.abs = (a) => Complex.abs(a);

InstaCalc.prototype.fn.gcd = function (a, b) {
  // Ensure numbers are positive
  a = Math.abs(a);
  b = Math.abs(b);

  // Use Euclidean algorithm to find GCD
  while (b) {
    var temp = b;
    b = a % b;
    a = temp;
  }

  return a;
};

InstaCalc.prototype.fn.lcm = function (a, b) {
  // Ensure numbers are positive
  a = Math.abs(a);
  b = Math.abs(b);

  // Calculate LCM
  return (a * b) / this.gcd(a, b);
};

InstaCalc.prototype.fn.sign = function (a) {
  return Math.sign(a);
};

InstaCalc.prototype.fn.clamp = function (n, min, max) {
  return Math.min(Math.max(n, min), max);
};

// https://hewgill.com/picomath/javascript/erf.js.html
InstaCalc.prototype.fn.erf = function (x) {
  // Save the sign of x
  const sign = x < 0 ? -1 : 1;
  x = Math.abs(x);

  // Constants
  const a1 = 0.254829592;
  const a2 = -0.284496736;
  const a3 = 1.421413741;
  const a4 = -1.453152027;
  const a5 = 1.061405429;
  const p = 0.3275911;

  // Abramowitz and Stegun formula 7.1.26
  if (x < 3.75) {
    const t = 1.0 / (1.0 + p * x);
    return sign * (1 - (((((a5 * t + a4) * t) + a3) * t + a2) * t + a1) * t * Math.exp(-x * x));
  } else {
    // For large x, use a continued fraction expansion
    let t = 1 / (x + 0.5 + Math.sqrt(x * (x + 1)));
    let sum = t;
    for (let n = 1; n <= 100; n++) {  // Adjust the number of iterations for desired accuracy
      let lastSum = sum;
      t *= -n / (x + n + 0.5);
      sum += t;
      if (Math.abs(sum - lastSum) < 1e-15) break;  // Convergence check
    }
    return sign * (1 - sum * Math.exp(-x * x) / Math.sqrt(Math.PI));
  }
};

InstaCalc.prototype.fn.erfInverse = function (x) {
  if (x < -1 || x > 1) {
    throw new Error("erfInv is only defined for -1 < x < 1");
  }

  if (x === 0) return 0;

  const a = 0.147;
  const sign = x < 0 ? -1 : 1;
  const ln1x2 = Math.log(1 - x * x);

  let tau = sign * Math.sqrt(
    Math.sqrt(
      (2 / (Math.PI * a) + ln1x2 / 2) ** 2 - ln1x2 / a
    ) - (2 / (Math.PI * a) + ln1x2 / 2)
  );

  return tau - (this.erf(tau) - x) / (2 / Math.sqrt(Math.PI) * Math.exp(-tau * tau));
};

/* stats functions */
InstaCalc.prototype.fn.normSInv = function (probability) {
  if (probability <= 0 || probability >= 1) return null;
  return Math.sqrt(2) * this.erfInverse(2 * probability - 1);
};

InstaCalc.prototype.fn.normInv = function (probability, mean, standard_dev) {
  if (probability <= 0 || probability >= 1) return null;
  const z = this.normSInv(probability);
  return mean + z * standard_dev;
};

InstaCalc.prototype.fn.normDist = function (x, mean, standard_dev, cumulative) {
  const variance = Math.pow(standard_dev, 2);
  const factor = 1 / (Math.sqrt(2 * Math.PI * variance));
  const exponent = Math.exp(-Math.pow(x - mean, 2) / (2 * variance));
  if (cumulative) {
    return 0.5 * (1 + this.erf((x - mean) / (standard_dev * Math.sqrt(2))));
  }
  return factor * exponent;
};

InstaCalc.prototype.fn.normSDist = function (z, cumulative) {
  if (cumulative) {
    return 0.5 * (1 + this.erf(z / Math.sqrt(2)));
  }
  const factor = 1 / Math.sqrt(2 * Math.PI);
  const exponent = Math.exp(-0.5 * Math.pow(z, 2));
  return factor * exponent;
};

InstaCalc.prototype.fn.binomDist = function (x, trials, probability_s, cumulative) {
  if (cumulative) {
    let sum = 0;
    for (let k = 0; k <= x; k++) {
      sum += this.combination(trials, k) * Math.pow(probability_s, k) * Math.pow(1 - probability_s, trials - k);
    }
    return sum;
  }
  return this.combination(trials, x) * Math.pow(probability_s, x) * Math.pow(1 - probability_s, trials - x);
};

InstaCalc.prototype.fn.negbinomDist = function (x, r, p, cumulative) {
  if (cumulative) {
    let sum = 0;
    for (let k = 0; k <= x; k++) {
      sum += this.combination(k + r - 1, k) * Math.pow(p, r) * Math.pow(1 - p, k);
    }
    return sum;
  }
  return this.combination(x + r - 1, x) * Math.pow(p, r) * Math.pow(1 - p, x);
};

InstaCalc.prototype.fn.weibullDist = function (x, alpha, beta, cumulative) {
  if (x < 0) return 0;

  if (cumulative) {
    return 1 - Math.exp(-Math.pow(x / beta, alpha));
  }
  return (alpha / beta) * Math.pow(x / beta, alpha - 1) * Math.exp(-Math.pow(x / beta, alpha));
};

InstaCalc.prototype.fn.poissonDist = function (x, mean, cumulative) {
  const lambda = Math.exp(-mean);
  const poisson = Math.pow(mean, x) * lambda / this.factorial(x);
  if (cumulative) {
    let sum = 0;
    for (let k = 0; k <= x; k++) {
      sum += Math.pow(mean, k) * lambda / this.factorial(k);
    }
    return sum;
  }
  return poisson;
};

InstaCalc.prototype.fn.gammaPDF = function (x, alpha, beta) {
  if (x < 0) return 0;
  return Math.pow(x, alpha - 1) * Math.exp(-x / beta) / (Math.pow(beta, alpha) * this.gamma(alpha));
};

InstaCalc.prototype.fn.gammaCDF = function (x, alpha, beta) {
  if (x <= 0) return 0;
  return this.gammaLowerIncomplete(alpha, x / beta) / this.gamma(alpha);
};

InstaCalc.prototype.fn.gammaDist = function (x, alpha, beta, cumulative) {
  if (cumulative) {
    return this.gammaCDF(x, alpha, beta);
  }
  return this.gammaPDF(x, alpha, beta);
};

InstaCalc.prototype.fn.betaDist = function (x, alpha, beta, cumulative) {
  if (x < 0 || x > 1) return 0;

  if (cumulative) {
    return this.betaCDF(x, alpha, beta);
  }
  return this.betaPDF(x, alpha, beta);
};

InstaCalc.prototype.fn.betaPDF = function (x, alpha, beta) {
  if (x < 0 || x > 1) return 0;
  return Math.pow(x, alpha - 1) * Math.pow(1 - x, beta - 1) / this.beta(alpha, beta);
};

InstaCalc.prototype.fn.betaCDF = function (x, alpha, beta) {
  if (x <= 0) return 0;
  if (x >= 1) return 1;
  return this.regularizedIncompleteBeta(x, alpha, beta);
};

InstaCalc.prototype.fn.hypgeomDist = function (x, sample_size, number_of_successes, population_size, cumulative) {
  // Check for valid parameters
  if (!Number.isInteger(x) || !Number.isInteger(sample_size) || !Number.isInteger(number_of_successes) || !Number.isInteger(population_size)) {
    throw new Error("all parameters must be integers");
  }
  if (population_size < 0 || number_of_successes < 0 || sample_size < 0 || x < 0) {
    throw new Error("all parameters must be non-negative");
  }
  if (sample_size > population_size) {
    throw new Error("sample_size must not exceed population_size");
  }

  // Adjust number_of_successes if it exceeds population_size
  number_of_successes = Math.min(number_of_successes, population_size);

  if (x > Math.min(sample_size, number_of_successes)) {
    return cumulative ? 1 : 0;
  }

  if (cumulative) {
    let sum = 0;
    for (let k = 0; k <= x; k++) {
      sum += this.hypgeomPMF(k, sample_size, number_of_successes, population_size);
    }
    return sum;
  }
  return this.hypgeomPMF(x, sample_size, number_of_successes, population_size);
};

InstaCalc.prototype.fn.hypgeomPMF = function (x, sample_size, number_of_successes, population_size) {
  // Adjust number_of_successes if it exceeds population_size
  number_of_successes = Math.min(number_of_successes, population_size);

  // Additional check for valid x
  if (x > Math.min(sample_size, number_of_successes)) {
    return 0;
  }

  // Use regular combination function
  let numerator = this.combination(number_of_successes, x) * this.combination(population_size - number_of_successes, sample_size - x);
  let denominator = this.combination(population_size, sample_size);

  // Check for potential division by zero
  if (denominator === 0) {
    return 0; // Return 0 instead of throwing an error to match Excel behavior
  }

  return numerator / denominator;
};

InstaCalc.prototype.fn.lognormDist = function (x, mu, sigma, cumulative) {
  if (x <= 0) return 0;

  if (cumulative) {
    return 0.5 + 0.5 * this.erf((Math.log(x) - mu) / (Math.sqrt(2) * sigma));
  }
  return Math.exp(-Math.pow(Math.log(x) - mu, 2) / (2 * Math.pow(sigma, 2))) / (x * sigma * Math.sqrt(2 * Math.PI));
};

InstaCalc.prototype.fn.lognormInv = function (probability, mu, sigma) {
  return Math.exp(mu + sigma * this.normInv(probability, 0, 1));
};

InstaCalc.prototype.fn.tInv = function (probability, degrees_freedom) {
  if (probability <= 0 || probability >= 1) return null;
  return this.inverseT(probability, degrees_freedom);
};

InstaCalc.prototype.fn.inverseT = function (p, df) {
  var x = this.incompleteBetaInverse(2 * Math.min(p, 1 - p), 0.5 * df, 0.5);
  x = Math.sqrt(df * (1 - x) / x);
  return (p > 0.5) ? x : -x;
};

InstaCalc.prototype.fn.tDist = function (x, degrees_freedom, cumulative) {
  if (cumulative) {
    return this.tCDF(x, degrees_freedom);
  }
  return this.tPDF(x, degrees_freedom);
};

// Helper functions for T.DIST
InstaCalc.prototype.fn.tPDF = function (x, df) {
  df = df > 1e100 ? 1e100 : df;  // Limit degrees of freedom
  const numerator = 1 / (Math.sqrt(df) * this.beta(0.5, df / 2));
  const denominator = Math.pow(1 + (x * x) / df, (df + 1) / 2);
  return numerator / denominator;
};

InstaCalc.prototype.fn.tCDF = function (x, df) {
  // Handle negative x using symmetry
  if (x < 0) {
    return 1 - this.tCDF(-x, df);
  }

  var df2 = df / 2;
  return this.incompleteBeta((x + Math.sqrt(x * x + df)) /
    (2 * Math.sqrt(x * x + df)), df2, df2);
};

InstaCalc.prototype.fn.chisqDist = function (x, degrees_freedom, cumulative) {
  if (cumulative) {
    return this.chisqCDF(x, degrees_freedom);
  }
  return this.chisqPDF(x, degrees_freedom);
};

InstaCalc.prototype.fn.chisqPDF = function (x, df) {
  if (x < 0 || df <= 0) {
    return 0;
  }
  const halfDf = df / 2;
  return Math.exp((halfDf - 1) * Math.log(x) - x / 2 - halfDf * Math.log(2) - this.logGamma(halfDf));
};

InstaCalc.prototype.fn.chisqCDF = function (x, df) {
  if (x <= 0) {
    return 0;
  }
  if (df <= 0) {
    throw new Error("Degrees of freedom must be positive");
  }
  return this.gammaLowerRegularized(df / 2, x / 2);
};

InstaCalc.prototype.fn.fDist = function (x, df1, df2, cumulative) {

  // Main F-distribution function
  if (x < 0 || df1 <= 0 || df2 <= 0) {
    return NaN;
  }

  if (cumulative) {
    return this.incompleteBeta((df1 * x) / (df1 * x + df2), df1 / 2, df2 / 2);
  } else {
    // Probability density function
    const num = Math.pow(df1 * x, df1) * Math.pow(df2, df2);
    const den = Math.pow(df1 * x + df2, df1 + df2);
    return Math.sqrt(num / den) / (x * this.beta(df1 / 2, df2 / 2));
  }
};

InstaCalc.prototype.fn.zTest = function (array, x, sigma) {
  const mean = this.arrayavg(array);
  const n = this.extractNumericValues(array).length;

  // Use provided sigma or calculate sample standard deviation
  const stdDev = sigma !== undefined ? sigma : this.arraystddev(array);
  const zValue = (mean - x) / (stdDev / Math.sqrt(n));

  // Calculate the p-value for the Z-test, Excel returns the upper tail probability
  const pValue = 1 - this.normSDist(zValue, true);
  return pValue;
};

InstaCalc.prototype.fn.tTest = function (array1, array2, tails, type) {
  const numericValues1 = this.extractNumericValues(array1);
  const numericValues2 = this.extractNumericValues(array2);
  const mean1 = this.arrayavg(numericValues1);
  const mean2 = this.arrayavg(numericValues2);
  const variance1 = this.arrayvariance(numericValues1);
  const variance2 = this.arrayvariance(numericValues2);
  const n1 = numericValues1.length;
  const n2 = numericValues2.length;

  let t, df;
  if (type === 1) {
    // Paired t-test
    const differences = numericValues1.map((val, i) => val[1] - numericValues2[i][1]);
    const meanDiff = this.arrayavg(differences);
    const varianceDiff = this.arrayvariance(differences);
    t = meanDiff / Math.sqrt(varianceDiff / differences.length);
    df = differences.length - 1;
  } else if (type === 2) {
    // Two-sample t-test assuming equal variances
    const pooledVar = ((n1 - 1) * variance1 + (n2 - 1) * variance2) / (n1 + n2 - 2);
    t = (mean1 - mean2) / Math.sqrt(pooledVar * (1 / n1 + 1 / n2));
    df = n1 + n2 - 2;
  } else if (type === 3) {
    // Two-sample t-test assuming unequal variances
    t = (mean1 - mean2) / Math.sqrt(variance1 / n1 + variance2 / n2);
    df = Math.pow(variance1 / n1 + variance2 / n2, 2) /
      (Math.pow(variance1 / n1, 2) / (n1 - 1) + Math.pow(variance2 / n2, 2) / (n2 - 1));
  } else {
    throw new Error("Invalid t-test type");
  }

  let pValue = this.tCDF(t, df);
  if (tails === 2) {
    pValue = 2 * (1 - pValue);
  } else if (tails !== 1) {
    throw new Error("Invalid number of tails");
  }

  return pValue;

};

InstaCalc.prototype.fn.tDist2T = function (x, df) {
  if (x < 0) {
    x = -x;
  }
  return 2 * (1 - this.tCDF(x, df));
};

InstaCalc.prototype.fn.tDistRT = function (x, df) {
  return 1 - this.tCDF(x, df);
};

InstaCalc.prototype.fn.tInv2T = function (x, df) {
  return this.tInv(1 - x / 2, df);
};

InstaCalc.prototype.fn.chisqDistRT = function (x, df) {
  return 1 - this.chisqCDF(x, df);
};

InstaCalc.prototype.fn.chisqInv = function (x, df) {
  return this.gammapInv(x, df / 2) * 2;
};

InstaCalc.prototype.fn.chisqInvRT = function (x, df) {
  return this.chisqInv(1 - x, df);
};

InstaCalc.prototype.fn.fDistRT = function (x, df1, df2) {
  return 1 - this.fDist(x, df1, df2, true);
};

InstaCalc.prototype.fn.fInv = function (x, df1, df2) {
  return df2 / (df1 * (1 / this.incompleteBetaInverse(x, df1 / 2, df2 / 2) - 1));
};

InstaCalc.prototype.fn.fInvRT = function (x, df1, df2) {
  return this.fInv(1 - x, df1, df2);
};

InstaCalc.prototype.fn.arraypercentrank = function (array, x, significance = 3) {
  // Sort the array in ascending order
  const values = this.extractNumericValuesAsFlatArray(array);
  const sortedArray = values.slice().sort((a, b) => a - b);
  const n = sortedArray.length;

  // If x is less than the smallest value, return 0
  if (x < sortedArray[0]) return 0;
  // If x is greater than the largest value, return 1
  if (x > sortedArray[n - 1]) return 1;

  // Find the position of x in the sorted array
  let position = 0;
  for (let i = 0; i < n; i++) {
    if (sortedArray[i] === x) {
      position = i;
      break;
    }
    if (sortedArray[i] < x && sortedArray[i + 1] > x) {
      // Interpolate between the two surrounding values
      const lower = sortedArray[i];
      const upper = sortedArray[i + 1];
      position = i + (x - lower) / (upper - lower);
      break;
    }
  }

  // Calculate the percentage rank
  const percentRank = position / (n - 1);

  // Round to the specified number of decimal places
  return Math.round(percentRank * Math.pow(10, significance)) / Math.pow(10, significance);
};

InstaCalc.prototype.fn.arrayforecast = function (x, known_ys, known_xs) {
  if (known_ys.length !== known_xs.length) {
    throw new Error("The number of y-values must match the number of x-values");
  }

  known_xs = this.extractNumericValuesAsFlatArray(known_xs);
  known_ys = this.extractNumericValuesAsFlatArray(known_ys);

  const n = known_ys.length;
  let sum_x = 0, sum_y = 0, sum_xy = 0, sum_xx = 0;

  for (let i = 0; i < n; i++) {
    sum_x += known_xs[i];
    sum_y += known_ys[i];
    sum_xy += known_xs[i] * known_ys[i];
    sum_xx += known_xs[i] * known_xs[i];
  }

  const slope = (n * sum_xy - sum_x * sum_y) / (n * sum_xx - sum_x * sum_x);
  const intercept = (sum_y - slope * sum_x) / n;

  return slope * x + intercept;
};

InstaCalc.prototype.fn.confidence = function (alpha, standard_dev, size) {
  // Calculate the critical value for the given confidence level
  const confidence_level = 1 - alpha;
  const critical_value = this.normSInv((1 + confidence_level) / 2);

  // Calculate the margin of error
  const margin_of_error = critical_value * (standard_dev / Math.sqrt(size));

  return margin_of_error;
};

InstaCalc.prototype.fn.arraycorrelation = function (array1, array2) {
  const numericValues1 = this.extractNumericValuesAsFlatArray(array1);
  const numericValues2 = this.extractNumericValuesAsFlatArray(array2);

  if (numericValues1.length !== numericValues2.length || numericValues1.length < 2) {
    return null;
  }

  const mean1 = this.arrayavg(numericValues1);
  const mean2 = this.arrayavg(numericValues2);
  const stdDev1 = Math.sqrt(this.arrayvariance(numericValues1));
  const stdDev2 = Math.sqrt(this.arrayvariance(numericValues2));

  if (stdDev1 === 0 || stdDev2 === 0) {
    return null;
  }

  let covariance = 0;
  for (let i = 0; i < numericValues1.length; i++) {
    covariance += (numericValues1[i] - mean1) * (numericValues2[i] - mean2);
  }

  covariance /= (numericValues1.length - 1);

  return covariance / (stdDev1 * stdDev2);
};

InstaCalc.prototype.fn.arrayslope = function (known_ys, known_xs) {
  const numericYs = this.extractNumericValuesAsFlatArray(known_ys);
  const numericXs = this.extractNumericValuesAsFlatArray(known_xs);

  if (numericYs.length !== numericXs.length || numericYs.length < 2) {
    return null;
  }

  // Calculate means
  const meanY = this.arrayavg(numericYs);
  const meanX = this.arrayavg(numericXs);

  // Calculate covariance
  let covariance = 0;
  for (let i = 0; i < numericYs.length; i++) {
    covariance += (numericXs[i] - meanX) * (numericYs[i] - meanY);
  }
  covariance /= (numericYs.length - 1);

  // Calculate variance of X
  const varianceX = this.arrayvariance(numericXs);

  // Avoid division by zero
  if (varianceX === 0) {
    return null;
  }

  // Calculate slope
  return covariance / varianceX;
};

InstaCalc.prototype.fn.arrayintercept = function (known_ys, known_xs) {
  const numericYs = this.extractNumericValuesAsFlatArray(known_ys);
  const numericXs = this.extractNumericValuesAsFlatArray(known_xs);

  if (numericYs.length !== numericXs.length || numericYs.length < 2) {
    return null;
  }

  // Calculate means
  const meanY = this.arrayavg(numericYs);
  const meanX = this.arrayavg(numericXs);

  // Calculate slope using the slope function
  const slopeValue = this.arrayslope(numericYs, numericXs);

  if (slopeValue === null) {
    return null;
  }

  // Calculate intercept
  return meanY - slopeValue * meanX;
};

InstaCalc.prototype.fn.arraylinest = function (known_ys, known_xs, constant = true, stats = false) {
  const numericYs = this.extractNumericValuesAsFlatArray(known_ys);
  const numericXs = this.extractNumericValuesAsFlatArray(known_xs);

  if (numericYs.length !== numericXs.length || numericYs.length < 2) {
    return null;
  }

  const slope = this.arrayslope(known_ys, known_xs);
  const intercept = this.arrayintercept(known_ys, known_xs);

  if (!constant) {
    // If constant is false, return only the slope
    return [slope];
  }

  if (stats) {
    // Calculate additional statistics
    const meanX = this.arrayavg(numericXs);
    const meanY = this.arrayavg(numericYs);
    const varianceX = this.arrayvariance(numericXs);
    const ssTotal = numericYs.reduce((sum, value) => sum + Math.pow(value - meanY, 2), 0);
    const ssResidual = numericYs.reduce((sum, value, index) => sum + Math.pow(value - (slope * numericXs[index] + intercept), 2), 0);
    const rSquared = 1 - (ssResidual / ssTotal);

    return [slope, intercept, rSquared, ssTotal, ssResidual];
  } else {
    // Return slope and intercept only
    return [slope, intercept];
  }
};

// external data lookups
InstaCalc.prototype.fn.stock = function (symbol) {
  // save stock to locals variables... (or a local cache...)
  if (typeof symbol !== "string") {
    return undefined;
  }
  symbol = symbol.toUpperCase();

  // it's an async function, so Action.recalculate? ...
  if (typeof Action !== "undefined") {
    return Action.fn.stock(symbol);
  } else {
    return undefined;
  }
};

InstaCalc.prototype.fn.import = function (url) {
  if (typeof url !== "string") {
    return undefined;
  }

  if (typeof Action !== "undefined") {
    return Action.fn.import(url);
  } else {
    return undefined;
  }
};

InstaCalc.prototype.fn.calc = function (id) {
  console.log("calc", id);
  if (typeof id !== "string" && typeof id !== "number") {
    return undefined;
  }

  if (typeof Action !== "undefined") {
    return Action.fn.import_calc(id);
  } else {
    return undefined;
  }
};

// Excel functions
InstaCalc.prototype.fn.PMT = function (rate, nperiod, pv, fv = 0, type = 0) {
  if (rate === 0) return -(pv + fv) / nperiod;

  var pvif = Math.pow(1 + rate, nperiod);
  var pmt = (rate / (pvif - 1)) * -(pv * pvif + fv);

  if (type === 1) {
    pmt /= 1 + rate;
  }

  return pmt;
};

InstaCalc.prototype.fn.IPMT = function (rate, per, nper, pv, fv = 0, type = 0) {
  let pmt = this.PMT(rate, nper, pv, fv, type);
  let ipmt = 0;

  if (per === 1) {
    if (type === 1) {
      ipmt = 0;
    } else {
      ipmt = -pv;
    }
  } else {
    if (type === 1) {
      ipmt = this.FV(rate, per - 2, pmt, pv, type) - pmt;
    } else {
      ipmt = this.FV(rate, per - 1, pmt, pv, type);
    }
  }

  return ipmt * rate;
};

InstaCalc.prototype.fn.PPMT = function (rate, per, nper, pv, fv = 0, type = 0) {
  if (per < 1 || per >= nper + 1) return null;
  let pmt = this.PMT(rate, nper, pv, fv, type);
  let ipmt = this.IPMT(rate, per, nper, pv, fv, type);
  return pmt - ipmt;
};

InstaCalc.prototype.fn.ISPMT = function (rate, per, nper, pv) {
  if (per < 1 || per > nper) {
    return "Error: Period must be between 1 and total number of periods";
  }

  return pv * rate * (per / nper - 1);
};

// PV (Present Value) function
InstaCalc.prototype.fn.PV = function (rate, nper, pmt, fv = 0, type = 0) {
  return rate === 0
    ? -pmt * nper - fv
    : (((1 - Math.pow(1 + rate, nper)) / rate) * pmt * (1 + rate * type) - fv) / Math.pow(1 + rate, nper)
};


// FV (Future Value) function
InstaCalc.prototype.fn.FV = function (rate, nper, pmt, pv = 0, type = 0) {
  if (rate === 0) {
    return -1 * (pv + pmt * nper);
  }
  var pvif = Math.pow(1 + rate, nper);
  var fv = (pmt * (1 + rate * type) * (1 - pvif) / rate) - pv * pvif;
  return fv;
};

InstaCalc.prototype.fn.RRI = function (nper, pv, fv) {
  return Math.pow(fv / pv, 1 / nper) - 1;
};

InstaCalc.prototype.fn.RATE = function (nper, pmt, pv, fv = 0, type = 0, guess = 0.1) {
  let result = InstaCalc.LIB.RATE(nper, pmt, pv, fv, type, guess);
  return typeof result === "number" ? result : undefined;
};

InstaCalc.prototype.fn.NPER = function (rate, pmt, pv, fv = 0, type = 0) {
  if (rate === 0) {
    return - (pv + fv) / pmt;
  }

  let pvif = (pmt * (1 + rate * type) - fv * rate) / (pv * rate + pmt * (1 + rate * type));
  return Math.log(pvif) / Math.log(1 + rate);
};

InstaCalc.prototype.fn.CAGR = function (startingValue, endingValue, periods) {
  if (startingValue > 0 && endingValue > 0 && periods > 0) {
    let value = Math.pow(endingValue / startingValue, 1 / periods) - 1;
    return IC.makeICObject(value, "", "percent");
  }

  return null;
};

InstaCalc.prototype.fn.PDURATION = function (rate, pv, fv) {
  if (rate === 0) {
    return undefined;
  }

  return Math.log(fv / pv) / Math.log(1 + rate);
};

// IRR (Internal Rate of Return) function
InstaCalc.prototype.fn.arrayIRR = function (data, guess = 0.1) {
  let values = this.extractNumericValuesAsFlatArray(data);
  let result = InstaCalc.LIB.IRR(values, guess);
  return typeof result === "number" ? result : undefined;
};

// net present value
InstaCalc.prototype.fn.arrayNPV = function (rate, cashFlows) {
  if (typeof rate !== 'number' || cashFlows.length === 0) {
    throw new Error("Invalid input: Need a numeric rate and at least one cash flow value");
  }

  let values = this.extractNumericValuesAsFlatArray(cashFlows);

  let npv = values.reduce((npv, cf, index) => {
    return npv + cf / Math.pow(1 + rate, index + 1);
  }, 0);

  // round to 2 decimal places
  npv = Math.round(npv * 100) / 100;
  return npv;
};

InstaCalc.prototype.fn.arraylength = function (a) {
  let values = this.extractNumericValuesAsFlatArray(a);
  return values.length;
};

InstaCalc.prototype.fn.arrayfirst = function (a) {
  let values = this.extractNumericValuesAsFlatArray(a);
  return values.length > 0 ? values[0] : undefined;
};

InstaCalc.prototype.fn.arraylast = function (a) {
  let values = this.extractNumericValuesAsFlatArray(a);
  return values.length > 0 ? values[values.length - 1] : undefined;
};

// do unit conversion on the base number. allows for functions in case you are doing things like fahrenheit to celcius, etc.
InstaCalc.prototype.conversion = function (a, b) {
  if (typeof b == "number") {
    // no conversion
    return a * b;
  }

  if (typeof b == "function") {
    return b(a);
  }

  return a;
};

// finds whether string exists a type of unit
// InstaCalc.isUnit("meter") returns distance object
InstaCalc.prototype.isUnit = function (str, nocache = false) {
  this.unitMatchCache ||= {};

  let key = `isUnit:${str}:${InstaCalc.getUnitTimeStamp()}`;

  if (!nocache && this.unitMatchCache.hasOwnProperty(key)) {
    return this.unitMatchCache[key];
  }

  // hasOwnProperty, so 'length' doesn't return true
  let ret;

  // default properties in the Unit object
  if (str.match(/^(name|base|SI)$/i)) {
    ret = false;
  }
  else {
    ret = Object.values(InstaCalc.Unit).find(unit => unit.hasOwnProperty(str)) || false;
  }

  if (!nocache) {
    this.unitMatchCache[key] = ret;
  }

  return ret;
};


// get conversion factor when translating between "from" and "to"
InstaCalc.prototype.convertUnitScale = function (from, to) {
  var objFrom = this.isUnit(from);
  var objTo = this.isUnit(to);

  if (!objFrom || !objTo) {
    return 1; // no conversion
  } else {
    return objFrom[fromRate] / objTo[toRate];
  }
};

// return power of unit
InstaCalc.prototype.getUnitPower = function (str) {
  var Unit = InstaCalc.Unit;
  var re;

  this.unitMatchCache ||= {};
  let key = str + "getUnitPower:" + InstaCalc.getUnitTimeStamp();
  if (this.unitMatchCache.hasOwnProperty(key)) {
    return this.unitMatchCache[key];
  }

  // area units - replace ^2 with "sq"
  str = str.replace("^2", " sq");
  str = str.replace("^3", " cu");
  str = str.replace("sq.", "sq");
  str = str.replace("cu.", "cu");

  for (var i = 0; i < InstaCalc.Unit.area.length; i++) {
    re = new RegExp("\\b" + Unit.area[i] + "\\b", "gi");
    if (str.match(re)) {
      str = InstaCalc.strtrim(str.replace(re, ""));
      return this.unitMatchCache[key] = [str, 2];
    }
  }

  // volume units
  for (var i = 0; i < Unit.volume.length; i++) {
    re = new RegExp("\\b" + Unit.volume[i] + "\\b", "gi");
    if (str.match(re)) {
      str = InstaCalc.strtrim(str.replace(re, ""));
      return this.unitMatchCache[key] = [str, 3];
    }
  }

  return this.unitMatchCache[key] = [str, 1]; // same string, default power
};

// check whether from^fpow == to^topow in correct units (returns true)
// for example, m^2 can be compared with acre, cm^3 with ml
// otherwise, if same pluralized unit "bubbles" and "bubbles", then return true
InstaCalc.prototype.unitMatch = function (from, frompow, to, topow) {
  var fromObj = InstaCalc.prototype.isUnit(from); // get unit types
  var toObj = InstaCalc.prototype.isUnit(to);

  if (!fromObj || !toObj) {
    if (frompow != topow) {
      return false; // different dimensions
    }

    // units don't exist in library
    // are these pluralized units the same?
    // cow == cow == cows
    var fromPlural = Inflector.pluralize(Inflector.pluralize(from)); // pluralize twice because mouse -> mice -> mices
    var toPlural = Inflector.pluralize(Inflector.pluralize(to)); // want to compare mouse and mice

    var fromSingular = Inflector.singularize(from);
    var toSingular = Inflector.singularize(to);

    return (fromPlural == toPlural || fromSingular == toSingular);
  }

  // ok these are official units. If they are the same type and power, we are done.
  // check whether fromObj and toObj are the same??? Easy check, right? For currency as well
  if (fromObj == toObj && frompow == topow) {
    return true;
  }

  // see if names and powers match directly
  /*
    if (fromObj['name'] == toObj['name'] && frompow == topow){
      return true;
    }
    */

  // final check -- see if they are both SI units that can be converted
  if (!fromObj.SI || !toObj.SI) {
    return false; // not SI units... cannot be compared
  }

  // see if units * power are equal for every item in fromObj -- for example, acre into cm^2
  for (var i in fromObj.SI) {
    // for each SI unit...
    if (fromObj.SI[i] * frompow != toObj.SI[i] * topow) {
      // make sure powers match: meters * 3 = L (which has meters = 3)
      return false;
    }
  }

  // and now the reverse...
  for (var i in toObj.SI) {
    // for each SI unit...
    if (fromObj.SI[i] * frompow != toObj.SI[i] * topow) {
      // make sure powers match
      return false;
    }
  }

  return true;
};

InstaCalc.prototype.unitMatch = (function () {
  const cache = new Map();

  const logic = function (from, frompow, to, topow) {
    // original function body
    var fromObj = InstaCalc.prototype.isUnit(from);
    var toObj = InstaCalc.prototype.isUnit(to);
    if (!fromObj || !toObj) {
      if (frompow != topow) {
        return false;
      }

      var fromPlural = Inflector.pluralize(Inflector.pluralize(from));
      var toPlural = Inflector.pluralize(Inflector.pluralize(to));

      var fromSingular = Inflector.singularize(from);
      var toSingular = Inflector.singularize(to);

      return (fromPlural == toPlural || fromSingular == toSingular);
    }

    if (fromObj === toObj && frompow === topow) return true;
    if (!fromObj.SI || !toObj.SI) return false;

    const allKeys = [...new Set([...Object.keys(fromObj.SI), ...Object.keys(toObj.SI)])];
    return allKeys.every(i => fromObj.SI[i] * frompow === toObj.SI[i] * topow);
  };

  return function (from, frompow, to, topow) {
    const key = `${from},${frompow},${to},${topow}`;
    if (cache.has(key)) {
      return cache.get(key);
    }

    const result = logic(from, frompow, to, topow);
    cache.set(key, result);
    return result;
  };
})();

// parse string and populate unit sections
// "3 miles/2 gallons in 3 km/liter"
// return object with from, fromRate, to, toRate, label properties
// later these items become actual objects... but right now, from, etc. are text
InstaCalc.prototype.parseUnitObject = function (str) {
  var a = this.splitUnits(str);

  return {
    from: a[0],
    fromRate: a[1],
    to: a[2],
    toRate: a[3],
    label: a[4],
  };
};

// split string: from/fromRate into to/toRate
// fromRate and toRate are optional
// returns array: [from, fromRate, to, toRate]
InstaCalc.prototype._splitUnits = function (str) {
  var Unit = InstaCalc.Unit;

  //str = str.toLowerCase(); // make string lowercase; -- why?
  // remove safe prepend
  var re = new RegExp(InstaCalc.safeprepend, "g");
  str = str.replace(re, "");
  var tmp;

  // InstaCalc.unitlabel = "";        // reset unit label
  InstaCalc.unitlabel = ""; // reset the label for this item
  re = new RegExp(/\bper\b/gi); // replace per with slash
  str = str.replace(re, "/");

  str = str.replace(/\bfor\b/gi, "/"); // "every", "until", "for" are all units of rate
  str = str.replace(/\bevery\b/gi, "/");
  str = str.replace(/\beach\b/gi, "/");
  str = str.replace(/\buntil\b/gi, "/");

  // replace spelled out numbers
  str = str.replace(/\bthousand\b/, "1000");
  str = str.replace(/\bmillion\b/, "1000000");
  str = str.replace(/\bbillion\b/, "1000000000");
  str = str.replace(/\btrillion\b/, "1000000000000");

  // allow [in, into, as, to] for the converion verb
  if (str.match(/\s+in\s+/i)) {
    tmp = str.split(/\s+in\s+/i); // 300 x IN y
  } else if (str.match(/\s+into\s+/i)) {
    tmp = str.split(/\s+into\s+/i); // 300 x IN y
  } else if (str.match(/\s+as\s+/i)) {
    tmp = str.split(/\s+as\s+/i); // 300 x IN y
  } else if (str.match(/\s+to\s+/i)) {
    tmp = str.split(/\s+to\s+/i); // 300 x IN y
  } else if (str.match(/\s+en\s+/i)) {
    tmp = str.split(/\s+en\s+/i); // 300 x IN y
  } else {
    return null; // no conversion to do
  }

  if (tmp.length < 2) {
    return null; // no conversion
  }

  // BUGFIX: need to trim string, otherwise extra spaces causes errors & the lookup doesn't work
  var from = InstaCalc.strtrim(tmp[0].toLowerCase()); // from X
  var fromScale = 1; // miles/hour (hour) -- assume default of 1
  var to = InstaCalc.strtrim(tmp[1].toLowerCase()); // into Y
  var toScale = 1; // feet/sec (sec) -- assume default of 1
  // replace the aliases
  if (Unit.alias[from]) {
    from = Unit.alias[from];
  }
  if (Unit.alias[to]) {
    to = Unit.alias[to];
  }

  // now, from could be m/s (meters per sec) or mph
  var matchesFrom;
  var matchesTo;

  var fromRate = "unity";
  var toRate = "unity";

  if ((matchesFrom = from.match(/(.+)\/(.+)/)) && (matchesTo = to.match(/(.+)\/(.+)/))) {
    from = InstaCalc.strtrim(matchesFrom[1]);
    to = InstaCalc.strtrim(matchesTo[1]);

    fromRate = InstaCalc.strtrim(matchesFrom[2]); // set new units for fromRate, to Rate
    toRate = InstaCalc.strtrim(matchesTo[2]);
  }

  var label = tmp[1]; // before the upper/lower case
  return [from, fromRate, to, toRate, label];
};

InstaCalc.prototype.splitUnits = (function () {
  const cache = new Map();
  return function (str) {
    return cache.get(str) || cache.set(str, InstaCalc.prototype._splitUnits(str)).get(str);
  };
})();

// return true if from and to units are actually conversion functions
InstaCalc.prototype.isConversionFunction = function (from, to) {
  var fromObj = this.isUnit(from);
  var toObj = this.isUnit(to);

  // they are the same conversion object, and it is a conversion function
  if (fromObj == toObj && fromObj.conversion == "function") {
    return fromObj;
  }

  return false;
};

// Parses object and determines powers of units
// Input: object o with these properties: o.from, o.fromRate,  o.to, o.toRate
// And returns object with these properties: o.from.unit, o.from.power... (for each of the above)
InstaCalc.prototype.getUnitPowers = function (obj) {
  var conversion = {};
  conversion.from = {};
  conversion.to = {};
  conversion.fromRate = {};
  conversion.toRate = {};

  // get unit powers
  var a = this.getUnitPower(obj.from);
  conversion.from.unit = a[0];
  conversion.from.power = a[1];

  var b = this.getUnitPower(obj.to);
  conversion.to.unit = b[0];
  conversion.to.power = b[1];

  // get rate powers
  a = this.getUnitPower(obj.fromRate);
  conversion.fromRate.unit = a[0];
  conversion.fromRate.power = a[1];

  b = this.getUnitPower(obj.toRate);
  conversion.toRate.unit = b[0];
  conversion.toRate.power = b[1];

  return conversion;
};

// Takes conversion unit (from above) and returns an object with two scaling factors:
// obj.scale.from and obj.scale.to
// For example, 3 miles/2 hours into 3 miles / 8 hours will get a obj.scale.from (= 3 /2) and obj.scale.to (=3/8)
InstaCalc.prototype.getScalingFactors = function (inputObj) {
  var scale = {};
  scale.from = 1;
  scale.to = 1;

  var obj = {};

  obj = inputObj; // make a copy
  // from.unit == "3 cows". Parse out the 3 and scale appropriately
  obj.from.scale = 1;
  var num = obj.from.unit.match(/[.,\d]+/);
  if (num) {
    var tmp = this.parseNumber(num[0]); // need to scale entire result by this.
    obj.from.unit = obj.from.unit.replace(/[.,\d]+\s*/, "");

    obj.from.scale = tmp;
    scale.from *= tmp; // this increases scale
  }

  // being messed up by parseNumber currently...
  obj.fromRate.scale = 1;
  var num = obj.fromRate.unit.match(/[.,\d]+/);
  if (num) {
    var tmp = this.parseNumber(num[0]); // need to scale entire result by this.
    obj.fromRate.unit = obj.fromRate.unit.replace(/[.,\d]+\s*/, "");

    obj.fromRate.scale = tmp;
    scale.from *= 1 / tmp; // this diminishes
  }

  obj.to.scale = 1;
  num = obj.to.unit.match(/[.,\d]+/);
  if (num) {
    var tmp = this.parseNumber(num[0]); // need to scale entire result by this.
    obj.to.unit = obj.to.unit.replace(/[.,\d]+\s*/, "");

    obj.to.scale = tmp;
    scale.to *= tmp; // this increases scale?
  }

  obj.toRate.scale = 1;
  num = obj.toRate.unit.match(/[.,\d]+/);
  if (num) {
    var tmp = this.parseNumber(num[0]); // need to scale entire result by this.
    obj.toRate.unit = obj.toRate.unit.replace(/[.,\d]+\s*/, "");

    obj.toRate.scale = tmp;
    scale.to *= 1 / tmp; // this decreases scale the scale
  }

  obj.scale = scale;
  return obj;
};

// Takes object above and returns result - whether or not the units matched
//  result.match == (true or false)
//  result.invert == (true or false) // whether we had to invert the results in order to match
//     therefore, the scale needs to be inverted as well
InstaCalc.prototype.getUnitMatches = function (inputObj) {
  var matchFailed = false;
  var ret = {
    match: false,
    invert: false,
  };

  var obj = {};

  obj = inputObj;
  obj.inverted = false;

  if (!this.unitMatch(obj.from.unit, obj.from.power, obj.to.unit, obj.to.power)) {
    matchFailed = true;
  }

  if (!this.unitMatch(obj.fromRate.unit, obj.fromRate.power, obj.toRate.unit, obj.toRate.power)) {
    matchFailed = true;
  }

  // Ok, the match failed, but try to invert them to see if it works
  if (matchFailed) {
    var fromInverted = this.unitMatch(obj.from.unit, obj.from.power, obj.toRate.unit, obj.toRate.power);
    var toInverted = this.unitMatch(obj.to.unit, obj.to.power, obj.fromRate.unit, obj.fromRate.power);

    if (fromInverted && toInverted) {
      // they are both inverted... so invert units to make it normal again
      obj.inverted = true;
    } else {
      // nope, didn't work. error out
      return null;
    }
  }

  return obj;
};

// return unit conversion if found, 1 otherwise
InstaCalc.prototype.getUnitConversion = function (unitstr) {
  const obj = this.isUnit(unitstr) || this.isUnit(unitstr.toLowerCase());
  return obj ? (obj[unitstr] || obj[unitstr.toLowerCase()]) : 1;
};

// take object above, with all scaling information, and return a conversion unit
//  this conversion can be a function or simply a value to scale by
InstaCalc.prototype.getConversionFactor = function (inputObj) {
  var obj = inputObj;
  var n; // number we are to scale
  var unit;

  /***********************************************
      Scale * From Top                     Scale *  To Top
      ----------------------   into     ----------------------
       Scale * From Bottom                Scale * To Bottom
       ************************************************/
  n = this.getUnitConversion(obj.from.unit);
  var ft = Math.pow(n, obj.from.power); // from top
  n = this.getUnitConversion(obj.fromRate.unit);
  var fb = Math.pow(n, obj.fromRate.power); // from bottom
  n = this.getUnitConversion(obj.to.unit);
  var tt = Math.pow(n, obj.to.power); // to top
  n = this.getUnitConversion(obj.toRate.unit);
  var tb = Math.pow(n, obj.toRate.power); // to top
  var fromScale = (obj.from.scale * ft) / (obj.fromRate.scale * fb);
  var toScale = (obj.to.scale * tt) / (obj.toRate.scale * tb);
  var regularScale = fromScale / toScale; // how many to's fit in a from?
  var invertedScale;

  if (obj.inverted) {
    fromScale = fromScale; // figure out what it would be on a regular scale, and flip that
    toScale = (obj.toRate.scale * tb) / (obj.to.scale * tt); // flip toRate and to, since we are inverted
    invertedScale = fromScale / toScale; // this is the factor we'd use if a regular scale... but still need to do 1/x
  }

  // other scaling factors come into play differently
  if (obj.inverted) {
    return function (x) {
      return 1 / (x * invertedScale);
    }; // return function to muliply by x and invert
  } else {
    return regularScale; // return static conversion factor. can also return function, but not needed.
  }
};

// return a number returning how to scale these units
InstaCalc.prototype._getUnitScale = function (from, fromRate, to, toRate) {
  var obj = {
    from: from,
    fromRate: fromRate,
    to: to,
    toRate: toRate,
  };

  obj = this.getUnitPowers(obj);
  if (!obj) {
    return null; // check value in case of an error
  }

  obj = this.getScalingFactors(obj);
  if (!obj) {
    return null;
  }

  obj = this.getUnitMatches(obj);
  if (!obj) {
    return null; // no matches found
  }

  // return composite function if it's a non-linear conversion
  var fnObj;
  if ((fnObj = this.isConversionFunction(from, to))) {
    var fromFn = fnObj[from][0];
    var toFn = fnObj[to][1];
    var composite = function (x) {
      return toFn(fromFn(x));
    };
    return composite;
  }

  return this.getConversionFactor(obj);
};

InstaCalc.prototype.getUnitScale = (function () {
  const cache = new Map();
  return function (from, fromRate, to, toRate) {
    const key = `${from}-${fromRate}-${to}-${toRate}`;
    return cache.get(key) || cache.set(key, InstaCalc.prototype._getUnitScale(from, fromRate, to, toRate)).get(key);
  };
})();

// convert units. Example: 300 x in y
// 300 feet in meters
InstaCalc.conversionCache = {};

InstaCalc.prototype.convertUnit = function (str) {
  var cached = InstaCalc.conversionCache[str];
  if (cached) {
    InstaCalc.unitlabel = cached.unitlabel;
    return cached.conversion;
  }

  var ret = this.splitUnits(str);

  if (ret == null) {
    InstaCalc.unitlabel = "";
    return 1; // no conversion
  }

  var from = ret[0];
  var fromRate = ret[1];
  var to = ret[2];
  var toRate = ret[3];
  var label = ret[4];

  //setStatus("from:" + from + " fromRate:"+ fromRate + " to:" + to + " toRate:" + toRate);
  var conversion = this.getUnitScale(from, fromRate, to, toRate);

  if (conversion == null || typeof conversion == "undefined") {
    InstaCalc.unitlabel = "";
    return 1;
  } else {
    InstaCalc.unitlabel = label;
    InstaCalc.conversionCache[str] = {
      conversion: conversion,
      unitlabel: label,
    }; // save to cache
    return conversion;
  }
};

/*********************
  Allowed Functions / Keywords - items before parens. f(x,y)
  **********************/

InstaCalc.allowedfn = {};
InstaCalc.locals = {};
InstaCalc.MAGIC_STRING = "__qweasdzxc";

InstaCalc.safeprepend = "InstaCalc.locals." + InstaCalc.MAGIC_STRING; // make it unique; will be removed in strings
InstaCalc.stringprepend = "InstaCalc__String" + InstaCalc.MAGIC_STRING; // cannot have periods
InstaCalc.resetLocals = function () {
  InstaCalc.locals = {};

  // feature: have constants be variables predefined in the environment. Lets e and E work
  InstaCalc.locals[InstaCalc.MAGIC_STRING + "pi"] = Math.PI;
  InstaCalc.locals[InstaCalc.MAGIC_STRING + "e"] = Math.E;
  InstaCalc.locals[InstaCalc.MAGIC_STRING + "phi"] = InstaCalc.prototype.cn.PHI;
};

//closure with nice js variable scoping
(function () {
  var a = InstaCalc.allowedfn; // for efficiency in object lookup & smaller code size
  a.IF = "if";
  a.ELSE_IF = "else if ";

  a.ABS = "this.fn().abs";
  a.CEIL = "Math.ceil";

  a.EXP = "this.fn().exp";
  a.FLOOR = "Math.floor";
  a.LN = a.LOGARITHM = "this.fn().log";
  a.LOG = "this.fn().log10";
  a.LOG10 = "this.fn().log10";
  a.LOG2 = "this.fn().log2";
  a.LOG1P = "Math.log1p";
  a.MAX = "Math.max";
  a.MIN = "Math.min";
  a.POWER = a.POW = "Math.pow"; // disabled because we already have A**B

  // std trig
  a.SIN = a.SINE = "this.fn().sin";
  a.COS = a.COSINE = "this.fn().cos";
  a.TAN = a.TANGENT = "this.fn().tan";
  a.SEC = a.SECANT = "this.fn().sec";
  a.CSC = a.COSECANT = "this.fn().csc";
  a.COT = a.COTANGENT = "this.fn().cot";

  // inverse trig
  a.ASIN = a.ARCSINE = "this.fn().asin";
  a.ACOS = a.ARCCOSINE = "this.fn().acos";
  a.ATAN = a.ARCTANGENT = "this.fn().atan";
  a.ATAN2 = "this.fn().atan2";
  a.ASEC = a.ARCSECANT = "this.fn().asec";
  a.ACSC = a.ARCCOSECANT = "this.fn().acsc";
  a.ACOT = a.ARCCOTANGENT = "this.fn().acot";

  a.COSH = "this.fn().cosh";
  a.SINH = "this.fn().sinh";
  a.TANH = "this.fn().tanh";
  a.COTH = "this.fn().coth";
  a.SECH = "this.fn().sech";
  a.CSCH = "this.fn().csch";

  a.ASINH = "this.fn().asinh";
  a.ACOSH = "this.fn().acosh";
  a.ATANH = "this.fn().atanh";
  a.ASECH = "this.fn().asech";
  a.ACSCH = "this.fn().acsch";
  a.ACOTH = "this.fn().acoth";

  a.SUBTRACT = "this.fn().subtract";
  a.DIVIDE = a.QUOTIENT = "this.fn().divide";
  a.MODULO = a.MODULUS = "this.fn().mod";

  a.GCD = "this.fn().gcd";
  a.LCM = "this.fn().lcm";

  a.CONVERT = "this.convertUnit";

  a.ROOT = a.SQRT = "this.fn().sqrt";
  a.ROUND = "this.fn().round";
  a.ROUNDDOWN = "Math.floor";
  a.ROUNDUP = "Math.ceil";
  a.CBRT = a.CUBEROOT = "this.fn().cbrt";

  a.INVERSE = "this.fn().inverse";
  a.INVERT = "this.fn().inverse";

  a.SQUARE = "this.fn().square";
  a.CUBE = "this.fn().cube";
  a.CUBIC = "this.fn().cube";

  a.TRUNC = a.INT = a.INTEGER = "Math.trunc";
  a.HYPOT = "Math.hypot";

  // Custom functions
  a.CHARCODE = true;
  a.FROMCHARCODE = true;
  a.FIB = "this.fn().fibonacci";
  a.FIBONACCI = "this.fn().fibonacci";
  a.FAC = "this.fn().factorial";
  a.FACTORIAL = "this.fn().factorial";
  a.GAMMA = "this.fn().gamma";
  a.NCHOOSEK = true;

  a.PRINT = "this.fn().print";

  a.TIME = true;

  // base conversion
  a.BIN = "this.fn().bin";
  a.OCT = "this.fn().oct";
  a.HEX = "this.fn().hex";
  a.DEC = "this.fn().dec";

  a.FROMBIN = "this.fn().frombin";
  a.FROMOCT = "this.fn().fromoct";

  // other math functoins
  a.RANDOM = a.RAND = "this.fn().random";

  // combination & permutation
  a.C = a.COMBINATION = a.COMBIN = "this.fn().combination";
  a.P = a.PERMUTATION = a.PERMUT = "this.fn().permutation";

  // degrees and radians
  a.DEG = true;
  a.RAD = true;

  // number parsing & cleanup
  a.PARSENUMBER = "this.parseNumber";
  a.GETROWVALUES = "this.getRowValues";
  a.GETROWVALUE = "this.getRowValue";

  // array functions
  a.MAX = "this.fn().arraymax";
  a.MIN = "this.fn().arraymin";
  a.SUM = a.ADD = a.TOTAL = a.SUBTOTAL = "this.fn().arraysum";

  a.LENGTH = "this.fn().arraylength";
  a.FIRST = "this.fn().arrayfirst";
  a.LAST = "this.fn().arraylast";

  a.PRODUCT = "this.fn().arrayproduct";
  a.MULTIPLY = a.PRODUCT;
  a.SUB = "this.fn().arraydifference"; // subtract
  a.AVERAGE = "this.fn().arrayavg";
  a.AVG = "this.fn().arrayavg";
  a.MEAN = "this.fn().arrayavg";
  a.MEDIAN = "this.fn().arraymedian";
  a.MODE = "this.fn().arraymode";
  a.GEOMEAN = "this.fn().arraygeomean";

  a.VAR = a.VARIANCE = "this.fn().arrayvariance";
  a["VAR.S"] = "this.fn().arrayvariance";
  a["VAR.P"] = "this.fn().arrayvariancePopulation";

  a.COVARIANCE = "this.fn().arraycovariance";
  a.COVAR = "this.fn().arraycovariance";
  a["COVAR.S"] = "this.fn().arraycovariance";
  a["COVAR.P"] = "this.fn().arraycovariancePopulation";
  a["COVARIANCE.S"] = "this.fn().arraycovariance";
  a["COVARIANCE.P"] = "this.fn().arraycovariancePopulation";

  a.STDDEV = "this.fn().arraystddev";
  a.STDEV = "this.fn().arraystddev";

  a["STDEV.S"] = "this.fn().arraystddev";
  a["STDEV.P"] = "this.fn().arraystddevPopulation";

  a["STDDEV.S"] = "this.fn().arraystddev";
  a["STDDEV.P"] = "this.fn().arraystddevPopulation";

  a.SKEWNESS = "this.fn().arrayskewness";
  a.SKEW = "this.fn().arrayskewness";
  a.KURTOSIS = "this.fn().arraykurtosis";
  a.KURT = "this.fn().arraykurtosis";

  a.CORREL = "this.fn().arraycorrelation";
  a.CORRELATION = "this.fn().arraycorrelation";
  a.SLOPE = "this.fn().arrayslope";
  a.INTERCEPT = "this.fn().arrayintercept";
  a.LINEST = "this.fn().arraylinest";

  a.RANGE = "this.fn().arrayrange";

  a.COUNT = "this.fn().arraycount";
  a.SORT = "this.fn().arraysort";
  a.REVERSE = "this.fn().arrayreverse";
  a.PERCENTILE = "this.fn().arraypercentile";
  a.MAP = "this.fn().arraymap";
  a.FILTER = "this.fn().arrayfilter";
  a.REDUCE = "this.fn().arrayreduce";
  a.FIND = "this.fn().arrayfind";

  a.PERCENTRANK = "this.fn().arraypercentrank";
  a.FORECAST = "this.fn().arrayforecast";
  a.CONFIDENCE = "this.fn().confidence";

  a.SEQUENCE = "this.fn().sequence";
  a.SEQ = "this.fn().sequence";

  a.FUNCTION = "function";
  a.TIME = "this.fn().time";

  a.CONVERSION = "this.conversion";
  a.STOCK = "this.fn().stock";
  a.IMPORT = "this.fn().import";
  a.CALC = "this.fn().calc";

  a.PMT = "this.fn().PMT";
  a.IPMT = "this.fn().IPMT";
  a.PPMT = "this.fn().PPMT";
  a.ISPMT = "this.fn().ISPMT";
  a.IRR = "this.fn().arrayIRR";
  a.PV = "this.fn().PV";
  a.FV = "this.fn().FV";
  a.RRI = "this.fn().RRI";
  a.RATE = "this.fn().RATE";
  a.NPER = "this.fn().NPER";
  a.CAGR = "this.fn().CAGR";
  a.PDURATION = "this.fn().PDURATION";
  a.NPV = "this.fn().arrayNPV";


  a.SIGN = "this.fn().sign";
  a.CLAMP = "this.fn().clamp";

  a.ERF = "this.fn().erf";
  a.ERFINVERSE = "this.fn().erfInverse";

  a["NORM.S.INV"] = "this.fn().normSInv";
  a["NORMSINV"] = "this.fn().normSInv";
  a["NORM.INV"] = "this.fn().normInv";
  a["NORMINV"] = "this.fn().normInv";
  a["NORM.DIST"] = "this.fn().normDist";
  a["NORMDIST"] = "this.fn().normDist";
  a["NORM.S.DIST"] = "this.fn().normSDist";
  a["NORMSDIST"] = "this.fn().normSDist";
  a["T.INV"] = "this.fn().tInv";
  a["TINV"] = "this.fn().tInv";
  a["T.DIST"] = "this.fn().tDist";
  a["TDIST"] = "this.fn().tDist";
  a["CHISQ.DIST"] = "this.fn().chisqDist";
  a["CHISQDIST"] = "this.fn().chisqDist";
  a["F.DIST"] = "this.fn().fDist";
  a["FDIST"] = "this.fn().fDist";
  a["Z.TEST"] = "this.fn().zTest";
  a["ZTEST"] = "this.fn().zTest";
  a["T.TEST"] = "this.fn().tTest";
  a["TTEST"] = "this.fn().tTest";

  a["T.DIST.2T"] = "this.fn().tDist2T";
  a["TDIST2T"] = "this.fn().tDist2T";
  a["T.DIST.RT"] = "this.fn().tDistRT";
  a["TDISTRT"] = "this.fn().tDistRT";
  a["T.INV.2T"] = "this.fn().tInv2T";
  a["TINVT2T"] = "this.fn().tInv2T";
  a["CHISQ.DIST.RT"] = "this.fn().chisqDistRT";
  a["CHISQDISTRT"] = "this.fn().chisqDistRT";
  a["CHISQ.INV"] = "this.fn().chisqInv";
  a["CHISQINV"] = "this.fn().chisqInv";
  a["CHISQ.INV.RT"] = "this.fn().chisqInvRT";
  a["CHISQINVRT"] = "this.fn().chisqInvRT";
  a["F.DIST.RT"] = "this.fn().fDistRT";
  a["FDISTRT"] = "this.fn().fDistRT";
  a["F.INV"] = "this.fn().fInv";
  a["FINV"] = "this.fn().fInv";
  a["F.INV.RT"] = "this.fn().fInvRT";
  a["FINVRT"] = "this.fn().fInvRT";

  a["BINOM.DIST"] = "this.fn().binomDist";
  a["BINOMDIST"] = "this.fn().binomDist";
  a["POISSON.DIST"] = "this.fn().poissonDist";
  a["POISSONDIST"] = "this.fn().poissonDist";
  a["GAMMA.DIST"] = "this.fn().gammaDist";
  a["GAMMADIST"] = "this.fn().gammaDist";
  a["BETA.DIST"] = "this.fn().betaDist";
  a["BETADIST"] = "this.fn().betaDist";
  a["HYPGEOM.DIST"] = "this.fn().hypgeomDist";
  a["HYPGEOMDIST"] = "this.fn().hypgeomDist";
  a["LOGNORM.DIST"] = "this.fn().lognormDist";
  a["LOGNORMDIST"] = "this.fn().lognormDist";
  a["LOGNORM.INV"] = "this.fn().lognormInv";
  a["LOGNORMINV"] = "this.fn().lognormInv";
  a["NEGBINOM.DIST"] = "this.fn().negbinomDist";
  a["NEGBINOMDIST"] = "this.fn().negbinomDist";
  a["WEIBULL.DIST"] = "this.fn().weibullDist";
  a["WEIBULLDIST"] = "this.fn().weibullDist";

  /*
  a.AREA = "this.fn().area";
  a.VOLUME = "this.fn().volume";
  a.SURFACEAREA = "this.fn().surfacearea";
  a.PERIMETER = "this.fn().perimeter";
  */

  /* Allowed Constants */
  InstaCalc.allowedcn = {};

  var c = InstaCalc.allowedcn;
  c.RANDOM = "Math.random()"; // not really a constant, but replaced by a function without parameters

  // have it be case INSENSITIVE... make all words upper-case. eliminates bad keywords as well.
  /* keywords -- replaced wherever they appear */
  InstaCalc.keywords = {};
  var k = InstaCalc.keywords;

  k.IF = "if";
  k.ELSE = "else";
  k.ELSE_IF = "else if"; // because two keywords can be merged with underscore "else if" => else_if
  //k.FUNCTION = "function";
  //k.RETURN = "return"; // return is useful as a keyword
  k.TRUE = "true";
  k.FALSE = "false";

  // valid regular expressions and how to replace them; in this order
  InstaCalc.expressions = [];

  // string replacements
  var re = new RegExp("\\b" + InstaCalc.stringprepend + "(\\d+)\\b", "g");

  InstaCalc.expressions.push([re, InstaCalc.stringprepend + "$1"]); // string replacement

  InstaCalc.expressions.push([/\band\b/gi, " & "]);
  InstaCalc.expressions.push([/\bor\b/gi, " | "]);
  InstaCalc.expressions.push([/\bnot\b/gi, " ~ "]);

  InstaCalc.expressions.push([/\bxor\b/gi, " @@ "]); // avoid conflicting with ^ for power; replace it as a postfilter; can't use @XOR@ as it could get replaced again; can't use @1@ as it will get replaced...
  InstaCalc.expressions.push([/\bmod\b/gi, " @@@ "]); // avoid conflict with %, replace in post filter

  // The very earliest processing, before even the power/exponent parsing ^
  InstaCalc.firstfilter = [];
  var f = InstaCalc.firstfilter;

  // separate digits from unit labels 15km to miles => "15 km to miles" and similar
  f.push([/\b([1-9]|[1-9.][0-9,.]+)([a-z][a-z]+)\b/gi, "$1 $2"]);

  // filter out equality expressions
  f.push([/^(.*)=(.*[)]|.*\d)\s+(([a-zA-Z].*\s+(in|as|into|to|en)\s+.*))$/gi, '$1 = CONVERSION($2, CONVERT("$3") )']); // do not allow parens in description of units, otherwise gets confused with parseNumber
  // get regular text: 3 feet in cm
  f.push([/^\s*(-?[\d()\w.,]+)\s+(([a-zA-Z].*\s+(in|as|into|to|en)\s+.*))$/gi, 'CONVERSION($1, CONVERT("$2") )']); // do not allow parens in description of units, otherwise gets confused with parseNumber
  // get parens: (3 + 4) feet in cm
  f.push([/^\s*[(](.+)[)]\s+(([a-zA-Z].*\s+(in|as|into|to|en)\s+.*))$/gi, 'CONVERSION($1, CONVERT("$2"))']);

  // stock quote - don't have AAPL become a local variable
  f.push([/\bSTOCK[(]([a-zA-Z]+)[)]/gi, 'STOCK("$1")']);
  f.push([/\bSTOCK:([a-zA-Z]+)/gi, 'STOCK("$1")']);

  // arabic numerals treated as "constants"
  // 0-9 are unicode charcodes 1632-1641 (see http://www.jdstiles.com/java/cct.html)
  // 0x0660 - 0x0669
  f.push([/\u0660/gi, "0"]);
  f.push([/\u0661/gi, "1"]);
  f.push([/\u0662/gi, "2"]);
  f.push([/\u0663/gi, "3"]);
  f.push([/\u0664/gi, "4"]);
  f.push([/\u0665/gi, "5"]);
  f.push([/\u0666/gi, "6"]);
  f.push([/\u0667/gi, "7"]);
  f.push([/\u0668/gi, "8"]);
  f.push([/\u0669/gi, "9"]);

  // allow for sin(3 * pi rad) to do the right thing
  f.push([/pi rad/gi, "180"]);

  f.push([/!=/gi, " @@@@ "]); // avoid conflict with factorial: 3 != 2, replace in post

  // general clean up string before processing
  InstaCalc.prefilter = [];
  var p = InstaCalc.prefilter;

  // fix Excel-style assignment (=a * b)
  p.push([/^\s*=\s*/, ""]); // remove  leading equals sign (= 3 + 4)
  p.push([/\s*=\s*$/, ""]); // remove trailing equals sign (3 + 4 =)

  // add or subtract percent
  p.push([/[+]\s*([0-9.,]+)%/g, " * (1 + .01 * $1)"]);
  p.push([/-\s*([0-9.,]+)%/g, " * (1 - .01 * $1)"]);

  p.push([/%\s+of\s+/gi, " * .01 * "]); // 5% of 200
  p.push([/\s*([0-9.,]+)%/g, "($1 * .01)"]); // 3 / 7% ... the % should bind to the 7, not be (3/7)%
  p.push([/%/g, " * .01"]); // some other type of percent
  p.push([/[|]([^|]+)[|]/g, "ABS($1)"]); // absolute value

  // Kilobytes, Megabytes, Gigabytes, Terabytes, etc. Allow any number
  p.push([/\b((\d|[,.])+)\s*KB\b/gi, "($1 * 1024)"]); // KB
  p.push([/\b((\d|[,.])+)\s*MB\b/gi, "($1 * 1024 * 1024)"]); // MB
  p.push([/\b((\d|[,.])+)\s*GB\b/gi, "($1 * 1024 * 1024 * 1024)"]); // GB
  p.push([/\b((\d|[,.])+)\s*TB\b/gi, "($1 * 1024 * 1024 * 1024 * 1024)"]); // TB
  p.push([/\b((\d|[,.])+)\s*PB\b/gi, "($1 * 1024 * 1024 * 1024 * 1024 * 1024)"]); // Petabyte
  p.push([/\b((\d|[,.])+)\s*KBPS\b/gi, "($1 * 1024 / 8)"]); // bandwidth - kilobits per second
  p.push([/\b((\d|[,.])+)\s*MBPS\b/gi, "($1 * 1024 * 1024 / 8)"]); // bandwidth - kilobits per second
  p.push([/\b((\d|[,.])+)\s*GBPS\b/gi, "($1 * 1024 * 1024 * 1024 / 8)"]); // bandwidth - kilobits per second

  // bugfix: NEED the \b otherwise things like 0x123b won't work correctly!
  p.push([/\b((\d|[,.])+)\s*K\b/gi, "($1 * 1e3)"]); // thousand
  p.push([/\b((\d|[,.])+)\s*M\b/gi, "($1 * 1e6)"]); // million
  p.push([/\b((\d|[,.])+)\s*B\b/gi, "($1 * 1e9)"]); // billion
  p.push([/\b((\d|[,.])+)\s*T\b/gi, "($1 * 1e12)"]); // trillion
  p.push([/((\d|[,.])+)\s*thousand\b/gi, "($1 * 1e3)"]); // thousand
  p.push([/((\d|[,.])+)\s*million\b/gi, "($1 * 1e6)"]); // million
  p.push([/((\d|[,.])+)\s*billion\b/gi, "($1 * 1e9)"]); // billion
  p.push([/((\d|[,.])+)\s*trillion\b/gi, "($1 * 1e12)"]); // trillion
  p.push([/\s+rad\b/gi, "* 180 / PI"]); // radian
  p.push([/\b([0-9.,]+)rad\b/gi, "$1 * 180 / PI"]); // radian (no spaces, just number)

  p.push([/\s+deg\b/gi, ""]); // degrees - ignore

  // Are these wanted features? Allowing 34x, (34x + 4)y... etc.?
  // any identifier prefixed by numbers: 124x becomes 124 * x
  //p.push( [/((\d|[,.])+)\s*([_a-zA-Z]+)\b/ig, "($1 * $3)"]); // any identifier
  // problems happen when using hex - 0xfe looks for a variable "0 * xfe" ... need to filter out 0x..., since 0 is nonsensical anyway... hrm.
  // 34(3+4) becomes 34 * (3+4)

  p.push([/\b0[bB]([01]+)/g, "FROMBIN('0b$1')"]); // 0b101010101 binary format; still needs to be parsed
  p.push([/\b0[oO]([01234567]+)/g, "FROMOCT('0o$1')"]); // 0o101010101 octal format

  // convert log_2(x) to (1/log(2))*log(x) -- happens before parsenumber
  p.push([/\blog_(.+)[(](.+)[)]/gi, "(log($2)/log($1))"]);

  // capture either regular numbers (0-9 with decimals and commas) or those followed by scientific notation (e+10...)
  p.push([/((\b|[.])+[0-9.,]+((e|e-|e+)[0-9]+)?)\b/gi, 'PARSENUMBER("$1")']);

  // regular "e" not working... need to fix that.
  p.push([/\bR(\d+):R(\d+)\b/gi, "getRowValues($1,$2)"]); // ROW1:ROW3
  p.push([/\bR(\d+),R(\d+)\b/gi, "getRowValues($1,$2)"]); // R1,R2 (because colon substituted)
  p.push([/\bR(\d+)\b/gi, "getRowValue($1 - 1)"]); // R1 by itself
  p.push([/\brandom\b/gi, "RANDOM"]); // capitalize random

  InstaCalc.postfilter = [];

  // for units that aren't explicitly done -- "x = 37 smiles/day"
  InstaCalc.postfilter.push([/([)])\s+(([a-z][^0123456789]+))$/gi, '$1 * this.convertUnit("$2")']); // do not allow parens in description of units, otherwise gets confused with parseNumber
  InstaCalc.postfilter.push([/[=]\s*[?]\s/, " to "]); // "100 feet = ? miles" => "100 feet to miles"
  // TODO: clean this up. it's a last resort, doesn't quite handle the conversion properly!!!
  // InstaCalc.postfilter.push( [/^(-?[\d.,]+)\s+(([a-zA-Z].*\s+(in|as|into|to)\s+.*))$/g, "CONVERSION($1, CONVERT(\"$2\") )"]);
  // replace constants

  InstaCalc.postfilter.push([/@@@@/gi, " != "]); // return != back to normal
  InstaCalc.postfilter.push([/@@@/gi, " % "]); // return MOD back to normal
  InstaCalc.postfilter.push([/@@/gi, " ^ "]); // return XOR back to normal


  // add in unit prefixes for base units
  let Units = [
    "mass:gram|grams|g",
    "length:meter|meters|m",
    "time:second|seconds|sec|s",
    "liquid:liter|liters|litre|litres|L",
    "energy:joule|joules|eV|calorie|cal|J",
    "power:watt|watts|W",
    "force:newton|newtons|N",
    "pressure:pascal|pascals|bar|bars|Pa",
    "electric_charge:coulomb|coulombs|C",
    "electric_potential:volt|volts|V",
    "electric_capacitance:farad|farads|F",
    "electric_resistance:ohm|ohms|Ω",
    "electric_conductance:siemens",
    "electric_current:ampere|amperes|amp|amps|A",
    "magnetic_flux:weber|webers|Wb",
    "magnetic_flux_density:tesla|teslas",
    "electric_inductance:henry|henrys",
    "luminous_flux:lumen|lumens|lm",
    "illuminance:lux",
    "luminous_intensity:candela|cd",
    "radioactivity:becquerel|becquerels|Bq",
    "absorbed_dose:gray|grays|Gy",
    "equivalent_dose:sievert|sieverts|Sv",
    "catalytic_activity:katal|katals|kat",
    "molar_concentration:molar",

    "freq:hz|hertz",
  ];

  let Prefixes = [
    "quetta|Q|1e30",
    "ronna|R|1e27",
    "yotta|Y|1e24",
    "zetta|Z|1e21",
    "exa|E|1e18",
    "peta|P|1e15",
    "tera|T|1e12",
    "giga|G|1e9",
    "mega|M|1e6",
    "kilo|k|1e3",
    "hecto|h|1e2",
    "deca|da|1e1",
    "deci|d|1e-1",
    "centi|c|1e-2",
    "milli|m|1e-3",
    "micro|µ|1e-6",
    "micro|u|1e-6",
    "nano|n|1e-9",
    "pico|p|1e-12",
    "femto|f|1e-15",
    "atto|a|1e-18",
    "zepto|z|1e-21",
    "yocto|y|1e-24",
    "ronto|r|1e-27",
    "quecto|q|1e-30"
  ];

  // lowercase to uppercase
  let OrderedPrefixes = Prefixes.reverse();

  // do not populate these -- they must be defined explicitly
  let Exceptions = {
    "pa": 1, // pa = Pascal, not picoAmp
    "ma": 1, // ma = milliAmp, not megaAmp
    "ha": 1, // ha = hectare, not hectaAmp
    "f": 1, // fahrenheit, not Farad,
    "c": 1, // celsius, not coulomb

    "cf": 1, //cubic foot, not centi-farad

    "ac": 1, //acre, not charge
    "cc": 1, //cubic centimeter, not centi-coulomb
    "ev": 1, //electron volt, not exavolt
    "pv": 1, // present value, not picovolt
    "fv": 1, // future value, not femtovolt
    "gs": 1, //grams, not gigasecond
    "gm": 1, //grams, not gigameter
  };

  // official spelling: w => W
  Unit.canonicalName = (function () {
    const cache = new Map();

    return function (unit) {
      if (cache.has(unit)) {
        return cache.get(unit);
      }

      for (const unitDef of Units) {
        const [_, unitNames] = unitDef.split(":");
        const names = unitNames.split("|");

        for (const name of names) {
          if (name.toLowerCase() === unit.toLowerCase()) {
            const correctedUnit = name;
            cache.set(unit, correctedUnit);
            return correctedUnit;
          }
        }
      }

      // If no match found, return the original unit string
      cache.set(unit, unit);
      return unit;
    };
  })();

  // find any units without SI, which mightb a mistake
  Unit.findMissngSI = function () {
    Object.keys(Unit).forEach(key => !Unit[key].SI && console.log(`Unit.${key} does not have an SI property.`));
  };

  // log overlapping units to console
  Unit.findOverlaps = function () {
    let overlaps = {};
    let unitNames = {};

    for (let category in Unit) {
      if (Unit.hasOwnProperty(category) && typeof Unit[category] === 'object') {
        for (let unit in Unit[category]) {
          if (Unit[category].hasOwnProperty(unit) && unit !== 'SI' && unit !== 'name') {
            if (!unitNames[unit]) {
              unitNames[unit] = [category];
            } else {
              unitNames[unit].push(category);
            }
          }
        }
      }
    }

    for (let unit in unitNames) {
      if (unitNames[unit].length > 1) {
        overlaps[unit] = unitNames[unit];
      }
    }

    for (let overlap in overlaps) {
      console.log(`Unit "${overlap}" appears in categories: ${overlaps[overlap].join(', ')}`);
    }
  };

  Units.forEach((unit) => {
    // split into type and names
    let [type, allnames] = unit.split(":");
    let names = allnames.split("|");

    OrderedPrefixes.forEach((SIprefix) => {
      let [prefix, symbol, multiplier] = SIprefix.split("|");

      let baseScale = null;

      names.forEach((name) => {
        let fullname = prefix + name;
        let fullsymbol = symbol + name;

        if (Exceptions[fullsymbol.toLowerCase()]) {
          return;
        }

        // take first entry to lookup scale
        baseScale = Unit[type][name] || Unit[type][name.toLowerCase()] || baseScale;

        // if a unit entry is already defined in the Unit object, no assignments are needed
        if (!Unit[type][fullname]) {
          // otherwise, fill in the unit definition. be case sensitive, so MPa is Megapascal, and mPa is micropascal.
          Unit[type][fullname] = baseScale * Number(multiplier);
        }

        if (symbol) {
          Unit[type][fullsymbol] ||= baseScale * Number(multiplier);
          Unit[type][fullsymbol.toLowerCase()] ||= baseScale * Number(multiplier);
        }
      });
    });
  });

  /*
    Units.forEach((unit) => {
      // split into type and names
      let [type, allnames] = unit.split(":");
      let names = allnames.split("|");
  
      // fill out prefixes -- go from lowercase to uppercase
      Prefixes.reverse().forEach((SIprefix) => {
        let [prefix, symbol, multiplier] = SIprefix.split("|");
  
        let baseScale = null;
  
        names.forEach((name) => {
          let fullname = (prefix + name).toLowerCase();
          let fullsymbol = (symbol + name).toLowerCase();
  
          if (Exceptions[fullsymbol]) {
            return;
          }
  
          // take first entry to lookup scale
          baseScale = Unit[type][name] || Unit[type][name.toLowerCase()] || baseScale;
  
          Unit[type][fullname] ||= baseScale * Number(multiplier);
          if (symbol) {
            Unit[type][fullsymbol] ||= baseScale * Number(multiplier);
          }
        });
      });
    });
    */

})();

// https://github.com/formulajs/formulajs/blob/master/src/financial.js
InstaCalc.LIB ||= {};
/**
 * Returns the internal rate of return for a series of cash flows.
 *
 * Category: Financial
 *
 * @param {*} values An array or a reference to values that contain numbers for which you want to calculate the internal rate of return.
 - Values must contain at least one positive value and one negative value to calculate the internal rate of return.
 - IRR uses the order of values to interpret the order of cash flows. Be sure to enter your payment and income values in the sequence you want.
 - If an array or reference argument contains text, logical values, or empty values, those values are ignored.
 * @param {*} guess Optional. A number that you guess is close to the result of IRR.
 - Microsoft Excel uses an iterative technique for calculating IRR. Starting with guess, IRR cycles through the calculation until the result is accurate within 0.00001 percent. If IRR can't find a result that works after 20 tries, the #NUM! error value is returned.
 - In most cases you do not need to provide guess for the IRR calculation. If guess is omitted, it is assumed to be 0.1 (10 percent).
 - If IRR gives the #NUM! error value, or if the result is not close to what you expected, try again with a different value for guess.
 * @returns
 */

InstaCalc.LIB.IRR = function (values, guess) {
  // Credits: algorithm inspired by Apache OpenOffice
  guess = guess || 0

  // Calculates the resulting amount
  const irrResult = (values, dates, rate) => {
    const r = rate + 1
    let result = values[0]

    for (let i = 1; i < values.length; i++) {
      result += values[i] / Math.pow(r, (dates[i] - dates[0]) / 365)
    }

    return result
  }

  // Calculates the first derivation
  const irrResultDeriv = (values, dates, rate) => {
    const r = rate + 1
    let result = 0

    for (let i = 1; i < values.length; i++) {
      const frac = (dates[i] - dates[0]) / 365
      result -= (frac * values[i]) / Math.pow(r, frac + 1)
    }

    return result
  }

  // Initialize dates and check that values contains at least one positive value and one negative value
  const dates = []
  let positive = false
  let negative = false

  for (let i = 0; i < values.length; i++) {
    dates[i] = i === 0 ? 0 : dates[i - 1] + 365

    if (values[i] > 0) {
      positive = true
    }

    if (values[i] < 0) {
      negative = true
    }
  }

  // Return error if values does not contain at least one positive value and one negative value
  if (!positive || !negative) {
    return undefined;
  }

  // Initialize guess and resultRate
  guess = guess === undefined ? 0.1 : guess
  let resultRate = guess

  // Set maximum epsilon for end of iteration
  const epsMax = 1e-10

  // Implement Newton's method
  let newRate, epsRate, resultValue
  let contLoop = true
  do {
    resultValue = irrResult(values, dates, resultRate)
    newRate = resultRate - resultValue / irrResultDeriv(values, dates, resultRate)
    epsRate = Math.abs(newRate - resultRate)
    resultRate = newRate
    contLoop = epsRate > epsMax && Math.abs(resultValue) > epsMax
  } while (contLoop)

  // Return internal rate of return
  return resultRate
}

/**
 * Returns the interest rate per period of an annuity.
 *
 * Category: Financial
 *
 * @param {*} nper The total number of payment periods in an annuity.
 * @param {*} pmt The payment made each period and cannot change over the life of the annuity. Typically, pmt includes principal and interest but no other fees or taxes. If pmt is omitted, you must include the fv argument.
 * @param {*} pv The present value — the total amount that a series of future payments is worth now.
 * @param {*} fv Optional. The future value, or a cash balance you want to attain after the last payment is made. If fv is omitted, it is assumed to be 0 (the future value of a loan, for example, is 0). If fv is omitted, you must include the pmt argument.
 * @param {*} type Optional. The number 0 or 1 and indicates when payments are due.
 * @param {*} guess Optional. Your guess for what the rate will be. If you omit guess, it is assumed to be 10 percent. If RATE does not converge, try different values for guess. RATE usually converges if guess is between 0 and 1.
 - If you omit guess, it is assumed to be 10 percent.
 - If RATE does not converge, try different values for guess. RATE usually converges if guess is between 0 and 1.
 * @returns
 */
InstaCalc.LIB.RATE = function (nper, pmt, pv, fv, type, guess) {
  guess = guess === undefined ? 0.01 : guess
  fv = fv === undefined ? 0 : fv
  type = type === undefined ? 0 : type

  const epsMax = 1e-10
  const iterMax = 20
  let rate = guess

  type = type ? 1 : 0

  for (let i = 0; i < iterMax; i++) {
    if (rate <= -1) {
      return undefined
    }

    let y, f

    if (Math.abs(rate) < epsMax) {
      y = pv * (1 + nper * rate) + pmt * (1 + rate * type) * nper + fv
    } else {
      f = Math.pow(1 + rate, nper)
      y = pv * f + pmt * (1 / rate + type) * (f - 1) + fv
    }

    if (Math.abs(y) < epsMax) {
      return rate
    }

    let dy

    if (Math.abs(rate) < epsMax) {
      dy = pv * nper + pmt * type * nper
    } else {
      f = Math.pow(1 + rate, nper)
      const df = nper * Math.pow(1 + rate, nper - 1)
      dy = pv * df + pmt * (1 / rate + type) * df + pmt * (-1 / (rate * rate)) * (f - 1)
    }

    rate -= y / dy
  }

  return rate
}

InstaCalc.LIB.area = function area(shape, ...dimensions) {
  let area;
  switch (shape) {
    case 'square':
      if (dimensions.length !== 1) return new Error("A square requires one dimension: side length.");
      area = dimensions[0] * dimensions[0];
      break;
    case 'circle':
      if (dimensions.length !== 1) return new Error("A circle requires one dimension: radius.");
      area = Math.PI * dimensions[0] * dimensions[0];
      break;
    case 'triangle':
      if (dimensions.length === 1) {
        // Assume equilateral triangle
        let s = dimensions[0];
        area = (Math.sqrt(3) / 4) * s * s;  // area of an equilateral triangle
      } else if (dimensions.length === 2) {
        // Assume right triangle
        area = 0.5 * dimensions[0] * dimensions[1];  // area of a right triangle
      } else if (dimensions.length === 3) {
        // Use Heron's formula for arbitrary triangle
        let s = (dimensions[0] + dimensions[1] + dimensions[2]) / 2;  // semi-perimeter
        area = Math.sqrt(s * (s - dimensions[0]) * (s - dimensions[1]) * (s - dimensions[2]));  // Heron's formula
      } else {
        return new Error("A triangle requires one, two, or three dimensions. Please provide valid dimensions.");
      }
      break;
    case 'rectangle':
      if (dimensions.length !== 2) return new Error("A rectangle requires two dimensions: width and height.");
      area = dimensions[0] * dimensions[1];  // area of a rectangle
      break;
    case 'ellipse':
      if (dimensions.length !== 2) return new Error("An ellipse requires two dimensions: major axis and minor axis.");
      area = Math.PI * dimensions[0] * dimensions[1];  // area of an ellipse
      break;
    default:
      return new Error("Shape not recognized. Please provide a valid shape: square, circle, triangle, rectangle or ellipse.");
  }
  return area;
}

InstaCalc.LIB.rational_approximation = function (t) {
  // Abramowitz and Stegun formula 26.2.23.
  // The absolute value of the error should be less than 4.5 e-4.
  var c = [2.515517, 0.802853, 0.010328];
  var d = [1.432788, 0.189269, 0.001308];
  var numerator = (c[2] * t + c[1]) * t + c[0];
  var denominator = ((d[2] * t + d[1]) * t + d[0]) * t + 1.0;
  return t - numerator / denominator;
};

InstaCalc.LIB.normal_cdf_inverse = function (p) {
  // See article above for explanation of this section.
  if (p < 0.5) {
    // F^-1(p) = - G^-1(p)
    return -this.rational_approximation(Math.sqrt(-2.0 * Math.log(p)));
  } else {
    // F^-1(p) = G^-1(1-p)
    return this.rational_approximation(Math.sqrt(-2.0 * Math.log(1.0 - p)));
  }
};

InstaCalc.LIB.STOCK_ACTIVE_ETF = new Set([
  "SQQQ", "TQQQ", "SPY", "SOXS", "SOXL", "QQQ", "XLF", "PSQ", "HYG", "FXI",
  "LABU", "EEM", "IWM", "EWZ", "TLT", "TMF", "SPXU", "SPXS", "KWEB", "LQD",
  "XLE", "KRE", "GDX", "SH", "UNG", "ARKK", "EFA", "QID", "SLV", "TNA",
  "TSLL", "XLU", "TZA", "XLP", "IEMG", "UVXY", "XLI", "GOVT", "SPXL", "XLV",
  "VEA", "UVIX", "FNGD", "VXX", "BITO", "VWO", "AGG", "JNK", "EWJ", "IEFA",
  "SMH", "IEF", "JDST", "XLK", "XBI", "BKLN", "BIL", "XLB", "IYR", "UPRO",
  "GLD", "XLC", "SDOW", "RSP", "LABD", "BND", "GDXJ", "XRT", "SHY", "SDS",
  "EMB", "QYLD", "SPTL", "XLRE", "VCIT", "USHY", "XLY", "YANG", "VNQ", "JEPI",
  "DUST", "SPDN", "SPTI", "VCSH", "SJNK", "SPIB", "XOP", "JPST", "QLD", "IVV",
  "IAU", "MCHI", "USFR", "VOO", "IJR", "ASHR", "PGX", "BOIL", "IGSB", "SSO"
]);

InstaCalc.LIB.STOCK_ACTIVE_COMPANY = new Set([
  "TSLA",
  "AMC",
  "KVUE",
  "NVDA",
  "APE",
  "PLTR",
  "M",
  "AMD",
  "NIO",
  "T",
  "JNJ",
  "AAPL",
  "BAC",
  "F",
  "AMZN",
  "LCID",
  "RIVN",
  "GRAB",
  "AAL",
  "INTC",
  "LYG",
  "SOFI",
  "MPW",
  "C",
  "PLUG",
  "VALE",
  "PCG",
  "VFS",
  "LU",
  "DKS",
  "VZ",
  "CCL",
  "GOOGL",
  "SCHW",
  "NU",
  "PR",
  "NOK",
  "S",
  "SIRI",
  "XPEV",
  "PYPL",
  "MSFT",
  "PTON",
  "ITUB",
  "PFE",
  "IQ",
  "JBLU",
  "SWN",
  "RIG",
  "AGNC",
  "CSCO",
  "GOOG",
  "ZM",
  "MRVL",
  "BBD",
  "UBER",
  "KEY",
  "GOLD",
  "META",
  "TFC",
  "WFC",
  "OPEN",
  "DNA",
  "BABA",
  "HBAN",
  "PBR",
  "ATVI",
  "SE",
  "ABEV",
  "TEVA",
  "X",
  "CLF",
  "DIDIY",
  "RUN",
  "ET",
  "SNAP",
  "NCLH",
  "CMCSA",
  "GPS",
  "IONQ",
  "KO",
  "RF",
  "SQ",
  "WBA",
  "KMI",
  "XOM",
  "TME",
  "MDT",
  "MU",
  "DIS",
  "NKE",
  "MRO",
  "HPE",
  "SLB",
  "HL",
  "LYFT",
  "KGC",
  "CVNA",
  "USB",
  "JWN"
]);

InstaCalc.LIB.isPossibleStock = function (str) {
  let name = str.toUpperCase().trim();
  if (name.length < 2) return false;

  return InstaCalc.LIB.STOCK_ACTIVE_COMPANY.has(name) || InstaCalc.LIB.STOCK_ACTIVE_ETF.has(name);
};

/* complex number class */
/* {
r: real part,
i: imaginary part
}
*/

class Complex {

  static tolerance = 1e-14;
  static precision = 1e-12;
  static displayPrecision = 1e-8;

  constructor(r, i) {
    if (typeof r !== "number" || typeof i !== "number") {
      return null;
    }

    this.r = r ?? 0; // real part
    this.i = i ?? 0; // imaginary part

    let adjust = (c) => {
      // Determine the number of decimal places from the rounding level.
      let decimals = Math.round(-Math.log10(Complex.precision));
      if (Math.abs(c.r) < Complex.tolerance) {
        c.r = 0;
      } else {
        c.r = Number(c.r.toFixed(decimals));
      }
      if (Math.abs(c.i) < Complex.tolerance) {
        c.i = 0;
      } else {
        c.i = Number(c.i.toFixed(decimals));
      }
      return c;
    };

    return adjust(this);
  }

  static phasor(mag, angle) {
    if (typeof mag !== "number" || typeof angle !== "number") {
      return null;
    }

    let autoAngle = InstaCalc.prototype.fn.autoRad(angle);

    let real = mag * Math.cos(autoAngle);
    let imag = mag * Math.sin(autoAngle);
    let c = new Complex(real, imag);
    return c;
  }

  // pare 5∠53.13 back into complex number
  static fromPhasorString(str) {
    let parts = str.split("∠");
    if (parts.length !== 2) {
      return null;
    }
    let mag = parseFloat(parts[0]);
    let angle = parseFloat(parts[1]);
    if (isNaN(mag) || isNaN(angle)) {
      return null;
    }
    return this.phasor(mag, angle * Math.PI / 180); // convert to radians
  }

  // return in format: 15∠30 (degrees assumed)
  static toPhasorString(c) {
    if (!this.isComplex(c)) {
      return null;
    }

    let mag = Complex.abs(c);
    let angle = Complex.angle(c) * 180 / Math.PI; // convert to degrees
    return IC.parser.toFixedIfNecessary(mag, 4) + "∠" + IC.parser.toFixedIfNecessary(angle, 2);
  }

  static toString(c) {
    const decimals = Math.round(-Math.log10(Complex.displayPrecision));
    function format(num) {
      return Number(num.toFixed(decimals)).toString();
    }

    if (typeof c === "number") {
      return format(c);
    }
    if (c.i === 0) {
      return format(c.r);
    }
    if (c.r === 0) {
      const imagAbs = Math.abs(c.i);
      const formattedImag = format(imagAbs);
      return (c.i < 0 ? "-" : "") + (imagAbs === 1 ? "i" : formattedImag + "i");
    }
    const formattedReal = format(c.r);
    let imagPart = "";
    if (c.i < 0) {
      imagPart = (Math.abs(c.i) === 1 ? " - i" : " - " + format(-c.i) + "i");
    } else {
      imagPart = (Math.abs(c.i) === 1 ? " + i" : " + " + format(c.i) + "i");
    }
    return formattedReal + imagPart;
  }

  static anyIsComplex(a, b) {
    return this.isComplex(a) || this.isComplex(b);
  }

  static isComplex(obj) {
    if (typeof obj !== 'object') {
      return false;
    }

    return obj instanceof Object && obj.hasOwnProperty('r') && obj.hasOwnProperty('i');
  }

  static toComplex(obj) {
    if (this.isComplex(obj)) {
      return obj;
    }

    let real = IC.val(obj);
    if (isNaN(real)) {
      return null;
    }

    return {
      r: real,
      i: 0
    };
  }

  static equalityTolerance = 1e-6;

  static isEqual(z1, z2) {
    if (typeof z1 === "number" && typeof z2 === "number") {
      return Math.abs(z1 - z2) < Complex.equalityTolerance;
    }
    let c1 = Complex.isComplex(z1) ? z1 : new Complex(z1, 0);
    let c2 = Complex.isComplex(z2) ? z2 : new Complex(z2, 0);
    return Math.abs(c1.r - c2.r) < Complex.equalityTolerance &&
      Math.abs(c1.i - c2.i) < Complex.equalityTolerance;
  }

  static isNotEqual(z1, z2) {
    return !this.isEqual(z1, z2);
  }

  static lessThan(z1, z2) {
    if (typeof z1 === "number" && typeof z2 === "number") {
      return z1 < z2;
    }
    if (typeof z1 === "number") {
      return z1 < z2.r && 0 === z2.i;
    }
    if (typeof z2 === "number") {
      return z1.r < z2 && 0 === z1.i;
    }
    return z1.r < z2.r && z1.i < z2.i;
  }

  static re(z) {
    return typeof z === "number" ? z : z.r;
  }

  static im(z) {
    return typeof z === "number" ? 0 : z.i;
  }

  static abs(z) {
    if (typeof z === "number") {
      return Math.abs(z);
    }

    return Math.sqrt(z.r * z.r + z.i * z.i);
  }

  // don't like the "arg" name...
  static angle(z) {
    if (typeof z === "number") {
      return 0;
    }

    return Math.atan2(z.i, z.r);
  }

  static conjugate(z) {
    if (typeof z === "number") {
      return z;
    }
    return new Complex(z.r, -z.i);
  }

  static add(a, b) {
    if (typeof a === "number" && typeof b === "number") {
      return IC.mathAdd(a, b);
    }
    let ca = Complex.isComplex(a) ? a : new Complex(a, 0);
    let cb = Complex.isComplex(b) ? b : new Complex(b, 0);
    let result = new Complex(ca.r + cb.r, ca.i + cb.i);
    return result.i === 0 ? result.r : result;
  }

  static subtract(a, b) {
    if (typeof a === "number" && typeof b === "number") {
      return IC.mathSub(a, b);
    }
    let ca = Complex.isComplex(a) ? a : new Complex(a, 0);
    let cb = Complex.isComplex(b) ? b : new Complex(b, 0);
    let result = new Complex(ca.r - cb.r, ca.i - cb.i);
    return result.i === 0 ? result.r : result;
  }

  static multiply(a, b) {
    if (typeof a === "number" && typeof b === "number") {
      return IC.mathMul(a, b);
    }
    let ca = Complex.isComplex(a) ? a : new Complex(a, 0);
    let cb = Complex.isComplex(b) ? b : new Complex(b, 0);
    let realPart = ca.r * cb.r - ca.i * cb.i;
    let imagPart = ca.r * cb.i + ca.i * cb.r;
    let result = new Complex(realPart, imagPart);
    return result.i === 0 ? result.r : result;
  }

  static inverse(z) {
    if (typeof z === "number") {
      return IC.mathInverse(z);
    }

    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    let denominator = cz.r * cz.r + cz.i * cz.i;
    if (denominator === 0) {
      return Infinity;
    }
    let result = new Complex(cz.r / denominator, -cz.i / denominator);
    return result.i === 0 ? result.r : result;
  }

  static divide(a, b) {
    if (typeof a === "number" && typeof b === "number") {
      return IC.mathDiv(a, b);
    }
    return Complex.multiply(a, Complex.inverse(b));
  }

  static sqrt(z) {
    return Complex.pow(z, 0.5);
  }

  static pow(base, exponent) {
    if (typeof base === "number" && typeof exponent === "number" && (base >= 0 || Number.isInteger(exponent))) {
      return Math.pow(base, exponent);
    }

    // Convert base and exponent to complex objects.
    const b = Complex.isComplex(base) ? base : new Complex(base, 0);
    const e = Complex.isComplex(exponent) ? exponent : new Complex(exponent, 0);

    // Use the identity: z^w = exp(w * log(z))
    const result = Complex.exp(Complex.multiply(e, Complex.log(b)));

    // If the imaginary part is effectively zero, return a real number.
    return Math.abs(result.i) < Complex.tolerance ? result.r : result;
  }

  static exp(z) {
    if (typeof z === "number") {
      return Math.exp(z);
    }
    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    let expRe = Math.exp(cz.r);
    return new Complex(expRe * Math.cos(cz.i), expRe * Math.sin(cz.i));
  }

  // natural log
  static log(z) {
    if (typeof z === "number") {
      if (z > 0) {
        return Math.log(z);
      } else if (z < 0) {
        return new Complex(Math.log(-z), Math.PI);
      } else {
        return new Complex(-Infinity, 0); // log(0) should be -Infinity + 0i
      }
    }

    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);

    // Handle special case: log(0) = -Infinity + 0i
    if (cz.r === 0 && cz.i === 0) {
      return new Complex(-Infinity, 0);
    }

    // Handle positive real numbers: log(positive real) = log(r) + 0i
    if (cz.i === 0 && cz.r > 0) {
      return new Complex(Math.log(cz.r), 0);
    }

    // Handle negative real numbers: log(negative real) = log(|r|) + πi
    if (cz.i === 0 && cz.r < 0) {
      return new Complex(Math.log(-cz.r), Math.PI);
    }

    // General complex case: log(z) = log(|z|) + i*arg(z)
    let absVal = this.abs(cz);
    let angleVal = this.angle(cz);
    return new Complex(Math.log(absVal), angleVal);
  }

  static log10(z) {
    return Complex.logBase(z, 10);
  }

  static log2(z) {
    return Complex.logBase(z, 2);
  }

  static logBase(z, base) {
    if (typeof z === "number" && typeof base === "number" && z > 0 && base > 1) {
      return Math.log(z) / Math.log(base);
    }

    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    let cbase = Complex.isComplex(base) ? base : new Complex(base, 0);
    return Complex.divide(Complex.log(cz), Complex.log(cbase));
  }

  static sin(z) {
    if (typeof z === "number") {
      return Math.sin(z);
    }
    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    return Complex.divide(
      Complex.subtract(
        Complex.exp(Complex.multiply(new Complex(0, 1), cz)),
        Complex.exp(Complex.multiply(new Complex(0, -1), cz))
      ),
      new Complex(0, 2)
    );
  }

  static cos(z) {
    if (typeof z === "number") {
      return Math.cos(z);
    }
    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    return Complex.divide(
      Complex.add(
        Complex.exp(Complex.multiply(new Complex(0, 1), cz)),
        Complex.exp(Complex.multiply(new Complex(0, -1), cz))
      ),
      new Complex(2, 0)
    );
  }

  static tan(z) {
    if (typeof z === "number") {
      return Math.tan(z);
    }
    // tan(z) = sin(z)/cos(z)
    return Complex.divide(Complex.sin(z), Complex.cos(z));
  }

  static cot(z) {
    if (typeof z === "number") {
      return 1 / Math.tan(z);
    }
    // cot(z) = cos(z)/sin(z)
    return Complex.divide(Complex.cos(z), Complex.sin(z));
  }

  static sec(z) {
    if (typeof z === "number") {
      return 1 / Math.cos(z);
    }
    // sec(z) = 1/cos(z)
    return Complex.inverse(Complex.cos(z));
  }

  static csc(z) {
    if (typeof z === "number") {
      return 1 / Math.sin(z);
    }
    // csc(z) = 1/sin(z)
    return Complex.inverse(Complex.sin(z));
  }

  static asin(z) {
    if (typeof z === "number") {
      if (Math.abs(z) <= 1) return Math.asin(z);
      // For z > 1 or z < -1
      const s = z > 1 ? 1 : -1;
      return new Complex(s * Math.PI / 2, -Math.log(Math.abs(z) + Math.sqrt(z * z - 1)));
    }
    // For complex values: asin(z) = -i * ln(i*z + √(1 - z²))
    const cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    const iTimesZ = Complex.multiply(new Complex(0, 1), cz);
    const sqrtTerm = Complex.pow(Complex.subtract(new Complex(1, 0), Complex.multiply(cz, cz)), 0.5);
    return Complex.multiply(new Complex(0, -1), Complex.log(Complex.add(iTimesZ, sqrtTerm)));
  }

  static acos(z) {
    if (typeof z === "number") {
      if (Math.abs(z) <= 1) {
        return Math.acos(z);
      } else if (z > 1) {
        // For z > 1, acos(z) = i * ln(z + √(z² - 1))
        return new Complex(0, Math.log(z + Math.sqrt(z * z - 1)));
      } else { // z < -1
        // For z < -1, acos(z) = π - i * ln(-z + √(z² - 1))
        return new Complex(Math.PI, -Math.log(-z + Math.sqrt(z * z - 1)));
      }
    }
    // For complex values use the standard formula: acos(z) = π/2 - asin(z)
    return Complex.subtract(new Complex(Math.PI / 2, 0), Complex.asin(z));
  }

  static atan(z) {
    if (typeof z === "number") {
      return Math.atan(z);
    }

    // For complex values: atan(z) = 0.5 * i * ln((1 - iz) / (1 + iz))
    const cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    const iTimesZ = Complex.multiply(new Complex(0, 1), cz);
    const numerator = Complex.subtract(new Complex(1, 0), iTimesZ);
    const denominator = Complex.add(new Complex(1, 0), iTimesZ);
    return Complex.multiply(new Complex(0.5, 0), Complex.log(Complex.divide(numerator, denominator)));
  }

  static atan2(y, x) {
    if (typeof y === "number" && typeof x === "number") {
      return Math.atan2(y, x);
    }

    const cz = Complex.isComplex(x) ? x : new Complex(x, 0);
    const cy = Complex.isComplex(y) ? y : new Complex(y, 0);
    return Complex.atan(Complex.divide(cy, cz));
  }

  static asec(z) {
    if (typeof z === "number") {
      if (Math.abs(z) < 1) return undefined; // asec is undefined for |z| < 1
      return Math.acos(1 / z);
    }
    // For complex values: asec(z) = acos(1/z)
    const cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    return Complex.acos(Complex.inverse(cz));
  }

  static acsc(z) {
    if (typeof z === "number") {
      if (Math.abs(z) < 1) return undefined; // acsc is undefined for |z| < 1
      return Math.asin(1 / z);
    }
    // For complex values: acsc(z) = asin(1/z)
    const cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    return Complex.asin(Complex.inverse(cz));
  }

  static acot(z) {
    if (typeof z === "number") {
      return Math.atan(1 / z);
    }
    // For complex values: acot(z) = atan(1/z)
    const cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    return Complex.atan(Complex.inverse(cz));
  }

  static sinh(z) {
    if (typeof z === "number") {
      return (Math.exp(z) - Math.exp(-z)) / 2;
    }
    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    let expPos = Complex.exp(cz);
    let expNeg = Complex.exp(Complex.multiply(cz, -1));
    return Complex.divide(Complex.subtract(expPos, expNeg), 2);
  }

  static cosh(z) {
    if (typeof z === "number") {
      return (Math.exp(z) + Math.exp(-z)) / 2;
    }
    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    let expPos = Complex.exp(cz);
    let expNeg = Complex.exp(Complex.multiply(cz, -1));
    return Complex.divide(Complex.add(expPos, expNeg), 2);
  }

  static tanh(z) {
    if (typeof z === "number") {
      let ePos = Math.exp(z);
      let eNeg = Math.exp(-z);
      return ePos === Infinity ? 1 : eNeg === Infinity ? -1 : (ePos - eNeg) / (ePos + eNeg);
    }
    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    let sinhVal = this.sinh(cz);
    let coshVal = this.cosh(cz);
    return Complex.divide(sinhVal, coshVal);
  }

  static sech(z) {
    if (typeof z === "number") {
      return 1 / ((Math.exp(z) + Math.exp(-z)) / 2);
    }
    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    let coshVal = this.cosh(cz);
    return Complex.inverse(coshVal);
  }

  static csch(z) {
    if (typeof z === "number") {
      return 1 / ((Math.exp(z) - Math.exp(-z)) / 2);
    }
    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    let sinhVal = this.sinh(cz);
    return Complex.inverse(sinhVal);
  }

  static coth(z) {
    if (typeof z === "number") {
      return 1 / Math.tanh(z);
    }
    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    let sinhVal = this.sinh(cz);
    let coshVal = this.cosh(cz);
    return Complex.divide(coshVal, sinhVal);
  }

  static asinh(z) {
    if (typeof z === "number") {
      return Math.log(z + Math.sqrt(z * z + 1));
    }
    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    let zSquared = Complex.multiply(cz, cz);
    let underSqrt = Complex.add(zSquared, 1);
    let sqrtVal = Complex.sqrt(underSqrt);
    return Complex.log(Complex.add(cz, sqrtVal));
  }

  static acosh(z) {
    if (typeof z === "number") {
      if (z < 1) return undefined;
      return Math.log(z + Math.sqrt(z * z - 1));
    }
    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    let zSquared = Complex.multiply(cz, cz);
    let underSqrt = Complex.subtract(zSquared, 1);
    let sqrtVal = Complex.sqrt(underSqrt);
    return Complex.log(Complex.add(cz, sqrtVal));
  }

  static atanh(z) {
    if (typeof z === "number") {
      return Math.log((1 + z) / (1 - z)) / 2;
    }
    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    let numerator = Complex.add(cz, 1);
    let denominator = Complex.subtract(1, cz);
    return Complex.multiply(Complex.log(Complex.divide(numerator, denominator)), 0.5);
  }

  static asech(z) {
    if (typeof z === "number") {
      if (z <= 0 || z > 1) return undefined;
      return this.acosh(1 / z);
    }
    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    return this.acosh(Complex.inverse(cz));
  }

  static acsch(z) {
    if (typeof z === "number") {
      if (z === 0) return undefined;
      return this.asinh(1 / z);
    }
    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    return this.asinh(Complex.inverse(cz));
  }

  static acoth(z) {
    if (typeof z === "number") {
      if (Math.abs(z) < 1) return undefined;
      return 0.5 * Math.log((z + 1) / (z - 1));
    }
    let cz = Complex.isComplex(z) ? z : new Complex(z, 0);
    let numerator = Complex.add(cz, 1);
    let denominator = Complex.subtract(cz, 1);
    return Complex.multiply(Complex.log(Complex.divide(numerator, denominator)), 0.5);
  }
}

InstaCalc.Complex = Complex;

;
window.Util = {};
Util.cache = {};
Util.timeSince = function (date) {
  var seconds = Math.floor((new Date() - date) / 1000);

  var interval = Math.floor(seconds / 31536000);

  if (interval > 1) {
    return interval + " years";
  }
  interval = Math.floor(seconds / 2592000);
  if (interval > 1) {
    return interval + " months";
  }
  interval = Math.floor(seconds / 86400);
  if (interval > 1) {
    return interval + " days";
  }
  interval = Math.floor(seconds / 3600);
  if (interval > 1) {
    return interval + " hours";
  }
  interval = Math.floor(seconds / 60);
  if (interval > 1) {
    return interval + " minutes";
  }
  return Math.floor(seconds) + " seconds";
};

Util.displayDate = function (date) {
  var cached = Util.cache[date];
  if (cached) {
    return cached;
  }

  if (typeof date === "undefined" || !date) {
    return null;
  }

  var dstring = new Date(date).toLocaleDateString([], {
    day: "numeric",
    month: "2-digit",
    year: "2-digit",
  });
  var diff = new Date() - new Date(date);
  if (diff < 10 * 60 * 60 * 1000) {
    dstring = new Date(date).toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  Util.cache[date] = dstring;
  return Util.cache[date];
};

Util.parseQuery = function (qstr) {
  var query = {};
  var a = qstr.substr(1).split("&");
  for (var i = 0; i < a.length; i++) {
    var b = a[i].split("=");
    query[decodeURIComponent(b[0])] = decodeURIComponent(b[1] || "");
  }
  return query;
};

Util.parseLegacyCalc = function (uri) {
  var query = Util.parseQuery(uri);

  try {
    data = atob(query.c.replace(/\*/g, "+").replace(/-/g, "/"));
  } catch (e) {
    console.log("Error decoding: " + uri);
    return null;
  }
  var settings = query.s || "";
  var rows = data.split("|").map(function (text, i) {
    return { text: text, hidden: settings[i] == "h" };
  });
  return Calc.createCalcObject({ name: "InstaCalc", rows: rows });
};
;
/**
 * HistoryManager - Manages undo/redo history for calcs using JSON Patch
 * No external dependencies - lightweight implementation
 */

// Simple JSON Patch implementation (subset of RFC 6902)
const JSONPatch = {
  // Generate patches between two objects
  compare(oldObj, newObj) {
    const patches = [];
    this._diff(oldObj, newObj, '', patches);
    return patches;
  },

  _diff(oldObj, newObj, path, patches) {
    if (this._deepEqual(oldObj, newObj)) return;

    if (Array.isArray(newObj) && Array.isArray(oldObj)) {
      // Array diffing
      const maxLen = Math.max(oldObj.length, newObj.length);

      for (let i = 0; i < maxLen; i++) {
        if (i >= newObj.length) {
          // Removed - note: we remove from end to start to maintain indices
          patches.push({ op: 'remove', path: `${path}/${i}` });
        } else if (i >= oldObj.length) {
          // Added
          patches.push({ op: 'add', path: `${path}/${i}`, value: newObj[i] });
        } else if (!this._deepEqual(oldObj[i], newObj[i])) {
          // Changed
          if (typeof newObj[i] === 'object' && newObj[i] !== null && !Array.isArray(newObj[i])) {
            this._diff(oldObj[i], newObj[i], `${path}/${i}`, patches);
          } else {
            patches.push({ op: 'replace', path: `${path}/${i}`, value: newObj[i] });
          }
        }
      }
    } else if (typeof newObj === 'object' && newObj !== null && typeof oldObj === 'object' && oldObj !== null) {
      // Object diffing
      const allKeys = new Set([...Object.keys(oldObj), ...Object.keys(newObj)]);

      for (const key of allKeys) {
        const newPath = path ? `${path}/${key}` : `/${key}`;

        if (!(key in newObj)) {
          patches.push({ op: 'remove', path: newPath });
        } else if (!(key in oldObj)) {
          patches.push({ op: 'add', path: newPath, value: newObj[key] });
        } else if (!this._deepEqual(oldObj[key], newObj[key])) {
          if (typeof newObj[key] === 'object' && newObj[key] !== null) {
            this._diff(oldObj[key], newObj[key], newPath, patches);
          } else {
            patches.push({ op: 'replace', path: newPath, value: newObj[key] });
          }
        }
      }
    } else {
      // Primitive change
      patches.push({ op: 'replace', path: path || '/', value: newObj });
    }
  },

  // Apply patches to an object
  applyPatch(obj, patches) {
    const result = JSON.parse(JSON.stringify(obj));

    for (const patch of patches) {
      this._applyOperation(result, patch);
    }

    return result;
  },

  _applyOperation(obj, op) {
    const path = op.path.split('/').filter(p => p !== '');

    if (op.op === 'replace' || op.op === 'add') {
      this._setValue(obj, path, op.value);
    } else if (op.op === 'remove') {
      this._removeValue(obj, path);
    }
  },

  _setValue(obj, path, value) {
    if (path.length === 0) return obj;

    let current = obj;
    for (let i = 0; i < path.length - 1; i++) {
      const key = path[i];

      // If current is an array and key is a number, ensure array is long enough
      if (Array.isArray(current) && !isNaN(key)) {
        const index = Number(key);
        while (current.length <= index) {
          current.push(null);
        }
      }

      // Initialize if doesn't exist or is null
      if (!(key in current) || current[key] === null) {
        current[key] = isNaN(path[i + 1]) ? {} : [];
      }

      current = current[key];
    }

    // Handle final key
    const lastKey = path[path.length - 1];
    if (Array.isArray(current) && !isNaN(lastKey)) {
      const index = Number(lastKey);
      while (current.length <= index) {
        current.push(null);
      }
    }
    current[lastKey] = value;
  },

  _removeValue(obj, path) {
    if (path.length === 0) return;

    let current = obj;
    for (let i = 0; i < path.length - 1; i++) {
      current = current[path[i]];
      if (!current) return;
    }

    const lastKey = path[path.length - 1];
    if (Array.isArray(current)) {
      current.splice(Number(lastKey), 1);
    } else {
      delete current[lastKey];
    }
  },

  _deepEqual(a, b) {
    return JSON.stringify(a) === JSON.stringify(b);
  }
};

// HistoryManager class
class HistoryManager {
  constructor(calc) {
    this.calc = calc;
    this.maxSize = 50;
    this.excludedFields = ['id', 'created', 'updated', 'published', 'uid', 'history', '_historyManager'];
    this.debounceMs = 2000; // 2 seconds - only create new entry if this much time has passed

    // Initialize history if needed
    if (!calc.history) {
      calc.history = {
        stack: [],
        currentIndex: -1
      };
    }
  }

  // Capture current state as snapshot
  captureSnapshot(operation, options = {}) {
    const { force = false } = options;

    const currentSnapshot = this._createSnapshot();
    const previousSnapshot = this._getPreviousSnapshot();
    const patch = this._computePatch(previousSnapshot, currentSnapshot);

    // Don't create history entry if there are no changes
    if (patch.type === 'patch' && patch.patches.length === 0) {
      return;
    }

    const now = new Date();
    const currentTime = now.toISOString();

    // Check if we should replace the last entry (within debounce window)
    const lastEntry = this.calc.history.stack[this.calc.history.currentIndex];
    const shouldReplaceLastEntry = !force && lastEntry &&
      this.calc.history.currentIndex === this.calc.history.stack.length - 1 &&
      (now - new Date(lastEntry.timestamp)) < this.debounceMs;

    const entry = {
      timestamp: currentTime,
      operation: operation,
      patch: patch
    };

    if (shouldReplaceLastEntry) {
      // Replace the most recent entry instead of creating a new one
      this.calc.history.stack[this.calc.history.currentIndex] = entry;
    } else {
      // Truncate forward history if not at end
      if (this.calc.history.currentIndex < this.calc.history.stack.length - 1) {
        this.calc.history.stack = this.calc.history.stack.slice(0, this.calc.history.currentIndex + 1);
      }

      this.calc.history.stack.push(entry);
      this.calc.history.currentIndex++;

      // Limit history size
      if (this.calc.history.stack.length > this.maxSize) {
        this.calc.history.stack.shift();
        this.calc.history.currentIndex--;
      }
    }
  }

  // Create snapshot of current state (all fields except excluded)
  _createSnapshot() {
    const snapshot = {};
    for (const key in this.calc) {
      if (!this.excludedFields.includes(key)) {
        try {
          snapshot[key] = JSON.parse(JSON.stringify(this.calc[key]));
        } catch (e) {
          // Skip fields that can't be serialized (circular references, functions, etc.)
          console.warn(`Skipping field '${key}' in history snapshot:`, e.message);
        }
      }
    }
    return snapshot;
  }

  _getPreviousSnapshot() {
    const idx = this.calc.history.currentIndex;
    if (idx < 0) return null;

    // Reconstruct previous state by applying patches up to current index
    return this._reconstructSnapshot(idx);
  }

  // Compute JSON Patch between two snapshots
  _computePatch(oldSnapshot, newSnapshot) {
    if (!oldSnapshot) {
      return { type: 'full', data: newSnapshot };
    }

    // Generate JSON Patch
    const patches = JSONPatch.compare(oldSnapshot, newSnapshot);
    return { type: 'patch', patches };
  }

  // Reconstruct snapshot at given index by applying patches
  _reconstructSnapshot(index) {
    let state = {};

    // Apply patches sequentially from start to index
    for (let i = 0; i <= index; i++) {
      const entry = this.calc.history.stack[i];
      state = this._applyPatch(state, entry.patch);
    }

    return state;
  }

  // Apply a patch to a state
  _applyPatch(state, patch) {
    if (patch.type === 'full') {
      return JSON.parse(JSON.stringify(patch.data));
    }

    // Apply JSON Patch
    return JSONPatch.applyPatch(state, patch.patches);
  }

  // Undo to previous state
  undo() {
    if (this.calc.history.currentIndex <= 0) {
      return false;
    }

    this.calc.history.currentIndex--;
    this._restoreSnapshot(this.calc.history.currentIndex);
    return true;
  }

  // Redo to next state
  redo() {
    if (this.calc.history.currentIndex >= this.calc.history.stack.length - 1) {
      return false;
    }

    this.calc.history.currentIndex++;
    this._restoreSnapshot(this.calc.history.currentIndex);
    return true;
  }

  // Restore calc to snapshot at index
  _restoreSnapshot(index) {
    const snapshot = this._reconstructSnapshot(index);

    // Restore all fields except excluded
    for (const key in snapshot) {
      if (!this.excludedFields.includes(key)) {
        let value = JSON.parse(JSON.stringify(snapshot[key]));

        // Sanitize rows array - replace null entries with empty row objects
        if (key === 'rows' && Array.isArray(value)) {
          value = value.map(row => row || { text: '', hidden: false });
        }

        this.calc[key] = value;
      }
    }
  }

  // Jump to specific history index
  jumpTo(index) {
    if (index < 0 || index >= this.calc.history.stack.length) {
      return false;
    }

    this.calc.history.currentIndex = index;
    this._restoreSnapshot(index);
    return true;
  }

  // Get current history size in bytes
  getHistorySize() {
    return JSON.stringify(this.calc.history).length;
  }

  // Get compression ratio (compared to full snapshots)
  getCompressionRatio() {
    const patchSize = this.getHistorySize();
    const fullSnapshotsSize = this.calc.history.stack.length * JSON.stringify(this._createSnapshot()).length;
    return fullSnapshotsSize > 0 ? (1 - patchSize / fullSnapshotsSize) : 0;
  }

  // Get history entries for display (reverse chronological - newest first)
  getHistory() {
    return this.calc.history.stack.map((entry, index) => ({
      index,
      timestamp: entry.timestamp,
      operation: entry.operation
    })).reverse();
  }

  // Convert display index (reverse chronological) to actual stack index
  _displayIndexToActual(displayIndex) {
    return this.calc.history.stack.length - 1 - displayIndex;
  }

  // Get snapshot at display index (handles reverse chronological order)
  getSnapshot(displayIndex) {
    const actualIndex = this._displayIndexToActual(displayIndex);
    if (actualIndex < 0 || actualIndex >= this.calc.history.stack.length) {
      return null;
    }
    return this._reconstructSnapshot(actualIndex);
  }

  // Can undo?
  canUndo() {
    return this.calc.history.currentIndex > 0;
  }

  // Can redo?
  canRedo() {
    return this.calc.history.currentIndex < this.calc.history.stack.length - 1;
  }

  // Get diff from history snapshot to current live state (handles reverse chronological order)
  getDiffToCurrent(displayIndex) {
    const actualIndex = this._displayIndexToActual(displayIndex);
    if (actualIndex < 0 || actualIndex >= this.calc.history.stack.length) {
      return null;
    }

    const historySnapshot = this._reconstructSnapshot(actualIndex);
    const currentSnapshot = this._createSnapshot();
    const patch = this._computePatch(historySnapshot, currentSnapshot);

    return {
      timestamp: new Date().toISOString(),
      operation: 'diff_to_current',
      patch: patch
    };
  }

  // Restore to a specific display index (handles reverse chronological order)
  restoreToDisplayIndex(displayIndex) {
    const actualIndex = this._displayIndexToActual(displayIndex);
    return this.jumpTo(actualIndex);
  }
}

// Export for use in action.js
window.HistoryManager = HistoryManager;
;
Action = {};
Embed = Object.create(Action);

// Store history managers externally to avoid serialization issues
const historyManagers = new WeakMap();

Action.Util = {};
Action.Util.guid = function () {
  function S4() {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
  }
  return (S4() + S4() + "-" + S4() + "-4" + S4().substr(0, 3) + "-" + S4() + "-" + S4() + S4() + S4()).toLowerCase();
};

Action.Util.debounce = function (func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;

    var later = function () {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };

    var callNow = immediate && !timeout;

    clearTimeout(timeout);

    timeout = setTimeout(later, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };
}

Action.addRows = function (calc, n) {
  var new_rows = EMPTY_ROW(n);
  calc.rows = calc.rows.concat(new_rows);
  this.save(calc);
};

Action.insertRow = function (calc, i) {
  calc.rows.splice(i, 0, EMPTY_ROW(1)[0]);
  this.updateRowReferences(calc, i, +1);
  this.save(calc);
};

Action.deleteRow = function (calc, i) {
  calc.rows.splice(i, 1);
  this.updateRowReferences(calc, i, -1);
  this.save(calc);
};

Action.addText = function (calc, i, text) {
  calc.rows[i].text += text;
  this.save(calc);
};

Action.deleteText = function (calc, i, n) {
  n ||= 1;
  calc.rows[i].text = calc.rows[i].text.slice(0, -n);
  this.save(calc);
};

Action.dragMove = function (from, to) {

  if (from !== null && to !== null && from != to) {
    from = Number(from);
    to = Number(to);

    let calc = Action.getCurrentCalc();
    let row = calc.rows[from];
    let offset = from < to ? 1 : 0;

    // references to the "from" cell (0-indexed) updated to a temp "99999" row
    Action.changeRowReferences(calc, from + 1, "99999");

    // add a row (and fix references)
    Action.insertRow(calc, to + offset);

    // copy contents...
    calc.rows[to + offset] = { ...row };

    // remove the earlier row
    let deleteOffset = from > to ? 1 : 0;
    Action.deleteRow(calc, from + deleteOffset);

    // replace references to the original row
    Action.changeRowReferences(calc, "99999", to + 1);
    this.save(calc);
    Action.currentInstaCalcReact.onSelectRow(to);
  }
};

Action.pasteTextLines = function (calc, i, textLines) {
  const rowCount = calc.rows.length;
  const newCount = i + textLines.length;
  if (newCount > rowCount) {
    Action.addRows(calc, newCount - rowCount);
  }

  textLines.forEach((line, idx) => {
    calc.rows[i + idx].text = line.trim();
  });

  this.save(calc);
};

// if more than half of rows are hidden, show all rows
Action.shouldHideRows = function (calc) {
  let hiddenCount = calc.rows.filter((row) => row.hidden).length;
  let shouldHideRows = hiddenCount <= calc.rows.length / 2;
  return shouldHideRows;
}

Action.presentCalc = function (calc) {
  let shouldHideRows = this.shouldHideRows(calc);
  calc.rows.forEach((row) => {
    row.hidden = shouldHideRows;
  });

  this.save(calc);
  this.currentInstaCalcReact.updateRowVariableState();
};

Action.reactComponents = {};
Action.setReactComponent = function (calc, component) {
  Action.reactComponents[calc.id] = component;
};

Action.getReactComponent = function (calc) {
  return Action.reactComponents[calc.id];
};

Action.setCurrentCalc = function (calc) {
  Action.currentCalc = Action.sanitizeCalc(calc);
};

// Sanitize calc rows to ensure no null entries
Action.sanitizeCalc = function (calc) {
  if (calc && calc.rows && Array.isArray(calc.rows)) {
    calc.rows = calc.rows.map(row => row || { text: '', hidden: false });
  }
  return calc;
};

Action.getCurrentCalc = function () {
  return Action.sanitizeCalc(Action.currentCalc);
};

Action.addTextToCurrentCalc = function (text) {
  var calc = Action.currentCalc;
  var row = Action.currentInstaCalcReact.state.selected || 0;
  this.addText(calc, row, text);
};

Action.applyRowFormatStringToCurrentCalc = function (formatString) {
  var calc = Action.currentCalc;
  var row = Action.currentInstaCalcReact.state.selected || 0;

  // pad start and end of formatString with a space if needed
  formatString = " " + (formatString.trim()) + " ";
  let currentText = calc.rows[row].text.trimEnd();
  let newText = IC.api.appendBeforeComment(currentText, formatString);
  this.updateRowText(calc, row, newText);
};

Action.deleteTextFromCurrentCalc = function (n) {
  var calc = Action.currentCalc;
  var row = Action.currentInstaCalcReact.state.selected || 0;
  this.deleteText(calc, row, n || 1);
};

Action.selectDefaultRow = function () {
  let index = this.currentInstaCalcReact.state.selected || 0;
  Action.currentInstaCalcReact.onSelectRow(index);
  Action.currentInstaCalcReact.onSelectRow(index);
};

Action.selectRelativeRow = function (n) {
  let newRow = (this.currentInstaCalcReact.state.selected || 0) + n;
  if (newRow <= 0) {
    newRow = 0;
  }
  let max = this.currentInstaCalcReact.props.calc.rows.length - 1;
  if (newRow > max) {
    newRow = max;
  }

  // have to repeat for some reason?
  Action.currentInstaCalcReact.onSelectRow(newRow);
  Action.currentInstaCalcReact.onSelectRow(newRow);
};

// update R3 to R4 when a new row is inserted. n is the new row, change is +1 for insert, -1 for delete
// note, n is zero-indexed
Action.updateRowReferences = function (calc, n, change) {
  calc.rows.forEach((row) => {
    /* prefix   r  */
    row.text = row.text.replace(/\b([:]?R)(\d+)\b/gi, (str, prefix, r) => {
      var rowRef = parseInt(r);
      var orig = prefix + rowRef;
      var changed = prefix + (rowRef + change);

      if (rowRef + change == 0) {
        return orig; // special case: can't reference "R0"
      }

      // surprisingly, same formula for both
      // inserting: if referencing after the insert, update
      // deleting: if referencing after the deleted row, update
      return rowRef > n ? changed : orig;
    });
  });
};

Action.changeRowReferences = function (calc, searchIndex, replaceIndex) {
  calc.rows.forEach((row) => {
    /* prefix   r  */
    row.text = row.text.replace(/\b([:]?R)(\d+)\b/gi, (str, prefix, r) => {
      var rowRef = parseInt(r);
      var orig = prefix + rowRef;
      var changed = `${prefix}${replaceIndex}`;
      if (rowRef == Number(searchIndex)) {
        return changed;
      }
      return orig;
    });
  });

};

Action.updateRowText = function (calc, row_id, text) {
  calc.rows[row_id].text = text;
  this.save(calc);
};

Action.updateName = function (calc, name) {
  calc.name = name.substr(0, 80);
  this.save(calc);
};

Action.updateFolder = function (calc, folder) {
  calc.folder = folder?.trim();
  this.save(calc);
}

Action.toggleRowVisibility = function (calc, row_id) {
  calc.rows[row_id].hidden = !calc.rows[row_id].hidden;
  this.save(calc);
};

Action.clear = function (calc) {
  calc = calc || this.getCurrentCalc();

  // Capture snapshot BEFORE clearing
  const manager = Action.getHistoryManager(calc);
  manager.captureSnapshot("clear", { force: true });

  calc.rows = calc.rows.map((row) => {
    row.text = "";
    row.hidden = false;
    return row;
  });

  // Capture the cleared state too, so currentIndex points to current state
  manager.captureSnapshot("cleared", { force: true });

  Action._saveWithoutHistory(calc);
};

Action.clearCurrentLine = function (calc = null) {
  calc = calc || this.getCurrentCalc();
  var row = Action.currentInstaCalcReact.state.selected || 0;
  calc.rows[row].text = "";
  this.save(calc);
};

Action.insertRowBeforeCurrentLine = function (calc = null) {
  calc = calc || this.getCurrentCalc();
  var row = Action.currentInstaCalcReact.state.selected || 0;
  this.insertRow(calc, row);
};

Action.insertRowAfterCurrentLine = function (calc = null) {
  calc = calc || this.getCurrentCalc();
  var row = Action.currentInstaCalcReact.state.selected || 0;
  this.insertRow(calc, row + 1);
}

Action.deleteRowCurrentLine = function (calc = null) {
  calc = calc || this.getCurrentCalc();
  var row = Action.currentInstaCalcReact.state.selected || 0;
  this.deleteRow(calc, row);
};

Action.setRounding = function (calc, digits) {
  calc.rounding = digits;
  this.save(calc);
};

Action.setLocale = function (calc, locale) {
  let codes = Intl.getCanonicalLocales(locale);
  if (codes && codes.length) {
    calc.locale = codes[0];
  }
  this.save(calc);
};

Action.setLocalOption = function (name, value) {
  let options;
  try {
    options = JSON.parse(window.localStorage.getItem("settings") || "{}");
  } catch (e) {
    options = {};
  }
  options[name] = value;
  window.localStorage.setItem("settings", JSON.stringify(options));
}

Action.getLocalOption = function (name) {
  let options;
  try {
    options = JSON.parse(window.localStorage.getItem("settings") || "{}");
  } catch (e) {
    options = {};
  }
  return options[name];
}

Action.hide = function () { };

Action.select = function (calcOrId) {
  let id = typeof calcOrId == "object" ? calcOrId.id : calcOrId;
  window.App.onSelect(id);
};

Action.create = function (fromCalc) {
  // count how many calcs have the default name...
  var i = Calc.all().filter((c) => {
    return c.name.match(DEFAULT_NAME);
  }).length;
  var default_name = i == 0 ? DEFAULT_NAME : DEFAULT_NAME + " " + (i + 1);

  // Bugfix: do a deep clone, not Object.assign() which is a shallow clone
  fromCalc = fromCalc || {};
  var clone = JSON.parse(JSON.stringify(fromCalc));
  clone.name = clone.name || default_name;

  var calc = Calc.createCalcObject(clone);
  Calc.set(calc.id, calc);

  // should auto-save if you are logged in...
  if (Action.isLoggedIn()) {
    Action.save(calc);
  }

  Calc.pub();
  return calc;
};

Action.clone = function (oldCalc, suffix) {
  var clone = JSON.parse(JSON.stringify(oldCalc));
  clone.name = oldCalc.name + suffix;

  // automatically save
  Action.create(clone);
};

Action.upgrade = function (calc, version) {
  calc.version = version || 2;
  this.save(calc);
};

Action.redirectHomeAfterDelay = function () {
  setTimeout(function () {
    window.location.href = "/";
  }, 1500);
};

Action.savePublic = function (oldCalc) {
  Action.clone(oldCalc, "");

  // BUGFIX: have a delay before redirect because saveLocalStore is delayed
  // TODO: change state with URL hash change
  Action.redirectHomeAfterDelay();
};

// save embedded calc to user calc list
Action.saveEmbedCalc = function (id) {
  let calc = Embed.get(id);
  if (calc) {
    calc.parent = id;
    Action.create(calc);
  }
};

Action.get = function (id) {
  return Calc.get(id);
};

// Get or create HistoryManager for a calc
Action.getHistoryManager = function (calc) {
  if (!historyManagers.has(calc)) {
    historyManagers.set(calc, new HistoryManager(calc));
  }
  return historyManagers.get(calc);
};

// Keep reference to original save (for restoring without history)
Action._saveWithoutHistory = function (calc) {
  calc.updated = new Date().toISOString();
  Calc.set(calc.id, calc);

  // if already published, update it [publish does a setRemote as well]
  if (calc.published && calc.published.id && !calc.deleted) {
    Calc.publish(calc.id);
  } else {
    Calc.setRemote(calc.id, calc);
  }
  Calc.pub();
};

Action.save = function (calc, options = {}) {
  const { snapshot } = options;

  // Always capture history snapshot locally (regardless of login)
  const manager = Action.getHistoryManager(calc);
  if (snapshot) {
    // Force snapshot with custom operation label
    manager.captureSnapshot(snapshot, { force: true });
  } else {
    // Normal save with debouncing
    manager.captureSnapshot("edit");
  }

  // Continue with normal save (Firebase save only if logged in)
  Action._saveWithoutHistory(calc);
};

// Undo/Redo functions
Action.undo = function () {
  const calc = Action.getCurrentCalc();
  if (!calc) return false;

  const manager = Action.getHistoryManager(calc);
  if (manager.undo()) {
    // Save without creating new history entry
    Action._saveWithoutHistory(calc);
    // Trigger UI refresh
    if (Action.currentInstaCalcReact) {
      Action.currentInstaCalcReact.smartRecalculate();
    }
    return true;
  }
  return false;
};

Action.redo = function () {
  const calc = Action.getCurrentCalc();
  if (!calc) return false;

  const manager = Action.getHistoryManager(calc);
  if (manager.redo()) {
    // Save without creating new history entry
    Action._saveWithoutHistory(calc);
    // Trigger UI refresh
    if (Action.currentInstaCalcReact) {
      Action.currentInstaCalcReact.smartRecalculate();
    }
    return true;
  }
  return false;
};

Action.canUndo = function () {
  const calc = Action.getCurrentCalc();
  if (!calc) return false;
  const manager = Action.getHistoryManager(calc);
  return manager.canUndo();
};

Action.canRedo = function () {
  const calc = Action.getCurrentCalc();
  if (!calc) return false;
  const manager = Action.getHistoryManager(calc);
  return manager.canRedo();
};

Action.getHistory = function () {
  const calc = Action.getCurrentCalc();
  if (!calc) return [];
  const manager = Action.getHistoryManager(calc);
  return manager.getHistory();
};

Action.getHistorySnapshot = function (index) {
  const calc = Action.getCurrentCalc();
  if (!calc) return null;
  const manager = Action.getHistoryManager(calc);
  return manager.getSnapshot(index);
};

Action.getHistoryEntry = function (displayIndex) {
  const calc = Action.getCurrentCalc();
  if (!calc) return null;
  if (!calc.history || !calc.history.stack) return null;

  const manager = Action.getHistoryManager(calc);
  const actualIndex = manager._displayIndexToActual(displayIndex);
  if (actualIndex < 0 || actualIndex >= calc.history.stack.length) return null;
  return calc.history.stack[actualIndex];
};

Action.jumpToHistory = function (displayIndex) {
  const calc = Action.getCurrentCalc();
  if (!calc) return false;

  const manager = Action.getHistoryManager(calc);
  if (manager.restoreToDisplayIndex(displayIndex)) {
    // Save without creating new history entry
    Action._saveWithoutHistory(calc);
    return true;
  }
  return false;
};

Action.delete = function (calc) {
  console.log("deleting calc");
  calc.deleted = true;
  Calc.set(calc.id, calc);
  Calc.setRemote(calc.id, calc);
  Calc.pub();
  console.log(calc);
};

Action.merge = function (id, props) {
  let calc = Action.get(id);
  calc.updated = new Date().toISOString();
  Calc.merge(id, props);
  Calc.setRemote(id, Calc.get(id));
  Calc.pub();
};

Action.publish = function (calc) {
  if (calc?.published?.origId && !calc?.published?.id) {
    calc.published.id = calc.published.origId;
    Calc.set(calc.id, calc);
    Calc.setRemote(calc.id, calc);
  }

  Calc.publish(calc.id);
  Calc.pub();
};

Action.unpublish = function (calc) {
  if (!calc?.published?.id) {
    return;
  }

  calc.published.origId = calc.published.id;
  calc.published.id = null;
  Action.save(calc);

  // keep track of original uid for republishing
  let blank = Calc.createCalcObject();
  blank.uid = firebase.auth().currentUser.uid;
  Calc.publishToSharedFirebase(calc.published.origId, blank);
};

// map from calc.id => result array
Action.results = {};
Action.setResults = function (calc, results) {
  this.results[calc.id] = results;
}

Action.getResults = function (calc) {
  return this.results[calc.id];
};

/**
 * @param {Calc} calc - calc object
 * @param {string} style - null, inputs, results, resultsAll
 */
Action.getTextView = function (calc, style = null) {
  const results = this.results[calc.id] || [];

  const inputs = results.map(result => {
    let input = result.input;
    if (result.comment) {
      input = input.split("//")[0];
    }
    return input.trim();
  });

  const max = Math.max(...inputs.map(input => input.length));

  const padToMax = str => str.padEnd(max + 5, ' ');

  const formatFraction = line => line.replace(/FRACTION{(\d+)[,]\s*(\d+)}/g, "$1/$2");

  const lines = results.map((result, i) => {
    if (!inputs[i] && result.comment) {
      return result.comment;
    }

    // Align to same number of chars
    const suffix = [result.type, result.comment].filter(Boolean).join(" ");
    const prefix = inputs[i] || result.comment.trim();
    const equalsSign = (inputs[i] && result.result) ? " = " : "";
    const resultStr = result.result || "";

    // Format the line using a template literal, pad to max and format fraction
    let line = `${padToMax(prefix)}${equalsSign}${resultStr} ${suffix}`.trim();

    if (style === "inputs") {
      line = inputs[i];
    }

    if (style === "results") {
      line = resultStr;
    }

    if (style === "resultsAll") {
      line = `${resultStr} ${suffix}`.trim();
    }

    return formatFraction(line);
  });

  return lines.join("\n");
};

Action.getPublicURL = function (calc = {}) {
  var base = "https://instacalc.com/";
  if (window.location.href.match("localhost")) {
    base = "/";
  }
  if (!(calc.published && calc.published.id)) {
    return "";
  }

  return base + calc.published.id;
};

Action.getEmbedURL = function (calc) {
  return this.getPublicURL(calc) + "/embed";
};

Action.isLoggedIn = function () {
  return user && user.uid;
};

Action.isOwner = function (calc) {
  return user && user.uid == calc.uid;
};

Action.getShortId = function (calc) {
  return calc.id.split("-")[0];
};

Action.engine = new InstaCalc();

Action.isLegacyCalc = function (calc) {

  // all local calcs are updated
  if (!calc.published) {
    return false;
  }

  if (calc.version) {
    return false;
  }

  // published, and originally created before the beta epoch
  // TODO: have a "v2" flag
  const BETA_EPOCH = Date.parse("2022-11-03T23:45:00.000Z");
  let date = calc.created || calc.created_at || calc.updated;

  if (date && Date.parse(date) < BETA_EPOCH) {
    return true;
  }

  return false;
};

Action.legacyRecalculate = function (calc) {
  var inputs = calc.rows.map((row) => row?.text || "");
  var results = this.engine.instacalc_compute(inputs, {
    rounding: calc.rounding,
  });

  return results.map((result, i) => {
    return {
      input: inputs[i],
      result: result.result,
      comment: result.comment,
      title: result.title,
    };
  });
};

var processCache = {};
Action.scanForErrors = function (ret) {
  ret.forEach((result) => {
    let time = result.processTime;
    // console.log(result.processed, time);
    if (time > 60 && !processCache[result.processed]) {
      processCache[result.processed] = time;
      if (typeof Rollbar != "undefined") {
        Rollbar.info("slow parse", { time: time, processed: result.processed }); // log this slow result
      }
    }
  });
};

Action.recalculate = function (calc) {
  if (Action.isLegacyCalc(calc) || typeof IC == "undefined") {
    return Action.legacyRecalculate(calc);
  }

  let ret = IC.api.recalculate(calc);

  // do async check for errors
  window.setTimeout(() => Action.scanForErrors(ret), 1000);
  return ret;
};

Action.async_recalculate = function (calc, callback) {
  if (IC.WORKER_LOADED && !Action.isLegacyCalc(calc)) {
    IC.WORKER_RECALCULATE(calc, callback);
  }
  else {
    let ret = Action.legacyRecalculate(calc);
    callback(ret);
  }
};

Action.name = function (str, calc) {
  return str + calc.id;
};

// Embed
Embed.calcs = {};

Embed.save = function (calc) {
  this.calcs[calc.id] = calc;
  this.pub(calc);
};

Embed.get = function (id) {
  return this.calcs[id];
};

Embed.createCopy = function (id, newId) {
  const originalCalc = this.get(id);
  if (!originalCalc) return null;

  const calcCopy = { ...originalCalc, id: newId };
  this.calcs[newId] = calcCopy;
  return calcCopy;
};

Embed.callbacks = [];

Embed.pub = function (calc) {
  this.callbacks.forEach(fn => fn(calc));
};

Embed.sub = function (fn) {
  if (!this.callbacks.includes(fn)) {
    this.callbacks.push(fn);
  }
};

Embed.unsub = function (fn) {
  const index = this.callbacks.indexOf(fn);
  if (index > -1) {
    this.callbacks.splice(index, 1);
  }
};

// assign a new guid to the calc copy
Embed.loadEmbed = function (id, fn, newId) {
  if (!id) {
    console.log("ERROR: invalid calc ID.");
    return () => { };
  }

  const calcCopy = this.createCopy(id, newId);
  this.sub(fn);

  if (calcCopy) {
    fn(calcCopy);
    return () => { };
  }

  var path = "/shared/";
  if (parseInt(id) < 50000) {
    path = "/archive/";
  }

  var url = "https://instacalc.firebaseio.com" + path + id + ".json";
  CachedJSON.fetch(url).then((calc) => {
    if (calc) {
      calc.id = id;
      calc.published = { id: id };
      calc = Calc.validate(calc);
      this.save(calc);
      const copy = this.createCopy(id, newId);
      this.save(copy);
      fn(copy);
    } else {
      console.log("REMOTE NOT FOUND:" + id);
    }
  });

  return () => { };
};

Calc = {};

// return new objects, otherwise these get linked
var EMPTY_ROW = function (n) {
  var rows = [];
  for (var i = 0; i < n; i++) {
    rows.push({ text: "" });
  }
  return rows;
};

var DEFAULT_NAME = "Scratchpad";

var DEMO_ROWS = [
  { text: "" },
  { text: "" },
  { text: "// just type and answers appear" },
  { text: "50 + 300*2" },
  { text: "$250k + 15%" },
  { text: "100 USD in EUR" },
  { text: "1 gallon in cups" },
  { text: "400k mortgage 30 years 6%" },
  { text: "200 miles at 25 mpg with $3.80/gal" },
  { text: "today + 90 days" },
];

var DEMO_ROWS_NEW = [
  { text: "" },
  { text: "" },
  { text: "// just type and answers appear" },
  { text: "50 + 300*2" },
  { text: "net income = $75k - 30%" },
  { text: "500 USD to EUR" },
  { text: "25 C to F" },
  { text: "50 miles @ 75 mph in minutes" },
  { text: "20 mbps in minutes until 5 gigabytes" },
];

Calc.createCalcObject = function (obj) {
  var now = new Date().toISOString();
  var calc = {
    id: Action.Util.guid(),
    name: obj?.name || DEFAULT_NAME,
    rows: obj?.rows || EMPTY_ROW(5),
    updated: now,
    created: now,
    published: null,
    version: 2.0,
    viewMode: obj?.viewMode || "calc",
  };

  // merge default settings from obj
  return calc;
};

Calc.all = function () {
  var calcs = Object.values(window.store.calcs)
    .filter(Calc.validate)
    .filter((calc) => !calc.deleted);

  if (calcs.length === 0) {
    var new_calc = Calc.createCalcObject();
    Calc.set(new_calc.id, new_calc);
    return [new_calc];
  }

  return calcs;
};

Calc.allByNewest = function () {
  return Calc.all().sort(function (a, b) {
    return new Date(b.updated || b.created) - new Date(a.updated || a.created);
  });
};

Calc.get = function (id) {
  var calc = window.store.calcs[id];
  return Calc.validate(calc);
};

Calc.set = function (id, calc) {
  window.store.calcs[id] = Calc.validate(calc);
  Calc.saveLocalStore();
  // Calc.saveLocalStore();
};

Calc.setIfNewer = function (id, calc) {
  let existing = Calc.get(id);
  if (!existing) {
    return Calc.set(id, calc);
  }

  let local_updated = Date.parse(existing.updated);
  let remote_updated = Date.parse(calc.updated);
  let editTime = 5 * 1000; // ms

  if (local_updated - remote_updated > editTime) {
    // console.log("local newer: not loading remote", calc.id, calc.title);
  } else {
    Calc.set(id, calc);
  }
};

// todo - validate calc format before save
Calc._setRemote = function (id, calc) {
  let user = Action.getCurrentUser();

  // update firebase as well
  if (typeof firebase !== "undefined" && firebase && user?.uid) {
    var updates = {};
    updates["/users/" + user.uid + "/calcs/" + id] = calc;
    firebase.database().ref().update(updates);
  }
};

Calc.setRemote = Action.Util.debounce(Calc._setRemote, 250);

// sanity check calc on every access
Calc.validate = function (calc) {
  if (!calc || typeof calc !== "object" || !calc.id) {
    console.log("Invalid calc");
    console.log(calc);
    return null;
  }

  if (!Array.isArray(calc.rows)) {
    console.log("Invalid rows");
    calc.rows = EMPTY_ROW(5);
  }

  // Sanitize null rows - replace with empty row objects
  calc.rows = calc.rows.map(row => row || { text: '', hidden: false });

  return calc;
};

Calc.merge = function (id, props) {
  var calc = Calc.get(id);
  for (var key in props) {
    calc[key] = props[key];
  }
  Calc.set(id, calc);
};

Action.setCalcViewMode = function (calc, mode) {
  if (!calc || !calc.id) return;
  calc.viewMode = mode;
  calc.updated = new Date().toISOString();
  Calc.set(calc.id, calc);
  Calc.setRemote(calc.id, calc);
};

Action.getCalcViewMode = function (calc) {
  if (!calc) return "calc";
  const viewMode = calc.viewMode;
  // Only allow valid view mode types
  if (viewMode === "text" || viewMode === "calc") {
    return viewMode;
  }
  return "calc";
};

Calc.publishToSharedFirebase = function (id, calc) {
  if (typeof firebase !== "undefined" && firebase) {
    if (calc?.published?.disabled) {
      // calc is not meant to be published
      return;
    }

    var updates = {};
    updates["/shared/" + id] = calc;
    firebase.database().ref().update(updates);
  }
};

Calc.publish = function (id) {
  var calc = Calc.get(id);

  // make a publish-ready version of the calc
  var published_date = new Date().toISOString();

  // merge new properties over existing
  var firebase_calc = {
    ...calc,
    updated: published_date,
    uid: firebase.auth().currentUser.uid,
  };

  function handlePublish(published_id) {
    Calc.merge(id, {
      published: { id: published_id, updated: published_date },
    });
    Calc.setRemote(id, Calc.get(id));
    Calc.publishToSharedFirebase(published_id, firebase_calc);
    Calc.pub();
  }

  if (!calc?.published?.id && calc?.published?.origId) {
    // hasn't been re-published yet
    return;
  }

  if (calc.published && calc.published.id) {
    handlePublish(calc.published.id);
  } else {
    var countRef = firebase.database().ref("/shared/_count");
    countRef.transaction(
      function (current_value) {
        return (current_value || 0) + 1;
      },
      function (err, committed, ss) {
        if (err) {
          // setError(err);
        } else if (committed) {
          // if counter update succeeds, then create record
          // probably want a recourse for failures too
          handlePublish(ss.val());
        }
      }
    );
  }
};

Calc.callbacks = [];
Calc.sub = function (fn) {
  Calc.callbacks.push(fn);
};

Calc.pub = function () {
  Calc.callbacks.map((fn) => {
    fn();
  });
};

// Have a calc store (locally) which can sync with firebase
Calc.loadLocalStore = function () {
  // console.log("loadLocalStore");
  var store;
  try {
    if (window.localStorage && localStorage.getItem("store")) {
      var json_string = localStorage.getItem("store");
      store = JSON.parse(json_string);
    }
  } catch (e) {
    console.log("Error decoding JSON");
  }

  window.store = store || {};
  if (!window.store.calcs) {
    var newCalc = Calc.createCalcObject({ rows: DEMO_ROWS });
    window.store.calcs = {};
    window.store.calcs[newCalc.id] = newCalc;
  }
};

Calc.loadLocalStore();

Calc.clearLocalStore = function () {
  if (window.localStorage) {
    localStorage.setItem("store", "");
  }
};

Calc._saveLocalStore = function () {
  if (!window.localStorage) {
    return;
  }
  if (localStorage) {
    localStorage.setItem("store", JSON.stringify(window.store));
  }
};

Calc.saveLocalStore = Action.Util.debounce(Calc._saveLocalStore, 500);

Action.exportAllCalcs = function () {
  const data = JSON.stringify(Calc.all(), null, 2);
  const blob = new Blob([data], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = 'calcs.json';
  link.click();
};

Action.exportCalc = function (calc) {
  const data = JSON.stringify(calc, null, 2);
  const blob = new Blob([data], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `${calc.name}.json`;
  link.click();
};

Action.importAllCalcs = function (file) {
  const reader = new FileReader();
  reader.onload = (event) => {
    const data = JSON.parse(event.target.result);

    if (Array.isArray(data)) {
      data.forEach((calc) => {
        Calc.set(calc.id, calc);
      });
      console.log('Imported', data.length, 'calcs');
    } else if (data.id) {
      Calc.set(data.id, data);
      console.log('Imported 1 calc');
    } else {
      console.error('Invalid JSON data');
      alert('Invalid JSON data');
    }

    Calc.pub();
    // this is still needed to force a re-render
    window.App.externalForceRender();
  };
  reader.readAsText(file);
};

Action.openFileImportUX = function () {
  const fileInput = document.createElement('input');
  fileInput.type = 'file';
  fileInput.accept = '.json';
  fileInput.style.display = 'none';
  document.body.appendChild(fileInput);

  fileInput.addEventListener('change', function (event) {
    const file = event.target.files[0];
    if (file) {
      Action.importAllCalcs(file);
    }
    document.body.removeChild(fileInput);
  });

  fileInput.click();
}

window.user = null;

Action.getCurrentUserId = function () {
  return window.user?.uid || firebase.auth().currentUser.uid;
};

// items that have to be done after JSX is rendered...
Action.refreshUI = function () {
  // console.log("UI refresh");
  // TODO: this happens because preline is not integrated with react
  window?.HSStaticMethods?.autoInit();
};

Action.getCurrentUser = function () {
  return window.user;
};

Action.setCurrentUser = function (user) {
  window.user = user;
};

Action.updateUserData = function (uid, name, email) {
  firebase
    .database()
    .ref("users/" + uid)
    .update({
      username: name,
      email: email,
    });
};

Action.login = function () {
  localStorage["_lastlogin"] = Date.now();

  window.location = "/login.html";

  // var provider = new firebase.auth.GoogleAuthProvider();
  // firebase.auth().signInWithPopup(provider);
};

Action.logout = function () {
  if (Action.getCurrentUser()) {
    firebase
      .auth()
      .signOut()
      .then(
        function () {
          Calc.clearLocalStore();
          localStorage.clear();
          window.location = "/";
        },
        function (error) {
          console.error("Sign Out Error", error);
        }
      );
  }
};

Action.__firebase_count = 0;
Action.loadFirebase = function () {
  if ((typeof firebase === "undefined" || !firebase.auth || !firebase.database) && Action.__firebase_count < 8) {
    // console.log("deferring firebase check");
    Action.__firebase_count++;
    setTimeout(Action.loadFirebase, 250);
  } else if (typeof firebase !== "undefined") {
    // configure if not already setup
    if (typeof FIREBASE_CONFIG === "undefined") {
      var FIREBASE_CONFIG = {
        apiKey: "AIzaSyDB0PiisLG31Lvn-KGADptCUpUiOcliWb8",
        authDomain: "instacalc.com",
        databaseURL: "https://instacalc.firebaseio.com",
        storageBucket: "firebase-instacalc.appspot.com",
        messagingSenderId: "297159307988",
      };

      firebase.initializeApp(FIREBASE_CONFIG);
    }
  }
}

Action.loadRemoteCalcs = function (uid) {
  firebase
    .database()
    .ref(`/users/${uid}/calcs`)
    .on("value", function (data) {
      const calcs = data.val();
      if (!calcs) {
        return;
      }

      for (const id in calcs) {
        // For online vs. offline, assume firebase figures that out
        // TODO: optimize this to only set calc if newer? Calc.set() is still pretty fast
        Calc.setIfNewer(id, calcs[id]);
      }

      Calc.pub();
    });
}

Action.checkUserLogin = function (callback) {
  function afterLogin(user) {
    if (user?.isAnonymous) {
      console.log("Anonymous user");
      return;
    }

    if (!user || !user.uid) {
      console.error('invalid user: ', user);
      return;
    }

    Action.setCurrentUser(user);
    Action.loadRemoteCalcs(user.uid);
    Action.updateUserData(user.uid, user.displayName, user.email);
    console.log("user: ", user.uid);
    callback(user);
  }

  // if firebase not defined, exit
  if (typeof firebase === "undefined") {
    console.log("firebase not loaded");
    return;
  }

  firebase
    .auth()
    .getRedirectResult()
    .then(function (result) {
      let currentUser = Action.getCurrentUser();
      // console.log('getRedirectResult', result);
      if (result?.user) {
        afterLogin(result.user)
      } else if (!currentUser?.uid) {
        console.log("Anonymous user");
        firebase.auth().signInAnonymously();
        callback(null);
      }
    })
    .catch((error) => {
      console.log("AUTH ERROR: ", error);
    });

  // Listen for auth state changes
  firebase.auth().onAuthStateChanged(function (user) {
    if (user && user.isAnonymous === false) {
      console.log('onAuthStateChanged', user);
      afterLogin(user);
    } else {
      // TODO: set app.error
      // BUGFIX: Firebase doesn't allow login with incognito. If 2 login attempts within 30 seconds, raise a warning.
      if (Math.abs(localStorage["_lastlogin"] - Date.now()) < 30 * 1000) {
      }
    }
  });
};


Action.CURRENCY_URL = "https://instacalc.com/currencies.json";
if (location.hostname !== "localhost" && window.location?.protocol !== "file:") {
  // Use local endpoint only in production
  Action.CURRENCY_URL = "/currencies.json";
}

Action.REQUEST_IN_FLIGHT = false;

Action.loadCurrencies = function (callback) {
  // Check if the currencies have already been loaded.
  if (InstaCalc.Unit.currenciesLoaded()) {
    if (callback) {
      callback();
    }
    Calc.pub();
    return;
  }

  // If a fetch request is in progress, don't start another one
  if (Action.REQUEST_IN_FLIGHT) {
    return;
  }

  // Fetch the currency data asynchronously.
  // Old demo url = 'https://malachite-glade.hyperdev.space/api/data/currencies.json';
  Action.REQUEST_IN_FLIGHT = true;
  fetch(Action.CURRENCY_URL)
    .then((res) => {
      // Check if response came from service worker cache
      const source = res.headers.get('x-cache') || (res.ok && !navigator.onLine ? 'cache' : 'network');
      return res.json().then(data => ({ data, source }));
    })
    .then(({ data, source }) => {
      console.log(`Currencies: from ${source}`);
      InstaCalc.loadCurrencies(data);
      if (callback) {
        callback();
      }
      Calc.pub();
    })
    .catch((error) => {
      console.error('Currencies: fetch error -', error);
    })
    .finally(() => {
      Action.REQUEST_IN_FLIGHT = false;  // Reset the request in flight flag
    });
};

Action.fn = {};

Action.STOCK_URL = '/stock.json';
if (location.hostname !== "localhost" || window.location?.protocol === "file:") {
  Action.STOCK_URL = 'https://instacalc.com/stock.json';
}

Action.fn.stock_cache = {};

Action.fn.stock = function (symbol) {
  // Check if the stock data is already in the cache.
  const data = Action.fn.stock_cache[symbol];
  if (data) {
    return data.loaded ? data.price : undefined;
  }

  // If not, fetch the data asynchronously.
  Action.fn.stock_cache[symbol] = { loaded: false };
  fetch(Action.STOCK_URL + '?symbol=' + symbol)
    .then((res) => res.json())
    .then((data) => {
      console.log('JSON stock lookup: ' + symbol);
      Action.fn.stock_cache[symbol] = {
        loaded: true,
        price: data.regularMarketPreviousClose,
      };
      InstaCalc.updateUnitTimeStamp();
      Calc.pub();
    })
    .catch((error) => {
      console.error(`Error fetching stock data for ${symbol}:`, error);
      Action.fn.stock_cache[symbol] = { loaded: true };
    });

  return `Loading ${symbol}...`;
};

Action.fn.import_cache = {};
Action.fn.import = function (url) {
  const data = Action.fn.import_cache[url];
  if (data) {
    return data.loaded ? (data.json ?? data.text) : undefined;
  }

  // load cache with unloaded result
  Action.fn.import_cache[url] = { loaded: false };

  console.log('Importing url: ' + url);
  fetch(url)
    .then((res) => res.text())
    .then((text) => {
      Action.fn.import_cache[url] = {
        loaded: true,
        text: text,
        json: IC.ICParseRelaxedJSON(text),
        date: new Date().toISOString(),
      };
      InstaCalc.updateUnitTimeStamp(); // to break cache
      Calc.pub();
    })
    .catch((error) => {
      console.error(`Error fetching ${url}:`, error);
    });

  return undefined;
};

Action.fn.import_calc_cache = {};
Action.fn.import_calc_handle_result = function (id_lookup, calc) {
  env = calc ? IC.api.recalculate(calc, true).env : "Calc not found";

  Action.fn.import_calc_cache[id_lookup.toString()] = {
    loaded: true,
    env: env,
    date: new Date().toISOString(),
  };
  InstaCalc.updateUnitTimeStamp();
  Calc.pub();

};

Action.fn.extractCalcIdFromString = function (str) {
  // Check if id is a number or matches the formats
  const match = str.toString().match(/^(?:https?:\/\/)?instacalc\.com\/(\d+)|^\d+$/);

  if (match) {
    // If the match is from the URL, extract the group, otherwise parse the number
    return match[1] ? parseInt(match[1], 10) : parseInt(str, 10);
  }

  // Return null or throw an error if the id is not in a valid format
  return null;
};

// id: 12345, instacalc.com/12345, or "My Calc"
Action.fn.import_calc = function (id) {
  // Extract number from id
  let possibleId = Action.fn.extractCalcIdFromString(id);
  if (possibleId) {
    id = possibleId;
  }

  const data = Action.fn.import_calc_cache[id?.toString()];
  if (data) {
    return data.loaded ? data.env : undefined;
  }

  if (typeof id === "number") {
    console.log('Importing calc from embed id: ' + id);
    Embed.loadEmbed(id, (calc) => {
      Action.fn.import_calc_handle_result(id, calc);
    });
  }

  // If the id is a string, find a calc of the same name
  if (typeof id === 'string') {
    console.log('Importing calc from string: ' + id);

    // Check if we're in a service worker context
    if (typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope) {
      // We're in a service worker, send a message to the main thread
      self.postMessage({ type: 'FETCH_CALC', id: id });
    } else {
      // We're in the main thread, proceed as before
      const calc = Calc.all().find((c) => c.name?.toLowerCase().trim() === id.toLowerCase().trim());
      if (calc) {
        Action.fn.import_calc_handle_result(id, calc);
        return;
      }
    }
  }
};

/* keyboard shortcuts */
Action.registerKeyboardHandlers = function () {
  document.addEventListener('keydown', Action.handleKeyPress);
};

Action.handleKeyPress = function (event) {
  const SHORTCUTS = {
    "ccc": () => { Action.clearCurrentLine() },
    "iii": () => {
      // insert row above
      const row = Action.currentCalc?.rows?.[Action.selectedRow];
      if (row) {
        const newText = row.text.replace(/i+$/, '');
        if (newText !== row.text) {
          Action.updateRowText(Action.currentCalc, Action.selectedRow, newText);
        }
        Action.insertRowBeforeCurrentLine();
      }
    },
    "ooo": () => {
      const row = Action.currentCalc?.rows?.[Action.selectedRow];
      if (row) {
        const newText = row.text.replace(/o+$/, '');
        if (newText !== row.text) {
          Action.updateRowText(Action.currentCalc, Action.selectedRow, newText);
        }
        Action.insertRowAfterCurrentLine();
        Action.currentInstaCalcReact.focusRow(Action.selectedRow + 1);
      }
    },

    "ddd": () => { Action.deleteRowCurrentLine(); },
    "[Del][Del][Del]": () => {
      const calc = Action.getCurrentCalc();
      const row = calc?.rows?.[Action.selectedRow];
      if (row && row.text.trim() === '' && calc.rows.length > 1) {
        Action.deleteRowCurrentLine();
      }
    },
  };

  const MAX_SEQUENCE_LENGTH = Math.max(...Object.keys(SHORTCUTS).map(k => k.length));
  const TIMEOUT = 350; // milliseconds

  // Use closure to maintain state between function calls
  if (!Action.handleKeyPress.state) {
    Action.handleKeyPress.state = {
      lastKeyPressTime: 0,
      keyPressSequence: ''
    };
  }

  const state = Action.handleKeyPress.state;
  const currentTime = new Date().getTime();
  let key = event.key.toLowerCase();

  // Convert special keys to a readable format
  if (key === 'backspace' || key === 'delete') {
    key = '[Del]';
  }

  if (currentTime - state.lastKeyPressTime > TIMEOUT) {
    state.keyPressSequence = key;
  } else {
    state.keyPressSequence += key;
  }
  state.lastKeyPressTime = currentTime;

  // Trim the sequence if it's longer than the longest shortcut
  if (state.keyPressSequence.length > MAX_SEQUENCE_LENGTH) {
    state.keyPressSequence = state.keyPressSequence.slice(-MAX_SEQUENCE_LENGTH);
  }

  // Check if the sequence matches any shortcut
  for (const [shortcut, action] of Object.entries(SHORTCUTS)) {
    if (state.keyPressSequence.endsWith(shortcut)) {
      event.preventDefault();
      action();
      state.keyPressSequence = '';
      break;
    }
  }
};

//Action.registerKeyboardHandlers();

const CachedJSON = {
  cache: new Map(),
  fetch(url, options = {}) {
    const cacheKey = JSON.stringify({ url, options });
    if (!this.cache.has(cacheKey)) {
      this.cache.set(cacheKey, fetch(url, options)
        .then(res => res.json()) // only want to call .json once for all consumers
        .catch(error => {
          this.cache.delete(cacheKey); // Remove failed requests from cache
          throw error; // Re-throw the error for the caller to handle
        })
      );
    }
    return this.cache.get(cacheKey);
  }
};
;
var __ICREACT = (() => {
  var __defProp = Object.defineProperty;
  var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
  var __getOwnPropNames = Object.getOwnPropertyNames;
  var __hasOwnProp = Object.prototype.hasOwnProperty;
  var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
  var __export = (target, all) => {
    for (var name in all)
      __defProp(target, name, { get: all[name], enumerable: true });
  };
  var __copyProps = (to, from, except, desc) => {
    if (from && typeof from === "object" || typeof from === "function") {
      for (let key of __getOwnPropNames(from))
        if (!__hasOwnProp.call(to, key) && key !== except)
          __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
    }
    return to;
  };
  var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

  // public/src/instacalc.jsx
  var instacalc_exports = {};
  __export(instacalc_exports, {
    default: () => instacalc_default
  });
  var LIB = {};
  try {
    window.IC_UI_DEBUG = window.IC_UI_DEBUG || false;
  } catch (e) {
  }
  function UIlog() {
    try {
      if (window.IC_UI_DEBUG) {
        console.log.apply(console, arguments);
      }
    } catch (e) {
    }
  }
  __name(UIlog, "UIlog");
  LIB.tryToRender = function(reactElement, querySelector) {
    let el = document.querySelector(querySelector);
    if (el) {
      ReactDOM.render(reactElement, el);
    }
  };
  LIB.prettyPrintResultHTML = (result) => {
    let result_display = result;
    if (result_display && typeof result_display === "object") {
      try {
        result_display = JSON.stringify(result_display);
      } catch (e) {
        result_display = String(result_display);
      }
    }
    if (typeof result_display === "string") {
      let fracRegex = new RegExp(/FRACTION{(\d+)[,]\s*(\d+)}/);
      let fractionMatch = result_display.match(fracRegex);
      if (fractionMatch) {
        let n = fractionMatch[1];
        let d = fractionMatch[2];
        const buildFraction = /* @__PURE__ */ __name((start, n2, d2, end) => /* @__PURE__ */ React.createElement("span", null, start.trim(), /* @__PURE__ */ React.createElement("frac", null, /* @__PURE__ */ React.createElement("span", { className: "fracspace" }, " "), /* @__PURE__ */ React.createElement("sup", null, n2), "\u2044", /* @__PURE__ */ React.createElement("sub", null, d2)), end.trim()), "buildFraction");
        let parts = result_display.split(fracRegex);
        result_display = buildFraction(parts[0] || "", n, d, parts[parts.length - 1] || "");
      }
    }
    return result_display;
  };
  LIB.prettyPrintFunction = (funcObj) => {
    return `function(${funcObj.params.join(", ")})`;
  };
  LIB.prettyPrintObject = (obj, indent = 2) => {
    let result = "";
    const addIndent = /* @__PURE__ */ __name((level) => " ".repeat(level * indent), "addIndent");
    const isReactEl = /* @__PURE__ */ __name((v) => v && typeof v === "object" && (v.$$typeof || v.props), "isReactEl");
    const formatObject = /* @__PURE__ */ __name((o, level = 0) => {
      if (!o || typeof o !== "object") {
        result += `${addIndent(level)}${String(o)}
`;
        return;
      }
      if (isReactEl(o)) {
        result += `${addIndent(level)}[react-element]
`;
        return;
      }
      let entries = [];
      try {
        entries = Object.entries(o);
      } catch (e) {
        entries = [];
      }
      for (const [key, value] of entries) {
        if (typeof value === "object" && value !== null) {
          if (isReactEl(value)) {
            result += `${addIndent(level)}${key}: [react-element]
`;
            continue;
          }
          let formatted = IC.api.formatValue(value);
          if (formatted !== value && typeof formatted !== "object") {
            result += `${addIndent(level)}${key}: ${formatted}
`;
          } else {
            result += `${addIndent(level)}${key}:
`;
            formatObject(value, level + 1);
          }
        } else {
          result += `${addIndent(level)}${key}: ${value}
`;
        }
      }
    }, "formatObject");
    formatObject(obj);
    return result;
  };
  LIB.prettyPrintArray = (arr, indent = 2, level = 0) => {
    let result = "";
    const addIndent = /* @__PURE__ */ __name((level2) => " ".repeat(level2 * indent), "addIndent");
    const isReactEl = /* @__PURE__ */ __name((v) => v && typeof v === "object" && (v.$$typeof || v.props), "isReactEl");
    const formatArray = /* @__PURE__ */ __name((a, level2 = 0) => {
      (a || []).forEach((item, index) => {
        if (typeof item === "object" && item !== null) {
          if (isReactEl(item)) {
            result += `${addIndent(level2)}[${index}]: [react-element]
`;
            return;
          }
          let formatted = IC.api.formatValue(item);
          if (formatted !== item && typeof formatted !== "object") {
            result += `${addIndent(level2)}[${index}]: ${formatted}
`;
          } else if (Array.isArray(item)) {
            result += `${addIndent(level2)}[${index}]:
`;
            result += LIB.prettyPrintArray(item, indent, level2 + 1);
          } else {
            result += `${addIndent(level2)}[${index}]:
`;
            result += LIB.prettyPrintObject(item, indent, level2 + 1);
          }
        } else {
          result += `${addIndent(level2)}[${index}]: ${item}
`;
        }
      });
    }, "formatArray");
    formatArray(arr, level);
    return result;
  };
  var SliderControl = class extends React.Component {
    static {
      __name(this, "SliderControl");
    }
    constructor(props) {
      super(props);
      this.state = {
        localValue: null,
        // Track value during drag
        isDragging: false
      };
    }
    componentDidUpdate(prevProps) {
      if (!this.state.isDragging && prevProps.current !== this.props.current) {
        this.setState({ localValue: null });
      }
    }
    handleChange = /* @__PURE__ */ __name((e) => {
      const newValue = Number(e.target.value);
      this.setState({ localValue: newValue, isDragging: true });
      this.props.onChange(newValue);
    }, "handleChange");
    handleMouseUp = /* @__PURE__ */ __name(() => {
      this.setState({ isDragging: false, localValue: null });
    }, "handleMouseUp");
    render() {
      const { min, max, step, current, decimals, fmt, hasRowParameter } = this.props;
      const displayValue = this.state.localValue !== null ? this.state.localValue : current;
      return /* @__PURE__ */ React.createElement("div", { className: "flex items-center gap-1.5 sm:gap-3 w-full md:w-1/2" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "range",
          className: "flex-1 w-full h-2 rounded-md outline-none cursor-pointer",
          min,
          max,
          step,
          value: displayValue,
          onChange: this.handleChange,
          onMouseUp: this.handleMouseUp,
          onTouchEnd: this.handleMouseUp
        }
      ), /* @__PURE__ */ React.createElement("span", { className: "text-sm sm:text-base opacity-80 min-w-[2.5ch] sm:min-w-[3ch] text-right shrink-0" }, fmt(displayValue)));
    }
  };
  var UIControlRenderer = class _UIControlRenderer {
    static {
      __name(this, "UIControlRenderer");
    }
    // Helper to strip quotes from strings
    static stripQuotes(s) {
      if (typeof s !== "string") return s;
      const t = s.trim();
      if (t.startsWith('"') && t.endsWith('"') || t.startsWith("'") && t.endsWith("'")) {
        return t.slice(1, -1);
      }
      return t;
    }
    // Helper to convert value to snippet
    static valueToSnippet(val) {
      if (typeof val === "number") return String(val);
      if (typeof val === "boolean") return val ? "true" : "false";
      return String(val);
    }
    // Determine selected index for option-based controls
    static getSelectedIndex(options, result) {
      UIlog("[getSelectedIndex] options:", options, "result.ui_write:", result?.ui_write);
      options.forEach((opt, idx) => {
        UIlog(
          "[getSelectedIndex] opt[" + idx + "]:",
          "label:",
          opt.label,
          "raw:",
          opt.raw,
          "value:",
          opt.value
        );
      });
      const selectedIndex = IC.parser.UIMetadataParser.getSelectedOptionIndex(options, result);
      UIlog("[getSelectedIndex] selectedIndex:", selectedIndex);
      return selectedIndex;
    }
    // Render dropdown control
    static renderDropdown(options, selectedIndex, hasRowParameter, onChange) {
      return /* @__PURE__ */ React.createElement(
        "select",
        {
          className: (hasRowParameter ? "configField w-full lg:w-1/3 mr-1" : "w-full md:w-auto md:min-w-[180px] ") + " px-2 py-1 border border-color-soft text-color-default rounded-md text-base outline-none focus:ring-2 focus:ring-sky-300 hover-bg-button transition",
          value: String(selectedIndex),
          onChange: (e) => {
            const i = parseInt(e.target.value, 10) || 0;
            const opt = options[i] || options[0];
            onChange(opt.raw);
          }
        },
        options.map((opt, i) => /* @__PURE__ */ React.createElement("option", { key: i, value: String(i) }, opt.label))
      );
    }
    // Render multiselect control
    static renderMultiselect(options, result, hasRowParameter, onChange) {
      const selected = result?.ui_write?.multiselect_selected ?? [];
      const normalizeKey = /* @__PURE__ */ __name((v) => JSON.stringify(v), "normalizeKey");
      const selectedKeys = new Set(selected.map(normalizeKey));
      const handleChange = /* @__PURE__ */ __name((e) => {
        const selected2 = Array.from(e.target.selectedOptions || []).map((opt) => Number(opt.value));
        const snippets = selected2.map((i) => {
          const opt = options[i];
          return opt?.raw;
        });
        const arraySnippet = `[${snippets.join(", ")}]`;
        onChange(arraySnippet);
      }, "handleChange");
      return /* @__PURE__ */ React.createElement(
        "select",
        {
          multiple: true,
          size: Math.min(6, Math.max(3, options.length)),
          className: (hasRowParameter ? "configField mr-1" : "") + " w-full sm:min-w-[180px] px-2 py-1 border border-color-soft text-color-default bg-secondary rounded-md text-base outline-none focus:ring hover-bg-button transition",
          value: options.map((opt, i) => selectedKeys.has(normalizeKey(opt.value)) ? String(i) : null).filter((v) => v !== null),
          onChange: handleChange
        },
        options.map((opt, i) => /* @__PURE__ */ React.createElement("option", { key: i, value: String(i) }, opt.label))
      );
    }
    // Render radio buttons control
    static renderRadio(options, selectedIndex, calcId, rowIndex, onChange, result = null) {
      const name = `row-radio-${calcId}-${rowIndex}`;
      UIlog("[renderRadio] options:", options, "selectedIndex:", selectedIndex);
      const valueRaw = result?.ui_write?.value_raw;
      const valueEval = result?.ui_write?.value_eval;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "flex flex-wrap items-center w-full gap-2 sm:gap-3",
          "data-value-raw": valueRaw,
          "data-value-eval": valueEval,
          "data-selected-index": selectedIndex
        },
        options.map((opt, i) => /* @__PURE__ */ React.createElement(
          "label",
          {
            key: i,
            className: "inline-flex items-center gap-2 cursor-pointer",
            "data-opt-index": i,
            "data-opt-label": opt.label,
            "data-opt-raw": opt.raw,
            "data-opt-value": JSON.stringify(opt.value)
          },
          /* @__PURE__ */ React.createElement(
            "input",
            {
              type: "radio",
              name,
              checked: i === selectedIndex,
              onChange: () => {
                UIlog("[renderRadio] onChange clicked, opt:", opt, "opt.raw:", opt.raw);
                onChange(opt.raw);
              },
              className: "w-4 h-4 focus:ring-0 focus:outline-none",
              "data-opt-index": i,
              "data-opt-raw": opt.raw
            }
          ),
          /* @__PURE__ */ React.createElement("span", { className: "text-base" }, opt.label)
        ))
      );
    }
    // Render date/time input
    static renderDateTimeInput(type, result, hasRowParameter, onChange) {
      const htmlType = type === "datetime" ? "datetime-local" : type;
      const current = result?.ui_input_type === htmlType && typeof result?.ui_display_value === "string" ? result.ui_display_value : "";
      return /* @__PURE__ */ React.createElement(
        "input",
        {
          type: htmlType,
          className: (hasRowParameter ? "configField mr-1" : "") + " w-full md:w-1/2 sm:min-w-[180px] px-2 py-1 border border-color-soft text-color-default bg-secondary rounded-md text-base outline-none focus:ring hover-bg-button transition",
          value: current || "",
          onChange: (e) => {
            try {
              const canon = window.IC && window.IC.parser && typeof window.IC.parser.canonicalizeDateInput === "function" ? window.IC.parser.canonicalizeDateInput(htmlType, e.target.value) : String(e.target.value || "");
              const literal = IC.parser.dateToNativeLiteral(type, canon);
              onChange(literal);
            } catch (_) {
              onChange(String(e.target.value || ""));
            }
          }
        }
      );
    }
    // Render slider/range control
    static renderSlider(result, hasRowParameter, assignedSnippet, onChange) {
      const min = result?.ui_write?.min_eval ?? 0;
      const max = result?.ui_write?.max_eval ?? 100;
      const step = result?.ui_write?.step_eval ?? 1;
      const evalVal = result?.ui_write?.value_eval;
      const current = typeof evalVal === "number" ? evalVal : Number(_UIControlRenderer.stripQuotes(assignedSnippet)) || 0;
      const stepStr = typeof step === "number" && isFinite(step) ? String(step) : null;
      const decimals = stepStr && stepStr.includes(".") ? stepStr.length - stepStr.indexOf(".") - 1 : 0;
      const fmt = /* @__PURE__ */ __name((n) => {
        if (typeof n !== "number" || !isFinite(n)) return "";
        return n.toLocaleString(void 0, {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals
        });
      }, "fmt");
      return /* @__PURE__ */ React.createElement(
        SliderControl,
        {
          min,
          max,
          step,
          current,
          decimals,
          fmt,
          hasRowParameter,
          onChange
        }
      );
    }
    // Render checkbox control
    static renderCheckbox(result, uiMeta, hasRowParameter, onChange) {
      const checked = result?.ui_write?.checkbox_checked ?? false;
      return /* @__PURE__ */ React.createElement("label", { className: (hasRowParameter ? "configField w-full md:w-1/3 mr-1 inline-flex" : "inline-flex ") + " items-center gap-2" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          checked,
          onChange: (e) => onChange(e.target.checked),
          className: "w-4 h-4 focus:ring-0 focus:outline-none"
        }
      ), /* @__PURE__ */ React.createElement("span", { className: "text-base opacity-75" }, uiMeta.label || ""));
    }
  };
  var FormatDropdown = class extends React.Component {
    static {
      __name(this, "FormatDropdown");
    }
    constructor(props) {
      super(props);
      this.state = {
        formattedValues: {},
        inputValues: {}
      };
      this.formatConfig = {
        helpText: "Type a format after the calculation:",
        helpExample: "3000 as money => 3K",
        categories: [
          {
            id: "common",
            title: /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "inline w-4 h-4 mr-2" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12z" })), "Most Common"),
            examples: [
              { display: "3000 as money", format: "as money", fallback: "$3K" },
              { display: ".15 as percent", format: "as percent", fallback: "15%" },
              { display: "0x123 as decimal", format: "as decimal", fallback: "291" }
            ]
          },
          {
            id: "currency",
            title: /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "inline w-5 h-5" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M12 6v12m-3-2.818l.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.467-.22-2.121-.659-1.172-.879-1.172-2.303 0-3.182s3.07-.879 4.242 0L15 9m-3 0V6" })), "Currency Display"),
            examples: [
              { display: "$22/7", format: "$", fallback: "$3.14" },
              { display: "$$22/7", format: "$$", fallback: "3.14" },
              { display: "$300000 as money", format: "as money", fallback: "$300K" }
            ]
          },
          {
            id: "science",
            title: /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "inline w-4 h-4 mr-2" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23-.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" })), "Science & Engineering"),
            examples: [
              { display: "15000 as scientific", format: "as scientific", fallback: "1.5e4" },
              { display: "15000 as engineering", format: "as engineering", fallback: "15e3" },
              { display: "3+4i as phasor", format: "as phasor", fallback: "5\u222053.13\xB0" },
              { display: "123456 as 3 sigfig", format: "as 3 sigfig", fallback: "1.23e5" }
            ]
          },
          {
            id: "programming",
            title: /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "inline w-4 h-4 mr-2" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5" })), "Data & Programming"),
            examples: [
              { display: "100 to hex", format: "to hex", fallback: "0x64" },
              { display: "100 to oct", format: "to oct", fallback: "0o144" },
              { display: "100 to bin", format: "to bin", fallback: "0b1100100" },
              { display: "0x64 to dec", format: "to dec", fallback: "100" },
              { display: "pi -> int", format: "-> int", fallback: "3" }
            ]
          },
          {
            id: "rounding",
            title: /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "inline w-4 h-4 mr-2" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" })), "Rounding"),
            examples: [
              { display: "3.14159 -> round", format: "-> round", fallback: "3" },
              { display: "3.14159 -> roundup", format: "-> roundup", fallback: "4" },
              { display: "3.14159 -> rounddown", format: "-> rounddown", fallback: "3" },
              { display: "3.14159 as 2 decimal places", format: "as 2 decimal places", fallback: "3.14" }
            ]
          },
          {
            id: "construction",
            title: /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "inline w-4 h-4 mr-2" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9" })), "Construction"),
            examples: [
              { display: ".15 as fraction", format: "as fraction", fallback: "3/20" },
              { display: ".625 as fraction over 16", format: "as fraction over 16", fallback: "10/16" },
              { display: "3.5 inches as tape", format: "as tape", fallback: '3 1/2"' }
            ]
          },
          {
            id: "utilities",
            title: /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "inline w-4 h-4 mr-2" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M11.42 15.17 17.25 21A2.652 2.652 0 0 0 21 17.25l-5.877-5.877M11.42 15.17l2.496-3.03c.317-.384.74-.626 1.208-.766M11.42 15.17l-4.655 5.653a2.548 2.548 0 1 1-3.586-3.586l6.837-5.63m5.108-.233c.55-.164 1.163-.188 1.743-.14a4.5 4.5 0 0 0 4.486-6.336l-3.276 3.277a3.004 3.004 0 0 1-2.25-2.25l3.276-3.276a4.5 4.5 0 0 0-6.336 4.486c.091 1.076-.071 2.264-.904 2.95l-.102.085m-1.745 1.437L5.909 7.5H4.5L2.25 3.75l1.5-1.5L7.5 4.5v1.409l4.26 4.26m-1.745 1.437 1.745-1.437m6.615 8.206L15.75 15.75M4.867 19.125h.008v.008h-.008v-.008Z" })), "Utilities"),
            examples: [
              { display: "100 cm -> value", format: "-> value", fallback: "100" },
              { display: "100 cm -> unit", format: "-> unit", fallback: "1 cm" },
              { display: "$12345.67 as noformat", format: "as noformat", fallback: "12345.67" },
              { display: "10000 s as time", format: "as time", fallback: "2h 46m 40s" },
              { display: "12345 as nearest 1000", format: "as nearest 1000", fallback: "12000" }
            ]
          },
          {
            id: "fun",
            title: /* @__PURE__ */ React.createElement("span", null, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "inline w-4 h-4 mr-2" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" })), "Fun & Special"),
            examples: [
              { display: "42 as roman", format: "as roman", fallback: "XLII" },
              { display: "100 N as sibase", format: "as sibase", fallback: "100 kg\u22C5m\u22C5s\u207B\xB2" }
            ]
          }
        ]
      };
    }
    getCurrentRowValue = /* @__PURE__ */ __name(() => {
      const ic = this.props.Action.currentInstaCalcReact;
      if (ic?.state?.results) {
        const { result: value = "", type = "" } = ic.state.results[ic.state.selected] || {};
        return `${value} ${type}`.trim();
      }
      return "";
    }, "getCurrentRowValue");
    getCurrentRowName = /* @__PURE__ */ __name(() => {
      return "R" + (this.props.Action?.currentInstaCalcReact?.state?.selected + 1);
    }, "getCurrentRowName");
    getFormattedValue = /* @__PURE__ */ __name((format) => {
      if (!format) {
        return "";
      }
      let currentValue = this.getCurrentRowValue();
      if (!currentValue) {
        return "";
      }
      const singleRowCalc = {
        rows: [{
          text: `${currentValue} ${format}`,
          hidden: false
        }]
      };
      const results = this.props.Action.recalculate(singleRowCalc);
      let result = results[0].result;
      let type = results[0].type;
      if (result && format.includes("bin") || format.includes("hex") || format.includes("oct")) {
        if (result?.includes(".")) {
          result = result.substring(0, result.indexOf(".") + 9);
        }
      }
      return (result + " " + type).trim();
    }, "getFormattedValue");
    getCalculatedValue = /* @__PURE__ */ __name((expression) => {
      if (!expression) {
        return "";
      }
      try {
        const singleRowCalc = {
          rows: [{
            text: expression,
            hidden: false
          }]
        };
        const results = this.props.Action.recalculate(singleRowCalc);
        let result = results[0].result;
        let type = results[0].type;
        if (!result) return "";
        result = result.replace(/FRACTION\{(\d+),(\d+)\}/g, "$1/$2");
        return (result + " " + (type || "")).trim();
      } catch (e) {
        return "";
      }
    }, "getCalculatedValue");
    recalculateAllFormats = /* @__PURE__ */ __name(() => {
      const formattedValues = {};
      this.formatConfig.categories.forEach((category) => {
        category.examples.forEach((example) => {
          formattedValues[example.format] = this.getCalculatedValue(example.display) || example.fallback;
        });
      });
      this.setState({ formattedValues });
    }, "recalculateAllFormats");
    handleHover = /* @__PURE__ */ __name(() => {
      this.recalculateAllFormats();
    }, "handleHover");
    closeModal = /* @__PURE__ */ __name(() => {
      const closeButton = document.querySelector(`button[data-hs-overlay="#hs-modal-format"]`);
      if (closeButton) {
        closeButton.click();
      }
    }, "closeModal");
    // applyFormat method kept for potential future use
    applyFormat = /* @__PURE__ */ __name((formatValue) => {
      const ic = this.props.Action.currentInstaCalcReact;
      if (ic?.state?.calc?.rows && ic.state.selected >= 0) {
        const currentRow = ic.state.calc.rows[ic.state.selected];
        let currentText = currentRow.text || "";
        const formatPatterns = [
          /\s+(as\s+\w+(\s+\w+)*)$/,
          // "as money", "as fraction over 16"
          /\s+(to\s+\w+)$/,
          // "to hex", "to bin"
          /\s+(->\s*\w+)$/
          // "-> round", "-> value"
        ];
        let hasExistingFormat = false;
        for (const pattern of formatPatterns) {
          if (pattern.test(currentText)) {
            currentText = currentText.replace(pattern, ` ${formatValue}`);
            hasExistingFormat = true;
            break;
          }
        }
        if (!hasExistingFormat) {
          currentText = `${currentText} ${formatValue}`;
        }
        ic.state.calc.rows[ic.state.selected].text = currentText.trim();
        ic.recalculate();
      } else {
        UIlog("[Row]", this.props.index, "expanded view regular result path");
        this.props.Action.applyRowFormatStringToCurrentCalc(formatValue);
      }
      this.closeModal();
    }, "applyFormat");
    componentDidMount() {
      this.recalculateAllFormats();
    }
    handleInputChange = /* @__PURE__ */ __name((categoryId, exampleIndex, value) => {
      const inputKey = `${categoryId}-${exampleIndex}`;
      this.setState({
        inputValues: {
          ...this.state.inputValues,
          [inputKey]: value
        }
      });
    }, "handleInputChange");
    hasModifiedExamples = /* @__PURE__ */ __name(() => {
      for (const [inputKey, inputValue] of Object.entries(this.state.inputValues)) {
        const [categoryId, exampleIndex] = inputKey.split("-");
        const category = this.formatConfig.categories.find((cat) => cat.id === categoryId);
        if (category && category.examples[parseInt(exampleIndex)]) {
          const defaultValue = category.examples[parseInt(exampleIndex)].display;
          if (inputValue !== defaultValue) {
            return true;
          }
        }
      }
      return false;
    }, "hasModifiedExamples");
    resetToDefaults = /* @__PURE__ */ __name(() => {
      this.setState({ inputValues: {} });
    }, "resetToDefaults");
    renderFormatExample = /* @__PURE__ */ __name((example, index, categoryId) => {
      const inputKey = `${categoryId}-${index}`;
      const inputValue = this.state.inputValues[inputKey] || example.display;
      const calculatedValue = this.getCalculatedValue(inputValue) || example.fallback;
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          key: index,
          className: "flex items-center justify-between w-full px-3 py-2 font-mono text-xs rounded bg-default"
        },
        /* @__PURE__ */ React.createElement(
          "input",
          {
            type: "text",
            value: inputValue,
            onChange: (e) => this.handleInputChange(categoryId, index, e.target.value),
            className: "flex-1 mr-3 font-mono text-xs bg-transparent border-none outline-none text-color-default focus:outline-none",
            placeholder: example.display
          }
        ),
        /* @__PURE__ */ React.createElement("span", { className: "text-color-muted whitespace-nowrap" }, calculatedValue)
      );
    }, "renderFormatExample");
    renderCategory = /* @__PURE__ */ __name((category, index) => {
      const isLastCategory = index === this.formatConfig.categories.length - 1;
      const marginClass = isLastCategory ? "mb-4" : "mb-6";
      return /* @__PURE__ */ React.createElement("div", { key: category.id, className: marginClass }, /* @__PURE__ */ React.createElement("h4", { className: "mb-3 text-sm font-medium text-color-default" }, category.title), /* @__PURE__ */ React.createElement("div", { className: "space-y-1" }, category.examples.map((example, index2) => this.renderFormatExample(example, index2, category.id))));
    }, "renderCategory");
    render() {
      const { helpText, helpExample, categories } = this.formatConfig;
      let formatModal = /* @__PURE__ */ React.createElement(ICModal, { id: "hs-modal-format", title: "Row Format Reference", closeIcon: true }, /* @__PURE__ */ React.createElement("div", { className: "px-3 pt-2 pb-2 w-full max-w-4xl sm:px-6 lg:min-w-[48rem]" }, /* @__PURE__ */ React.createElement("div", { className: "mb-4" }, /* @__PURE__ */ React.createElement("p", { className: "mb-2 text-sm text-center text-color-default" }, helpText, " ", /* @__PURE__ */ React.createElement("span", { className: "px-1 font-mono rounded bg-secondary" }, helpExample))), /* @__PURE__ */ React.createElement("div", { className: "grid grid-cols-1 gap-6 lg:grid-cols-2" }, categories.map(this.renderCategory)), /* @__PURE__ */ React.createElement("div", { className: "flex justify-end mt-2 h-7" }, this.hasModifiedExamples() && /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: this.resetToDefaults,
          className: "inline-flex items-center gap-1 px-2 py-1 text-xs transition-all rounded opacity-60 hover:opacity-100 text-color-muted hover:text-color-default hover:bg-secondary",
          title: "Reset all examples to defaults"
        },
        /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "w-3 h-3" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" })),
        "Reset examples"
      ), !this.hasModifiedExamples() && /* @__PURE__ */ React.createElement("div", { className: "inline-flex items-center gap-1 px-2 py-1 text-xs transition-all rounded opacity-40 text-color-muted" }, "Type to edit examples above"))));
      LIB.tryToRender(formatModal, "FormatModal");
      return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "inline-flex items-center justify-center gap-2 px-2 py-1 text-xs capitalize align-middle transition-all rounded tooltip text-color-default hover-text-color-active hover-bg-button focus:outline-none",
          "data-tip": "See row formatting options",
          onMouseEnter: this.handleHover,
          "data-hs-overlay": "#hs-modal-format"
        },
        this.props.customDisplayContent || "Format"
      ));
    }
  };
  var ToolbarButton = class _ToolbarButton {
    static {
      __name(this, "ToolbarButton");
    }
    // Common button styling
    static buttonClass = "inline-flex items-center justify-center px-2 py-1 text-xs align-middle transition-all rounded text-color-default hover-text-color-active hover-bg-button focus:outline-none min-w-[36px]";
    static borderedButtonClass = "inline-flex items-center justify-center px-3 py-1.5 text-xs font-medium align-middle transition-all rounded-md shadow-sm bg-secondary text-color-default hover-text-color-active hover-bg-button focus:outline-none min-w-[40px] border border-soft";
    static dropdownButtonClass = "inline-flex items-center justify-center px-2 py-1 text-xs align-middle transition-all rounded text-color-default hover-text-color-active hs-dropdown-toggle hover-bg-button focus:outline-none min-w-[36px]";
    static dropdownMenuClass = "hs-dropdown-menu z-[60] transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden bg-secondary shadow-md rounded-lg p-2 mt-2 after:h-4 after:absolute after:-bottom-4 after:left-0 after:w-full before:h-4 before:absolute before:-top-4 before:left-0 before:w-full";
    static dropdownItemClass = "flex text-sm items-center gap-x-3.5 py-2 hover-bg-button rounded px-3";
    // Helper to create consistent SVG action buttons
    static createSvgButton(width, text, ariaTitle, onClick, dataTip, showBorder = true) {
      const rectWidth = width - 6;
      const centerX = width / 2;
      return /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "inline-flex items-center justify-center text-xs transition-all rounded tooltip group text-color-default hover-text-color-active hover-bg-button focus:outline-none",
          "data-tip": dataTip,
          onClick
        },
        /* @__PURE__ */ React.createElement("svg", { width, height: "24", viewBox: `0 0 ${width} 24`, role: "img", "aria-labelledby": `${text.toLowerCase().replace(/\s+/g, "-")}-title`, xmlns: "http://www.w3.org/2000/svg", fill: "none", className: "text-color-default group-hover:text-color-active" }, /* @__PURE__ */ React.createElement("title", { id: `${text.toLowerCase().replace(/\s+/g, "-")}-title` }, ariaTitle), showBorder && /* @__PURE__ */ React.createElement("rect", { x: "3", y: "4", width: rectWidth, height: "16", rx: "4", stroke: "currentColor", strokeWidth: "1.2", fill: "transparent" }), /* @__PURE__ */ React.createElement(
          "text",
          {
            x: centerX,
            y: "14.5",
            textAnchor: "middle",
            fontSize: "9",
            fontWeight: "600",
            fontFamily: "ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
            fill: "currentColor"
          },
          text
        ))
      );
    }
    static createButton(onClick, dataTip, displayContent, additionalProps = {}) {
      const result = /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick,
          "data-tip": dataTip,
          className: `${_ToolbarButton.buttonClass} tooltip`,
          ...additionalProps
        },
        displayContent
      );
      return result;
    }
    static createDropdown(dataTip, displayContent, menuContent, menuWidth = "min-w-[10rem]") {
      const buttonClass = `${_ToolbarButton.dropdownButtonClass}${dataTip ? " tooltip" : ""}`;
      return /* @__PURE__ */ React.createElement("div", { className: "relative inline-flex hs-dropdown [--trigger:hover]" }, /* @__PURE__ */ React.createElement("button", { type: "button", "data-tip": dataTip, className: buttonClass }, displayContent), /* @__PURE__ */ React.createElement("div", { className: `${_ToolbarButton.dropdownMenuClass} ${menuWidth}` }, menuContent));
    }
    static createGoalseek(context, displayContent) {
      const result = _ToolbarButton.createButton(
        context.clickGoalseekButton.bind(context),
        "Find variables that reach a desired goal",
        displayContent,
        { "data-hs-overlay": "#hs-modal-goalseek" }
      );
      return result;
    }
    static createLocale(context, displayContent) {
      const locale = context.props.calc.locale || "en-US";
      const menuContent = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "text-xs font-medium text-center capitalize opacity-50 text-color-default" }, "Number format"), /* @__PURE__ */ React.createElement(
        "a",
        {
          href: "javascript:void(0)",
          className: (locale == "en-US" ? "active " : "") + _ToolbarButton.dropdownItemClass,
          onClick: () => context.props.Action.setLocale(context.props.calc, "en-US")
        },
        "123,456.78 (US)"
      ), /* @__PURE__ */ React.createElement(
        "a",
        {
          href: "javascript:void(0)",
          className: (locale == "de-DE" ? "active " : "") + _ToolbarButton.dropdownItemClass,
          onClick: () => context.props.Action.setLocale(context.props.calc, "de-DE")
        },
        "123.456,78 (Europe)"
      ), /* @__PURE__ */ React.createElement(
        "a",
        {
          href: "javascript:void(0)",
          className: (locale == "hi-IN" ? "active " : "") + _ToolbarButton.dropdownItemClass,
          onClick: () => context.props.Action.setLocale(context.props.calc, "hi-IN")
        },
        "1,23,456.78 (South Asia)"
      ));
      const result = _ToolbarButton.createDropdown(null, displayContent, menuContent);
      return result;
    }
    static createRounding(context, displayContent) {
      const rounding_enabled = context.props.calc.rounding === 0 || context.props.calc.rounding > 0;
      const menuContent = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "text-xs font-medium text-center capitalize opacity-50 text-color-default" }, "Decimals to show"), /* @__PURE__ */ React.createElement(
        "a",
        {
          href: "javascript:void(0)",
          className: (rounding_enabled == false ? "active " : "") + _ToolbarButton.dropdownItemClass,
          onClick: () => context.props.Action.setRounding(context.props.calc, -1)
        },
        "All"
      ), /* @__PURE__ */ React.createElement(
        "a",
        {
          href: "javascript:void(0)",
          className: (context.props.calc.rounding === 2 ? "active " : "") + _ToolbarButton.dropdownItemClass,
          onClick: () => context.props.Action.setRounding(context.props.calc, 2)
        },
        "0.01"
      ), /* @__PURE__ */ React.createElement(
        "a",
        {
          href: "javascript:void(0)",
          className: (context.props.calc.rounding === 1 ? "active " : "") + _ToolbarButton.dropdownItemClass,
          onClick: () => context.props.Action.setRounding(context.props.calc, 1)
        },
        "0.1"
      ), /* @__PURE__ */ React.createElement(
        "a",
        {
          href: "javascript:void(0)",
          className: (context.props.calc.rounding === 0 ? "active " : "") + _ToolbarButton.dropdownItemClass,
          onClick: () => context.props.Action.setRounding(context.props.calc, 0)
        },
        "1"
      ));
      const result = _ToolbarButton.createDropdown(null, displayContent, menuContent, "min-w-[15rem]");
      return result;
    }
    static createFormat(context, displayContent) {
      const result = /* @__PURE__ */ React.createElement(FormatDropdown, { Action: context.props.Action, customDisplayContent: displayContent });
      return result;
    }
    static createPresent(context, displayContent) {
      const show_display_mode = context.props.Action.shouldHideRows(context.props.calc);
      const result = _ToolbarButton.createButton(
        () => context.props.Action.presentCalc(context.props.calc),
        `Enter ${show_display_mode ? "display mode" : "calc mode"} (${show_display_mode ? "collapse" : "expand"} all rows)`,
        displayContent
      );
      return result;
    }
    static createClear(context, displayContent) {
      const result = _ToolbarButton.createButton(
        () => context.props.Action.clear(context.props.calc),
        "Clear all rows",
        displayContent
      );
      return result;
    }
    static createEmbed(context, displayContent) {
      const result = _ToolbarButton.createButton(
        context.clickEmbedButton,
        "Get HTML embed (for website)",
        displayContent,
        { "data-hs-overlay": "#hs-modal-copyembed" }
      );
      return result;
    }
  };
  var App = class extends React.Component {
    static {
      __name(this, "App");
    }
    constructor(props) {
      super(props);
      this.state = {
        selected: this.props.Action.getLocalOption("selected") || null,
        view: "calc",
        currenciesLoaded: false,
        rerenderKey: 0
        // increment to force re-render
      };
      this.props.Action.loadCurrencies(() => {
        this.setState({ currenciesLoaded: true });
        this.forceUpdate();
      });
      Calc.sub(() => this.forceUpdate());
      this.componentDidUpdate();
      this.externalForceRender = this.externalForceRender.bind(this);
      this.debounceRefreshUI = debounce(this.debounceRefreshUI, 1e3).bind(this);
      this.componentDidUpdate = this.componentDidUpdate.bind(this);
    }
    setStateExt = /* @__PURE__ */ __name((state) => {
      this.setState(state);
    }, "setStateExt");
    debounceRefreshUI = /* @__PURE__ */ __name(() => {
      this.props.Action.refreshUI();
    }, "debounceRefreshUI");
    externalForceRender() {
      console.log("forcing re-render");
      this.setState({ rerenderKey: this.state.rerenderKey + 1 });
    }
    onSelect(id) {
      this.setState({ selected: id, view: "calc" });
      this.props.Action.setLocalOption("selected", id);
    }
    getCalcInfo(selected_id) {
      var calcs = Calc.allByNewest();
      var calc = calcs.filter((c) => c.id == selected_id)[0];
      if (!calc) {
        calc = calcs[0];
      }
      return {
        calcs,
        calc,
        selected_id: calc.id
      };
    }
    componentDidMount() {
      var selected_id = this.state.selected || this.getCalcInfo().selected_id;
      this.setState({ selected: selected_id });
    }
    componentDidUpdate() {
      LIB.tryToRender(/* @__PURE__ */ React.createElement(ThemeOptionsPanel, { Action: this.props.Action, setOption: this.props.Action.setLocalOption, getOption: this.props.Action.getLocalOption, view: this.state.view }), "ThemeOptionsPanel");
      LIB.tryToRender(/* @__PURE__ */ React.createElement(ThemeOptionsPanel, { Action: this.props.Action, setOption: this.props.Action.setLocalOption, getOption: this.props.Action.getLocalOption, view: this.state.view }), "MobileThemeOptionsPanel");
      if (this.props.layout == "home") {
        var { calcs, calc, selected_id } = this.getCalcInfo(this.state.selected);
        let reactCalc = /* @__PURE__ */ React.createElement(
          InstaCalcReact,
          {
            key: this.state.rerenderKey,
            Action: this.props.Action,
            calc,
            view: this.state.view,
            currenciesLoaded: this.state.currenciesLoaded,
            ref: (component) => this.props.Action.currentInstaCalcReact = component
          }
        );
        this.props.Action.setCurrentCalc(calc);
        LIB.tryToRender(reactCalc, "CalcHolder");
        LIB.tryToRender(/* @__PURE__ */ React.createElement(CalcList, { key: this.state.rerenderKey, Action: this.props.Action, calcs, selected: selected_id, onSelect: this.onSelect.bind(this) }), "CalcList");
        LIB.tryToRender(/* @__PURE__ */ React.createElement(
          CalcList,
          {
            key: this.state.rerenderKey,
            Action: this.props.Action,
            calcs,
            selected: selected_id,
            onSelect: (calc2) => {
              this.onSelect.bind(this)(calc2);
              document.body._x_dataStack[0].mobiletab = null;
            }
          }
        ), "MobileCalcList");
        LIB.tryToRender(/* @__PURE__ */ React.createElement(CalcMeta, { key: this.state.rerenderKey, Action: this.props.Action, calc, selected: selected_id, view: this.state.view }), "CalcMetaHolder");
        LIB.tryToRender(/* @__PURE__ */ React.createElement(CalcMeta, { key: this.state.rerenderKey, Action: this.props.Action, calc, selected: selected_id, isMobile: "mobile", view: this.state.view }), "MobileCalcMeta");
        LIB.tryToRender(/* @__PURE__ */ React.createElement(CalcInfo, { key: this.state.rerenderKey, Action: this.props.Action, calc, selected: selected_id, view: this.state.view }), "CalcInfo");
      }
      LIB.tryToRender(/* @__PURE__ */ React.createElement(ShareButton, { key: this.state.rerenderKey, Action: this.props.Action, view: this.state.view }), "ShareButton");
      LIB.tryToRender(/* @__PURE__ */ React.createElement(NewCalcButton, { key: this.state.rerenderKey, Action: this.props.Action, view: this.state.view }), "NewCalcButton");
      LIB.tryToRender(/* @__PURE__ */ React.createElement(UserInfo, { key: this.state.rerenderKey, Action: this.props.Action, view: this.state.view }), "UserInfo");
      this.debounceRefreshUI();
    }
    renderCalc() {
      let el = document.querySelector("CalcHolder");
      el.style.height = el.offsetHeight + "px";
      ReactDOM.unmountComponentAtNode(document.querySelector("CalcHolder"));
      var { calcs, calc, selected_id } = this.getCalcInfo(this.state.selected);
      let reactCalc = /* @__PURE__ */ React.createElement(
        InstaCalcReact,
        {
          Action: this.props.Action,
          calc,
          view: this.state.view,
          currenciesLoaded: this.state.currenciesLoaded,
          ref: (component) => this.props.Action.currentInstaCalcReact = component
        }
      );
      LIB.tryToRender(reactCalc, "CalcHolder");
      setTimeout(() => {
        el.style.removeProperty("height");
      }, 500);
    }
    render() {
      return /* @__PURE__ */ React.createElement("div", { className: "render-from-app" });
    }
  };
  App.propTypes = {
    Action: React.PropTypes.any.isRequired
  };
  var Shared = class extends React.Component {
    static {
      __name(this, "Shared");
    }
    constructor(props) {
      super(props);
      this.state = {
        calc: null,
        view: this.props.view,
        titleSet: false,
        guid: Action.Util.guid()
      };
      this.handleCalcUpdate = this.handleCalcUpdate.bind(this);
    }
    // be careful: we have the older handler lying around still.
    handleCalcUpdate(calc) {
      if (calc.id !== this.state.guid) {
        return;
      }
      this.setState({ calc });
      if (this.props.setTitle && !this.state.titleSet) {
        document.title = calc.name + " | InstaCalc Online Calculator";
        this.setState({ titleSet: true });
      }
    }
    loadEmbed(embed_id) {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
      this.unsubscribe = this.props.Action.loadEmbed(embed_id, this.handleCalcUpdate, this.state.guid);
    }
    componentWillReceiveProps(nextProps) {
      if (this.props.embed_id !== nextProps.embed_id) {
        this.setState({ calc: null, titleSet: false, copyId: null });
        this.loadEmbed(nextProps.embed_id, null, this.state.guid);
      }
    }
    componentDidMount() {
      this.loadEmbed(this.props.embed_id);
      this.props.Action.loadCurrencies(() => this.forceUpdate());
    }
    componentWillUnmount() {
      if (this.unsubscribe) {
        this.unsubscribe();
      }
    }
    render() {
      if (!this.state.calc) {
        return /* @__PURE__ */ React.createElement("div", { className: "progress" }, /* @__PURE__ */ React.createElement("div", { className: "indeterminate" }));
      }
      var url = this.props.Action.getPublicURL(this.state.calc);
      let footer = null;
      if (this.props.view == "embed") {
        footer = /* @__PURE__ */ React.createElement("div", { className: "flex items-center justify-between embed-footer" }, /* @__PURE__ */ React.createElement("div", { "data-role": "spacer" }), /* @__PURE__ */ React.createElement("a", { href: url, target: "_blank", className: "poweredby" }, /* @__PURE__ */ React.createElement("img", { src: "/img/icons/svg/instacalc.logo.svg", alt: "Instacalc", className: "inline-block w-4 h-4", style: { background: "var(--calc-bg-color);" } }), /* @__PURE__ */ React.createElement("span", { className: "hidden tagline" }, "powered by"), /* @__PURE__ */ React.createElement("span", { className: "ml-2 instacalc-title" }, "instacalc")), /* @__PURE__ */ React.createElement("a", { href: url, className: "inline-block ml-1", title: `Open ${url} in a new tab`, target: "_blank" }, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-4 h-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25" }))));
      }
      ;
      return /* @__PURE__ */ React.createElement("sharedcalc", { className: " " + this.props.view, "data-guid": this.state.guid }, /* @__PURE__ */ React.createElement("div", { className: this.props.view == "embed" ? "notooltip" : "" }, /* @__PURE__ */ React.createElement(
        InstaCalcReact,
        {
          Action: this.props.Action,
          calc: this.state.calc,
          view: this.state.view,
          footer,
          ref: (component) => this.props.view == "public" ? this.props.Action.currentInstaCalcReact = component : ""
        }
      )), this.props.view == "public" && /* @__PURE__ */ React.createElement("div", { "data-role": "calcmetaholder", className: "block" }, /* @__PURE__ */ React.createElement(CalcMeta, { Action: this.props.Action, calc: this.state.calc, view: this.props.view, layout: "single", isMobile: this.props.isMobile })));
    }
  };
  Shared.propTypes = {
    embed_id: React.PropTypes.any.isRequired
  };
  var CalcList = class extends React.Component {
    static {
      __name(this, "CalcList");
    }
    constructor(props) {
      super(props);
      this.state = {
        sortby: "-updated",
        newFolderName: "",
        folders: this.getFolders(this.props.calcs),
        draggedItem: null,
        draggedIntoFolder: null,
        showAddFolderInput: false,
        editingFolder: null,
        // or, set to name of folder we are editing
        editingFolderNewName: null,
        searchQuery: "",
        showSearch: false
      };
      this.folderInput = null;
      this.toggleFolder = this.toggleFolder.bind(this);
    }
    sort = /* @__PURE__ */ __name((calcs) => {
      function naturalCompare(a, b) {
        const ax = [], bx = [];
        a.replace(/(\d+)|(\D+)/g, function(_, $1, $2) {
          ax.push([$1 || Infinity, $2 || ""]);
        });
        b.replace(/(\d+)|(\D+)/g, function(_, $1, $2) {
          bx.push([$1 || Infinity, $2 || ""]);
        });
        while (ax.length && bx.length) {
          const an = ax.shift();
          const bn = bx.shift();
          const nn = an[0] - bn[0] || an[1].localeCompare(bn[1]);
          if (nn) return nn;
        }
        return ax.length - bx.length;
      }
      __name(naturalCompare, "naturalCompare");
      function dynamicSort(property) {
        let sortOrder = 1;
        if (property[0] === "-") {
          sortOrder = -1;
          property = property.substr(1);
        }
        return function(a, b) {
          if (isNaN(a[property]) || isNaN(b[property])) {
            return sortOrder * naturalCompare(a[property], b[property]);
          } else {
            UIlog("[Row]", this.props.index, "expanded view regular result path");
            UIlog("[Row]", this.props.index, "rendering default result in collapsed output");
            return sortOrder * (a[property] - b[property]);
          }
        };
      }
      __name(dynamicSort, "dynamicSort");
      return calcs.sort(dynamicSort(this.state.sortby));
    }, "sort");
    handleNewFolderNameChange = /* @__PURE__ */ __name((e) => {
      this.setState({ newFolderName: e.target.value });
    }, "handleNewFolderNameChange");
    getFolders = /* @__PURE__ */ __name((calcs) => {
      const storedFolders = this.props.Action.getLocalOption("folders") || [];
      const foldersMap = /* @__PURE__ */ new Map();
      storedFolders.forEach((folder) => {
        foldersMap.set(folder.name, folder.open);
      });
      calcs.forEach((calc) => {
        if (calc.folder && !foldersMap.has(calc.folder)) {
          foldersMap.set(calc.folder, false);
        }
      });
      const foldersArray = Array.from(foldersMap, ([name, open]) => ({ name, open }));
      return foldersArray.sort((a, b) => a.name.localeCompare(b.name));
    }, "getFolders");
    toggleAddFolderInput = /* @__PURE__ */ __name(() => {
      this.setState(
        (prevState) => ({ showAddFolderInput: !prevState.showAddFolderInput }),
        () => {
          if (this.state.showAddFolderInput && this.folderInput) {
            this.folderInput.focus();
          }
        }
      );
    }, "toggleAddFolderInput");
    addNewFolder = /* @__PURE__ */ __name((e) => {
      e.preventDefault();
      const { newFolderName, folders } = this.state;
      if (newFolderName.trim() === "") {
        alert("Please provide a folder name!");
        return;
      }
      const newFolder = {
        name: newFolderName,
        isOpen: true
        // Newly added folders default to open
      };
      const updatedFolders = [...folders, newFolder];
      this.setState({
        folders: updatedFolders,
        newFolderName: "",
        showAddFolderInput: false
      });
      this.props.Action.setLocalOption("folders", updatedFolders);
    }, "addNewFolder");
    onDragStart = /* @__PURE__ */ __name((e, item) => {
      this.setState({ draggedItem: item });
      e.dataTransfer.effectAllowed = "move";
    }, "onDragStart");
    onDragOver = /* @__PURE__ */ __name((e, folderName) => {
      e.preventDefault();
      this.setState({ draggedIntoFolder: folderName });
    }, "onDragOver");
    onDrop = /* @__PURE__ */ __name((e, folder) => {
      e.preventDefault();
      const { draggedItem } = this.state;
      if (draggedItem) {
        this.setState({
          draggedItem: null,
          draggedIntoFolder: null
        });
        this.changeCalcFolder(draggedItem, folder);
      }
    }, "onDrop");
    toggleFolder = /* @__PURE__ */ __name((folderName) => {
      const updatedFolders = this.state.folders.map((folder) => {
        if (folder.name === folderName) {
          const detailsElement = document.querySelector(`details[data-folder-name="${folderName}"]`);
          if (detailsElement) {
            if (!folder.open) {
              detailsElement.setAttribute("open", "");
            } else {
              UIlog("[Row]", this.props.index, "expanded view regular result path");
              UIlog("[Row]", this.props.index, "rendering default result in collapsed output");
              detailsElement.removeAttribute("open");
            }
          }
          return { ...folder, open: !folder.open };
        }
        return folder;
      });
      this.setState({ folders: updatedFolders });
      this.props.Action.setLocalOption("folders", updatedFolders);
    }, "toggleFolder");
    changeCalcFolder = /* @__PURE__ */ __name((calc, folder) => {
      this.props.Action.updateFolder(calc, folder);
    }, "changeCalcFolder");
    renameCalcsInFolder = /* @__PURE__ */ __name((oldName, newName) => {
      this.props.calcs.forEach((calc) => {
        if (calc.folder === oldName) {
          this.changeCalcFolder(calc, newName);
        }
      });
    }, "renameCalcsInFolder");
    startEditingFolder = /* @__PURE__ */ __name((folderName) => {
      this.setState({ editingFolder: folderName, editingFolderNewName: folderName });
    }, "startEditingFolder");
    stopEditingFolder = /* @__PURE__ */ __name(() => {
      this.setState({ editingFolder: null, editingFolderNewName: null });
    }, "stopEditingFolder");
    handleFolderEditComplete = /* @__PURE__ */ __name(() => {
      const newName = this.state.editingFolderNewName;
      if (newName.trim() === "") {
        this.stopEditingFolder();
        return;
      }
      const updatedFolders = this.state.folders.map((folder) => {
        if (folder.name === this.state.editingFolder) {
          return { ...folder, name: newName };
        }
        return folder;
      });
      this.setState({ folders: updatedFolders });
      this.props.Action.setLocalOption("folders", updatedFolders);
      this.renameCalcsInFolder(this.state.editingFolder, newName);
      this.stopEditingFolder();
    }, "handleFolderEditComplete");
    deleteFolder = /* @__PURE__ */ __name((folder) => {
      if (this.props.calcs.filter((calc) => calc.folder === folder.name).length === 0) {
        const updatedFolders = this.state.folders.filter((f) => f.name !== folder.name);
        this.setState({ folders: updatedFolders });
        this.props.Action.setLocalOption("folders", updatedFolders);
      }
    }, "deleteFolder");
    createCalcInFolder = /* @__PURE__ */ __name((folder) => {
      let calc = this.props.Action.create();
      this.props.Action.updateFolder(calc, folder);
    }, "createCalcInFolder");
    render() {
      const { folders, newFolderName, sortby, showAddFolderInput } = this.state;
      const sorted_calcs = this.sort(this.props.calcs);
      const filtered_calcs = this.state.showSearch && this.state.searchQuery.trim() ? sorted_calcs.filter(
        (calc) => calc.name.toLowerCase().includes(this.state.searchQuery.trim().toLowerCase())
      ) : sorted_calcs;
      const SEARCH_BUTTON = /* @__PURE__ */ React.createElement("div", { className: "flex justify-between items-center font-light capitalize text-[12px] text-color-default" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "inline-flex cursor-pointer tooltip tooltip-right",
          "data-tip": "Search your calcs",
          onClick: () => this.setState((prevState) => ({ showSearch: !prevState.showSearch }))
        },
        /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-5 h-5" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z" }))
      ), this.state.showSearch && /* @__PURE__ */ React.createElement("div", { className: "ml-2" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "search",
          placeholder: "Search calcs...",
          value: this.state.searchQuery,
          onChange: (e) => this.setState({ searchQuery: e.target.value }),
          className: "w-full px-1 py-0.5 text-color-default text-sm rounded-md outline-none focus:ring-1 ring-sky-300"
        }
      )));
      const SORT_BUTTON = /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "inline-flex text-right cursor-pointer tooltip tooltip-left",
          "data-tip": "Sort by date/name",
          onClick: () => {
            this.setState({ sortby: this.state.sortby === "name" ? "-updated" : "name" });
          }
        },
        /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "size-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3" })),
        this.state.sortby === "name" ? "name" : "date"
      );
      const FOLDER_BUTTON = /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "inline-flex cursor-pointer tooltip tooltip-right",
          onClick: this.toggleAddFolderInput,
          "data-tip": "Add folder",
          "aria-label": "Add folder"
        },
        /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-5 h-5" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M12 10.5v6m3-3H9m4.06-7.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z" })),
        /* @__PURE__ */ React.createElement("span", { className: "pl-1 mt-0.5 font-light capitalize hidden" }, "Folder")
      );
      const CALCLIST_DROPDOWN = /* @__PURE__ */ React.createElement(CalcListDropdown, { Action: this.props.Action });
      const LOGIN_MESSAGE_UI = /* @__PURE__ */ React.createElement("div", { className: "if-logged-out flex items-center text-[12px] text-color-default" }, /* @__PURE__ */ React.createElement("a", { href: "javascript:Action.login()", className: "inline-flex items-center gap-1 transition-opacity hover:opacity-100 tooltip tooltip-bottom", "data-tip": "Login to backup/sync" }, "login to sync", /* @__PURE__ */ React.createElement("span", { className: "inline-flex items-center gap-0.5 opacity-50" }, /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", className: "w-3 h-3", fill: "currentColor" }, /* @__PURE__ */ React.createElement("path", { d: "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" }), /* @__PURE__ */ React.createElement("path", { d: "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" }), /* @__PURE__ */ React.createElement("path", { d: "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" }), /* @__PURE__ */ React.createElement("path", { d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" })), /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", className: "w-4 h-4", style: { transform: "translateY(-1px)" }, fill: "currentColor" }, /* @__PURE__ */ React.createElement("path", { d: "M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" })))));
      const LIST_HEADER_UI = /* @__PURE__ */ React.createElement("div", { className: "flex justify-between items-center my-1 font-light capitalize text-[12px] text-color-default opacity-50 hover:opacity-100", style: { height: "24px" } }, /* @__PURE__ */ React.createElement("div", { className: "inline-flex space-x-2" }, SEARCH_BUTTON, !this.state.showSearch && FOLDER_BUTTON), LOGIN_MESSAGE_UI, /* @__PURE__ */ React.createElement("div", { className: "inline-flex space-x-2" }, SORT_BUTTON, CALCLIST_DROPDOWN));
      const ADD_FOLDER_UI = showAddFolderInput ? /* @__PURE__ */ React.createElement("form", { onSubmit: this.addNewFolder, className: "flex items-center mt-4 ml-1 text-sm" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          ref: (input) => {
            this.folderInput = input;
            if (input) {
              input.addEventListener("keydown", (e) => {
                if (e.key === "Escape") {
                  this.toggleAddFolderInput();
                }
              });
            }
          },
          type: "text",
          value: newFolderName,
          onChange: this.handleNewFolderNameChange,
          placeholder: "Enter folder name",
          className: "flex-grow p-1 mr-2 border rounded outline-none border-color-soft"
        }
      ), /* @__PURE__ */ React.createElement("button", { type: "submit", className: "px-2 py-1 border rounded-md shadow-sm border-color-soft text-color-default" }, "Add Folder"), /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "inline-flex items-center justify-center flex-shrink-0 w-8 h-8 text-sm text-gray-500 transition-all rounded-md hs-dropdown-toggle hover:text-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-gray-700 dark:focus:ring-offset-gray-800",
          onClick: this.toggleAddFolderInput,
          title: "Cancel adding folder",
          "aria-label": "Cancel adding folder"
        },
        /* @__PURE__ */ React.createElement("svg", { className: "w-3.5 h-3.5", width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React.createElement("path", { d: "M0.258206 1.00652C0.351976 0.912791 0.479126 0.860131 0.611706 0.860131C0.744296 0.860131 0.871447 0.912791 0.965207 1.00652L3.61171 3.65302L6.25822 1.00652C6.30432 0.958771 6.35952 0.920671 6.42052 0.894471C6.48152 0.868271 6.54712 0.854471 6.61352 0.853901C6.67992 0.853321 6.74572 0.865971 6.80722 0.891111C6.86862 0.916251 6.92442 0.953381 6.97142 1.00032C7.01832 1.04727 7.05552 1.1031 7.08062 1.16454C7.10572 1.22599 7.11842 1.29183 7.11782 1.35822C7.11722 1.42461 7.10342 1.49022 7.07722 1.55122C7.05102 1.61222 7.01292 1.6674 6.96522 1.71352L4.31871 4.36002L6.96522 7.00648C7.05632 7.10078 7.10672 7.22708 7.10552 7.35818C7.10442 7.48928 7.05182 7.61468 6.95912 7.70738C6.86642 7.80018 6.74102 7.85268 6.60992 7.85388C6.47882 7.85498 6.35252 7.80458 6.25822 7.71348L3.61171 5.06702L0.965207 7.71348C0.870907 7.80458 0.744606 7.85498 0.613506 7.85388C0.482406 7.85268 0.357007 7.80018 0.264297 7.70738C0.171597 7.61468 0.119017 7.48928 0.117877 7.35818C0.116737 7.22708 0.167126 7.10078 0.258206 7.00648L2.90471 4.36002L0.258206 1.71352C0.164476 1.61976 0.111816 1.4926 0.111816 1.36002C0.111816 1.22744 0.164476 1.10028 0.258206 1.00652Z", fill: "currentColor" }))
      )) : null;
      const buildCalcDropdown = /* @__PURE__ */ __name((calc, props) => {
        return /* @__PURE__ */ React.createElement(CalcDropdown, { key: "calc-dropdown-" + calc.id, calc, Action: this.props.Action, folders: this.state.folders });
      }, "buildCalcDropdown");
      const sortedFolders = folders.sort((a, b) => a.name.localeCompare(b.name));
      return /* @__PURE__ */ React.createElement("div", { className: "mx-1 overflow-y-auto no-scrollbar" }, LIST_HEADER_UI, ADD_FOLDER_UI, sortedFolders.map(
        (folder) => {
          const calcsInFolder = filtered_calcs.filter((calc) => calc.folder === folder.name);
          const isEmptyFolder = calcsInFolder.length === 0;
          const isDraggedOver = this.state.draggedIntoFolder === folder.name;
          const dragTargetStyles = isDraggedOver ? "placeholder rounded-md" : "";
          const editingThisFolder = this.state.editingFolder === folder.name;
          const folderEditInterface = /* @__PURE__ */ React.createElement("form", { onSubmit: (e) => {
            e.preventDefault();
            this.handleFolderEditComplete();
          } }, /* @__PURE__ */ React.createElement(
            "input",
            {
              className: "w-full p-1 border rounded-lg outline-none border-color-soft",
              value: this.state.editingFolderNewName,
              onBlur: this.stopEditingFolder,
              onChange: (e) => this.setState({ editingFolderNewName: e.target.value }),
              maxLength: "50",
              placeholder: "Enter a title",
              autoFocus: true,
              type: "text",
              "aria-label": "Folder title",
              "data-hj-whitelist": true
            }
          ));
          return /* @__PURE__ */ React.createElement(
            "details",
            {
              key: folder.name,
              open: folder.open,
              onDragOver: (e) => this.onDragOver(e, folder.name),
              onDrop: (e) => this.onDrop(e, folder.name),
              "data-folder-name": folder.name,
              className: "my-2 mb-0 -ml-1 rounded-xl folder"
            },
            /* @__PURE__ */ React.createElement(
              "summary",
              {
                className: "relative flex items-center gap-2 list-none cursor-pointer select-none group",
                onClick: (e) => {
                  e.preventDefault();
                  if (!editingThisFolder) {
                    this.toggleFolder(folder.name);
                  }
                }
              },
              /* @__PURE__ */ React.createElement("div", { className: (folder.open ? "" : "-rotate-90") + " transform transition duration-150" }, /* @__PURE__ */ React.createElement("svg", { className: "", fill: "none", height: "20", width: "20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", viewBox: "0 0 24 24" }, /* @__PURE__ */ React.createElement("polyline", { points: "6 9 12 15 18 9" }))),
              editingThisFolder ? folderEditInterface : /* @__PURE__ */ React.createElement("div", { className: "inline-flex max-w-[75%]" }, folder.name),
              /* @__PURE__ */ React.createElement("div", { className: "absolute right-0 hidden group-hover:flex justify-middle" }, /* @__PURE__ */ React.createElement(
                FolderDropdown,
                {
                  onClick: (e) => e.preventDefault(),
                  folder,
                  isEmptyFolder,
                  onDelete: () => this.deleteFolder(folder),
                  onCreate: () => this.createCalcInFolder(folder.name),
                  onRename: () => this.startEditingFolder(folder.name)
                }
              ))
            ),
            /* @__PURE__ */ React.createElement("main", { className: `select-none` }, /* @__PURE__ */ React.createElement("ul", { className: (!isEmptyFolder ? "border-l border-color-soft" : "bg-secondary rounded-lg border-2 border-transparent	") + " pl-4 ml-6 calcs-list " + dragTargetStyles }, isEmptyFolder ? /* @__PURE__ */ React.createElement("li", { className: "flex p-4 -ml-2 text-sm text-center opacity-50 rounded-xl bg-secondary text-color-default" }, "Drag calc here") : "", calcsInFolder.map((calc) => {
              const active = this.props.selected == calc.id;
              const date = Util.displayDate(calc.updated || calc.created);
              return /* @__PURE__ */ React.createElement(
                "li",
                {
                  key: calc.id,
                  draggable: true,
                  onDragStart: (e) => this.onDragStart(e, calc),
                  className: (active ? "selected" : "") + " group calc-item rounded cursor-pointer flex items-center justify-between my-2 relative"
                },
                /* @__PURE__ */ React.createElement(
                  "a",
                  {
                    className: (active ? "text-color-active font-bold" : "text-color-default") + " w-full inline-flex whitespace-nowrap overflow-hidden calclist-item",
                    href: "javascript:void(0)",
                    onClick: (e) => {
                      this.props.onSelect(calc.id);
                    }
                  },
                  calc.name || "New Calc (" + Util.displayDate(calc.updated || calc.created) + ")",
                  calc.deleted ? " (deleted)" : ""
                ),
                !active && /* @__PURE__ */ React.createElement("date", { className: "inline-block mr-1 text-xs text-right whitespace-nowrap opacity-0 group-hover:opacity-75 transition-all duration-100 min-w-[60px]" }, date),
                /* @__PURE__ */ React.createElement("div", { className: `${active ? "flex" : "hidden"} mr-0 relative -right-[1px]` }, buildCalcDropdown(calc))
              );
            })))
          );
        }
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "mb-4 ml-1 select-none folder",
          onDragOver: (e) => {
            this.onDragOver(e, null);
          },
          onDrop: (e) => this.onDrop(e, null)
        },
        /* @__PURE__ */ React.createElement("ul", { className: "calcs-list " + (this.state.draggedItem && this.state.draggedIntoFolder == null ? "placeholder" : "border border-transparent") }, filtered_calcs.filter((calc) => !calc.folder).map((calc) => {
          const active = this.props.selected == calc.id;
          const date = Util.displayDate(calc.updated || calc.created);
          return /* @__PURE__ */ React.createElement(
            "li",
            {
              key: calc.id,
              draggable: true,
              onDragStart: (e) => this.onDragStart(e, calc),
              className: (active ? "selected" : "") + " calc-item group rounded cursor-pointer flex items-center justify-between my-2 relative px-2"
            },
            /* @__PURE__ */ React.createElement(
              "a",
              {
                className: (active ? "text-color-active font-bold" : "text-color-default") + " w-full inline-flex whitespace-nowrap overflow-hidden max-w-3/4 calclist-item",
                href: "javascript:void(0)",
                onClick: (e) => {
                  this.props.onSelect(calc.id);
                }
              },
              calc.name || "New Calc (" + Util.displayDate(calc.updated || calc.created) + ")",
              calc.deleted ? " (deleted)" : ""
            ),
            !active && /* @__PURE__ */ React.createElement("date", { className: "inline-block mr-1 text-xs text-right whitespace-nowrap opacity-0 group-hover:opacity-75 transition-all duration-100 min-w-[60px]" }, date),
            /* @__PURE__ */ React.createElement("div", { className: `${active ? "flex" : "hidden"} mr-0` }, buildCalcDropdown(calc))
          );
        }))
      ));
    }
  };
  var SharedCalcUI = class extends React.Component {
    static {
      __name(this, "SharedCalcUI");
    }
    constructor(props) {
      super(props);
      this.state = {
        open: 0
      };
    }
    render() {
      return /* @__PURE__ */ React.createElement("div", { className: "block w-full overflow-auto rounded-lg" }, /* @__PURE__ */ React.createElement(
        "details",
        {
          className: "my-2 mb-0 rounded-xl folder"
        },
        /* @__PURE__ */ React.createElement(
          "summary",
          {
            className: "relative flex items-center gap-2 -ml-1 list-none cursor-pointer select-none group",
            onClick: () => this.setState({ open: !this.state.open })
          },
          /* @__PURE__ */ React.createElement("div", { className: (this.state.open ? "" : "-rotate-90") + " transform transition duration-150" }, /* @__PURE__ */ React.createElement("svg", { className: "", fill: "none", height: "20", width: "20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", viewBox: "0 0 24 24" }, /* @__PURE__ */ React.createElement("polyline", { points: "6 9 12 15 18 9" }))),
          "Shared Library"
        ),
        /* @__PURE__ */ React.createElement("main", { className: `rounded-lg select-none bg-secondary` }, /* @__PURE__ */ React.createElement("div", { "data-load": "html/gallery1.html" }))
      ));
    }
  };
  var CalcDropdown = class extends React.Component {
    static {
      __name(this, "CalcDropdown");
    }
    updateDeleteModal = /* @__PURE__ */ __name((calc) => {
      let deleteModal = /* @__PURE__ */ React.createElement(ICModal, { id: "hs-modal-delete", title: `Delete ${calc.name}?`, close: "Keep", accept: "Delete", onAccept: (e) => {
        this.props.Action.delete(calc);
      } });
      LIB.tryToRender(deleteModal, "DeleteModal");
    }, "updateDeleteModal");
    render() {
      const { calc, folders } = this.props;
      return /* @__PURE__ */ React.createElement("div", { className: "inline-flex hs-dropdown [--auto-close:inside]" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          id: `hs-dropdown-calc-${calc.id}`,
          "aria-label": "Calc actions",
          type: "button",
          className: "relative flex items-center justify-center gap-1 text-xs capitalize align-middle transition-all border-transparent rounded-md tooltip tooltip-left text-color-default hover-text-color-active hs-dropdown-toggle focus:outline-none",
          "data-tip": "Calc actions"
        },
        /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "w-5 h-5" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12a9 9 0 11-18 0 9 9 0 0118 0z" }))
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "hs-dropdown-menu z-[60] transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden min-w-[10rem] bg-secondary shadow-md rounded-lg p-2 mt-2 dark:bg-gray-800 dark:border dark:border-gray-700 dark:divide-gray-700 after:h-4 after:absolute after:-bottom-4 after:left-0 after:w-full before:h-4 before:absolute before:-top-4 before:left-0 before:w-full",
          "aria-labelledby": `hs-dropdown-calc-${calc.id}`
        },
        /* @__PURE__ */ React.createElement("div", { className: "relative inline-flex items-center gap-x-3.5 rounded hover-bg-button w-full select-dropdown" }, /* @__PURE__ */ React.createElement(
          "select",
          {
            className: "w-full px-3 py-2 text-sm rounded bg-secondary text-color-default hover-text-color-active focus:outline-none",
            onClick: (e) => e.stopPropagation(),
            onChange: (e) => {
              e.stopPropagation();
              this.props.Action.updateFolder(calc, e.target.value);
            },
            value: calc.folder || ""
          },
          /* @__PURE__ */ React.createElement("option", { value: "" }, "Move to..."),
          /* @__PURE__ */ React.createElement("option", { key: "", value: "", disabled: !calc.folder }, "Top-level"),
          folders.map((folder) => /* @__PURE__ */ React.createElement("option", { key: folder.name, value: folder.name, disabled: calc.folder == folder.name }, folder.name))
        )),
        /* @__PURE__ */ React.createElement("a", { href: "javascript:void(0)", className: "flex text-sm items-center gap-x-3.5 py-2 rounded hover-bg-button px-3", onClick: () => this.props.Action?.currentInstaCalcReact?.editOpen() }, "Rename calc"),
        /* @__PURE__ */ React.createElement("a", { href: "javascript:void(0)", className: "flex text-sm items-center gap-x-3.5 py-2 rounded hover-bg-button px-3", onClick: () => this.props.Action.clone(calc, " copy") }, "Copy calc"),
        /* @__PURE__ */ React.createElement("a", { href: "javascript:void(0)", className: "flex text-sm items-center gap-x-3.5 py-2 rounded hover-bg-button px-3", "data-hs-overlay": "#hs-modal-delete", onClick: () => this.updateDeleteModal(calc) }, "Delete calc"),
        /* @__PURE__ */ React.createElement("a", { href: "javascript:void(0)", className: "flex text-sm items-center gap-x-3.5 py-2 rounded hover-bg-button px-3", onClick: () => this.props.Action.exportCalc(calc) }, "Export to file")
      ));
    }
  };
  var FolderDropdown = class extends React.Component {
    static {
      __name(this, "FolderDropdown");
    }
    render() {
      const { onRename, onDelete, isEmptyFolder, onCreate, folder } = this.props;
      let safeName = folder.name.replace(/[^a-zA-Z0-9]/g, "-");
      return /* @__PURE__ */ React.createElement("div", { onClick: (e) => e.stopPropagation(), className: "relative inline-flex hs-dropdown" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          id: `hs-dropdown-folder-${safeName}`,
          "aria-label": "Folder actions",
          type: "button",
          className: "relative flex items-center justify-center gap-1 text-xs capitalize align-middle transition-all border-transparent rounded-md tooltip tooltip-left text-color-default hover-text-color-active hs-dropdown-toggle focus:outline-none",
          "data-tip": "Folder actions"
        },
        /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "w-5 h-5" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12a9 9 0 11-18 0 9 9 0 0118 0z" }))
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "hs-dropdown-menu z-[60] transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden min-w-[10rem] bg-secondary shadow-md rounded-lg p-2 mt-2 dark:bg-gray-800 dark:border dark:border-gray-700 dark:divide-gray-700 after:h-4 after:absolute after:-bottom-4 after:left-0 after:w-full before:h-4 before:absolute before:-top-4 before:left-0 before:w-full",
          "aria-labelledby": `hs-dropdown-folder-${safeName}`
        },
        /* @__PURE__ */ React.createElement("a", { href: "", className: "flex text-sm items-center gap-x-3.5 py-2 rounded hover-bg-button px-3", onClick: (e) => {
          e.preventDefault();
          onCreate();
        } }, "+New calc here"),
        /* @__PURE__ */ React.createElement("a", { href: "", className: "flex text-sm items-center gap-x-3.5 py-2 rounded hover-bg-button px-3", onClick: (e) => {
          e.preventDefault();
          onRename();
        } }, "Rename folder"),
        isEmptyFolder ? /* @__PURE__ */ React.createElement("a", { href: "", className: "flex text-sm items-center gap-x-3.5 py-2 rounded hover-bg-button px-3", onClick: (e) => {
          e.preventDefault();
          onDelete();
        } }, "Delete empty folder") : /* @__PURE__ */ React.createElement("div", { className: "flex text-sm opacity-50 items-center gap-x-3.5 py-2 rounded px-3" }, "Delte folder when empty")
      ));
    }
  };
  var CalcListDropdown = class extends React.Component {
    static {
      __name(this, "CalcListDropdown");
    }
    render() {
      const { Action: Action2 } = this.props;
      return /* @__PURE__ */ React.createElement("div", { onClick: (e) => e.stopPropagation(), className: "relative inline-flex normal-case hs-dropdown" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          id: `hs-dropdown-calclist`,
          "aria-label": "Calc list actions",
          type: "button",
          className: "relative flex items-center justify-center gap-1 text-xs align-middle transition-all border-transparent rounded-md tooltip tooltip-left text-color-default hover-text-color-active hs-dropdown-toggle focus:outline-none",
          "data-tip": "Calc list actions"
        },
        /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "w-5 h-5" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12a9 9 0 11-18 0 9 9 0 0118 0z" }))
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "hs-dropdown-menu z-[60] transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden min-w-[10rem] bg-secondary shadow-md rounded-lg p-2 mt-2 dark:bg-gray-800 dark:border dark:border-gray-700 dark:divide-gray-700 after:h-4 after:absolute after:-bottom-4 after:left-0 after:w-full before:h-4 before:absolute before:-top-4 before:left-0 before:w-full",
          "aria-labelledby": `hs-dropdown-calclist`
        },
        /* @__PURE__ */ React.createElement("a", { href: "", className: "flex text-sm items-center gap-x-3.5 py-2 rounded hover-bg-button px-3", onClick: (e) => {
          e.preventDefault();
          this.props.Action.exportAllCalcs();
        } }, "Export calcs"),
        /* @__PURE__ */ React.createElement("a", { href: "", className: "flex text-sm items-center gap-x-3.5 py-2 rounded hover-bg-button px-3", onClick: (e) => {
          e.preventDefault();
          this.props.Action.openFileImportUX();
        } }, "Import calcs...")
      ));
    }
  };
  var TextEditView = class extends React.Component {
    static {
      __name(this, "TextEditView");
    }
    constructor(props) {
      super(props);
      this.state = {
        textValue: this.getTextFromRows(),
        lineHeights: []
      };
      this.handleTextChange = this.handleTextChange.bind(this);
      this.syncTextToRows = this.syncTextToRows.bind(this);
      this.getTextFromRows = this.getTextFromRows.bind(this);
      this.calculateLineHeights = this.calculateLineHeights.bind(this);
      this.textareaRef = null;
    }
    componentDidUpdate(prevProps) {
      if (prevProps.calc.id !== this.props.calc.id || prevProps.calc.rows !== this.props.calc.rows) {
        this.setState({ textValue: this.getTextFromRows() }, () => {
          this.calculateLineHeights();
        });
      }
    }
    componentDidMount() {
      this.calculateLineHeights();
    }
    getTextFromRows() {
      return this.props.calc.rows.map((row) => row.text || "").join("\n");
    }
    handleTextChange(event) {
      const newText = event.target.value;
      this.setState({ textValue: newText }, () => {
        this.calculateLineHeights();
      });
      this.syncTextToRows(newText);
    }
    syncTextToRows(text) {
      const lines = text.split("\n");
      const calc = this.props.calc;
      lines.forEach((line, index) => {
        if (index < calc.rows.length) {
          this.props.Action.updateRowText(calc, index, line);
        } else {
          UIlog("[Row]", this.props.index, "expanded view regular result path");
          UIlog("[Row]", this.props.index, "rendering default result in collapsed output");
          this.props.Action.insertRow(calc, index);
          this.props.Action.updateRowText(calc, index, line);
        }
      });
      while (calc.rows.length > lines.length) {
        this.props.Action.deleteRow(calc, calc.rows.length - 1);
      }
      this.props.onTextChange();
    }
    calculateLineHeights() {
      if (!this.textareaRef || !document.body) return;
      const textarea = this.textareaRef;
      const lines = this.state.textValue.split("\n");
      const lineHeights = [];
      let measureElement = null;
      try {
        measureElement = document.createElement("div");
        measureElement.style.position = "absolute";
        measureElement.style.visibility = "hidden";
        measureElement.style.whiteSpace = "pre-wrap";
        measureElement.style.wordWrap = "break-word";
        measureElement.style.top = "-9999px";
        measureElement.style.left = "-9999px";
        measureElement.style.padding = "0";
        measureElement.style.margin = "0";
        measureElement.style.border = "0";
        const computedStyle = getComputedStyle(textarea);
        measureElement.style.font = computedStyle.font;
        measureElement.style.lineHeight = computedStyle.lineHeight || "27px";
        measureElement.style.fontSize = computedStyle.fontSize;
        measureElement.style.fontFamily = computedStyle.fontFamily;
        measureElement.style.width = Math.max(textarea.clientWidth - 16, 100) + "px";
        document.body.appendChild(measureElement);
        lines.forEach((line) => {
          measureElement.textContent = line || " ";
          const height = Math.max(measureElement.offsetHeight, 27);
          lineHeights.push(height);
        });
      } catch (error) {
        console.warn("Error calculating line heights:", error);
        lines.forEach(() => lineHeights.push(27));
      } finally {
        if (measureElement && measureElement.parentNode) {
          measureElement.parentNode.removeChild(measureElement);
        }
      }
      this.setState({ lineHeights });
    }
    render() {
      const results = this.props.results;
      const resultAlignment = "left";
      const showLineNumbers = this.props.showLineNumbers !== false;
      const flexDirection = resultAlignment === "right" ? "flex-row-reverse" : "flex-row";
      const textAlign = `text-${resultAlignment}`;
      const lineCount = (this.state.textValue.match(/\n/g) || []).length + 1;
      const lineHeight = 27;
      const padding = 16;
      const minLines = Math.max(lineCount, 5);
      let totalContentHeight = 0;
      if (this.state.lineHeights.length > 0) {
        totalContentHeight = this.state.lineHeights.reduce((sum, height) => sum + height, 0);
      } else {
        UIlog("[Row]", this.props.index, "expanded view regular result path");
        totalContentHeight = lineCount * lineHeight;
      }
      const dynamicHeight = Math.max(minLines * lineHeight + padding, totalContentHeight + padding);
      const lineNumbers = Array.from({ length: Math.max(lineCount, 5) }, (_, i) => i + 1);
      return /* @__PURE__ */ React.createElement("div", { className: "flex gap-2 text-sm text-edit-view lg:text-base" }, /* @__PURE__ */ React.createElement("div", { className: "relative flex w-1/2" }, showLineNumbers && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "select-none group",
          style: {
            lineHeight: "27px",
            paddingTop: "8px",
            paddingBottom: "8px",
            height: `${dynamicHeight}px`,
            scrollbarWidth: "none",
            msOverflowStyle: "none"
          }
        },
        lineNumbers.map((num) => {
          const lineHeight2 = this.state.lineHeights[num - 1] || 27;
          return /* @__PURE__ */ React.createElement("div", { key: num, style: { height: `${lineHeight2}px`, minHeight: "27px" } }, /* @__PURE__ */ React.createElement("number", { className: "draggable align-middle pr-1 text-[68.75%] md:pr-2 w-4 md:w-5 cursor-pointer hover-text-color-active opacity-0 group-hover:opacity-75 transition-opacity duration-500" }, "R", num));
        })
      ), /* @__PURE__ */ React.createElement(
        "textarea",
        {
          ref: (el) => this.textareaRef = el,
          className: "flex-1 p-2 bg-transparent border-r outline-none resize-none no-scrollbar border-color-soft text-color-default",
          value: this.state.textValue,
          onChange: this.handleTextChange,
          placeholder: "Enter calculations...",
          autoComplete: "off",
          autoCorrect: "off",
          autoCapitalize: "off",
          spellCheck: false,
          style: {
            lineHeight: "27px",
            height: `${dynamicHeight}px`
          }
        }
      )), /* @__PURE__ */ React.createElement("div", { className: "w-1/2 p-2 overflow-hidden rounded-md", style: {
        height: `${dynamicHeight}px`
      } }, /* @__PURE__ */ React.createElement("div", { className: textAlign }, results.map((result, i) => {
        const lineHeight2 = this.state.lineHeights[i] || 27;
        return /* @__PURE__ */ React.createElement(
          "div",
          {
            key: i,
            style: {
              height: `${lineHeight2}px`,
              minHeight: "27px"
              // Ensure minimum height
            },
            className: `block items-center min-w-0 max-w-full space-x-2 text-color-default ${flexDirection}`
          },
          result.result && /* @__PURE__ */ React.createElement("result", { className: resultAlignment === "right" ? "flex-auto text-right inline cursor-pointer break-words" : "flex-shrink-0 inline cursor-pointer break-words", style: { overflowWrap: "anywhere" } }, LIB.prettyPrintResultHTML(result.result)),
          result.type && /* @__PURE__ */ React.createElement("type", { className: "flex-shrink-0 inline cursor-pointer whitespace-nowrap", style: { marginLeft: ".25rem" } }, result.type),
          typeof result.comment === "string" && result.comment && /* @__PURE__ */ React.createElement("comment", { className: "flex-shrink-0 inline text-left break-words cursor-pointer", style: { overflowWrap: "anywhere" } }, result.comment)
        );
      }))));
    }
  };
  var InstaCalcReact = class extends React.Component {
    static {
      __name(this, "InstaCalcReact");
    }
    constructor(props) {
      super(props);
      this.state = {
        selected: 0,
        editingTitle: false,
        results: [],
        recalcNonce: null,
        recalcTime: null,
        textEditMode: this.props.Action.getCalcViewMode(this.props.calc) === "text"
      };
      this.handleEdit = this.handleEdit.bind(this);
      this.editOpen = this.editOpen.bind(this);
      this.editClose = this.editClose.bind(this);
      this.focusRow = this.focusRow.bind(this);
      this.onSelectRow = this.onSelectRow.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
      this.asyncRecalculate = this.asyncRecalculate.bind(this);
      this.recalculate = this.recalculate.bind(this);
      this.smartRecalculate = this.smartRecalculate.bind(this);
      this.toggleTextEditMode = this.toggleTextEditMode.bind(this);
      this.debounceRecalculate = debounce(this.asyncRecalculate, 5).bind(this);
    }
    componentDidMount() {
      if (typeof ClipboardJS !== "undefined") {
        new ClipboardJS(".copy-event");
      }
      if (this.props.view === "calc") {
        setTimeout(() => {
          const rowToFocus = this.findFirstAvailableRow();
          this.focusRow(rowToFocus);
        }, 100);
      }
      this.smartRecalculate();
    }
    componentWillReceiveProps(nextProps) {
      if (nextProps.calc.id !== this.props.calc.id) {
        this.setState({ editingTitle: nextProps.calc.name == "" });
        this.setState({ results: this.blankResultArray(nextProps.calc.rows.length) });
        this.setState({ textEditMode: this.props.Action.getCalcViewMode(nextProps.calc) === "text" });
      } else {
        UIlog("[Row]", this.props.index, "expanded view regular result path");
        this.setState({
          editingTitle: nextProps.calc.name == "" || this.state.editingTitle
        });
      }
      this.smartRecalculate();
    }
    blankResultArray(count) {
      return new Array(count).fill({
        data: "",
        result: "",
        comment: "",
        type: "",
        title: "",
        processed: "",
        log: []
      });
    }
    handleEdit(event) {
      this.props.Action.updateName(this.props.calc, event.target.value);
    }
    editOpen() {
      this.setState({ editingTitle: true });
    }
    editClose(e) {
      e.preventDefault();
      if (this.props.calc.name !== "") {
        this.setState({ editingTitle: false });
        this.focusRow(0);
      }
    }
    insertRow(i) {
      this.props.Action.insertRow(this.props.calc, i);
      this.focusRow(i);
    }
    deleteRow(i) {
      var rows = this.props.calc.rows;
      this.props.Action.deleteRow(this.props.calc, i);
      rows.length == i ? this.focusRow(i - 1) : this.focusRow(i);
    }
    // arrow keys only on keydown
    onKeyDown(event) {
      var rows = this.props.calc.rows;
      var change = null;
      switch (event.key) {
        case "ArrowDown":
          change = 1;
          break;
        case "Enter":
          change = 1;
          if (this.props.view != "embed") {
            let i2 = this.state.selected;
            if (i2 == this.props.calc.rows.length - 1) {
              this.insertRow(i2 + 1);
              setTimeout(() => this.focusRow(i2 + 1), 50);
              return;
            }
          }
          break;
        case "ArrowUp":
          change = -1;
          break;
        default:
          return;
      }
      for (var i = this.state.selected + change; i < rows.length && i >= 0; i += change) {
        var hasVisibleInput = this.refs["row" + i] && this.refs["row" + i].refs["input"];
        if (hasVisibleInput) {
          this.focusRow(i);
          return;
        }
      }
      if (change == 1) {
        this.focusRow(this.state.selected + change);
      }
    }
    findFirstAvailableRow() {
      const rows = this.props.calc.rows;
      for (var i = 0; i < rows.length; i++) {
        var hasVisibleInput = this.refs["row" + i] && this.refs["row" + i].refs["input"];
        if (hasVisibleInput) {
          return i;
        }
      }
      return 0;
    }
    focusRow(i) {
      var row = this.refs["row" + i];
      if (row) {
        this.onSelectRow(i);
        row.setFocus();
      }
    }
    onSelectRow(i) {
      this.setState({ selected: i });
      this.props.Action.selectedRow = i;
    }
    recalculate() {
      let results = this.props.Action.recalculate(this.props.calc);
      this.props.Action.setResults(this.props.calc, results);
      this.setState({ results });
    }
    // TODO: use lib here?
    asyncRecalculate() {
      if (IC.api.isWorkerLoaded()) {
        this.props.Action.async_recalculate(this.props.calc, (results) => {
          this.props.Action.setResults(this.props.calc, results);
          this.setState({ results });
        });
      } else {
        UIlog("[Row]", this.props.index, "expanded view regular result path");
        setTimeout(this.recalculate, 0);
      }
    }
    smartRecalculate() {
      this.debounceRecalculate();
      return;
      let recalcNonce = JSON.stringify(this.props.calc.rows) + this.state.selected + this.props.currenciesLoaded;
      let recalcTime = Date.now();
      let timeDiff = Math.abs(recalcTime - this.state.recalcTime);
      if (recalcNonce != this.state.recalcNonce) {
        this.setState({ recalcNonce, recalcTime });
        this.asyncRecalculate();
      }
    }
    updateRowVariableState() {
      for (const [key, value] of Object.entries(this.refs)) {
        key.match("row") && value.updateVariableState();
      }
    }
    toggleTextEditMode() {
      const newTextEditMode = !this.state.textEditMode;
      const newViewMode = newTextEditMode ? "text" : "calc";
      this.setState({ textEditMode: newTextEditMode });
      this.props.Action.setCalcViewMode(this.props.calc, newViewMode);
    }
    render() {
      var results = this.state.results;
      this.rowElements = results.map((result, i) => {
        return /* @__PURE__ */ React.createElement(
          Row,
          {
            key: i,
            index: i,
            view: this.props.view,
            Action: this.props.Action,
            calc: this.props.calc,
            ref: "row" + i,
            result,
            onSelectRow: this.onSelectRow,
            deleteRow: () => this.deleteRow(i),
            insertRow: () => this.insertRow(i),
            insertRowAfter: () => this.insertRow(i + 1)
          }
        );
      }, this);
      var calc_settings = /* @__PURE__ */ React.createElement("div", { className: "hidden relative lg:inline-flex hs-dropdown [--Xtrigger:hover] float-left -ml-1 mr-3" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          id: "hs-dropdown-calc-settings",
          "aria-label": "Calc actions",
          type: "button",
          className: "relative flex items-center justify-center gap-1 mt-1 text-xs capitalize align-middle transition-all border-transparent rounded-md tooltip text-color-default hover-text-color-active hs-dropdown-toggle focus:outline-none",
          "data-tip": "Calc actions"
        },
        /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "w-5 h-5 opacity-75" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M8.625 12a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H8.25m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0H12m4.125 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm0 0h-.375M21 12a9 9 0 11-18 0 9 9 0 0118 0z" }))
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "hs-dropdown-menu z-[60] transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden min-w-[10rem] bg-secondary shadow-md rounded-lg p-2 mt-2 dark:bg-gray-800 dark:border dark:border-gray-700 dark:divide-gray-700 after:h-4 after:absolute after:-bottom-4 after:left-0 after:w-full before:h-4 before:absolute before:-top-4 before:left-0 before:w-full",
          "aria-labelledby": "hs-dropdown-calc-settings"
        },
        /* @__PURE__ */ React.createElement("div", { className: "hidden text-xs font-medium text-center capitalize opacity-50 text-color-default" }, "Calc Actions"),
        /* @__PURE__ */ React.createElement(
          "a",
          {
            href: "javascript:void(0)",
            className: "flex text-sm items-center gap-x-3.5 py-2 rounded hover-bg-button px-3",
            onClick: this.editOpen
          },
          "Rename calc"
        ),
        /* @__PURE__ */ React.createElement(
          "a",
          {
            href: "javascript:void(0)",
            className: "flex text-sm items-center gap-x-3.5 py-2 rounded hover-bg-button px-3",
            title: "Add another copy of this calc to your list",
            onClick: () => this.props.Action.clone(this.props.calc, " copy")
          },
          "Copy calc"
        ),
        /* @__PURE__ */ React.createElement(
          "a",
          {
            href: "javascript:void(0)",
            className: "calc-delete flex text-sm items-center gap-x-3.5 py-2 rounded hover-bg-button px-3",
            "data-hs-overlay": "#hs-modal-delete",
            onClick: (e) => document.querySelector("#hs-dropdown-calc-settings").click()
          },
          "Delete calc"
        )
      ));
      if (this.props.view == "calc") {
        let deleteModal = /* @__PURE__ */ React.createElement(ICModal, { id: "hs-modal-delete", title: `Delete ${this.props.calc.name}?`, close: "Keep", accept: "Delete", onAccept: (e) => {
          this.props.Action.delete(this.props.calc);
        } });
        LIB.tryToRender(deleteModal, "DeleteModal");
      }
      var titleArea = null;
      if (this.state.editingTitle && this.props.view == "calc") {
        titleArea = /* @__PURE__ */ React.createElement("form", { onSubmit: this.editClose }, /* @__PURE__ */ React.createElement(
          "input",
          {
            className: "w-1/2 px-2 py-1 border rounded-lg outline-none border-color-soft focus:border-0 focus:ring focus:ring-sky-300",
            value: this.props.calc.name,
            onChange: this.handleEdit,
            onBlur: this.editClose,
            placeholder: "Enter a title",
            type: "text",
            "aria-label": "Calc title",
            "data-hj-whitelist": true
          }
        ));
      } else {
        UIlog("[Row]", this.props.index, "expanded view regular result path");
        const isCalcView = this.props.view == "calc";
        var style = isCalcView ? { cursor: "pointer" } : {};
        titleArea = /* @__PURE__ */ React.createElement("h2", { style, className: "mb-2 max-w-[60%] lg:max-w-full " + (!isCalcView ? "lg:text-center" : "") }, /* @__PURE__ */ React.createElement("span", { "data-tip": "Click to edit title", className: "text-md font-bold text-color-default lg:text-xl lg:mb-4 font-heading" + (isCalcView && "tooltip"), onClick: this.editOpen }, this.props.calc.name));
      }
      let classes = this.props.view == "embed" ? "rounded-lg" : "lg:rounded-t-lg";
      return /* @__PURE__ */ React.createElement("calc", { className: `block px-2 py-2 icreact lg:px-4 bg-default max-w-[100vw] ${classes}` }, /* @__PURE__ */ React.createElement("div", { className: "w-full mx-auto" }, titleArea, this.state.textEditMode ? /* @__PURE__ */ React.createElement(
        TextEditView,
        {
          calc: this.props.calc,
          Action: this.props.Action,
          results,
          onTextChange: this.smartRecalculate,
          showLineNumbers: false
        }
      ) : /* @__PURE__ */ React.createElement(
        "rows",
        {
          className: "block mb-2 text-sm md:text-base",
          onKeyDown: this.onKeyDown
        },
        this.rowElements
      ), this.props.footer));
    }
  };
  InstaCalcReact.propTypes = {
    calc: React.PropTypes.any.isRequired
  };
  var Row = class extends React.Component {
    static {
      __name(this, "Row");
    }
    constructor(props) {
      super(props);
      this.inputChanged = this.inputChanged.bind(this);
      this.onFocus = this.onFocus.bind(this);
      this.onBlur = this.onBlur.bind(this);
      this.onPaste = this.onPaste.bind(this);
      this.toggleHidden = this.toggleHidden.bind(this);
      this.getRowParameter = this.getRowParameter.bind(this);
      this.updateVariableState = this.updateVariableState.bind(this);
      this.hasRowParameter = this.hasRowParameter.bind(this);
      this.toggleExpanded = this.toggleExpanded.bind(this);
      this.renderUIControl = this.renderUIControl.bind(this);
      this.replaceBeforeComment = this.replaceBeforeComment.bind(this);
      this.extractBeforeComment = this.extractBeforeComment.bind(this);
      this.extractAssignedSnippet = this.extractAssignedSnippet.bind(this);
      this.valueToSnippet = this.valueToSnippet.bind(this);
      this.state = {
        className: "",
        hasRowParameter: this.hasRowParameter(),
        id: this.props.calc.id,
        rowlength: this.props.calc.rows.length,
        lastkeypress: "",
        expanded: false
      };
    }
    hasRowParameter(calc, index) {
      return this.getRowParameter(calc, index) !== null;
    }
    toggleExpanded(event) {
      console.log("toggleExpanded");
      event.stopPropagation();
      this.setState((prevState) => ({ expanded: !prevState.expanded }));
    }
    updateVariableState(calc, index) {
      this.setState({ hasRowParameter: this.hasRowParameter(calc, index) });
    }
    // isVariableRow checks isHidden, etc. to see if this can be a variable row
    getRowParameter(calc, index) {
      var c = calc || this.props.calc;
      var i = index || this.props.index;
      var configValue = IC.api.getParameter(c, i);
      return configValue;
    }
    componentWillReceiveProps(nextProps) {
      var nextCalc = nextProps.calc;
      if (nextCalc.id !== this.state.id || nextCalc.rows.length !== this.state.rowlength) {
        this.updateVariableState(nextProps.calc, nextProps.index);
        this.setState({ id: nextCalc.id, rowlength: nextCalc.rows.length });
      }
    }
    shouldComponentUpdate(nextProps, nextState) {
      return true;
      var identical = JSON.stringify(nextProps) == JSON.stringify(this.props) && JSON.stringify(nextState) == JSON.stringify(this.state);
      return true;
      return !identical;
    }
    setFocus() {
      var el = ReactDOM.findDOMNode(this.refs.input);
      if (el) {
        el.focus();
        setTimeout(function() {
          el.select();
        }, 0);
      }
    }
    isVeryLastRow() {
      const rows = this.props.calc.rows || [];
      return this.props.index === rows.length - 1;
    }
    onPaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData("text").trim();
      if (pastedText.includes("\n")) {
        event.preventDefault();
        const lines = pastedText.split("\n");
        const callback = /* @__PURE__ */ __name(() => {
          this.props.Action.pasteTextLines(this.props.calc, this.props.index, lines);
        }, "callback");
        let replaceArray = lines.map((line, i) => {
          return /* @__PURE__ */ React.createElement("tr", { className: "border-b border-color-soft" }, /* @__PURE__ */ React.createElement("td", { className: "p-2" }, "R" + (this.props.index + i + 1).toString()), /* @__PURE__ */ React.createElement("td", { className: "p-2" }, this.props.calc.rows[this.props.index + i]?.text || ""), /* @__PURE__ */ React.createElement("td", { className: "p-2" }, line));
        });
        console.log("onpaste", lines, replaceArray);
        let pasteLinesModal = /* @__PURE__ */ React.createElement(
          ICModal,
          {
            id: "hs-modal-paste-lines",
            title: `Paste ${lines.length} rows?`,
            close: "Close",
            accept: "Paste",
            onAccept: callback.bind(this)
          },
          /* @__PURE__ */ React.createElement("div", { className: "block overflow-auto max-h-96 min-w-[24rem]" }, /* @__PURE__ */ React.createElement("table", { className: "w-full p-4 mx-auto text-sm text-center border-collapse table-auto" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", { className: "text-center border-b border-color-soft" }, /* @__PURE__ */ React.createElement("th", null, "Row"), /* @__PURE__ */ React.createElement("th", null, "Current"), /* @__PURE__ */ React.createElement("th", null, "New"))), /* @__PURE__ */ React.createElement("tbody", null, replaceArray)))
        );
        LIB.tryToRender(pasteLinesModal, "PasteLinesModal");
        document.getElementById("PasteLinesModalTrigger").click();
        return;
      }
    }
    onFocus(event) {
      this.setState({ className: "selected" });
      this.props.onSelectRow(this.props.index);
    }
    onBlur(event) {
      this.setState({ className: "" });
    }
    toggleHidden(event) {
      this.props.Action.toggleRowVisibility(this.props.calc, this.props.index);
      this.updateVariableState();
    }
    inputChanged(event) {
      var newtext = event.target.value;
      if (this.state.hasRowParameter) {
        let currentText = this.props.calc.rows[this.props.index].text;
        newtext = IC.api.buildParameterText(currentText, event.target.value);
      }
      this.props.Action.updateRowText(this.props.calc, this.props.index, newtext);
      if (event.charCode) {
        this.setState({ lastkeypress: event.charCode });
      }
    }
    // --- UI metadata helpers ---
    extractBeforeComment(text) {
      if (typeof text !== "string") return "";
      const idx = text.indexOf("//");
      return (idx >= 0 ? text.substring(0, idx) : text).trimEnd();
    }
    extractAssignedSnippet(text) {
      if (IC && IC.api && typeof IC.api.extractAssignedSnippet === "function") {
        return IC.api.extractAssignedSnippet(text);
      }
      const before = this.extractBeforeComment(text).trim();
      const eqIdx = before.indexOf("=");
      if (eqIdx >= 0) {
        return before.substring(eqIdx + 1).trim();
      }
      return before;
    }
    replaceBeforeComment(originalText, newMainText) {
      try {
        if (IC && IC.parser && typeof IC.parser.replaceTextBeforeComment === "function") {
          return IC.parser.replaceTextBeforeComment(originalText, newMainText);
        }
      } catch (e) {
      }
      const hasComment = originalText.includes("//");
      const comment = hasComment ? originalText.split("//").slice(1).join("//") : "";
      const combined = newMainText + (hasComment ? ` //${comment}` : "");
      return combined;
    }
    valueToSnippet(val) {
      if (typeof val === "number") return String(val);
      if (typeof val === "boolean") return val ? "true" : "false";
      return String(val);
    }
    renderUIControl(uiMeta) {
      if (!uiMeta) return null;
      const type = (uiMeta.ui || "").toLowerCase();
      UIlog("[UIControl] type:", type, "uiMeta:", uiMeta, "result:", this.props.result);
      const options = Array.isArray(uiMeta.options) ? uiMeta.options : [];
      const rowText = this.props.calc.rows[this.props.index]?.text || "";
      const extractAssignedSnippet = /* @__PURE__ */ __name((text) => {
        const before = this.extractBeforeComment(text).trim();
        const eqIdx = before.indexOf("=");
        if (eqIdx >= 0) {
          return before.substring(eqIdx + 1).trim();
        }
        return before;
      }, "extractAssignedSnippet");
      const assignedSnippet = extractAssignedSnippet(rowText);
      const selectedIndex = type === "checkbox" ? 0 : UIControlRenderer.getSelectedIndex(options, this.props.result);
      const applySelection = /* @__PURE__ */ __name((optValue, { forceStringLiteral = false } = {}) => {
        UIlog("[applySelection] called with optValue:", optValue);
        const snippet = forceStringLiteral ? JSON.stringify(String(optValue)) : this.valueToSnippet(optValue);
        UIlog("[applySelection] snippet:", snippet);
        const before = this.extractBeforeComment(rowText);
        let newMain = snippet;
        const eqIdx = before.indexOf("=");
        if (eqIdx >= 0) {
          const lhs = before.substring(0, eqIdx).trimEnd();
          newMain = `${lhs}= ${snippet}`;
        }
        const newText = this.replaceBeforeComment(rowText, newMain);
        UIlog("[applySelection] rowText:", rowText, "\u2192 newText:", newText);
        this.props.Action.updateRowText(this.props.calc, this.props.index, newText);
      }, "applySelection");
      if (type === "dropdown") {
        return UIControlRenderer.renderDropdown(options, selectedIndex, this.state.hasRowParameter, applySelection);
      }
      if (type === "multiselect" || type === "multi" || type === "select-multiple") {
        return UIControlRenderer.renderMultiselect(options, this.props.result, this.state.hasRowParameter, applySelection);
      }
      if (type === "radio") {
        return UIControlRenderer.renderRadio(options, selectedIndex, this.props.calc.id, this.props.index, applySelection, this.props.result);
      }
      if (type === "date" || type === "time" || type === "datetime" || type === "datetime-local") {
        return UIControlRenderer.renderDateTimeInput(type, this.props.result, this.state.hasRowParameter, applySelection);
      }
      if (type === "range" || type === "slider") {
        UIlog("[UIControl] rendering range/slider");
        return UIControlRenderer.renderSlider(this.props.result, this.state.hasRowParameter, assignedSnippet, applySelection);
      }
      if (type === "checkbox") {
        UIlog("[UIControl] rendering checkbox");
        return UIControlRenderer.renderCheckbox(this.props.result, uiMeta, this.state.hasRowParameter, applySelection);
      }
      return null;
    }
    formattedComment(comment) {
      const config = [
        { regex: /^<br\s*\/?>$/i, create: /* @__PURE__ */ __name((key) => /* @__PURE__ */ React.createElement("br", { key: `br-${key}` }), "create") },
        { regex: /^<hr\s*\/?>$/i, create: /* @__PURE__ */ __name((key) => /* @__PURE__ */ React.createElement("hr", { key: `hr-${key}` }), "create") }
      ];
      const parts = comment.split(/(<br\s*\/?>|<hr\s*\/?>)/gi);
      return parts.map((part, index) => {
        const rule = config.find(({ regex }) => regex.test(part));
        return rule ? rule.create(index) : part;
      });
    }
    render() {
      if (!this.props.calc.rows[this.props.index]) {
        return /* @__PURE__ */ React.createElement("div", null);
      }
      var isHidden = this.props.calc.rows[this.props.index].hidden || false;
      var isSelected = this.props.Action.selectedRow == this.props.index;
      var isExpanded = this.state.expanded;
      var showTooltip = this.state.view !== "embed";
      var rowTitle = "R" + (this.props.index + 1);
      var title = `Click to ${isHidden ? "expand" : "collapse"} ${rowTitle}`;
      var parameterValue = this.getRowParameter(this.props.calc, this.props.index);
      var hasParameterRow = this.state.hasRowParameter;
      var hideType = false;
      let value;
      if (hasParameterRow) {
        value = parameterValue;
        if (this.props.result.type) {
          hideType = true;
        }
      } else {
        UIlog("[Row]", this.props.index, "expanded view regular result path");
        value = this.props.calc.rows[this.props.index].text;
        if (IC && this.state.lastkeypress == 32) {
          value = IC.api.processSymbols(value);
        }
      }
      var isLongText = value?.length > (window?.innerWidth <= 768 ? 20 : 30);
      var showExpandButton = isLongText && isSelected && !isHidden && !isExpanded && this.state.view !== "embed";
      const rowText = this.props.calc.rows[this.props.index]?.text || "";
      const rowParamName = IC?.api?.getParameterNameForDisplay ? IC.api.getParameterNameForDisplay(rowText) : null;
      const collapsedLabel = rowParamName && rowParamName.trim() || this.props.result.title;
      const uiMeta = this.props.result?.ui;
      if (uiMeta && isHidden) {
        hideType = true;
      }
      const numberCanBeIncremented = isSelected && isHidden && hasParameterRow && IC.api.canIncrement(value);
      let self = this;
      function changeInput(direction = 1) {
        let newValue = IC.api.increment(value, direction);
        self.inputChanged({ target: { value: newValue } });
      }
      __name(changeInput, "changeInput");
      var inputField = /* @__PURE__ */ React.createElement("div", { className: isHidden && hasParameterRow ? "relative flex ml-0.5 w-2/5 md:w-1/3 flex-shrink-0" : isHidden ? "contents" : "relative ml-0.5" }, !isExpanded && /* @__PURE__ */ React.createElement(
        "input",
        {
          ref: "input",
          value,
          type: "text",
          autoComplete: "off",
          autoCorrect: "off",
          autoCapitalize: "off",
          spellCheck: false,
          onPaste: this.onPaste,
          onInput: this.inputChanged,
          onChange: this.inputChanged,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          className: (hasParameterRow ? "configField " + (isHidden ? "w-full" : "w-2/5 md:w-1/3 mr-1") : "w-full ") + " " + (isHidden ? "" : " ") + " px-1 py-[3px] border border-color-soft text-color-default rounded text-[100%] outline-none focus:ring ring-sky-300" + (showExpandButton ? " pr-6" : "") + (numberCanBeIncremented ? " lg:pr-7" : ""),
          "aria-label": `Input row ${this.props.index + 1}`,
          "data-hj-whitelist": true
        }
      ), showExpandButton && /* @__PURE__ */ React.createElement("button", { onClick: this.toggleExpanded, className: "absolute top-0 right-0 p-1.5 md:p-2 opacity-50", title: "Vertically expand row" }, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-4 h-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "m4.5 5.25 7.5 7.5 7.5-7.5m-15 6 7.5 7.5 7.5-7.5" }))), isExpanded && /* @__PURE__ */ React.createElement("div", { className: "relative top-0 bottom-0 left-0 right-0 z-50 flex items-center justify-center mb-1 bg-opacity-50" }, /* @__PURE__ */ React.createElement(
        "textarea",
        {
          ref: "input",
          value,
          onChange: this.inputChanged,
          className: "w-full h-48 px-1 py-[3px] pr-6 border border-color-soft text-color-default rounded text-[100%] outline-none focus:ring ring-sky-300"
        }
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "absolute top-0 right-0 p-2",
          onClick: this.toggleExpanded,
          title: "Vertically collapse row"
        },
        /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-4 h-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "m4.5 18.75 7.5-7.5 7.5 7.5" }), /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "m4.5 12.75 7.5-7.5 7.5 7.5" }))
      )), numberCanBeIncremented && /* @__PURE__ */ React.createElement("div", { className: "pointer-required:flex flex-col justify-center opacity-50 absolute right-0.5 top-1/2 -translate-y-1/2 z-10 py-0.5" }, /* @__PURE__ */ React.createElement("button", { tabIndex: "-1", className: "p-0 hover:opacity-100", onClick: () => {
        changeInput(1);
      } }, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-3 h-3" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M4.5 15.75l7.5-7.5 7.5 7.5" }))), /* @__PURE__ */ React.createElement("button", { tabIndex: "-1", className: "p-0 hover:opacity-100", onClick: () => {
        changeInput(-1);
      } }, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-3 h-3" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M19.5 8.25l-7.5 7.5-7.5-7.5" })))));
      var resultClass = "";
      if (this.props.result && this.props.result.result == "Number undefined") {
        resultClass = "result_undefined";
      }
      let result_display = LIB.prettyPrintResultHTML(this.props.result.result);
      if (this.props.result.is_custom_function) {
        const prettyPrintResult = LIB.prettyPrintFunction(this.props.result.result);
        result_display = prettyPrintResult;
      } else if (this.props.result.is_custom_object) {
        const prettyPrintResult = LIB.prettyPrintObject(this.props.result.result);
        result_display = /* @__PURE__ */ React.createElement("details", { onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement("summary", null, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "currentColor", className: "inline-block mb-1 mr-1 opacity-75 icon-closed size-3" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm.75-10.25v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5a.75.75 0 0 1 1.5 0Z", clipRule: "evenodd" })), /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "currentColor", className: "inline-block mb-1 mr-1 opacity-75 icon-open size-3" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm4-7a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0 0 1.5h6.5A.75.75 0 0 0 12 8Z", clipRule: "evenodd" })), "Object[", Object.keys(this.props.result.result).length, "]"), /* @__PURE__ */ React.createElement("pre", { className: "inline-block w-full p-2 ml-2 overflow-auto text-xs max-h-[600px]" }, prettyPrintResult));
      } else if (this.props.result.is_array) {
        const prettyPrintResult = LIB.prettyPrintArray(this.props.result.result);
        result_display = /* @__PURE__ */ React.createElement("details", { onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement("summary", null, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "currentColor", className: "inline-block mb-1 mr-1 opacity-75 icon-closed size-3" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm.75-10.25v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5a.75.75 0 0 1 1.5 0Z", clipRule: "evenodd" })), /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "currentColor", className: "inline-block mb-1 mr-1 opacity-75 icon-open size-3" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm4-7a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0 0 1.5h6.5A.75.75 0 0 0 12 8Z", clipRule: "evenodd" })), "Array[", this.props.result.result.length, "]"), /* @__PURE__ */ React.createElement("pre", { className: "inline-block w-full p-2 ml-2 overflow-auto text-xs max-h-[500px]" }, prettyPrintResult));
      }
      if (this.props.result?.result?.vars) {
        result_display = /* @__PURE__ */ React.createElement(
          SetVarsDisplay,
          {
            Action: this.props.Action,
            calc: this.props.calc,
            resultObj: this.props.result.result,
            result: this.props.result
          }
        );
      }
      let hasLog = Array.isArray(this.props.result.log) && this.props.result.log.length;
      var logStr = hasLog ? this.props.result.log.join(" \u2502 ") : null;
      const formatLogStr = /* @__PURE__ */ __name((logStr2) => {
        return logStr2.split("\n").map((item, index) => /* @__PURE__ */ React.createElement("div", null, item, index < logStr2.split("\n").length - 1 && /* @__PURE__ */ React.createElement("br", null)));
      }, "formatLogStr");
      let processed = this.props.result.processed;
      let comment = this.props.result.comment;
      let customType = this.props.result.is_custom_type ? "custom" : "";
      let type = this.props.result.type;
      let rowNumber = "R" + (this.props.index + 1);
      let maybeSelectedLast = this.props.Action.selectedRow == this.props.index ? "selected" : "";
      let numberHtmlId = this.props.Action.name("row-target-" + this.props.index + "-", this.props.calc);
      let allowHoverTrigger = true;
      const isCalcView = this.props.view == "calc";
      let UIResult = false;
      const isResultObjectWithType = this.props.result?.result && typeof this.props.result.result === "object" && this.props.result.result.type;
      if (isResultObjectWithType) {
        try {
          UIResult = /* @__PURE__ */ React.createElement(UIResultNew, { result: this.props.result.result });
        } catch (e) {
          console.error(e);
        }
      }
      let regularResult;
      resultClass += " overflow-auto no-scrollbar ";
      let extraUIComment = null;
      if (uiMeta && typeof this.props.result.ui_comment === "string" && this.props.result.ui_comment.length) {
        extraUIComment = this.props.result.ui_comment;
      } else if (uiMeta && typeof comment === "string" && comment.trim().startsWith("{")) {
        const extractLeadingJSONObject = /* @__PURE__ */ __name((s) => {
          let i = s.indexOf("{");
          if (i < 0) return null;
          let depth = 0, inStr = false, esc = false;
          for (let j = i; j < s.length; j++) {
            const ch = s[j];
            if (inStr) {
              if (esc) {
                esc = false;
                continue;
              }
              if (ch === "\\") {
                esc = true;
                continue;
              }
              if (ch === '"') {
                inStr = false;
              }
              continue;
            }
            if (ch === '"') {
              inStr = true;
              continue;
            }
            if (ch === "{") depth++;
            else if (ch === "}") {
              depth--;
              if (depth === 0) {
                return { start: i, end: j };
              }
            }
          }
          return null;
        }, "extractLeadingJSONObject");
        const pos = extractLeadingJSONObject(comment.trim());
        if (pos) {
          const after = comment.trim().slice(pos.end + 1).trim();
          extraUIComment = after || null;
        }
      }
      UIlog("[Row]", this.props.index, "hidden:", isHidden, "hasParam:", hasParameterRow, "uiMeta:", this.props.result?.ui, "ui_comment:", this.props.result?.ui_comment, "comment:", this.props.result?.comment);
      if (isHidden) {
        if (uiMeta) {
          UIlog("[Row]", this.props.index, "rendering UI in collapsed output");
          regularResult = this.renderUIControl(uiMeta);
        } else if (hasParameterRow) {
          UIlog("[Row]", this.props.index, "rendering parameter input in collapsed output");
          regularResult = inputField;
        } else {
          UIlog("[Row]", this.props.index, "expanded view regular result path");
          UIlog("[Row]", this.props.index, "rendering default result in collapsed output");
          const hasComment = !!(uiMeta && extraUIComment) || !!(!uiMeta && comment);
          const resultMaxWidth = hasComment ? "max-w-[50%]" : "max-w-[100%]";
          regularResult = this.props.result.result != null && /* @__PURE__ */ React.createElement(
            "result",
            {
              className: resultClass + `inline-block whitespace-normal cursor-pointer shrink-0 ${resultMaxWidth} overflow-x-auto no-scrollbar`,
              onClick: this.toggleHidden,
              title
            },
            result_display
          );
        }
      } else {
        UIlog("[Row]", this.props.index, "expanded view regular result path");
        UIlog("[Row]", this.props.index, "rendering default result in collapsed output");
        const hasComment = !!(uiMeta && extraUIComment) || !!(!uiMeta && comment);
        const resultMaxWidth = hasComment ? "max-w-[50%]" : "max-w-[100%]";
        regularResult = this.props.result.result != null && /* @__PURE__ */ React.createElement(
          "result",
          {
            className: resultClass + `inline-block whitespace-normal cursor-pointer shrink-0 ${resultMaxWidth} overflow-x-auto no-scrollbar`,
            onClick: this.toggleHidden,
            title
          },
          result_display
        );
      }
      let ret = /* @__PURE__ */ React.createElement("row", { "data-index": this.props.index, className: (this.state.className || maybeSelectedLast) + " group flex items-center space-x-2 min-h-[30px] md:min-h-[36px] lg:min-h-[44px]" }, /* @__PURE__ */ React.createElement("c0", { className: "relative inline-flex hs-dropdown " + (allowHoverTrigger ? "[--trigger:hover]" : "") }, /* @__PURE__ */ React.createElement(
        "number",
        {
          id: numberHtmlId,
          className: "draggable align-middle pr-1 text-[68.75%] md:pr-2 w-4 md:w-5 cursor-pointer hover-text-color-active hs-dropdown-toggle " + (isCalcView ? "opacity-75" : "opacity-25")
        },
        rowTitle
      ), /* @__PURE__ */ React.createElement("div", { "aria-labelledby": numberHtmlId, className: "hs-dropdown-menu z-[60] transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden min-w-[10rem] bg-secondary shadow-md rounded-lg p-2 mt-2 after:h-4 after:absolute after:-bottom-4 after:left-0 after:w-full before:h-4 before:absolute before:-top-4 before:left-0 before:w-full" }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("a", { href: "javascript:void(0)", onClick: this.props.insertRow, className: "flex text-sm items-center gap-x-3.5 py-2 hover-bg-button rounded px-3" }, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "size-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M3 4.5h14.25M3 9h9.75M3 13.5h5.25m5.25-.75L17.25 9m0 0L21 12.75M17.25 9v12" })), "Insert row above ", rowNumber), /* @__PURE__ */ React.createElement("a", { href: "javascript:void(0)", onClick: this.props.insertRowAfter, className: "flex text-sm items-center gap-x-3.5 py-2 hover-bg-button rounded px-3" }, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "size-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M3 4.5h14.25M3 9h9.75M3 13.5h9.75m4.5-4.5v12m0 0-3.75-3.75M17.25 21 21 17.25" })), "Insert row below ", rowNumber), /* @__PURE__ */ React.createElement("a", { href: "javascript:void(0)", onClick: this.toggleHidden, className: "flex text-sm items-center gap-x-3.5 py-2 hover-bg-button rounded px-3" }, isHidden ? /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "size-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "m18.75 4.5-7.5 7.5 7.5 7.5m-6-15L5.25 12l7.5 7.5" })) : /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "size-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5" })), isHidden ? "Expand" : "Collapse", " ", rowNumber), /* @__PURE__ */ React.createElement("a", { href: "javascript:void(0)", onClick: this.props.deleteRow, className: "flex text-sm items-center gap-x-3.5 py-2 hover-bg-button rounded px-3" }, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "size-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" })), "Delete ", rowNumber)))), /* @__PURE__ */ React.createElement("c1", { className: "relative flex-1 min-w-0 overflow-visible basis-0" }, isHidden ? /* @__PURE__ */ React.createElement("rowlabel", { onClick: this.toggleHidden, className: "block py-1 mr-2 text-right cursor-pointer" }, collapsedLabel) : inputField, isHidden ? "" : (() => {
        const isLastRow = this.isVeryLastRow();
        if (isLastRow) {
          return /* @__PURE__ */ React.createElement("rowContext", { className: `absolute block w-full sm:w-3/4 md:w-2/3 lg:w-1/2 text-xs text-center top-full mt-1 left-1/2 -translate-x-1/2 transition-opacity duration-500 ${isSelected ? "opacity-40" : "opacity-0"}` }, /* @__PURE__ */ React.createElement("span", { className: "" }, /* @__PURE__ */ React.createElement("kbd", { className: "bg-secondary border border-color-soft rounded px-1.5 text-[11px] font-medium" }, "Enter"), " adds row"));
        } else {
          UIlog("[Row]", this.props.index, "expanded view regular result path");
          UIlog("[Row]", this.props.index, "rendering default result in collapsed output");
          return /* @__PURE__ */ React.createElement("rowContext", { className: "absolute block w-full sm:w-3/4 md:w-2/3 lg:w-1/2 text-[9px] uppercase text-center cursor-pointer top-full -mt-[6px] left-1/2 -translate-x-1/2" }, /* @__PURE__ */ React.createElement("a", { className: "", onClick: this.props.insertRowAfter }, "+row"));
        }
      })(), logStr && !isHidden ? /* @__PURE__ */ React.createElement("log", { className: `${isExpanded ? "block" : "absolute left-0 top-full mt-1"} z-40 px-1 py-0.5 text-xs rounded-md border ` + (logStr.length > 60 && "long") }, formatLogStr(logStr)) : ""), /* @__PURE__ */ React.createElement("c2", { className: "relative flex-1 min-w-0 overflow-visible basis-0" }, /* @__PURE__ */ React.createElement("div", { className: "text-[100%] flex items-center space-x-2" }, UIResult ? UIResult : regularResult, !hideType && type && /* @__PURE__ */ React.createElement("type", { className: customType + " inline cursor-pointer", style: { marginLeft: ".25rem" }, title, onClick: this.toggleHidden }, type), uiMeta && extraUIComment && /* @__PURE__ */ React.createElement("comment", { className: "min-w-0 text-left break-words cursor-pointer", style: { overflowWrap: "anywhere" }, onClick: this.toggleHidden, title }, this.formattedComment(extraUIComment)), !uiMeta && comment && /* @__PURE__ */ React.createElement("comment", { className: "min-w-0 text-left break-words cursor-pointer", style: { overflowWrap: "anywhere" }, onClick: this.toggleHidden, title }, this.formattedComment(comment)), !isHidden && uiMeta && /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: this.toggleHidden,
          className: "inline-flex items-center transition-opacity cursor-pointer tooltip opacity-40 hover:opacity-100",
          "data-tip": "Collapse to see UI control"
        },
        /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-4 h-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "m5.25 4.5 7.5 7.5-7.5 7.5m6-15 7.5 7.5-7.5 7.5" }))
      )), processed && !isHidden && this.props.result.output_msg ? /* @__PURE__ */ React.createElement("parsed", { className: "absolute top-full mt-1 z-50 px-1 py-0.5 left-0 text-xs rounded-md border pointer-events-none whitespace-pre-wrap" }, this.props.result.output_msg) : ""));
      return ret;
    }
  };
  var Chart = class _Chart extends React.Component {
    static {
      __name(this, "Chart");
    }
    constructor(props) {
      super(props);
      this.state = {
        // Status: 'idle', 'loading', 'loaded', 'error'
        loadingStatus: window.Chartist ? "loaded" : "idle"
        // Check initial state
      };
      this.chart = null;
    }
    static _loadingPromise = null;
    // Static property to hold the loading promise
    static loadChartistResources() {
      if (window.Chartist) {
        return Promise.resolve();
      }
      if (_Chart._loadingPromise) {
        return _Chart._loadingPromise;
      }
      _Chart._loadingPromise = new Promise((resolve, reject) => {
        console.log("Static Loader: Initiating Chartist load...");
        if (!document.getElementById("chartist-css")) {
          const cssLink = document.createElement("link");
          cssLink.id = "chartist-css";
          cssLink.rel = "stylesheet";
          cssLink.href = "/vendor/chartist/chartist.min.css";
          document.head.insertBefore(cssLink, document.head.firstChild);
          console.log("Static Loader: Chartist CSS prepended.");
        } else {
          UIlog("[Row]", this.props.index, "expanded view regular result path");
          UIlog("[Row]", this.props.index, "rendering default result in collapsed output");
          console.log("Static Loader: Chartist CSS already present.");
        }
        if (!document.getElementById("chartist-js")) {
          const script = document.createElement("script");
          script.id = "chartist-js";
          script.src = "/vendor/chartist/chartist.min.js";
          script.async = true;
          script.onload = () => {
            if (window.Chartist) {
              console.log("Static Loader: Chartist JS loaded successfully.");
              resolve();
            } else {
              UIlog("[Row]", this.props.index, "expanded view regular result path");
              UIlog("[Row]", this.props.index, "rendering default result in collapsed output");
              console.error("Static Loader: Chartist JS loaded but window.Chartist not defined.");
              _Chart._loadingPromise = null;
              reject(new Error("Chartist loaded but failed to initialize."));
            }
          };
          script.onerror = (error) => {
            console.error("Static Loader: Failed to load Chartist JS:", error);
            _Chart._loadingPromise = null;
            reject(new Error("Failed to load Chartist script."));
          };
          document.body.appendChild(script);
          console.log("Static Loader: Chartist JS appended.");
        } else {
          UIlog("[Row]", this.props.index, "expanded view regular result path");
          UIlog("[Row]", this.props.index, "rendering default result in collapsed output");
          console.warn("Static Loader: Script tag exists, checking window.Chartist again shortly...");
          setTimeout(() => {
            if (window.Chartist) {
              resolve();
            } else {
              UIlog("[Row]", this.props.index, "expanded view regular result path");
              UIlog("[Row]", this.props.index, "rendering default result in collapsed output");
              console.error("Static Loader: window.Chartist still not defined after delay.");
              _Chart._loadingPromise = null;
              reject(new Error("Existing Chartist script tag found but library not initialized."));
            }
          }, 500);
        }
      });
      return _Chart._loadingPromise;
    }
    initializeChartLoading() {
      this.setState({ loadingStatus: "loading" });
      _Chart.loadChartistResources().then(() => {
        this.setState({ loadingStatus: "loaded" }, this.renderOrUpdateChart);
      }).catch((error) => {
        console.error("Error initializing chart:", error);
        this.setState({ loadingStatus: "error" });
      });
    }
    componentDidMount() {
      if (this.state.loadingStatus === "loaded") {
        this.renderOrUpdateChart();
      } else if (this.state.loadingStatus === "idle") {
        this.initializeChartLoading();
      }
    }
    componentDidUpdate(prevProps) {
      if (this.props.result !== prevProps.result) {
        this.renderOrUpdateChart();
      }
    }
    componentWillUnmount() {
      if (this.chart) {
        try {
          this.chart.detach();
        } catch (e) {
        }
        this.chart = null;
      }
    }
    renderOrUpdateChart() {
      const { result } = this.props;
      const chartContainerNode = ReactDOM.findDOMNode(this.refs.chartContainer);
      if (!chartContainerNode) {
        console.error("Chart container ref not found.");
        return;
      }
      if (typeof window.Chartist === "undefined") {
        return;
      }
      const chartTypeMap = {
        barchart: "Bar",
        linechart: "Line",
        piechart: "Pie"
      };
      const chartType = chartTypeMap[result.type];
      if (!result || !chartType || !result.data) {
        if (this.chart) {
          try {
            this.chart.detach();
          } catch (e) {
          }
          this.chart = null;
        }
        chartContainerNode.innerHTML = "";
        return;
      }
      const ChartConstructor = window.Chartist[chartType];
      if (!ChartConstructor) {
        console.error("Invalid Chartist chart type:", chartType);
        chartContainerNode.innerHTML = `<p class="chart-error">Invalid chart type: ${chartType}</p>`;
        if (this.chart) {
          try {
            this.chart.detach();
          } catch (e) {
          }
          this.chart = null;
        }
        return;
      }
      let chartOptions = {
        width: "100%",
        height: "200px"
        // Basic default height
      };
      const scaleAxisOptions = {
        axisX: {
          labelInterpolationFnc: /* @__PURE__ */ __name(function(value, index) {
            return value;
          }, "labelInterpolationFnc")
        },
        axisY: {
          // Use labelInterpolationFnc to format Y-axis labels
          labelInterpolationFnc: /* @__PURE__ */ __name(function(value) {
            if (typeof value === "number" && !isNaN(value)) {
              if (Math.abs(value) >= 1e3) {
                try {
                  return IC.api.formatFinance(value);
                } catch (e) {
                  return value.toLocaleString(void 0, { maximumFractionDigits: 0 });
                }
              }
              return value.toLocaleString(void 0, { maximumFractionDigits: Math.abs(value) < 10 && !Number.isInteger(value) ? 2 : 0 });
            }
            return value;
          }, "labelInterpolationFnc")
        }
      };
      if (chartType === "Bar" || chartType === "Line") {
        chartOptions = { ...chartOptions, ...scaleAxisOptions };
      }
      let responsiveOptions = {};
      if (chartType == "Pie") {
        responsiveOptions = [
          ["screen and (min-width: 640px)", {
            chartPadding: 10,
            labelOffset: 20,
            labelPosition: "outside",
            labelInterpolationFnc: /* @__PURE__ */ __name(function(value) {
              return value;
            }, "labelInterpolationFnc")
          }],
          ["screen and (min-width: 1024px)", {
            labelOffset: 20,
            chartPadding: 10
          }]
        ];
      }
      try {
        chartContainerNode.className = "ct-chart chart-component-container";
        chartContainerNode.classList.add(`ct-${chartType.toLowerCase()}`);
        const rawLabels = result.data.map((item) => item.label);
        const rawValues = result.data.map((item) => item.value);
        const chartistData = {
          labels: rawLabels,
          series: chartType === "Pie" ? rawValues : [rawValues]
        };
        if (this.chart) {
          this.chart.update(chartistData, chartOptions);
        } else {
          UIlog("[Row]", this.props.index, "expanded view regular result path");
          UIlog("[Row]", this.props.index, "rendering default result in collapsed output");
          this.chart = new ChartConstructor(
            chartContainerNode,
            chartistData,
            chartOptions,
            responsiveOptions
          );
        }
      } catch (error) {
        console.error(`Error rendering/updating Chartist ${chartType}:`, error);
        chartContainerNode.innerHTML = `<p class="chart-error">Could not render chart.</p>`;
        if (this.chart) {
          try {
            this.chart.detach();
          } catch (e) {
          }
          this.chart = null;
        }
      }
    }
    render() {
      return /* @__PURE__ */ React.createElement("div", { ref: "chartContainer", className: "ct-chart chart-component-container", style: { minHeight: "150px" } });
    }
  };
  var UIResultNew = class extends React.Component {
    static {
      __name(this, "UIResultNew");
    }
    render() {
      const { result } = this.props;
      if (typeof result !== "object" || !result.type) {
        return null;
      }
      let parsedResult = result;
      if (result.type.endsWith("chart") && result?.data) {
        return /* @__PURE__ */ React.createElement(Chart, { result });
      }
      if (parsedResult.type === "image") {
        return /* @__PURE__ */ React.createElement("img", { src: parsedResult.args[0], style: { maxHeight: "500px" }, alt: "Image" });
      }
      if (parsedResult.type === "embed") {
        let url = parsedResult.args[0];
        let id = url?.toString().match(/(\d+)/);
        if (id) {
          let embedURL = `https://instacalc.com/${id[0]}/embed`;
          let height = parseInt(parsedResult.args[1]) || 300;
          if (height > 1e3) {
            height = 1e3;
          }
          if (height < 100) {
            height = 100;
          }
          return /* @__PURE__ */ React.createElement("iframe", { className: "w-full", style: { height: `${height}px` }, src: embedURL });
        } else {
          UIlog("[Row]", this.props.index, "expanded view regular result path");
          UIlog("[Row]", this.props.index, "rendering default result in collapsed output");
          return /* @__PURE__ */ React.createElement("div", null, "Usage: embed(id), ex: embed(12345)");
        }
      }
      if (parsedResult.type === "hyperlink") {
        let title = parsedResult.args[1] || parsedResult.args[0];
        return /* @__PURE__ */ React.createElement("a", { href: parsedResult.args[0], target: "_blank", rel: "noreferrer" }, title);
      }
      if (parsedResult.type === "table") {
        console.log(parsedResult);
        return /* @__PURE__ */ React.createElement("table", { className: "w-full border-collapse table-auto" }, /* @__PURE__ */ React.createElement("tbody", null, parsedResult.data.map((item, index) => /* @__PURE__ */ React.createElement("tr", { key: index, className: "border border-b" }, /* @__PURE__ */ React.createElement("td", { className: "px-4 py-2" }, item.title), /* @__PURE__ */ React.createElement("td", { className: "px-4 py-2" }, parsedResult.args[index])))));
      }
      return /* @__PURE__ */ React.createElement("div", { className: "flex items-center space-x-2" }, /* @__PURE__ */ React.createElement("div", { className: "w-1/4 text-right" }, this.props.label), /* @__PURE__ */ React.createElement("div", { className: "w-3/4" }, this.props.children));
    }
  };
  var CalcMeta = class extends React.Component {
    static {
      __name(this, "CalcMeta");
    }
    constructor(props) {
      super(props);
      this.state = {
        textView: this.props.Action.getTextView(this.props.calc),
        textViewStyle: null,
        embedCalcId: false,
        copiedURL: false,
        isPublic: this.props.view == "public",
        isOpen: false,
        isMobile: this.props.isMobile,
        goalseekButtonClicks: 0,
        historyButtonClicks: 0,
        formatMenuOpen: false,
        quickFormatOpen: false
      };
      this.toggleOptionsPanel = this.toggleOptionsPanel.bind(this);
      this.clickEmbedButton = this.clickEmbedButton.bind(this);
      this.getDOMID = this.getDOMID.bind(this);
      this.toggleFormatMenu = this.toggleFormatMenu.bind(this);
    }
    clickEmbedButton() {
      this.setState({ embedCalcId: this.props.calc.id });
    }
    clickTextButton() {
      this.setState({ textView: this.props.Action.getTextView(this.props.calc, this.state.textViewStyle) });
    }
    toggleOptionsPanel() {
      this.setState({ isOpen: !this.state.isOpen });
    }
    clickGoalseekButton() {
      this.setState({ goalseekButtonClicks: this.state.goalseekButtonClicks + 1 });
    }
    clickHistoryButton() {
      this.setState({ historyButtonClicks: this.state.historyButtonClicks + 1 });
    }
    copyURL() {
      this.setState({ copiedURL: true });
      setTimeout(() => {
        this.setState({ copiedURL: false });
      }, 1500);
    }
    getDOMID(name, useMobile = false) {
      let str = name + "-" + this.props.calc.id + "-" + this.props.view;
      if (useMobile) {
        str += this.props.isMobile ? "-mobile" : "";
      }
      return str;
    }
    toggleFormatMenu() {
      this.setState({ formatMenuOpen: !this.state.formatMenuOpen });
    }
    // Refined toolbar now takes a single params object to avoid positional arg bugs
    renderRefinedToolbar({
      addrows_button,
      clear_button,
      reset_button,
      goalseek_button,
      locale_enabled,
      locale_button,
      rounding_button,
      format_button,
      present_button,
      plaintext_button,
      isPublished,
      embed_button,
      add_button,
      publish_button,
      url_section,
      createShareDropdown,
      createTextButton
    }) {
      var locale = this.props.calc.locale || "en-US";
      var rounding_enabled = false;
      if (this.props.calc.rounding === 0 || this.props.calc.rounding > 0) {
        rounding_enabled = true;
      }
      const refinedGoalseekButton = ToolbarButton.createGoalseek(
        this,
        /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "w-4 h-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M12.33 3H12a9 9 0 1 0 9 9c0-.11 0-.22 0-.33M16.9 13A5 5 0 1 1 11 7.1M15 6V9h3l3-3H18V3M15 9l-2.5 2.5" }))
      );
      var localeText = "US";
      if (locale === "de-DE") {
        localeText = "EU";
      } else if (locale === "hi-IN") {
        localeText = "SA";
      }
      const refinedLocaleButton = ToolbarButton.createLocale(
        this,
        /* @__PURE__ */ React.createElement("div", { className: "flex items-center gap-1" }, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "w-4 h-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" })), /* @__PURE__ */ React.createElement("span", { className: "text-xs font-medium" }, localeText))
      );
      const refinedRoundingButton = ToolbarButton.createRounding(
        this,
        /* @__PURE__ */ React.createElement("span", { className: "text-xs" }, rounding_enabled ? this.props.calc.rounding === 0 ? "1" : `.${Array(this.props.calc.rounding).join("0")}1` : ".123")
      );
      const refinedFormatButton = ToolbarButton.createFormat(
        this,
        /* @__PURE__ */ React.createElement("span", { className: "text-sm font-medium" }, "$")
      );
      const refinedPresentButton = ToolbarButton.createPresent(
        this,
        this.props.Action.shouldHideRows(this.props.calc) ? /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-4 h-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0018 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6" })) : /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-4 h-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z" }))
      );
      const textEditButton = /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "inline-flex items-center justify-center gap-2 px-2 py-1 text-xs transition-all rounded tooltip text-color-default hover-text-color-active hover-bg-button focus:outline-none",
          "data-tip": "Toggle text edit mode",
          onClick: () => {
            if (this.props.Action.currentInstaCalcReact) {
              this.props.Action.currentInstaCalcReact.toggleTextEditMode();
            }
          }
        },
        /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-4 h-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10" }))
      );
      return /* @__PURE__ */ React.createElement("div", { className: "flex flex-col w-full gap-2 px-0 py-1 md:grid md:grid-cols-3 md:items-center md:gap-0" }, /* @__PURE__ */ React.createElement("div", { className: "flex items-center justify-center gap-1 md:justify-start" }, this.state.isPublic ? /* @__PURE__ */ React.createElement("div", { className: "flex items-center tooltip", "data-tip": "Reset values" }, reset_button) : /* @__PURE__ */ React.createElement("div", null, ToolbarButton.createClear(
        this,
        /* @__PURE__ */ React.createElement("span", { className: "inline-flex items-center gap-1 rounded-md" }, /* @__PURE__ */ React.createElement("svg", { className: "w-4 h-4", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React.createElement("path", { d: "M5.50506 11.4096L6.03539 11.9399L5.50506 11.4096ZM3 14.9522H2.25H3ZM9.04776 21V21.75V21ZM11.4096 5.50506L10.8792 4.97473L11.4096 5.50506ZM13.241 17.8444C13.5339 18.1373 14.0088 18.1373 14.3017 17.8444C14.5946 17.5515 14.5946 17.0766 14.3017 16.7837L13.241 17.8444ZM7.21629 9.69832C6.9234 9.40543 6.44852 9.40543 6.15563 9.69832C5.86274 9.99122 5.86274 10.4661 6.15563 10.759L7.21629 9.69832ZM17.9646 12.0601L12.0601 17.9646L13.1208 19.0253L19.0253 13.1208L17.9646 12.0601ZM6.03539 11.9399L11.9399 6.03539L10.8792 4.97473L4.97473 10.8792L6.03539 11.9399ZM6.03539 17.9646C5.18538 17.1146 4.60235 16.5293 4.22253 16.0315C3.85592 15.551 3.75 15.2411 3.75 14.9522H2.25C2.25 15.701 2.56159 16.3274 3.03 16.9414C3.48521 17.538 4.1547 18.2052 4.97473 19.0253L6.03539 17.9646ZM4.97473 10.8792C4.1547 11.6993 3.48521 12.3665 3.03 12.9631C2.56159 13.577 2.25 14.2035 2.25 14.9522H3.75C3.75 14.6633 3.85592 14.3535 4.22253 13.873C4.60235 13.3752 5.18538 12.7899 6.03539 11.9399L4.97473 10.8792ZM12.0601 17.9646C11.2101 18.8146 10.6248 19.3977 10.127 19.7775C9.64651 20.1441 9.33665 20.25 9.04776 20.25V21.75C9.79649 21.75 10.423 21.4384 11.0369 20.97C11.6335 20.5148 12.3008 19.8453 13.1208 19.0253L12.0601 17.9646ZM4.97473 19.0253C5.79476 19.8453 6.46201 20.5148 7.05863 20.97C7.67256 21.4384 8.29902 21.75 9.04776 21.75V20.25C8.75886 20.25 8.449 20.1441 7.9685 19.7775C7.47069 19.3977 6.88541 18.8146 6.03539 17.9646L4.97473 19.0253ZM17.9646 6.03539C18.8146 6.88541 19.3977 7.47069 19.7775 7.9685C20.1441 8.449 20.25 8.75886 20.25 9.04776H21.75C21.75 8.29902 21.4384 7.67256 20.97 7.05863C20.5148 6.46201 19.8453 5.79476 19.0253 4.97473L17.9646 6.03539ZM19.0253 13.1208C19.8453 12.3008 20.5148 11.6335 20.97 11.0369C21.4384 10.423 21.75 9.79649 21.75 9.04776H20.25C20.25 9.33665 20.1441 9.64651 19.7775 10.127C19.3977 10.6248 18.8146 11.2101 17.9646 12.0601L19.0253 13.1208ZM19.0253 4.97473C18.2052 4.1547 17.538 3.48521 16.9414 3.03C16.3274 2.56159 15.701 2.25 14.9522 2.25V3.75C15.2411 3.75 15.551 3.85592 16.0315 4.22253C16.5293 4.60235 17.1146 5.18538 17.9646 6.03539L19.0253 4.97473ZM11.9399 6.03539C12.7899 5.18538 13.3752 4.60235 13.873 4.22253C14.3535 3.85592 14.6633 3.75 14.9522 3.75V2.25C14.2035 2.25 13.577 2.56159 12.9631 3.03C12.3665 3.48521 11.6993 4.1547 10.8792 4.97473L11.9399 6.03539ZM14.3017 16.7837L7.21629 9.69832L6.15563 10.759L13.241 17.8444L14.3017 16.7837Z", fill: "currentColor" }), /* @__PURE__ */ React.createElement("path", { d: "M9 21H21", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round" })), /* @__PURE__ */ React.createElement("span", null, "AC"))
      ), ToolbarButton.createButton(
        this.clickHistoryButton.bind(this),
        "History",
        /* @__PURE__ */ React.createElement("svg", { className: "w-4 h-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" })),
        { "data-hs-overlay": "#" + this.getDOMID("hs-modal-history") }
      ))), /* @__PURE__ */ React.createElement("div", { className: "flex items-center justify-center gap-0" }, locale_enabled && refinedLocaleButton, refinedRoundingButton, !this.state.isPublic && refinedFormatButton, refinedGoalseekButton, !this.state.isPublic && refinedPresentButton, !this.state.isPublic && textEditButton), /* @__PURE__ */ React.createElement("div", { className: "flex items-center justify-center gap-0 md:justify-end" }, createTextButton(), createShareDropdown(), isPublished ? (
        // When published: show URL
        url_section
      ) : (
        // When not published: show publish/add button
        this.state.isPublic ? add_button : publish_button
      )));
    }
    render() {
      var calc = this.props.calc;
      var isPublished = calc.published && calc.published.id;
      var isPublicView = this.state.view == "public";
      const getButtonStyles = /* @__PURE__ */ __name(({ hasDropdown = false } = {}) => {
        const baseStyles = "inline-flex items-center justify-center gap-2 px-2 py-1 text-xs transition-all rounded tooltip text-color-default hover-text-color-active hover-bg-button focus:outline-none";
        const dropdownStyles = hasDropdown ? "border rounded-md shadow-sm border-color-soft hs-dropdown-toggle" : "";
        return `${baseStyles} ${dropdownStyles}`.trim();
      }, "getButtonStyles");
      const createShareDropdown = /* @__PURE__ */ __name(() => {
        const url2 = this.props.Action.getPublicURL(calc);
        return /* @__PURE__ */ React.createElement("div", { className: "relative inline-flex hs-dropdown [--trigger:hover]" }, /* @__PURE__ */ React.createElement(
          "button",
          {
            id: this.getDOMID("hs-dropdown-share", true),
            type: "button",
            className: getButtonStyles(),
            "data-tip": "Share calculator options"
          },
          /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-4 h-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z" }))
        ), /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "hs-dropdown-menu z-[60] transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden min-w-[16rem] bg-secondary shadow-md rounded-lg p-2 mt-2 dark:bg-gray-800 dark:border dark:border-gray-700 dark:divide-gray-700 after:h-4 after:absolute after:-bottom-4 after:left-0 after:w-full before:h-4 before:absolute before:-top-4 before:left-0 before:w-full",
            "aria-labelledby": this.getDOMID("hs-dropdown-share", true)
          },
          /* @__PURE__ */ React.createElement("div", { className: "mb-1 text-xs font-medium text-center capitalize opacity-50 text-color-default" }, "Share options"),
          isPublished && /* @__PURE__ */ React.createElement(
            "a",
            {
              href: "javascript:void(0)",
              className: "flex items-start gap-x-3.5 py-2.5 hover-bg-button rounded px-3 copy-event cursor-pointer",
              "data-clipboard-text": url2,
              onClick: (e) => {
                e.preventDefault();
                this.copyURL();
              }
            },
            /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "w-4 h-4 mt-0.5 flex-shrink-0" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244" })),
            /* @__PURE__ */ React.createElement("div", { className: "text-sm" }, /* @__PURE__ */ React.createElement("div", { className: "font-medium" }, "Copy Link"), /* @__PURE__ */ React.createElement("div", { className: "text-xs text-color-default mt-0.5" }, "Copy public URL to clipboard"))
          ),
          !isPublished && /* @__PURE__ */ React.createElement(
            "a",
            {
              href: "javascript:void(0)",
              className: "flex items-start gap-x-3.5 py-2.5 hover-bg-button rounded px-3 cursor-pointer",
              onClick: () => this.props.Action.publish(this.props.calc)
            },
            /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "w-4 h-4 mt-0.5 flex-shrink-0 text-color-default" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418" })),
            /* @__PURE__ */ React.createElement("div", { className: "text-sm" }, /* @__PURE__ */ React.createElement("div", { className: "font-medium text-color-default" }, "Publish Calculator"), /* @__PURE__ */ React.createElement("div", { className: "text-xs text-color-default mt-0.5" }, "Create public link to share"))
          ),
          isPublished && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
            "a",
            {
              href: "javascript:void(0)",
              className: "flex items-start gap-x-3.5 py-2.5 hover-bg-button rounded px-3 cursor-pointer",
              onClick: this.clickEmbedButton.bind(this),
              "data-hs-overlay": "#hs-modal-copyembed"
            },
            /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "w-4 h-4 mt-0.5 flex-shrink-0" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5" })),
            /* @__PURE__ */ React.createElement("div", { className: "text-sm" }, /* @__PURE__ */ React.createElement("div", { className: "font-medium" }, "Get HTML Embed Code"), /* @__PURE__ */ React.createElement("div", { className: "text-xs text-color-default mt-0.5" }, "Embed on your website"))
          ), /* @__PURE__ */ React.createElement("div", { className: "my-2 border-t border-color-soft" }), /* @__PURE__ */ React.createElement(
            "a",
            {
              href: "javascript:void(0)",
              className: "flex items-start gap-x-3.5 py-2.5 hover-bg-button rounded px-3 cursor-pointer",
              onClick: () => this.props.Action.unpublish(this.props.calc)
            },
            /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", className: "w-4 h-4 mt-0.5 flex-shrink-0 text-red-500" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M3.28 2.22a.75.75 0 0 0-1.06 1.06l14.5 14.5a.75.75 0 1 0 1.06-1.06l-1.745-1.745a10.029 10.029 0 0 0 3.3-4.38 1.651 1.651 0 0 0 0-1.185A10.004 10.004 0 0 0 9.999 3a9.956 9.956 0 0 0-4.744 1.194L3.28 2.22ZM7.752 6.69l1.092 1.092a2.5 2.5 0 0 1 3.374 3.373l1.091 1.092a4 4 0 0 0-5.557-5.557Z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { d: "m10.748 13.93 2.523 2.523a9.987 9.987 0 0 1-3.27.547c-4.258 0-7.894-2.66-9.337-6.41a1.651 1.651 0 0 1 0-1.186A10.007 10.007 0 0 1 2.839 6.02L6.07 9.252a4 4 0 0 0 4.678 4.678Z" })),
            /* @__PURE__ */ React.createElement("div", { className: "text-sm" }, /* @__PURE__ */ React.createElement("div", { className: "font-medium text-red-500" }, "Unpublish"), /* @__PURE__ */ React.createElement("div", { className: "text-xs text-color-default mt-0.5" }, "Remove public access"))
          ))
        ));
      }, "createShareDropdown");
      const createTextButton = /* @__PURE__ */ __name(() => {
        return /* @__PURE__ */ React.createElement(
          "button",
          {
            className: "inline-flex items-center justify-center gap-1 px-2 py-1 text-xs transition-all rounded tooltip text-color-default hover-text-color-active hover-bg-button focus:outline-none",
            "data-tip": "Export as text",
            onClick: this.clickTextButton.bind(this),
            "data-hs-overlay": "#hs-modal-copytext"
          },
          /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-4 h-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z" }))
        );
      }, "createTextButton");
      const createGoalseekButton = /* @__PURE__ */ __name((displayContent) => /* @__PURE__ */ React.createElement("div", { className: "relative inline-flex" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          id: this.getDOMID("hs-dropdown-goalseek", true),
          type: "button",
          onClick: this.clickGoalseekButton.bind(this),
          className: "inline-flex items-center justify-center gap-2 px-2 py-1 text-xs capitalize align-middle transition-all border rounded-md shadow-sm border-color-soft tooltip text-color-default hover-text-color-active hs-dropdown-toggle hover-bg-button focus:outline-none",
          "data-tip": "Find variables that reach a desired goal",
          "data-hs-overlay": "#hs-modal-goalseek"
        },
        displayContent
      )), "createGoalseekButton");
      const createLocaleButton = /* @__PURE__ */ __name((displayContent) => /* @__PURE__ */ React.createElement("div", { id: this.getDOMID("region-dropdown", true), className: "relative inline-flex hs-dropdown [--Xtrigger:hover]" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          id: this.getDOMID("hs-dropdown-locale", true),
          type: "button",
          className: "flex items-center justify-center gap-1 px-2 py-1 text-xs capitalize align-middle transition-all border rounded-md shadow-sm border-color-soft tooltip text-color-default hover-text-color-active hs-dropdown-toggle hover-bg-button focus:outline-none",
          "data-tip": "Set number display format"
        },
        displayContent
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "hs-dropdown-menu z-[60] transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden min-w-[10rem] bg-secondary shadow-md rounded-lg p-2 mt-2 dark:bg-gray-800 dark:border dark:border-gray-700 dark:divide-gray-700 after:h-4 after:absolute after:-bottom-4 after:left-0 after:w-full before:h-4 before:absolute before:-top-4 before:left-0 before:w-full",
          "aria-labelledby": "hs-dropdown-locale"
        },
        /* @__PURE__ */ React.createElement("div", { className: "text-xs font-medium text-center capitalize opacity-50 text-color-default" }, "Number format"),
        /* @__PURE__ */ React.createElement(
          "a",
          {
            href: "javascript:void(0)",
            className: (calc.locale == "en-US" ? "active" : "") + " flex text-sm items-center gap-x-3.5 py-2 hover-bg-button rounded px-3",
            onClick: () => this.props.Action.setLocale(this.props.calc, "en-US")
          },
          "123,456.78 (US)"
        ),
        /* @__PURE__ */ React.createElement(
          "a",
          {
            href: "javascript:void(0)",
            className: (calc.locale == "de-DE" ? "active" : "") + " flex text-sm items-center gap-x-3.5 py-2 hover-bg-button  rounded px-3",
            onClick: () => this.props.Action.setLocale(this.props.calc, "de-DE")
          },
          "123.456,78 (Europe)"
        ),
        /* @__PURE__ */ React.createElement(
          "a",
          {
            href: "javascript:void(0)",
            className: (calc.locale == "hi-IN" ? "active" : "") + " flex text-sm items-center gap-x-3.5 py-2 hover-bg-button  rounded px-3",
            onClick: () => this.props.Action.setLocale(this.props.calc, "hi-IN")
          },
          "1,23,456.78 (South Asia)"
        )
      )), "createLocaleButton");
      const createRoundingButton = /* @__PURE__ */ __name((displayContent) => /* @__PURE__ */ React.createElement("div", { id: this.getDOMID("rounding-dropdown", true), className: "relative inline-flex hs-dropdown [--Xtrigger:hover]" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          id: this.getDOMID("hs-dropdown-rounding", true),
          type: "button",
          className: "inline-flex items-center justify-center gap-2 px-2 py-1 text-xs capitalize align-middle transition-all border rounded-md shadow-sm border-color-soft tooltip text-color-default hover-text-color-active hs-dropdown-toggle hover-bg-button focus:outline-none",
          "data-tip": "Set decimals for rounding"
        },
        displayContent
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "hs-dropdown-menu z-[60] transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden min-w-[15rem] bg-secondary shadow-md rounded-lg p-2 mt-2 dark:bg-gray-800 dark:border dark:border-gray-700 dark:divide-gray-700 after:h-4 after:absolute after:-bottom-4 after:left-0 after:w-full before:h-4 before:absolute before:-top-4 before:left-0 before:w-full",
          "aria-labelledby": "hs-dropdown-rounding"
        },
        /* @__PURE__ */ React.createElement("div", { className: "text-xs font-medium text-center capitalize opacity-50 text-color-default" }, "Round to nearest"),
        /* @__PURE__ */ React.createElement(
          "a",
          {
            href: "javascript:void(0)",
            className: ((calc.rounding === 0 || calc.rounding > 0) == false ? "active" : "") + " flex text-sm items-center gap-x-3.5 py-2 hover-bg-button rounded px-3",
            onClick: () => this.props.Action.setRounding(this.props.calc, -1)
          },
          "All"
        ),
        /* @__PURE__ */ React.createElement(
          "a",
          {
            href: "javascript:void(0)",
            className: (this.props.calc.rounding === 2 ? "active" : "") + " flex text-sm items-center gap-x-3.5 py-2 hover-bg-button rounded px-3",
            onClick: () => this.props.Action.setRounding(this.props.calc, 2)
          },
          "0.01"
        ),
        /* @__PURE__ */ React.createElement(
          "a",
          {
            href: "javascript:void(0)",
            className: (this.props.calc.rounding === 1 ? "active" : "") + " flex text-sm items-center gap-x-3.5 py-2 hover-bg-button rounded px-3",
            onClick: () => this.props.Action.setRounding(this.props.calc, 1)
          },
          "0.1"
        ),
        /* @__PURE__ */ React.createElement(
          "a",
          {
            href: "javascript:void(0)",
            className: (this.props.calc.rounding === 0 ? "active" : "") + " flex text-sm items-center gap-x-3.5 py-2 hover-bg-button rounded px-3",
            onClick: () => this.props.Action.setRounding(this.props.calc, 0)
          },
          "1"
        )
      )), "createRoundingButton");
      const createFormatButton = /* @__PURE__ */ __name((displayContent) => {
        return /* @__PURE__ */ React.createElement(FormatDropdown, { Action: this.props.Action, customDisplayContent: displayContent });
      }, "createFormatButton");
      const createPresentButton = /* @__PURE__ */ __name((displayContent) => /* @__PURE__ */ React.createElement("div", { id: this.getDOMID("present-dropdown", true), className: "relative inline-flex" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "inline-flex items-center justify-center gap-2 px-2 py-1 text-xs capitalize align-middle transition-all border rounded-md shadow-sm border-color-soft tooltip text-color-default hover-text-color-active hs-dropdown-toggle hover-bg-button focus:outline-none min-w-[92px]",
          "data-tip": `Enter ${this.props.Action.shouldHideRows(this.props.calc) ? "display mode" : "calc mode"} (${this.props.Action.shouldHideRows(this.props.calc) ? "collapse" : "expand"} all rows)`,
          onClick: () => this.props.Action.presentCalc(this.props.calc)
        },
        displayContent
      )), "createPresentButton");
      var addrows_button = /* @__PURE__ */ React.createElement(
        "button",
        {
          className: getButtonStyles(),
          "data-tip": "Add 5 rows",
          onClick: () => this.props.Action.addRows(this.props.calc, 5)
        },
        /* @__PURE__ */ React.createElement("svg", { className: "w-4 h-4", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React.createElement("path", { d: "M17 19V11M3 11H13M3 7H13M3 15H9M13 15H21", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" })),
        /* @__PURE__ */ React.createElement("span", null, "Rows")
      );
      var clear_button = /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("a", { href: "javascript:void(0)", className: "flex items-center gap-1 tooltip right", "data-tip": "Clear all rows", onClick: () => this.props.Action.clear(this.props.calc) }, /* @__PURE__ */ React.createElement("svg", { className: "w-4 h-4", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" })), "AC"));
      let historyModal = /* @__PURE__ */ React.createElement(HistoryModal, { id: this.getDOMID("hs-modal-history"), calc: this.props.calc, Action: this.props.Action, clickCount: this.state.historyButtonClicks });
      LIB.tryToRender(historyModal, "HistoryModal");
      var reset_button = /* @__PURE__ */ React.createElement("div", { className: "items-center space-x-2" }, /* @__PURE__ */ React.createElement("a", { href: "javascript:location.reload()", className: "flex items-center tooltip right", "data-tip": "Discard your changes and reload" }, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "inline-block w-4 h-4 mr-1" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99" })), "reset"));
      var locale = this.props.calc.locale || "en-US";
      var localeName = "US";
      if (locale == "de-DE") {
        localeName = "Europe";
      }
      if (locale == "hi-IN") {
        localeName = "Asia";
      }
      var locale_enabled = this.props.Action.isLegacyCalc(calc) === false;
      var rounding_enabled = false;
      if (this.props.calc.rounding === 0 || this.props.calc.rounding > 0) {
        rounding_enabled = true;
      }
      var url_section = null;
      if (isPublished) {
        var url = this.props.Action.getPublicURL(calc);
        var display_url = url.replace("https://", "");
        if (display_url[0] == "/") {
          display_url = "instacalc.com" + display_url;
        }
        if (url[0] == "/") {
          url = "https://instacalc.com" + url;
        }
        url_section = /* @__PURE__ */ React.createElement(
          "a",
          {
            href: url,
            className: "p-1 lowercase publish tooltip copy-event min-w-[8rem] text-center",
            title: "Click to copy public URL: " + url,
            "data-tip": "Click to copy public URL",
            "data-clipboard-text": url,
            onClick: (e) => {
              e.preventDefault();
              this.copyURL();
            }
          },
          /* @__PURE__ */ React.createElement("span", { className: "xurl-in-button" }, this.state.copiedURL ? "URL COPIED" : display_url)
        );
      }
      var publish_button = isPublished ? /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "relative inline-flex items-center justify-center gap-1 text-xs capitalize align-middle rounded text-color-default hover-text-color-active tooltip tooltip-info highlight hover-bg-button",
          "data-tip": "Unpublish and clear public version",
          title: "Unpublish this calc",
          onClick: () => this.props.Action.unpublish(this.props.calc)
        },
        /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", fill: "currentColor", className: "inline-block size-4" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M3.28 2.22a.75.75 0 0 0-1.06 1.06l14.5 14.5a.75.75 0 1 0 1.06-1.06l-1.745-1.745a10.029 10.029 0 0 0 3.3-4.38 1.651 1.651 0 0 0 0-1.185A10.004 10.004 0 0 0 9.999 3a9.956 9.956 0 0 0-4.744 1.194L3.28 2.22ZM7.752 6.69l1.092 1.092a2.5 2.5 0 0 1 3.374 3.373l1.091 1.092a4 4 0 0 0-5.557-5.557Z", clipRule: "evenodd" }), /* @__PURE__ */ React.createElement("path", { d: "m10.748 13.93 2.523 2.523a9.987 9.987 0 0 1-3.27.547c-4.258 0-7.894-2.66-9.337-6.41a1.651 1.651 0 0 1 0-1.186A10.007 10.007 0 0 1 2.839 6.02L6.07 9.252a4 4 0 0 0 4.678 4.678Z" }))
      ) : /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "inline-flex items-center justify-center gap-1 px-2 py-1 text-xs capitalize align-middle rounded shadow-md text-color-highlight hover-text-color-active bg-highlight tooltip tooltip-info publish highlight hover-bg-button",
          "data-tip": "Get a public link/embed code.",
          title: "Get a link to share this calc",
          onClick: () => this.props.Action.publish(this.props.calc)
        },
        /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "inline-block w-4 h-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" })),
        "Public link"
      );
      var add_button = /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "flex items-center px-3 py-1 text-xs rounded shadow-md text-color-highlight bg-highlight tooltip tooltip-info publish highlight hover-bg-button hover-text-color-active",
          "data-tip": "Add this calc to your personal list to save changes",
          onClick: () => this.props.Action.savePublic(this.props.calc)
        },
        /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", fill: "currentColor", className: "inline-block w-4 h-4 mr-1" }, /* @__PURE__ */ React.createElement("path", { d: "M11.645 20.91l-.007-.003-.022-.012a15.247 15.247 0 01-.383-.218 25.18 25.18 0 01-4.244-3.17C4.688 15.36 2.25 12.174 2.25 8.25 2.25 5.322 4.714 3 7.688 3A5.5 5.5 0 0112 5.052 5.5 5.5 0 0116.313 3c2.973 0 5.437 2.322 5.437 5.25 0 3.925-2.438 7.111-4.739 9.256a25.175 25.175 0 01-4.244 3.17 15.247 15.247 0 01-.383.219l-.022.012-.007.004-.003.001a.752.752 0 01-.704 0l-.003-.001z" })),
        "Save"
      );
      let locale_button = createLocaleButton(
        /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            strokeWidth: "1.5",
            stroke: "currentColor",
            width: "16",
            height: "16"
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              strokeLinecap: "round",
              strokeLinejoin: "round",
              d: "M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
            }
          )
        ), localeName, /* @__PURE__ */ React.createElement(
          "svg",
          {
            className: "hidden hs-dropdown-open:rotate-180 w-2.5 h-2.5 text-gray-600",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              d: "M2 5L8.16086 10.6869C8.35239 10.8637 8.64761 10.8637 8.83914 10.6869L15 5",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round"
            }
          )
        ))
      );
      let rounding_button = createRoundingButton(
        /* @__PURE__ */ React.createElement(React.Fragment, null, rounding_enabled ? `Round: ${Math.pow(10, -this.props.calc.rounding)}` : "Round: All", /* @__PURE__ */ React.createElement(
          "svg",
          {
            className: "hidden hs-dropdown-open:rotate-180 w-2.5 h-2.5 text-gray-600",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              d: "M2 5L8.16086 10.6869C8.35239 10.8637 8.64761 10.8637 8.83914 10.6869L15 5",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round"
            }
          )
        ))
      );
      let format_button = createFormatButton(
        /* @__PURE__ */ React.createElement(React.Fragment, null, "Format", /* @__PURE__ */ React.createElement(
          "svg",
          {
            className: "hs-dropdown-open:rotate-180 w-2.5 h-2.5 text-gray-600",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          },
          /* @__PURE__ */ React.createElement(
            "path",
            {
              d: "M2 5L8.16086 10.6869C8.35239 10.8637 8.64761 10.8637 8.83914 10.6869L15 5",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round"
            }
          )
        ))
      );
      let show_display_mode = this.props.Action.shouldHideRows(this.props.calc);
      let present_button = createPresentButton(
        /* @__PURE__ */ React.createElement(React.Fragment, null, show_display_mode && /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-4 h-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M3.75 3v11.25A2.25 2.25 0 006 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0118 16.5h-2.25m-7.5 0h7.5m-7.5 0l-1 3m8.5-3l1 3m0 0l.5 1.5m-.5-1.5h-9.5m0 0l-.5 1.5M9 11.25v1.5M12 9v3.75m3-6v6" })), !show_display_mode && /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-4 h-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M15.75 15.75V18m-7.5-6.75h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V13.5zm0 2.25h.008v.008H8.25v-.008zm0 2.25h.008v.008H8.25V18zm2.498-6.75h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V13.5zm0 2.25h.007v.008h-.007v-.008zm0 2.25h.007v.008h-.007V18zm2.504-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zm0 2.25h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V18zm2.498-6.75h.008v.008h-.008v-.008zm0 2.25h.008v.008h-.008V13.5zM8.25 6h7.5v2.25h-7.5V6zM12 2.25c-1.892 0-3.758.11-5.593.322C5.307 2.7 4.5 3.65 4.5 4.757V19.5a2.25 2.25 0 002.25 2.25h10.5a2.25 2.25 0 002.25-2.25V4.757c0-1.108-.806-2.057-1.907-2.185A48.507 48.507 0 0012 2.25z" })), show_display_mode ? "Display" : "Calc")
      );
      let public_url = this.props.Action.getPublicURL(this.props.calc);
      let plaintext_button = /* @__PURE__ */ React.createElement("div", { className: "relative inline-flex" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          id: this.getDOMID("hs-dropdown-copytext", true),
          type: "button",
          onClick: this.clickTextButton.bind(this),
          className: "inline-flex items-center justify-center gap-2 px-2 py-1 text-xs capitalize align-middle transition-all border rounded-md shadow-sm border-color-soft tooltip text-color-default hover-text-color-active hs-dropdown-toggle hover-bg-button focus:outline-none",
          "data-tip": "Get plaintext version (for email, forums)",
          "data-hs-overlay": "#hs-modal-copytext"
        },
        "Text"
      ));
      let copyTextModal = /* @__PURE__ */ React.createElement(ICModal, { id: "hs-modal-copytext", title: "Plain Text", closeIcon: true }, /* @__PURE__ */ React.createElement("div", { className: "relative p-2 mt-2 normal-case min-w-md bg-secondary" }, /* @__PURE__ */ React.createElement("pre", { className: "text-xs min-w-[40vw] max-w-[90vw] font-mono py-2 px-4 overflow-auto", id: `copy-text-${this.props.calc.id}` }, this.props.calc.name, "\n\n", this.state.textView, public_url ? "\n---\n" + public_url : ""), /* @__PURE__ */ React.createElement("div", { className: "absolute p-1 pt-2 text-xs right-10 -top-12" }, /* @__PURE__ */ React.createElement(CopyButton, { target: `#copy-text-${this.props.calc.id}` })), /* @__PURE__ */ React.createElement("div", { className: "absolute p-1 pt-2 text-xs left-2 -top-[3.25rem]" }, /* @__PURE__ */ React.createElement(
        "select",
        {
          className: "px-2 py-1 text-xs capitalize align-middle border rounded-md shadow-sm border-color-soft text-color-default hover-text-color-active hover-bg-button focus:outline-none",
          value: this.state.textViewStyle,
          onChange: (e) => {
            this.setState({ textViewStyle: e.target.value, textView: this.props.Action.getTextView(this.props.calc, e.target.value) });
          }
        },
        /* @__PURE__ */ React.createElement("option", { value: "" }, "inputs + results"),
        /* @__PURE__ */ React.createElement("option", { value: "inputs" }, "inputs"),
        /* @__PURE__ */ React.createElement("option", { value: "resultsAll" }, "results"),
        /* @__PURE__ */ React.createElement("option", { value: "results" }, "results (number only)")
      ))));
      LIB.tryToRender(copyTextModal, "CopyTextModal");
      let goalseek_button = createGoalseekButton(
        /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            strokeWidth: "1.5",
            stroke: "currentColor",
            width: "16",
            height: "16"
          },
          /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M12.33 3H12a9 9 0 1 0 9 9c0-.11 0-.22 0-.33M16.9 13A5 5 0 1 1 11 7.1M15 6V9h3l3-3H18V3M15 9l-2.5 2.5" })
        ), "Goal seek")
      );
      let goalseekModal = /* @__PURE__ */ React.createElement(
        GoalseekModal,
        {
          calc: this.props.calc,
          Action: this.props.Action,
          clickCount: this.state.goalseekButtonClicks
        }
      );
      LIB.tryToRender(goalseekModal, "GoalseekModal");
      var iframe = '<iframe src="' + Action.getEmbedURL(this.props.calc) + '" width="450" height="350" frameborder="0"></iframe>';
      let embed_button = ToolbarButton.createEmbed(
        this,
        /* @__PURE__ */ React.createElement("div", { className: "flex items-center gap-1" }, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: "1.5", stroke: "currentColor", className: "w-4 h-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M17.25 6.75 22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3-4.5 16.5" })), /* @__PURE__ */ React.createElement("span", null, "Embed"))
      );
      let copyEmbedModal = /* @__PURE__ */ React.createElement(ICModal, { id: "hs-modal-copyembed", title: "HTML Embed Code", closeIcon: true }, /* @__PURE__ */ React.createElement("div", { className: "relative flex flex-col items-center p-2 mt-2 normal-case lg:min-w-lg bg-secondary" }, /* @__PURE__ */ React.createElement("div", { className: "flex w-full align-middle border rounded border-color-soft" }, this.state.embedCalcId == this.props.calc.id && /* @__PURE__ */ React.createElement("textarea", { readOnly: true, className: "flex p-2 font-mono text-xs grow bg-secondary", id: `copy-embed-${this.props.calc.id}`, "data-embed": this.props.selected }, iframe), /* @__PURE__ */ React.createElement("div", { className: "absolute p-1 pt-2 text-xs right-10 -top-12" }, /* @__PURE__ */ React.createElement(CopyButton, { target: `#copy-embed-${this.props.calc.id}` }))), this.state.embedCalcId == this.props.calc.id && /* @__PURE__ */ React.createElement(
        "iframe",
        {
          src: Action.getEmbedURL(calc).replace("https://instacalc.com", ""),
          width: "450",
          height: "350",
          frameborder: "0"
        }
      )));
      LIB.tryToRender(copyEmbedModal, "CopyEmbedModal");
      if (this.props.layout == "single") {
        let mobileSharedMeta = /* @__PURE__ */ React.createElement("div", { className: "flex items-center justify-between w-full p-3 pb-4 text-xs capitalize" }, /* @__PURE__ */ React.createElement("a", { href: "/", className: "flex items-center text-color-default" }, /* @__PURE__ */ React.createElement(
          "svg",
          {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            strokeWidth: 1.5,
            stroke: "currentColor",
            className: "inline-block w-4 h-4 mr-1"
          },
          /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M10 19l-7-7m0 0l7-7m-7 7h18" })
        ), "Back"), this.state.isPublic ? reset_button : clear_button, this.state.isPublic ? add_button : null);
        LIB.tryToRender(mobileSharedMeta, "MobileSharedMeta");
      }
      const toolbarContent = this.renderRefinedToolbar({
        addrows_button,
        clear_button,
        reset_button,
        goalseek_button,
        locale_enabled,
        locale_button,
        rounding_button,
        format_button,
        present_button,
        plaintext_button,
        isPublished,
        embed_button,
        add_button,
        publish_button,
        url_section,
        createShareDropdown,
        createTextButton
      });
      return /* @__PURE__ */ React.createElement("calcmeta", { "x-data": "{}", className: (this.props.layout == "single" ? "hidden lg:block" : "block") + " w-auto px-4 py-0 text-xs rounded-b-lg lg:py-2 lg:relative _bg-secondary lg:bg-default" }, toolbarContent);
    }
  };
  var CopyButton = class extends React.Component {
    static {
      __name(this, "CopyButton");
    }
    constructor(props) {
      super(props);
      this.state = {
        message: this.props.message
      };
    }
    onCopy() {
      this.setState({ message: "copied!" });
      setTimeout(() => {
        this.setState({ message: null });
      }, 2e3);
    }
    render() {
      let message = /* @__PURE__ */ React.createElement("div", { className: "inline-block mx-2" }, this.state.message);
      return /* @__PURE__ */ React.createElement("button", { className: "flex copy-event tooltip", "data-tip": "Click to copy", "data-clipboard-target": this.props.target, onClick: this.onCopy.bind(this) }, this.state.message && message, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "w-4 h-4" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" })));
    }
  };
  var CalcInfo = class extends React.Component {
    static {
      __name(this, "CalcInfo");
    }
    render() {
      let isLegacy = this.props.Action.isLegacyCalc(this.props.calc);
      let msg = "";
      let upgradeButton = /* @__PURE__ */ React.createElement(
        "a",
        {
          href: "javascript:void(0)",
          className: "upgrade",
          title: "upgrade this calc to v2",
          onClick: () => this.props.Action.upgrade(this.props.calc)
        },
        "UPGRADE LEGACY CALC"
      );
      if (isLegacy) {
        msg = /* @__PURE__ */ React.createElement("div", { className: "inline-block pt-3 tooltip", "data-tip": "This calc is on the older v1 engine. Click to upgrade." }, upgradeButton, /* @__PURE__ */ React.createElement("a", { href: "https://github.com/kazad/instacalc/wiki/Legacy-Calcs", target: "_blank" }, "learn more"));
      } else {
        UIlog("[Row]", this.props.index, "expanded view regular result path");
        msg = /* @__PURE__ */ React.createElement("span", { className: "tooltip", "data-tip": "Learn about instacalc v2 features" }, /* @__PURE__ */ React.createElement("a", { href: "https://github.com/kazad/instacalc/wiki/InstaCalc-V2", target: "_blank" }, "v2"));
        msg = null;
      }
      return /* @__PURE__ */ React.createElement("info", { className: "inline-block w-full px-4 text-xs text-right text-color-default" }, msg);
    }
  };
  var HistoryChangeSummary = class extends React.Component {
    static {
      __name(this, "HistoryChangeSummary");
    }
    render() {
      const { rawEntry, label } = this.props;
      const changeLabel = label || "What changed";
      if (!rawEntry || !rawEntry.patch) {
        return /* @__PURE__ */ React.createElement("div", { className: "overflow-hidden border rounded-lg border-color-soft bg-secondary" }, /* @__PURE__ */ React.createElement("div", { className: "p-3 text-sm opacity-75 text-color-default" }, "Loading..."));
      }
      const { patch } = rawEntry;
      if (patch.type === "full") {
        return /* @__PURE__ */ React.createElement("div", { className: "overflow-hidden border rounded-lg border-color-soft bg-secondary" }, /* @__PURE__ */ React.createElement("div", { className: "p-3 text-sm opacity-75 text-color-default" }, "Initial state (no previous version)"));
      }
      const patches = patch.patches || [];
      if (patches.length === 0) {
        return /* @__PURE__ */ React.createElement("div", { className: "overflow-hidden border rounded-lg border-color-soft bg-secondary" }, /* @__PURE__ */ React.createElement("div", { className: "p-3 text-sm opacity-75 text-color-default" }, "No changes"));
      }
      const formatPatch = /* @__PURE__ */ __name((patch2) => {
        const { op, path, value } = patch2;
        const rowObjectMatch = path.match(/^\/rows\/(\d+)$/);
        const rowFieldMatch = path.match(/^\/rows\/(\d+)\/(.+)$/);
        if (rowObjectMatch) {
          const rowIndex = parseInt(rowObjectMatch[1]);
          const rowNumber = rowIndex + 1;
          if (op === "add") {
            if (value && value.text && value.text.trim()) {
              return { label: `R${rowNumber}`, value: value.text, icon: "+" };
            }
            return { label: `R${rowNumber} added`, value: null, icon: "+" };
          } else if (op === "remove") {
            return { label: `R${rowNumber} removed`, value: null, icon: "\u2212" };
          } else if (op === "replace" && typeof value === "object" && value !== null) {
            if (!value.text || value.text.trim() === "") {
              return { label: `R${rowNumber} cleared`, value: null, icon: "\xD7" };
            }
            return { label: `R${rowNumber}`, value: value.text, icon: "~" };
          }
        }
        if (rowFieldMatch) {
          const rowIndex = parseInt(rowFieldMatch[1]);
          const rowNumber = rowIndex + 1;
          const field = rowFieldMatch[2];
          if (field === "text") {
            if (value === "" || value === null) {
              return { label: `R${rowNumber} cleared`, value: null, icon: "\xD7" };
            }
            return { label: `R${rowNumber}`, value, icon: "~" };
          } else if (field === "hidden") {
            const visibility = value ? "hidden" : "visible";
            return { label: `R${rowNumber}`, value: visibility, icon: "\u25D0" };
          }
          return { label: `R${rowNumber} \u2192 ${field}`, value, icon: "~" };
        }
        const label2 = path.replace(/^\//, "").replace(/\//g, " \u2192 ");
        return { label: label2, value, icon: null };
      }, "formatPatch");
      const formatValue = /* @__PURE__ */ __name((value) => {
        if (value === null || value === void 0) return "";
        if (typeof value === "object") {
          return JSON.stringify(value);
        }
        return String(value);
      }, "formatValue");
      const getOpColor = /* @__PURE__ */ __name((op) => {
        switch (op) {
          case "add":
            return "text-emerald-600";
          case "remove":
            return "text-red-600";
          case "replace":
            return "text-amber-600";
          default:
            return "text-color-default";
        }
      }, "getOpColor");
      const getOpSymbol = /* @__PURE__ */ __name((op) => {
        switch (op) {
          case "add":
            return "+";
          case "remove":
            return "\u2212";
          case "replace":
            return "~";
          default:
            return "\u2022";
        }
      }, "getOpSymbol");
      return /* @__PURE__ */ React.createElement("div", { className: "overflow-hidden border rounded-lg border-color-soft bg-secondary" }, /* @__PURE__ */ React.createElement("div", { className: "p-3 font-mono text-[13px] leading-relaxed" }, /* @__PURE__ */ React.createElement("div", { className: "grid grid-cols-[1rem_1fr] gap-x-3 gap-y-1" }, patches.map((p, idx) => {
        const formatted = formatPatch(p);
        const icon = formatted.icon || getOpSymbol(p.op);
        const color = formatted.icon ? getOpColor(p.op) : getOpColor(p.op);
        return [
          /* @__PURE__ */ React.createElement("span", { key: idx + "-op", className: color }, icon),
          /* @__PURE__ */ React.createElement("code", { key: idx + "-code", className: "text-color-default" }, formatted.label, formatted.value !== null && formatted.value !== void 0 && /* @__PURE__ */ React.createElement("span", null, " \u2192 ", /* @__PURE__ */ React.createElement("span", { className: "font-semibold" }, formatValue(formatted.value))))
        ];
      }))));
    }
  };
  var HistoryCalcPreview = class extends React.Component {
    static {
      __name(this, "HistoryCalcPreview");
    }
    constructor(props) {
      super(props);
      this.state = {
        results: []
      };
    }
    componentDidMount() {
      this.executeSnapshot();
    }
    componentDidUpdate(prevProps) {
      if (prevProps.snapshot !== this.props.snapshot) {
        this.executeSnapshot();
      }
    }
    executeSnapshot() {
      if (!this.props.snapshot || !this.props.snapshot.rows) {
        this.setState({ results: [] });
        return;
      }
      try {
        const rowTexts = this.props.snapshot.rows.filter((row) => row).map((row) => row.text || "");
        const resultData = IC.parser.executeRows(rowTexts);
        const results = resultData.results || resultData || [];
        this.setState({ results: Array.isArray(results) ? results : [] });
      } catch (e) {
        console.error("Error executing history snapshot:", e);
        this.setState({ results: [] });
      }
    }
    // Extract which rows were changed from the patches and their operation types
    getChangedRows() {
      const { rawEntry } = this.props;
      const changedRows = /* @__PURE__ */ new Map();
      if (!rawEntry || !rawEntry.patch || rawEntry.patch.type !== "patch") {
        return changedRows;
      }
      const patches = rawEntry.patch.patches || [];
      patches.forEach((patch) => {
        const rowMatch = patch.path.match(/^\/rows\/(\d+)/);
        if (rowMatch) {
          const rowIndex = parseInt(rowMatch[1]);
          changedRows.set(rowIndex, patch.op);
        }
      });
      return changedRows;
    }
    // Get dot color class based on operation type
    getOpDotColor(op) {
      switch (op) {
        case "add":
          return "bg-emerald-600";
        case "remove":
          return "bg-red-600";
        case "replace":
          return "bg-amber-600";
        default:
          return "";
      }
    }
    render() {
      const { snapshot } = this.props;
      const { results } = this.state;
      if (!snapshot || !snapshot.rows) {
        return /* @__PURE__ */ React.createElement("div", { className: "text-sm opacity-50 text-color-default" }, "No data to display");
      }
      const rows = snapshot.rows.filter((row) => row);
      const lineCount = rows.length;
      const changedRows = this.getChangedRows();
      return /* @__PURE__ */ React.createElement("div", { className: "flex gap-2 text-sm" }, /* @__PURE__ */ React.createElement("div", { className: "flex w-1/2 min-w-0" }, /* @__PURE__ */ React.createElement("div", { className: "select-none pr-2 text-[68.75%] opacity-60" }, rows.map((row, idx) => {
        const op = changedRows.get(idx);
        const dotColor = op ? this.getOpDotColor(op) : "";
        return /* @__PURE__ */ React.createElement("div", { key: idx, style: { height: "27px", lineHeight: "27px" }, className: "relative" }, dotColor && /* @__PURE__ */ React.createElement("span", { className: `absolute left-0 top-1/2 -translate-y-1/2 -translate-x-2 w-1 h-1 rounded-full ${dotColor}` }), /* @__PURE__ */ React.createElement("span", null, "R", idx + 1));
      })), /* @__PURE__ */ React.createElement("div", { className: "flex-1 pr-2 border-r text-color-default border-color-soft min-w-0" }, rows.map((row, idx) => /* @__PURE__ */ React.createElement(
        "div",
        {
          key: idx,
          style: { height: "27px", lineHeight: "27px" },
          className: "whitespace-nowrap overflow-x-auto no-scrollbar"
        },
        row.text || ""
      )))), /* @__PURE__ */ React.createElement("div", { className: "w-1/2 pl-2 min-w-0" }, results.map((result, idx) => /* @__PURE__ */ React.createElement(
        "div",
        {
          key: idx,
          style: { height: "27px", lineHeight: "27px" },
          className: "flex items-center gap-2 text-color-default overflow-x-auto whitespace-nowrap no-scrollbar"
        },
        result.result && /* @__PURE__ */ React.createElement("result", { className: "flex-shrink-0" }, LIB.prettyPrintResultHTML(
          typeof result.result === "object" ? IC.api.formatValue(result.result) : result.result
        )),
        result.type && /* @__PURE__ */ React.createElement("type", { className: "flex-shrink-0 opacity-60" }, result.type),
        typeof result.comment === "string" && result.comment && /* @__PURE__ */ React.createElement("comment", { className: "flex-shrink-0 opacity-75" }, result.comment)
      ))));
    }
  };
  var HistoryModal = class extends React.Component {
    static {
      __name(this, "HistoryModal");
    }
    constructor(props) {
      super(props);
      this.state = {
        history: [],
        selectedIndex: null,
        previewSnapshot: null,
        rawHistoryEntry: null,
        showChanges: false,
        showRawJson: false
      };
      this.toggleChanges = this.toggleChanges.bind(this);
      this.toggleRawJson = this.toggleRawJson.bind(this);
    }
    toggleChanges() {
      this.setState({ showChanges: !this.state.showChanges });
    }
    toggleRawJson() {
      this.setState({ showRawJson: !this.state.showRawJson });
    }
    getChangeCount(rawEntry) {
      if (!rawEntry || !rawEntry.patch) return 0;
      if (rawEntry.patch.type === "full") return "Full snapshot";
      const patches = rawEntry.patch.patches || [];
      return patches.length;
    }
    // Get changes for display - either unsaved changes or the patch that created this revision
    getChangesFromHistory(displayIndex) {
      if (displayIndex === 0) {
        const manager = this.props.Action.getHistoryManager(this.props.calc);
        if (!manager || !manager.canUndo()) return null;
        return manager.getDiffToCurrent(0);
      }
      return this.state.rawHistoryEntry;
    }
    componentDidMount() {
      this.loadHistory();
    }
    componentDidUpdate(prevProps) {
      if (prevProps.clickCount !== this.props.clickCount) {
        this.loadHistory();
      }
    }
    loadHistory() {
      if (!this.props.Action || !this.props.Action.getHistory) {
        console.error("Action or getHistory not available");
        return;
      }
      const historyStack = this.props.Action.getHistory();
      const liveEntry = {
        index: -1,
        timestamp: (/* @__PURE__ */ new Date()).toISOString(),
        operation: "current",
        isLive: true
      };
      const history = [liveEntry, ...historyStack];
      this.setState({
        history,
        selectedIndex: 1,
        // Select first history entry by default
        previewSnapshot: null
      }, () => {
        if (this.state.selectedIndex !== null) {
          this.loadPreview(this.state.selectedIndex);
        }
      });
    }
    loadPreview(displayIndex) {
      if (!this.props.Action || !this.props.Action.getHistorySnapshot) {
        return;
      }
      const entry = this.state.history[displayIndex];
      if (entry && entry.isLive) {
        this.setState({
          selectedIndex: displayIndex,
          previewSnapshot: this.props.calc,
          rawHistoryEntry: null
        });
        return;
      }
      const historyIndex = displayIndex - 1;
      const snapshot = this.props.Action.getHistorySnapshot(historyIndex);
      const rawEntry = this.props.Action.getHistoryEntry ? this.props.Action.getHistoryEntry(historyIndex) : null;
      this.setState({
        selectedIndex: displayIndex,
        previewSnapshot: snapshot,
        rawHistoryEntry: rawEntry
      });
    }
    formatTime(timestamp) {
      const date = new Date(timestamp);
      return date.toLocaleString();
    }
    // Group history entries by time buckets
    groupHistoryByTime(history) {
      const now = /* @__PURE__ */ new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
      const groups = {
        "Today": [],
        "Yesterday": [],
        "Last 7 days": [],
        "Earlier": []
      };
      history.forEach((entry) => {
        const entryDate = new Date(entry.timestamp);
        const entryDay = new Date(entryDate.getFullYear(), entryDate.getMonth(), entryDate.getDate());
        if (entryDay.getTime() === today.getTime()) {
          groups["Today"].push(entry);
        } else if (entryDay.getTime() === yesterday.getTime()) {
          groups["Yesterday"].push(entry);
        } else if (entryDate >= sevenDaysAgo) {
          groups["Last 7 days"].push(entry);
        } else {
          UIlog("[Row]", this.props.index, "expanded view regular result path");
          UIlog("[Row]", this.props.index, "rendering default result in collapsed output");
          groups["Earlier"].push(entry);
        }
      });
      Object.keys(groups).forEach((key) => {
        if (groups[key].length === 0) {
          delete groups[key];
        }
      });
      return groups;
    }
    // Smart formatting based on time bucket (similar to Util.displayDate)
    formatHistoryTime(timestamp, groupName) {
      const date = new Date(timestamp);
      if (groupName === "Today") {
        return date.toLocaleTimeString([], {
          hour: "numeric",
          minute: "2-digit",
          second: "2-digit"
        });
      } else if (groupName === "Yesterday") {
        return date.toLocaleTimeString([], {
          hour: "numeric",
          minute: "2-digit",
          second: "2-digit"
        });
      } else if (groupName === "Last 7 days") {
        const dayName = date.toLocaleDateString([], { weekday: "short" });
        const time = date.toLocaleTimeString([], {
          hour: "numeric",
          minute: "2-digit",
          second: "2-digit"
        });
        return `${dayName} ${time}`;
      } else {
        UIlog("[Row]", this.props.index, "expanded view regular result path");
        return date.toLocaleDateString([], {
          day: "numeric",
          month: "2-digit",
          year: "2-digit"
        });
      }
    }
    restoreToVersion(displayIndex) {
      if (!this.props.Action || !this.props.Action.jumpToHistory) {
        return;
      }
      const historyIndex = displayIndex - 1;
      this.props.Action.jumpToHistory(historyIndex);
      this.loadHistory();
      const modalElement = document.getElementById(this.props.id);
      if (modalElement) {
        window.HSOverlay.close(modalElement);
      }
    }
    render() {
      const { history, selectedIndex, previewSnapshot } = this.state;
      return /* @__PURE__ */ React.createElement("div", { id: this.props.id, className: "hs-overlay hidden w-full h-full fixed top-0 start-0 z-[80] overflow-x-hidden overflow-y-auto pointer-events-none" }, /* @__PURE__ */ React.createElement("div", { className: "hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all max-w-4xl w-full m-3 mx-auto min-h-[calc(100%-3.5rem)] flex items-center" }, /* @__PURE__ */ React.createElement("div", { className: "flex flex-col w-full border shadow-sm pointer-events-auto bg-secondary border-color-soft rounded-xl" }, /* @__PURE__ */ React.createElement("div", { className: "flex items-center justify-between px-4 py-3" }, /* @__PURE__ */ React.createElement("h3", { className: "block w-full text-base font-bold text-center normal-case text-color-default" }, "Revision History"), /* @__PURE__ */ React.createElement("button", { type: "button", "data-hs-overlay": "#" + this.props.id }, /* @__PURE__ */ React.createElement("svg", { className: "w-3 h-3", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React.createElement("path", { d: "M0.258206 1.00652C0.351976 0.912791 0.479126 0.860131 0.611706 0.860131C0.744296 0.860131 0.871447 0.912791 0.965207 1.00652L3.61171 3.65302L6.25822 1.00652C6.30432 0.958771 6.35952 0.920671 6.42052 0.894471C6.48152 0.868271 6.54712 0.854471 6.61352 0.853901C6.67992 0.853321 6.74572 0.865971 6.80722 0.891111C6.86862 0.916251 6.92442 0.953381 6.97142 1.00032C7.01832 1.04727 7.05552 1.1031 7.08062 1.16454C7.10572 1.22599 7.11842 1.29183 7.11782 1.35822C7.11722 1.42461 7.10342 1.49022 7.07722 1.55122C7.05102 1.61222 7.01292 1.6674 6.96522 1.71352L4.31871 4.36002L6.96522 7.00648C7.05632 7.10078 7.10672 7.22708 7.10552 7.35818C7.10442 7.48928 7.05182 7.61468 6.95912 7.70738C6.86642 7.80018 6.74102 7.85268 6.60992 7.85388C6.47882 7.85498 6.35252 7.80458 6.25822 7.71348L3.61171 5.06702L0.965207 7.71348C0.870907 7.80458 0.744606 7.85498 0.613506 7.85388C0.482406 7.85268 0.357007 7.80018 0.264297 7.70738C0.171597 7.61468 0.119017 7.48928 0.117877 7.35818C0.116737 7.22708 0.167126 7.10078 0.258206 7.00648L2.90471 4.36002L0.258206 1.71352C0.164476 1.61976 0.111816 1.4926 0.111816 1.36002C0.111816 1.22744 0.164476 1.10028 0.258206 1.00652Z", fill: "currentColor" })))), /* @__PURE__ */ React.createElement("div", { className: "flex flex-col md:flex-row overflow-hidden no-scrollbar h-[90vh] md:h-[500px]" }, /* @__PURE__ */ React.createElement("div", { className: "w-full p-4 overflow-y-auto border-b h-1/3 md:h-auto md:w-1/3 md:border-b-0 border-color-soft" }, history.length === 0 ? /* @__PURE__ */ React.createElement("div", { className: "py-8 text-sm text-center opacity-50 text-color-default" }, "No history yet") : (() => {
        const groupedHistory = this.groupHistoryByTime(history);
        return /* @__PURE__ */ React.createElement("div", null, Object.entries(groupedHistory).map(([groupName, entries]) => /* @__PURE__ */ React.createElement("div", { key: groupName, className: "mb-4" }, /* @__PURE__ */ React.createElement("div", { className: "px-2 py-2 text-xs font-semibold tracking-wide uppercase opacity-60 text-color-default" }, groupName), /* @__PURE__ */ React.createElement("div", { className: "space-y-2" }, entries.map((entry) => {
          const actualIndex = history.indexOf(entry);
          const isSelected = selectedIndex === actualIndex;
          const isLive = entry.isLive;
          let changeCount = 0;
          if (!isLive) {
            const historyIndex = actualIndex - 1;
            const rawEntry = this.props.Action.getHistoryEntry ? this.props.Action.getHistoryEntry(historyIndex) : null;
            changeCount = this.getChangeCount(rawEntry);
          }
          return /* @__PURE__ */ React.createElement(
            "div",
            {
              key: actualIndex,
              className: `p-3 border rounded-lg cursor-pointer transition-colors ${isSelected ? "border-soft bg-default" : "border-color-soft hover-bg-button"}`,
              onClick: () => this.loadPreview(actualIndex)
            },
            /* @__PURE__ */ React.createElement("div", { className: "flex items-center justify-between gap-2" }, /* @__PURE__ */ React.createElement("div", { className: "text-sm font-medium text-color-default" }, this.formatHistoryTime(entry.timestamp, groupName)), isLive ? /* @__PURE__ */ React.createElement("span", { className: "px-2 py-0.5 text-xs rounded-full border border-soft bg-navlink text-color-calc flex-shrink-0" }, "current") : changeCount > 0 && /* @__PURE__ */ React.createElement("span", { className: "flex items-center flex-shrink-0 gap-1 text-xs opacity-50 text-color-default" }, changeCount, /* @__PURE__ */ React.createElement("svg", { className: "w-3 h-3", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2" }, /* @__PURE__ */ React.createElement("path", { d: "M12 2L2 22h20L12 2z", strokeLinecap: "round", strokeLinejoin: "round" }))))
          );
        })))));
      })()), /* @__PURE__ */ React.createElement("div", { className: "flex-1 p-4 overflow-y-auto h-2/3 md:h-auto bg-primary no-scrollbar" }, previewSnapshot ? /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "flex items-center justify-between h-10 mb-4" }, /* @__PURE__ */ React.createElement("h4", { className: "text-sm font-semibold text-color-default" }, previewSnapshot.name || "Untitled"), selectedIndex > 0 && /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "inline-flex items-center justify-center gap-2 px-2 py-1 text-sm font-semibold text-white transition-all border border-transparent rounded-md bg-destructive hover:ring-2",
          onClick: () => this.restoreToVersion(selectedIndex)
        },
        "Restore this version"
      )), /* @__PURE__ */ React.createElement("div", { className: "p-3 mb-4 border rounded-lg border-color-soft bg-secondary" }, /* @__PURE__ */ React.createElement(
        HistoryCalcPreview,
        {
          snapshot: previewSnapshot,
          rawEntry: this.getChangesFromHistory(selectedIndex)
        }
      )), selectedIndex >= 0 && /* @__PURE__ */ React.createElement("div", { className: "mb-4" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: this.toggleChanges,
          className: "flex items-center gap-2 mb-2 text-sm transition-opacity text-color-default opacity-80 hover:opacity-100"
        },
        /* @__PURE__ */ React.createElement("div", { className: (this.state.showChanges ? "" : "-rotate-90") + " transform transition duration-150" }, /* @__PURE__ */ React.createElement("svg", { className: "", fill: "none", height: "20", width: "20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", viewBox: "0 0 24 24" }, /* @__PURE__ */ React.createElement("polyline", { points: "6 9 12 15 18 9" }))),
        /* @__PURE__ */ React.createElement("span", null, (() => {
          const diffEntry = this.getChangesFromHistory(selectedIndex);
          const count = this.getChangeCount(diffEntry);
          if (count === "Full snapshot") return count;
          if (count === 0) return "No changes";
          return `${count} ${count === 1 ? "change" : "changes"} from previous version`;
        })())
      ), this.state.showChanges && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
        HistoryChangeSummary,
        {
          rawEntry: this.getChangesFromHistory(selectedIndex),
          label: selectedIndex === 0 ? "Current changes" : "What changed"
        }
      ), this.state.rawHistoryEntry && /* @__PURE__ */ React.createElement("div", { className: "hidden mt-3" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: this.toggleRawJson,
          className: "text-xs underline transition-opacity opacity-50 text-color-default hover:opacity-80"
        },
        this.state.showRawJson ? "Hide" : "View",
        " raw history entry"
      ), this.state.showRawJson && /* @__PURE__ */ React.createElement("div", { className: "mt-2 overflow-hidden border rounded-lg border-color-soft bg-primary" }, /* @__PURE__ */ React.createElement("pre", { className: "p-3 overflow-auto text-xs leading-relaxed max-h-72" }, /* @__PURE__ */ React.createElement("code", { className: "text-color-default" }, JSON.stringify(this.state.rawHistoryEntry, null, 2)))))))) : /* @__PURE__ */ React.createElement("div", { className: "py-8 text-sm text-center opacity-50 text-color-default" }, "Select a history entry to preview"))))));
    }
  };
  var GoalseekModal = class extends React.Component {
    static {
      __name(this, "GoalseekModal");
    }
    constructor(props) {
      super(props);
      this.state = {
        targetVariable: "",
        targetValue: "",
        adjustmentVars: {},
        // { varName: { currentValue, selected, solvedValue } }
        computedVars: {},
        // { varName: value }
        gsResult: null,
        dependencyMap: {},
        // { targetVar: [dependentVars] }
        newRowContents: null
      };
    }
    loadVariables() {
      let ic = this.props.Action?.currentInstaCalcReact;
      if (!ic) {
        ic = Embed?.currentInstaCalcReact;
      }
      if (!ic?.state.results) return;
      const adjustmentVars = {};
      const computedVars = {};
      ic.state.results.forEach((r, idx) => {
        let rowName = r.title;
        let isRawNumeric = false;
        if (!rowName && IC.api.canIncrement(r.input)) {
          rowName = `r${idx + 1}`;
          isRawNumeric = true;
        }
        if (!rowName) return;
        const rowParameter = IC.api.getParameterName(r.input);
        if (rowParameter || isRawNumeric) {
          adjustmentVars[rowParameter || rowName] = {
            selected: false,
            currentValue: r.result,
            solvedValue: null
          };
        } else {
          UIlog("[Row]", this.props.index, "expanded view regular result path");
          UIlog("[Row]", this.props.index, "rendering default result in collapsed output");
          computedVars[rowName] = r.result;
        }
      });
      const firstComputedVar = Object.keys(computedVars)[0];
      this.setState({
        adjustmentVars,
        computedVars,
        targetVariable: firstComputedVar || "",
        targetValue: firstComputedVar ? computedVars[firstComputedVar] : ""
      }, () => {
        if (firstComputedVar) {
          this.computeDependencies(firstComputedVar);
        }
      });
    }
    loadVariablesOld() {
      let ic = this.props.Action?.currentInstaCalcReact;
      if (!ic) {
        let ic2 = Embed?.currentInstaCalcReact;
      }
      if (!ic?.state.results) return;
      const adjustmentVars = {};
      const computedVars = {};
      ic.state.results.forEach((r) => {
        if (!r.title) return;
        const rowParameter = IC.api.getParameterName(r.input);
        if (rowParameter) {
          adjustmentVars[rowParameter] = {
            selected: false,
            currentValue: r.result,
            solvedValue: null
          };
        } else {
          UIlog("[Row]", this.props.index, "expanded view regular result path");
          UIlog("[Row]", this.props.index, "rendering default result in collapsed output");
          computedVars[r.title] = r.result;
        }
      });
      const firstComputedVar = Object.keys(computedVars)[0];
      this.setState({
        adjustmentVars,
        computedVars,
        targetVariable: firstComputedVar || "",
        targetValue: firstComputedVar ? computedVars[firstComputedVar] : ""
      }, () => {
        if (firstComputedVar) {
          this.computeDependencies(firstComputedVar);
        }
      });
    }
    componentDidMount() {
      this.loadVariables();
    }
    componentDidUpdate(prevProps) {
      if (prevProps.clickCount !== this.props.clickCount) {
        this.loadVariables();
      }
    }
    computeDependencies = /* @__PURE__ */ __name(async (targetVar) => {
      if (!targetVar) return;
      const cloneCalc = Object.assign({}, this.props.calc);
      const newRowContents = `solve ${targetVar} = ${this.state.targetValue || "0"}`;
      cloneCalc.rows = [...cloneCalc.rows, { text: newRowContents }];
      const newResults = this.props.Action.recalculate(cloneCalc);
      const result = newResults[newResults.length - 1].result;
      if (!result?.dependentVars) return;
      this.setState((prevState) => {
        const updatedAdjustmentVars = { ...prevState.adjustmentVars };
        Object.keys(updatedAdjustmentVars).forEach((varName) => {
          updatedAdjustmentVars[varName] = {
            ...updatedAdjustmentVars[varName],
            selected: result.dependentVars.includes(varName),
            solvedValue: null
          };
        });
        return {
          dependencyMap: {
            ...prevState.dependencyMap,
            [targetVar]: result.dependentVars
          },
          adjustmentVars: updatedAdjustmentVars
        };
      }, () => {
        if (this.state.targetValue) {
          this.computeGoalseek();
        }
      });
    }, "computeDependencies");
    computeGoalseek = /* @__PURE__ */ __name(() => {
      const { targetVariable, targetValue, adjustmentVars } = this.state;
      if (!targetVariable || !targetValue) return;
      const selectedVars = Object.entries(adjustmentVars).filter(([_, details]) => details.selected).map(([varName]) => varName);
      const cloneCalc = Object.assign({}, this.props.calc);
      const newRowContents = `solve ${targetVariable} = ${targetValue.replaceAll(",", "")} using ${selectedVars.join(", ")}`;
      cloneCalc.rows = [...cloneCalc.rows, { text: newRowContents }];
      const newResults = this.props.Action.recalculate(cloneCalc);
      const gsResult = newResults[newResults.length - 1].result;
      this.setState((prevState) => {
        const updatedAdjustmentVars = { ...prevState.adjustmentVars };
        if (gsResult?.vars) {
          Object.entries(gsResult.vars).forEach(([varName, value]) => {
            if (updatedAdjustmentVars[varName]) {
              updatedAdjustmentVars[varName].solvedValue = value;
            }
          });
        }
        return {
          gsResult,
          adjustmentVars: updatedAdjustmentVars,
          newRowContents
        };
      });
    }, "computeGoalseek");
    handleVariableChange = /* @__PURE__ */ __name((e) => {
      const newTarget = e.target.value;
      this.setState({
        targetVariable: newTarget,
        gsResult: null
      }, () => {
        this.computeDependencies(newTarget);
      });
    }, "handleVariableChange");
    handleTargetChange = /* @__PURE__ */ __name((e) => {
      this.setState({
        targetValue: e.target.value,
        gsResult: null
      }, this.computeGoalseek);
    }, "handleTargetChange");
    toggleAdjustmentVar = /* @__PURE__ */ __name((variable) => {
      this.setState((prevState) => ({
        adjustmentVars: {
          ...prevState.adjustmentVars,
          [variable]: {
            ...prevState.adjustmentVars[variable],
            selected: !prevState.adjustmentVars[variable].selected
          }
        },
        gsResult: null
      }), this.computeGoalseek);
    }, "toggleAdjustmentVar");
    handleApply = /* @__PURE__ */ __name(() => {
      const varsToSet = {};
      Object.entries(this.state.adjustmentVars).forEach(([varName, details]) => {
        varsToSet[varName] = details.selected ? details.solvedValue : details.currentValue;
      });
      LIB.setVariablesInCalc(this.props.Action, this.props.calc, varsToSet);
      const closeButton = document.querySelector(`button[data-hs-overlay="#hs-modal-goalseek"]`);
      if (closeButton) {
        closeButton.click();
      }
    }, "handleApply");
    handleInsertSolution = /* @__PURE__ */ __name(() => {
      this.props.Action.addRows(this.props.calc, 1);
      this.props.Action.updateRowText(this.props.calc, this.props.calc.rows.length - 1, this.state.newRowContents);
    }, "handleInsertSolution");
    // TODO: have it match the format for the incoming value
    formatNumber(parameterName, value = 0) {
      if (value == null) {
        return null;
      }
      return IC.api.formatNumber(value);
    }
    render() {
      const { targetVariable, targetValue, adjustmentVars, computedVars, gsResult, dependencyMap } = this.state;
      const dependencies = dependencyMap[targetVariable] || [];
      return /* @__PURE__ */ React.createElement(ICModal, { id: "hs-modal-goalseek", title: this.props.title || "Goal Seek (Beta)", closeIcon: true }, /* @__PURE__ */ React.createElement("div", { className: "px-6 min-h-40 min-w-1/2" }, /* @__PURE__ */ React.createElement("div", { className: "flex items-center gap-2 mb-6" }, /* @__PURE__ */ React.createElement("span", { className: "text-sm" }, "I want"), /* @__PURE__ */ React.createElement(
        "select",
        {
          value: targetVariable,
          onChange: this.handleVariableChange,
          className: "px-3 py-1.5 text-sm border rounded outline-none focus:ring-1 min-w-32"
        },
        /* @__PURE__ */ React.createElement("option", { value: "" }, "Select variable"),
        Object.keys(computedVars).map((v) => /* @__PURE__ */ React.createElement("option", { key: v, value: v }, v))
      ), /* @__PURE__ */ React.createElement("span", { className: "text-sm" }, "="), /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "text",
          value: targetValue,
          onChange: this.handleTargetChange,
          placeholder: "Enter target value",
          className: "px-3 py-1.5 text-sm border rounded outline-none focus:ring-1 min-w-32"
        }
      )), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", { className: "mb-2 text-sm" }, "By adjusting:"), /* @__PURE__ */ React.createElement("div", { className: "overflow-hidden border rounded-lg" }, /* @__PURE__ */ React.createElement("table", { className: "w-full" }, /* @__PURE__ */ React.createElement("thead", null, /* @__PURE__ */ React.createElement("tr", null, /* @__PURE__ */ React.createElement("th", { className: "px-4 py-2 text-xs text-left" }, "Variable"), /* @__PURE__ */ React.createElement("th", { className: "px-4 py-2 text-xs text-left" }, "Current"), /* @__PURE__ */ React.createElement("th", { className: "px-4 py-2 text-xs text-left" }, "Solution value"))), /* @__PURE__ */ React.createElement("tbody", { className: "divide-y" }, Object.entries(adjustmentVars).filter(
        ([varName]) => varName !== targetVariable && dependencies.includes(varName)
      ).map(([varName, details]) => /* @__PURE__ */ React.createElement("tr", { key: varName }, /* @__PURE__ */ React.createElement("td", { className: "px-4 py-2" }, /* @__PURE__ */ React.createElement(
        "input",
        {
          type: "checkbox",
          checked: details.selected,
          onChange: () => this.toggleAdjustmentVar(varName),
          className: "mr-2 rounded-md"
        }
      ), varName), /* @__PURE__ */ React.createElement("td", { className: "px-4 py-2 text-sm" }, this.formatNumber(varName, details.currentValue)), /* @__PURE__ */ React.createElement("td", { className: "px-4 py-2 text-sm" }, details.selected ? this.formatNumber(varName, details.solvedValue) : this.formatNumber(varName, details.currentValue)))))))), /* @__PURE__ */ React.createElement("div", { className: "flex items-center justify-center p-3 mb-6 text-xs" }, gsResult?.solved && /* @__PURE__ */ React.createElement("span", null, gsResult.errorPct >= 0.01 ? `Solution found (${(100 * (1 - Math.abs(gsResult.errorPct))).toFixed(1)}%)! ${targetVariable} = ` : `Solution found! ${targetVariable} = `, this.formatNumber(targetVariable, gsResult.solvedValue))), /* @__PURE__ */ React.createElement("div", { className: "flex justify-end gap-2" }, /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: this.handleInsertSolution,
          disabled: !targetVariable || !targetValue,
          className: "inline-flex items-center justify-center gap-2 px-4 py-3 text-sm font-medium align-middle transition-all border rounded-md shadow-sm border-color-soft text-color-default bg-secondary hover-bg-button"
        },
        "Insert solution row"
      ), /* @__PURE__ */ React.createElement(
        "button",
        {
          onClick: this.handleApply,
          disabled: !targetVariable || !targetValue,
          className: "inline-flex items-center justify-center gap-2 px-4 py-3 text-sm font-semibold text-white transition-all border border-transparent rounded-md bg-destructive hover:ring-2"
        },
        "Apply solution"
      ))));
    }
  };
  LIB.setVariablesInCalc = function(Action2, calc, vars, results) {
    const solution = vars;
    if (!solution || !calc) return;
    for (const varName in solution) {
      const solvedValue = solution[varName];
      let newText = null;
      let rowIndex = 0;
      if (varName.match(/^r\d+$/i)) {
        let varRowIndex = parseInt(varName.slice(1)) - 1;
        let currentRowText = calc.rows[varRowIndex].text;
        const newMainText = IC.api.formatValue(solvedValue);
        newText = IC.api.replaceBeforeComment(currentRowText, newMainText);
        Action2.updateRowText(calc, varRowIndex, newText);
      } else {
        rowIndex = IC.api.findParameterRow(calc, varName);
        if (rowIndex !== null) {
          const row = calc.rows[rowIndex];
          newText = IC.api.buildParameterText(row.text, IC.api.formatValue(solvedValue));
        }
        if (newText) {
          Action2.updateRowText(calc, rowIndex, newText);
        }
      }
    }
  };
  var SetVarsDisplay = class extends React.Component {
    static {
      __name(this, "SetVarsDisplay");
    }
    handleApplySolution() {
      LIB.setVariablesInCalc(this.props.Action, this.props.calc, this.props.resultObj.vars);
    }
    render() {
      let vars_display = null;
      const varMap = this.props.resultObj?.vars;
      const type = this.props.resultObj?.type;
      if (varMap) {
        const variablesToSet = Object.entries(varMap).map(([key, value]) => {
          return /* @__PURE__ */ React.createElement("li", { key }, key, " = ", IC.api.formatValue(value));
        });
        vars_display = /* @__PURE__ */ React.createElement("div", { className: "flex items-center" }, /* @__PURE__ */ React.createElement("div", { className: "flex-none w-24 pr-1" }, /* @__PURE__ */ React.createElement(
          "button",
          {
            onClick: (e) => {
              this.handleApplySolution(varMap);
              e.stopPropagation();
            },
            className: "px-2 py-1 text-xs border rounded-md shadow-sm text-color-default border-color-soft hover-text-color-active"
          },
          "Set values"
        )), /* @__PURE__ */ React.createElement("div", { className: "flex-grow overflow-x-auto" }, /* @__PURE__ */ React.createElement("ul", { className: "block w-full p-2 overflow-auto text-xs" }, variablesToSet)));
      } else {
        UIlog("[Row]", this.props.index, "expanded view regular result path");
        vars_display = /* @__PURE__ */ React.createElement("div", { className: "cursor-pointer" }, /* @__PURE__ */ React.createElement("details", { onClick: (e) => e.stopPropagation() }, /* @__PURE__ */ React.createElement("summary", null, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "currentColor", className: "inline-block mb-1 mr-1 opacity-75 icon-closed size-3" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm.75-10.25v2.5h2.5a.75.75 0 0 1 0 1.5h-2.5v2.5a.75.75 0 0 1-1.5 0v-2.5h-2.5a.75.75 0 0 1 0-1.5h2.5v-2.5a.75.75 0 0 1 1.5 0Z", clipRule: "evenodd" })), /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "currentColor", className: "inline-block mb-1 mr-1 opacity-75 icon-open size-3" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm4-7a.75.75 0 0 0-.75-.75h-6.5a.75.75 0 0 0 0 1.5h6.5A.75.75 0 0 0 12 8Z", clipRule: "evenodd" })), "Goalseek couldn't find a solution"), /* @__PURE__ */ React.createElement("main", null, /* @__PURE__ */ React.createElement("pre", { className: "text-xs" }, LIB.prettyPrintObject(this.props.goalseekObj)))));
      }
      return /* @__PURE__ */ React.createElement("div", { className: "cursor-pointer" }, vars_display);
    }
  };
  var ThemeOptionsPanel = class extends React.Component {
    static {
      __name(this, "ThemeOptionsPanel");
    }
    constructor(props) {
      super(props);
      let theme = this.props.getOption("theme");
      let font = this.props.getOption("font");
      let size = this.props.getOption("size");
      if ((theme === "undefined" || theme == null) && this.prefersDark()) {
        theme = 1;
      }
      this.setTheme(theme);
      this.setFont(font);
      this.setSize(size);
      this.state = {
        theme: theme || 0,
        font: font || 0,
        size: size || 0
      };
    }
    prefersDark() {
      return window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
    }
    getIconText() {
      let iconText = this.state.theme == 0 ? "\u2600" : "\u263E";
      iconText = this.state.theme == 0 ? /* @__PURE__ */ React.createElement("i", { className: "gg-sun" }) : /* @__PURE__ */ React.createElement("i", { className: "gg-moon" });
      return iconText;
    }
    removeClasses(el, prefix) {
      Array.from(el.classList).forEach((item) => {
        if (item.match(prefix)) {
          el.classList.remove(item);
        }
      });
    }
    setTheme(theme_id) {
      const THEME_MAP = {
        0: "default",
        1: "tokyo",
        2: "morning",
        3: "1984"
      };
      let body = document.querySelector("body");
      this.removeClasses(body, "theme");
      let name = THEME_MAP[theme_id];
      if (theme_id > 0 && name) {
        body.classList.add("theme");
        body.classList.add("theme-" + name);
      }
      this.props.setOption("theme", theme_id);
      this.setState({ theme: theme_id });
    }
    setFont(font_id) {
      const FONT_MAP = {
        0: "inter",
        1: "monospace",
        2: "classy",
        3: "hand"
      };
      let body = document.querySelector("body");
      this.removeClasses(body, "font");
      if (font_id !== null) {
        let name = FONT_MAP[font_id];
        body.classList.add("font-" + name);
      }
      this.props.setOption("font", font_id);
      this.setState({ font: font_id });
    }
    setSize(size_id) {
      const SIZE_MAP = {
        0: "regular",
        1: "compact",
        2: "zen"
      };
      let body = document.querySelector("body");
      this.removeClasses(body, "size");
      if (size_id > 0) {
        let name = SIZE_MAP[size_id];
        body.classList.add("size-" + name);
      }
      this.props.setOption("size", size_id);
      this.setState({ size: size_id });
    }
    getThemeOptionsPanel() {
      let btn_classes = " py-1 px-2 inline-flex justify-center items-center gap-2 -ml-px first:rounded-l-lg first:ml-0 last:rounded-r-lg border align-middle transition-all text-sm border-color-soft hover-bg-button";
      let btn_classes_active = " text-color-active";
      btn_classes = " p-2 rounded bg-secondary capitalize text-xs font-medium";
      let themeOptions = ["daylight", "tokyo night", "rosebud", "1984"].map((name, id) => {
        let active = this.state.theme == id ? "text-color-active" : "";
        let classList = `style-theme-${name} ${active}` + btn_classes;
        return /* @__PURE__ */ React.createElement("button", { href: "javascript:void(0)", className: classList, onClick: () => this.setTheme(id) }, name, " ");
      });
      let fontOptions = ["clean", "mono", "serif", "hand"].map((name, id) => {
        let active = this.state.font == id ? "text-color-active" : "";
        let classList = `style-font-${name} ${active}` + btn_classes;
        return /* @__PURE__ */ React.createElement("button", { href: "javascript:void(0)", className: classList, onClick: () => this.setFont(id) }, name, " ");
      });
      let sizeOptions = ["spacious", "compact"].map((name, id) => {
        let active = this.state.size == id ? "text-color-active" : "";
        let classList = `style-size-${name} ${active}` + btn_classes;
        return /* @__PURE__ */ React.createElement("button", { href: "javascript:void(0)", className: classList, onClick: () => this.setSize(id) }, name);
      });
      return /* @__PURE__ */ React.createElement("div", { className: "flex flex-col max-w-md space-y-4 text-sm text-color-default" }, /* @__PURE__ */ React.createElement("div", { className: "flex items-center" }, /* @__PURE__ */ React.createElement("span", { className: "inline-flex w-20 pr-4 text-xs capitalize" }, "Colors"), /* @__PURE__ */ React.createElement("div", { className: "inline-flex space-x-2" }, themeOptions)), /* @__PURE__ */ React.createElement("div", { class: "flex items-center" }, /* @__PURE__ */ React.createElement("span", { className: "inline-flex w-20 pr-4 text-xs capitalize" }, "Font"), /* @__PURE__ */ React.createElement("div", { className: "inline-flex space-x-2" }, fontOptions)), /* @__PURE__ */ React.createElement("div", { class: "flex items-center" }, /* @__PURE__ */ React.createElement("span", { className: "inline-flex w-20 pr-4 text-xs capitalize" }, "Size"), /* @__PURE__ */ React.createElement("div", { className: "inline-flex space-x-2" }, sizeOptions)));
    }
    render() {
      return /* @__PURE__ */ React.createElement("div", null, this.getThemeOptionsPanel());
    }
  };
  var UserInfo = class extends React.Component {
    static {
      __name(this, "UserInfo");
    }
    constructor(props) {
      super(props);
      let localOption = JSON.parse(this.props.Action.getLocalOption("user") || "{ }");
      this.state = {
        name: localOption?.name,
        photoURL: localOption?.photoURL,
        uid: localOption?.uid,
        userLoaded: false
      };
      UserStore.sub((user) => {
        this.setState({ name: user?.displayName, photoURL: user?.photoURL, uid: user?.uid, userLoaded: true });
        this.props.Action.setLocalOption("user", JSON.stringify(this.state));
      });
    }
    logout() {
      this.setState({ name: "", photoURL: "" });
      this.props.Action.setLocalOption("user", null);
      this.props.Action.logout();
    }
    render() {
      let initials = this.props.name ? this.props.name.split(" ").map((word) => word[0]).join("") : "";
      let currentUser = this.props.Action.getCurrentUser();
      if (!this.state.userLoaded) {
        return /* @__PURE__ */ React.createElement("div", null);
      }
      if (!currentUser) {
        return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("button", { onClick: (e) => Action.login(), className: "py-0.5 lg:px-2 text-xs lg:text-sm lg:min-w-[100] rounded capitalize" }, "Login"));
      }
      let userIcon = this.state.photoURL ? /* @__PURE__ */ React.createElement("img", { className: "inline-block w-5 h-5 mt-0.5 rounded-full lg:mt-0 lg:ml-2 lg:w-8 lg:h-8 ring-1 lg:ring-2 ring-slate-100", src: this.state.photoURL }) : /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "inline-block w-5 h-5 mt-0.5 rounded-full lg:mt-0 lg:w-8 lg:h-8" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z", clipRule: "evenodd" }));
      let truncatedName = this.state.name?.length > 20 ? this.state.name.split(" ")[0].substring(0, 20) : this.state.name;
      return /* @__PURE__ */ React.createElement("div", { id: "userinfo", className: "inline-block hs-dropdown" }, /* @__PURE__ */ React.createElement("button", null, /* @__PURE__ */ React.createElement("span", { className: "hidden mr-2 text-sm text-white _xl:inline-block max-w-[14rem] max-h-4" }, truncatedName ?? "Account"), userIcon), /* @__PURE__ */ React.createElement("div", { "aria-labelledby": "userinfo", className: "hs-dropdown-menu z-[60] transition-[opacity,margin] duration hs-dropdown-open:opacity-100 opacity-0 hidden min-w-[12rem] bg-secondary shadow-md rounded-lg p-2 mt-2 after:h-4 after:absolute after:-bottom-4 after:left-0 after:w-full before:h-4 before:absolute before:-top-4 before:left-0 before:w-full" }, /* @__PURE__ */ React.createElement("a", { href: "/account.html", className: "flex text-sm items-center gap-x-3.5 py-2 rounded hover-bg-button px-3" }, "Account settings"), /* @__PURE__ */ React.createElement("a", { href: "javascript:void(0)", onClick: this.logout.bind(this), className: "flex text-sm items-center gap-x-3.5 py-2 rounded hover-bg-button px-3" }, "Log out and clear calcs")));
    }
  };
  var NewCalcButton = class extends React.Component {
    static {
      __name(this, "NewCalcButton");
    }
    handleClick(e) {
      e.preventDefault();
      let calc = this.props.Action.create();
      this.props.Action.select(calc.id);
      if (!Router.isHome()) {
        Router.goHome();
      }
    }
    render() {
      return /* @__PURE__ */ React.createElement("button", { className: "inline-flex items-center gap-x-2 py-0.5 px-2 text-xs lg:pr-4 lg:text-base rounded create capitalize lg:min-w-[100]", onClick: this.handleClick.bind(this) }, /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "hidden lg:inline-block size-5" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M12 4.5v15m7.5-7.5h-15" })), /* @__PURE__ */ React.createElement("span", { className: "hidden lg:inline-block" }, this.props.title || "New"), /* @__PURE__ */ React.createElement("span", { className: "inline-block lg:hidden" }, this.props.title || "New"));
    }
  };
  var ShareButton = class extends React.Component {
    static {
      __name(this, "ShareButton");
    }
    constructor(props) {
      super(props);
      this.state = {
        copiedURL: false
      };
      this.handleClick = this.handleClick.bind(this);
      this.copyURL = this.copyURL.bind(this);
    }
    copyURL() {
      this.setState({ copiedURL: true });
      setTimeout(() => {
        this.setState({ copiedURL: false });
      }, 1500);
    }
    handleClick(e) {
      e.preventDefault();
      let calc = this.props.Action.currentCalc;
      if (!calc?.published) {
        console.log("publishing calc", calc);
        this.props.Action.publish(calc);
        let maxTries = 20;
        let interval = setInterval(() => {
          maxTries--;
          let calc2 = this.props.Action.currentCalc;
          if (calc2) {
            clearInterval(interval);
            const newUrl = this.props.Action.getPublicURL(calc2);
            if (this.refs.copyAnchor) {
              this.refs.copyAnchor.setAttribute("data-clipboard-text", newUrl);
              this.refs.copyAnchor.click();
            }
          }
          if (maxTries < 0) {
            clearInterval(interval);
          }
        }, 200);
      } else {
        UIlog("[Row]", this.props.index, "expanded view regular result path");
        this.copyURL();
      }
    }
    render() {
      const calc = this.props.Action.currentCalc;
      var url = this.props.Action.getPublicURL(calc);
      let icon_link = /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "size-5", style: { width: "20px", height: "20px" } }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" }));
      let icon_publish = /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", strokeWidth: 1.5, stroke: "currentColor", className: "size-5" }, /* @__PURE__ */ React.createElement("path", { strokeLinecap: "round", strokeLinejoin: "round", d: "M9 8.25H7.5a2.25 2.25 0 0 0-2.25 2.25v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25H15m0-3-3-3m0 0-3 3m3-3V15" }));
      let info_message = /* @__PURE__ */ React.createElement("div", { className: "inline-block text-sm bg-secondary" }, "url copied");
      return /* @__PURE__ */ React.createElement(
        "a",
        {
          ref: "copyAnchor",
          href: "javascript:void(0)",
          className: "copy-event",
          onClick: this.handleClick,
          "data-clipboard-text": url,
          title: calc?.published ? "Copy link " + url : "Publish and copy link"
        },
        this.state.copiedURL ? info_message : icon_link
      );
    }
  };
  var ICModal = class extends React.Component {
    static {
      __name(this, "ICModal");
    }
    render() {
      let accept_button = /* @__PURE__ */ React.createElement(
        "button",
        {
          className: "inline-flex items-center justify-center gap-2 px-4 py-3 text-sm font-semibold text-white transition-all border border-transparent rounded-md bg-destructive hover:ring-2",
          onClick: this.props.onAccept,
          "data-hs-overlay": "#" + this.props.id
        },
        this.props.accept
      );
      let close_button = /* @__PURE__ */ React.createElement(
        "button",
        {
          type: "button",
          className: "inline-flex items-center justify-center gap-2 px-4 py-3 text-sm font-medium align-middle transition-all border rounded-md shadow-sm border-color-soft text-color-default bg-secondary hs-dropdown-toggle hover-bg-button",
          "data-hs-overlay": "#" + this.props.id
        },
        this.props.close
      );
      let close_icon = /* @__PURE__ */ React.createElement("button", { type: "button", "data-hs-overlay": `#${this.props.id}` }, /* @__PURE__ */ React.createElement("svg", { className: "w-3 h-3", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, /* @__PURE__ */ React.createElement("path", { d: "M0.258206 1.00652C0.351976 0.912791 0.479126 0.860131 0.611706 0.860131C0.744296 0.860131 0.871447 0.912791 0.965207 1.00652L3.61171 3.65302L6.25822 1.00652C6.30432 0.958771 6.35952 0.920671 6.42052 0.894471C6.48152 0.868271 6.54712 0.854471 6.61352 0.853901C6.67992 0.853321 6.74572 0.865971 6.80722 0.891111C6.86862 0.916251 6.92442 0.953381 6.97142 1.00032C7.01832 1.04727 7.05552 1.1031 7.08062 1.16454C7.10572 1.22599 7.11842 1.29183 7.11782 1.35822C7.11722 1.42461 7.10342 1.49022 7.07722 1.55122C7.05102 1.61222 7.01292 1.6674 6.96522 1.71352L4.31871 4.36002L6.96522 7.00648C7.05632 7.10078 7.10672 7.22708 7.10552 7.35818C7.10442 7.48928 7.05182 7.61468 6.95912 7.70738C6.86642 7.80018 6.74102 7.85268 6.60992 7.85388C6.47882 7.85498 6.35252 7.80458 6.25822 7.71348L3.61171 5.06702L0.965207 7.71348C0.870907 7.80458 0.744606 7.85498 0.613506 7.85388C0.482406 7.85268 0.357007 7.80018 0.264297 7.70738C0.171597 7.61468 0.119017 7.48928 0.117877 7.35818C0.116737 7.22708 0.167126 7.10078 0.258206 7.00648L2.90471 4.36002L0.258206 1.71352C0.164476 1.61976 0.111816 1.4926 0.111816 1.36002C0.111816 1.22744 0.164476 1.10028 0.258206 1.00652Z", fill: "currentColor" })));
      return /* @__PURE__ */ React.createElement(
        "div",
        {
          id: this.props.id,
          className: "hs-overlay hidden w-full h-full fixed top-0 left-0 z-[60] overflow-x-hidden overflow-y-auto"
        },
        /* @__PURE__ */ React.createElement(
          "div",
          {
            className: "hs-overlay-open:mt-7 hs-overlay-open:opacity-100 hs-overlay-open:duration-500 mt-0 opacity-0 ease-out transition-all sm:w-full m-3 sm:mx-auto min-h-[calc(100%-3.5rem)] flex items-center justify-center"
          },
          /* @__PURE__ */ React.createElement(
            "div",
            {
              className: "flex min-w-[200px] flex-col bg-secondary border border-color-soft shadow-sm rounded-xl px-1"
            },
            /* @__PURE__ */ React.createElement("div", { className: "flex items-center justify-between px-4 py-3" }, /* @__PURE__ */ React.createElement("h3", { className: "block w-full text-base font-bold text-center normal-case text-color-default" }, this.props.title), this.props.closeIcon && close_icon),
            this.props.children,
            /* @__PURE__ */ React.createElement("div", { className: "flex items-center justify-end px-4 py-3 gap-x-2" }, this.props.close && close_button, this.props.accept && accept_button)
          )
        )
      );
    }
  };
  ICModal.propTypes = {
    id: React.PropTypes.isRequired,
    close: React.PropTypes.isRequired,
    accept: React.PropTypes.isRequired,
    onAccept: React.PropTypes.isRequired
  };
  var debounce = /* @__PURE__ */ __name((callback, wait) => {
    let timeoutId = null;
    return (...args) => {
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(() => {
        callback.apply(null, args);
      }, wait);
    };
  }, "debounce");
  var instacalc_default = { App, ThemeOptionsPanel, Shared, UserInfo, NewCalcButton };
  return __toCommonJS(instacalc_exports);
})();
;
// Generated automatically by nearley, version 2.20.1
// http://github.com/Hardmath123/nearley
(function () {
function id(x) { return x[0]; }

if (typeof moo === "undefined") {
    const moo = require("moo");
}

// turn a template interpolated string into a regex
function reg(strings, ...pieces) {
  return new RegExp(strings.raw.map((r, i) => r + (pieces[i] === undefined ? '' : pieces[i].source)).join(''), "u")
}

// note: moo requires non-capturing groups, (?:)
const ID_START = /(?:\p{Letter}|[_]|\\u[a-fA-F0-9]{4})/u;
const ID_REST = reg`(?:${ID_START}|[0-9]|['".])`;
const ID_FINAL = reg`${ID_START}(?:\s*${ID_REST})*`;

const DECIMAL_DIGITS = /[0-9]+/u;
const SIGNED_INTEGER = /[+-]?[0-9]+/u;
const EXPONENT_INDICATOR = /[eE]/u;
const EXPONENT_PART = reg`${EXPONENT_INDICATOR}${SIGNED_INTEGER}`;

const DECIMAL_INTEGER_LITERAL = reg`\d+(?:[,._]\d+)*(?:[,._]\d+)?[.]?`;
const DECIMAL_LITERAL = reg`(?:[.]?${DECIMAL_INTEGER_LITERAL})(?:${EXPONENT_PART})?`;
const DECIMAL_FRACTION_LITERAL = reg`(?:${DECIMAL_INTEGER_LITERAL}\s+)?${DECIMAL_DIGITS}\s*[\/]\s*${DECIMAL_DIGITS}`;

function caseInsensitive(input) {
    return Array.from(input).map(c => {
        if (/[a-zA-Z]/.test(c)) {
            return `[${c.toUpperCase()}${c.toLowerCase()}]`;
        }
        return c;
    }).join("");
}

function buildTimeStringRegex() {
    let numPart = "\\d+(?:\\.\\d+)?";
    let unitsPart = "(?:" + caseInsensitive("y") + "(?:" + caseInsensitive("ears") + "?)?" +
                        "|" + caseInsensitive("d") + "(?:" + caseInsensitive("ays") + "?)?" +
                        "|" + caseInsensitive("h") + "(?:" + caseInsensitive("ours") + "?)?" +
                        "|" + caseInsensitive("m") + "(?:" + caseInsensitive("inutes") + "?)?" +
                        "|" + caseInsensitive("s") + "(?:" + caseInsensitive("econds") + "?)?)";
    let timePart = numPart + "\\s*" + unitsPart;
    let timeString = "(?:" + timePart + "\\s*){2,}";
    let colonTimeString = "(?:\\d{1,2}:\\d{1,2}(?::\\d{1,2})?(?:\\.\\d+)?)";

    return new RegExp(timeString + "|" + colonTimeString, "u");
}

const TIMEZONEREGEX = "\\s*(?:UTC[+-][0-9]+|GMT[+-][0-9]+|[A-Za-z]{2,4})";                  // Timezone: PST, GMT+5, UTC+5

function buildTimeImpliedDateRegex() {
    let numPart = "\\d{1,2}";                                // Matches numbers
    let optionalMinutesPart = "(?::\\d{1,2})?";              // Matches optional minutes part after colon e.g. ":30"
    let optionalSecondsPart = "(?::\\d{1,2})?";              // Matches optional seconds part after another colon e.g. ":45"
    let amPmPart = "\\s*(?:" + caseInsensitive("am") + "\\b|" + caseInsensitive("pm") + "\\b)"; // am/pm, optional spaces
    let timezonePart = TIMEZONEREGEX;
    let timeString = numPart + optionalMinutesPart + optionalSecondsPart + amPmPart + "(?:" + timezonePart + ")?";
    return new RegExp(timeString, "u");
}

function buildDateStringRegex() {
    // Convert month names to case insensitive format
    const months = caseInsensitive('(?:Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sept?(?:ember)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)');
    
    // Weekdays (optional) followed by an optional comma
    const weekdays = caseInsensitive('(?:Mon(?:day)?|Tue(?:sday)?|Wed(?:nesday)?|Thu(?:rsday)?|Fri(?:day)?|Sat(?:urday)?|Sun(?:day)?)?,?');

    const day = '\\d{1,2}';
    //const year = '\\d{2}(?:\\d{2})?';

    const fullYear = '(?:19[0-9]{2}|20[0-9]{2})';  
    const twoDigitYear = '\\d{2}';
    const year = `(?:${fullYear}|${twoDigitYear})`;

    const time = '\\d{1,2}:\\d{2}(?::\\d{2})?\\s*[APap][Mm]?';  // Time (in the format hh:mm:ss AM/PM)
    const timezone = TIMEZONEREGEX;
    const textualMonthDay = `${months}\\s+${day}`; // "Nov 5" or "November 5" 

    // "Tue, Nov 5, 1994" or "November 5 1994"
    const textualMonthDayYear = `${weekdays}\\s*${textualMonthDay},?\\s+${year}(?:\\s+${time})?(?:\\s+${timezone})?`;

    // Numeric date formats with mandatory year
    const numericDateFormats = [
        `\\d{1,2}/\\d{1,2}/${year}\\b`,    // MM/DD/YY
        `${year}/\\d{1,2}/\\d{1,2}\\b`,     // YY/MM/DD
        `\\d{1,2}[.]\\d{1,2}[.]${year}\\b`,    // DD.MM.YYYY
        `${year}[.]\\d{1,2}[.]\\d{1,2}\\b`,     // YY.MM.DD
    ].join('|');

    // Construct the regex with the textual date formats first, followed by the numeric date formats
    const regexString = `${textualMonthDayYear}|${textualMonthDay}|${numericDateFormats}`;
    return new RegExp(regexString, 'u');
}

const TIME_IMPLIED_DATE = buildTimeImpliedDateRegex();
if (typeof window !== "undefined") {
    window.TIME_IMPLIED_DATE = TIME_IMPLIED_DATE;
}
const TIME_STRING = buildTimeStringRegex();
const DATE_STRING = buildDateStringRegex();

function makeKeywordRegexString(str) {
    return str.split("").map(c => {
        if (/[a-zA-Z]/.test(c)) {
            return `[${c.toUpperCase()}${c.toLowerCase()}]`;
        }
        return c;
    }).join('');
}

// wrap keyword with \b to ensure it is a word
function makeStandaloneKeywordRegex(str) {
    str = makeKeywordRegexString(str);
    return new RegExp("\\b" + str + "\\b", "u");
}

function createAlternativesRegex(keywords) {
    return new RegExp(keywords.map(keyword => makeKeywordRegexString(keyword)).join("|"), "u");
}

const footSymbol = `'`;
const inchesSymbol = `"`;

// longest match first
const footKeywords = [footSymbol, "foot", "feet", "ft"];
const inchesKeywords = [inchesSymbol, "inches", "inch", "in"];

const ANY_FOOT_SYMBOL = createAlternativesRegex(footKeywords);
const ANY_INCH_SYMBOL = createAlternativesRegex(inchesKeywords);

const FEET_AND_INCHES = reg`(?:${DECIMAL_LITERAL}|${DECIMAL_FRACTION_LITERAL})\s*(?:${ANY_FOOT_SYMBOL})\s*(?:and|[,])?\s*(?:${DECIMAL_LITERAL}|${DECIMAL_FRACTION_LITERAL})\s*(?:${ANY_INCH_SYMBOL})`;
const FOOTPART = reg`(?:${DECIMAL_LITERAL}|${DECIMAL_FRACTION_LITERAL})\s*'`;
const INCHESPART = reg`(?:${DECIMAL_LITERAL}|${DECIMAL_FRACTION_LITERAL})\s*"`;

const ISO_TIMESTAMP = /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})/u;

const KEYWORDS = new Set("null true false if else and or not xor mod off of from".split(" "));
const OPS = new Set("and or not xor mod");
let IGNORE = new Set("ws commentSingle commentMulti".split(" "));

const LEXER = moo.compile({
  timeImpliedDate: TIME_IMPLIED_DATE,
  isoTimestamp: ISO_TIMESTAMP,
  datestring: DATE_STRING,
  timestring: TIME_STRING,
    
  // allow underscores between chars: 0x1_2
  /*
  oct: /0[oO](?:[0-7]+_)*[0-7]+/u,
  bin: /0[bB](?:[01]+_)*[01]+/u,
  hex: /0[xX](?:[0-9a-fA-F]+_)*[0-9a-fA-F]+/u,
  */

  oct: /(?:0[oO](?:[0-7]+_)*[0-7]+(?:\.[0-7]+)?)/u,
  bin: /(?:0[bB](?:[01]+_)*[01]+(?:\.[01]+)?)/u,
  hex: /(?:0[xX](?:[0-9a-fA-F]+_)*[0-9a-fA-F]+(?:\.[0-9a-fA-F]+)?)/u,

  rowRange: /[rR]\d+[:][rR]?\d+/u,

  // "else if" must be two separate tokens, not a merged id token
  if: /\bif(?=\s*[(])\b/u,        // if is a keyword if followed by (

  else: makeStandaloneKeywordRegex("else"),
  and: makeStandaloneKeywordRegex("and"),
  or: makeStandaloneKeywordRegex("or"),
  not: makeStandaloneKeywordRegex("not"),
  xor: makeStandaloneKeywordRegex("xor"),
  mod: makeStandaloneKeywordRegex("mod"),
  off: makeStandaloneKeywordRegex("off"),
  of: makeStandaloneKeywordRegex("of"),
  from: makeStandaloneKeywordRegex("from"),
  function: makeStandaloneKeywordRegex("function"),
    
  // must happen before decimal
  feetAndInches: FEET_AND_INCHES,
  footPart: FOOTPART,
  inchesPart: INCHESPART,

  id: {match: ID_FINAL},
  decimal: DECIMAL_LITERAL,

  rarrow:                    /=>/u,
    
  teq: /[=][=][=]/u,
  deq: /[=][=]/u,
  eq: /[=]/u,
        
  strictlynotequals:         /!==/u,
  strictlyequals:            /===/u,
  unsignedrightshiftassign:  />>>=/u,
  leftshiftassign:           /<<=/u,
  rightshiftassign:          />>=/u,
  greaterthanorequal:        />=/u,
  lessthanorequal:           /<=/u,
  exponentiationassign: /\*\*=/u,
  exponentiation:            /\*\*/u,
  unsignedshiftright:        />>>/u,
  logicalor:                 /\|\|/u,
  logicaland:                /&&/u,
  shiftleft:                 /<</u,
  shiftright:                />>/u,
  doubleequals:              /==/u,
  notequals:                 /!=/u,
  plusequals:                /\+=/u,
  minusequals:               /-=/u,
  timesequals:               /\*=/u,
  divideequals:              /\/=/u,
  modulusequals:             /%=/u,
  andassign:                 /&=/u,
  orassign:                  /\|=/u,
  xorequals:                 /\^=/u,
  doubleplus:                /\+\+/u,
  doubleminus:               /--/u,
 
  // TODO: can have multiple matches with an array, all back to a comment type
  commentSingle: /(?:\/\/|[#])[^\n]*/u, // js style (//), or Python style (#)
  commentMulti: /\/\*[\s\S]*?\*\//u,

  // define with regex, avoid special chars
  conversionOp: /[-][>]/u,
  typesolveOp: /[@]/u,
  percentOp: /[%]/u,
    
  sc: ';',
  comma: ',',
  ws: { match: /\s+/u, lineBreaks: true },
    
  string_double: /"(?:\\["bfnrt\/\\]|\\u[a-fA-F0-9]{4}|[^"\\])*"/u,
  string_single: /'(?:\\['bfnrt\/\\]|\\u[a-fA-F0-9]{4}|[^'\\])*'/u,

  lp: '(',
  rp: ')',
  lb: '{',
  rb: '}',
  lbracket: '[',
  rbracket: ']',
  carat: '^',
  doublepipe: '||',
  pipe: '|',
        

  symbol: /[+\-*/%=!<>&|~?:]/u,
  squote: `'`,
  dquote: `"`,

  slashItem: /[\\]\w+/u,
                  
  // catchall 
  source: { match: /./u, lineBreaks: true },
});

LEXER.IGNORE = IGNORE;
LEXER.IGNORE_ENABLED = true;

LEXER.next = (next => () => {
    let tok;
    try {
        do {
            tok = next.call(LEXER); // Get the next token
            if (!tok) break; // Exit loop if no token (EOF or error handled inside)

            // Skip ignored tokens (inside the do-while loop)
            if (LEXER.IGNORE_ENABLED && IGNORE.has(tok.type)) {
                continue; // Go to the next iteration of the do-while loop to get another token
            } else {
                break; // If it's not an ignored token, exit the do-while loop
            }
        } while (true); // Loop until a non-ignored token or no token is found

        // turn keywords into keyword items (after the do-while loop)
        if (tok?.type === "id" && KEYWORDS.has(tok.value.toLowerCase())) {
            tok.type = "keyword";
            tok.value = tok.text = tok.value.toLowerCase();
        }

    } catch (error) {
        // Error occurred during next.call(LEXER) (handled outside the loop)
        // console.error("Error in LEXER.next (Safari?):", error);
        return undefined; // Or return null
    }

    return tok; // Return the token (or undefined if error or no token)
})(LEXER.next);

// unwrap single item arrays
function unwrap(x) {
    if (Array.isArray(x) && x.length == 1) {
        return unwrap(x[0]);
    }
    return x;
}

function hasContent(x) {
    return Array.isArray(x) ? x.length > 0 : x;
}

const CONVERSION_OP = {
  "*": "mul",
  "+": "add",
  "-": "sub"
};

var grammar = {
    Lexer: LEXER,
    ParserRules: [
    {"name": "main", "symbols": ["Program"], "postprocess": id},
    {"name": "nullLiteral", "symbols": [{"literal":"null"}], "postprocess": id},
    {"name": "booleanLiteral$subexpression$1", "symbols": [{"literal":"true"}]},
    {"name": "booleanLiteral$subexpression$1", "symbols": [{"literal":"false"}]},
    {"name": "booleanLiteral", "symbols": ["booleanLiteral$subexpression$1"], "postprocess": id},
    {"name": "fraction", "symbols": [(LEXER.has("decimal") ? {type: "decimal"} : decimal), (LEXER.has("decimal") ? {type: "decimal"} : decimal), {"literal":"/"}, (LEXER.has("decimal") ? {type: "decimal"} : decimal)], "postprocess":  d => {
        let src = d.join(" ").trim();
        return {type: "fraction", value: src, text: src}
        }
        },
    {"name": "numericLiteral$subexpression$1", "symbols": [(LEXER.has("oct") ? {type: "oct"} : oct)]},
    {"name": "numericLiteral$subexpression$1", "symbols": [(LEXER.has("bin") ? {type: "bin"} : bin)]},
    {"name": "numericLiteral$subexpression$1", "symbols": [(LEXER.has("hex") ? {type: "hex"} : hex)]},
    {"name": "numericLiteral$subexpression$1", "symbols": [(LEXER.has("decimal") ? {type: "decimal"} : decimal)]},
    {"name": "numericLiteral", "symbols": ["numericLiteral$subexpression$1"], "postprocess": id},
    {"name": "numericDivision", "symbols": ["numericLiteral", {"literal":"/"}, "numericLiteral"], "postprocess": d => ["div", d[0], d[2]].map(unwrap)},
    {"name": "stringLiteral$subexpression$1", "symbols": [(LEXER.has("string_double") ? {type: "string_double"} : string_double)]},
    {"name": "stringLiteral$subexpression$1", "symbols": [(LEXER.has("string_single") ? {type: "string_single"} : string_single)]},
    {"name": "stringLiteral", "symbols": ["stringLiteral$subexpression$1"], "postprocess": id},
    {"name": "timeLiteral", "symbols": [(LEXER.has("timestring") ? {type: "timestring"} : timestring)], "postprocess": id},
    {"name": "datetimeLiteral", "symbols": [(LEXER.has("isoTimestamp") ? {type: "isoTimestamp"} : isoTimestamp)]},
    {"name": "datetimeLiteral$ebnf$1$subexpression$1", "symbols": ["timeLiteral"]},
    {"name": "datetimeLiteral$ebnf$1$subexpression$1", "symbols": ["timeImpliedDateLiteral"]},
    {"name": "datetimeLiteral$ebnf$1", "symbols": ["datetimeLiteral$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "datetimeLiteral$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "datetimeLiteral", "symbols": [(LEXER.has("datestring") ? {type: "datestring"} : datestring), "datetimeLiteral$ebnf$1"], "postprocess": d => { return {value: d.map(unwrap).filter(Boolean).join(" ") } }},
    {"name": "timeImpliedDateLiteral", "symbols": [(LEXER.has("timeImpliedDate") ? {type: "timeImpliedDate"} : timeImpliedDate)], "postprocess": id},
    {"name": "temporalLiteral", "symbols": ["timeLiteral"], "postprocess": d => ["timeLiteral", unwrap(d[0])]},
    {"name": "temporalLiteral", "symbols": ["datetimeLiteral"], "postprocess": d => ["datetimeLiteral", unwrap(d[0])]},
    {"name": "temporalLiteral", "symbols": ["timeImpliedDateLiteral"], "postprocess": d => ["timeImpliedDateLiteral", unwrap(d[0])]},
    {"name": "tapeMeasureLiteral", "symbols": [(LEXER.has("feetAndInches") ? {type: "feetAndInches"} : feetAndInches)], "postprocess": d => ["tapemeasure", {both: unwrap(d)}]},
    {"name": "tapeMeasureLiteral", "symbols": [(LEXER.has("footPart") ? {type: "footPart"} : footPart)], "postprocess": d => ["tapemeasure", {foot: unwrap(d)}]},
    {"name": "tapeMeasureLiteral", "symbols": [(LEXER.has("inchesPart") ? {type: "inchesPart"} : inchesPart)], "postprocess": d => ["tapemeasure", {inch: unwrap(d)}]},
    {"name": "literal", "symbols": ["nullLiteral"], "postprocess": d => ["nullLiteral", d[0]]},
    {"name": "literal", "symbols": ["booleanLiteral"], "postprocess": d => ["booleanLiteral", unwrap(d[0])]},
    {"name": "literal", "symbols": ["stringLiteral"], "postprocess": d => ["stringLiteral", unwrap(d[0])]},
    {"name": "literal$subexpression$1", "symbols": ["numericLiteral"]},
    {"name": "literal$subexpression$1", "symbols": ["fraction"]},
    {"name": "literal", "symbols": ["literal$subexpression$1"], "postprocess": id},
    {"name": "literal", "symbols": ["temporalLiteral"], "postprocess": id},
    {"name": "literal", "symbols": ["tapeMeasureLiteral"]},
    {"name": "ArrayLiteral$ebnf$1$subexpression$1$ebnf$1", "symbols": []},
    {"name": "ArrayLiteral$ebnf$1$subexpression$1$ebnf$1$subexpression$1", "symbols": [{"literal":","}, "AssignmentExp"]},
    {"name": "ArrayLiteral$ebnf$1$subexpression$1$ebnf$1", "symbols": ["ArrayLiteral$ebnf$1$subexpression$1$ebnf$1", "ArrayLiteral$ebnf$1$subexpression$1$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "ArrayLiteral$ebnf$1$subexpression$1", "symbols": ["AssignmentExp", "ArrayLiteral$ebnf$1$subexpression$1$ebnf$1"]},
    {"name": "ArrayLiteral$ebnf$1", "symbols": ["ArrayLiteral$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "ArrayLiteral$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "ArrayLiteral", "symbols": [{"literal":"["}, "ArrayLiteral$ebnf$1", {"literal":"]"}], "postprocess": d => ['arrayLiteral', d[1] ? [d[1][0], ...(d[1][1] || []).map(item => item[1])] : []]},
    {"name": "ArrayAccess", "symbols": ["PrimaryExp", {"literal":"["}, "ConversionOpExp", {"literal":"]"}], "postprocess": d => ["arrayAccess", d[0], d[2]]},
    {"name": "ObjectLiteral$ebnf$1", "symbols": []},
    {"name": "ObjectLiteral$ebnf$1$subexpression$1", "symbols": [{"literal":","}, "ObjectItem"]},
    {"name": "ObjectLiteral$ebnf$1", "symbols": ["ObjectLiteral$ebnf$1", "ObjectLiteral$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "ObjectLiteral", "symbols": [{"literal":"{"}, "ObjectItem", "ObjectLiteral$ebnf$1", {"literal":"}"}], "postprocess": d => ['objectLiteral', [d[1], ...d[2].map(item => item[1])].map(unwrap)]},
    {"name": "ObjectLiteral", "symbols": [{"literal":"{"}, {"literal":"}"}], "postprocess": d => ['objectLiteral', []]},
    {"name": "ObjectItem$subexpression$1", "symbols": ["stringLiteral"]},
    {"name": "ObjectItem$subexpression$1", "symbols": [(LEXER.has("id") ? {type: "id"} : id)]},
    {"name": "ObjectItem", "symbols": ["ObjectItem$subexpression$1", {"literal":":"}, "ConversionOpExp"], "postprocess": d => ['objectItem', unwrap(d[0][0]), d[2]]},
    {"name": "ObjectAccess", "symbols": ["PrimaryExp", {"literal":"."}, (LEXER.has("id") ? {type: "id"} : id)], "postprocess": d => ["objectAccess", d[0], d[2]]},
    {"name": "PrimaryExp", "symbols": [(LEXER.has("id") ? {type: "id"} : id)], "postprocess": id},
    {"name": "PrimaryExp", "symbols": ["literal"], "postprocess": id},
    {"name": "PrimaryExp", "symbols": ["ArrayLiteral"], "postprocess": id},
    {"name": "PrimaryExp", "symbols": ["ArrayAccess"], "postprocess": id},
    {"name": "PrimaryExp", "symbols": ["ObjectLiteral"], "postprocess": id},
    {"name": "PrimaryExp", "symbols": ["ObjectAccess"], "postprocess": id},
    {"name": "PrimaryExp", "symbols": ["FunctionStatement"], "postprocess": id},
    {"name": "PrimaryExp", "symbols": [{"literal":"("}, "Exp", {"literal":")"}], "postprocess": d => ["parenExpr", unwrap(d[1])]},
    {"name": "PrimaryExp", "symbols": [{"literal":"|"}, "Exp", {"literal":"|"}], "postprocess": d => ["absValue", unwrap(d[1])]},
    {"name": "LValue", "symbols": ["PrimaryExp"], "postprocess": id /* assignable left hand side expression */},
    {"name": "RValue", "symbols": ["CallExp"]},
    {"name": "RValue", "symbols": ["LValue"], "postprocess": id /* executable right hand side expression */},
    {"name": "keywordFunctions$subexpression$1", "symbols": [(LEXER.has("and") ? {type: "and"} : and)]},
    {"name": "keywordFunctions$subexpression$1", "symbols": [(LEXER.has("or") ? {type: "or"} : or)]},
    {"name": "keywordFunctions$subexpression$1", "symbols": [{"literal":"if"}]},
    {"name": "keywordFunctions", "symbols": ["keywordFunctions$subexpression$1"], "postprocess": id},
    {"name": "keywordFunctionsUnary$subexpression$1", "symbols": [(LEXER.has("not") ? {type: "not"} : not)]},
    {"name": "keywordFunctionsUnary", "symbols": ["keywordFunctionsUnary$subexpression$1"], "postprocess": id},
    {"name": "CallExp", "symbols": [(LEXER.has("decimal") ? {type: "decimal"} : decimal), "CallExp"], "postprocess": d => ["scaledCallExp", d[0], d[1]].map(unwrap)},
    {"name": "CallExp", "symbols": [(LEXER.has("id") ? {type: "id"} : id), "Arguments"], "postprocess": d =>['callExp', d[0], d[1].map(unwrap).filter(hasContent)]},
    {"name": "CallExp", "symbols": ["ObjectAccess", "Arguments"], "postprocess": d => ['callExp', d[0][2], [d[0][1], ...d[1].map(unwrap).filter(hasContent)]]},
    {"name": "CallExp", "symbols": ["CallExp", {"literal":"."}, (LEXER.has("id") ? {type: "id"} : id), "Arguments"], "postprocess": d => ['callExp', d[2], [['parenExpr', d[0]], ...d[3].map(unwrap).filter(hasContent)]]},
    {"name": "CallExp", "symbols": ["keywordFunctions", "MultipleArguments"], "postprocess": d => ['callExpWithKeyword', unwrap(d[0]), d[1].map(unwrap).filter(hasContent)]},
    {"name": "CallExp", "symbols": ["keywordFunctionsUnary", "SingleArgument"], "postprocess": d => ['callExpWithKeyword', unwrap(d[0]), d[1].map(unwrap).filter(hasContent)]},
    {"name": "SingleArgument", "symbols": [{"literal":"("}, "Argument", {"literal":")"}], "postprocess": (d) => d[1]},
    {"name": "MultipleArguments$ebnf$1$subexpression$1", "symbols": [{"literal":","}, "Argument"]},
    {"name": "MultipleArguments$ebnf$1", "symbols": ["MultipleArguments$ebnf$1$subexpression$1"]},
    {"name": "MultipleArguments$ebnf$1$subexpression$2", "symbols": [{"literal":","}, "Argument"]},
    {"name": "MultipleArguments$ebnf$1", "symbols": ["MultipleArguments$ebnf$1", "MultipleArguments$ebnf$1$subexpression$2"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "MultipleArguments", "symbols": [{"literal":"("}, "Argument", "MultipleArguments$ebnf$1", {"literal":")"}], "postprocess": (d) => [d[1], ...(d[2] || []).map(([comma, arg]) => unwrap(arg))]},
    {"name": "Arguments$ebnf$1", "symbols": []},
    {"name": "Arguments$ebnf$1$subexpression$1", "symbols": [{"literal":","}, "Argument"]},
    {"name": "Arguments$ebnf$1", "symbols": ["Arguments$ebnf$1", "Arguments$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "Arguments", "symbols": [{"literal":"("}, "Argument", "Arguments$ebnf$1", {"literal":")"}], "postprocess": (d) => [d[1], ...(d[2] || []).map(([comma, arg]) => unwrap(arg))]},
    {"name": "Argument", "symbols": [(LEXER.has("rowRange") ? {type: "rowRange"} : rowRange)]},
    {"name": "Argument", "symbols": ["FunctionStatement"]},
    {"name": "Argument", "symbols": ["AssignmentExp"]},
    {"name": "Argument", "symbols": []},
    {"name": "PostfixExp$subexpression$1", "symbols": [{"literal":"++"}]},
    {"name": "PostfixExp$subexpression$1", "symbols": [{"literal":"--"}]},
    {"name": "PostfixExp", "symbols": ["LValue", "PostfixExp$subexpression$1"], "postprocess": d => ["postfix", d[0], d[1]].map(unwrap)},
    {"name": "PostfixExp", "symbols": ["RValue", {"literal":"!"}], "postprocess": d => ["factorial", d[0]].map(unwrap)},
    {"name": "PostfixExp", "symbols": ["PercentExp"], "postprocess": unwrap},
    {"name": "PostfixExp", "symbols": ["RValue"], "postprocess": unwrap},
    {"name": "PercentExp", "symbols": ["RValue", {"literal":"%"}], "postprocess": d => ["pctExpression", d[0]].map(unwrap)},
    {"name": "UnaryExp$subexpression$1", "symbols": [{"literal":"!"}]},
    {"name": "UnaryExp$subexpression$1", "symbols": [{"literal":"not"}]},
    {"name": "UnaryExp$subexpression$1", "symbols": [{"literal":"~"}]},
    {"name": "UnaryExp$subexpression$1", "symbols": [{"literal":"++"}]},
    {"name": "UnaryExp$subexpression$1", "symbols": [{"literal":"--"}]},
    {"name": "UnaryExp$subexpression$1", "symbols": [{"literal":"+"}]},
    {"name": "UnaryExp$subexpression$1", "symbols": [{"literal":"-"}]},
    {"name": "UnaryExp", "symbols": ["UnaryExp$subexpression$1", "UnaryExp"], "postprocess": d => ["unary",  id(d[0]).value, d[1]]},
    {"name": "UnaryExp", "symbols": ["PostfixExp"], "postprocess": unwrap},
    {"name": "ExponentExp$subexpression$1", "symbols": [{"literal":"^"}]},
    {"name": "ExponentExp$subexpression$1", "symbols": [{"literal":"**"}]},
    {"name": "ExponentExp", "symbols": ["UnaryExp", "ExponentExp$subexpression$1", "ExponentExp"], "postprocess": d => ["power", d[0], d[2]].map(unwrap)},
    {"name": "ExponentExp", "symbols": ["UnaryExp"], "postprocess": unwrap},
    {"name": "MultiplicativeExp", "symbols": ["MultiplicativeExp", (LEXER.has("mod") ? {type: "mod"} : mod), "ExponentExp"], "postprocess": d => ["mod", d[0], d[2]].map(unwrap)},
    {"name": "MultiplicativeExp", "symbols": ["ExponentExp"], "postprocess": unwrap},
    {"name": "ParenExp", "symbols": [{"literal":"("}, "Exp", {"literal":")"}], "postprocess": d => d[1]},
    {"name": "ParenExpWithExponent$subexpression$1", "symbols": [{"literal":"^"}]},
    {"name": "ParenExpWithExponent$subexpression$1", "symbols": [{"literal":"**"}]},
    {"name": "ParenExpWithExponent", "symbols": ["ParenExp", "ParenExpWithExponent$subexpression$1", "ExponentExp"], "postprocess": d => ["power2", d[0], d[2]].map(unwrap)},
    {"name": "ImplicitMultPrefix", "symbols": ["numericLiteral"], "postprocess": unwrap},
    {"name": "ImplicitMultPrefix", "symbols": ["PercentExp"], "postprocess": unwrap},
    {"name": "ImplicitMultPrefix$subexpression$1", "symbols": [{"literal":"^"}]},
    {"name": "ImplicitMultPrefix$subexpression$1", "symbols": [{"literal":"**"}]},
    {"name": "ImplicitMultPrefix", "symbols": ["numericLiteral", "ImplicitMultPrefix$subexpression$1", "numericLiteral"], "postprocess": d => ["power3", d[0], d[2]].map(unwrap)},
    {"name": "ImplicitMultPrefix", "symbols": ["numericDivision"], "postprocess": unwrap},
    {"name": "ImplicitMultPrefix", "symbols": ["ImplicitMultTerm"]},
    {"name": "ImplicitMultTerm", "symbols": ["ParenExp"]},
    {"name": "ImplicitMultTerm", "symbols": ["ParenExpWithExponent"], "postprocess": unwrap},
    {"name": "ParenMultExp$ebnf$1", "symbols": ["unitLabel"], "postprocess": id},
    {"name": "ParenMultExp$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "ParenMultExp", "symbols": ["ImplicitMultSequence", "ParenMultExp$ebnf$1"], "postprocess": d => ["parenMult", ...(d.filter(x => x))].map(unwrap)},
    {"name": "ImplicitMultSequence$ebnf$1", "symbols": ["ImplicitMultTerm"]},
    {"name": "ImplicitMultSequence$ebnf$1", "symbols": ["ImplicitMultSequence$ebnf$1", "ImplicitMultTerm"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "ImplicitMultSequence", "symbols": ["ImplicitMultPrefix", "ImplicitMultSequence$ebnf$1"]},
    {"name": "ImplicitMultSequence$ebnf$2", "symbols": ["ImplicitMultTerm"]},
    {"name": "ImplicitMultSequence$ebnf$2", "symbols": ["ImplicitMultSequence$ebnf$2", "ImplicitMultTerm"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "ImplicitMultSequence", "symbols": ["ImplicitMultSequence$ebnf$2", "ImplicitMultSuffix"]},
    {"name": "ImplicitMultSuffix", "symbols": ["numericLiteral"]},
    {"name": "UnitAwareMultExp", "symbols": ["UnitAwareMultExp", {"literal":"*"}, "MultiplicativeOperand"], "postprocess": d => ["mul", d[0], d[2]].map(unwrap)},
    {"name": "UnitAwareMultExp", "symbols": ["UnitAwareMultExp", {"literal":"/"}, "MultiplicativeExpWithUnit"], "postprocess": d => ["divUnit", d[0], d[2]].map(unwrap)},
    {"name": "UnitAwareMultExp", "symbols": ["UnitAwareMultExp", {"literal":"/"}, "MultiplicativeExp"], "postprocess": d => ["div", d[0], d[2]].map(unwrap)},
    {"name": "UnitAwareMultExp", "symbols": ["ParenMultExp", {"literal":"/"}, "ParenMultExp"], "postprocess": d => ["div", d[0], d[2]].map(unwrap)},
    {"name": "UnitAwareMultExp", "symbols": ["UnitAwareMultExp", "customOp", "MultiplicativeExp"], "postprocess": d => ["customOp", d[0], d[1], d[2]].map(unwrap)},
    {"name": "UnitAwareMultExp", "symbols": ["ParenMultExp"], "postprocess": id},
    {"name": "UnitAwareMultExp", "symbols": ["MultiplicativeExpWithUnit"], "postprocess": id},
    {"name": "UnitAwareMultExp", "symbols": ["MultiplicativeExp"], "postprocess": id},
    {"name": "customOp", "symbols": [{"literal":":"}, (LEXER.has("id") ? {type: "id"} : id), {"literal":":"}], "postprocess": d => `:${d[1].value}:`},
    {"name": "MultiplicativeOperand", "symbols": ["MultiplicativeExpWithUnit"]},
    {"name": "MultiplicativeOperand", "symbols": ["MultiplicativeExp"]},
    {"name": "MultiplicativeOperand", "symbols": ["ParenMultExp"]},
    {"name": "MultiplicativeExpWithUnit", "symbols": ["MultiplicativeExp", "unitLabel"], "postprocess": d => ["unit", d[0], d[1]]},
    {"name": "unitLabel$ebnf$1", "symbols": []},
    {"name": "unitLabel$ebnf$1", "symbols": ["unitLabel$ebnf$1", "unitLabelParts"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "unitLabel", "symbols": ["unitID", "unitLabel$ebnf$1"], "postprocess": d => `${d[0]} ${d[1] && d[1].join(' ')}`.trim()},
    {"name": "unitID$ebnf$1", "symbols": ["unitLabelPower"], "postprocess": id},
    {"name": "unitID$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "unitID", "symbols": [(LEXER.has("id") ? {type: "id"} : id), "unitID$ebnf$1"], "postprocess": d => `${d[0]}${d[1] ? d[1] : ''}`},
    {"name": "unitLabelParts", "symbols": ["unitID"]},
    {"name": "unitLabelParts", "symbols": [{"literal":"_"}]},
    {"name": "unitLabelParts", "symbols": [{"literal":"'"}]},
    {"name": "unitLabelParts", "symbols": [{"literal":" "}]},
    {"name": "unitLabelParts", "symbols": ["numericLiteral"], "postprocess": d => `${d[0]}`},
    {"name": "unitLabelPower$ebnf$1", "symbols": [{"literal":"-"}], "postprocess": id},
    {"name": "unitLabelPower$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "unitLabelPower$ebnf$2", "symbols": [(LEXER.has("decimal") ? {type: "decimal"} : decimal)]},
    {"name": "unitLabelPower$ebnf$2", "symbols": ["unitLabelPower$ebnf$2", (LEXER.has("decimal") ? {type: "decimal"} : decimal)], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "unitLabelPower", "symbols": [{"literal":"^"}, "unitLabelPower$ebnf$1", "unitLabelPower$ebnf$2"], "postprocess": d => `${d[0]}${d[1] ? "-" : ''}${d[2]}`},
    {"name": "UnitExp", "symbols": ["UnitAwareMultExp"], "postprocess": id},
    {"name": "AdditiveExp$subexpression$1", "symbols": [{"literal":"+"}]},
    {"name": "AdditiveExp$subexpression$1", "symbols": [{"literal":"-"}]},
    {"name": "AdditiveExp", "symbols": ["AdditiveExp", "AdditiveExp$subexpression$1", "UnitExp"], "postprocess":  d => {
            if (Array.isArray(d[2]) && d[2][0] == "pctExpression") {
                return ["pctChange", d[0], d[1], d[2]].map(unwrap);
            }
            let op = d[1] == "+" ? "add" : "sub";
            
            return [op, d[0], d[2]].map(unwrap);
            
        }},
    {"name": "AdditiveExp$subexpression$2", "symbols": [(LEXER.has("off") ? {type: "off"} : off)]},
    {"name": "AdditiveExp$subexpression$2", "symbols": [(LEXER.has("of") ? {type: "of"} : of)]},
    {"name": "AdditiveExp$subexpression$2", "symbols": [(LEXER.has("from") ? {type: "from"} : from)]},
    {"name": "AdditiveExp", "symbols": ["RValue", {"literal":"%"}, "AdditiveExp$subexpression$2", "UnitExp"], "postprocess": d => ["pctOp", ...d].map(unwrap)},
    {"name": "AdditiveExp", "symbols": ["UnitExp"], "postprocess": unwrap},
    {"name": "ShiftExp", "symbols": ["ShiftExp", {"literal":"<<"}, "AdditiveExp"], "postprocess": d => ["lsl", d[0], d[2]].map(unwrap)},
    {"name": "ShiftExp", "symbols": ["ShiftExp", {"literal":">>>"}, "AdditiveExp"], "postprocess": d => ["lsr", d[0], d[2]].map(unwrap)},
    {"name": "ShiftExp", "symbols": ["ShiftExp", {"literal":">>"}, "AdditiveExp"], "postprocess": d => ["asr", d[0], d[2]].map(unwrap)},
    {"name": "ShiftExp", "symbols": ["AdditiveExp"], "postprocess": unwrap},
    {"name": "RelationalExp", "symbols": ["RelationalExp", {"literal":"<"}, "ShiftExp"], "postprocess": d => ["lt", d[0], d[2]].map(unwrap)},
    {"name": "RelationalExp", "symbols": ["RelationalExp", {"literal":">"}, "ShiftExp"], "postprocess": d => ["gt", d[0], d[2]].map(unwrap)},
    {"name": "RelationalExp", "symbols": ["RelationalExp", {"literal":"<="}, "ShiftExp"], "postprocess": d => ["le", d[0], d[2]].map(unwrap)},
    {"name": "RelationalExp", "symbols": ["RelationalExp", {"literal":">="}, "ShiftExp"], "postprocess": d => ["ge", d[0], d[2]].map(unwrap)},
    {"name": "RelationalExp", "symbols": ["ShiftExp"], "postprocess": unwrap},
    {"name": "EqualityExp", "symbols": ["EqualityExp", {"literal":"=="}, "RelationalExp"], "postprocess": d => ["equal", d[0], d[2]].map(unwrap)},
    {"name": "EqualityExp", "symbols": ["EqualityExp", {"literal":"!="}, "RelationalExp"], "postprocess": d => ["notEqual", d[0], d[2]].map(unwrap)},
    {"name": "EqualityExp", "symbols": ["EqualityExp", {"literal":"==="}, "RelationalExp"], "postprocess": d => ["eq", d[0], d[2]].map(unwrap)},
    {"name": "EqualityExp", "symbols": ["EqualityExp", {"literal":"!=="}, "RelationalExp"], "postprocess": d => ["notEq", d[0], d[2]].map(unwrap)},
    {"name": "EqualityExp", "symbols": ["RelationalExp"], "postprocess": id},
    {"name": "BitwiseANDExp$subexpression$1", "symbols": [(LEXER.has("and") ? {type: "and"} : and)]},
    {"name": "BitwiseANDExp$subexpression$1", "symbols": [{"literal":"&"}]},
    {"name": "BitwiseANDExp", "symbols": ["BitwiseANDExp", "BitwiseANDExp$subexpression$1", "EqualityExp"], "postprocess": d => ["band", d[0], d[2]].map(unwrap)},
    {"name": "BitwiseANDExp", "symbols": ["EqualityExp"], "postprocess": id},
    {"name": "BitwiseXORExp", "symbols": ["BitwiseXORExp", (LEXER.has("xor") ? {type: "xor"} : xor), "BitwiseANDExp"], "postprocess": d => ["bxor", d[0], d[2]].map(unwrap)},
    {"name": "BitwiseXORExp", "symbols": ["BitwiseANDExp"], "postprocess": id},
    {"name": "BitwiseORExp$subexpression$1", "symbols": [(LEXER.has("or") ? {type: "or"} : or)]},
    {"name": "BitwiseORExp$subexpression$1", "symbols": [{"literal":"|"}]},
    {"name": "BitwiseORExp", "symbols": ["BitwiseORExp", "BitwiseORExp$subexpression$1", "BitwiseXORExp"], "postprocess": d => ["bor", d[0], d[2]].map(unwrap)},
    {"name": "BitwiseORExp", "symbols": ["BitwiseXORExp"], "postprocess": id},
    {"name": "LogicalANDExp", "symbols": ["LogicalANDExp", {"literal":"&&"}, "BitwiseORExp"], "postprocess": d => ["land", d[0], d[2]].map(unwrap)},
    {"name": "LogicalANDExp", "symbols": ["BitwiseORExp"], "postprocess": id},
    {"name": "LogicalORExp", "symbols": ["LogicalORExp", {"literal":"||"}, "LogicalANDExp"], "postprocess": d => ["lor", d[0], d[2]].map(unwrap)},
    {"name": "LogicalORExp", "symbols": ["LogicalANDExp"], "postprocess": id},
    {"name": "ConditionalExp", "symbols": ["LogicalORExp", {"literal":"?"}, "AssignmentExp", {"literal":":"}, "AssignmentExp"], "postprocess": d => ["conditional", d[0], d[2], d[4]].map(unwrap)},
    {"name": "ConditionalExp", "symbols": ["LogicalORExp"], "postprocess": id},
    {"name": "ConversionOpExp", "symbols": ["ConversionWithArithmetic"], "postprocess": id},
    {"name": "ConversionOpExp$subexpression$1", "symbols": ["allowedConversionSymbols"]},
    {"name": "ConversionOpExp$subexpression$1", "symbols": ["UnitExp"]},
    {"name": "ConversionOpExp", "symbols": ["ConversionOpExp", (LEXER.has("conversionOp") ? {type: "conversionOp"} : conversionOp), "ConversionOpExp$subexpression$1"], "postprocess": d => ["conversion", d[0], d[2]].map(unwrap)},
    {"name": "ConversionOpExp$subexpression$2", "symbols": ["ConversionDivision"]},
    {"name": "ConversionOpExp", "symbols": ["ConversionOpExp", (LEXER.has("conversionOp") ? {type: "conversionOp"} : conversionOp), "ConversionOpExp$subexpression$2"], "postprocess": d => ["conversionDiv", d[0], d[2]].map(unwrap)},
    {"name": "ConversionOpExp", "symbols": ["ConversionOpExp", (LEXER.has("typesolveOp") ? {type: "typesolveOp"} : typesolveOp), "ConditionalExp"], "postprocess": d => ["typesolve", d[0], d[2]].map(unwrap)},
    {"name": "ConversionOpExp", "symbols": ["ConditionalExp"], "postprocess": id},
    {"name": "ConversionOpExp", "symbols": ["RateExp"], "postprocess": id},
    {"name": "ConversionWithArithmetic$subexpression$1", "symbols": ["allowedConversionSymbols"]},
    {"name": "ConversionWithArithmetic$subexpression$1", "symbols": ["ConditionalExp"]},
    {"name": "ConversionWithArithmetic$subexpression$2", "symbols": [{"literal":"+"}]},
    {"name": "ConversionWithArithmetic$subexpression$2", "symbols": [{"literal":"-"}]},
    {"name": "ConversionWithArithmetic$subexpression$2", "symbols": [{"literal":"*"}]},
    {"name": "ConversionWithArithmetic", "symbols": ["ConditionalExp", (LEXER.has("conversionOp") ? {type: "conversionOp"} : conversionOp), "ConversionWithArithmetic$subexpression$1", "ConversionWithArithmetic$subexpression$2", "AdditiveExp"], "postprocess": d => [CONVERSION_OP[d[3]], ["conversion", d[0], d[2]].map(unwrap), d[4]]},
    {"name": "ConversionWithArithmetic$subexpression$3", "symbols": ["ConversionDivision"]},
    {"name": "ConversionWithArithmetic$subexpression$4", "symbols": [{"literal":"+"}]},
    {"name": "ConversionWithArithmetic$subexpression$4", "symbols": [{"literal":"-"}]},
    {"name": "ConversionWithArithmetic$subexpression$4", "symbols": [{"literal":"*"}]},
    {"name": "ConversionWithArithmetic", "symbols": ["ConditionalExp", (LEXER.has("conversionOp") ? {type: "conversionOp"} : conversionOp), "ConversionWithArithmetic$subexpression$3", "ConversionWithArithmetic$subexpression$4", "AdditiveExp"], "postprocess": d => [CONVERSION_OP[d[3]], ["conversionDiv", d[0], d[2]].map(unwrap), d[4]]},
    {"name": "ConversionDivision", "symbols": [{"literal":"/"}, "ConditionalExp"]},
    {"name": "RateExp", "symbols": ["MultiplicativeExpWithUnit", {"literal":"="}, "Exp"], "postprocess": d=> ["rate", d[0], d[2]]},
    {"name": "allowedConversionSymbols", "symbols": [{"literal":"%"}]},
    {"name": "AssignmentExp", "symbols": ["ConversionOpExp"], "postprocess": id},
    {"name": "AssignmentExp", "symbols": ["PrimaryExp", "assignmentOperator", "AssignmentExp"], "postprocess": d => ["assignmentExp", d[0], d[1], d[2]].map(unwrap)},
    {"name": "AssignmentExp", "symbols": ["IfStatement"], "postprocess": id},
    {"name": "AssignmentExp", "symbols": ["FunctionStatement"], "postprocess": id},
    {"name": "assignmentOperator", "symbols": [{"literal":"="}]},
    {"name": "assignmentOperator", "symbols": [{"literal":"*="}]},
    {"name": "assignmentOperator", "symbols": [{"literal":"/="}]},
    {"name": "assignmentOperator", "symbols": [{"literal":"+="}]},
    {"name": "assignmentOperator", "symbols": [{"literal":"-="}], "postprocess": id},
    {"name": "Exp", "symbols": ["AssignmentExp"], "postprocess": unwrap},
    {"name": "Exp$ebnf$1", "symbols": ["commaExp"]},
    {"name": "Exp$ebnf$1", "symbols": ["Exp$ebnf$1", "commaExp"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "Exp", "symbols": ["AssignmentExp", "Exp$ebnf$1"], "postprocess": d => ["commaExp", d[0], ...d[1]]},
    {"name": "commaExp", "symbols": [{"literal":","}, "AssignmentExp"], "postprocess": d => d[1]},
    {"name": "StatementNotEmpty", "symbols": ["Block"], "postprocess": id},
    {"name": "StatementNotEmpty", "symbols": ["ExpStatement"], "postprocess": id},
    {"name": "StatementNotEmpty", "symbols": ["IfStatement"], "postprocess": id},
    {"name": "StatementNotEmpty", "symbols": ["FunctionStatement"], "postprocess": id},
    {"name": "Statement", "symbols": ["StatementNotEmpty"], "postprocess": id},
    {"name": "Statement", "symbols": ["EmptyStatement"], "postprocess": d => null},
    {"name": "IfStatement$ebnf$1$subexpression$1", "symbols": [{"literal":"else"}, "StatementNotEmpty"]},
    {"name": "IfStatement$ebnf$1", "symbols": ["IfStatement$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "IfStatement$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "IfStatement", "symbols": [{"literal":"if"}, {"literal":"("}, "Exp", {"literal":")"}, "StatementNotEmpty", "IfStatement$ebnf$1"], "postprocess":  d => ({
            type: "ifStatement",
            ifcond: d[2],
            ifbody: d[4],
            elsebody: d[5] ? d[5][1] : null
        }) },
    {"name": "FunctionStatement", "symbols": [{"literal":"function"}, (LEXER.has("id") ? {type: "id"} : id), {"literal":"("}, "ParamList", {"literal":")"}, "Block"], "postprocess": d => ["functionDeclaration", d[1], d[3], d[5]]},
    {"name": "FunctionStatement", "symbols": [{"literal":"function"}, {"literal":"("}, "ParamList", {"literal":")"}, "Block"], "postprocess": d => ["functionDeclaration", "", d[2], d[4]] /* anonymous fn */},
    {"name": "FunctionStatement", "symbols": [(LEXER.has("id") ? {type: "id"} : id), (LEXER.has("rarrow") ? {type: "rarrow"} : rarrow), "ConditionalExp"], "postprocess": d => ["functionDeclaration", "", [d[0]], d[2]] /* x => expr */},
    {"name": "FunctionStatement", "symbols": [{"literal":"("}, "ParamList", {"literal":")"}, (LEXER.has("rarrow") ? {type: "rarrow"} : rarrow), "ConditionalExp"], "postprocess": d => ["functionDeclaration", "", d[1], d[4]] /* (x,y) => expr */},
    {"name": "ParamList$ebnf$1$subexpression$1$ebnf$1", "symbols": []},
    {"name": "ParamList$ebnf$1$subexpression$1$ebnf$1$subexpression$1", "symbols": [{"literal":","}, (LEXER.has("id") ? {type: "id"} : id)]},
    {"name": "ParamList$ebnf$1$subexpression$1$ebnf$1", "symbols": ["ParamList$ebnf$1$subexpression$1$ebnf$1", "ParamList$ebnf$1$subexpression$1$ebnf$1$subexpression$1"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "ParamList$ebnf$1$subexpression$1", "symbols": [(LEXER.has("id") ? {type: "id"} : id), "ParamList$ebnf$1$subexpression$1$ebnf$1"]},
    {"name": "ParamList$ebnf$1", "symbols": ["ParamList$ebnf$1$subexpression$1"], "postprocess": id},
    {"name": "ParamList$ebnf$1", "symbols": [], "postprocess": function(d) {return null;}},
    {"name": "ParamList", "symbols": ["ParamList$ebnf$1"], "postprocess": d => d[0] ? [d[0][0], ...(d[0][1] || []).map(item => item[1])] : []},
    {"name": "ExpStatement", "symbols": ["Exp"], "postprocess": id},
    {"name": "EmptyStatement", "symbols": []},
    {"name": "Block", "symbols": [{"literal":"{"}, "StatementList", {"literal":"}"}], "postprocess": d => d[1]},
    {"name": "StatementList", "symbols": ["Statement"], "postprocess": id},
    {"name": "StatementList$ebnf$1$subexpression$1", "symbols": [(LEXER.has("sc") ? {type: "sc"} : sc), "Statement"], "postprocess": d => d[1]},
    {"name": "StatementList$ebnf$1", "symbols": ["StatementList$ebnf$1$subexpression$1"]},
    {"name": "StatementList$ebnf$1$subexpression$2", "symbols": [(LEXER.has("sc") ? {type: "sc"} : sc), "Statement"], "postprocess": d => d[1]},
    {"name": "StatementList$ebnf$1", "symbols": ["StatementList$ebnf$1", "StatementList$ebnf$1$subexpression$2"], "postprocess": function arrpush(d) {return d[0].concat([d[1]]);}},
    {"name": "StatementList", "symbols": ["Statement", "StatementList$ebnf$1"], "postprocess": d => [d[0], ...d[1].filter(x => x)].map(unwrap)},
    {"name": "Program", "symbols": ["StatementList"], "postprocess": id}
]
  , ParserStart: "main"
}
if (typeof module !== 'undefined'&& typeof module.exports !== 'undefined') {
   module.exports = grammar;
} else {
   window.instacalc_grammar = grammar;
}
})();
;
// @ts-check

/*

## General processing flow 
        
  [Preprocess]          Apply string/regex changes in CONFIG (i.e. "in" becomes " -> ")
  [Parse]               Parse into AST using grammar (Nearley.js) 
  [Evaluate]            Execute AST with various modules (Math, Type, Unit, Eval)
  [Postprocess]         Format final result (decimal places, help text, logs, etc.)

## Components

- CONFIG      Goal: data driven where possible
- IC          main facade, with submodules for
  Core
  Logs
  Environment   - Execution state
  Object        - internal ICObject 
  Literal       - base primitives
  Type          - type system
  String
  Parse
  Semantic      - AST operations
  Math
  Eval          

- IC.parser     - apply preprocess/parse rules with config

## Classes

- ICUnit      
- ICTime      
- ICDate      
- ICLib
*/


/** @global */
var LIB = {};

LIB.nearley = nearley || window?.nearley;
LIB.text2num = text2num || window?.text2num;
LIB.Inflector = Inflector || window?.Inflector;
LIB.toFractionIterative = toFractionIterative || window?.toFractionIterative;

LIB.InstaCalc = InstaCalc || window?.InstaCalc;
LIB.Unit = Unit || window?.Unit;
LIB.Calc = typeof Calc !== "undefined" ? Calc : window?.Calc;
LIB.Complex = LIB.InstaCalc.Complex;

/** @global */
// @ts-ignore
const GRAMMAR = window.instacalc_grammar;
const LEXER = GRAMMAR.Lexer;
const GRAMMAR_FROM_COMPILED = LIB.nearley.Grammar.fromCompiled(GRAMMAR);

const CONFIG = {

  SETTINGS: {
    MAX_ARRAY_SIZE: 1000,
  },

  // warns user if overridden
  KEYWORDS: {
    and: true,
    or: true,
    not: true,
    xor: true,

    mod: true,
    off: true,
    from: true,

    in: true,
    into: true,
    to: true,
    as: true,
    en: true,
    if: true,
    else: true,

    using: true,
    with: true,
    at: true,
    per: true,
    every: true,
    until: true,
  },

  // 10 sales per 3 days => 10 sales / 3 days
  UNIT_DIVISION_REGEX: {
    find: /\b(per|for|every|each|until)\b/gi,
    replace: "/",
  },

  STOP_WORDS: {
    a: true,
    an: true,
    and: true,
    are: true,
    as: true,
    at: true,
    be: true,
    but: true,
    by: true,
    for: true,
    if: true,
    in: true,
    into: true,
    is: true,
    it: true,
    no: true,
    not: true,
    of: true,
    on: true,
    or: true,
    such: true,
    that: true,
    the: true,
    their: true,
    then: true,
    there: true,
    these: true,
    they: true,
    this: true,
    to: true,
    was: true,
    will: true,
    with: true,

    // for loan: pay off over 
    over: true,
    off: true,
  },

  FN_REMOVE_STOP_WORDS: (str) => {
    // delete stop words from string; loop through
    let SYMBOLS = ["@", "->"];
    let words = str.split(/\s+/);
    let newWords = [];
    for (let i = 0; i < words.length; i++) {
      if (!CONFIG.STOP_WORDS[words[i].toLowerCase()] && !SYMBOLS.includes(words[i])) {
        newWords.push(words[i]);
      }
    }

    return newWords.join(" ");
  },

  // prefixed with \
  SYMBOLS: {
    // operators - https://www.classe.cornell.edu/~dms79/LectureNotes/formulae/list-of-math-symbols-extended.htm 
    plus: "\u002B",
    minus: "\u2212",
    times: "\u00D7",
    mult: "\u00D7",
    div: "\u00F7",

    lt: "<",
    gt: ">",
    ne: "≠",
    "!=": "≠",
    eq: "=",
    le: "≤",
    "<=": "≤",
    ge: "≥",
    ">=": "≥",

    root: "\u221A",
    sqrt: "\u221A",
    cbrt: "\u221B",

    // exponents
    "0": "\u2070",
    "1": "\u00B9", // ¹
    "2": "\u00B2", // ² 
    "3": "\u00B3", // ³ 
    "4": "\u2074",
    "5": "\u2075",
    "6": "\u2076",
    "7": "\u2077",
    "8": "\u2078",
    "9": "\u2079",

    // neg exponents
    "-0": "\u207B\u2070",
    "-1": "\u207B\u00B9", // ¹
    "-2": "\u207B\u00B2", // ² 
    "-3": "\u207B\u00B3", // ³ 
    "-4": "\u207B\u2074",
    "-5": "\u207B\u2075",
    "-6": "\u207B\u2076",
    "-7": "\u207B\u2077",
    "-8": "\u207B\u2078",
    "-9": "\u207B\u2079",

    // subscripts
    "_0": "\u2080",
    "_1": "\u2081",
    "_2": "\u2082",
    "_3": "\u2083",
    "_4": "\u2084",
    "_5": "\u2085",
    "_6": "\u2086",
    "_7": "\u2087",
    "_8": "\u2088",
    "_9": "\u2089",

    // latex symbols
    dot: "·",
    bullet: "\u2022",
    cdot: "·",
    deg: "\u00B0",

    // calc symbols
    del: "∂",
    partial: "∂",
    grad: "∇",
    nabla: "∇",
    angle: "∠",
    triangle: "△",
    star: "★",
    sum: "\u03A3", // sigma
    int: "∫",
    oint: "∮",
    prop: "∝",
    propto: "∝",
    approx: "≈",

    // greeks - http://www.javascripter.net/faq/greekletters.htm
    Alpha: "\u0391", // Α,
    Beta: "\u0392", // Β,
    Gamma: "\u0393", // Γ,
    Delta: "\u0394", // Δ,
    Epsilon: "\u0395", // Ε,
    Zeta: "\u0396", // Ζ,
    Eta: "\u0397", // Η,
    Theta: "\u0398", // Θ,
    Iota: "\u0399", // Ι,
    Kappa: "\u039A", // Κ,
    Lambda: "\u039B", // Λ,
    Mu: "\u039C", // Μ,
    Nu: "\u039D", // Ν,
    Xi: "\u039E", // Ξ,
    Omicron: "\u039F", // Ο,
    Pi: "\u03A0", // Π,
    Rho: "\u03A1", // Ρ,
    Sigma: "\u03A3", // Σ,
    Tau: "\u03A4", // Τ,
    Upsilon: "\u03A5", // Υ,
    upsih: "\u03D2", // ϒ,
    Phi: "\u03A6", // Φ,
    Chi: "\u03A7", // Χ,
    Psi: "\u03A8", // Ψ,
    Omega: "\u03A9", // Ω,
    alpha: "\u03B1", // α,
    beta: "\u03B2", // β,
    gamma: "\u03B3", // γ,
    delta: "\u03B4", // δ,
    epsilon: "\u03B5", // ε,
    zeta: "\u03B6", // ζ,
    eta: "\u03B7", // η,
    theta: "\u03B8", // θ,
    thetasym: "\u03D1", // ϑ,
    iota: "\u03B9", // ι,
    kappa: "\u03BA", // κ,
    lambda: "\u03BB", // λ,
    mu: "\u03BC", // μ,
    nu: "\u03BD", // ν,
    xi: "\u03BE", // ξ,
    omicron: "\u03BF", // ο,
    pi: "\u03C0", // π,
    piv: "\u03D6", // ϖ,
    rho: "\u03C1", // ρ,
    sigmaf: "\u03C2", // ς,
    sigma: "\u03C3", // σ,
    tau: "\u03C4", // τ,
    upsilon: "\u03C5", // υ,
    phi: "\u03C6", // φ,
    chi: "\u03C7", // χ,
    psi: "\u03C8", // ψ,
    omega: "\u03C9", // ω,

    // other symbols
    rightarrow: "→",
    infty: "∞",

    micro: "µ",

    // curisve script
    // https://www.w3.org/TR/xml-entity-names/1D4.html
    // Idea: let people enter variables, constants, etc. that don't interfere
    // with built-in units (c), etc.
    A: "𝓐",
    B: "𝓑",
    C: "𝓒",
    D: "𝓓",
    E: "𝓔",
    F: "𝓕",
    G: "𝓖",
    H: "𝓗",
    I: "𝓘",
    J: "𝓙",
    K: "𝓚",
    L: "𝓛",
    M: "𝓜",
    N: "𝓝",
    O: "𝓞",
    P: "𝓟",
    Q: "𝓠",
    R: "𝓡",
    S: "𝓢",
    T: "𝓣",
    U: "𝓤",
    V: "𝓥",
    W: "𝓦",
    X: "𝓧",
    Y: "𝓨",
    Z: "𝓩",

    a: "𝒂",
    b: "𝒃",
    c: "𝒄",
    d: "𝒅",
    e: "𝒆",
    f: "𝒇",
    g: "𝒈",
    h: "𝒉",
    i: "𝒊",
    j: "𝒋",
    k: "𝒌",
    l: "𝒍",
    m: "𝒎",
    n: "𝒏",
    o: "𝒐",
    p: "𝒑",
    q: "𝒒",
    r: "𝒓",
    s: "𝒔",
    t: "𝒕",
    u: "𝒖",
    v: "𝒗",
    w: "𝒘",
    x: "𝒙",
    y: "𝒚",
    z: "𝒛"
  },

  // not shown in custom list, as it's built-in
  CUSTOM_UNIT_IGNORE: { cycle: true, cycles: true },

  SCALES: {
    k: 1e3,
    hundred: 1e2,
    thousand: 1e3,

    // m: 1e6, // bad m! gone, for stephen
    million: 1e6,
    mln: 1e6,
    mio: 1e6, // german, somehow getting more commmon

    // TODO: have language packs which can add new units/scales? 

    b: 1e9,
    billion: 1e9,
    bil: 1e9,
    bn: 1e9,
    bln: 1e9,
    milliard: 1e9,

    t: 1e12,
    trillion: 1e12,

    quadrillion: 1e15,
    quintillion: 1e18,
    sextillion: 1e21,
    septillion: 1e24,

    rad: 180 / Math.PI,
    radian: 180 / Math.PI,
    radians: 180 / Math.PI,

    googol: 1e100,
    googolplex: 1e1000,

    i: LIB.Complex.pow(-1, 0.5),  // implicit unit as well as variable. Would like to clean up this for a single def.
  },

  NUMBER_SCALES: {
    dozen: 12,
    lakh: 1e5,
    lac: 1e5,
    cr: 1e7,
    crore: 1e7,
    score: 20,
  },

  SCALES_CASE_SENSITIVE: {
    M: 1e6,
  },

  // convert text to a number: "million" -> 1e6, for use in "123456 to nearest million"
  nearestNumberScale: (text) => {
    let textLower = text.toLowerCase();

    // exception for M, which means million here
    if (textLower == "m") {
      return CONFIG.SCALES_CASE_SENSITIVE["M"];
    }
    return CONFIG.SCALES[textLower] || CONFIG.NUMBER_SCALES[textLower] || null;
  },

  nearestNumberOrUnit: (x, multiple) => {
    if (typeof multiple != "number") {
      return x;
    }

    let newNum = Math.round(IC.val(x) / multiple) * multiple;

    if (IC.hasType(x)) {
      return IC.makeICObject(newNum, x.t, x.f);
    }
    else {
      return newNum;
    }
  },

  /* 3pi/2rad is interpreted as (3*pi/2) rad */
  SCALES_POST_CONVERT: {
    rad: "rad", // lookup key in the scales array
    radian: "rad",
    radians: "rad",
  },

  PREDEFINED: {
    TAU: 2 * Math.PI,
    PI: Math.PI,
    E: Math.E,
    //    IM_UNIT: LIB.Complex.pow(-1, 0.5),
    LOG10E: Math.LOG10E,
    LOG2E: Math.LOG2E,
    LN10: Math.LN10,
    LN2: Math.LN2,
    SQRT1_2: Math.SQRT1_2,
    PHI: (1 + Math.sqrt(5)) / 2,
    RAD: 180 / Math.PI, // acts like a constant as well
    RADIAN: 180 / Math.PI,
    RADIANS: 180 / Math.PI,

    // phystics constants
    GRAVITY: () => IC.makeICObject(9.8, "m/s^2"),
    SPEED_OF_LIGHT: () => IC.makeICObject(299792458, "m/s"),
    C_LIGHT: () => IC.makeICObject(299792458, "m/s"),
    SMALLG: () => IC.makeICObject(9.8, "m/s^2"),
    BIGG: () => IC.makeICObject(6.67408e-11, "m^3/kg/s^2"),
    PLANCK: () => IC.makeICObject(6.62607015e-34, "J s"),
    PLANCK_REDUCED: () => IC.makeICObject(6.62607015e-34 / (2 * Math.PI), "J*s"),
    HBAR: () => IC.makeICObject(6.62607015e-34 / (2 * Math.PI), "J s"),
    ELECTRON_CHARGE: () => IC.makeICObject(1.602176634e-19, "coulomb"),
    ELECTRON_MASS: () => IC.makeICObject(9.1093837015e-31, "kg"),
    PROTON_MASS: () => IC.makeICObject(1.67262192369e-27, "kg"),
    NEUTRON_MASS: () => IC.makeICObject(1.67492749804e-27, "kg"),
    R_GAS: () => IC.makeICObject(8.31446261815324, "J/K/mol"),
    F_FARADAY: () => IC.makeICObject(96485.33212331001, "coulomb/mol"),
    AVOGADRO_CONST: () => IC.makeICObject(6.02214076e23, "1/mol"),
    K_BOLTZMANN: () => IC.makeICObject(1.380649e-23, "J/K"),
  },

  PREDEFINED_FALLBACK: {
    I: LIB.Complex.pow(-1, 0.5), // too common to always be there, but it exists as a fallback
  },

  PREDEFINED_FUNCTION: {
    RANDOM: () => Math.random(),
    NOW: () => ICDate.makeICObject((new Date()).toISOString()),
    TODAY:
      () => {
        const date = new Date();
        date.setHours(0, 0, 0, 0);  // Set time to midnight in local timezone
        return ICDate.makeICObject(date.toISOString());
      },

    DATE: (year, month, day) => {
      if (year && month && day) {
        return ICDate.makeICObject(`${year}-${month}-${day}`);
      }

      return CONFIG.PREDEFINED_FUNCTION.TODAY();
    },
    TIME: () => CONFIG.PREDEFINED_FUNCTION.NOW(),

    YESTERDAY: () => {
      const date = new Date();
      date.setDate(date.getDate() - 1);
      date.setHours(0, 0, 0, 0);
      return ICDate.makeICObject(date.toISOString());
    },

    TOMORROW: () => {
      const date = new Date();
      date.setDate(date.getDate() + 1);
      date.setHours(0, 0, 0, 0);
      return ICDate.makeICObject(date.toISOString());
    },

    // + 1 for 1-based array, + 1 for next
    RNEXT: () => IC.envGetVariable("r" + (IC.envGetRowIndex() + 1 + 1)),
    RPREV: () => IC.envGetVariable("r" + (IC.envGetRowIndex() + 1 - 1)),
    ANS: () => CONFIG.PREDEFINED_FUNCTION.RPREV(),

    GOALSEEK: (targetVar, targetVal, freeVarArray) => {
      return { vars: freeVarArray, targetVar: targetVar, targetValue: targetVal, type: "goalseek" };
    },

    SET: (varMap) => {
      return { vars: varMap, type: "setvars" };
    },

    // should this be here, or in the engine function list?
    PHASOR: (mag, angle) => {
      return LIB.Complex.phasor(mag, angle);
    },



  },

  KEYWORD_FUNCTION: {
    IF: (condition, trueVal, falseVal) => IC.eval(IC.ifConditionCleanup(condition)) ? IC.eval(trueVal) : IC.eval(falseVal),
    AND: (...args) => args.every(arg => IC.eval(IC.ifConditionCleanup(arg))),
    OR: (...args) => args.some(arg => IC.eval(IC.ifConditionCleanup(arg))),
    NOT: (arg) => !IC.eval(IC.ifConditionCleanup(arg)),
  },

  /* do not wrap in parens for converions, since (rad) is a unit */
  PREDEFINED_AND_UNIT: {
    RAD: true,
    RADIAN: true,
    RADIANS: true,
  },

  POSTCONVERT_FUNCTIONS: {
    fraction: (x, denom) => {
      let [n, d] = IC.mathToFraction(IC.val(x), denom) ?? ['', ''];
      return `${n}/${d}`;
    },

    frac: "fraction",

    // @ts-ignore
    dec: (x) => IC.evalFunction("dec", [x]),
    decimal: "dec",

    // @ts-ignore
    hex: (x) => IC.evalFunction("hex", [x]),
    hexadecimal: "hex",

    // @ts-ignore
    oct: (x) => IC.evalFunction("oct", [x]),
    octal: "oct",

    // @ts-ignore
    bin: (x) => IC.evalFunction("bin", [x]),
    binary: "bin",

    value: (x) => Number(IC.val(x)),
    "plain number": "value",
    "raw number": "value",
    number: "value",
    num: "value",
    val: "value",
    unitless: "value",
    numeric: "value",
    scalar: "value",
    dimensionless: "value",
    magnitude: "value",

    percent: (x) => IC.makeICObject(IC.val(x), null, "percent"),
    percentage: "percent",
    pct: "percent",
    "%": "percent",

    unit: (x) => {
      // If x is a string, try to create a unit from it
      if (typeof x === 'string') {
        // Parse the string as a unit identifier (e.g., "meter" -> 1 meter)
        const parsed = IC.parseAndEval(x);
        if (parsed && IC.hasType(parsed)) {
          return IC.makeICObject(1, parsed.t);
        }
        // If it doesn't parse as a unit, just return the string as-is
        return x;
      }
      // Otherwise, use existing logic: extract unit from typed value
      return IC.hasType(x) ? IC.makeICObject(1, x.t) : IC.val(x);
    },
    type: "unit",

    "feet and inches": "tape",
    "tape measure": "tape",
    tape: (x) => {
      if (IC.hasType(x)) {
        IC.ICObjectSetFormat(x, "tape");
      }
      return x;
    },

    "scientific notation": "scientific",

    scientific: (x) => {
      if (IC.hasType(x)) {
        IC.ICObjectSetFormat(x, "scientific");
        return x;
      }
      else {
        // native string, gets parsed in JS
        return IC.parser.formatAsScientific(IC.val(x));
      }
    },
    "exponential": "scientific",
    "science": "scientific",
    "sci": "scientific",

    "engineering": (x) => {
      if (IC.hasType(x)) {
        IC.ICObjectSetFormat(x, "engineering");
        return x;
      }
      else {
        // native string type, gets parsed in JS
        return IC.parser.formatAsEngineering(IC.val(x));
      }
    },

    "engineer": "engineering",
    "eng": "engineering",

    // significant figures
    sigfig: (x, n) => {
      let value = IC.val(x);
      if (typeof value !== 'number' || isNaN(value)) {
        return x;
      }

      // Convert to exponential notation
      let exp = value.toExponential();
      let parts = exp.split('e');
      let mantissa = parts[0];
      let exponent = parseInt(parts[1]);

      // Round the mantissa to n significant figures
      let roundedMantissa = parseFloat(mantissa).toPrecision(n);

      // Reconstruct the number
      let result = parseFloat(roundedMantissa + 'e' + exponent);

      if (IC.hasType(x)) {
        return IC.makeICObject(result, x.t, x.f);
      } else {
        return result;
      }
    },

    "finance": (x) => {
      if (IC.hasType(x)) {
        IC.ICObjectSetFormat(x, "finance");
        return x;
      }
      else {
        return IC.makeICObject(IC.val(x), null, "finance");
      }
    },
    "financial": "finance", // Put on the thousands, millions, billions scale 
    "money": "finance",
    "scale": "scaled",
    "scaled": (x) => {
      let isCurrencyType = IC.hasType(x) && ICUnit.isCurrency(IC.typestring(x.t));
      if (isCurrencyType) {
        return CONFIG.POSTCONVERT_FUNCTIONS.finance(x);
      }

      if (IC.hasType(x)) {
        return ICUnit.scaleToBestUnit(x);
      }

      return IC.makeICObject(IC.val(x), null, "finance");
    },

    "roman": (x) => {
      return IC.makeICObject(IC.val(x), null, "roman");
    },

    "roman numerals": "roman",
    "roman numeral": "roman",

    noformat: (x) => {
      // string may need to be converted back to a number
      if (typeof x === "string") {
        if (typeof x == "string") {
          let n = IC.parseLocaleNumber(x);
          if (n !== null)
            return n;
        }
      }

      if (IC.format(x)) {
        IC.ICObjectSetFormat(x, "");
        return x;
      }
      else {
        // Clear formatter for this specific row only
        IC.clearRowFormat();
        return IC.val(x);
      }
    },

    si: (v) => {
      if (IC.hasNoType(v)) {
        return v;
      }

      return ICUnit.autoCollapse(v);
    },

    // SI base unit
    base: "sibase",
    metric: "sibase",
    sibase: (v) => {
      if (IC.hasNoType(v)) {
        return v;
      }

      let [baseUnits, scale] = ICUnit.convertToBaseUnits(v.t);

      // this normally does an autocollapse
      let ret = IC.makeICObject(IC.mathPreciseMultiply(IC.val(v), scale), null);
      ret.t = JSON.parse(JSON.stringify(baseUnits));
      return ret;
    },

    decimal_places: (x, places) => {
      let newNum = Number(IC.val(x).toFixed(places));

      if (IC.hasType(x)) {
        return IC.makeICObject(newNum, x.t, x.f);
      }
      else {
        return newNum;
      }
    },

    nearest: (x, multiple) => {
      return CONFIG.nearestNumberOrUnit(x, multiple);
    },

    // work in progress
    mixed: (x, ...args) => {
      return ICUnit.makeMixedUnit(x, ...args);
    },

    string: (x) => IC.ICStringify(x),
    stringify: "string",
    str: "string",
    parse: (x) => IC.ICParseRelaxedJSON(x),
    parsejson: "parse",

    re: (z) => LIB.Complex.re(z),
    real: "re",
    im: (z) => LIB.Complex.im(z),
    imaginary: "im",
    arg: (z) => LIB.Complex.angle(z),
    angle: "arg",
    conj: (z) => LIB.Complex.conjugate(z),
    conjugate: "conj",
    phasor: (z) => { return IC.makeICObject(z, null, "phasor"); },
    polar: "phasor",
  },

  POSTCONVERT_FUNCTION_REGEX: {
    fraction: {
      regex: /fraction\s*[/]\s*(\d+)/,
      f: (x, match) => {
        let denom = parseInt(match[1]);
        return CONFIG.POSTCONVERT_FUNCTIONS.fraction(x, denom);
      }
    },

    decimal_places: {
      regex: /(\d+)\s+(decimal\s*places|decimals?|digits?|places?)/,
      f: (x, match) => {
        let places = parseInt(match[1]);
        return CONFIG.POSTCONVERT_FUNCTIONS.decimal_places(x, places);
      }
    },

    nearest: {
      regex: /(nearest|closest)\s+(\S+)/,
      f: (x, match) => {
        let multiple = IC.parseAndEval(match[2]);
        if (typeof multiple != "number") {
          multiple = CONFIG.nearestNumberScale(match[2]);
        }

        if (typeof multiple == "number") {
          return CONFIG.nearestNumberOrUnit(x, multiple);
        }
        IC.log(`couldn't round to nearest ${match[2]}`);
        return x;
      }
    },

    sigfig: {
      regex: /(\d+)\s+(?:sig(?:nificant)?\s+(?:fig(?:ure)?s?|digits?)|sigfig(?:s)?)/i,
      f: (x, match) => {
        let n = parseInt(match[1]);
        return CONFIG.POSTCONVERT_FUNCTIONS.sigfig(x, n);
      }
    },
  },

  SUFFIX_DICT: {
    squared: (val) => IC.mathPow(val, 2),
    cubed: (val) => IC.mathPow(val, 3),
    inverse: (val) => IC.mathPow(val, -1),
    invert: (val) => IC.mathPow(val, -1),

    // TODO: make some of these use the POSTCONVERT functions
    unitless: (val) => Number(IC.val(val)),
  },

  PREFIX_DICT: {
    // longer keys first (longer match wins)
    //    "square root of": "sqrt",
    //    "sqrt root of": "sqrt",
    "square root": "sqrt",
    //    "root of": "sqrt",
    "root": "sqrt",
    sqrt: (val) => IC.mathPow(val, 0.5),

    //   "cube root of": "cuberoot",
    "cube root": "cuberoot",
    "cbrt": "cuberoot",
    cuberoot: (val) => IC.mathPow(val, 1 / 3),

    //"square": (x) => IC.pow(x, 2),
    //"cube": (x) => IC.pow(x, 3),

    invert: (val) => IC.mathPow(val, -1),
    inverse: "invert",
    reciprocal: "invert"
  },

  UNIT_AWARE_FUNCTIONS: {
    SQUARE: (v) => IC.mathPow(v, 2),
    CUBE: (v) => IC.mathPow(v, 3),
    CUBIC: (v) => IC.mathPow(v, 3),
    SQRT: (v) => IC.mathPow(v, 0.5),
    CBRT: (v) => IC.mathPow(v, 1 / 3),
    INVERT: (v) => IC.mathPow(v, -1),
    INVERSE: (v) => IC.mathPow(v, -1),
    RECIPROCAL: (v) => IC.mathPow(v, -1),
    NEGATE: (v) => IC.mathMul(-1, v),
    ROUND: (v) => IC.makeICObject(Math.round(IC.val(v)), v.t),
    ROUNDDOWN: (v) => IC.makeICObject(Math.floor(IC.val(v)), v.t),
    FLOOR: (v) => IC.makeICObject(Math.floor(IC.val(v)), v.t),
    CEIL: (v) => IC.makeICObject(Math.ceil(IC.val(v)), v.t),
    ROUNDUP: (v) => IC.makeICObject(Math.ceil(IC.val(v)), v.t),
    UNIT: (v) => CONFIG.POSTCONVERT_FUNCTIONS.unit(v),
    VALUE: (v) => CONFIG.POSTCONVERT_FUNCTIONS.value(v),
    TIME: (v) => {
      let seconds = IC.val(v);
      // if not same type as second, convert to second if possible
      if (IC.hasType(v)) {
        seconds = IC.val(IC.ICObjectConvertToType(v, "s"));
      }

      return IC.CALC.fn()["time"](seconds);
    },
  },

  // these functions actually get help messages
  OTHER_FUNCTIONS: {
    CHART: (values) => {
      return Chart.getChartData(values, Chart.LINE);
    },

    BARCHART: (values) => {
      return Chart.getChartData(values, Chart.BAR);
    },

    LINECHART: (values) => {
      return Chart.getChartData(values, Chart.LINE);
    },

    PIECHART: (values) => {
      return Chart.getChartData(values, Chart.PIE);
    },
  },

  // custom functions better done here, vs in instacalc.engine.js
  ENGLISH_FUNCTION: {
    LOAN: (v, rate, term) => {
      return ICLib.loan(v, rate, term);
    },

    INVEST: (v, rate, term) => {
      return ICLib.invest(v, rate, term);
    },

    INTEREST: (v, rate, term) => {
      return ICLib.interest(v, rate, term);
    },

    TOTALPAYMENT: (v, rate, term) => {
      return ICLib.totalPayment(v, rate, term);
    },

    SAVINGSGOAL: (v, rate, term) => {
      return ICLib.savingsGoal(v, rate, term);
    },

    PRESENTVALUE: (v, rate, term) => {
      return ICLib.presentValue(v, rate, term);
    },
  },

  UNIT_HELP_MSG: {
    kb: "(2^10 bytes), see also: kb_si (thousand bytes)",
    mb: "(2^20 bytes), see also: mb_si (million bytes)",
    gb: "(2^30 bytes), see also: gb_si (billion bytes)",
    tb: "(2^40 bytes), see also: tb_si (trillion bytes)",
    pb: "(2^50 bytes), see also: pb_si (quadrillion bytes)",
    eb: "(2^60 bytes), see also: eb_si (1e18 bytes)",
    zb: "(2^70 bytes), see also: zb_si (1e21 bytes)",
    yb: "(2^80 bytes), see also: yb_si (1e24 bytes)",
    rb: "(2^90 bytes), see also: rb_si (1e27 bytes)",
    qb: "(2^100 bytes), see also: qb_si (1e30 bytes)",

    kb_si: "(thousand bytes)",
    mb_si: "(million bytes)",
    gb_si: "(billion bytes)",
    tb_si: "(trillion bytes)",
    pb_si: "(quadrillion bytes)",
    eb_si: "(1e18 bytes)",
    zb_si: "(1e21 bytes)",
    yb_si: "(1e24 bytes)",
    rb_si: "(1e27 bytes)",
    qb_si: "(1e30 bytes)",

    kib: "alias:kb",
    mib: "alias:mb",
    gib: "alias:gb",
    tib: "alias:tb",
    pib: "alias:pb",
    eib: "alias:eb",
    zib: "alias:zb",
    yib: "alias:yb",
    rib: "alias:rb",
    qib: "alias:qb",

    kibibyte: "alias:kb",
    mebibyte: "alias:mb",
    gibibyte: "alias:gb",
    tebibyte: "alias:tb",
    pebibyte: "alias:pb",
    exbibyte: "alias:eb",
    zebibyte: "alias:zb",
    yobibyte: "alias:yb",
    ronnibyte: "alias:rb",
    quettibyte: "alias:qb",

    kilobyte: "alias:kb",
    megabyte: "alias:mb",
    gigabyte: "alias:gb",
    terabyte: "alias:tb",
    petabyte: "alias:pb",
    exabyte: "alias:eb",
    zettabyte: "alias:zb",
    yottabyte: "alias:yb",
    ronnabyte: "alias:rb",
    quettabyte: "alias:qb",

    kilobytes: "alias:kb",
    megabytes: "alias:mb",
    gigabytes: "alias:gb",
    terabytes: "alias:tb",
    petabytes: "alias:pb",
    exabytes: "alias:eb",
    zettabytes: "alias:zb",
    yottabytes: "alias:yb",
    ronnabytes: "alias:rb",
    quettabytes: "alias:qb",

    kilobit: "(2^10 bits)",
    megabit: "(2^20 bits)",
    gigabit: "(2^30 bits)",
    terabit: "(2^40 bits)",
    petabit: "(2^50 bits)",
    exabit: "(2^60 bits)",
    zettabit: "(2^70 bits)",
    yottabit: "(2^80 bits)",
    ronnabit: "(2^90 bits)",
    quettabit: "(2^100 bits)",

    kilobits: "(2^10 bits)",
    megabits: "(2^20 bits)",
    gigabits: "(2^30 bits)",
    terabits: "(2^40 bits)",
    petabits: "(2^50 bits)",
    exabits: "(2^60 bits)",
    zettabits: "(2^70 bits)",
    yottabits: "(2^80 bits)",
    ronnabits: "(2^90 bits)",
    quettabits: "(2^100 bits)",

    kbit: "alias:kilobit",
    mbit: "alias:megabit",
    gbit: "alias:gigabit",
    tbit: "alias:terabit",
    pbit: "alias:petabit",
    ebit: "alias:exabit",
    zbit: "alias:zettabit",
    ybit: "alias:yottabit",
    rbit: "alias:ronnabit",
    qbit: "alias:quettabit",

    kbits: "alias:kilobit",
    mbits: "alias:megabit",
    gbits: "alias:gigabit",
    tbits: "alias:terabit",
    pbits: "alias:petabit",
    ebits: "alias:exabit",
    zbits: "alias:zettabit",
    ybits: "alias:yottabit",
    rbits: "alias:ronnabit",
    qbits: "alias:quettabit",

    kbps: "(thousand bits/sec), see also: KBps (bytes/sec)",
    mbps: "(million bits/sec), see also: MBps (bytes/sec)",
    gbps: "(billion bits/sec), see also: GBps (bytes/sec)",
    tbps: "(trillion bits/sec), see also: TBps (bytes/sec)",
    pbps: "(quadrillion bits/sec), see also: PBps (bytes/sec)",
    ebps: "(1e18 bits/sec), see also: EBps (bytes/sec)",
    zbps: "(1e21 bits/sec), see also: ZBps (bytes/sec)",
    ybps: "(1e24 bits/sec), see also: YBps (bytes/sec)",
    rbps: "(1e27 bits/sec), see also: RBps (bytes/sec)",
    qbps: "(1e30 bits/sec), see also: QBps (bytes/sec)",

    KBps: "(thousand bytes/sec), see also: kbps (bits/sec)",
    MBps: "(million bytes/sec), see also: mbps (bits/sec)",
    GBps: "(billion bytes/sec), see also: gbps (bits/sec)",
    TBps: "(trillion bytes/sec), see also: tbps (bits/sec)",
    PBps: "(quadrillion bytes/sec), see also: pbps (bits/sec)",
    EBps: "(1e18 bytes/sec), see also: ebps (bits/sec)",
    ZBps: "(1e21 bytes/sec), see also: zbps (bits/sec)",
    YBps: "(1e24 bytes/sec), see also: ybps (bits/sec)",
    RBps: "(1e27 bytes/sec), see also: rbps (bits/sec)",
    QBps: "(1e30 bytes/sec), see also: qbps (bits/sec)",

    flop: "(op, flops = ops/sec)",
    flops: "(ops/sec, flop=op count)",
    mflop: "(million ops, mflops=ops/sec)",
    mflops: "(million ops/sec, mflop=ops count)",
    gflop: "(billion ops, gflops=ops/sec)",
    gflops: "(billion ops/sec, gflop=ops count)",
    tflop: "(trillion ops, tflops=ops/sec)",
    tflops: "(trillion ops/sec, tflop=ops count)",
    pflop: "(1e15 ops, pflops=ops/sec)",
    pflops: "(1e15 ops/sec, pflop=ops count)",
    eflop: "(1e18 ops, eflops=ops/sec)",
    eflops: "(1e18 ops/sec, eflop=ops count)",
    zflop: "(1e21 ops, zflops=ops/sec)",
    zflops: "(1e21 ops/sec, zflop=ops count)",
    yflop: "(1e24 ops, yflops=ops/sec)",
    yflops: "(1e24 ops/sec, yflop=ops count)",

    // Unit help is lowercase first
    m: "(m=meter, M=million)",
    mw: "(megawatt, mW=milliwatt)", // covers mw, MW, Mw
    mW: "(milliwatt, MW=megawatt)",

    f: "(Fahrenheit), see also: Farad",
    c: "(Celsius), see also: Coulomb, c_light",

    g: "(gram), see also: gravity [SmallG], g_const [BigG]",

    i: "(imaginary unit), √-1",

    cal: "(calorie [small] = 4.184 J)",
    Cal: "(Calorie [big] = kcal = 4184 J)",

    time: "(time formats hh:mm, hh:mm:ss, 1y 2d 3h 4m 5s)",

    mil: "(mil = 1/1000 inch, see: mil_nato [angle])",

    //    dollar: "(generic money label, use USD for currency conversions)",
    yen: "(JPY, Japanese Yen)",
    euro: "(EUR, Euro)",
    yuan: "(CNY, Chinese Yuan)",
    rupee: "(INR, Indian Rupee)",
    peso: "(MXN, Mexican Peso)",
    ruble: "(RUB, Russian Ruble)",
    ringgit: "(MYR, Malaysian Ringgit)",
    won: "(KRW, South Korean Won)",
    loonie: "(CAD, Canadian Dollar)",
    aussie: "(AUD, Australian Dollar)",
    baht: "(THB, Thai Baht)",
    dirham: "(AED, United Arab Emirates Dirham)",
    lira: "(TRY, Turkish Lira)",
    riyal: "(SAR, Saudi Riyal)",
    lev: "(BGN, Bulgarian Lev)",
    zloty: "(PLN, Polish Zloty)",
    krona: "(SEK, Swedish Krona)",
    franc: "(CHF, Swiss Franc)",
    quetzal: "(GTQ Guatemalan Quetzal)",
    shekel: "(ILS, Israeli Shekel)",
    dong: "(VND, Vietnamese Dong)",
    dinar: "(KWD, Kuwaiti Dinar)",
    kuna: "(HRK, Croatian Kuna)",
    birr: "(ETB, Ethiopian Birr)",
    taka: "(BDT, Bangladeshi Taka)",
    forint: "(HUF, Hungarian Forint)",
    rupiah: "(IDR, Indonesian Rupiah)",
    kyat: "(MMK, Burmese Kyat)",
    naira: "(NGN, Nigerian Naira)",
    bolivar: "(VES, Venezuelan Bolivar)",
  },

  getUnitHelpMessage(unit, compact = false) {
    let message = this.UNIT_HELP_MSG[unit] || this.UNIT_HELP_MSG[unit.toLowerCase()] || null;

    // alias lookup
    if (message && message.startsWith("alias:")) {
      const aliasKey = message.split(":")[1];
      message = this.UNIT_HELP_MSG[aliasKey];
    }

    // Check FLEX_UNIT_ALIAS (e.g. petaflop) 
    if (!message) {
      const flexUnit = this.FLEX_UNIT_ALIAS[unit.toLowerCase()];
      if (flexUnit) {
        const { scale, type } = flexUnit;
        const formattedScale = scale > 1000 ? scale.toExponential().replace("+", "") : scale;
        message = `(${formattedScale} ${type})`;
      }
    }

    if (message && compact) {
      // take everything up to the first )
      message = message.split(")")[0] + ")";
    }

    return message;
  },

  FUNCTION_HELP_MSG: {
    sin: "sin uses deg, for radians use sin(2pi rad)",
    cos: "cos uses deg, for radians use cos(2pi rad)",
    tan: "tan uses deg, for radians use tan(2pi rad)",
    sec: "sec uses deg, for radians use sec(2pi rad)",
    csc: "csc uses deg, for radians use csc(2pi rad)",
    cot: "cot uses deg, for radians use cot(2pi rad)",
  },

  FUNCTION_USAGE_MSG: {

    "hex": "hex(x) | convert x to hexadecimal, hex(255) = 0xff",
    "oct": "oct(x) | convert x to octal, oct(255) = 0377",
    "bin": "bin(x) | convert x to binary, bin(255) = 0b11111111",
    "dec": "dec(x) | convert x to decimal, dec(0xFF) = 255",

    if: "if (condition) { result } else { result } | if (age >= 18) { \"adult\" } else { \"child\" } \n IF(condition, true result, false result) | IF(age >= 18, \"adult\", \"child\") // excel-style",

    sin: "sin(x) | sine of x (degrees) | sin(2pi rad) for radians",
    cos: "cos(x) | cosine of x (degrees) | cos(2pi rad) for radians",
    tan: "tan(x) | tangent of x (degrees) | tan(2pi rad) for radians",
    sec: "sec(x) | secant of x (degrees) | sec(2pi rad) for radians",
    csc: "csc(x) | cosecant of x (degrees) | csc(2pi rad) for radians",
    cot: "cot(x) | cotangent of x (degrees) | cot(2pi rad) for radians",

    asin: "asin(x) | arcsine of x (result in degrees)",
    acos: "acos(x) | arccosine of x (result in degrees)",
    atan: "atan(x) | arctangent of x (result in degrees)",
    atan2: "atan2(y, x) | arctangent of y/x (result in degrees)",
    asec: "asec(x) | arcsecant of x (result in degrees)",
    acsc: "acsc(x) | arccosecant of x (result in degrees)",
    acot: "acot(x) | arccotangent of x (result in degrees)",

    sinh: "sinh(x) | hyperbolic sine",
    cosh: "cosh(x) | hyperbolic cosine",
    tanh: "tanh(x) | hyperbolic tangent",
    sech: "sech(x) | hyperbolic secant",
    csch: "csch(x) | hyperbolic cosecant",
    coth: "coth(x) | hyperbolic cotangent",
    asinh: "asinh(x) | hyperbolic arcsine of x",
    acosh: "acosh(x) | hyperbolic arccosine of x",
    atanh: "atanh(x) | hyperbolic arctangent of x",
    asech: "asech(x) | hyperbolic arcsecant of x",
    acsch: "acsch(x) | hyperbolic arccosecant of x",
    acoth: "acoth(x) | hyperbolic arccotangent of x",

    re: "re(z) | real part of complex number",
    im: "im(z) | imaginary part of complex number",
    arg: "arg(z) | angle of complex number (radians)",
    angle: "angle(z) | angle of complex number (radians)",
    phasor: "phasor(magnitude, angle) | build complex number (default degrees) | phasor(3, 90), phasor(2, pi/2 rad)",

    abs: "abs(x) | absolute value of x",
    ceil: "ceil(x) | ceiling of x",
    floor: "floor(x) | floor of x",
    round: "round(x, [decimal places]) | rounds number: round(pi) = 3, round(pi, 2) = 3.14, round(pi, .01) = 3.14",
    roundup: "roundup(x) | round up to nearest integer",
    rounddown: "rounddown(x) | round down to nearest integer",
    trunc: "trunc(x) | truncate to integer",
    int: "int(x) | truncate to integer",
    integer: "integer(x) | truncate to integer",

    hypot: "hypot(x, y) | sqrt(x^2 + y^2)",
    exp: "exp(x) | e^x",
    ln: "ln(x) | natural log of x",
    log: "log(x) | log base 10 of x",
    log2: "log2(x) | log base 2 of x",
    log_2: "log2(x) | log base 2 of x",
    log10: "log10(x) | log base 10 of x",
    log_10: "log10(x) | log base 10 of x",
    sqrt: "sqrt(x) | square root of x",
    cbrt: "cuberoot(x) | cube root of x",
    cuberoot: "cuberoot(x) | cube root of x",
    pow: "pow(x, y) | x to power y: x^y",
    root: "root(x) | square root of x",

    time: "time(seconds) | convert seconds to HMS, time(10000) = 2h 46m 40s",

    mod: "mod(x, y) | x modulo (remainder) y",
    gcd: "gcd(x, y) | greatest common divisor of x and y",
    lcm: "lcm(x, y) | least common multiple of x and y",
    sign: "sign(x) | sign of x (-1, 0, or 1)",
    clamp: "clamp(x, min, max) | min <= x <= max",
    erf: "erf(x) | error function",
    erfinverse: "erfinverse(x) | inverse error function",
    gamma: "gamma(x) | gamma function",

    square: "square(x) | x^2",
    cube: "cube(x) | x^3",

    max: "max(r1:r3) or max(x, y, ...) | maximum of values",
    min: "min(r1:r3) or min(x, y, ...) | minimum of values",
    avg: "avg(r1:r3) or avg(x, y, ...) | average of values",
    sum: "sum(r1:r3) or sum(x, y, ...) | sum of values",
    total: "total(r1:r3) or total(x, y, ...) | sum of values",
    average: "average(r1:r3) or average(x, y, ...) | average of values",
    product: "product(r1:r3) or product(x, y, ...) | product of values",
    sub: "sub(x, y) | subtract y from x",
    subtract: "subtract(x, y) | subtract y from x",
    divide: "divide(x, y) | divide x by y",
    quotient: "quotient(x, y) | divide x by y",

    mean: "mean(r1:r3) or mean(x, y, ...) | mean of values",
    mode: "mode(r1:r3) or mode(x, y, ...) | mode of values",
    median: "median(r1:r3) or median(x, y, ...) | median of values",
    geomean: "geomean(r1:r3) or geomean(x, y, ...) | geometric mean of values",

    var: "var(r1:r3) or var(x, y, ...) | sample variance of values",
    variance: "variance(r1:r3) or variance(x, y, ...) | sample variance of values",

    "var.s": "var.s(r1:r3) or var.s(x, y, ...) | sample variance of values",
    "var.p": "var.p(r1:r3) or var.p(x, y, ...) | population variance of values",

    covar: "covar(r1:r3) or var(x, y, ...) | population covariance of values",
    covariance: "covariance(r1:r3) or variance(x, y, ...) | population covariance of values",

    "covar.s": "var.s(r1:r3) or var.s(x, y, ...) | sample variance of values",
    "covar.p": "var.p(r1:r3) or var.p(x, y, ...) | population variance of values",
    "covariance.s": "var.s(r1:r3) or var.s(x, y, ...) | sample variance of values",
    "covariance.p": "var.p(r1:r3) or var.p(x, y, ...) | population variance of values",

    slope: "slope(known_y's, known_x's) | slope of the linear regression line (Excel)",
    intercept: "intercept(known_y's, known_x's) | y-intercept of the linear regression line (Excel)",
    correl: "correl(array1, array2) | correlation coefficient between two data sets (Excel)",
    linest: "linest(known_y's, known_x's, [const], [stats]) | linear regression line (Excel)",
    forecast: "forecast(x, known_y's, known_x's) | forecast value on the linear regression line (Excel)",
    confidence: "confidence(alpha, standard_dev, size) | confidence interval for population mean (Excel)",

    stddev: "stddev(r1:r3) or stddev(x, y, ...) | sample standard deviation of values",
    stdev: "stdev(r1:r3) or stddev(x, y, ...) | sample standard deviation of values",

    "stdev.s": "stdev.s(r1:r3) or stdev.s(x, y, ...) | sample standard deviation of values",
    "stdev.p": "stdev.p(r1:r3) or stdev.p(x, y, ...) | population standard deviation of values",

    kurt: "kurtosis(r1:r3) | sample kurtosis of values (Excel)",
    kurtosis: "kurtosis(r1:r3) | sample kurtosis of values (Excel)",
    skewness: "skew(array) | sample skewness of values (Excel)",
    skew: "skew(array) | sample skewness of values (Excel)",

    "norm.s.inv": "norm.s.inv(p) | inverse of standard normal cumulative distribution function (Excel)",
    "normsinv": "norm.s.inv(p) | inverse of standard normal cumulative distribution function (Excel)",
    "norminv": "norm.inv(p) | inverse of normal cumulative distribution function (Excel)",
    "norm.dist": "norm.dist(x, mean, standard_dev, cumulative) | normal distribution function (Excel)",
    "normdist": "norm.dist(x, mean, standard_dev, cumulative) | normal distribution function (Excel)",
    "norm.s.dist": "norm.s.dist(z, cumulative) | standard normal distribution function (Excel)",
    "normsdist": "norm.s.dist(z, cumulative) | standard normal distribution function (Excel)",
    "t.inv": "t.inv(probability, degrees_freedom) | inverse of Student's t-distribution (Excel)",
    "tinv": "t.inv(probability, degrees_freedom) | inverse of Student's t-distribution (Excel)",
    "t.dist": "t.dist(x, degrees_freedom, cumulative) | Student's t-distribution function (Excel)",
    "tdist": "t.dist(x, degrees_freedom, cumulative) | Student's t-distribution function (Excel)",
    "chisq.dist": "chisq.dist(x, degrees_freedom, cumulative) | chi-square distribution function (Excel)",
    "chisqdist": "chisq.dist(x, degrees_freedom, cumulative) | chi-square distribution function (Excel)",
    "f.dist": "f.dist(x, degrees_freedom1, degrees_freedom2, cumulative) | F-distribution function (Excel)",
    "fdist": "f.dist(x, degrees_freedom1, degrees_freedom2, cumulative) | F-distribution function (Excel)",
    "z.test": "z.test(array, x, [sigma]) | z-test for mean (Excel)",
    "ztest": "z.test(array, x, [sigma]) | z-test for mean (Excel)",
    "t.test": "t.test(array1, array2, [tails], [type]) | t-test for means (Excel)",
    "ttest": "t.test(array1, array2, [tails], [type]) | t-test for means (Excel)",

    "t.dist.2t": "t.dist.2t(x, degrees_freedom) | two-tailed Student's t-distribution function (Excel)",
    "tdist2t": "t.dist.2t(x, degrees_freedom) | two-tailed Student's t-distribution function (Excel)",
    "t.dist.rt": "t.dist.rt(x, degrees_freedom) | right-tailed Student's t-distribution function (Excel)",
    "tdistrt": "t.dist.rt(x, degrees_freedom) | right-tailed Student's t-distribution function (Excel)",
    "t.inv.2t": "t.inv.2t(probability, degrees_freedom) | two-tailed inverse of Student's t-distribution (Excel)",
    "tinv2t": "t.inv.2t(probability, degrees_freedom) | two-tailed inverse of Student's t-distribution (Excel)",
    "chisq.dist.rt": "chisq.dist.rt(x, degrees_freedom) | right-tailed chi-square distribution function (Excel)",
    "chisqdistrt": "chisq.dist.rt(x, degrees_freedom) | right-tailed chi-square distribution function (Excel)",
    "chisq.inv": "chisq.inv(probability, degrees_freedom) | inverse of chi-square distribution function (Excel)",
    "chisqinv": "chisq.inv(probability, degrees_freedom) | inverse of chi-square distribution function (Excel)",
    "chisq.inv.rt": "chisq.inv.rt(probability, degrees_freedom) | right-tailed inverse of chi-square distribution function (Excel)",
    "chisqinvrt": "chisq.inv.rt(probability, degrees_freedom) | right-tailed inverse of chi-square distribution function (Excel)",
    "f.dist.rt": "f.dist.rt(x, degrees_freedom1, degrees_freedom2) | right-tailed F-distribution function (Excel)",
    "fdistrt": "f.dist.rt(x, degrees_freedom1, degrees_freedom2) | right-tailed F-distribution function (Excel)",
    "f.inv": "f.inv(probability, degrees_freedom1, degrees_freedom2) | inverse of F-distribution function (Excel)",
    "finv": "f.inv(probability, degrees_freedom1, degrees_freedom2) | inverse of F-distribution function (Excel)",
    "f.inv.rt": "f.inv.rt(probability, degrees_freedom1, degrees_freedom2) | right-tailed inverse of F-distribution function (Excel)",
    "finvrt": "f.inv.rt(probability, degrees_freedom1, degrees_freedom2) | right-tailed inverse of F-distribution function (Excel)",

    "binom.dist": "binom.dist(x, trials, probability_s, cumulative) | binomial distribution function (Excel)",
    "binomdist": "binom.dist(x, trials, probability_s, cumulative) | binomial distribution function (Excel)",
    "negbinom.dist": "negbinom.dist(x, r, p, cumulative) | negative binomial distribution function (Excel)",
    "negbinomdist": "negbinom.dist(x, r, p, cumulative) | negative binomial distribution function (Excel)",
    "weibull.dist": "weibull.dist(x, alpha, beta, cumulative) | Weibull distribution function (Excel)",
    "weibulldist": "weibull.dist(x, alpha, beta, cumulative) | Weibull distribution function (Excel)",
    "poisson.dist": "poisson.dist(x, mean, cumulative) | Poisson distribution function (Excel)",
    "poissondist": "poisson.dist(x, mean, cumulative) | Poisson distribution function (Excel)",
    "gamma.dist": "gamma.dist(x, alpha, beta, cumulative) | gamma distribution function (Excel)",
    "gammadist": "gamma.dist(x, alpha, beta, cumulative) | gamma distribution function (Excel)",

    range: "range(r1:r3) or range(x, y, ...) | range of values",
    count: "count(r1:r3) or count(x, y, ...) | count of values",
    percentile: "percentile(r1:r3, p) or percentile(x, y, ..., p) | pth percentile of values",
    percentrank: "percentrank(r1:r3, x, [sig (optional)]) or percentrank(x, y, ..., x) | percent rank of x in values, to [sig] digits (Excel)",
    sort: "sort(r1:r3) or sort(x, y, ...) | sort values in ascending order",
    reverse: "reverse(r1:r3) or reverse(x, y, ...) | reverse array of values",
    sequence: "sequence(count, [start], [step]) or sequence({count:, start:, step:}) | generate sequence | sequence(5) = [1,2,3,4,5]",
    seq: "seq(count, [start], [step]) or seq({count:, start:, step:}) | generate sequence | seq(5) = [1,2,3,4,5]",

    combin: "combination(n, k) | n choose k",
    combination: "combination(n, k) | n choose k",
    c: "combination(n, k) | n choose k",
    permut: "permutation(n, k) | n permute k",
    permutation: "permutation(n, k) | n permute k",
    p: "permutation(n, k) | n permute k",

    // excel functions
    pmt: "PMT(rate, nper, pv, [fv (optional)], [type]) | loan payment (Excel)",
    ipmt: "IPMT(rate, per, nper, pv, [fv (optional)], [type]) | interest payment (Excel)",
    ppmt: "PPMT(rate, per, nper, pv, [fv (optional)], [type]) | payment on the principal (Excel)",

    ispmt: "ISPMT(rate, per, nper, pv) | interest payment specific period (Excel)",

    pv: "PV(rate, nper, pmt, [fv (optional)], [type]) | present value of an investment (Excel)",
    fv: "FV(rate, nper, pmt, [pv (optional)], [type]) | future value of an investment (Excel)",
    irr: "IRR(values, [guess (optional]) | internal rate of return (Excel)",
    npv: "NPV(rate, r1:r5) or NPV(rate, val1, val2...) | net present value (Excel)",

    rate: "RATE(nper, pmt, pv, [fv (optional)], [type], [guess]) | interest rate per period of an annuity (Excel)",
    nper: "NPER(rate, pmt, pv, [fv (optional)], [type]) | number of periods for an annuity (Excel)",
    cagr: "CAGR(start, end value, n) | compound annual growth rate assuming n periods",

    rri: "RRI(nper, pv, fv) | interest rate per period of an annuity (Excel)",
    pduration: "PDURATION(rate, pv, fv) | number of periods for an annuity (Excel)",

    loan: "loan(amount, rate, term) | loan payment: loan(400k, 5%, 30y)",
    invest: "invest(amount, rate, term) | future value of investment: invest(200/month, 5%, 30y)",
    interest: "interest(amount, rate, term) | interest cost of loan: interest(200/month, 5%, 30y)",

    stock: "stock(symbol) | stock price: STOCK(AAPL)",
    import: "import(json_url) | import data from public URL to object",
    fib: "fib(n) | returns the nth Fibonacci number",
    fibonacci: "fibonacci(n) | returns the nth Fibonacci number",
    fac: "fac(n) | returns the factorial of n",
    factorial: "factorial(n) | returns the factorial of n",
    nchoosek: "nchoosek(n, k) | returns the binomial coefficient of n and k",

    sigfig: "sigfig(x, n) | round to n significant figures, sigfig(123.456, 2) = 120",
    date: "date(year, month, day) | create date (Excel)", /* todo: not appearing since date by itself renders */

    calc: "calc(id) | import calculator by local title ('my calc') or URL ('https://instacalc.com/123')",

    chart: "chart(r1:r3) | line chart of row range | linechart(r1:r3) piechart(r1:r3) barchart(r1:r3)",
    barchart: "barchart(r1:r3) | bar chart of row range",
    linechart: "linechart(r1:r3) | line chart of row range",
    piechart: "piechart(r1:r3) | pie chart of row range",
  },

  CONVERSION_WARNING_LIST: {
    oz: "fluid oz",
    ozs: "fluid ozs",
    ounce: "fluid ounce",
    ounces: "fluid ounces",
  },

  IMPLIED_CONVERSIONS: [
    {
      match: (toType) => /\bdollar(s)?|\bcent(s)?\b/i.test(IC.typestring(toType)),
      exclude: (fromType) => IC.typestring(fromType).toLowerCase().includes("dollar"),
      unit: "dollar"
    },
    {
      match: (toType) => /\bUSD\b/i.test(IC.typestring(toType)),
      exclude: (fromType) => IC.typestring(fromType).toLowerCase().includes("usd"),
      unit: "USD"
    },
    {
      match: (toType) => IC.typeHasUnitInCategory(toType, "byte"),
      exclude: (fromType) => IC.typeHasUnitInCategory(fromType, "byte"),
      unit: "byte"
    }
  ],

  FLEX_UNIT_CONVERSIONS: {
    cycle: true,
    cycles: true,
  },

  FLEX_UNIT_ALIAS: {

    // TODO: clean this up, move into regular flow
    hz: { scale: 1, type: "cycles/second" },
    khz: { scale: 1e3, type: "cycles/second" },
    mhz: { scale: 1e6, type: "cycles/second" },
    ghz: { scale: 1e9, type: "cycles/second" },
    thz: { scale: 1e12, type: "cycles/second" },
    phz: { scale: 1e15, type: "cycles/second" },

    bps: { scale: 1, type: "bits/sec" },
    kbps: { scale: 1e3, type: "bits/sec" },
    mbps: { scale: 1e6, type: "bits/sec" },
    gbps: { scale: 1e9, type: "bits/sec" },
    tbps: { scale: 1e12, type: "bits/sec" },

    // TODO: make the flex unit alias support singular/plural
    flop: { scale: 1, type: "ops" },
    flops: { scale: 1, type: "ops/second" },

    kiloflop: { scale: 1e3, type: "ops" },
    kiloflops: { scale: 1e3, type: "ops/second" },

    megaflop: { scale: 1e6, type: "ops" },
    megaflops: { scale: 1e6, type: "ops/second" },
    mflop: { scale: 1e6, type: "ops" },
    mflops: { scale: 1e6, type: "ops/second" },

    gigaflop: { scale: 1e9, type: "ops" },
    gigaflops: { scale: 1e9, type: "ops/second" },
    gflop: { scale: 1e9, type: "ops" },
    gflops: { scale: 1e9, type: "ops/second" },

    teraflop: { scale: 1e12, type: "ops" },
    teraflops: { scale: 1e12, type: "ops/second" },
    tflop: { scale: 1e12, type: "ops" },
    tflops: { scale: 1e12, type: "ops/second" },

    petaflop: { scale: 1e15, type: "ops" },
    petaflops: { scale: 1e15, type: "ops/second" },
    pflop: { scale: 1e15, type: "ops" },
    pflops: { scale: 1e15, type: "ops/second" },

    exaflop: { scale: 1e18, type: "ops" },
    exaflops: { scale: 1e18, type: "ops/second" },
    eflop: { scale: 1e18, type: "ops" },
    eflops: { scale: 1e18, type: "ops/second" },

    zettaflop: { scale: 1e21, type: "ops" },
    zettaflops: { scale: 1e21, type: "ops/second" },
    zflop: { scale: 1e21, type: "ops" },
    zflops: { scale: 1e21, type: "ops/second" },

    yottaflop: { scale: 1e24, type: "ops" },
    yottaflops: { scale: 1e24, type: "ops/second" },
    yflop: { scale: 1e24, type: "ops" },
    yflops: { scale: 1e24, type: "ops/second" },

    kops: { scale: 1e3, type: "ops/second" },
    mops: { scale: 1e6, type: "ops/second" },
    gops: { scale: 1e9, type: "ops/second" },
    tops: { scale: 1e12, type: "ops/second" },
    pops: { scale: 1e15, type: "ops/second" },
    xops: { scale: 1e18, type: "ops/second" },
    exops: { scale: 1e18, type: "ops/second" },
    zops: { scale: 1e21, type: "ops/second" },

    mpge: { scale: 1 / 33.7, type: "miles/kWh" }, // 1 mile per gallon equivalent = 33.7 kWh

    // "molar concentration": { scale: 1, type: "mol/L" },
  },

  PREFIX_REMOVE: ["what is the", "what is", "whats", "what's", "how much is", "how much", "how many", "find", "figure out", "calculate", "convert"],

  L1_REPLACEMENTS_REGEX: {
    // TODO: should only be triggered by a Trie match on a keyword
    // Or, split the input, scan the string, and try to resume
    "divide by": {
      find: /divide (\S+) by (\S+)/gi, replace: "$1 / $2"
    },

    "subtract from": {
      find: /subtract (\S+) from (\S+)/gi, replace: "$2 - $1"
    },

    "multiply and": {
      find: /multiply (\S+) (and|with) (\S+)/gi, replace: "$1 * $3"
    },

    "add to": {
      find: /add (\S+) (and|to) (\S+)/gi, replace: "$1 + $3"
    },

    // R1:10 => R1:R10 [handle before variable assignment for (R1):10]
    "shorthandRowRef": {
      find: /\br(\d+)[:](\d+)\b/gi, replace: function (match, start, end) {
        return `r${start}:r${end}`;
      }
    },

    "unicodeWhitespace": {
      find: /[\u00a0\u2000-\u200a\u202f\u205f\u3000]/gi, replace: " "
    },

    // f(x) = x^2
    "functionShorthand": {
      find: /(\w+)\s*\(([\w\s,]*)\)\s*=\s*([^=].*)$/gm,
      replace: function (match, funcName, params, body) {
        const trimmedBody = body.trim();

        // ignore existing brackets
        // note that we may be split on semicolon, so only check first part
        const wrappedBody = trimmedBody.startsWith("{") ? trimmedBody : `{ ${trimmedBody} }`;

        // function declaration
        return `function ${funcName}(${params}) ${wrappedBody}`;
      }
    },

    "set": {
      // Matches any line that starts with "set" (ignoring case)
      find: /^\s*set\b(.*)$/i,
      replace: function (match, rest) {
        // make sure it's not a function call
        if (!rest.includes("=")) {
          return match;
        }

        // Trim the rest of the string.
        rest = rest.trim();
        // If the rest starts with a colon, remove it.
        if (rest.startsWith(':')) {
          rest = rest.slice(1).trim();
        }

        // Split the rest into individual assignments using commas.
        const assignments = rest.split(',');

        // For each assignment, split on "=" to extract key and value.
        const props = assignments.map(item => {
          let parts = item.split('=');
          if (parts.length < 2) return "";
          let key = parts[0].trim();
          // In case there are extra "=" in the value, join the remaining parts.
          let value = parts.slice(1).join('=').trim();
          return `${key}: ${value}`;
        }).filter(Boolean); // remove any empty results

        // Construct the final function call.
        return `set({${props.join(', ')}})`;
      }
    },

    "solve": {
      // Match a line starting with "solve" (ignoring case)
      find: /^\s*(?:solve|goalseek)\s+\b(.*)$/i,
      replace: function (match, rest) {
        // Split on the first "="
        const parts = rest.split('=');
        if (parts.length < 2) {
          // If there's no "=", leave the string unchanged.
          return match;
        }

        // remove commas
        parts[1] = parts[1].replace(/,/g, ' ');

        // Phase 1: Extract the target variable from the left-hand side.
        const targetVar = IC.canonicalName(parts[0].trim());

        // Phase 2: Process the right-hand side.
        // Join back any extra "=" that might have been in the RHS.
        const rhs = parts.slice(1).join('=').trim();
        // Split the RHS on whitespace
        const tokens = rhs.split(/\s+/);

        if (tokens.length === 0) {
          // If no tokens on the right-hand side, do nothing.
          return match;
        }

        // The first token is the target value.
        const targetValue = tokens[0];

        // Any subsequent tokens (filtered through IC.isDefinedVariable) are free parameters.
        const freeParams = tokens.slice(1).filter(token => IC.envIdentifierExists(token));

        // Build the function call string.
        if (freeParams.length > 0) {
          return `goalseek("${targetVar}", ${targetValue}, [${freeParams.map(p => '"' + p + '"').join(", ")}])`;
        } else {
          return `goalseek("${targetVar}", ${targetValue})`;
        }
      }
    }
  },

  L2_REPLACEMENTS_STRINGS: {
    "×": "*",
    "✕": "*", // multiplication X
    "÷": "/",
    "⁄": "/",
    "\u2212": "-",
    "–": "-",       // en dash
    "—": "-",       // em dash

    "**": "^",      // treat ** as ^ for all conversions, units, etc.

    "•": "*", // bullet
    "·": "*", // middot

    // annoying quotes: https://unicode-table.com/en/sets/quotation-marks/
    // https://gist.github.com/thanpolas/244d9a13151caf5a12e42208b6111aa6
    "\u201C": '"',
    "\u201D": '"',
    "\u201F": '"',
    "\u275D": '"',
    "\u275E": '"',
    "\u301D": '"',
    "\u301E": '"',

    "\u2018": "'",
    "\u2019": "'",
    "\u201B": "'",
    "\u275B": "'",
    "\u275C": "'",

    "√": "sqrt",
    "∛": "cbrt",

    "≠": "!=",
    "≤": "<=",
    "≥": ">=",

    "°": "deg", // degree

    // constants
    "\u03C0": "(PI)",
    "\u03C6": "(PHI)",
    "\u03C4": "(TAU)",
  },

  L3_REPLACEMENTS_REGEX: {

    // replace superscripts before we process identifiers
    "encodedSuperscriptExponents": {
      find: /((?:\\u207b)?(?:\\u00b9|\\u00b2|\\u00b3|\\u2074|\\u2075|\\u2076|\\u2077|\\u2078|\\u2079|\\u2070)+)/g,
      replace: function (match) {
        const superscripts = {
          '\\u00b9': '1',
          '\\u00b2': '2',
          '\\u00b3': '3',
          '\\u2074': '4',
          '\\u2075': '5',
          '\\u2076': '6',
          '\\u2077': '7',
          '\\u2078': '8',
          '\\u2079': '9',
          '\\u2070': '0',
          '\\u207b': '-'
        };

        let chunks = match.match(/.{6}/g); // Split the string into chunks of 6 characters
        let normalExponent = chunks.map(chunk => superscripts[chunk]).join('');

        return '^' + normalExponent;
      }
    },

    // sum r1:r3 => sum(r1:r3)
    "wrapRowRangeExpressionsInParens": {
      find: /(?<!\()(\br\d+\s*:\s*r\d+\b)(?!\))/g,
      replace: "($1)"
    }
  },

  L4_REPLACEMENTS_REGEX: {
    // TODO: make the "as|to|into|to" list a global config variable
    "as_percent": { find: /\s(as|to|into|in)\s+[%]/gi, replace: " -> percent " },
    "percent": { find: /\s(percent|pct)(\s+|\b)/gi, replace: "% " },

    // of becomes * for multiplication between two numbers. check for digit on either side
    "of": { find: /(\d)\s+(of)\s+(\d)/gi, replace: "$1 * $3" },

    // 12 inches = ? feet
    "=?": { find: /(=)\s*[?]/gi, replace: " -> " },

    // degrees F and C
    "degF": { find: /deg(ree(s)?)?\s*F(ahrenheit)?\b/gi, replace: "F" },
    "degC": { find: /deg(ree(s)?)?\s*C(el(c|s|ius))?\b/gi, replace: "C" },

    // colon assignment: x: 3 => x = 3
    "colonAssignment": {
      find: /^\s*(\b[a-zA-Z_]\w*)\s*[:]/,
      replace: '$1 = '
    },

    // explicitly set to undefined
    "emptyAssignment": {
      find: /(^\s*\b[a-zA-Z_]\w*)\s*=\s*$/g,
      replace: '$1 = undefined'
    },

    // = 3 + 3, 3 + 3 =, 3 + 3?
    "leadingOrTrailingSymbols": { find: /(^\s*[=]|[\?=]\s*$)/gi, replace: "" },

    // stock functions - no quotes needed
    "STOCK()": { find: /\bSTOCK[(]([a-zA-Z]+)[)]/gi, replace: `STOCK("$1")` },
    "STOCK:": { find: /\bSTOCK:([a-zA-Z]+)/gi, replace: `STOCK("$1")` },

    // cm2 => cm^2
    "unitPower": {
      find: /(\s|^|\d|\W)([a-z]+)([2-9])(\s|\b)/gi, replace: function (match, space, unit, power, rest) {
        // rankine...
        if (!IC.predefinedUnit(unit) || !IC.typestringIsSameUnitCategory(unit, "cm")) {
          return match;
        }
        return `${space}${unit}^${power}${rest}`;
      }
    },

    // log10 and log2 should be log_10 and log_2
    "logPower": {
      find: /\b(log)(10|2)\b/gi, replace: "log_$2"
    },

    // combination like 10C3, 5C3, genertally [int]c[int]
    "combination": {
      find: /\b(\d+)c(\d+)/gi, replace: function (match, n, k) {
        return `combination(${n}, ${k})`;
      }
    },

    "permutation": {
      find: /\b(\d+)p(\d+)/gi, replace: function (match, n, k) {
        return `permutation(${n}, ${k})`;
      }
    },

    // double single quote after a number becomes a double quote: 13' 2'' => 13' 2"
    "doubleQuote": { find: /(\d)''/g, replace: "$1\"" },

    // multiple "->" are replaced by a single ->
    "->": { find: /(\s*->\s*){2,}/g, replace: " -> " },

    // collapse 2 or more whitespace
    "whitespace": { find: /\s{2,}/g, replace: " " },

    // remove apostrophes from mexican-style numbers: 3'500 => 3500, 3'500.000 => 3500.000
    // require 3 digits after the apostrophe, and do negative lookahead for ["] symbol
    "mexicanApostrophe": { find: /(\d)'(\d{3})(?!\d|")/g, replace: "$1,$2" },

    "currencyThenNumber": {
      find: /\b([a-z]{3})(\d+)/gi, replace: function (match, code, digits) {
        if (ICUnit.isCurrency(code) && !IC.envIsDefined(match)) {
          return `${code} ${digits}`;
        }
        return match;
      }
    },

    "unitless": {
      find: /\b(no|without|remove|strip|clear|drop|omit|exclude|ignore)\s+(units?|dimensions?)\b/gi,
      replace: "unitless"
    },

    // UTC+9 => UTCPLUS9, especially in conversions
    "UTCAndGMT": {
      find: /->\s*(UTC|GMT)([+-])(\d+)/g,
      replace: (match, prefix, sign, number) => {
        return `-> ${prefix}${sign === '+' ? 'PLUS' : 'MINUS'}${number}`;
      }
    },

    // replace angle symbol (\u2220) with :phaseangle: 
    // 5∠60.4 => 5 :phaseangle: 60.4
    "phasor": {
      find: /(\d+)\s*(\\u2220|angle)\s*(\d+)/gi,
      replace: (match, magnitude, symbol, angle) => {
        if (IC.envIsDefined(symbol)) {
          return match;
        }

        return `${magnitude} :phaseangle: ${angle}`;
      }
    }

  },

  L5_REPLACEMENTS_STRINGS: {

    /*
    // builtin constants
    // TODO: these constants should be under predefined variables, I think
    "c_light": "(299,792,458 meters/second)",
    // "speed of light": "(299,792,458 meters/second)",
 
    "g_accel": "(9.8 meters/second^2)", // gravitational acceleration
    //    "gravity": "(9.8 meters/second^2)",
    "smallG": "(9.8 meters/second^2)",
 
    "g_const": "(6.67430 * 10^-11 newton meter^2 / kilogram^2)", // gravitational constant
    "gravitational_constant": "(6.67430 * 10^-11 newton meter^2 / kilogram^2)",
    "bigG": "(6.67430 * 10^-11 newton meter^2 / kilogram^2)",
 
    "planck_const": "(6.62607015 * 10^-34 meter^2 kilogram / second)",
    "h_planck": "(6.62607015 * 10^-34 meter^2 kilogram / second)",
 
    "e_charge": "(1.602176634 * 10^-19 coulombs)", // electron charge
    "avogadro_const": "(6.02214076 * 10^23 per mole)",
 
    "boltzmann_const": "(1.380649 * 10^-23 joules/kelvin)",
    "k_boltzmann": "(1.380649 * 10^-23 joules/kelvin)",
 
    "r_gas": "(8.314462618 joules/(mole·kelvin))", // gas constant
 
    "faraday_const": "(96,485.33212 coulombs/mole)",
    "F_faraday": "(96,485.33212 coulombs/mole)",
 
    // Particle masses
    "electron mass": "(9.10938356 * 10^-31 kilograms)",
    "proton mass": "(1.6726219 * 10^-27 kilograms)",
 
    // Astronomical constants
    "earth mass": "(5.97237 * 10^24 kilograms)",
    "earth radius": "(6,371 kilometers)",
 
    "moon mass": "(7.342 * 10^22 kilograms)",
    "moon radius": "(1,737.5 kilometers)",
 
    "sun mass": "(1.989 * 10^30 kilograms)",
    "sun radius": "(696,340 kilometers)",
    */
  },

  PLAIN_ENGLISH_OPS: {
    add: "+",
    "added to": "+",
    plus: "+",
    minus: "-",
    times: "*",
    "multiply by": "*",
    "by": "*",
    mul: "*",
    multiply: "*",
    "multiplied by": "*",
    div: "/",
    "divide by": "/",
    "divided by": "/",
    "out of": "/",
    "over": "/",
    "subtracted from": "* -1 +",
    "take away": "-",
    "to the power of": "^",
    "to the power": "^",
    "raised to the power of": "^",
    "raised to the power": "^",
    "raised to": "^",
    "power": "^",
    "pow": "^",
    "half of": "0.5 *",
    "half": "0.5 *",
    "twice": "2 *",
    "double": "2 *",
    "triple": "3 *",
    "thrice": "3 *",
    "quadruple": "4 *",

    "is": " = ",
    "are": " = ",
    "equals": " = ",

    sub: "-",
    subtract: "-",
    negative: "-", // three plus negative two: 3+ -2
    modulo: " mod",

    // full names for math functions
    cosine: "cos ",
    sine: "sin ",
    tangent: "tan ",
    cotangent: "cot ",
    secant: "sec ",
    cosecant: "csc ",

    // remember: longest match first
    "is what percentage of": " :pctof: ",
    "is what percent of": " :pctof: ",
    "is what pct of": " :pctof: ",
    "is what % of": " :pctof: ",
    "is what of": " :pctof: ",
    "as a percentage of": " :pctof: ",
    "as a percent of": " :pctof: ",
    "as a pct of": " :pctof: ",
    "as a % of": " :pctof: ",

    "% of what is": "% inverse *", // 20% of what is 30 => 20% inverse * 30

    "choose": ":choose:",
    "pick": ":choose:", // wolfram alpha uses pick as choose
    "permute": ":permute:",

    "percentage of": "% of ",
    "percent of": "% of ",
    "pct of": "% of ",

    "square root": "sqrt",
    "cube root": "cbrt",

    // conversion words
    "into a": " -> ",
    "to a": " -> ",
    "as a": " -> ",
    "in a": " -> ",

    "converted to": " -> ",
    "convert to": " -> ",
    "convert": " -> ",
    "as": " -> ",
    "into": " -> ",
    "to": " -> ",
    // no "in" because it could be "inch"

    // typesolve words
    "using": " @ ",
    "with": " @ ",
    "at": " @ ",
    "for": " @ ",

    "per": "/",
    "every": "/",
    "until": "/",

    // simple replacement. TODO: have a proper "until" operator
    "days until": "now - ",

    /*
    "ago": "* -1 + now",
    "from now": " + now",
    "before": "* -1 + now",
    "after": " + now",
    */

    /*
    // TODO: scan the entire set of rows for an assignment, and use that reference. otherwise "daily edge = 3" will be transformed.
 
    "hourly": "/hour",
    "daily": "/day",
    "weekly": "/week",
    "monthly": "/month",
    "yearly": "/year",
    "annually": "/year",
    */
  }
};

const CoreModule = {
  CALC: new LIB.InstaCalc(),
  NOPARSE: { msg: "PARSE ERROR" },
  CACHE: {}, // initialied later

  // note: 0 and Infinity are valid; looking for null/undefined/failed parse
  isValidEvalResult(eval_result) {
    return eval_result != null
      && typeof eval_result !== "undefined"
      && eval_result != IC.NOPARSE;
  },

  arrayLimitCheck(arr, index) {
    if (Array.isArray(arr) && (index >= CONFIG.SETTINGS.MAX_ARRAY_SIZE || arr.length >= CONFIG.SETTINGS.MAX_ARRAY_SIZE)) {
      IC.log(`Array size limit ${CONFIG.SETTINGS.MAX_ARRAY_SIZE}`);
      return false;
    }
    return true;
  },

  // case insensitive key search in object
  ICObjectLiteralFindKey: function (obj, key = "") {
    if (obj && typeof obj === 'object') {
      // First, try exact match
      if (obj.hasOwnProperty(key)) {
        return key;
      }

      // If exact match not found, try case-insensitive match
      let lowercaseKey = key.toLowerCase();
      return Object.keys(obj).find(k => k.toLowerCase() === lowercaseKey);
    }

    return undefined;
  },

};

const LogModule = {

  _log_paused: false,

  // log a function call. Inside the function, $1 and $2 are replaced with the argument
  // info: error: warning: as type prefix
  log(str) {
    if (IC._log_paused || IC.info.rowIndex === undefined) {
      return;
    }

    IC.info.logs[IC.info.rowIndex] = IC.info.logs[IC.info.rowIndex] || [];
    IC.info.logs[IC.info.rowIndex].push(str);
  },

  logNewUnit: function (name) {
    if (!name.trim()) {
      return;
    }

    name = IC.parser.unescapeUnicode(name);

    // "3 gigabytes" is just "gigabytes"
    if (ICUnit.unitStringHasNumber(name)) {
      name = ICUnit.unitStringExtractNumber(name)[1];
    }

    let customUnitIgnore =
      IC.typestringIsPossibleUnitIncludingSlash(name) ||
      CONFIG.FLEX_UNIT_ALIAS[name.toLowerCase()] ||
      CONFIG.CUSTOM_UNIT_IGNORE[name.toLowerCase()] ||
      ICDate.getIANATimeZone(name.toUpperCase());
    ;

    if (!customUnitIgnore) {
      IC.log("custom unit: " + name);
      return;
    }

    IC.log("unit: " + IC.unitDisplayName(name));
  },

  logFunctionReference(name) {
    let msg = IC.predefinedFunction(name) ? `function: ${name}` : `missing function: ${name}`;
    IC.log(msg);
  },

  logPause() {
    IC._log_paused = true;
  },

  logResume() {
    IC._log_paused = false;
  },

  logSetCurrentRow(log) {
    IC.info.logs[IC.info.rowIndex] = log;
  },

  logGetCurrentRow() {
    return IC.info.logs[IC.info.rowIndex];
  },

  logClear() {
    IC.info.logs[IC.info.rowIndex] = [];
  },

  logProcess(log, result) {
    const entries = [...new Set(log)];
    const units = {
      custom: new Set(),
      standard: new Set()
    };

    let finalLog = [];
    let sawFunction = false;

    let hasPlainEnglishFunction = log.find(el => {
      return el.match(/fn:/) && CONFIG.ENGLISH_FUNCTION[el.split(":")[1]?.trim()?.toUpperCase()];
    });

    entries.forEach((entry) => {
      const [type, msg] = entry.split(":").map((e) => e.trim());

      if (hasPlainEnglishFunction) {
        switch (type) {
          case "custom unit":
          case "unit":
          case "function":
            break;
          default:
            finalLog.push(entry);
        }
        return;
      }

      switch (type) {
        case "custom unit":
          units.custom.add(msg);
          break;
        case "unit":
          if (![...units.standard].some((unit) => IC.typestringIsSameUnitAndScale(unit, msg))) {
            units.standard.add(msg);
          }
          break;
        case "function":
          if (CONFIG.FUNCTION_HELP_MSG[msg.toLowerCase()] && !sawFunction) {
            finalLog.push('info: ' + CONFIG.FUNCTION_HELP_MSG[msg.toLowerCase()]);
            sawFunction = true;
          }
          break;
        default:
          finalLog.push(entry);
      }
    });

    const formatUnits = (type, prefix, formatter) => type.size ? `${prefix}${type.size > 1 ? "units" : "unit"}: ${[...type].map(formatter).join(", ")}` : '';

    let stdUnitsStr = formatUnits(units.standard, "", (unit) => {
      let isCompact = units.standard.size > 1;

      const helpMsg = CONFIG.getUnitHelpMessage(unit, isCompact);
      let infoMsg = helpMsg ? "" : ICUnit.infoMessage(unit);
      let message = `${unit}${helpMsg ? " " + helpMsg : ""} ${units.standard.size === 1 ? infoMsg : ""}`;
      return message.trim();

      // short name
      return unit;
    });

    const customUnitsStr = formatUnits(units.custom, "custom ", unit => unit);

    /*
    const varFoundLog = [...units.custom, ...units.standard]
      .map(unit => IC.envGetLongestIdentifierMatch(unit) && `variable/unit overlap: ${IC.envGetLongestIdentifierMatch(unit)}. Automultiply works with single letter variables: xy = x * y`)
      .filter(Boolean);
      */

    // quick fix for time_compact
    let format = IC.format(result);
    if (format.startsWith("time_") && stdUnitsStr.startsWith("unit: s")) {
      stdUnitsStr = CONFIG.getUnitHelpMessage("time");
    }

    // if a

    return [customUnitsStr, stdUnitsStr, ...finalLog].filter(Boolean);
  },
};

const EnvModule = {
  // environment items
  env: {},
  info: {},

  envReset() {
    IC.env = {};
    IC.envResetRowInfo();
  },

  envResetRowInfo() {
    IC.info = {
      _temp: {},    // temp data for the row
      inputRows: [], // original inputs
      rowIndex: 0,
      rowRefs: {}, // rows with a reference
      varRefs: {}, // variables being referenced 
      formatters: {}, // rows with a format string
      titles: {},
      unitTitles: {},
      comments: {},
      identifiers: {}, // variable names in use
      logs: {}, // argument call log
      strings: {}, // strings which are replaced for easier processing
      cancelledUnits: {}, // whether a unit may have been cancalled during multiplication
      settings: {}, // calc and rounding settings
      unitOverride: false // if "miles" is defined as var, but treat as unit
    };
  },

  envResetRowInfoForExecution() {
    // see if we already have defined objects...
    if (typeof IC.info.logs !== "object") {
      IC.envResetRowInfo();
    }

    IC.info.logs[IC.info.rowIndex] = [];
    IC.info.formatters[IC.info.rowIndex] = {};
    IC.info.cancelledUnits[IC.info.rowIndex] = false;
    IC.info.titles[IC.info.rowIndex] = "";
    IC.info.comments[IC.info.rowIndex] = "";
    IC.info._temp = {};
  },

  envGetTemp(name) {
    return IC.info._temp[name];
  },

  envSetTemp(name, value) {
    IC.info._temp[name] = value;
  },

  envAddString(str) {
    let info = IC.envGetInfo();
    let i = Object.keys(info.strings).length;
    let key = `:string_${IC.envGetRowIndex()}_${i + 1}_`;
    info.strings[key] = str;
    return key;
  },

  envGetString(key) {
    let info = IC.envGetInfo();
    return info.strings[key];
  },

  envGetStrings() {
    return IC.envGetInfo().strings;
  },

  envSetStrings(strings) {
    IC.envGetInfo().strings = strings;
  },

  envReplaceStrings(input) {
    input = input.replace(/(:string_\d+_\d+_)/g, (match) => IC.envGetString(match));
    return input;
  },

  envGet() {
    return IC.env;
  },

  envGetVariablesOnly() {
    // return IC.env with r1 r2 etc filtered out, but the entire key/value.
    // it should return a new object
    let newObj = {};
    for (let key in IC.env) {
      if (key.match(/r\d+/i)) {
        continue;
      }
      newObj[key] = IC.env[key];
    }
    return newObj;
  },

  envNewStartEnv(i, settings) {
    IC.envSetRowIndex(i);
    IC.envSetSettings(settings);
    IC.envResetRowInfoForExecution();
    const startEnv = Object.assign({}, IC.envGet());
    return startEnv;
  },

  envSet(env) {
    IC.env = Object.assign({}, env);
  },

  envGetInfo() {
    return IC.info;
  },

  envSetInfo(info) {
    IC.info = Object.assign({}, info);
  },

  envGetRowIndex() {
    return IC.info.rowIndex;
  },

  envSetRowIndex(i) {
    IC.info.rowIndex = i;
  },

  envSetSettings(settings) {
    IC.info.settings = settings;
  },

  envGetSettings() {
    return IC.info.settings;
  },

  envSetFormatter: function (currencyObj) {
    IC.info.formatters[IC.info.rowIndex] = currencyObj;
  },

  envGetFormatter: function () {
    return IC.info.formatters[IC.info.rowIndex];
  },

  // Clear formatter for current row
  clearRowFormat: function () {
    IC.info.formatters[IC.info.rowIndex] = null;
  },

  // Set formatter for current row
  setRowFormat: function (currencyObj) {
    IC.info.formatters[IC.info.rowIndex] = currencyObj;
  },

  envSetInputRows(rows) {
    IC.info.inputRows = rows;
  },

  envGetInputRows() {
    return IC.info.inputRows;
  },

  envGetCurrentInput() {
    return IC.envGetInputRows()[IC.envGetRowIndex()];
  },

  envSetHasCancelledUnit() {
    IC.info.cancelledUnits[IC.info.rowIndex] = true;
  },

  envGetHasCancelledUnit() {
    return IC.info.cancelledUnits[IC.info.rowIndex];
  },

  envNormalizeTitle: function (title) {
    return title ? title.replace(/(_+| +)+/g, ' ').trim() : title;
  },

  envSetRowTitle: function (title) {
    IC.info.titles[IC.info.rowIndex] = IC.envNormalizeTitle(title);
  },

  envGetRowTitle: function () {
    return IC.info.titles[IC.info.rowIndex];
  },

  envSetUnitTitle: function (unit, title) {
    let key = `${IC.info.rowIndex}${unit}`;
    IC.info.unitTitles[key] = title;
  },

  envGetUnitTitle: function (unit) {
    let key = `${IC.info.rowIndex}${unit}`;
    return IC.info.unitTitles[key] || unit;
  },

  envSetRowComment: function (comment) {
    if (comment) {
      comment = comment.trim();
      IC.info.comments[IC.info.rowIndex] = comment;
    }
  },

  envSetIdentifier: function (id) {
    if (id) {
      id = IC.canonicalName(id);
      IC.info.identifiers[id] = true;
    }
  },

  envCheckOverlappingId(id) {
    id = id.trim();
    if (!id.includes(" ")) return;

    let parts = id.split(" ");
    if (parts.every((part) => IC.envIsDefined(part))) {
      IC.log(`warning: var '${id}' overlaps with '${parts.join(", ")}'`);
    }
  },

  // TODO: need to consolidate these various checking functions
  envIsDefined: function (name) {
    if (!name) return false;
    return IC.envIsVariableDefined(name) || IC.predefinedIdentifier(name) || IC.envIdentifierExists(name);
  },

  // ugh, so many functions. this one does a global search
  envIsDefinedSearchAll: function (name) {
    return IC.envIsDefined(name) || IC.predefinedFunction(name) || IC.predefinedUnit(name);
  },

  envIdentifierExists: function (id) {
    id = IC.canonicalName(id);
    return IC.info.identifiers[id] ?? IC.env[id];
  },

  envGetIdentifiers: function () {
    return Object.keys(IC.info.identifiers);
  },

  envIsUserFunction: function (name) {
    return IC.envGetVariable(name)?.type === "function";
  },

  // look at input, find longest identifier it starts with
  envGetLongestIdentifierMatch: function (input) {
    let processed = input.trim();
    let idsLongestFirst = IC.envGetIdentifiers().sort((a, b) => b.length - a.length);
    let id = idsLongestFirst.find((id) => processed.startsWith(id));
    return id;
  },

  /**
   * Logs if there are any overrides
   * @param {string[]} ids - new identifiers for this row
   */
  envCheckIdentifierWarnings(ids) {
    ids.forEach((id) => {
      IC.envCheckOverlappingId(id);

      let unit, keyword, constant;
      if ((unit = IC.typestringIsPossibleUnitIncludingSlash(id)) && id.length >= 2) {
        // don't worry about a, n, etc. -- only larger units like cm, inch, and so on

        let typeMsg = unit?.name ? `:${unit.name}` : "";
        IC.log(`overriding '${id}${typeMsg}', be cautious in conversions`);
      } else if ((keyword = IC.stringIsKeyword(id))) {
        IC.log(`overriding keyword '${id}'`);
      } else if ((constant = IC.predefinedIdentifier(id))) {
        IC.log(`overriding predefined '${id}'`);
      }
    });
  },

  /**
    * Warns if this is an empty object and converts back to plain number
    * @param {ICObject} ret
    * @returns ICObject | number
    */
  envCheckCancelledUnits(ret) {
    // an array could be passed in, which is instance of "object"
    if (IC.hasNoType(ret) && IC.format(ret) == "" && IC.envGetHasCancelledUnit()) {
      IC.log(`units cancel to number`);
      return IC.val(ret);
    }
    return ret;
  },

  envGetRowComment: function () {
    return IC.info.comments[IC.info.rowIndex];
  },

  envGetVariableReferences: function () {
    return Object.keys(IC.info.varRefs);
  },

  envHasMissingRowReference: function (i) {
    return IC.info.rowRefs[i];
  },

  /**
    * Is the variable an autouint (cm => 1cm) or actually defined (x = 3)
    * @param {string} varname 
    * @returns boolean
    */
  envIsAutoUnit(varname) {
    return !IC.envIsDefined(varname) && IC.predefinedUnit(varname);
  },

  // split x[10] or a.b.c
  getVariableParts(name) {
    const hasTrailingDot = name.endsWith('.');

    // Split the variable name, but keep trailing dot if present
    let parts = name.split(/[.\[]/).map(part => part.replace(']', ''));
    if (hasTrailingDot) {
      parts[parts.length - 1] += '.'; // allow x. = 10 (as an assignment)
      delete parts[parts.length - 1];
    }

    return parts;
  },

  envAssignVariable(x, op, val) {
    x = IC.canonicalName(x);
    val = IC.envCheckCancelledUnits(val);

    let parts = IC.getVariableParts(x);

    const baseVar = parts[0];

    // If it's a simple assignment (no nested properties or array indices)
    if (parts.length === 1) {
      return IC.assignValueIntoObject(IC.env, x, op, val);
    }

    // Rest of the function remains the same for handling nested structures
    if (!(baseVar in IC.env)) {
      IC.env[baseVar] = parts[1] === '' ? [] : {};
    }

    let current = IC.env[baseVar];
    for (let i = 1; i < parts.length - 1; i++) {
      const part = parts[i];
      if (part === '') {
        if (!Array.isArray(current)) {
          current = [];
        }

        if (!IC.arrayLimitCheck(current, current.length)) return undefined;

        current.push(parts[i + 1] === '' ? [] : {});
        current = current[current.length - 1];
      } else if (!isNaN(part)) {
        const index = parseInt(part);
        if (!Array.isArray(current)) {
          current = [];
        }

        if (!IC.arrayLimitCheck(current, current.length)) return undefined;
        if (!(index in current)) {
          current[index] = parts[i + 1] === '' ? [] : {};
        }
        current = current[index];
      } else {
        if (!(part in current)) {
          current[part] = parts[i + 1] === '' ? [] : {};
        }
        current = current[part];
      }
    }

    const lastPart = parts[parts.length - 1];
    const lastIndex = lastPart === '' ? current.length : (!isNaN(lastPart) ? parseInt(lastPart) : lastPart);

    if (lastPart === '' || !isNaN(lastPart)) {
      if (!IC.arrayLimitCheck(current, current.length)) return undefined;
      if (!IC.arrayLimitCheck(current, lastIndex)) return undefined;
    }

    return IC.assignValueIntoObject(current, lastIndex, op, val);
  },

  assignValueIntoObject(obj, key, op, val) {
    if (op === '=') {
      if (Array.isArray(val)) {
        IC.arrayLimitCheck(val, val.length - 1);
      }

      obj[key] = Array.isArray(val) || typeof val === 'object'
        ? JSON.parse(JSON.stringify(val))
        : val;
    } else if (op.endsWith('=') && op.length > 1) {
      const baseOp = op.slice(0, -1);
      obj[key] = IC.semanticInfixOp(IC.val(obj[key]), baseOp, val);
    }
    return obj[key];
  },

  envAssignRowResult(result) {
    let rowName = "r" + (IC.info.rowIndex + 1);
    IC.envAssignVariable(rowName, "=", result ?? 0); // default value for any row
  },

  envIsVariableDefined(name) {
    return IC.canonicalName(name) in IC.env;
  },

  envFindInflectionVariant(name) {
    const canonicalName = IC.canonicalName(name);
    const variants = [
      canonicalName,
      IC.stringPluralize(canonicalName),
      IC.stringSingularize(canonicalName)
    ];

    for (const variant of variants) {
      if (IC.envIsDefined(variant)) {
        return variant;
      }
    }

    return null;
  },

  envSetVariable(name, value) {
    return IC.envAssignVariable(name, "=", value);
  },

  envGetVariable(name) {
    if (!name) {
      return undefined;
    }
    let x = IC.canonicalName(name);

    // special case: sin(2 * PI rad) or sin(x rad)
    // or [varname] [scalename]
    // radians need to be broken out separately from "pi rad" variable
    // same with x gbps
    let matches = name.trim().split(" ");
    if (matches.length > 1) {
      let suffix = matches.pop();
      let scale = IC.predefinedSuffixScale(suffix);
      let realName = matches.join(" ");

      if (scale !== 1 && IC.envIsDefined(realName)) {
        return IC.mathMul(scale, IC.envGetVariable(realName));
      }
    }

    // don't check for IC.env[x], which could be 0
    if (x in IC.env) {
      // successful var lookup
      IC.info.varRefs[x] = true;
      return IC.env[x] ?? 0; // null/undefined defaults to 0 when used 
    }

    // accessing a missing row ref
    if (x.match(/^r\d+$/i)) {
      IC.info.rowRefs[IC.info.rowIndex] = true;
      return 0;
    }

    var val = IC.predefinedIdentifier(x);
    return typeof val == "function" ? val() : val || undefined;
  },

  envGetRowRangeVariables(startIndex, endIndex) {
    let values = [];
    let maxIndex = Math.min(IC.envGetInputRows().length, endIndex);
    for (var i = startIndex; i <= maxIndex; i++) {
      if (i == IC.info.rowIndex + 1) {
        values.push(0);       // avoid circular reference to current row; SUM(R1:R5), which appears on R3
        continue;
      }

      values.push(IC.envGetVariable("r" + i));
    }

    IC.envSetTemp("startIndex", startIndex);
    IC.envSetTemp("endIndex", maxIndex);

    return values;
  },

  /** metadata for the last accessed rowrange */
  envGetRowRangeMeta() {
    let startIndex = IC.envGetTemp("startIndex");
    let endIndex = IC.envGetTemp("endIndex");

    let data = [];
    for (var i = startIndex; i <= endIndex; i++) {
      const idx = i - 1;
      data.push({ title: IC.info.titles[idx], comment: IC.info.comments[idx] });
    }

    return data;
  },


}

const ObjectModule = {
  val(a) {
    if (a instanceof Date) return a;
    if (a instanceof Array) return IC.ICArrayLiteralUnwrap(a); // must happen before object check
    if (a instanceof Object && a.hasOwnProperty("v")) return a.v;

    return a;
  },

  // native IC object vs generic object
  isICObject: function (obj) {
    //required keys 'v' and 't', and no extra keys
    return obj instanceof Object &&
      obj.hasOwnProperty('v') &&
      obj.hasOwnProperty('t') &&
      Object.keys(obj).every(key => ['v', 't', 'f'].includes(key));
  },

  isCustomObject: function (obj) {
    return obj instanceof Object && !IC.isICObject(obj);
  },

  isCustomFunction: function (obj) {
    return (obj instanceof Object) && obj?.type === "function";
  },

  anyIsObject: function (a, b) {
    return (IC.isICObject(a) && a) || (IC.isICObject(b) && b) || null;
  },

  anyIsCustomObject: function (a, b) {
    return (IC.isCustomObject(a) && a) || (IC.isCustomObject(b) && b) || null;
  },

  // add or subtract: 4 inches + 3cm shoudl convert everything to cm (if possible and add). otheriwse just add
  allAreObjects: function (a, b) {
    return IC.isICObject(a) && IC.isICObject(b);
  },

  // either is a valid datestring
  anyIsDate: function (aVal, bVal) {
    if (typeof aVal == "string" || typeof bVal == "string") {
      return ICDate.isDateString(aVal) || ICDate.isDateString(bVal);
    }
    return false;
  },

  /**
    *
    * @typedef {Object} ICObject
    * @property {number} v - value
    * @property {ICType} t - type {m: 2, s: 2}
    * @property {string|null} f - format
    */

  /**
   *
   * @typedef {Object.<string, number>} ICType - Maps unit to powers, {m: 2, s: 2}
   */

  _makeICObjectUnitType: function (type) {
    let val = 1;
    const createObject = (t = {}) => ({ v: val, t: t });

    type = type.trim();
    if (type.includes("\\")) {
      type = IC.parser.unescapeUnicode(type);
      type = (type || "").toString(); // for TS
    }

    // note: units are really multiplied and divided, and should use the same flow.

    // rates: "miles/hour", "m / s / kg"
    const [numerator, ...denominators] = type.split("/");
    if (denominators.length) {
      return denominators.reduce(
        // passing collapse = false: don't want hz/day turned into cycles / sec^2
        (result, unit) => IC.mathDiv(result, IC._makeICObjectTypeOnly(1, unit), false),
        IC._makeICObjectTypeOnly(val, numerator)
      );
    }

    // space-separated multiplications: "m^1 s^2", "kg s"
    const units = type.split(" ");
    if (units.length > 1 && units.every(IC.typestringIsPossibleUnitIncludingSlash)) {
      return units.reduce(
        (result, unit) => IC.mathMul(result, IC._makeICObjectTypeOnly(1, unit), false),
        val
      );
    }

    // cm, cm^2, sq cm...
    const [parsedType, power] = ICUnit.getUnitNameAndPower(type);
    return createObject({ [parsedType]: power });
  },

  /**
   * Create new ICObject
   * @param {number|string|Date|null} val
   * @param {string|ICType|null} type - typestring, like "cm/s"
   * @returns ICObject
   */
  _makeICObjectTypeOnly: function (val, type) {
    const createObject = (t = {}) => ({ v: val, t: t });

    if (!type || val == null) return createObject();
    if (type instanceof Object) return createObject(type);
    if (IC.predefinedUnit(type)) return createObject({ [type]: 1 }); // quick return known type
    if (typeof type == "string" && IC.envGetVariable(type)) return createObject({ [type]: 1 }); // unknown type

    return IC.mathMul(val, IC._makeICObjectUnitType(type));
  },

  cloneObject: function (obj) {
    return structuredClone(obj);
    // return JSON.parse(JSON.stringify(obj));
  },

  /**
   * Create new ICObject
   * @param {number|string|Date|null} val
   * @param {string|ICType|null} type
   * @param {string} format
   * @returns ICObject
   */
  makeICObject: function (val, type = {}, format = "") {
    let ret = IC._makeICObjectTypeOnly(val, type);

    // TODO: figure out why ret is coming back null
    if (ret.t) {
      for (let unit in ret.t) {
        if (IC.typestringHasUnitWarning(unit) && false) return null;
        IC.logNewUnit(unit);
      }
    }

    ret.f = format.toLowerCase().trim();
    return IC.cloneObject(ret);
  },

  ICObjectSetFormat(obj, format) {
    if (obj instanceof Object && typeof format === "string") {
      obj.f = format.toLowerCase().trim();
    }
  },

  ICObjectPrettyPrint(obj) {
    if (!IC.isICObject(obj)) {
      return String(obj);
    }

    let value = IC.val(obj);
    let type = IC.typestring(obj.t);
    let format = IC.format(obj);

    let result = value;

    // Apply formatting if available
    if (format) {
      result = IC.parser.formatResult(obj, IC.envGetSettings());
    }

    // Add type if available
    if (type) {
      result += ` ${type}`;
    }

    return result;
  },

  format(obj) {
    return obj?.f ?? "";
  },

  /**
   * Combine individual display formats 
   * @param {string} formatA 
   * @param {string} formatB 
   * @param {boolean} mergeOk -- whether to merge format if they both are defined
   * @returns 
   */
  ICObjectFormatMerge(formatA, formatB, mergeOk) {

    // combine percentages if they are both there
    if (formatA === "percent" || formatB === "percent") {
      return formatA === formatB ? formatA : "";
    }

    // If either formatA or formatB is not defined, return the other
    if (!formatA || !formatB) {
      return formatA || formatB;
    }

    // 3' + 4' = 7'
    if (mergeOk) {
      return formatA;
    }

    // 3' * 4' = 12 sq ft
    return "";
  },

  // if type is "inverse", flip it. 6 hour^-1 => 1/6 hour
  ICObjectOptionalInvert: function (obj) {
    if (IC.hasNoType(obj)) {
      return obj;
    }

    let allNegative = Object.values(obj.t).every((v) => v < 0);
    if (allNegative) {
      return IC.mathDiv(1, obj);
    }
    return obj;
  },

}

const LiteralModule = {
  makeNumber(n, settings = {}) {
    let locale = settings?.locale || "en-US";

    // Handle different input types
    if (typeof n === 'number') {
      return n;
    }
    if (typeof n === 'boolean') {
      return n ? 1 : 0;
    }
    if (typeof n !== 'string') {
      return NaN;
    }

    n = n.replace(/_/g, "");
    let float = IC.parseLocaleNumber(n, locale);
    return float;
  },

  makeBoolean: function (str) {
    return str.toLowerCase() == "true";
  },

  makeString: function (str) {
    return str;
  },

  makeNumberInBase: function (n, base) {
    let val;
    if (typeof n == "string") {
      let [intPart, fracPart] = n.replace(/_/g, "").split(".");
      val = parseInt(intPart, base);
      if (fracPart) {
        for (let i = 0; i < fracPart.length; i++) {
          val += parseInt(fracPart[i], base) / Math.pow(base, i + 1);
        }
      }
    } else {
      val = n;
    }
    return val;
  },

  makeHexadecimal: function (n) {
    let val = this.makeNumberInBase(n, 16);
    return IC.makeICObject(val, null, "hex");
  },

  makeOctal: function (n) {
    let val = this.makeNumberInBase(n, 8);
    return IC.makeICObject(val, null, "oct");
  },

  makeBinary: function (n) {
    let val = this.makeNumberInBase(n, 2);
    return IC.makeICObject(val, null, "bin");
  },

  /** 
     * Parse a localized number to a float. https://stackoverflow.com/questions/29255843/is-there-a-way-to-reverse-the-formatting-by-intl-numberformat-in-javascript
     * @param {string} stringNumber - the localized number
     * @param {string} locale - [optional] the locale that the number is represented in. Omit this parameter to use the current locale.
     */
  REGEX_SEP: {},
  parseLocaleNumber(stringNumber, locale) {
    IC.REGEX_SEP["t" + locale] ||= Intl.NumberFormat(locale).format(11111).replace(/\p{Number}/gu, '');
    IC.REGEX_SEP["d" + locale] ||= Intl.NumberFormat(locale).format(1.1).replace(/\p{Number}/gu, '');

    IC.REGEX_SEP["tregex" + locale] ||= new RegExp('\\' + IC.REGEX_SEP["t" + locale], 'g');
    IC.REGEX_SEP["dregex" + locale] ||= new RegExp('\\' + IC.REGEX_SEP["d" + locale]);

    return parseFloat(stringNumber
      .replace(IC.REGEX_SEP["tregex" + locale], '')
      .replace(IC.REGEX_SEP["dregex" + locale], '.')
    );
  },
}

const TypeModule = {
  // @param string parsedType - the type string
  // @returns Boolean
  typestringHasUnitWarning: function (parsedType) {
    if (IC.envIsVariableDefined(parsedType)) {
      const unitRet = IC.predefinedUnit(parsedType);
      const unitMsg = unitRet?.name ? `type: ${unitRet.name}` : "";
      const msg = unitRet ?
        `warning: using '${parsedType}' as unit, not var` : "";
      /* `error: cannot use ${parsedType} as unit`; */
      if (msg) IC.log(msg);
      if (!unitRet) return true;
    }

    return false;
  },

  typePowerCount: function (typeA = {}) {
    return Object.values(typeA)
      .map((v) => Math.abs(v))
      .reduce((a, b) => a + b, 0);
  },

  typePowerCountNet: function (typeA = {}) {
    return Object.values(typeA)
      .reduce((a, b) => a + b, 0);
  },

  // magic-solve for missing constraint
  // 15 mph @ 10 miles = time (10 miles / 15 mph)
  // 10 miles @ 15 mph = distance (10 miles * 15 mph)
  // 15 mph @ 10 minutes = distance (15 mph * 10 minutes)
  typeSolve: function (objA, objB, tries = 1) {

    let typeA = objA?.t || {}; // could be $15 / day @ $50  
    let typeB = objB?.t || {};

    let typestringA = IC.typestring(typeA);
    let typestringB = IC.typestring(typeB);

    let maxPowerCount = Math.max(IC.typePowerCount(typeA), IC.typePowerCount(typeB));

    // don't flatten information units - let the best matchup be used
    let AmulB = IC.mathMul(objA, objB, false);
    let AdivB = IC.ICObjectOptionalInvert(IC.mathDiv(objA, objB));
    let BdivA = IC.ICObjectOptionalInvert(IC.mathDiv(objB, objA));

    if (IC.hasNoType(objA) || IC.hasNoType(objB)) {
      let best = [AmulB, AdivB, BdivA].map((obj) => {
        return { obj: obj, netPowerCount: IC.typePowerCountNet(obj.t) }
      }).sort((a, b) => b.netPowerCount - a.netPowerCount)[0].obj; // reverse sort
      IC.log(`autosolve: ${typestringA || "unitless"} & ${typestringB || "unitless"} -> ${IC.typestring(best.t)}`);
      // remove currency formatting, likely used as unit...
      if (IC.envGetFormatter()?.code) {
        IC.envSetFormatter(null);
      }
      return best;
    }

    if (IC.typePowerCount(AmulB.t) <= maxPowerCount) {
      IC.log(`autosolve: ${typestringA} & ${typestringB} → ${IC.typestring(AmulB.t)}`);
      return AmulB;
    }

    if (IC.typePowerCount(AdivB.t) <= maxPowerCount) {
      IC.log(`autosolve: ${typestringA} & ${typestringB} → ${IC.typestring(AdivB.t)}`);
      return AdivB;
    }

    if (IC.typePowerCount(BdivA.t) <= maxPowerCount) {
      IC.log(`autosolve: ${typestringB} & ${typestringA} → ${IC.typestring(BdivA.t)}`);
      return BdivA;
    }

    let flexA = IC.ICObjectReplaceFlexibleUnits(objA);
    let flexB = IC.ICObjectReplaceFlexibleUnits(objB);

    if (tries) {
      if (
        IC.typeSimilarityByString(typestringA, IC.typestring(flexA.t)) == 0 ||
        IC.typeSimilarityByString(typestringB, IC.typestring(flexB.t)) == 0
      ) {
        return IC.typeSolve(flexA, flexB, tries - 1);
      }
    }

    IC.log(`cannot autosolve: ${typestringA} & ${typestringB}`);
    return null;
  },

  // combine types from A to B, with B having a change direction (+1 add, -1 to remove)
  // if similar types combine (cm & in), include scaling factor
  // changeDir: +1 or -1 (to subtract types)
  // 0 for smart convert (cm/s into inches => in/s)
  _typeMultiply: function (typeA, typeB, changeDir, consolidate = true, dateCacheKey = null) {
    let scale = 1;

    /** @type {ICType} */
    let merged = {};
    let processedKeys = {};

    const typeAKeys = Object.keys(typeA ?? {});
    const typeBKeys = Object.keys(typeB ?? {});

    function updateMatches(unit) {
      let foundInTypeB = false;
      typeBKeys.forEach((key) => {
        // check whether base units match, we handle the power cancel on our own
        // TODO: fix this to use the actual scale, like acre & m^2
        if (!processedKeys[key] && (IC.typestringIsSameUnitCategory(unit, key) || ICUnit.unitMatch(unit, 1, key, 1))) {
          let ratio = ICUnit.convertKnownUnitMatch(key, unit) || 1; // 1 for custom units, or functions

          let powerChange = typeB[key] * changeDir;
          scale *= Math.pow(ratio, powerChange);
          let resultPower = typeA[unit] + powerChange;

          if (powerChange == 0) {
            // smart conversion: cm/s to feet => feet/s [shrinks]
            // cm/s to min => cm/min [gets larger]
            // the actual direction of type B doesn't matter, just that it matches a unit type A
            scale *= Math.pow(ratio, -typeA[unit]);
            merged[key] = typeA[unit]; // key from b, with original power from A
          } else if (resultPower != 0) {
            merged[unit] = resultPower;
          }

          processedKeys[key] = true;
          foundInTypeB = true;
        }
      });
      if (!foundInTypeB) {
        merged[unit] = typeA[unit];
      }
    }

    // for every key in A, see if it matches units in B
    typeAKeys.forEach((key) => updateMatches(key));

    // include remaining keys from B
    typeBKeys.filter(key => !processedKeys[key]).forEach((key) => {
      merged[key] = typeB[key] * changeDir;
    });

    let ret = IC.makeICObject(scale, merged);
    let keycount = Object.keys(merged).length;
    if (keycount == 0 && typeAKeys.length && typeBKeys.length) {
      IC.envSetHasCancelledUnit();
    }

    // can lead to infinite loop with mul
    if (keycount && consolidate) {
      ret = IC.ICObjectConsolidateUnits(ret);
    }

    return ret;
  },

  typeMultiply: function (typeA, typeB, changeDir, consolidate = true) {
    return IC._typeMultiply(typeA, typeB, changeDir, consolidate, LIB.InstaCalc.Unit._updated);
  },

  checkFailedConversionWarnings(fromType, toType) {
    let parts = (fromType + " " + toType).split(/\W+/);
    let replacementUnit = parts
      .map((p) => CONFIG.CONVERSION_WARNING_LIST[p])
      .filter((r) => r)
      .join("");
    return replacementUnit;
  },

  // Does this conversion leave a difference of only flex types?
  isFlexTypeConversion: function (fromType, toType) {
    let typeMultiplyResult = IC.typeMultiply(fromType, toType, 1);
    let flexConversion = Object.keys(typeMultiplyResult.t).every(key => CONFIG.FLEX_UNIT_CONVERSIONS[key]);
    return [flexConversion, typeMultiplyResult];
  },

  /* 
   Attempt to convert to a flexible unit, if possible (Hz, cycles)
   */
  ICObjectConvertToFlexType(x, unitObj, typeMultiplyResult, unitName) {
    let tmUnitObj = IC.makeICObject(1, typeMultiplyResult.t);
    let positiveConversion = Object.values(tmUnitObj.t).some(v => v > 0);

    let conversionUnit = unitName;

    let sourceX;
    let toTypeExpanded = IC.ICObjectReplaceFlexibleUnits(unitObj).t;
    let toTypeKeysFuzzy = Object.keys(toTypeExpanded).some(key => CONFIG.FLEX_UNIT_CONVERSIONS[key]);

    // to type needs the fuzzy unit
    if (!toTypeKeysFuzzy) {
      sourceX = x;
      let conversionObject = positiveConversion ? IC.mathDiv(unitObj, tmUnitObj) : IC.mathMul(unitObj, tmUnitObj);
      conversionUnit = IC.typestring(conversionObject.t);
    }
    else {
      // from type needs the fuzzy unit
      sourceX = positiveConversion ? IC.mathDiv(x, tmUnitObj) : sourceX = IC.mathMul(tmUnitObj, x);
    }

    sourceX = IC.ICObjectReplaceFlexibleUnits(sourceX);
    let result = IC.ICObjectConvertToType(sourceX, conversionUnit, false);

    // convert units back to unitName if needed?
    return result;
  },


  /**
   * convert similar units, e.g "cm/hour to inches" will convert the cm portion, so you get inches/hour
   * @param {ICObject} x - object to convert
   * @param {string} unitName - string to convert to ("cm", "cm/s", etc)
   * @returns
   */
  ICObjectConvertToType(x, unitName, retryAllowed = true) {
    if (!IC.isValidEvalResult(x)) return null;

    unitName = ICUnit.processUnitName(unitName);

    let defaultConversionResult = ICUnit.convert(x, unitName);
    if (defaultConversionResult) {
      return defaultConversionResult;
    }

    let fromType = x.t || {};
    let unitObj = IC.makeICObject(1, unitName);
    let toType = unitObj?.t;

    if (!toType) {
      IC.log(`cannot convert: ${IC.typestring(fromType)} → '${unitName.trim()}'`);
      return x;
    }

    if (IC.typeIsVirtual(toType)) {
      return IC.typeConvertNumericToVirtual(IC.val(x), IC.typestring(toType));
    }

    if (unitName.match(/[+\-*]/)) {
      IC.log(`cannot convert: ${IC.typestring(fromType)} → '${unitName.trim()}', split up statements with ()`);
      return x;
    }

    if (IC.typestringIsSameUnitAndScale(IC.typestring(fromType), unitName)) {
      return x;
    }

    if (ICDate.isDateTimeObject(x)) {
      return ICDate.convertTo(x, unitName);
    }

    // at this point, we have a partial conversion, like "cm/s -> m"
    let ret, typeMultiplyResult, isFlexTypeConversion;
    [isFlexTypeConversion, typeMultiplyResult] = IC.isFlexTypeConversion(fromType, toType);

    // check for "fuzzy" units that need to be expanded
    if (isFlexTypeConversion && retryAllowed) {
      return IC.ICObjectConvertToFlexType(x, unitObj, typeMultiplyResult, unitName);
    }

    // if toType has numeric keys, we need to simplify it (400 w => w)
    const hasNumericKeys = Object.keys(toType).some(k => k.match(/\d/));
    const fullyNumericKey = Object.keys(toType).find(k => {
      if (ICUnit.unitStringHasNumber(k)) {
        let [n, unit] = ICUnit.unitStringExtractNumber(k);
        return unit === '';
      }
      return false;
    });

    if (hasNumericKeys) {
      let simplifiedObj = IC.typeSimplifyIntoObject(toType);
      typeMultiplyResult = IC.typeMultiply(fromType, simplifiedObj.t, 0);

      let ratio = IC.mathDiv(x, simplifiedObj); // x / obj
      ret = ratio;

      let inverseType = IC.hasNoType(IC.typeMultiply(fromType, simplifiedObj.t, 1));
      if (inverseType) {
        ret = IC.mathInverse(IC.mathMul(x, simplifiedObj)); // 1 / (x * obj)
      }

      // 10 mbit/sec in minutes/1 gb => finding time to get a single gb, not scaling the rate
      let isUnitRate = IC.val(simplifiedObj) === 1;
      if (isUnitRate) {
        const scaleVal = IC.mathPreciseDivide(IC.mathPreciseDivide(1, IC.val(typeMultiplyResult)), IC.val(x));
        const scale = IC.makeICObject(scaleVal, null);
        ret = scale;
      }

      // $25/hour in hours until 2000 : "2000" (unitless) becomes a key
      if (fullyNumericKey) {
        ret = IC.mathDiv(IC.mathInverse(simplifiedObj), x);
      }

      // clone toType, scan keys, see if any match variables in the environment, replace that
      // TODO: look in execution log for replaced variables, and use that for replacement
      let toTypeClone = { ...toType };

      // let identifiers = IC.envGetIdentifiers();
      let identifiers = IC.envGetVariablesOnly();

      for (let key in toTypeClone) {
        let currentInput = IC.envGetCurrentInput();
        let tokens = currentInput.split(" ");

        let [n, unit] = ICUnit.unitStringExtractNumber(key);
        if (!n) {
          continue;
        }

        let idKeys = Object.keys(identifiers);

        idKeys.forEach((id) => {
          if (!currentInput.toLowerCase().includes(id.toLowerCase())) {
            return;
          };

          let idValue = identifiers[id];
          let keyValue = IC.makeICObject(n, unit);

          // check equality -- division is 1
          let divResult = IC.mathDiv(idValue, keyValue);
          if (IC.mathEqualWithinThreshold(1, IC.val(divResult))) {
            toTypeClone[id] = toTypeClone[key];
            delete toTypeClone[key];
          }
        });
      }
      ret.t = { ...toTypeClone };

      // ret.t = { ...toType };
    }
    else {
      typeMultiplyResult = IC.typeMultiply(fromType, toType, 0);
      ret = IC.mathMul(IC.val(x), typeMultiplyResult);
    }

    // 15 -> cm is OK
    // 15 m/s to cm is OK
    // 15 m -> cm/s not OK
    let fromKeyCount = Object.keys(fromType).length;
    let toKeyCount = Object.keys(toType).length;
    let sameOrBetterTypeComplexity = fromKeyCount == 0 || toKeyCount <= fromKeyCount;
    let hasDifferentType = !IC.typeIsSameNormalizedObject(ret.t, fromType);

    // basic conversion
    if (sameOrBetterTypeComplexity && hasDifferentType) {
      IC.log(`convert: ${IC.typestring(fromType)} → ${IC.typestring(typeMultiplyResult.t)}`);
      return ret;
    }

    // inverse conversion
    let inverseObjA = IC.mathInverse(x);
    ret = IC.makeICObject(IC.val(IC.mathDiv(IC.val(inverseObjA), typeMultiplyResult)), toType);
    let numbersAreNotEqual = !IC.mathEqualWithinThreshold(IC.val(ret), IC.val(inverseObjA));
    if (numbersAreNotEqual && sameOrBetterTypeComplexity) {
      // TODO: this only triggers for hz and ms right now; move hz to IMPLIED_CONVERSIONS
      IC.log(`convert: ${IC.typestring(fromType)} → ${IC.typestring(typeMultiplyResult.t)}`);
      return ret;
    }

    // try switching oz with fl oz
    let [swappedConversionResult, swappedObj] = ICUnit.convertWithUnitSwap(x, unitName);
    if (swappedConversionResult) {
      IC.log(`assumed conversion: ${IC.typestring(swappedObj.t)} → ${IC.typestring(swappedConversionResult.t)}`);
      return swappedConversionResult;
    }

    // implied units (dollars, bytes, USD), ie: $.15/mile in USD per 100 miles
    for (const impliedConversion of CONFIG.IMPLIED_CONVERSIONS) {
      if (impliedConversion.match(toType) && !impliedConversion.exclude(fromType)) {
        let objAWithUnit = IC.mathMul(x, IC.makeICObject(1, impliedConversion.unit));
        let result = IC.semanticConvert(objAWithUnit, unitName);
        return result;
      }
    }

    // same base units: N -> kg m s^-2
    let [fromBaseUnits, fromUnitScale] = ICUnit.convertToBaseUnits(fromType);
    let [toBaseUnits, toUnitScale] = ICUnit.convertToBaseUnits(toType);
    if (ICUnit.isSameUnitObject(fromBaseUnits, toBaseUnits)) {
      let finalScale = IC.mathPreciseMultiply(IC.val(x), fromUnitScale / toUnitScale);
      let final = IC.makeICObject(finalScale, unitName);

      IC.log(`convert: ${IC.typestring(fromType)} → ${IC.typestring(toType)}`);
      return final;
    };

    // "wh -> joule/sec" should not be allowed
    let isGainingComplexity = IC.typePowerCount(fromBaseUnits) < IC.typePowerCount(toBaseUnits);
    // TODO: this should be if the from type is CONTAINED in the target, no conversion possible
    // L -> cm is possible

    if (!isGainingComplexity) {

      // fuzzy conversion: 15 uW s / cm in nJ
      let collapsedResult = ICUnit.autoCollapse(IC.typeMultiply(fromType, toType, -1));
      if (collapsedResult && IC.typePowerCount(collapsedResult.t) <= IC.typePowerCount(fromType)) {
        let final = IC.mathMul(IC.val(x), collapsedResult);
        final.t = { ...final.t, ...toType };

        IC.log(`fuzzy convert: ${IC.typestring(fromType)} → ${IC.typestring(final.t)}`);
        return final;
      }
    }

    // no conversion
    let replacementUnit = IC.checkFailedConversionWarnings(fromType, unitName).trim();
    let replacementText = replacementUnit ? `, try ${replacementUnit}` : "";
    IC.log(`cannot convert: ${IC.typestring(fromType)} → ${unitName}${replacementText}`);
    return x;
  },

  typeIsVirtual: function (typeObjOrString) {
    const VIRTUAL_CATEGORIES = ["ppm", "bel"];
    let typestring = typeof typeObjOrString === "string" ? typeObjOrString : IC.typestring(typeObjOrString);

    for (let category of VIRTUAL_CATEGORIES) {
      if (IC.typestringIsSameUnitCategory(typestring, category)) {
        return category;
      }
    }

    return null;
  },

  typeConvertVirtualToNumeric: function (obj) {
    let ret;

    let category = IC.typeIsVirtual(obj?.t);
    if (category == "bel") {
      ret = IC.ICObjectConvertToType(obj, "bel");
      return Math.pow(10, IC.val(ret));
    }

    // all others assume ppm equivalent
    ret = IC.ICObjectConvertToType(obj, "ppm");
    return IC.val(ret) * 1e-6;
  },

  typeConvertNumericToVirtual: function (obj, targetUnit = "ppm") {
    let amount;
    if (IC.typestringIsSameUnitCategory(targetUnit, "bel")) {
      amount = Math.log10(IC.val(obj)); // converted to bels
    }
    else {
      amount = IC.mathPreciseDivide(IC.val(obj), 1e-6); // ppm default
    }

    let scale = ICUnit.getUnitScale(targetUnit);
    let scaledAmount = IC.mathPreciseDivide(amount, scale);
    let ret = IC.makeICObject(scaledAmount, targetUnit);

    return ret;
  },

  typeIsByte: function (typeObjOrString) {
    let typestring = typeof typeObjOrString === "string" ? typeObjOrString : IC.typestring(typeObjOrString);
    return IC.typestringIsSameUnitCategory(typestring, "byte");
  },

  typeIsCurrency: function (typeObjOrString) {
    let typestring = typeof typeObjOrString === "string" ? typeObjOrString : IC.typestring(typeObjOrString);
    return IC.typestringIsSameUnitCategory(typestring, "usd");
  },

  typeConvertByteToNumber: function (obj) {
    let ret = IC.ICObjectConvertToType(obj, "byte");
    IC.log(`treat bytes as number`);
    return IC.val(ret);
  },

  /*
   @param typeObj - unit type
   @param useTitle (default false) - use formatted title (gb -> GB)
   */
  typestring: function (typeObj, useTitle = false) {
    if (!typeObj) return "";
    let posTypes = "";
    let negTypes = "";

    Object.keys(typeObj).forEach(function (key) {
      let name = key;
      let pow = typeObj[key];
      let unitLabel = "";

      let powScale = Math.abs(pow);
      if (powScale > 1 && Number.isInteger(powScale)) {
        unitLabel = "^" + powScale;
      }

      name = IC.unitDisplayName(useTitle ? IC.envGetUnitTitle(name) : name, pow);

      if (pow > 0) {
        posTypes += name + unitLabel + " ";
      }
      if (pow < 0) {
        negTypes += name + unitLabel + " ";
      }
    });

    posTypes = posTypes.trim();
    negTypes = negTypes.trim();

    // no negatives
    if (!negTypes) {
      return posTypes;
    }

    return `${posTypes || "1"}/${negTypes}`;
  },

  // Finds shortest unit name: centimeters -> cm, cows -> cow 
  typestringNormalize: function (unitStr) {
    unitStr = unitStr.toLowerCase().trim();
    let obj = ICUnit.getUnit(unitStr);
    if (obj) {
      let value = obj[unitStr];

      // search object for all keys with the same value and take the shortest key by length
      let shortestKey = Object.keys(obj).filter(name => name != "base").reduce((a, b) =>
        (obj[b] === value && b.length < a.length) ? b : a, unitStr
      );

      return shortestKey;
    }

    return IC.stringSingularize(unitStr);
  },

  // just for hz currently
  // convert hz to cycles/second
  ICObjectReplaceFlexibleUnits: function (obj) {
    if (IC.hasNoType(obj)) {
      return obj;
    }

    // has no information units at multiple powers
    let hasFlexibleUnits = Object.keys(obj.t).some((unit) => CONFIG.FLEX_UNIT_ALIAS[unit.toLowerCase()]);
    if (!hasFlexibleUnits) {
      return obj;
    }

    let scale = IC.val(obj);
    let ret = scale; // will be multiplied

    Object.keys(obj.t).forEach((unit) => {
      let pow = obj.t[unit];
      let entry = CONFIG.FLEX_UNIT_ALIAS[unit.toLowerCase()];
      let newUnit = null;
      if (entry) {
        newUnit = IC.makeICObject(entry.scale, entry.type);
      } else {
        newUnit = IC.makeICObject(1, unit);
      }

      // do not consolidate, which can lead to infinite loop
      newUnit = IC.mathPow(newUnit, pow, false);
      ret = IC.mathMul(ret, newUnit, false);
    })

    // return orig or new
    return scale == ret ? obj : ret;
  },

  // flatten 1kb x 1kb into "bytes"
  ICObjectReplaceInformationUnits: function (obj) {
    if (IC.hasNoType(obj)) {
      return obj;
    }

    // has no information units at multiple powers
    let hasPowersOfInfoUnit = Object.keys(obj.t).some((unit) => obj.t[unit] > 1 && IC.typeIsByte(unit));
    if (!hasPowersOfInfoUnit) {
      return obj;
    }

    let scale = IC.val(obj);
    let ret = scale;

    Object.keys(obj.t).forEach((unit) => {
      let pow = obj.t[unit];
      let newUnit = null;
      if (pow > 1 && IC.typeIsByte(unit)) {
        let log = IC?.logGetCurrentRow()?.toString() || "";
        if (!log.includes("flattening")) {
          IC.log(`flattening ${unit}^${pow} → bytes`);
        }

        let typescale = ICUnit.typeConversionScale(unit, "byte");
        newUnit = IC.makeICObject(Math.pow(typescale, pow), "bytes");
      }
      else {
        newUnit = IC.makeICObject(1, unit);
      }

      ret = IC.mathMul(ret, newUnit, false);
    });

    return scale == ret ? obj : ret;
  },

  // if we have (meter/sec) * hour, reduce to ("meter") with the right scaling factor
  // or, if we have "hz" and second, try to reduce
  ICObjectConsolidateUnits: function (obj) {
    if (IC.hasNoType(obj)) {
      return obj;
    }

    let ret = IC.ICObjectReplaceFlexibleUnits(obj);
    ret = IC.ICObjectReplaceInformationUnits(ret);
    return ret;
  },

  // feet / cm => no type
  typeIsCancelled: function (type) {
    if (Object.keys(type).length < 2) {
      return false;
    }

    let typeDir = { pos: "", posPower: 0, neg: "", negPower: 0 };
    for (var key in type) {
      if (type[key] > 0) {
        typeDir.pos = key;
        typeDir.posPower = type[key];
      } else {
        typeDir.neg = key;
        typeDir.negPower = type[key];
      }
    }

    if (
      typeDir.pos &&
      typeDir.neg &&
      Math.abs(typeDir.posPower) == Math.abs(typeDir.negPower) &&
      IC.typestringIsSameUnitCategory(typeDir.pos, typeDir.neg)
    ) {
      return true;
    }

    return false;
  },

  /*
  @param {ICObject} obj
  */
  hasNoType(obj) {
    return !obj || !obj.t || Object.keys(obj.t).length === 0;
  },

  /*
  @param {ICObject} obj
  */
  hasType(obj) {
    return !IC.hasNoType(obj);
  },

  /* 
  @param {ICType|string|null} typeA
  @param {ICType|string|null} typeB
  @returns {boolean} - true if types can be compared: (days with weeks) == true
  */
  typeIsEquivalent: function (typeA, typeB) {
    if (typeof typeA === "string") {
      typeA = IC.makeICObject(1, typeA).t;
    }

    if (typeof typeB === "string") {
      typeB = IC.makeICObject(1, typeB).t;
    }

    let result = IC.typeMultiply(typeA, typeB, -1);
    return IC.hasNoType(result);
  },

  /*
  @param {string} typeStrA
  @param {string} typeStrB
  @returns {boolean} - true if identical scale in their Unit object cm and centimeter (but not cm and ft)
  */
  typestringIsSameUnitAndScale: function (typeStrA, typeStrB) {
    let unitA = ICUnit.getUnit(typeStrA);
    let unitB = ICUnit.getUnit(typeStrB);

    return unitA && unitB && unitA == unitB && unitA[typeStrA.trim().toLowerCase()] == unitB[typeStrB.trim().toLowerCase()];
  },

  typestringIsSameUnitCategory: function (typeStrA, typeStrB) {
    let unitA = ICUnit.getUnitCaseInsensitive(typeStrA);
    let unitB = ICUnit.getUnitCaseInsensitive(typeStrB);

    return unitA && unitB && unitA == unitB;
  },

  typeHasUnitInCategory: function (typeObj, category) {
    return Object.keys(typeObj).some((unit) => IC.typestringIsSameUnitCategory(unit, category));
  },

  // check if exists as combination of some units
  typestringIsPossibleUnitIncludingSlash: function (str) {

    if (!str) return false;
    str = str.trim();

    // could be "2"
    if (str.match(/^\d+$/)) {
      return false;
    }

    // miles/hour
    if (str.includes("/")) {
      let parts = str.split("/");
      return IC.typestringIsPossibleUnitIncludingSlash(parts[0]) && IC.typestringIsPossibleUnitIncludingSlash(parts[1]);
    }

    // exponent unit: cm^2
    if (str.includes("^")) {
      let base = str.split("^")[0];
      return IC.typestringIsPossibleUnitIncludingSlash(base);
    }

    return IC.predefinedUnit(str);
  },

  /*
   @param {ICType} typeA
   @param {ICType} typeB
   @returns {boolean} true if typeA and typeB are the same unit object
   */
  typeIsSameNormalizedObject(typeA = {}, typeB = {}) {

    // Function to normalize and filter out zero values and empty keys
    const normalizeAndFilter = (type) => {
      return Object.fromEntries(
        Object.entries(type)
          .map(([key, value]) => [IC.typestringNormalize(key) || key, value])
          .filter(([key, value]) => key && value !== 0)
      );
    };

    const normalizedTypeA = normalizeAndFilter(typeA);
    const normalizedTypeB = normalizeAndFilter(typeB);

    // Checking if both objects have same normalized keys with same values
    const keysA = Object.keys(normalizedTypeA);
    const keysB = Object.keys(normalizedTypeB);

    if (keysA.length !== keysB.length) return false;

    return keysA.every(key => key in normalizedTypeB && normalizedTypeB[key] === normalizedTypeA[key]);
  },


  /**
    * return 1 if units same, -1 if inverse, 0 otherwise 
    * @param {string} typeStrA 
    * @param {string} typeStrB 
    * @returns 
    */
  typeSimilarityByString(typeStrA, typeStrB) {
    if (!typeStrA || !typeStrB) {
      return 0;
    }

    if (typeStrA == typeStrB) {
      return 1;
    }

    const [numerator, denominator] = typeStrA.split("/");
    if (`${denominator}/${numerator}` === typeStrB) {
      return -1;
    }
    return 0;
  },

  typeSimilarityByObject(typeA, typeB) {
    const keysA = Object.keys(typeA);
    const keysB = Object.keys(typeB);

    if (keysA.length !== keysB.length) return 0;

    let similarity = 1;
    for (let key of keysA) {
      // keys are different...
      if (typeA[key] !== typeB[key]) {
        // as long as they are opposite, we are fine
        if (typeA[key] === -typeB[key]) {
          similarity = -1;
        } else {
          // not opposite, early return
          return 0;
        }
      }
    }

    return similarity;
  },

  typeInverse(typeObj) {
    let type = {};
    for (const [key, value] of Object.entries(typeObj)) {
      type[key] = value * -1;
    }
    return type;
  },

  // true if some type has negative power
  typeObjHasNegativeType(typeObj) {
    return Object.values(typeObj).some(value => value < 0);
  },

  // turn a type like {"400 w": 1} into {w: 1} with a scaling factor
  typeSimplifyIntoObject(typeObj) {
    let rate = 1;
    /* @type {ICType} */
    let simplifiedType = {};

    Object.entries(typeObj).forEach(([key, power]) => {
      if (ICUnit.unitStringHasNumber(key)) {
        let [n, restOfUnit] = ICUnit.unitStringExtractNumber(key);
        rate *= Math.pow(n, power);

        if (restOfUnit) {
          // If there's a remaining unit after extracting the number
          if (simplifiedType[restOfUnit]) {
            simplifiedType[restOfUnit] += power;
          } else {
            simplifiedType[restOfUnit] = power;
          }
        }
      } else {
        // If the key doesn't have a number, keep it as is
        if (simplifiedType[key]) {
          simplifiedType[key] += power;
        } else {
          simplifiedType[key] = power;
        }
      }
    });

    // Remove any keys with zero power
    Object.keys(simplifiedType).forEach(key => {
      if (simplifiedType[key] === 0) {
        delete simplifiedType[key];
      }
    });

    // Handle flexible units
    let simplifiedObj = IC.makeICObject(1, simplifiedType);
    simplifiedObj = IC.ICObjectReplaceFlexibleUnits(simplifiedObj);

    return IC.makeICObject(rate, simplifiedObj.t);
  },

  // turn a type like {"400 w": 1} into {w: 1} with a scaling factor
  typeSimplifyIntoObjectOld(typeObj) {
    let rate = 1;
    let swappedKey = {};
    let simplifiedType = { ...typeObj };
    Object.keys(typeObj).forEach((key) => {
      if (ICUnit.unitStringHasNumber(key)) {
        let [n, restOfUnit] = ICUnit.unitStringExtractNumber(key);
        rate *= Math.pow(n, -1 * typeObj[key]);
        swappedKey[key] = restOfUnit;
      }
    });

    if (Object.keys(swappedKey).length) {
      Object.keys(typeObj).forEach((key) => {
        let actualKey = swappedKey[key] || key;
        simplifiedType[actualKey] = typeObj[key];
      });

      let simplifiedObj = IC.makeICObject(1, simplifiedType);
      simplifiedObj = IC.ICObjectReplaceFlexibleUnits(simplifiedObj);
    }

    return IC.makeICObject(rate, simplifiedType);
  },



}

const StringModule = {
  stringSingularize: function (word = "") {
    if (IC.predefinedUnit(word) && word.endsWith("s")) {
      let testSingular = LIB.Inflector.singularize(word);
      if (IC.typestringIsSameUnitAndScale(testSingular, word)) {
        return testSingular;
      }
    }
    return LIB.Inflector.singularize(word);
  },

  stringPluralize: function (word = "") {
    if (IC.predefinedUnit(word) && !word.endsWith("s")) {
      let testPlural = LIB.Inflector.pluralize(word);
      if (IC.typestringIsSameUnitAndScale(testPlural, word)) {
        return testPlural;
      }
    }
    return LIB.Inflector.pluralize(word);
  },

  stringIsValidSingularUnit: function (unit = "") {
    return unit && unit.length >= 3 && !unit.match(/\d/);
  },

  unitDisplayName: function (unit, pow) {

    if (IC.predefinedUnit(unit)) {
      unit = ICUnit.formatSIUnit(unit);
    }

    // in denominator
    if (pow < 0 && IC.stringIsValidSingularUnit(unit)) {
      let baseName = IC.stringSingularize(unit);
      unit = baseName;
    }

    if (IC.stringIsCurrencyUnit(unit)) {
      if (unit.length == 3) {
        unit = unit.toUpperCase();
      }
    }

    return unit;
  },

  stringIsKeyword: function (str) {
    return CONFIG.KEYWORDS.hasOwnProperty(str.toLowerCase());
  },

  stringIsCurrencyUnit: function (str) {
    let name = str.trim().toLowerCase();

    // IRR => iranian rial, internal rate of return
    return LIB.InstaCalc.Unit?.currencies?.hasOwnProperty(name) && !IC.predefinedFunction(name);
  },

  predefinedIdentifier(name) {
    let upper = name.toUpperCase();
    return CONFIG.PREDEFINED[upper];//  || CONFIG.PREDEFINED_FUNCTION[upper];
  },

  predefinedConfigFunction(name) {
    let upper = name.toUpperCase();
    return CONFIG.PREDEFINED_FUNCTION[upper];
  },

  // versions of other functions which are unit-aware
  predefinedFunction(name = "") {

    // dynamic functions
    if (name?.toLowerCase()?.match(/log_\w+/)) {
      return name;
    }

    if (IC.envIsUserFunction(name)) {
      return name;
    }

    let upper = name.toUpperCase();

    return LIB.InstaCalc.allowedfn[upper] || CONFIG.UNIT_AWARE_FUNCTIONS[upper] || CONFIG.OTHER_FUNCTIONS[upper] || CONFIG.ENGLISH_FUNCTION[upper];
  },

  // @returns Object | null
  predefinedUnit: function (unit = "") {
    if (!unit) return false;

    const checkUnit = (u) => {
      const unitObj = ICUnit.getUnit(u);
      return unitObj && unitObj.name && unitObj[u];
    };

    if (unit && IC.isNumberString(unit)) {
      return false;
    }

    const unitLower = unit.toLowerCase();
    if (checkUnit(unit) || checkUnit(unitLower)) {
      return true;
    }

    // the constant unit has aliases like "time"
    return LIB.Unit.alias[unitLower] || IC.stringIsCurrencyUnit(unit) || CONFIG.FLEX_UNIT_ALIAS[unitLower] || false;
  },

  /*
    // not quite ready, has british spellings: cm -> centimetre 
    longUnitName: function (unitStr) {
      unitStr = unitStr.toLowerCase().trim();
      let obj = ICUnit.getUnit(unitStr);
      if (obj) {
        let value = obj[unitStr];
        let longestKey = Object.keys(obj).reduce((a, b) =>
          (obj[b] === value && b.length > a.length) ? b : a, unitStr
        );
     
        return this.singularize(longestKey);
      }
     
      return this.singularize(unitStr);
    },
    */


  // get scale amount for a suffx (1 by default)
  predefinedSuffixScale: function (s) {
    if (!s) return 1;
    let unit = s.toLowerCase();
    return CONFIG.SCALES[unit] ?? CONFIG.SCALES_CASE_SENSITIVE[s] ?? 1;
  },

  // get the internal name for a variable: "Net Sales" => "net_sales"
  canonicalName(str) {
    if (!str) return null;

    // unicode remove accents: Café => cafe
    if (str.includes("\\u")) {
      str = IC.parser.unescapeUnicode(str);
      str = str?.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      str = IC.parser.escapeUnicode(str);
    }

    // removing leading/trailing space, parens, then collapse space to _
    return str.toLowerCase().replace(/^\s+|\s+$|[()]/g, "").replace(/\s+/g, "_");
  },

  predefinedPostConvertFunction(x, fnname) {
    let str = fnname.trim();
    let f = CONFIG.POSTCONVERT_FUNCTIONS[fnname.toLowerCase()];
    if (f) {
      if (typeof f === "string") {
        str = f;
        f = CONFIG.POSTCONVERT_FUNCTIONS[f];
      }

      IC.log(`converting to ${str}`);
      return f(x);
    }

    // match a regex postconvert
    for (const [, value] of Object.entries(CONFIG.POSTCONVERT_FUNCTION_REGEX)) {
      let match = fnname.match(value.regex);
      if (match) {
        return value.f(x, match);
      }
    }

    return null;
  },

  // radians are units that are automatically converted into decimal
  // TODO: should that be the case? keep radian as radian, have deg in help text?
  predefinedPostConversionUnit(str) {
    let lastUnit = str.trim().toLowerCase().split(" ").pop();
    return CONFIG.SCALES_POST_CONVERT[lastUnit];
  },
}

const ParseModule = {
  ICParseRelaxedJSON: function (str) {
    if (typeof str !== "string") return null;

    // raw string: "15 cm"
    if (!str.includes("{")) {
      try {
        return IC.parser.quickResult(str);
      } catch (e) {
        return null;
      }
    }

    // actual JSON string
    const finalJson = str
      .replace(/([{,])\s*([a-zA-Z_][a-zA-Z0-9_]*)\s*:/g, "$1\"$2\":");
    try {
      return JSON.parse(finalJson, (key, value) => {
        // try to convert numbers, etc. to native ICObjects
        if (typeof value === "string") {
          // attempt to parse with regular engine
          try {
            let ret = IC.parser.quickResult(value);
            return ret ?? value;
          }
          catch (e) {

          }
        }
        return value;
      });
    } catch (e) {
      return null;
    }
  },

  ICStringifyOld: function (obj) {
    if (IC.isICObject(obj)) {
      return IC.parser.formatResultAsSingleLine(obj);
    }

    return JSON.stringify(obj);
  },

  ICStringify: function (obj, indent = 2) {
    const seen = new WeakSet();

    function stringify(val, depth = 0) {
      if (val === null) return 'null';
      if (typeof val === 'undefined') return 'undefined';
      if (typeof val === 'string') return JSON.stringify(val);
      if (typeof val !== 'object') return String(val);
      if (IC.isICObject(val)) return JSON.stringify(IC.parser.formatResultAsSingleLine(val));

      if (seen.has(val)) return '[Circular]';
      seen.add(val);

      if (Array.isArray(val)) {
        const elements = val.map(elem => stringify(elem, depth + 1)).join(', ');
        return `[${elements}]`;
      }

      const entries = Object.entries(val).map(([key, value]) => {
        return `${JSON.stringify(key)}:${stringify(value, depth + 1)}`;
      }).join(', ');

      return `{${entries}}`;
    }

    return stringify(obj);
  },

  // [10] => 10
  ICArrayLiteralUnwrap: function (value) {
    while (Array.isArray(value) && value.length === 1) {
      value = value[0];
    }
    return value;
  },
  parseKnownPrefix(str) {
    str = str.toLowerCase().trim();
    if (!str) {
      return;
    }

    if (CONFIG.PREFIX_DICT_TRIE.search(str).length == 0) {
      return;
    }

    const len = str.length;
    for (const prefix in CONFIG.PREFIX_DICT) {
      let prefixWithOf = prefix + " of";

      // longest prefix first
      if (len > prefix.length + 2 && str.startsWith(prefixWithOf)) {
        return prefixWithOf;
      }

      if (len > prefix.length && str.startsWith(prefix)) {
        return prefix;
      }

    }
  },

  // returns true for "2", "2.5", etc.
  isNumberString: function (str) {
    return str?.trim().match(/^[\d,.]+$/);
  },

  // as above, but also: "2.5k"
  isNumberStringIncludingScaleSuffix: function (str) {
    const scales = Object.keys(CONFIG.SCALES);
    const numberScales = Object.keys(CONFIG.NUMBER_SCALES);
    const scalesCaseSensitive = Object.keys(CONFIG.SCALES_CASE_SENSITIVE);
    const allScales = [...scales, ...numberScales, ...scalesCaseSensitive];

    // Create a regex to split the number and the possible suffix
    const match = str.trim().match(/^([\d,.]+)([a-zA-Z]*)$/);

    if (!match) {
      return false;
    }

    const numberPart = match[1];
    const suffixPart = match[2];

    // Validate the number part
    if (!IC.isNumberString(numberPart)) {
      return false;
    }

    // If there's no suffix, it's valid if the number part is valid
    if (suffixPart === '') {
      return true;
    }

    // Validate the suffix part
    return allScales.includes(suffixPart) || allScales.includes(suffixPart.toLowerCase());
  },

  // take a string and return [variable] [units]
  parseUnitsFromString(label) {
    if (!label) {
      return null;
    }

    // bugfix: 1kb => 1 kb
    label = label.replace(/^\s*([0-9,.]+)/, "$1 ");

    label = label.replace("/", " / ");
    let nameParts = [];
    let unitParts = [];

    label.split(" ").forEach((w) => {
      // by here, "per" must have been replaced already
      if (w == "/" || IC.typestringIsPossibleUnitIncludingSlash(w)) {
        unitParts.push(w);
      } else {
        nameParts.push(w);
      }
    });

    return {
      name: nameParts.join(" "),
      units: unitParts.join(" "),
    };
  },

  parseWrittenNumber(label) {
    let trimmed = label.trim();

    // ignore things that don't look like written numbers
    if (label.match(/[.,;!?'"():\-—–_‘’“”…{}*=<>&~+|]|^(\s*\d)/) || !trimmed || IC.predefinedFunction(trimmed) || IC.predefinedUnit(trimmed)) {
      return null;
    }

    label = trimmed.toLowerCase();
    let extract = IC.parseUnitsFromString(label);
    if (!extract) {
      return null;
    }
    let words = extract.name;

    if (words == "zero") {
      return 0;
    }

    // FUTURE IDEA: parse numbers like "square root of four" => square root of (4)

    let n = LIB.text2num(words);
    if (n == 0 || n == null) {
      return null;
    }

    return extract.units ? IC.makeICObject(n, extract.units) : n;
  },


}

// can walk the AST and understand meaning 
const SemanticModule = {
  semanticPrefixFromIdentifierString(str) {
    if (!str) {
      return null;
    }

    str = str.toLowerCase().trim();
    let prefix = IC.parseKnownPrefix(str);
    if (prefix) {
      let id = str.substr(prefix.length).trim();
      let ret;
      if (IC.envIsVariableDefined(id)) {
        ret = IC.envGetVariable(id);
      }
      else if (IC.isNumberString(id)) {
        ret = IC.makeNumber(id, IC.envGetSettings());
      } else if (IC.envIsAutoUnit(id)) {
        ret = IC.makeICObject(1, id);
      } else {
        // parse full expression...
        ret = IC.parseAndEval(id);
        if (!IC.isValidEvalResult(ret)) {
          ret = null;
        }
      }

      if (ret) {
        return IC.semanticSuffixOrPrefix(ret, prefix, CONFIG.PREFIX_DICT);
      }
    }

    return null;
  },

  // "x squared"
  semanticSuffixOrPrefix(val, label, dict) {
    if (!label || !dict || !IC.isValidEvalResult(val)) {
      return null;
    }

    // normalize "of"
    if (label.endsWith(" of")) {
      label = label.substr(0, label.length - 3);
    }

    let str = label.trim().toLowerCase();

    let fn = dict[str];
    // lookup alias
    fn = typeof fn === "string" ? dict[fn] : fn;

    if (typeof fn == "function") {
      return fn(val);
    }

    return null;
  },

  // turn item into a single unit if variable not defined
  semanticAutoUnit(a) {
    let aVal = IC.eval(a);
    let aSource = IC.semanticGetUnitName(a);

    if (!IC.isValidEvalResult(aVal) && !IC.envIsVariableDefined(aSource)) {
      aVal = IC.makeICObject(1, aSource);
    }

    // standalone units do not parse. Turn them into typed objects
    if (!IC.isValidEvalResult(aVal) || Number.isNaN(aVal)) {
      if (!aSource.match(/[+\-*/()]/)) {
        aVal = IC.makeICObject(1, aSource);
      }
    }
    return aVal;
  },

  checkVariableUnitOverlapWarnings(str) {

    // remove parens
    let names = str.replaceAll(/[()]/g, "");
    names.split(" ").forEach((name) => {
      if (IC.envIsDefined(name) && IC.predefinedUnit(name)) {
        IC.log(`warning: treating '${name}' as variable, not unit`);
      }
    });
  },

  semanticApplyUnit(node, unitName) {
    let ret = IC.eval(node);
    if (!unitName) {
      return ret;
    }

    let varName = IC.semanticGetVarName(node);
    if (varName) {
      IC.checkVariableUnitOverlapWarnings(varName);
    }

    // check scale list: could be "10k" => 10,0000
    let scaleName = unitName.split(" ")[0];
    let scale = IC.predefinedSuffixScale(scaleName);
    if (scale != 1.0) {

      // apply rest of unit: 15k m => (15000) meters
      if (scaleName != unitName) {
        let restOfUnit = unitName.substr(scaleName.length).trim();
        ret = IC.mathMul(ret, scale);
        return IC.semanticApplyUnit(ret, restOfUnit);
      }

      return IC.mathMul(ret, scale);
    }

    // looks like a real unit...
    if (IC.typestringIsPossibleUnitIncludingSlash(unitName)) {

      // simple unit creation
      if (IC.hasNoType(ret)) {
        return IC.mathMul(ret, IC.makeICObject(1, unitName));
      }

      // if same category, convert: (2.54cm) inches => 2.54 cm to inches
      let sameType = IC.typeIsEquivalent(ret.t, IC.makeICObject(1, unitName).t);
      if (sameType) {
        return IC.semanticConvert(ret, unitName);
      }

      // (joules/sec) hour => multiply
      // x hour => convert to hours
      if (!IC.envIsDefined(varName) && IC.envIsAutoUnit(unitName)) {
        return IC.mathMul(ret, IC.makeICObject(1, unitName));
      }

      // do a smart convert
      return IC.ICObjectConvertToType(ret, unitName);
    }

    // special suffix: 3 squared
    let result = IC.semanticSuffixOrPrefix(ret, unitName, CONFIG.SUFFIX_DICT);
    if (result) {
      return result;
    }

    // custom unit: "3 cows" 
    return IC.makeICObject(ret, unitName);
  },
  /*
   * Performs a semantic division operation on two inputs with smart unit handling.
   *
   * Examples:
   * - 1024 / 2kb results in (1024 bytes) / 2kb = .5, not in inverse bytes.
   * - 3 / 4 cm results in 0.75 (cm), not in inverse cm.
   * - 3pi/2rad results in (3pi/2) rad, not in inverse radians.
   */
  semanticDivUnit(a, b) {
    let aVal = IC.semanticAutoUnit(a);
    let bVal = IC.semanticAutoUnit(b);

    /*
    The last item could be a conversion phrase:
    a/b * b/c in a/c
   
    (b/c) INTO a/c
    */

    // 1024 / 2kb
    if (IC.hasNoType(aVal) && IC.typeIsByte(bVal.t)) {
      IC.log(`converting ${IC.val(aVal)} to bytes`);
      return IC.mathDiv(IC.makeICObject(IC.val(aVal), "bytes"), bVal);
    }

    // 3 / 4cm
    if (IC.hasNoType(aVal) && IC.hasType(bVal)) {
      let bUnit = IC.makeICObject(1, bVal.t);
      return IC.mathMul(IC.mathDiv(aVal, IC.val(bVal)), bUnit);
    }

    // example: 3pi/2rad => (3pi/2) rad
    let postConversionUnit;
    if (Array.isArray(b) && b[0] == "unit" && IC.hasNoType(bVal)) {
      let unitName = b[2];
      postConversionUnit = IC.predefinedPostConversionUnit(unitName);
      if (postConversionUnit) {
        let scale = CONFIG.SCALES[postConversionUnit];
        let origVal = bVal / scale;
        aVal = IC.eval(a);
        return IC.mathMul(IC.mathDiv(aVal, origVal), scale);
      }
    }

    return IC.mathDiv(aVal, bVal);
  },

  // need special handling for division, given unit possibilites
  semanticDiv(a, b) {
    let aVal = IC.semanticAutoUnit(a);
    let bVal = IC.semanticAutoUnit(b);

    // Regular division handles:
    // 3 / 4
    // 3cm / 4
    // 3cm / 4cm ==> (3cm) / (4cm)
    // hz / day => hz / day (no unit collapse)
    return IC.mathDiv(aVal, bVal, false);
  },

  semanticTypeCompareOp(a, op, b) {
    let aVal = IC.eval(a);
    let bVal = IC.eval(b);
    let OP = op;

    if (IC.hasType(aVal) && IC.hasType(bVal)) {
      // for same types, return difference
      if (ICUnit.areEquivalentBaseUnits(aVal.t, bVal.t)) {
        let result = IC.mathSub(aVal, bVal);
        return IC.mathSimpleComparison(IC.val(result), OP, 0);
      }

      // cannot be compared
      IC.log(`can't compare mixed units [${IC.typestring(aVal.t)}] & [${IC.typestring(bVal.t)}]`);
      return undefined;
    }

    // might have a single typed object -- but type could be empty
    let varWithType = IC.anyIsObject(aVal, bVal);
    if (varWithType && IC.hasType(varWithType)) {

      // turn bytes into a number
      if (IC.typeIsByte(varWithType.t)) {
        let numericVal = IC.typeConvertByteToNumber(varWithType);
        aVal = (aVal == varWithType) ? numericVal : aVal;
        bVal = (bVal == varWithType) ? numericVal : bVal;
        return IC.mathSimpleComparison(aVal, OP, bVal);
      }

      let aUnitName = IC.semanticGetUnitName(a);
      let bUnitName = IC.semanticGetUnitName(b);
      IC.log(`comparing number with ${aUnitName || bUnitName} (type: ${IC.typestring(varWithType.t)})`);
    }

    // regular comparison -- could have remnants of types left over
    return IC.mathSimpleComparison(IC.val(aVal), OP, IC.val(bVal));
  },

  semanticPercentOp(a, op, b) {
    let OP = op.toLowerCase().trim();

    let aVal = IC.eval(a);
    let bVal = IC.eval(b);
    let pctChange = IC.val(aVal);
    // TODO: find a better way to get the actual source of the expression...

    switch (OP) {
      case "of":
      case "from":
        IC.log(`calculating ${IC.val(bVal)} * ${pctChange}%`);
        return IC.mathMul(IC.mathMul(0.01, pctChange), bVal);
      case "off":
        IC.log(`calculating ${IC.val(bVal)} - ${pctChange}%`);
        return IC.mathMul(1 - (IC.mathMul(.01, pctChange)), bVal);
    }
    return null;
  },

  semanticPercentChange(a, sign, b) {
    let aVal = IC.eval(a);
    let bVal = IC.val(IC.eval(b));
    let signStr = sign;

    if (IC.format(aVal) == "percent") {
      IC.log(`combine percent values: ${IC.val(aVal)} ${signStr} ${IC.val(bVal)}`);
      let ret = signStr == "+" ? IC.mathAdd(aVal, bVal) : IC.mathSub(aVal, bVal);
      return IC.makeICObject(IC.val(ret), null, "percent");
    }

    let scaleChange = 1 + (signStr == "+" ? 1 : -1) * bVal;

    let msg = `percent change: ${IC.val(aVal)} * ${scaleChange}`;
    IC.log(msg);
    return IC.mathMul(aVal, scaleChange);
  },

  // execute a op b in the grammar
  /* 
  @param a - left side of expression
  @param op - operator (lowercase and trimmed)
  @param b - right side of expression
  */
  semanticInfixOp(a, op, b) {
    let OP = op;

    let aVal = IC.eval(a);
    let bVal = IC.eval(b);

    if (LIB.Complex.isComplex(aVal) || LIB.Complex.isComplex(bVal)) {
      return IC.mathComplexInfixOp(aVal, op, bVal);
    }

    if (IC.anyIsCustomObject(aVal, bVal)) {
      return undefined;
    }

    function checkRet(op, ret) {
      if (op.length >= 2 && (op == "and" || op == "or" || op == "xor")) {
        IC.log(`binary operator: ${op}`);
        let format = IC.format(aVal) || IC.format(bVal) || "bin";
        ret = IC.makeICObject(IC.val(ret), "", format);
      }
      return ret;
    }

    switch (OP) {
      case "*":
        return IC.mathMul(aVal, bVal);
      case "/":
        return IC.semanticDiv(a, b);
      case "+":
        return IC.mathAdd(aVal, bVal);
      case "-":
        return IC.mathSub(aVal, bVal);

      case "<<":
        return checkRet("<<", IC.val(aVal) << IC.val(bVal));
      case ">>":
        return checkRet(">>", IC.val(aVal) >> IC.val(bVal));
      case ">>>":
        return checkRet(">>>", IC.val(aVal) >>> IC.val(bVal));

      case "<":
        return checkRet("<", IC.val(aVal) < IC.val(bVal));
      case "<=":
        return checkRet("<=", IC.val(aVal) <= IC.val(bVal));
      case ">":
        return checkRet(">", IC.val(aVal) > IC.val(bVal));
      case ">=":
        return checkRet(">=", IC.val(aVal) >= IC.val(bVal));

      case "==":
        return checkRet("==", IC.val(aVal) == IC.val(bVal));
      case "!=":
        return checkRet("!=", IC.val(aVal) != IC.val(bVal));
      case "===":
        return checkRet("===", IC.val(aVal) === IC.val(bVal));
      case "!==":
        return checkRet("!==", IC.val(aVal) !== IC.val(bVal));

      case "and":
        return checkRet("and", IC.val(aVal) & IC.val(bVal));
      case "xor":
        return checkRet("xor", IC.val(aVal) ^ IC.val(bVal));
      case "or":
        return checkRet("or", IC.val(aVal) | IC.val(bVal));

      case "&&":
        return checkRet("&&", IC.val(aVal) && IC.val(bVal));
      case "||":
        return checkRet("||", IC.val(aVal) || IC.val(bVal));

      // 15 as a percent of 30
      case ":pctof:":
        return IC.makeICObject(IC.mathDiv(IC.val(aVal), IC.val(bVal)), null, "percent");

      case ":choose:":
        return IC.evalFunction("COMBINATION", [aVal, bVal]);

      case ":permute:":
        return IC.evalFunction("PERMUTATION", [aVal, bVal]);

      case ":phaseangle:":
        return LIB.Complex.phasor(aVal, bVal);
    }
  },


  semanticConvert(expression, targetUnit) {
    let x = expression;

    // an object to eval
    if (typeof expression === "object" && expression.type && expression.value && expression.text) {
      x = IC.eval(expression);
    } else if (Array.isArray(expression)) {
      x = IC.eval(expression);
    }

    // Pipeline syntax: [1, 2, 3] -> map(x => x^2)
    // targetUnit is ["callExp", "map", [arrow_function]]
    if (Array.isArray(targetUnit) && targetUnit[0] === "callExp") {
      const functionName = targetUnit[1].value || targetUnit[1];
      const existingArgs = targetUnit[2] || [];
      // Evaluate arrow functions to function objects
      const evaluatedArgs = existingArgs.map(arg => {
        if (Array.isArray(arg) && arg[0] === "functionDeclaration") {
          return IC.eval(arg);
        }
        return IC.eval(arg);
      });
      const newArgs = [x, ...evaluatedArgs];
      return IC.evalFunction(functionName, newArgs);
    }

    // date range: jan 1 to jan 5
    if (Array.isArray(targetUnit) && targetUnit[0] == "datetimeLiteral") {
      targetUnit = IC.eval(targetUnit);

      if (ICDate.isDateTimeObject(x)) {
        return ICDate.subDates(targetUnit, x);
      }
    }

    /*
    // seconds in 2 years, swap order
    if (expression.type == "id" && IC.isAutoUnit(expression.value)) {
      IC.log(`converting ${unitName} to ${expression.value}`);
      // swap x and unitName
      let tmp = x;
      x = unitName;
      unitName = tmp;
    }
    */

    let unitName = typeof targetUnit == "string" ? targetUnit : IC.semanticGetUnitName(targetUnit);

    let varValue, prefix, final;
    let varInTargetUnit = null;
    let isRealVariable = null;

    // x = 10 miles; 15 mph in hours / x 
    varInTargetUnit = targetUnit?.[2]?.[1]?.type == "id";
    isRealVariable = IC.envIsVariableDefined(targetUnit?.[2]?.[1]?.value);
    if (Array.isArray(targetUnit) && targetUnit[0] == "div" && varInTargetUnit && isRealVariable) {
      let eval_result = IC.evalWithUnitOverride(targetUnit[2]);
      prefix = targetUnit[1].value + "/";
      varValue = IC.val(eval_result);
      final = IC.hasType(eval_result) ? IC.typestring(eval_result.t) : "";
    }

    // x = 10; 15 mph in hours / x miles
    varInTargetUnit = targetUnit?.[2]?.[1]?.[1]?.type == "id";
    isRealVariable = IC.envIsVariableDefined(targetUnit?.[2]?.[1]?.[1]?.value);
    if (Array.isArray(targetUnit) && targetUnit[0] == "divUnit" && varInTargetUnit && isRealVariable) {
      let eval_result = IC.evalWithUnitOverride(targetUnit[2]);
      prefix = targetUnit[1].value + "/";
      varValue = IC.val(eval_result);
      final = IC.hasType(eval_result) ? IC.typestring(eval_result.t) : "";
    }

    if (IC.isValidEvalResult(varValue)) {
      unitName = `${prefix} ${varValue} ${final}`;
    }

    if (!unitName) {
      return null;
    }

    // if a numeric unit like "ppm", convert to regular number before use
    let numericEquivalent = null;
    if (IC.typeIsVirtual(x?.t)) {
      numericEquivalent = IC.typeConvertVirtualToNumeric(x);
    }

    // check for postconversion function
    let functionResult = IC.predefinedPostConvertFunction(numericEquivalent ?? x, unitName);
    if (functionResult !== null) {
      return functionResult;
    }

    //  deg and rad are conversions, not functions to run
    if (IC.predefinedFunction(unitName) && !IC.predefinedUnit(unitName)) {
      if (IC.hasNoType(x)) {
        IC.log(`call function ${unitName}`);
      }
      return IC.evalFunction(unitName, [x]);
    }

    // 15 -> cm
    if (typeof x === "number") {

      // check for implied dollar unit
      let currentInput = IC.envGetCurrentInput();
      if (IC.stringIsCurrencyUnit(unitName)) {

        const currencies = Object.values(LIB.InstaCalc.format.currencies);
        // check for a currency symbol in the original input right before x
        let currencySymbol = currencies.find(c => {
          let escapedSymbol = ICLib.escapeRegExpString(c.symbol); // could be $ 
          return currentInput.match(new RegExp(`${escapedSymbol}\\s*${x}`));
        });

        if (currencySymbol) {
          IC.log(`convert ${x} → ${currencySymbol.code}`);
          x = IC.makeICObject(x, currencySymbol.code);
        }
        else {
          IC.log(`plain number → ${unitName}`);
          return IC.makeICObject(x, unitName);
        }
      } else if (IC.typeIsVirtual(unitName)) {
        IC.log(`plain number → ${unitName}`);
        return IC.typeConvertNumericToVirtual(x, unitName);
      }
      else {
        IC.log(`plain number → ${unitName}`);
        return IC.makeICObject(x, unitName);
      }
    }

    // regular conversion
    let finalResult = IC.ICObjectConvertToType(x, unitName);
    return finalResult;
  },

  semanticGetVarName(node) {
    if (Array.isArray(node)) {
      if (node[0] === "arrayAccess") {
        const arrayName = IC.semanticGetVarName(node[1]);
        const index = IC.eval(node[2]);
        return `${arrayName}[${index}]`;
      } else if (node[0] === "objectAccess") {
        const objName = IC.semanticGetVarName(node[1]);
        const propName = node[2].value;
        return `${objName}.${propName}`;
      }
    }

    switch (node[0]) {
      case "parenExpr":
      case "power":
        return IC.semanticGetVarName(node[1]);
    }

    return node?.value;
  },

  semanticGetUnitName(node) {
    if (typeof node === "string") {
      return node;
    }

    if (Array.isArray(node)) {

      switch (node[0]) {
        case "parenExpr":
          return IC.semanticGetUnitName(node[1]);
        case "power":
          return IC.semanticGetUnitName(node[1]) + "^" + IC.semanticGetUnitName(node[2]);
        case "div":
        case "divUnit":
          return IC.semanticGetUnitName(node[1]) + "/" + IC.semanticGetUnitName(node[2]);

        case "unit":
          return IC.semanticGetUnitName(node[1]) + " " + IC.semanticGetUnitName(node[2]);
      }

      // kg*m/s^2, but not fps * 2
      if (node[0] == "mul" && IC.predefinedUnit(node[1].value) && IC.predefinedUnit(node[2].value)) {
        return IC.semanticGetUnitName(node[1]) + " " + IC.semanticGetUnitName(node[2]);
      }
    }

    return node?.value;
  },
  semanticGetUnitNameFromString(str) {
    str = str.split("^")[0].trim();
    return str;
  },

  // sin(123,456) => true
  // sin((123,456)) => false
  semanticContainsDecimalWithCommas(tree) {
    if (Array.isArray(tree)) {
      return tree.flatMap(node => {
        if (node.type === 'parenExpr' && node[1].type === 'decimal') {
          // Skip decimal inside parenExpr
          return false;
        } else if (node.type === 'decimal' && node.value.includes(',')) {
          return true;
        } else {
          return IC.semanticContainsDecimalWithCommas(node);
        }
      }).some(v => v);
    } else {
      return false;
    }
  },


  // handle 200/2k => 200 / (2k)
  semanticNumericScaleFraction(tree) {
    let [n, d] = tree[1].value.split("/").map(val => IC.makeNumber(val, IC.envGetSettings()));
    let scale = IC.predefinedSuffixScale(tree[2]);

    return n / (d * scale);
  },


  ifConditionCleanup(tree) {
    tree = IC.replaceAssignmentWithEquality(tree);
    tree = IC.replaceBinaryWithLogical(tree);
    return tree;
  },

  replaceAssignmentWithEquality(tree) {
    if (Array.isArray(tree) && tree[0] == "assignmentExp") {
      IC.log(`treating = as equality (==)`);
      tree = ["equal", tree[1], tree[3]];
    }
    return tree;
  },

  // for use in "if" conditions
  replaceBinaryWithLogical(tree) {
    // replace binary operators with logical operators
    // change "band" to "land" and "bor" to "lor"
    if (Array.isArray(tree)) {
      if (tree[0] == "band") {
        tree[0] = "land";
      } else if (tree[0] == "bor") {
        tree[0] = "lor";
      }

      tree.forEach(t => IC.replaceBinaryWithLogical(t));
    }

    return tree;
  },
}

const MathModule = {

  // compare simple values
  mathSimpleComparison(a, op, b) {
    if (LIB.Complex.anyIsComplex(a, b)) {
      switch (op) {
        case "==": return LIB.Complex.isEqual(a, b);
        case "!=": return !LIB.Complex.isEqual(a, b);
        default:
          IC.log(`cannot compare complex numbers with ${op}`);
          return undefined;
      }
    }

    const operations = {
      "<": () => a < b,
      "<=": () => a <= b,
      ">": () => a > b,
      ">=": () => a >= b,
      "==": () => a == b,
      "!=": () => a != b,
      "===": () => a == b,
      "!==": () => a != b,
    };

    return operations[op.toLowerCase()]();
  },

  // poor man's high-precision math library...
  mathAddNumbersHighPrecision(num1, num2) {
    // Function to count the number of decimal places in a number
    function decimals(x) {
      var match = ('' + x).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
      if (!match) { return 0; }
      return Math.max(
        0,
        (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0)
      );
    }

    var decimalsNum1 = decimals(num1);
    var decimalsNum2 = decimals(num2);

    var factor = Math.pow(10, Math.max(decimalsNum1, decimalsNum2));
    return Number(((num1 * factor + num2 * factor) / factor).toFixed(Math.max(decimalsNum1, decimalsNum2)));
  },



  mathComplexInfixOp(a, op, b) {
    let aVal = LIB.Complex.toComplex(a);
    let bVal = LIB.Complex.toComplex(b);

    let ret = LIB.Complex.toComplex(0);

    switch (op) {
      case "+":
        return LIB.Complex.add(a, b);
        break;
      case "-":
        return LIB.Complex.subtract(a, b);
        break;
      case "*":
        return LIB.Complex.multiply(a, b);
        break;
      case "/":
        let denom = bVal.r * bVal.r + bVal.i * bVal.i;
        if (denom == 0) {
          IC.log("division by zero");
          return null;
        }
        return LIB.Complex.divide(a, b);
        break;
      case "==":
        return LIB.Complex.isEqual(a, b);
      case "!=":
        return LIB.Complex.isNotEqual(a, b);
      case "<":
      case "<=":
      case ">":
      case ">=":
        IC.log(`cannot compare complex numbers: ${op}`);
        return null;

      default:
        IC.log(`unknown complex operator: ${op}`);
        return null;
    }

    return ret;
  },

  // TODO: use units
  mathAdd(a, b) {
    if (a == null || b == null) {
      return null;
    }

    if (LIB.Complex.anyIsComplex(a, b)) {
      return LIB.Complex.add(a, b);
    }

    let aVal = IC.val(a);
    let bVal = IC.val(b);
    let sum = aVal + bVal;

    // if both are strings, add them together
    if (typeof aVal == 'string' && typeof bVal == 'string') {
      return sum;
    }

    // date operation
    if (IC.anyIsDate(aVal, bVal)) {
      return ICDate.addDates(a, b);
    }

    // If either is a decimal
    if (typeof (aVal) == 'number' && typeof (bVal) == 'number' && (!Number.isInteger(aVal) || !Number.isInteger(bVal))) {
      sum = IC.mathAddNumbersHighPrecision(aVal, bVal);
    }

    if (IC.allAreObjects(a, b)) {
      let scale = ICUnit.typeConversionScale(b.t, a.t); // 14 in + 3 cm => result in inches

      // lm == cd sr, where sr can be ignored
      if (scale == 1 && !IC.typeIsSameNormalizedObject(a.t, b.t) && !ICUnit.areEquivalentBaseUnits(a.t, b.t)) {
        // no conversion -- different types. 3 feet + 5 inches => 8
        IC.log(`mixed units ${IC.typestring(a.t)} & ${IC.typestring(b.t)}, using plain numbers`);
        return sum;
      }

      let val = aVal + bVal * scale;
      return IC.makeICObject(val, a.t, IC.ICObjectFormatMerge(a.f, b.f, true));
    }

    const varWithType = IC.anyIsObject(a, b);
    if (varWithType) {
      const otherObj = varWithType == a ? b : a;
      const typestring = (IC.typestring(varWithType.t) || "").trim();

      // could be a format-only item
      if (typestring) {
        IC.log(`converting '${IC.val(otherObj)}' to ${typestring}`);
      }
      return IC.makeICObject(sum, typestring, varWithType.f);
    }

    return sum;
  },

  mathSub(a, b) {
    if (IC.anyIsDate(IC.val(a), IC.val(b))) {
      return ICDate.subDates(a, b);
    }

    return IC.mathAdd(a, IC.mathNegate(b));
  },

  mathNegate(a) {
    return IC.mathMul(-1, a);
  },

  mathPreciseMultiply(a, b) {

    // no need for high precision
    if (Number.isInteger(a) && Number.isInteger(b)) return a * b;

    function getDecimals(num) {
      const numStr = String(num);
      if (numStr.includes('e-')) {
        const [base, exponent] = numStr.split('e-');
        const baseDecimals = (base.split('.')[1] || '').length;
        return baseDecimals + parseInt(exponent, 10);
      } else if (numStr.includes('e+')) {
        return 0; // For positive exponents, the number of decimals is effectively 0
      } else {
        return (numStr.split('.')[1] || '').length;
      }
    }

    const aDecimals = getDecimals(a);
    const bDecimals = getDecimals(b);

    const aInt = Math.round(a * Math.pow(10, aDecimals));
    const bInt = Math.round(b * Math.pow(10, bDecimals));

    const result = aInt * bInt;

    return result / (Math.pow(10, aDecimals) * Math.pow(10, bDecimals));
  },

  mathPreciseDivide(a, b) {
    if (b === 0) {
      return Infinity;
    }

    // No need for high precision if both numbers are integers
    if (Number.isInteger(a) && Number.isInteger(b)) return a / b;

    function getDecimals(num) {
      const numStr = String(num);
      if (numStr.includes('e-')) {
        const [base, exponent] = numStr.split('e-');
        const baseDecimals = (base.split('.')[1] || '').length;
        return baseDecimals + parseInt(exponent, 10);
      } else if (numStr.includes('e+')) {
        return 0; // For positive exponents, the number of decimals is effectively 0
      } else {
        return (numStr.split('.')[1] || '').length;
      }
    }

    const aDecimals = getDecimals(a);
    const bDecimals = getDecimals(b);

    const factor = Math.pow(10, Math.max(aDecimals, bDecimals));

    const aInt = Math.round(a * factor);
    const bInt = Math.round(b * factor);

    const result = aInt / bInt;

    return result;
  },

  mathMul(a, b, consolidate = true) {
    if (LIB.Complex.anyIsComplex(a, b)) {
      return LIB.Complex.multiply(a, b);
    }

    let product = IC.mathPreciseMultiply(IC.val(a), IC.val(b));

    if (IC.allAreObjects(a, b)) {
      let typeResult = IC.typeMultiply(a.t, b.t, +1, consolidate);
      let scaledProduct = IC.mathPreciseMultiply(product, IC.val(typeResult));
      return IC.makeICObject(scaledProduct, typeResult.t, IC.ICObjectFormatMerge(a.f, b.f, false));
    }
    let obj = IC.anyIsObject(a, b);
    if (obj) {
      return IC.makeICObject(product, obj.t, IC.ICObjectFormatMerge("", obj.f, false));
    }

    return product;
  },

  mathInverse(a) {
    if (LIB.Complex.isComplex(a)) {
      return LIB.Complex.inverse(a);
    }

    let inverseScale = 1 / IC.val(a);
    if (a instanceof Object) {
      let inverseType = IC.mathDivideTypePowers(a.t, -1);
      return IC.makeICObject(inverseScale, inverseType, a.f);
    }
    return inverseScale;
  },

  // a/b == a * (1/b)
  mathDiv(a, b, consolidate = true) {
    if (LIB.Complex.anyIsComplex(a, b)) {
      return LIB.Complex.divide(a, b);
    }

    if (IC.anyIsObject(a, b)) {
      return IC.mathMul(a, IC.mathInverse(b), consolidate);
    }
    return IC.mathPreciseDivide(a, b); // separate paths for approximation purposes; 3/5 vs 3 * 1/5 is different in JS
  },

  /*
  * Divides all exponents in the type object by the number n. 
  * @param {ICType} type - The type object containing unit types and exponents
  * @param {number} n - The number to divide all type exponents by
  * @returns {ICType|null} The new type object with all exponents divided by n, or null if unsuccessful
  * 
  */
  mathDivideTypePowers(type, n) {
    if (!type || !n) {
      return null;
    }

    const isDivisible = Object.values(type).every(value => value % n === 0);
    if (!isDivisible) {
      return null;
    }

    return Object.fromEntries(
      Object.entries(type).map(([key, value]) => [key, value / n])
    );
  },

  mathPow(a, b, consolidate = true) {
    if (LIB.Complex.anyIsComplex(a, b)) {
      return LIB.Complex.pow(a, b);
    }

    let base = IC.val(a);
    let power = IC.val(b);
    let val = Math.pow(base, power);

    // handle units
    if (a instanceof Object) {
      if (power == 0) {
        return 1;
      }

      if (power == 1) {
        return a;
      }

      // neg power: x^-3 = 1/x^3
      if (power < 0) {
        let inverse = IC.mathInverse(IC.mathPow(a, Math.abs(power), consolidate));
        return inverse;
      }

      // pos power
      if (Number.isInteger(b)) {
        let type = IC.typeMultiply(a.t, a.t, b - 1, consolidate).t;
        return IC.makeICObject(val, type);
      }

      // fractional powers:
      // TODO: have a "epsilon" check for arbitrary fraction
      if (b == 1 / 2 || b == 1 / 3 || b == 1 / 4 || b == 1 / 5 || b == 1 / 6) {
        let type = IC.mathDivideTypePowers(a.t, 1 / b);
        if (type) {
          return IC.makeICObject(val, type);
        }
      }
    }

    return val;
  },

  mathEqualWithinThreshold(a, b, threshold = 1e-10) {
    return Math.abs(a - b) < threshold;
  },

  mathMod(a, b) {
    return IC.val(a) % IC.val(b);
  },

  /*
   @param {number|null} x - number
   @param {number|null} denom - denominator to use
   */
  mathToFraction(x, denom = 0) {
    if (x == null) {
      return null;
    }

    let [n, d] = LIB.toFractionIterative(x, 1e-6);

    if (denom) {
      n = Math.round(n * (denom / d));
      d = denom;
    }

    return [n, d];
  },

  mathReduceFraction(numerator, denominator) {
    var a = numerator;
    var b = denominator;
    var c;
    while (b) {
      c = a % b; a = b; b = c;
    }
    return [numerator / a, denominator / a];
  },

}

const EvalModule = {
  parseAndEval(str) {
    let cacheKey = "nearley" + str;
    let r = IC.parser.RESULT_CACHE.get(cacheKey);
    if (r) {
      return IC.eval(r);
    }

    // @ts-ignore
    let NEARLEY_PARSER = new LIB.nearley.Parser(GRAMMAR_FROM_COMPILED);
    try {
      NEARLEY_PARSER.feed(str);
      let r = NEARLEY_PARSER.results[0];
      IC.parser.RESULT_CACHE.set(cacheKey, r);
      if (r) {
        return IC.eval(r);
      }
    } catch (e) {
    }
    return IC.NOPARSE;
  },


  // evaluate an AST to a result (usually ICObject|string|number|null)
  eval(tree) {
    let name, result, results, n, d, value;

    let isLiteral = (node) => {
      let type = node?.type ?? (Array.isArray(node) ? node[0] : undefined);

      // quick exit
      if (type == "id") {
        return false;
      }

      switch (type) {
        case "decimal":
        case "hex":
        case "oct":
        case "bin":
        case "fraction":
        case "stringLiteral":
        case "booleanLiteral":
        case "nullLiteral":
        case "arrayLiteral":
        case "objectLiteral":
          return true;
      }

      return false;
    }

    if (typeof tree === "object" && !Array.isArray(tree)) {
      switch (tree?.type) {
        case "decimal":
          return IC.makeNumber(tree.value, IC.envGetSettings());
        case "hex":
          return IC.makeHexadecimal(tree.value.slice(2));
        case "oct":
          return IC.makeOctal(tree.value.slice(2));
        case "bin":
          return IC.makeBinary(tree.value.slice(2));

        case "fraction":
          let whole = 0, fraction = 0;

          // remove whitespace around fraction symbol
          let text = tree.value.trim().replace(/\s*[/]\s*/g, "/");

          if (text.includes(" ")) {
            [whole, text] = text.split(" ");
            whole = IC.makeNumber(whole, IC.envGetSettings());
          }

          [n, d] = text.split("/");
          fraction = IC.makeNumber(n, IC.envGetSettings()) / IC.makeNumber(d, IC.envGetSettings());
          return whole + fraction;

        case "id":
          return IC.evalIdentifier(tree.value);

        case "ifStatement":
          // = and & should be == and && 
          tree.ifcond = IC.replaceAssignmentWithEquality(tree.ifcond);
          tree.ifcond = IC.replaceBinaryWithLogical(tree.ifcond);

          result = IC.eval(tree.ifcond);
          let isTruthy = result;

          if (result == "false" || !result) {
            isTruthy = false;
          }

          if (isTruthy) {
            return IC.eval(tree.ifbody);
          } else if (tree.elsebody) {
            return IC.eval(tree.elsebody);
          }

          return null;

        case "rowRange":
          let [start, end] = tree.value.replace(/r/ig, '').split(":").map(n => parseInt(n));
          return IC.envGetRowRangeVariables(start, end);


      }
    }

    if (Array.isArray(tree)) {
      if (tree.length == 1) {
        return IC.eval(tree[0]);
      }

      let cmd = typeof (tree[0]) === "string" ? tree[0] : null;

      // list of items to eval
      if (!cmd) {
        let results = tree.map(t => IC.eval(t));
        return results[results.length - 1];
      }

      switch (cmd) {
        case "booleanLiteral":
          return IC.makeBoolean(tree[1].value);
        case "stringLiteral":
          return IC.makeString(tree[1].value.slice(1, -1));
        case "nullLiteral":
          return null;

        case "parenExpr":
          return IC.eval(tree[1]);
        case "squareBracketExpr":
          return IC.eval(tree[1]);
        case "absValue":
          let ret = IC.eval(tree[1]);
          return this.evalFunction("ABS", [ret]);

        case "pctExpression":
          n = IC.mathMul(0.01, IC.eval(tree[1]));
          return IC.makeICObject(IC.val(n), null, "percent");

        case "pctOp":
          return IC.semanticPercentOp(tree[1], tree[3].value, tree[4]);

        case "pctChange":
          return IC.semanticPercentChange(tree[1], tree[2].value, tree[3]);

        case "factorial":
          n = IC.eval(tree[1]);
          return ICLib.factorial(n);

        case "parenMult":
          results = ([tree[1][0], ...tree[1][1]]).map(r => IC.eval(r));
          n = 1;
          if (results[0]?.type === "function") {
            return IC.evalUserFunction(results[0], results.slice(1));
          }

          results.forEach(r => n = IC.mathMul(n, r));
          if (tree[2]) {
            n = IC.semanticApplyUnit(n, tree[2]);
          }
          return n;

        case "assignmentExp":
          if (isLiteral(tree[1])) {
            result = IC.eval(tree[1]);
            name = IC.semanticGetVarName(tree[3]);
            return IC.envAssignVariable(name, tree[2].value, result);
          }

          result = IC.eval(tree[3]);
          name = IC.semanticGetVarName(tree[1]);
          return IC.envAssignVariable(name, tree[2].value, result);

        case "commaExp":
          let [_, ...cmds] = [...tree];
          results = cmds.map(c => IC.eval(c));
          return results[results.length - 1];

        case "scaledCallExp":
          return IC.semanticInfixOp(tree[1], "*", tree[2]);


        case "callExpWithKeyword":
        case "callExp":
          name = tree[1]?.value;
          let rawArgs = tree[2];

          let userDefinedFunc = IC.envGetVariable(name);
          if (tree[1][0] == "functionDeclaration") {
            userDefinedFunc = IC.eval(tree[1]);
          }

          if (userDefinedFunc && userDefinedFunc.type === "function") {
            let args = rawArgs.map(x => IC.eval(x));
            return IC.evalUserFunction(userDefinedFunc, args);
          }

          // Excel-style IF, AND, OR, NOT 
          if (CONFIG.KEYWORD_FUNCTION[name?.toUpperCase()]) {
            return CONFIG.KEYWORD_FUNCTION[name.toUpperCase()](...rawArgs);
          }

          let args = rawArgs.map(t => IC.eval(t));
          if (IC.semanticContainsDecimalWithCommas(tree)) {
            IC.log(`Number commas found, use spaces or wrap in parens: 1,234 => 1, 234 or (1,234)`);
          }

          if (IC.envGetVariable(name)) {
            IC.log(`multiplying variable '${name}' instead of calling function`);
            result = IC.mathMul(IC.envGetVariable(name), args[0]);
          } else {
            // run function first, so "time()" gets called
            result = IC.evalFunction(name, args);
            if (!IC.isValidEvalResult(result) && IC.envIsAutoUnit(name)) {
              result = IC.mathMul(IC.makeICObject(1, name, ""), args[0]);
            }
          }
          return result;

        case "arrayLiteral":
          return tree[1].map(item => IC.eval(item));

        case "arrayAccess":
          // Bracket access supports both arrays and plain objects
          // Evaluate container and key expression
          {
            let container = IC.eval(tree[1]);
            let keyExpr = IC.eval(tree[2]);

            // Array access
            if (Array.isArray(container)) {
              return container[keyExpr];
            }

            // Object dynamic key access: scenarios[scenario]
            if (container && typeof container === 'object') {
              // Coerce key to string where appropriate
              let k = (typeof keyExpr === 'string') ? keyExpr : String(keyExpr);
              // Use existing fuzzy finder for object keys (case/format tolerant)
              let found = IC.ICObjectLiteralFindKey(container, k);
              return found ? container[found] : undefined;
            }

            return undefined;
          }

        case "objectLiteral":
          let obj = {};
          return tree[1].reduce((obj, item) => {
            let key = item[1].value ?? null;

            // remove quotes from key
            if (key && item[1].type?.includes("string")) {
              key = key.slice(1, -1);
            }

            if (key !== null) {
              obj[key] = IC.eval(item[2]);
            }
            return obj;
          }, {});

        case "objectAccess":
          let object = IC.eval(tree[1]);
          let key = tree[2].value;

          // if array literal, call function
          if (Array.isArray(object) && IC.predefinedFunction(key)) {
            return IC.evalFunction(key, [object]);
          }

          // regular lookup, search
          key = IC.ICObjectLiteralFindKey(object, key);
          return key ? object[key] : undefined;

        case "timeLiteral":
          return ICTime.makeICObject(tree[1].value);

        case "datetimeLiteral":
          return ICDate.makeICObject(tree[1].value);

        case "timeImpliedDateLiteral":
          return ICDate.makeICObjectTimeImpliedDate(tree[1].value);

        case "tapemeasure":
          let makeNumberObj = (val) => {
            let value = val.trim().replace(/[^0-9. /]/g, "");

            if (value.includes("/")) {
              return { type: "fraction", value: value }
            } else {
              return { type: "decimal", value: value }
            }
          }

          if (value = tree[1]?.foot?.value) {
            n = IC.eval(makeNumberObj(value));
            return IC.makeICObject(n, "ft", "tape");
          } else if (value = tree[1]?.inch?.value) {

            n = IC.eval(makeNumberObj(value));
            return IC.makeICObject(n, "in", "tape");
          } else {
            value = tree[1].both.value;
            let parts = value.split(/[']|ft|foot|feet/i);
            let nFeet = IC.eval(makeNumberObj(parts[0]));
            let nInches = IC.eval(makeNumberObj(parts[1]));

            return IC.mathAdd(
              IC.makeICObject(nFeet, "ft", "tape"),
              IC.makeICObject(nInches, "in", "tape"));
          }

        case "unit":
          if (tree[1]?.type == "fraction" && IC.predefinedSuffixScale(tree[2]) != 1) {
            // TODO: not being hit by code coverage
            return IC.semanticNumericScaleFraction(tree);
          }

          return IC.semanticApplyUnit(tree[1], tree[2]);

        case "conversion":
          return IC.semanticConvert(tree[1], tree[2]);

        case "conversionDiv":

          // "15 mph -> /s" becomes "15 mph -> s", which is what we want
          let inverseType = IC.typestring(IC.eval(tree[2])?.t);
          return IC.semanticConvert(tree[1], inverseType);

        case "rate":
          let numerator = IC.eval(tree[2]);
          let denominator = IC.eval(tree[1]);
          result = IC.mathDiv(numerator, denominator);
          return result;

        case "typesolve":
          let aVal = IC.eval(tree[1]);
          let bVal = IC.eval(tree[2]);
          let bUnit = IC.semanticGetUnitName(tree[2]);

          // check if b was an autoconverted unit: 15 miles/hour using feet
          if (IC.envIsAutoUnit(bUnit)) {
            return IC.semanticConvert(aVal, bUnit);
          }

          // make sure "feet" is an actual variable, for example
          if (bVal != null) {
            let ret = IC.typeSolve(aVal, bVal);
            if (ret != null) {
              return ret;
            }
          }

          // best guess -- multiply? 
          return IC.mathMul(aVal, bVal);
        // return IC.semanticConvert(aVal, bUnit);

        case "unary":
          switch (tree[1]) {
            case "!":
              return !IC.eval(tree[2]);
            case "not":
            case "~":
              result = IC.eval(tree[2]);
              return ~IC.val(result);
            case "++":
              name = IC.semanticGetVarName(tree[2]);
              IC.envAssignVariable(name, "+=", 1);
              return IC.envGetVariable(name);
            case "--":
              name = IC.semanticGetVarName(tree[2]);
              IC.envAssignVariable(name, "-=", 1);
              return IC.envGetVariable(name);
            case "+":
              return IC.eval(tree[2]);
            case "-":
              return IC.mathNegate(IC.eval(tree[2]));
          }
          return null;

        case "postfix":
          result = IC.eval(tree[1]);
          name = IC.semanticGetVarName(tree[1]);

          switch (tree[2].value) {
            case "++":
              IC.envAssignVariable(name, "+=", 1); break;
            case "--":
              IC.envAssignVariable(name, "-=", 1); break;
          }
          return result;

        case "power":
        case "power2":
        case "power3":
          let base = IC.eval(tree[1]);
          let source = tree[1]?.value;

          // cm => 1 cm
          if (!base && IC.typestringIsPossibleUnitIncludingSlash(source)) {
            base = IC.makeICObject(1, source);
          }
          let power = IC.eval(tree[2]);
          return IC.mathPow(base, power);

        case "add":
          return IC.semanticInfixOp(tree[1], "+", tree[2]);
        case "sub":
          return IC.semanticInfixOp(tree[1], "-", tree[2]);
        case "mul":
          return IC.semanticInfixOp(tree[1], "*", tree[2]);
        case "div":
          return IC.semanticInfixOp(tree[1], "/", tree[2]);
        case "divUnit":
          return IC.semanticDivUnit(tree[1], tree[2]);
        case "mod":
          return IC.mathMod(IC.eval(tree[1]), IC.eval(tree[2]));

        case "lsl":
          return IC.semanticInfixOp(tree[1], "<<", tree[2]);
        case "lsr":
          return IC.semanticInfixOp(tree[1], ">>", tree[2]);
        case "asr":
          return IC.semanticInfixOp(tree[1], ">>>", tree[2]);

        case "lt":
          return IC.semanticTypeCompareOp(tree[1], "<", tree[2]);
        case "gt":
          return IC.semanticTypeCompareOp(tree[1], ">", tree[2]);
        case "le":
          return IC.semanticTypeCompareOp(tree[1], "<=", tree[2]);
        case "ge":
          return IC.semanticTypeCompareOp(tree[1], ">=", tree[2]);

        case "equal":
          return IC.semanticTypeCompareOp(tree[1], "==", tree[2]);
        case "notEqual":
          return IC.semanticTypeCompareOp(tree[1], "!=", tree[2]);
        case "eq":
          return IC.semanticTypeCompareOp(tree[1], "===", tree[2]);
        case "notEq":
          return IC.semanticTypeCompareOp(tree[1], "!==", tree[2]);

        case "band":
          return IC.semanticInfixOp(tree[1], "and", tree[2]);
        case "bxor":
          return IC.semanticInfixOp(tree[1], "xor", tree[2]);
        case "bor":
          return IC.semanticInfixOp(tree[1], "or", tree[2]);
        case "land":
          return IC.semanticInfixOp(tree[1], "&&", tree[2]);
        case "lor":
          return IC.semanticInfixOp(tree[1], "||", tree[2]);

        case "conditional":
          result = IC.eval(tree[1]);
          let isTruthy = result;

          if (result == "false" || !result) {
            isTruthy = false;
          }

          return isTruthy ? IC.eval(tree[2]) : IC.eval(tree[3]);

        case "customOp":
          return IC.semanticInfixOp(tree[1], tree[2], tree[3]);

        case "functionDeclaration":
          let funcName = tree[1]?.value ?? null;      // named or anon
          let params = tree[2].map(param => param.value || param);  // handle both param objects and strings
          let body = tree[3];
          let funcObj = {
            type: "function",
            params: params,
            body: JSON.parse(JSON.stringify(body))
          };
          if (funcName) {
            IC.envAssignVariable(funcName, "=", funcObj);
          }
          return funcObj;
      }
    }

    return tree; // may be valid result
  },


  evalIdentifier(name) {
    let ret = IC.envGetVariable(name);

    if (ret && IC.info.unitOverride && IC.predefinedUnit(name)) {
      // IC.log(`using ${name} as unit`); // already warned in output
      return IC.makeICObject(1, name);
    }

    if ((isNaN(ret) || !ret) && !IC.envIsVariableDefined(name)) {
      let semanticPrefix = IC.semanticPrefixFromIdentifierString(name);
      if (semanticPrefix !== null) {
        return semanticPrefix;
      }

      if (IC.predefinedUnit(name)) {
        return IC.makeICObject(1, name);
      }
    }

    if (!IC.envIsVariableDefined(name) && CONFIG.PREDEFINED_FALLBACK[name?.toUpperCase()]) {
      return CONFIG.PREDEFINED_FALLBACK[name?.toUpperCase()];
    }

    if (ret === undefined && name.includes(" ")) {

      // sine of 30 => sine 30
      if (name.toLowerCase().includes(" of ")) {
        name = name.replace(/\bof\b/g, "");
      }

      // Possible chain of functions: "sin 30" => sin(30), "square sin 30 deg" => square sin(30 deg)
      let parts = name.split(/\s+/);
      let lastFunctionIndex = parts.findLastIndex(part => IC.predefinedFunction(part) && !IC.predefinedUnit(part));

      if (lastFunctionIndex !== -1) {

        // Split the parts into function names and the argument
        let fnNames = parts.slice(0, lastFunctionIndex + 1).join(" ");
        let potentialArg = parts.slice(lastFunctionIndex + 1).join(" ");

        let arg = IC.parseAndEval(potentialArg);
        arg = Array.isArray(arg) ? arg : [arg];

        ret = IC.evalFunction(fnNames, arg);
        if (IC.isValidEvalResult(ret)) {
          return ret;
        }
      }

      // if it's all units, make that unit: "m s" => m * s
      let possibleUnits = name.split(/\s+/);
      let isPredefinedUnit = possibleUnits.map(ICUnit.isPredefinedUnitCaseInsensitive).every(x => x) ? IC.makeICObject(1, name) : null;
      if (isPredefinedUnit) {
        IC.log(`processing units: ${possibleUnits.map(ICUnit.formatSIUnit).join(" * ")}`);
        return isPredefinedUnit;
      }
    }

    // TODO: add caching for isRomanNumeral
    if (ret === undefined && ICLib.isRomanNumeral(name)) {
      let val = ICLib.romanToDecimal(name);
      IC.log(`Roman numeral ${name} = ${val}`);
      return IC.makeICObject(val, null, "roman");
    }

    let fn = IC.predefinedFunction(name); // could be the actual function, not a string
    if (ret === undefined && (typeof (fn) === "string" && fn.match("array"))) {
      // total - do total from R1 to previous row
      let start = 1;
      let end = IC.envGetRowIndex();

      if (name == "subtotal") {
        // change start row to index of first blank row
        let inputRows = IC.envGetInputRows();
        let blankRowIndex = inputRows.slice(0, end).reverse().findIndex(row => row == null || row.trim() === '');
        if (blankRowIndex !== -1) {
          start = end - blankRowIndex + 1;
        }
      }

      IC.log(`using function ${name}(R${start}:R${end})`);
      return IC.evalFunction(name, IC.envGetRowRangeVariables(start, end));
    }

    if (ret === undefined && IC.predefinedConfigFunction(name)) {
      return IC.predefinedConfigFunction(name)();
    }

    /*
    if (ret === undefined && LIB.InstaCalc.LIB.isPossibleStock(name)) {
      IC.log(`Lookup: STOCK(${name})`);
      return IC.evalFunction("STOCK", [name]);
    }
    */

    // lookup object access: var.x.y.z
    if (ret === undefined && name.includes(".")) {
      let parts = name.split(/\s+/);
      let objectPart = parts[0];
      let unitPart = parts.slice(1).join(" ");

      if (objectPart.includes(".")) {
        let objParts = objectPart.split(".");
        let obj = IC.envGetVariable(objParts[0]);

        for (let i = 1; i < objParts.length && obj; i++) {
          // array function: var.max
          if (Array.isArray(obj) && IC.predefinedFunction(objParts[i])?.match("array")) {
            obj = IC.evalFunction(objParts[i], obj);
            break;
          }

          let key = IC.ICObjectLiteralFindKey(obj, objParts[i]);
          obj = obj[key];
        }

        if (obj !== undefined) {
          if (unitPart && IC.predefinedUnit(unitPart)) {
            // Handle conversion: (var.field) to cm
            return IC.semanticConvert(obj, unitPart);
          }
          return obj;
        }
      }
    }

    // net sales USD => net_sales -> USD
    if (ret === undefined && name.includes(" ")) {
      let parts = name.split(/\s+/);
      let realName = null;
      let unit = null;
      for (var i = 0; i < parts.length; i++) {
        let builtUpName = parts.slice(0, i + 1).join("_");
        if (IC.envIsVariableDefined(builtUpName)) {
          realName = builtUpName;
          unit = parts.slice(i + 1).join(" ");
        }
      }

      // if a real unit, convert to that unit
      if (IC.predefinedUnit(unit)) {
        let val = IC.envGetVariable(realName);
        if (val !== undefined) {
          return IC.semanticConvert(val, unit);
        }
      }
    }

    return ret;
  },

  evalWithUnitOverride(tree) {
    IC.info.unitOverride = true;
    let ret = IC.eval(tree);
    IC.info.unitOverride = false;
    return ret;
  },

  evalUserFunction(nameOrFunctionObj, args) {
    let userDefinedFunc = nameOrFunctionObj;
    if (typeof nameOrFunctionObj === "string") {
      userDefinedFunc = IC.envGetVariable(nameOrFunctionObj);
    }

    if (!userDefinedFunc?.body) {
      return undefined;
    }

    // Initialize stackDepth if it doesn't exist
    if (IC.env.stackDepth === undefined) {
      IC.env.stackDepth = 0;
    }

    // Check if we've reached the stack limit
    const STACK_LIMIT = 20;
    if (IC.env.stackDepth >= STACK_LIMIT) {
      IC.log("Stack limit exceeded - check for function recursion");
      return "Stack limit exceeded";
    }

    let oldEnv = IC.env;
    IC.env = Object.create(IC.env);
    userDefinedFunc.params.forEach((param, index) => {
      IC.envAssignVariable(param, "=", args[index]);
    });

    IC.env.stackDepth++;
    let result = IC.eval(userDefinedFunc.body);
    IC.env.stackDepth--;

    IC.env = oldEnv;
    return result;
  },

  evalFunction(name, args) {
    if (IC.predefinedFunction(name)) {
      IC.log(`fn: ${name}`);
    }

    if (IC.envIsUserFunction(name)) {
      return IC.evalUserFunction(name, args);
    }

    // compound function call: square sin(45) => square(sin(45))
    const functionParts = name.split(' ');
    if (functionParts.length > 1) {
      const result = functionParts.reverse().reduce((prevResult, part) => {
        return prevResult === undefined ? undefined : IC.evalFunction(part, [prevResult]);
      }, args[0]);

      if (result !== undefined) {
        return result;
      }
    }

    let ucName = name.toUpperCase();
    let lcName = name.toLowerCase();
    let str = LIB.InstaCalc.allowedfn[ucName] || "";

    if (CONFIG.UNIT_AWARE_FUNCTIONS[ucName] && IC.hasType(args[0])) {
      return CONFIG.UNIT_AWARE_FUNCTIONS[ucName](...args);
    }

    if (CONFIG.OTHER_FUNCTIONS[ucName]) {
      return CONFIG.OTHER_FUNCTIONS[ucName](...args);
    }

    if (CONFIG.ENGLISH_FUNCTION[ucName]) {
      return CONFIG.ENGLISH_FUNCTION[ucName](...args);
    }

    const possibleConversion = ICUnit.isPredefinedUnitCaseInsensitive(name);

    // remove types, convert to degrees if needed
    var processed_args = args.map((a) => {
      if (IC.hasNoType(a)) {
        return IC.val(a);
      }

      // functions take degrees by default
      if (IC.typestringIsSameUnitCategory(IC.typestring(a.t), "radian")) {
        let newObj = IC.ICObjectConvertToType(a, "degrees");
        return IC.val(newObj);
      } else {
        if (IC.typeIsByte(a.t)) {
          a = IC.typeConvertByteToNumber(a);
        }
        else if (IC.typeIsVirtual(a.t)) {
          a = IC.typeConvertVirtualToNumeric(a);
        }
        else {
          if (!possibleConversion) {
            IC.log(`removing units`);
          }
        }

        return IC.val(a);
      }
    });

    // dynamic log function: log_2 or log_x
    if (ucName.includes("LOG_")) {
      let base = ucName.split("LOG_")[1];
      let baseVal = IC.isNumberString(base) ? IC.makeNumber(base) : IC.envGetVariable(base);

      return LIB.Complex.logBase(processed_args[0], baseVal);
    }

    if (str.includes("fn().")) {
      let ret = undefined;

      // internal
      let localName = str.split("fn().")[1];

      /*
      if (localName.startsWith("array")) {
        if (args.every(a => Array.isArray(a))) {
          // Flatten each argument separately and map them
          processed_args = args.map((arg, argIndex) =>
            arg.flat(Infinity).map((a, i) => [i, IC.val(a)])
          );
          // Pass the processed arguments separately to the function
          ret = IC.CALC.fn()[localName](...processed_args);
        } else {
          // Handle the case where not every argument is an array
          processed_args = args.flat(Infinity).map((a, i) => [i, IC.val(a)]);
          ret = IC.CALC.fn()[localName](processed_args); // takes array
        }
      }
        */

      if (localName.startsWith("array")) {
        const hasArrayArg = args.some(Array.isArray);

        if (!hasArrayArg) {
          // something like IRR(val, val, val) => IRR([val, val, val])
          processed_args = [args.map((a, i) => [i, IC.val(a)])];
        } else {
          // If at least one argument is an array, process each argument separately
          processed_args = args.map(arg => {
            if (Array.isArray(arg)) {
              return arg.map((a, i) => [i, IC.val(a)]);
            }
            return IC.val(arg);
          });
        }

        ret = IC.CALC.fn()[localName](...processed_args);
      }

      // format result with these types
      if (localName == "bin") return IC.makeBinary(processed_args[0]);
      if (localName == "oct") return IC.makeOctal(processed_args[0]);
      if (localName == "hex") return IC.makeHexadecimal(processed_args[0]);

      // TODO: make excel functions like IRR return a % by default

      if (!IC.isValidEvalResult(ret)) {
        ret = IC.CALC.fn()[localName](...processed_args);
      }

      const pctFunctions = new Set("arrayIRR|RATE|RRI".split("|"));
      if (pctFunctions.has(localName)) {
        ret = IC.makeICObject(ret, null, "percent");
      }

      const roundFunctions = new Set("PMT|IPMT|PPMT|ISPMT|PV|FV|NPV".split("|"));
      if (roundFunctions.has(localName)) {
        ret = ICLib.roundToDecimal(IC.val(ret), 2);
      }

      return ret;
    }

    if (str.includes("Math.")) {
      let localName = str.split("Math.")[1];
      return Math[localName](...processed_args);
    }

    // unit name: cm(1 inch). Must come last, since C [unit] vs C (combination)
    if (possibleConversion) {
      IC.log(`convert to ${name}`);
      return IC.semanticConvert(args[0], name);
    }

    // check for predefined function
    if (IC.predefinedConfigFunction(ucName)) {
      return IC.predefinedConfigFunction(ucName)(...processed_args);
    }

    // must come last, since some functions call evalFunction
    if (CONFIG.POSTCONVERT_FUNCTIONS[lcName]) {
      return IC.predefinedPostConvertFunction(args[0], lcName);
    }

    IC.log(`missing fn: ${name}`);
    return undefined;
  },
}

var IC = {
  ...CoreModule,
  ...LogModule,
  ...EnvModule,
  ...ObjectModule,
  ...TypeModule,
  ...LiteralModule,
  ...StringModule,
  ...ParseModule,
  ...SemanticModule,
  ...MathModule,
  ...EvalModule,
};


IC.parser = {
  cache: {},

  escapeUnicode: function (str) {
    if (!str) return str;

    return str.replace(/[\u007f-\uffff]/g, c =>
      '\\u' + ('0000' + c.charCodeAt(0).toString(16)).slice(-4)
    );
  },

  /*
  @param {any} - candidate str (could be a number or other format passed in)
  @returns {string} 
  */
  unescapeUnicode: function (str) {

    // unfortunately, the memoize function turns Infinity into null. Don't use it.

    // need at least 6 characters: \u1234
    if (!str || typeof str !== "string" || str.length < 6) return str;

    return str.replace(/\\u([0-9a-f]{4})/gi, (_, first) =>
      String.fromCodePoint(parseInt(first, 16))
    );
  },

  removeInvisibleUnicodeCharacters(str) {
    return str.replace(/[\0-\x1F\x7F-\x9F\xAD\u0600-\u0604\u070F\u17B4\u17B5\u200C-\u200F\u2028-\u202F\u2060-\u206F\ufeff\ufff9-\ufffc]/g, '');
  },

  CURRENCY_COMBINED_REGEX: null,
  processCurrencySymbolsAndStrings: function (input) {

    function replaceCurrencies(s) {
      const currencies = Object.values(LIB.InstaCalc.format.currencies);
      if (!IC.parser.CURRENCY_COMBINED_REGEX) {
        const regexes = currencies.map(c => c.regex.source);
        IC.parser.CURRENCY_COMBINED_REGEX = new RegExp(regexes.join('|'), 'gi');
      }

      // Reset lastIndex before testing the regex
      IC.parser.CURRENCY_COMBINED_REGEX.lastIndex = 0;

      if (IC.parser.CURRENCY_COMBINED_REGEX.test(s)) {
        // If combinedRegex has a match, check each currency regex
        currencies.forEach((c) => {
          // Make sure to reset lastIndex before calling test on this regex as well
          c.regex.lastIndex = 0;
          if (s.match(c.regex)) {
            IC.envSetFormatter(c);
            s = s.replace(c.regex, ` (_${c.code}) `);
          }
        });
      }

      return s;
    }

    let allTokens = IC.parser.tokenize(input, LEXER);
    let tokens = allTokens.filter(t => t.type != "ws");

    // remove multiple $ ($$, $$$, etc.) from stream
    tokens = tokens.filter((t, i) => {
      let nextToken = tokens[i + 1];
      let prevToken = tokens[i - 1];
      let isRepeated = (t.text == "$" && (nextToken?.text == "$" || prevToken?.text == "$"));
      return !isRepeated;
    });

    let results = tokens.map(t => {
      // string_double or string_single
      if (t.type.indexOf("string_") >= 0) {
        let key = IC.envAddString(t.value);
        return `${key}`;
      }

      if (t.type == "id" || t.type == "source") {
        return replaceCurrencies(t.text);
      }

      return t.text;
    });

    let processed = IC.parser.tokenSmartJoin(allTokens, results);
    let format = IC.envGetFormatter();
    let strings = IC.envGetStrings();

    return { processed, format, strings };
  },

  processDateTimeExpressions: function (input) {
    const REPLACEMENTS = {
      BEFORE: { operation: '* -1 +' },
      AGO: { operation: '* - 1 +' },
      AFTER: { operation: '+' },
      FROM: { operation: '+' },
    };

    IC.CACHE.PROCESS_DATETIME_REGEX = IC.CACHE.PROCESS_DATETIME_REGEX || new RegExp(Object.keys(REPLACEMENTS).join('|'), 'i');

    // return unless we have a REPLACEMENT keyword
    if (!input.match(IC.CACHE.PROCESS_DATETIME_REGEX)) {
      return input;
    }

    let allTokens = this.tokenize(input, LEXER);
    let tokens = allTokens.filter(t => t.type !== "ws");

    let isTimePeriod = function (unit) {
      return IC.typestringIsSameUnitCategory("s", unit);
    };

    let processedTokens = tokens.map((token, i) => {
      if (token.type === 'id') {
        let parts = token.text.split(/\s+/);

        var indexes = parts.map((part, i) => { return isTimePeriod(part) ? i : -1 });
        let maxIndex = Math.max(...indexes);

        if (maxIndex == -1) {
          return token;
        }

        let keyword = parts[maxIndex + 1]?.toUpperCase();
        if (REPLACEMENTS[keyword]) {
          let replacement = REPLACEMENTS[keyword];
          parts[1] = replacement.operation;
          if (keyword == "AGO") {
            parts[1] += " TODAY";
          }

          token.text = token.value = parts.join(' ');
        }
      }
      return token;
    });

    // Remove empty tokens
    processedTokens = processedTokens.filter(token => token.text);

    return IC.parser.tokenSmartJoin(allTokens, processedTokens);
  },

  processFinalCurrencies: function (input) {
    if (!input.match(/\(_[A-Z]+\)/i)) {
      return input;
    }

    const currencies = Object.values(LIB.InstaCalc.format.currencies);
    const validCurrencies = {};
    currencies.forEach((c) => {
      validCurrencies[c.code] = c;
    });

    const lines = input.split(';').map(line => line.trim());

    let processedLines = lines.slice();

    // Handle cases like: $100 EUR in USD => (_USD) 100 EUR in USD => 100 EUR in USD
    processedLines = processedLines.map(line => {
      let parts = line.split(/\s+/);
      if (parts.length >= 3 &&
        parts[0].match(/^\(_[A-Z]+\)$/) &&
        parts[2].match(/^[A-Z]{3}$/)) {
        // Remove the initial (_XXX) if there's another currency code
        parts.shift();
        return parts.join(' ');
      }
      return line;
    });

    // treat $2 / 3 oz => ($2) / (3 oz)
    processedLines = processedLines.map(line => {
      let allTokens = IC.parser.tokenize(line, LEXER);
      let tokens = allTokens.filter(t => t.type != "ws");

      function setToken(i, value) {
        tokens[i].value = value;
        tokens[i].text = value;
      }

      for (let i = 0; i < tokens.length - 6; i++) {
        let [LP, CURRENCY_WITH_UNDERSCORE, RP, NUMBEROBJ1, DIVIDE, NUMBEROBJ2, UNIT] = tokens.slice(i, i + 7);
        let CURRENCY = CURRENCY_WITH_UNDERSCORE?.value?.slice(1);

        // (_USD) 4k / 3 oz 
        if (IC.isNumberStringIncludingScaleSuffix(NUMBEROBJ1?.value + DIVIDE?.value)) {
          DIVIDE = tokens[i + 5];
          NUMBEROBJ2 = tokens[i + 6];
          UNIT = tokens[i + 7];
        }

        if (LP.value === '(' &&
          validCurrencies[CURRENCY?.toUpperCase()] &&
          RP.value === ')' &&
          NUMBEROBJ1?.type === 'decimal' &&
          DIVIDE?.value === '/' &&
          NUMBEROBJ2?.type === 'decimal' &&
          ICUnit.isPredefinedUnitCaseInsensitive(UNIT?.value)
        ) {
          setToken(i, "");
          setToken(i + 1, CURRENCY);
          setToken(i + 2, "");
        }
      }

      line = IC.parser.tokenSmartJoin(allTokens, tokens);
      return line;
    });

    // $varname = 15$ in eur => varname = USD 15 in eur
    processedLines = processedLines.map(line => {
      if (line.match("=")) {
        let parts = line.split("=");
        let lhs = parts[0].trim();
        let rhs = parts[1].trim();

        // remove _CODE if start of lhs
        currencies.forEach((c) => {
          line = line.replace(new RegExp(`^\\(_${c.code}\\)`, 'i'), '');
        });

        return line;
      }

      return line;
    });

    processedLines = processedLines.map(line => {
      if (!line.match("->")) {
        // If no conversion is detected in the line, remove _CODE from the string for all currencies
        currencies.forEach((c) => {
          line = line.replace(new RegExp(`\\(_${c.code}\\)`, 'gi'), '');
        });
        return line;
      }

      // If a conversion is detected in the line, replace _CODE with the actual currency code
      currencies.forEach((c) => {
        line = line.replace(new RegExp(`\\(_${c.code}\\)`, 'gi'), c.code);
      });
      return line;
    });

    return processedLines.join('; ');
  },

  /*
  // now all
  processRegexReplacementsOld: function (input, REPLACEMENTS) {
    let processed = input;
 
    if (REPLACEMENTS == CONFIG.L2_REPLACEMENTS_STRINGS) {
      processed = CONFIG.L2_REPLACEMENTS_STRING_ONLY_TRIE.replaceInText(processed, false);
      return processed;
    }
 
    for (const [find, replace] of Object.entries(REPLACEMENTS)) {
      if (typeof replace === "object") {
        processed = processed.replace(replace.find, replace.replace);
      } else {
        processed = processed.replaceAll(find, replace);
      }
    }
    return processed.trim();
  },
  */

  processRegexReplacements: function (input, REPLACEMENTS) {
    // Special case for L2 replacements
    if (REPLACEMENTS == CONFIG.L2_REPLACEMENTS_STRINGS) {
      return CONFIG.L2_REPLACEMENTS_STRING_ONLY_TRIE.replaceInText(input, false);
    }

    // Split the input by semicolons
    let parts = input.split(';');

    // Process each part separately
    let processedParts = parts.map(part => {
      let processed = part;
      for (const [find, replace] of Object.entries(REPLACEMENTS)) {
        if (typeof replace === "object") {
          processed = processed.replace(replace.find, replace.replace);
        } else {
          processed = processed.replaceAll(find, replace);
        }
      }
      return processed.trim();
    });

    // Rejoin the processed parts with semicolons
    return processedParts.join(';');
  },

  // "x + 3 // note" becomes "x + 3"
  processComment: function (input) {
    let processed = input;
    let comment = "";

    let tokens = IC.parser.tokenize(input, LEXER);

    tokens.forEach((t) => {
      if (t.type.indexOf("commentSingle") >= 0) {
        processed = input.substring(0, t.offset);

        // remove leading "/" or "#"
        comment = t.text.replace(/^[/#]+/, "").trim();
      }
    });

    return { processed, comment };
  },

  scanReferencesFromParseResult: function (ret) {
    let tree = ret.parseResult;

    const references = new Set();
    const custom_units = new Set();

    function processNode(node) {
      if (!node) return [];

      if (typeof node === "object") {
        switch (node.type) {
          case "ifStatement":
            return [node.ifcond, node.ifbody, node.elsebody];
          case "id":
            references.add(IC.canonicalName(node.value));
            return [];
          case "rowRange":
            const [r1, r2] = node.value.split(":").map(v => parseInt(v.replace(/r/i, "")));
            for (let i = r1; i <= r2; i++) {
              references.add(`r${i}`);
            }
            return [];
        }
      }

      if (Array.isArray(node)) {
        switch (node[0]) {
          case "assignmentExp":
            return [node[3]];
          case "callExp":
            return [node[2]];
          case "conversion":
            return [node[1]];
          case "unit":
            // TODO: have an "autounit" list, which we can check when vars are defined later
            // at this point, we don't know if it's a real unit or not
            if (!IC.typestringIsPossibleUnitIncludingSlash(node[2])) {
              custom_units.add(IC.semanticGetUnitNameFromString(node[2]));
            }
            return [];
          default:
            return node.filter(child => typeof child !== "string");
        }
      }

      return [];
    }

    function walkTree(node) {
      processNode(node).forEach(child => walkTree(child));
    }

    walkTree(tree);

    return { references: Array.from(references), custom_units: Array.from(custom_units) };
  },

  scanAssignedIdentifiersUsingLex: function (input) {
    if (!input.includes("=")) {
      return [];
    }

    let tokens = IC.parser.tokenize(input, LEXER).filter(t => t.type != "ws");

    let ids = tokens.map((t, i) => {
      let nextToken = tokens[i + 1];
      let prevToken = tokens[i - 1];

      // x = 3, but not "2 weeks = 3"
      if (t.type == "id" && nextToken?.type == "eq" && prevToken?.type != "decimal") {
        return {
          name: IC.canonicalName(t.text),
          orig: t.text
        }
      }
    }).filter(x => x);
    return ids;
  },

  processPrefixRegex: function (input) {
    if (!IC.PREFIX_COMBINED_REGEX) {
      const escapedPrefixes = CONFIG.PREFIX_REMOVE.map(prefix => prefix.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      IC.PREFIX_COMBINED_REGEX = new RegExp('^\\s*(' + escapedPrefixes.join('|') + ')\\s+', 'i');
    }
    let prefixRegex = IC.PREFIX_COMBINED_REGEX;

    let s = input;
    if (s.match(prefixRegex)) {
      s = s.replace(prefixRegex, '');
      s = s.replace(/\?/g, '');  // replace all question marks globally
    }

    return s;
  },

  // parse input using lexer. Returns ALL tokens, including items on ignore list
  tokenize(input, lexer) {
    if (!input) return [];
    let key = "tokenize:" + input;
    let tokens = IC.CACHE.get(key);
    if (!tokens) {
      lexer.IGNORE_ENABLED = false;
      tokens = [...lexer.reset(input)];
      lexer.IGNORE_ENABLED = true;
      IC.CACHE.set(key, tokens);
    }

    return tokens;
  },

  // 250 billion dollars a month => 250 billion dollars / month
  processAasKeyword(input) {
    if (!input?.match(/\sa\s/i)) {
      return input;
    }

    const tokens = input.split(' ');
    const processedTokens = tokens.map((token, index) => {
      if (token.toLowerCase() === 'a') {
        const prevToken = tokens[index - 1];
        const nextToken = tokens[index + 1];

        if (
          prevToken &&
          nextToken &&
          IC.predefinedUnit(prevToken) &&
          IC.predefinedUnit(nextToken)
        ) {
          return '/';
        }
      }
      return token;
    });

    return processedTokens.join(' ');
  },

  // 50 miles/hour in feet/sec ... if in is surrounded by units, convert it
  processInAsKeyword(input) {
    if (!input.match(/\bin\b/i) || IC.envIsDefined("in")) {
      return input;
    }

    // split up by whitespace too
    let tokens = IC.parser.tokenize(input, LEXER);

    function replaceIn(id, tokenIdx, allTokens) {
      const parts = id.split(" ");
      const tokensWithIn = parts.map(p => p.toLowerCase() == "in");
      const restOfTokens = allTokens.slice(tokenIdx + 1).map(t => t.text).join('');

      // no conversion needed
      if (parts.length === 1 || !tokensWithIn.some(item => item)) {

        // ($0.75) / (1.74 oz) in $/lb => ( (_USD) 0.75) / (1.5 oz) in (_USD) /lb
        // rest of tokens matches a paren
        if (id == "in" && restOfTokens.match(/^\s*[(]/i)) {
          return "->";
        }

        return id;
      }

      // TODO: clean this up a bit...
      let replacement = parts.map((val, i) => {
        if (!tokensWithIn[i]) {
          return val;
        }

        let ti = tokenIdx;
        let all = allTokens;

        let lastIndex = parts.length - 1;
        let nextIndex = i + 1;

        // next token is "in", and is not last, so skip me
        if (tokensWithIn[nextIndex] && nextIndex != lastIndex) {
          return val;
        }

        // if we're in a conversionDiv, and next token is " /s" convert "in" to ->
        if (allTokens[tokenIdx + 1]?.type == 'ws' && allTokens[tokenIdx + 2]?.value == '/') {
          return '->';
        }

        // search next 3 tokens for (_USD): whitespace, left paren, then _USD
        if (allTokens[ti + 1]?.type == 'ws' && allTokens[ti + 2]?.value == '(' && allTokens[ti + 3]?.value.match(/_[A-Z]+/)) {
          return "->";
        }

        // if next token is a paren, convert "in" to ->
        // example: 15 m/s in (cm)/day, where "cm" was a variable
        if (restOfTokens.match(/\s+?\(/)) {
          return "->";
        }

        // convert "in" to "->"", except for last position
        return i == lastIndex ? val : "->";
      }).join(" ");

      return replacement;
    }

    let replacements = tokens.map((t, i) => {
      if (t.type != "id") return t.text;

      return replaceIn(t.text, i, tokens);
    });

    return replacements.join("");
  },

  /*
  Insert -> operator where needed in paren expressions, ex:
    (10) cm / kg / day => (10) ->  cm / kg / day 
  */
  processParenUnitExpressions: function (input) {

    // Check if the string contains both parentheses and a slash.
    if (!/\(.*\).*\//.test(input)) {
      return input;
    }

    // quick and dirty...
    let tokens = input.split(/(\(|\))/); // split on parens
    let replacements = tokens.map((currentToken, i) => {
      let prevToken = tokens[i - 1];

      if (currentToken.includes("/") && prevToken == ")" && IC.typestringIsPossibleUnitIncludingSlash(currentToken)) {
        return " -> " + currentToken;
      }
      return currentToken;
    });

    // not real tokens, just use regular join
    return replacements.join('');
  },

  // Handle more natural input for conversions, i.e.
  // this: 30 miles per gallon in dollars per mile at $3/gallon  [A -> B @ C]
  // becomes: 30 miles per gallon at $3 per gallon in dollars per mile [C @ A -> B]
  processConversionAtOrder: function (input) {
    if (!input.includes("@")) {
      return input;
    }

    // Regular expression to match "A -> B @ C" pattern with spaces
    const conversionAtRegex = /(.+?)\s*->\s*(.+?)\s*@\s*(.+)/;

    // Check if the input contains the "->" followed by "@" pattern
    if (conversionAtRegex.test(input)) {
      // If the pattern is found, reorder the parts
      return input.replace(conversionAtRegex, (match, A, B, C) => {
        // Check if the matched parts contain parentheses
        if (A.includes('(') || B.includes('(') || C.includes('(')) {
          // If any part contains parentheses, do not reorder
          return match;
        }

        // Reorder the parts to "C @ A -> B"
        return `${C} @ ${A} -> ${B}`;
      });
    }

    // If the pattern is not found, return the original input
    return input;
  },

  checkFailedResult(input = "", result) {
    if (input.trim() == "") {
      let env = IC.envGet();
      let index = IC.envGetRowIndex();
      let inputRows = IC.envGetInputRows();
      let numberOfPreviousRows = 3; // Number of previous rows to check
      let previousRows = Array.from({ length: numberOfPreviousRows }, (_, i) => env['r' + (index - i)]);

      // valid number row
      function isValidRow(row, rowIndex) {
        return row != null && !isNaN(row) && inputRows[index - rowIndex]?.trim() !== "";
      }

      if (previousRows.every((row, i) => isValidRow(row, i + 1))) {
        let numericItems = IC.envGetRowRangeVariables(1, index).map(IC.val).filter(val => typeof (IC.val(val)) == 'number')
        let total = IC.evalFunction('total', numericItems);
        let result = {
          final_result: total
        };

        let formattedTotal = IC.parser.applyRawNumberFormatting(total, IC.envGetSettings()?.locale);
        let msg = `total: ${formattedTotal}`;
        IC.log(msg);
        return;
      }
    }

    if (IC.isValidEvalResult(result) || input == "") {
      return;
    }

    var unit = IC.predefinedUnit(input.trim());
    if (unit) {
      let msg = "";
      if (typeof unit == "object") {
        let suffix = unit.name ? ` (${unit.name})` : "";
        msg = `unit ${input}${suffix}, usage: '1 ${input}' or '1 ${input} to {unit}'`;
      }
      else {
        msg = `unit alias for: ${unit}`;
      }
      IC.log(msg);
      return;
    }

    // check for % being used as modulo
    if (input.match(/\w\s+%\s+\w/) || input.match(/\bMOD[(]/)) {
      IC.log("Modulo (remainder) use: `15 mod 7`");
      return;
    }

    if (input.match(/\w\s+[\^]\s+\w/)) {
      IC.log("Tip: ^ for exponent, `xor` for bitwise XOR");
      return;
    }

    if (input.match(/\w\s+[\&]\s+\w/)) {
      IC.log("Bitwise AND (&): `0x01 and 0x02`");
      return;
    }

    if (input.match(/\w\s+[\|]\s+\w/)) {
      IC.log("Bitwise OR (|): `0x01 or 0x02`");
      return;
    }

    if (input.match(/\w\s+[~]\s+\w/)) {
      IC.log("Bitwise NOT (~)");
      return;
    }

    if (input.includes("=")) {
      // check for starting with keyword
      const keywords = ["and", "or", "not", "xor", "mod", "off", "of", "from", "if", "else"];
      const kwregex = new RegExp("^\\s*(" + keywords.join("|") + ")\\s+(\\w+)", "i");
      let kwmatch = input.match(kwregex);
      if (kwmatch) {
        IC.log(`Variable name starts with keyword '${kwmatch[1]}', use: ${kwmatch[1]}_${kwmatch[2]} = ...`);
        return;
      }
    }

    let fnname = input.trim().toLowerCase().split("(")[0];
    let fn = IC.predefinedFunction(fnname);
    let help = "Usage: ";

    if (fn && fnname.length >= 2) {
      if (CONFIG.FUNCTION_USAGE_MSG[fnname]) {
        help = CONFIG.FUNCTION_USAGE_MSG[fnname];
      }
      else if (fn.includes("array")) {
        help += `${fnname}(r1:r3) or ${fnname}(value1, value2, ...)`;
      } else if (fn.includes("fn().")) {
        let localName = fn.split("fn().")[1];
        let argCount = IC.CALC.fn()[localName].length;

        // build example string from argcount
        let argHelp = argCount === 0 ? '()' :
          argCount === 1 ? '(value)' :
            `(${Array.from({ length: argCount }, (_, i) => `value${i + 1}`).join(', ')})`;

        help += `${fnname}${argHelp}`;
      }
      else {
        help += `${fnname}(value)`;
      }

      IC.log(help);
      return;
    }

    let suggestion = IC.parser.suggestFunction(input);
    let SUGGEST_IGNORE = ["c", "p"];
    if (suggestion && !SUGGEST_IGNORE.includes(suggestion.toLowerCase())) {
      help = "Suggest: " + CONFIG.FUNCTION_USAGE_MSG[suggestion];
      IC.log(help);
      return;
    }
  },

  // returns name of a function similar to the input string, i.e "payment" -> PMT
  suggestFunction(inputStr) {
    let functionList = CONFIG.FUNCTION_USAGE_MSG;

    // Convert input string to lowercase for case-insensitive matching
    const input = inputStr.toLowerCase();

    // Initialize variables to store the closest match
    let closestMatch = "";
    let closestMatchScore = 0;

    // Iterate over the function list and find the closest match
    for (const functionName in functionList) {
      const functionDesc = functionList[functionName].toLowerCase();

      // Calculate the similarity score using a simple matching algorithm
      let score = 0;
      for (const word of input.split(" ")) {
        // ignore single letter words
        if (word.length < 2) {
          continue;
        }

        // ignore symbols
        if (word.match(/^[^a-z0-9]+$/)) {
          continue;
        }

        // ignore row reference
        if (word.match(/^r[0-9]+/i)) {
          continue;
        }

        // skip stop words
        if (CONFIG.STOP_WORDS[word]) {
          continue;
        }

        if (functionDesc.includes(word)) {
          score++;
        }
      }

      // Update the closest match if the current score is higher
      if (score > closestMatchScore) {
        closestMatch = functionName;
        closestMatchScore = score;
      }
    }

    // Return the closest match if there is a match with a non-zero score
    return closestMatchScore >= 2 ? closestMatch : null;
  },

  scanExtraFormatting(input, result, format) {
    if (input.includes("$$")) {
      return "round2";
    }

    return format;
  },

  processIdentifiers: function (input, newIds = {}, assignedIDs = [], dateCache) {

    // Inner function to handle arrow function parameter wrapping
    function wrapFunctionParameters(input, tokens) {
      let arrowFunctionParams = new Set();
      let parametersInParenLists = new Set();

      // First pass: identify parameters that are already in parenthesized lists
      for (let i = 0; i < tokens.length - 1; i++) {
        const currentToken = tokens[i];
        const nextToken = tokens[i + 1];

        // Pattern: ")" "rarrow" for (a, b) =>
        if (currentToken.type === "rp" && nextToken.type === "rarrow") {
          // Walk backwards to find matching "(" and mark parameters as already in parens
          let depth = 1;
          let j = i - 1;
          while (j >= 0 && depth > 0) {
            if (tokens[j].type === "rp") depth++;
            if (tokens[j].type === "lp") depth--;
            if (depth > 0 && tokens[j].type === "id") {
              parametersInParenLists.add(tokens[j].value);
            }
            j--;
          }
        }
      }

      // Second pass: identify all arrow function parameters
      for (let i = 0; i < tokens.length - 1; i++) {
        const currentToken = tokens[i];
        const nextToken = tokens[i + 1];

        // Pattern 1: "id" "rarrow" (x =>)
        if (currentToken.type === "id" && nextToken.type === "rarrow") {
          arrowFunctionParams.add(currentToken.value);
        }

        // Pattern 2: ")" "rarrow" for (a, b) =>
        if (currentToken.type === "rp" && nextToken.type === "rarrow") {
          // Walk backwards to find matching "(" and extract parameters
          let depth = 1;
          let j = i - 1;
          while (j >= 0 && depth > 0) {
            if (tokens[j].type === "rp") depth++;
            if (tokens[j].type === "lp") depth--;
            if (depth > 0 && tokens[j].type === "id") {
              arrowFunctionParams.add(tokens[j].value);
            }
            j--;
          }
        }
      }

      // Only return parameters that are NOT already in parenthesized lists
      // This prevents double-wrapping: (acc, x) should not become ((acc), (x))
      let paramsToWrap = new Set();
      for (let param of arrowFunctionParams) {
        if (!parametersInParenLists.has(param)) {
          paramsToWrap.add(param);
        }
      }

      return paramsToWrap;
    }

    // Get token stream and extract arrow function parameters
    let arrowTokens = IC.parser.tokenize(input, LEXER).filter(t => t.type !== "ws");
    let arrowFunctionParams = wrapFunctionParameters(input, arrowTokens);

    // function params
    let params = {};
    function isDefinedVariable(name) {
      return IC.envIsDefined(name) || params[IC.canonicalName(name)] || IC.envIdentifierExists(name) || arrowFunctionParams.has(name);
    }

    function replaceAllSingleLetterIds(input) {
      // https://stackoverflow.com/questions/35223206/how-to-split-unicode-string-to-characters-in-javascript 

      let graphemes = IC.parser.unescapeUnicode(input).match(/./gu);
      let allLettersAreVariables = graphemes.every((id) => isDefinedVariable(IC.parser.escapeUnicode(id)));

      if (allLettersAreVariables && !isDefinedVariable(input)) {
        return graphemes.map((id) => "(" + IC.parser.escapeUnicode(id) + ")").join("");
      }
      return input;
    }

    function replaceMissingIdentifiers(input) {
      if (IC.typestringIsPossibleUnitIncludingSlash(input) || isDefinedVariable(input) || IC.predefinedFunction(input)) {
        return input;
      }

      // x=1; y=2; xy => (x)(y)
      let processed = replaceAllSingleLetterIds(input);
      return processed;
    }

    function replaceUnitAlias(input) {
      let parts = input.split(" ").map((word) => {
        if (isDefinedVariable(word)) {
          return word;
        }
        let lower = word.toLowerCase();
        return LIB.Unit.alias[lower] || word;
      });
      return parts.join(" ");
    }

    function wrapObjectAccess(input) {
      if (!input.includes(".") || input.startsWith("(")) {
        return input;
      }
      let parts = input.split(/\s+/);
      let objectParts = [];
      let remainingParts = [];
      let foundDot = false;

      for (let part of parts) {
        if (part.includes(".") || foundDot) {
          objectParts.push(part);
          foundDot = true;
        } else if (objectParts.length === 0) {
          objectParts.push(part);
        } else {
          remainingParts.push(part);
        }
      }

      let objectAccess = objectParts.join(" ");
      let dotParts = objectAccess.split(".");
      let firstPart = dotParts[0].trim();
      let canonicalFirstPart = IC.canonicalName(firstPart);

      if (isDefinedVariable(canonicalFirstPart)) {
        let wrappedAccess = "(" + canonicalFirstPart + "." + dotParts.slice(1).join(".") + ")";
        return [wrappedAccess, ...remainingParts].join(" ");
      }

      return input;
    }

    // original input has semicolon to have multiple assignemnts: x = 4; 4x
    const hasSemiColon = input.includes(";");
    function wrapKnownVariables(input) {
      let prefix = IC.parseKnownPrefix(input);
      // leave prefix unwrapped for now: "square root of x", not "square root of (x)"
      if (prefix) {
        return input;
      }

      // split into sections: 2 pi r^2 => 2, pi, r^2
      let parts = input.trim().split(" ");
      let replacements = parts.map((part) => {
        // hack for scenario:
        // net = pv 100k net amount
        // do not wrap second (net) since it's defined in this
        // but we want to allow "x = 3; 4x" => "4(x)"
        if (!hasSemiColon && assignedIDs.filter(id => id.name == part).length >= 1) {
          return part;
        }

        // quick return if the variable is found
        if (part && isDefinedVariable(part)) {
          if (CONFIG.PREDEFINED_AND_UNIT[part.trim().toUpperCase()] || IC.envIsUserFunction(part)) {
            return part;
          } else {
            return "(" + part.trim() + ")";
          }
        }

        // could be r^2  
        if (part.includes("^")) {
          return "(" + part.trim() + ")";
        }

        if (CONFIG.NUMBER_SCALES[part] && !isDefinedVariable(part)) {
          return "(" + CONFIG.NUMBER_SCALES[part] + ")";
        }

        let isVariableName = part.match(/^[a-z_]+$/i) && part?.length > 3;
        if (isVariableName && !IC.envIsDefinedSearchAll(part)) {
          let variant = IC.envFindInflectionVariant(part);
          if (variant) {
            IC.log(`treating '${part}' as ${variant}`);
            return "(" + variant + ")";
          }
        }

        return part;
      });

      let replacement = replacements.join(" ");
      return replacement;
    }

    let allTokens = IC.parser.tokenize(input, LEXER);
    let tokens = allTokens.filter(t => t.type != "ws");

    // for functions
    let inFunctionDeclaration = false;
    let parenDepth = 0;

    let results = tokens.map((t, i) => {

      // Start skipping at 'function' keyword, stop at first '{'
      if (t.type === 'function') {
        inFunctionDeclaration = true;
        params = {};
        return t.text;
      }

      if (inFunctionDeclaration) {
        if (t.type === 'lp') {
          parenDepth++;
        }

        if (t.type === 'id' && parenDepth > 0) {
          params[IC.canonicalName(t.text)] = true;
        }

        if (t.type === 'rp') {
          parenDepth--;
          if (parenDepth === 0) {
            inFunctionDeclaration = false;
          }
        }

        return t.text;
      }

      if (t.type != "id") {
        return t.text;
      }

      let nextToken = tokens[i + 1];
      let name = t.text;
      let canonical = IC.canonicalName(name);
      // in assignment - TODO, use moo rules to set state as id.assign = true
      if (nextToken?.type == "eq") {
        return canonical;
      }

      // if next token is :, we are in object properties, don't wrap
      if (nextToken?.text == ":") {
        return name;
      }

      // if previous token is ".", property access, don't wrap
      let prevToken = tokens[i - 1];
      if (prevToken?.text == ".") {
        return name;
      }

      if (isDefinedVariable(canonical)) {
        name = canonical;
      }

      name = replaceUnitAlias(name);
      name = wrapKnownVariables(name);
      name = wrapObjectAccess(name);
      name = replaceMissingIdentifiers(name);
      return name;
    });

    let processed = IC.parser.tokenSmartJoin(allTokens, results);

    return processed;

    // replace identifiers with underscore versions
    // wrap found identifier references in ()
    // break up single letter ids: xy => (x)(y)
    // everything else must be a unit (found) or plain-english operator (replace) plain-english number (replace)
  },

  // join tokens together, but keep original whitespace
  tokenSmartJoin(allTokens, resultTokens) {
    return allTokens
      .map(token => (token.type === 'ws' ? token.text : resultTokens.shift()))
      .join('');
  },

  // turns "x" into * as needed 
  processXToMultiply(input, identifiersProcessed = false) {
    let processed = input;
    if (!input.match(/x/i)) {
      return processed;
    }

    // \d\.?0 => 30x4, or 30.0x4, but not 0x4 (which is hex)  
    // [1-9] => 31x4 (regular digits)
    // \w\s => 3cm x 4 (word with space), not function like MAX(123, 456)
    // ['")%] => 3'x4 (quote or paren, or pct) - TODO: this stuff is fragile, have a better way to detect x
    processed = processed.replace(/(\d\.?0|[1-9]|\w\s|['")%])\s*x\s*(-?\d|[.(])/ig, "$1 * $2");

    if (identifiersProcessed) {
      processed = processed.replace(/(\)|\d)X(\w+\()/ig, (match, p1, p2) => {
        let funcName = p2.split('(')[0];
        if (IC.predefinedFunction(funcName)) {
          return `${p1} * ${p2}`;
        }
        return match;
      });

      // Handle cases like "3x total sale"
      processed = processed.replace(/(\d+)\s*x\s+(\w+(?:\s+\w+)*)/gi, (match, num, variable) => {
        if (IC.envIsDefined(variable.trim())) {
          return `${num} * (${variable.trim()})`;
        }
        return match;
      });
    }

    if (identifiersProcessed && !IC.envIsDefined('x')) {

      // replace X fn() with * fn()
      let tokens = processed.split(" ");

      // go through tokens. if current token is x, and next token is a function, replace x with *
      for (let i = 0; i < tokens.length - 1; i++) {
        let nextToken = tokens[i + 1];
        let prevToken = tokens[i - 1];
        let cleanedToken = nextToken.split(/[^a-z_]/)[0];

        // if prev token is something to ignore, skip it

        if (tokens[i].toLowerCase() == "x") {

          // function foo(x){ x as in} || the x should not be a mult
          if (!prevToken?.match(/(\w|[)])$/)) {
            continue;
          }

          // Look ahead to see if any combination of the next tokens forms a defined variable
          let variableName = '';
          for (let j = i + 1; j < tokens.length; j++) {
            variableName = tokens.slice(i + 1, j + 1).join(' ').trim();
            if (IC.envIsDefinedSearchAll(variableName)) {
              tokens[i] = '*';
              break;
            }
          }

          if (IC.envIsDefinedSearchAll(cleanedToken)) {
            tokens[i] = "*";
          }

          let isPlainEnglishNumber = IC.parser.processPlainEnglishNumbers(cleanedToken) !== cleanedToken;
          if (isPlainEnglishNumber) {
            tokens[i] = "*";
          }
        }
      };
      processed = tokens.join(" ");
    }

    if (processed != input && IC.envIsDefined('x')) {
      IC.log(`using 'x' as multplication (not variable)`);
    }

    return processed;
  },

  // sin^2(45) => sin(45)^2
  processFunctionWithExponent(input) {

    if (!input.match(/\w\w\^\d[(]/)) {
      return input;
    }

    if (!CONFIG.FUNCTION_WTIH_EXPONENT) {
      const trigFunctions = new Set(['sin', 'cos', 'tan', 'csc', 'sec', 'cot', 'sinh', 'cosh', 'tanh', 'csch', 'sech', 'coth']);
      const logFunctions = new Set(['log', 'ln']);
      CONFIG.FUNCTION_WTIH_EXPONENT = new Set([...trigFunctions, ...logFunctions]);
    }

    // Tokenize the input -- get cloned array
    let tokens = IC.parser.tokenize(input, LEXER).slice();

    for (let i = 0; i < tokens.length - 4; i++) {
      if (CONFIG.FUNCTION_WTIH_EXPONENT.has(tokens[i].value) && tokens[i + 1].value === '^' && tokens[i + 2].type === 'decimal' && tokens[i + 3].value === '(') {
        // Find the closing parenthesis
        let depth = 1;
        let j = i + 4;
        let lastParenIndex = j;

        while (j < tokens.length && depth > 0) {
          if (tokens[j].value === '(') depth++;
          if (tokens[j].value === ')') depth--;
          lastParenIndex = j;
          j++;
        }

        if (depth === 0) {
          let fn = tokens[i];
          let carat = tokens[i + 1];
          let power = tokens[i + 2];
          let startParen = tokens[i + 3];
          let endParen = tokens[lastParenIndex];

          // Remove the power and its preceding caret
          tokens.splice(i + 1, 2);

          // Insert the power and caret after the closing parenthesis
          tokens.splice(lastParenIndex - 1, 0, carat, power);

          // Note: we do NOT advance to the last token, we allow inner arguments to be processed also,
          // for example: sin^2(cos^2(45)) => sin(cos(45)^2)^2 
        }
      }
    }

    return tokens.map(t => t.text).join("");
  },

  processUnitTypeBeforeNumber(input) {
    // test for letter followed by space and number or .
    if (!input.match(/\w\s+[0-9.,]/)) {
      return input;
    }

    // Tokenize the input
    let tokens = IC.parser.tokenize(input, LEXER).slice();

    // deep clone tokens array since we're modifying it
    tokens = JSON.parse(JSON.stringify(tokens));

    for (let i = 0; i < tokens.length; i++) {
      if (tokens[i].type === 'id') {
        // Split the token value into parts
        const parts = tokens[i].value.split(/\s+/);
        let possibleUnit = parts[0];
        let rest_of_token = parts.slice(1).join(' ');

        // see how many of the next tokens can be added to rest of string;
        let rest_of_string = rest_of_token;
        let possibleNumber = rest_of_string;
        let tokensUsed = 0;

        // Build the number string, including commas
        for (let j = i + 1; j < tokens.length; j++) {
          if (tokens[j].value === ',' && (j + 1 < tokens.length && tokens[j + 1].value.trim() === '')) {
            // Stop if we encounter a comma followed by a space or end of input
            break;
          }
          rest_of_string += tokens[j].value;
          if (IC.isNumberStringIncludingScaleSuffix(rest_of_string.replace(/,/g, ''))) {
            possibleNumber = rest_of_string;
            tokensUsed++;
          } else {
            break;
          }
        }

        if ((IC.stringIsCurrencyUnit(possibleUnit) || ICUnit.isPredefinedUnitCaseInsensitive(possibleUnit)) && IC.isNumberStringIncludingScaleSuffix(possibleNumber.replace(/,/g, ''))) {
          // Swap the currency unit and the number, ensuring a space between them
          tokens[i].value = possibleNumber + ' ' + possibleUnit;
          tokens[i].text = possibleNumber + ' ' + possibleUnit;

          // clear out the used tokens
          for (let j = 1; j <= tokensUsed; j++) {
            tokens[i + j].value = "";
            tokens[i + j].text = "";
          }
        }
      }
    }

    // Filter out empty tokens and join the remaining ones
    let ret = tokens.filter(t => t.text !== "").map(t => t.text).join("");
    return ret;
  },

  // 800 miles 3 feet 6 inches gets implicitly added
  processChainOfAddedUnits(input) {
    if (!input?.match(/\w\s+[0-9.,]/)) {
      return input;
    }

    // Tokenize the input
    let allTokens = IC.parser.tokenize(input, LEXER).slice();
    let tokens = allTokens.filter(t => t.type != "ws");

    tokens.forEach((t, index) => {
      if (t.type === 'id' && tokens[index - 1]?.type == 'decimal') {
        // insert a space between a number and a unit
        let val = t.value.replace(/([0-9])([a-zA-Z])/, "$1 $2");
        const parts = val.split(/\s+/);

        let newValue = "";
        let i = 0;

        let hasChain = false;

        while (i < parts.length) {
          let thisUnit = parts[i];
          let nextNumber = parts[i + 1];

          if (i + 1 < parts.length && IC.isNumberString(nextNumber) && ICUnit.isPredefinedUnitCaseInsensitive(thisUnit)) {
            newValue += " " + thisUnit + " + " + nextNumber;
            hasChain = true;
            i += 2;
          } else if (ICUnit.isPredefinedUnitCaseInsensitive(thisUnit)) {
            // Handle the last unit without a following number
            newValue += " " + thisUnit;
            i++;
          } else {
            newValue = ""; // Pattern broken, clear the newValue
            break;
          }
        }

        // add "(" to previious toknen, append ")" to this one
        if (hasChain) {
          let prevToken = tokens[index - 1];
          prevToken.value = prevToken.text = "(" + prevToken.text;
          newValue += ")";
        }

        if (newValue.trim().length > 0) {
          t.value = newValue.trim();
          t.text = newValue.trim();
        }
      }
    });

    return IC.parser.tokenSmartJoin(allTokens, tokens);
  },

  // gb-month to (gb month), kg*m/s^2 to (kg m/s^2), m^2*(kg*s)^-3*A^-2" 
  processDashUnitSeparator: function (input) {
    if (!input.includes("-") && !input.includes("*")) {
      return input;
    }

    // Tokenize the input
    let allTokens = IC.parser.tokenize(input, LEXER);
    let tokens = allTokens.filter(t => t.type != "ws");
    let unitSeparator = /^[*-]$/;

    // Process the tokens
    tokens.forEach((t, index) => {
      let separatorToken = tokens[index + 1];
      let nextUnitToken = tokens[index + 2];

      if (separatorToken?.value == "^") {
        // check for minus sign as next token: kg^-1*m => kg^-1 m
        if (nextUnitToken?.value == "-") {
          separatorToken = tokens[index + 4];
          nextUnitToken = tokens[index + 5];
        }
        else {
          separatorToken = tokens[index + 3];
          nextUnitToken = tokens[index + 4];
        }
      }

      // kg*m -> kg m, 10 watt-hour in joules => 10 watt hour in joules [hour_in_joules is a full id]
      if (t.type === 'id' && unitSeparator.test(separatorToken?.value) && IC.predefinedUnit(t.value) && IC.predefinedUnit(nextUnitToken?.value?.split(" ")[0])) {
        separatorToken.value = separatorToken.text = " ";
        //IC.log(`unit: ${tokens[index].text}*${tokens[index + 2].text}`);
      }
    });

    // Join the tokens back into a string
    return IC.parser.tokenSmartJoin(allTokens, tokens);

  },

  // replace "\symbol": \alpha => α
  processSymbols: function (str) {
    if (!str || !str.includes("\\")) {
      return str;
    }

    let processed = str;
    let foundSymbol = false;
    processed = str.replace(/[\\]+(\S+)\s?/gi, function (s, word) {
      // escape sequence: \\
      if (s.match(/[\\][\\]/)) {
        return s;
      }

      let sym = CONFIG.SYMBOLS[word];

      // single letter needs space
      if (sym) {
        foundSymbol = true;
        if (s.endsWith(" ")) {
          return sym;
        }
        IC.log(`press space to replace with ${sym}`);
      }

      // IC.log(`symbol \\${word} not defined`);
      return s;
    });

    // no replacement, but has \
    if (!foundSymbol && str == processed) {
      IC.log(`type symbol shortcut like \\pi (π) \\2 (²) \\Delta (Δ)...`);
    }

    return processed;
  },

  // invest 500/month for 10 years at 5% => invest(500/month, 10, 5)
  processPlainEnglishFunctions: function (input) {
    if (!input.includes("%")) {
      return input;
    }

    const config = {
      functionKeywords: {
        interest: ['total interest', 'interest'],
        totalpayment: ['total payment', 'total repayment', 'total paid', 'total cost', 'total mortgage cost', 'full cost', 'cost'],
        loan: ['loan', 'mortgage', 'pay', 'payment', 'repayment', 'borrow', 'finance', 'lend', 'debt'],
        savingsgoal: ['monthly savings', 'savings', 'save monthly', 'save up', 'save to reach', 'save to have'],
        invest: ['invest', 'invested', 'save', 'saved', 'deposit', 'future value'],
        presentvalue: ['present value', 'current value'],
      },

      extraStopWords: ['total'],
      percentageRegex: /\d+\s*%/,
      numberRegex: /^-?[\d.]+/,
      stopWords: CONFIG.FN_REMOVE_STOP_WORDS
    };

    function matchesKeywords(input) {
      const keywords = Object.values(config.functionKeywords).flat();
      const regex = new RegExp(`\\b(${keywords.join('|')})\\b`, 'i');
      return input.match(regex);
    }

    function removeNonUnitWords(input) {
      const words = input.split(/\s+/);

      // find all words ([a-z]+) and test them to be a predefinedUnit
      let filtered = words.filter(word => {
        if (word.match(/^[a-zA-Z]+$/) && !IC.predefinedUnit(word)) {
          return "";
        }
        return word;
      });

      return filtered.join(' ');
    }

    function removeFunctionKeywords(input) {
      const keywords = Object.values(config.functionKeywords).flat();
      let removeList = [...keywords, ...config.extraStopWords];
      const regex = new RegExp(`\\b(${removeList.join('|')})\\b`, 'gi');
      return input.replace(regex, '');
    }

    function isExistingFunctionCall(input) {
      const matches = input.match(/(\w+)[(]/);
      return matches && IC.predefinedFunction(matches[1]);
    }

    function turnIntoFunction(input) {
      const tokens = input.split(/\s+/);

      // Get the keys in the correct order
      const keys = Object.keys(config.functionKeywords);

      for (const token of tokens) {
        for (const fnName of keys) {
          const keywords = config.functionKeywords[fnName];
          for (const keyword of keywords) {
            if (keyword === token.toLowerCase() || input.toLowerCase().startsWith(keyword.toLowerCase())) {
              input = input.replace(new RegExp(`\\b${keyword}\\b`, 'gi'), '');
              input = config.stopWords(input);
              input = removeFunctionKeywords(input);
              input = removeNonUnitWords(input);
              return `${fnName} ${input}`;
            }
          }
        }
      }

      return input;
    }

    function separateParameters(str) {
      let words = str.split(/\s+/);
      const functionName = words[0];
      let params = [];
      let currentParam = [];
      let inCurrencyAmount = false;

      // for simplicity, remove currencies from the list of words
      words = words.filter(w => {
        let possibleCurrency = w.replace(/[(_)]/g, "");
        if (IC.stringIsCurrencyUnit(possibleCurrency)) {
          return false;
        }
        return true;
      })

      for (let i = 1; i < words.length; i++) {
        const word = words[i];
        const nextWord = words[i + 1];

        if (config.numberRegex.test(word) || word.endsWith('%')) {
          if (currentParam.length > 0) {
            params.push(currentParam.join(' '));
            currentParam = [];
          }
        }

        currentParam.push(word);

        if (i === words.length - 1 ||
          (nextWord && (config.numberRegex.test(nextWord) || nextWord.endsWith('%')))) {
          params.push(currentParam.join(' '));
          currentParam = [];
        }
      }

      return { functionName, params };
    }

    function processInput(input) {
      let cleaned = config.stopWords(input);
      let turnedIntoFunction = turnIntoFunction(cleaned);
      let { functionName, params } = separateParameters(turnedIntoFunction);
      if (Object.keys(config.functionKeywords).includes(functionName) && params.length > 1) {
        return `${functionName}(${params.join(', ')})`;
      }
      return input;
    }

    if (!matchesKeywords(input) || isExistingFunctionCall(input)) {
      return input;
    }

    // Split the input by ';' first, then by '=' and process each part
    let processed = input.split(';').map(statement => {
      let parts = statement.split('=').map(part => part.trim());
      let processed = parts.map(processInput);
      return processed.join(' = ');
    }).join('; ');

    return processed;
  },

  processPlainEnglishNumbers: function (input) {

    // returns a list of tokens (ID vs non)
    function getIDTokensSimple(str) {
      return str.split(/([a-zA-Z0-9 _\.\,]+)/);
    }

    let tokens = getIDTokensSimple(input);

    // see which items can be parsed as written numbers
    let replacements = tokens.map(t => {
      if (!t || IC.envIsVariableDefined(t)) {
        return t;
      }

      let key = "plainEnglishNumber:" + t;
      let cachedValue = IC.CACHE.get(key);
      if (!cachedValue) {
        cachedValue = t;

        let parseResult = IC.parseWrittenNumber(t);
        if (parseResult != null) {
          let typeStr = IC.hasType(parseResult) ? " " + IC.typestring(parseResult.t) : "";
          cachedValue = IC.val(parseResult).toString() + typeStr;
        }
        IC.CACHE.set(key, cachedValue);
      }
      return cachedValue;
    });

    // not real tokens, simple join
    let processed = replacements.join('');
    return processed;
  },

  processPlainEnglishOp: function (input, newIDs = {}, env = {}) {
    // replace all items, since we're keeping track of the cursor
    const newIDsSet = new Set(Object.keys(newIDs));
    IC._plainEnglishOpRegexCache ||= {};

    const matches = CONFIG.PLAIN_ENGLISH_OPS_TRIE.search(input.toLowerCase());

    // order matches by length
    matches.sort((a, b) => b.length - a.length);

    matches.forEach((key) => {
      if (newIDsSet.has(key) || IC.envIsDefined(key)) {
        return;
      }

      if (!IC._plainEnglishOpRegexCache[key]) {
        IC._plainEnglishOpRegexCache[key] = new RegExp(`(^|\\s|\\b)(${key})(\\s+|[(])`, "gi");
      }

      const regex = IC._plainEnglishOpRegexCache[key];
      const match = input.match(regex);

      // also, make sure it's not a paren expression: (plus) or part of a variable _
      if (match && input[match.index + 1] !== ")") {
        input = input.replace(regex, (match, prefix, op, suffix) => {
          // Ensure it's not part of a variable name or a parenthesized expression
          if (prefix.endsWith('_') || (prefix.endsWith('(') && suffix === ')')) {
            return match;
          }

          // if we have a (, and it's a real function, don't replace 
          if (suffix === '(' && IC.predefinedFunction(op)) {
            return match;
          }

          return `${prefix}${CONFIG.PLAIN_ENGLISH_OPS[key]}${suffix}`;
        });

        // input = input.replace(regex, " " + CONFIG.PLAIN_ENGLISH_OPS[key] + " ");
      }
    });

    return input;
  },

  formatTypestring(result) {

    // hide type for certain formats
    if (IC.hasNoType(result) || IC.format(result) == "tape" || IC.format(result)?.startsWith("time_")) {
      return "";
    }

    // map negative powers in result to singular
    let newTypes = Object.fromEntries(
      Object.entries(result.t).map(([key, val]) => {
        // negative power
        if (val < 0 && IC.stringIsValidSingularUnit(key)) {
          // words like brass: brass => brasses => brass

          let baseName = IC.stringSingularize(key);
          return [baseName, val];
        }

        return [key, val];
      })
    );

    let typestring = IC.typestring(newTypes, true);

    // convert 3-digit currency code to uppercase
    if (typestring.length == 3 && LIB.InstaCalc.Unit?.currencies[typestring.toLowerCase()]) {
      typestring = typestring.toUpperCase();
    }

    // single unit: 1/s should be "per s"
    if (typestring.includes("1/")) {
      typestring = typestring.replace("1/", "/ ").trim();

      // 1 / kg s should just be / kg s
      if (!Object.keys(newTypes).every(IC.predefinedUnit)) {

        // make custom type singular
        let unitName = typestring.split("/")[1];
        // / eggs => "per egg" but "/ 2 weeks" stays as "per 2 weeks"
        if (!IC.predefinedUnit(unitName) && IC.stringIsValidSingularUnit(unitName)) {
          let baseName = IC.stringSingularize(unitName);
          typestring = typestring.replace(unitName, baseName);
        }
      }
    }

    typestring = IC.parser.typestringPluralize(typestring);
    typestring = IC.parser.typestringPrettyPrint(typestring);
    typestring = IC.parser.unescapeUnicode(typestring);

    return typestring;
  },

  typestringPluralize(typestring = "") {
    let typeObj = ICUnit.getUnit(typestring);

    // "dime" => dimes but not USD => USDs
    if (typeObj?.name == "currency" && typestring.length > 3) {
      return IC.stringPluralize(typestring);
    }

    let plural = IC.stringPluralize(typestring);

    if (typeObj?.name == "time" && typestring.length >= 3 && ICUnit.getUnit(plural) === typeObj) {
      // units larger than 1 hour get pluralized
      return ICUnit.getUnitScale(typestring) > 3600 ? plural : typestring;
    }

    return typestring;
  },

  typestringPrettyPrint(typestring) {
    let replacement = typestring.replace(/\^([2-9])\b/g, (match, exponent) => {
      const superscripts = {
        '2': '²',
        '3': '³',
        '4': '⁴',
        '5': '⁵',
        '6': '⁶',
        '7': '⁷',
        '8': '⁸',
        '9': '⁹',
      };
      return superscripts[exponent] || match;
    });
    return replacement;
  },

  formatNumber: function (n, format) {
    if (typeof n !== "number" || !format) {
      return n;
    }

    // allow local rounding to override default rounding
    if (format == "round2") {
      let locale = IC.envGetSettings().locale || "en-US";
      let nf = new Intl.NumberFormat(locale, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
      });
      let displayString = nf.format(n);
      return displayString;
    }

    return n;
  },

  formatAsTime(result, format) {
    return ICTime.buildTimeString(IC.val(result), format);
  },

  formatAsTapeMeasure(obj, silent = false) {
    IC.logPause();
    let totalInches = IC.val(IC.ICObjectConvertToType(obj, "inches")).toPrecision(10);  // 13.5 inches
    IC.logResume();

    /*
    let feetQty = Math.floor(totalInches / 12); // 1 foot
    let inchesRemainder = totalInches - 12 * feetQty; // 1.5 inches left
    let inchesQty = Math.floor(inchesRemainder);
    let inchFraction = inchesRemainder - inchesQty;
    */

    if (isNaN(totalInches)) {
      // Handle cases where conversion might fail or result is NaN
      if (!silent) IC.log('warning: tape measure conversion resulted in NaN');
      return String(obj.v); // Or return a default error string
    }

    const isNegative = totalInches < 0;
    const absTotalInches = Math.abs(totalInches); // Work with the absolute value

    // Now calculations are done on the positive absolute value
    let feetQty = Math.floor(absTotalInches / 12);       // e.g., 3.937 / 12 = 0.328 => 0 feet
    let inchesRemainder = absTotalInches - 12 * feetQty; // e.g., 3.937 - 0 = 3.937 inches left
    let inchesQty = Math.floor(inchesRemainder);         // e.g., floor(3.937) => 3 inches
    let inchFraction = inchesRemainder - inchesQty;      // e.g., 3.937 - 3 = 0.937 fraction

    const epsilon = 1e-9; // Small threshold for floating point comparisons
    let [n, d] = IC.mathToFraction(inchFraction);

    // bit twiddling: https://stackoverflow.com/questions/30924280/what-is-the-best-way-to-determine-if-a-given-number-is-a-power-of-two 
    function isPowerOf2(x) {
      return ((x != 0) && !(x & (x - 1)));
    }

    // Compute nearest lower power of 2 for n in [1, 2**31-1]:
    function nearestPowerOf2(n) {
      return 1 << 31 - Math.clz32(n);
    }

    // not power of 2...
    if (!isPowerOf2(d)) {
      let denom = nearestPowerOf2(d);
      denom *= 2;

      if (denom > 64) {
        denom = 64;
      }

      [n, d] = IC.mathToFraction(inchFraction, denom);
      [n, d] = IC.mathReduceFraction(n, d);

      if (!silent) {
        if (n == 0) {
          IC.log(`small decimal: treated as zero`);
        } else if (Math.abs((n / d) - inchFraction) < 1e-6) {
          IC.log(`inexact fraction: 1/1000 inch (mil)`);
        }
      }
    }

    let str = "";
    if (feetQty) {
      str += `${feetQty}' `
    }
    if (inchesQty) {
      str += `${inchesQty}`;
    }

    if (inchFraction) {
      str += ` FRACTION{${n},${d}}`;
    }
    if (inchesQty || inchFraction) {
      str += `"`;
    }

    if (str == "" && inchesQty == 0 && feetQty == 0) {
      str = `0"`;
    }

    if (isNegative && absTotalInches >= epsilon) {
      str = "-" + str.trim();
    } else {
      str = str.trim();
    }

    return str.trim();
  },

  formatAsScientific(val) {
    // return Number(val).toExponential().replace("e+", "e");
    const num = Number(val);
    const exp = num.toExponential().replace("e+", "e");
    return exp.includes('.') && exp.split('.')[1].split('e')[0].length > 8
      ? num.toExponential(8).replace("e+", "e")
      : exp;
  },

  formatAsEngineering(val) {
    if (val === 0) return "0";
    let magnitude = Math.floor(Math.log10(Math.abs(val)) / 3) * 3;
    let mantissa = val / Math.pow(10, magnitude);
    // Use toFixed(9) to get up to 9 decimal points and parseFloat to remove trailing zeros
    return parseFloat(mantissa.toFixed(9)) + 'e' + magnitude;
  },

  isScaleableResult(result) {
    if (!result || IC.hasNoType(result) || Object.keys(result.t).length > 1) {
      return false;
    }

    const typestring = IC.typestring(result.t);
    if (!ICUnit.isSIUnit(typestring)) {
      return false;
    }

    let val = IC.val(result);
    const inNumberRange = (Math.abs(val) >= 1e3 || Math.abs(val) <= 1e-3);
    // above the limit for scaling
    const limits = {
      s: 1.0,
    };

    if (IC.typestringIsSameUnitCategory("s", typestring)) {
      val = IC.val(IC.ICObjectConvertToType(result, "s"));
    }

    if (limits[typestring] && Math.abs(val) >= limits[typestring]) {
      return false;
    }

    return inNumberRange && ICUnit.isSIUnit(typestring);
  },

  formatAsScaledUnit(result) {
    let scaled = ICUnit.scaleToBestUnit(result);
    let number = IC.parser.toFixedIfNecessary(IC.val(scaled), 2);
    let typestring = IC.typestring(scaled.t);
    return `${number} ${typestring}`;
  },

  formatAsFinance(val) {
    if (typeof val !== "number") {
      return val;
    }

    const scales = new Map([
      [1.0e+12, 'T'],
      [1.0e+9, 'B'],
      [1.0e+6, 'M'],
      [1.0e+3, 'K']
    ]);

    for (let [scale, suffix] of scales) {
      if (Math.abs(val) >= scale) {
        let scaled = IC.parser.toFixedIfNecessary(val / scale, 1);
        return scaled + suffix;
      }
    }

    return val.toFixed(2);
  },

  formatAsRomanNumeral(val) {
    const n = Math.round(Number(val));
    if (isNaN(n) || n < 1 || n > 3999999 /* Vinculum */) {
      IC.log(`no Roman numeral for: ${val}`);
      return null;
    }
    return ICLib.decimalToRoman(n);
  },

  formatAsWattHour(result) {
    let msg = "";

    // display kWh 
    let joule = IC.val(result);
    let Wh = joule / 3600;
    let kWh = Wh / 1000;
    let MWh = kWh / 1000;
    let GWh = MWh / 1000;
    let TWh = GWh / 1000;

    // if small, display as Wh
    if (Math.abs(Wh) < 1000) {
      msg = IC.parser.toFixedIfNecessary(Wh, 4) + " Wh";
    }
    else if (Math.abs(kWh) < 1000) {
      msg = IC.parser.toFixedIfNecessary(kWh, 4) + " kWh";
    } else if (Math.abs(MWh) < 1000) {
      msg = IC.parser.toFixedIfNecessary(MWh, 4) + " MWh";
    } else if (Math.abs(GWh) < 1000) {
      msg = IC.parser.toFixedIfNecessary(GWh, 4) + " GWh";
    } else {
      msg = IC.parser.toFixedIfNecessary(TWh, 4) + " TWh";
    }

    return msg;
  },

  formatResultAsSingleLine(result) {
    let formatted = IC.parser.formatResult(result);
    let typestring = IC.typestring(result?.t);
    return formatted + (typestring ? " " + typestring : "");
  },

  formatResult(result, settings = {}, rowFormat) {
    let val = IC.val(result);
    let format = IC.format(result);

    // no format required for complex numbers
    if (format == "phasor") {
      // it has been wrapped
      return LIB.Complex.toPhasorString(IC.val(result));
    }

    if (LIB.Complex.isComplex(result) && !format) {
      return LIB.Complex.toString(result);
    }

    if (!format || !IC.isValidEvalResult(result)) {
      return val;
    }

    if (format === "percent") {
      val = Number(val);
      if (Math.abs(val) < 1e-6) {
        return val.toLocaleString(settings.locale || 'en-US', { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 14 });
      } else {
        return val.toLocaleString(settings.locale || 'en-US', { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 4 });
      }
    }

    if (format === "hex" || format === "oct" || format === "bin") {
      // @ts-ignore
      return IC.CALC.fn[format](val);
    }

    if (format === "tape") {
      if (IC.typestringIsSameUnitCategory("ft", IC.typestring(result.t))) {
        return IC.parser.formatAsTapeMeasure(result);
      } else {
        // not length unit; clear tape format
        IC.ICObjectSetFormat(result, "");
      }
    }

    if (format.startsWith("datetime_")) {
      return ICDate.toString(result);
    }

    if (format.startsWith("time_")) {
      if (IC.typestringIsSameUnitCategory("s", IC.typestring(result.t))) {
        return IC.parser.formatAsTime(result, format);
      } else {
        // not time unit; clear time format
        IC.ICObjectSetFormat(result, "");
      }
    }

    if (format === "scientific") {
      return IC.parser.formatAsScientific(val);
    }

    if (format === "engineering") {
      return IC.parser.formatAsEngineering(val);
    }

    if (format === "finance") {
      // for currency formatting
      let currencyPrefix = rowFormat?.symbol ?? "";
      let typestring = IC.typestring(result?.t);

      // $50M USD => $50M (no USD)
      if (result?.t) {
        Object.keys(result.t).forEach((key) => {
          if (IC.typeIsCurrency(key)) {
            // delete this key if we already have the currency?
            delete result.t[key];
          }
        });
      }

      return currencyPrefix + IC.parser.formatAsFinance(val);
    }

    if (format === "roman") {
      return IC.parser.formatAsRomanNumeral(val);
    }

    return val;
  },

  getOutputMessage(ret, result, input) {
    let msg = "";
    let processed = ret.processed;

    let isNumber = typeof ret.eval_result === "number" && !isNaN(ret.eval_result);

    let converted = false;
    let showFraction = true;

    if (LIB.Complex.isComplex(ret.eval_result)) {
      return "as phasor: " + LIB.Complex.toPhasorString(ret.eval_result);
    }

    // have empty message if we have a custom object
    if (IC.isCustomObject(result)) {
      return "";
    }

    if (processed.trim() != input.trim()) {
      msg += processed;
    }

    let val = IC.val(result);
    if (!IC.isValidEvalResult(val)) {
      return msg;
    }

    let typestring = IC.typestring(result?.t);
    let format = IC.format(result);
    if (format) {
      showFraction = false;
      if (format == "hex" || format == "bin" || format == "oct") {
        msg = " as decimal: " + IC.val(result);
        converted = true;
      }

      if (format == "bin") {
        // @ts-ignore
        msg += " | as hex: " + IC.CALC.fn.hex(IC.val(result));
      }

      if (format == "hex") {
        // @ts-ignore
        msg += " | as binary: " + IC.CALC.fn.bin(IC.val(result));
      }
    }

    // joule check. TODO: add energy unit check
    if (isNumber && format != "tape" && typestring.match(/(j)/i) && IC.typestringIsSameUnitCategory("joule", typestring.toLowerCase())) {
      msg += " = " + IC.parser.formatAsWattHour(result);
    }

    if (IC.parser.isScaleableResult(result)) {
      msg += " | as scaled: " + IC.parser.formatAsScaledUnit(result);
    }

    if (typeof ret.final_result === "string" && isNumber) {
      let typestringRaw = "";
      if (IC.hasType(result)) {
        typestringRaw = " " + typestring;
      }

      let retNumber = IC.makeNumber(ret.final_result, IC.envGetSettings());
      let isDifferentNumber = ret.final_result.match(/[a-z]/i) || (retNumber && Math.abs(ret.eval_result - retNumber) > 1e-10);

      // TODO: what about rounding and precision?
      if (!converted && isDifferentNumber) {
        msg += " = " + IC.parser.toFixedIfNecessary(ret.eval_result, 8) + typestringRaw;
      }

      // .125 feet/dollar gets shown as 8 dollars/foot
      if (val !== 0 && Math.abs(val) < 1 && typestringRaw.includes("/")) {
        let inverse = IC.mathInverse(result);
        let inverseVal = IC.val(inverse);
        let inverseTypeString = IC.parser.formatTypestring(inverse);
        msg += " = " + IC.parser.toFixedIfNecessary(inverseVal, 2) + " " + inverseTypeString;
      }
    }

    // tape measure check
    if (isNumber && format != "tape" && IC.hasType(result) && (IC.typestringIsSameUnitAndScale(IC.typestring(result.t), "inch")
      || IC.typestringIsSameUnitAndScale(IC.typestring(result.t), "foot"))) {
      let tapeMeasure = IC.parser.formatAsTapeMeasure(result, true);
      let simpleTapeMeasure = tapeMeasure.replace(/FRACTION{(\d+)[,]\s*(\d+)}/, (match, n, d) => {
        return `${n}/${d}`;
      });

      // 0/1" is not something to return
      if (!simpleTapeMeasure.includes(" 0/")) {
        msg += " | as tape measure: " + simpleTapeMeasure;
      }
    }

    // fraction check
    if (showFraction && isNumber) {
      let fracMatch = input.match(/\d[/]\d/gi);
      if (fracMatch && fracMatch.length > 1) {
        msg += " | as fraction: " + CONFIG.POSTCONVERT_FUNCTIONS.fraction(ret.eval_result);
      }
    }

    // time check
    if (isNumber && IC.hasType(result) && IC.typestringIsSameUnitCategory(IC.typestring(result.t), "second")) {
      let time = CONFIG.UNIT_AWARE_FUNCTIONS["TIME"](result);
      if (time) {
        msg += " | as time: " + time;
      }
    }

    // currency conversion to USD
    if (isNumber && IC.hasType(result) && ICUnit.isCurrency(IC.typestring(result.t)) && !processed.includes("->")) {
      const currencies = ['USD', 'EUR'];
      currencies.forEach(currency => {
        const conversionResult = IC.semanticConvert(result, currency);
        if (IC.isValidEvalResult(conversionResult) && currency != IC.typestring(result.t).toUpperCase()) {
          msg += ` | in ${currency} = ${ICLib.roundToDecimal(IC.val(conversionResult), 2)}`;
        }
      });
    }

    // remove leading " | "
    msg = msg.replace(/^\s*\|\s*/, "");

    return msg;
  },

  getResultCacheKey: function (input, env, settings, rowIndex = null) {
    // Use explicitly passed row index, or fall back to current row index
    const actualRowIndex = rowIndex !== null ? rowIndex : IC.envGetRowIndex();
    return JSON.stringify({ row: actualRowIndex, input: input, env: env, unit: LIB.InstaCalc.Unit._updated, settings: settings });
  },

  getResultCache: function ({ input, startEnv, settings, rowIndex = null }) {
    IC.parser.RESULT_CACHE ||= new LRUCache(10000);

    function hasMissingReferences(references) {
      return references.some((x) => !IC.envIsDefined(x));
    }

    // breaks the cache
    function isVolatile(input) {
      return input.match(/\brand|\bnow\b/i);
    }

    // check cache
    let quickKey = IC.parser.getResultCacheKey(input, startEnv, settings, rowIndex);
    let quickVal = IC.parser.RESULT_CACHE.get(quickKey);
    if (quickVal && !isVolatile(input) && !hasMissingReferences(quickVal.result.missing_references)) // using r13 when it's not defined yet; use normal process
    {
      IC.envSet({ ...startEnv, ...quickVal.changedEnv });
      return quickVal.result;
    }

    return null;
  },

  setResultCache: function ({ input, startEnv, settings, ret, rowIndex = null }) {
    let changedEnv = {};
    Object.entries(IC.envGet()).forEach(([key, value]) => {
      // only store helpful changes, where variables get defined
      if (JSON.stringify(value) != JSON.stringify(startEnv[key]) && value != null) {
        changedEnv[key] = value;
      }
    });

    IC.parser.RESULT_CACHE.set(IC.parser.getResultCacheKey(input, startEnv, settings, rowIndex), {
      result: ret,
      changedEnv: changedEnv,
      references: ret.references,
    });
  },

  /*
    Some grammar decisions are best handled in code (sensitive to neighboring tokens, variables defined in environment, etc.)
    */
  phasePreprocess: function ({ input, i, settings, startEnv }) {
    // --- Initial State & Logging ---
    let state = { processed: input, comment: "", title: "", format: null, strings: {}, identifiers: [], allAssignedIDs: [], tokens: [] };
    const process_debug = [["00_input", state.processed]]; // Start debug log
    let stepCounter = 0;

    // --- Inner Step Execution Function ---
    /**
     * Executes a processing step, updates state, logs, and times.
     * @param {string} description - Descriptive name for logging.
     * @param {Function} stepFunction - Receives current 'state', returns changes or new 'processed' string.
     * @param {Function | null} [resultFormatter=null] - Optional formatter for logged result.
     */
    const doStep = (description, stepFunction, resultFormatter = null) => {
      stepCounter++;
      const stepName = `${String(stepCounter).padStart(2, '0')}_${description}`;

      PerfLog.start(stepName);
      const resultChanges = stepFunction(state); // Pass current state
      PerfLog.end(stepName, process_debug);

      let logValue = resultChanges; // Default log value

      // --- Update State ---
      if (typeof resultChanges === 'string') {
        state.processed = resultChanges; // Update only 'processed'
        logValue = resultChanges;
      } else if (typeof resultChanges === 'object' && resultChanges !== null) {
        logValue = resultChanges.logValue !== undefined ? resultChanges.logValue : resultChanges;
        Object.assign(state, resultChanges); // Merge changes into state
        delete state.logValue; // Don't keep logValue in state
      }
      // If null/undefined return, assume side effects updated state where needed

      // --- Log Result ---
      const formattedLogValue = resultFormatter ? resultFormatter(logValue) : logValue;
      process_debug.push([stepName, formattedLogValue]);
    };

    // --- Define and Run Pipeline Steps ---
    PerfLog.start("phasePreprocess"); // Time the overall phase

    // Process Comment
    doStep('processComment',
      (s) => IC.parser.processComment(s.processed), // Operate on state.processed
      (result) => {
        // This step needs to update multiple state parts and env
        state.processed = result.processed;
        state.comment = result.comment;
        IC.envSetRowComment(result.comment);
        return result.processed; // Format log to show only processed string
      }
    );

    // L1 Regex
    doStep('processRegexReplacements(L1)', (s) => IC.parser.processRegexReplacements(s.processed, CONFIG.L1_REPLACEMENTS_REGEX));

    // Currency & Strings
    doStep('processCurrencySymbolsAndStrings',
      (s) => IC.parser.processCurrencySymbolsAndStrings(s.processed),
      (result) => {
        // Update multiple state parts and env
        state.processed = result.processed;
        state.format = result.format;
        state.strings = result.strings;
        IC.envSetFormatter(result.format);
        IC.envSetStrings(result.strings);
        return result.processed; // Format log
      }
    );

    // Simple String Transformations
    doStep('processSymbols', (s) => IC.parser.processSymbols(s.processed));
    doStep('processRegexReplacements(L2)', (s) => IC.parser.processRegexReplacements(s.processed, CONFIG.L2_REPLACEMENTS_STRINGS));
    doStep('processXToMultiply_1', (s) => IC.parser.processXToMultiply(s.processed));
    doStep('removeInvisibleUnicode', (s) => IC.parser.removeInvisibleUnicodeCharacters(s.processed));
    doStep('escapeUnicode', (s) => IC.parser.escapeUnicode(s.processed));

    // Scan Identifiers & Title
    doStep('scanAssignedIdentifiers',
      (s) => IC.parser.scanAssignedIdentifiersUsingLex(s.processed),
      (ids) => {
        // Update multiple state parts and env
        state.allAssignedIDs = ids;
        if (ids.length) {
          IC.envSetRowTitle(IC.parser.unescapeUnicode(ids[0].orig));
          state.title = IC.envGetRowTitle();
          process_debug.push(["09a_extractedTitle", state.title]); // Manual extra log
        }
        ids.forEach((id) => IC.envSetIdentifier(id.name));
        state.identifiers = IC.envGetIdentifiers();
        return `IDs: ${ids.map(id => id.name).join(', ')}`; // Format log
      }
    );

    //  More Transformations (using state.identifiers etc. via closure)
    doStep('processRegexReplacements(L3)', (s) => IC.parser.processRegexReplacements(s.processed, CONFIG.L3_REPLACEMENTS_REGEX));
    doStep('processIdentifiers', (s) => IC.parser.processIdentifiers(s.processed, s.identifiers, s.allAssignedIDs, startEnv));
    doStep('processXToMultiply_2', (s) => IC.parser.processXToMultiply(s.processed, true));
    doStep('processPrefixRegex', (s) => IC.parser.processPrefixRegex(s.processed));
    doStep('processPlainEnglishFunctions', (s) => IC.parser.processPlainEnglishFunctions(s.processed));
    doStep('processPlainEnglishOp', (s) => IC.parser.processPlainEnglishOp(s.processed, s.identifiers, startEnv));
    doStep('processInAsKeyword', (s) => IC.parser.processInAsKeyword(s.processed));
    doStep('processAasKeyword', (s) => IC.parser.processAasKeyword(s.processed));
    doStep('processRegexReplacements(L4)', (s) => IC.parser.processRegexReplacements(s.processed, CONFIG.L4_REPLACEMENTS_REGEX));
    doStep('processRegexReplacements(L5)', (s) => IC.parser.processRegexReplacements(s.processed, CONFIG.L5_REPLACEMENTS_STRINGS));
    doStep('processParenUnitExpressions', (s) => IC.parser.processParenUnitExpressions(s.processed));
    doStep('processPlainEnglishNumbers', (s) => IC.parser.processPlainEnglishNumbers(s.processed));
    doStep('processFunctionWithExponent', (s) => IC.parser.processFunctionWithExponent(s.processed));
    doStep('processFinalCurrencies', (s) => IC.parser.processFinalCurrencies(s.processed));
    doStep('processUnitTypeBeforeNumber', (s) => IC.parser.processUnitTypeBeforeNumber(s.processed));
    doStep('processDateTimeExpressions', (s) => IC.parser.processDateTimeExpressions(s.processed));
    doStep('preprocessRelativeDate', (s) => ICDate.preprocessRelativeDate(s.processed));
    doStep('processChainOfAddedUnits', (s) => IC.parser.processChainOfAddedUnits(s.processed));
    doStep('processConversionAtOrder', (s) => IC.parser.processConversionAtOrder(s.processed));
    doStep('processDashUnitSeparator', (s) => IC.parser.processDashUnitSeparator(s.processed));
    doStep('envReplaceStrings', (s) => IC.envReplaceStrings(s.processed)); // Reads strings from env

    // TODO: some of these require certain characters/strings (like "in", etc.). if we scan the input and get the charmap, we can see if we should even run the processor.

    // Tokenize
    state.tokens = IC.parser.tokenize(state.processed, LEXER); // Update state.tokens directly

    PerfLog.end("phasePreprocess", process_debug); // End overall phase timing

    // --- Return Final Result Object ---
    // Construct the final object explicitly from the state
    return {
      input, i, // Pass original input and index through
      processed: state.processed,
      comment: state.comment,
      title: state.title,
      format: state.format,
      strings: state.strings,
      process_debug, // Include the debug log
      identifiers: state.identifiers,
      allAssignedIDs: state.allAssignedIDs,
      tokens: state.tokens
    };
  },

  /*
  Some grammar decisions are best handled in code (sensitive to neighboring tokens, variables defined in environment, etc.)
  */
  phasePreprocessOld: function ({ input, i, settings, startEnv }) {
    let processed, comment, title, format, strings, process_debug = [], identifiers, allAssignedIDs;

    process_debug.push(["input", input]);
    processed = input;

    ({ processed, comment } = IC.parser.processComment(processed));
    IC.envSetRowComment(comment);
    processed = IC.parser.processRegexReplacements(processed, CONFIG.L1_REPLACEMENTS_REGEX);
    process_debug.push(["comment, L1", processed]);

    ({ processed, format, strings } = IC.parser.processCurrencySymbolsAndStrings(processed));
    IC.envSetFormatter(format);
    IC.envSetStrings(strings);
    process_debug.push(["currency|strings|spaces", processed]);

    processed = IC.parser.processSymbols(processed);
    processed = IC.parser.processRegexReplacements(processed, CONFIG.L2_REPLACEMENTS_STRINGS);
    processed = IC.parser.processXToMultiply(processed); // need 2 rounds, see x=2, 3 x 3 

    processed = IC.parser.removeInvisibleUnicodeCharacters(processed);
    processed = IC.parser.escapeUnicode(processed);
    //    processed = processed.replace(/\s+/, " ");      // collapse whitespace

    process_debug.push(["symbols|L2|xAsMult|unicode", processed]);

    allAssignedIDs = IC.parser.scanAssignedIdentifiersUsingLex(processed);

    // title is first ID
    if (allAssignedIDs.length) {
      IC.envSetRowTitle(IC.parser.escapeUnicode(allAssignedIDs[0].orig));
      title = IC.envGetRowTitle();
    }

    allAssignedIDs.forEach((id) => IC.envSetIdentifier(id.name));
    identifiers = IC.envGetIdentifiers();

    processed = IC.parser.processRegexReplacements(processed, CONFIG.L3_REPLACEMENTS_REGEX);
    processed = IC.parser.processIdentifiers(processed, identifiers, startEnv);
    processed = IC.parser.processXToMultiply(processed, true);
    process_debug.push(["L3|identifiers|xAsMult", processed]);

    processed = IC.parser.processPrefixRegex(processed);
    processed = IC.parser.processPlainEnglishFunctions(processed);
    processed = IC.parser.processPlainEnglishOp(processed, identifiers, startEnv);
    process_debug.push(["PrefixRegex|PlainEngFn|PlainEnglishOp", processed]);

    processed = IC.parser.processInAsKeyword(processed);
    processed = IC.parser.processAasKeyword(processed);
    processed = IC.parser.processRegexReplacements(processed, CONFIG.L4_REPLACEMENTS_REGEX);
    processed = IC.parser.processRegexReplacements(processed, CONFIG.L5_REPLACEMENTS_STRINGS);
    process_debug.push(["InAsKeyword|L4|L5", processed]);

    processed = IC.parser.processParenUnitExpressions(processed);
    process_debug.push(["ParenUnitExpressions", processed]);

    // see tests for why this comes last
    processed = IC.parser.processPlainEnglishNumbers(processed);
    processed = IC.parser.processFunctionWithExponent(processed);
    processed = IC.parser.processFinalCurrencies(processed);
    processed = IC.parser.processUnitTypeBeforeNumber(processed); // must happen after currency swap
    processed = IC.parser.processDateTimeExpressions(processed);
    processed = ICDate.preprocessRelativeDate(processed);
    processed = IC.parser.processChainOfAddedUnits(processed);
    processed = IC.parser.processConversionAtOrder(processed);
    processed = IC.parser.processDashUnitSeparator(processed);
    process_debug.push(["EnglishNum|FnWithExponent|FinalCurrencies|UnitBeforeNumber|AddedUnits|conversionAtOrder|Dash", processed]);

    processed = IC.envReplaceStrings(processed);
    process_debug.push(["ReplaceStrings", processed]);

    let tokens = IC.parser.tokenize(processed, LEXER);

    return { input, i, processed, comment, title, format, strings, process_debug, identifiers, allAssignedIDs, tokens };
  },

  phaseParse: function ({ processed }) {
    let cacheKey = "nearley" + processed;
    let parseResult = IC.parser.RESULT_CACHE.get(cacheKey);

    if (!IC.parser.RESULT_CACHE.has(cacheKey)) {
      try {
        let NEARLEY_PARSER = new LIB.nearley.Parser(GRAMMAR_FROM_COMPILED);
        NEARLEY_PARSER.feed(processed);
        parseResult = NEARLEY_PARSER.results[0];
      } catch {
        parseResult = null;
      }
      IC.parser.RESULT_CACHE.set(cacheKey, parseResult);
    }

    return { parseResult };
  },

  phaseEval: function (params = {}) {
    let { input, parseResult, allAssignedIDs, format, processed } = params;
    let result, final_result;
    if (parseResult) {
      IC.envCheckIdentifierWarnings(allAssignedIDs.map(id => id.name));
      try {
        result = IC.eval(parseResult);
      }
      catch (e) {
        result = null;
        console.error(e);
      }

      // last-ditch save... try to extra numbers
      let failedResult = !IC.isValidEvalResult(result) || IC.parser.invalidNumber(result);
      if (failedResult && !IC.predefinedFunction(processed)) {
        let simpleString = IC.parser.parseSimple(processed);
        if (simpleString) {
          let origLog = IC.logGetCurrentRow();
          IC.logClear();
          parseResult = IC.parser.phaseParse({ processed: simpleString }).parseResult;
          result = IC.eval(parseResult);
          if (result == null) {
            IC.logSetCurrentRow(origLog);
          }
        }
      }
      // TODO: put this in output message, if simple string used
      // IC.log(`converted to: ${simpleString}`);
    }

    // auto-format result when needed (i.e., not a conversion)
    // TODO: is there better logic to detect when to auto-collapse final result? 
    if (!processed.includes("->") && IC.hasType(result) /* this is needed for Infinity being cached */) {
      let collapsed = ICUnit.autoCollapse(result);
      if (ICUnit.autoCollapseIgnore(result)) {
        // log the ignored collapse
        let formattedNumber = IC.parser.applyLogNumberFormatting(IC.val(collapsed));
        let logMsg = `= ${formattedNumber} ${IC.typestring(collapsed.t)}`;
        IC.log(logMsg);
      } else {
        result = collapsed;
      }
    }

    IC.envAssignRowResult(result || 0);

    // may have been changed during execution, for example: autosolve
    format = IC.parser.scanExtraFormatting(input, result, IC.envGetFormatter());
    final_result = format ? IC.parser.formatNumber(result, format) : result;

    return { result, format, final_result };
  },

  phasePostprocess: function (params = {}, settings = {}, timeStart) {
    let { processed, input, process_debug, allAssignedIDs, i, comment, title, format, parseResult, tokens, result, final_result } = params;
    let ret = {};

    // {total} => total
    function interpolateString(str) {
      return str.replace(/{([^}]+)}/g, (match) => {
        let result = IC.parseAndEval(match);
        if (result != IC.NOPARSE && IC.isValidEvalResult(result)) {
          return result;
        }

        return match;
      });
    }

    try {
      // log errors
      IC.parser.checkFailedResult(processed, result);

      // get reference list
      let { references, custom_units } = IC.parser.scanReferencesFromParseResult(params);

      ret.input = input;
      const rawComment = (comment || "").trim();
      const looksLikeUIMetadata = UIMetadataParser.looksLikeUIMetadata(rawComment);
      // If the comment looks like JSON UI metadata, do NOT run interpolation on it
      // to avoid corrupting the JSON (e.g., turning it into [object Object]).
      ret.comment = looksLikeUIMetadata
        ? IC.parser.unescapeUnicode(rawComment)
        : IC.parser.unescapeUnicode(interpolateString(comment))?.trim();
      // Parse UI metadata from the raw (non-interpolated) comment if present
      const uiParseResult = UIMetadataParser.parse(rawComment);
      ret.ui = uiParseResult.ui;
      ret.ui_comment = uiParseResult.ui_comment;
      ret.title = IC.parser.unescapeUnicode(title)?.trim();
      ret.eval_result = IC.parser.unescapeUnicode(IC.val(result));
      ret.final_result = IC.parser.unescapeUnicode(IC.parser.formatResult(final_result, settings, format));
      ret.format = format;
      ret.result = result;

      if (IC.isValidEvalResult(ret.eval_result) && IC.isValidEvalResult(result)) {
        ret.type = IC.parser.formatTypestring(result);
      }

      // must happen before log
      // TODO - this seems to interfere with caching if we return ret directly
      IC.parser.applyNumberFormatting(ret, settings);

      ret.log = IC.logProcess(IC.logGetCurrentRow(), result);
      ret.processed = IC.parser.unescapeUnicode(processed);
      ret.process_debug = process_debug;
      ret.process_time_ms = performance.now() - timeStart;
      ret.output_msg = IC.parser.getOutputMessage(ret, result, input);

      ret.missing_references = references.filter(r => !IC.envIsDefined(r) /* && !IC.isRealUnit(r)  && !IC.isAllowedFunction(r)  && !(IC.suffix(r) != 1) */ && !CONFIG.POSTCONVERT_FUNCTIONS[r]);
      ret.assigned_references = [...allAssignedIDs, `r${i + 1}`];

      // update assigned references for object and array access
      let objAndArrayReferences = ret.assigned_references.map(id => {
        let parts = IC.getVariableParts(id?.name || id);
        if (parts.length > 1) {
          return parts[0];
        }
      }).filter(Boolean);

      ret.assigned_references = [...ret.assigned_references, ...objAndArrayReferences];

      ret.is_custom_type = ret.type && Object.keys(result?.t).find((t) => !IC.predefinedUnit(t));
      ret.is_custom_object = IC.isCustomObject(ret.final_result);
      ret.is_custom_function = IC.isCustomFunction(ret.final_result);
      ret.is_array = Array.isArray(result) && (result?.length > 1 || result?.length == 0);

      if (!ret.is_array && Array.isArray(result)) {
        ret.output_msg += "single-item treated as value";
        if (input.includes(",")) {
          ret.output_msg += "; separate with space: [1, 2, 3]";
        }
      }

      if (IC.parser.invalidResult(ret)) {
        let missingChar;
        const hasSymbols = tokens?.some(t => t.type == "symbol");

        if (ret?.missing_references.length && hasSymbols) {
          ret.output_msg = "undefined: " + ret.missing_references.join(", ");
        } else if (missingChar = IC.parser.hasMismatchedParensOrBraces(input)) {
          ret.output_msg = `unmatched ${missingChar}`;
        }
      }

      //ret.references = [...IC.getVarRefs()];
      ret.references = references;
      ret.custom_units = custom_units;

      ret.tokens = tokens;

      // UI write-back hints: provide explicit data for matching and write-back
      if (ret.ui) {
        const assignedRaw = IC.parser.extractAssignedSnippet(input);

        ret.ui_write = {
          value_raw: assignedRaw,           // Raw RHS: "10 mm", "0.5", "cap"
          value_eval: ret.eval_result,      // Evaluated: 10<mm>, 0.5, 0.8
        };

        const uiType = String(ret.ui.ui).toLowerCase();

        // For sliders, provide evaluated bounds as numbers
        if (uiType === 'slider' || uiType === 'range') {
          ret.ui_write.min_eval = (typeof ret.ui.min === 'number') ? ret.ui.min : Number(ret.ui.min) || 0;
          ret.ui_write.max_eval = (typeof ret.ui.max === 'number') ? ret.ui.max : Number(ret.ui.max) || 100;
          ret.ui_write.step_eval = (typeof ret.ui.step === 'number') ? ret.ui.step : Number(ret.ui.step) || 1;
        }

        // For checkboxes, provide boolean state
        if (uiType === 'checkbox') {
          let checked = false;
          if (typeof ret.eval_result === 'boolean') {
            checked = ret.eval_result;
          } else if (typeof ret.eval_result === 'string') {
            const s = ret.eval_result.toLowerCase();
            checked = s === 'true' || s === '1';
          }
          ret.ui_write.checkbox_checked = checked;
        }

        // For multiselect, provide parsed array of selected values
        if (uiType === 'multiselect' || uiType === 'multi' || uiType === 'select-multiple') {
          let selected = [];
          if (Array.isArray(ret.eval_result)) {
            selected = ret.eval_result.filter(item =>
              typeof item === 'number' || typeof item === 'boolean' || typeof item === 'string'
            );
          }
          ret.ui_write.multiselect_selected = selected;
        }
      }

      // UI helpers: provide canonical display values for date/time controls so UI can be dumb
      if (ret.ui && typeof ret.ui.ui === 'string') {
        const uiType = String(ret.ui.ui).toLowerCase();
        if (uiType === 'date' || uiType === 'time' || uiType === 'datetime' || uiType === 'datetime-local') {
          let currentRaw = '';

          // If the evaluated result is a date object (e.g., from date("2025-10-10")), extract the ISO string
          if (ICDate.isDateTimeObject(ret.eval_result)) {
            currentRaw = IC.val(ret.eval_result); // Get ISO string like "2025-10-10T00:00:00.000Z"
          } else {
            // Fall back to raw assigned text (for legacy quoted strings)
            const assignedRaw = IC.parser.extractAssignedSnippet(input);
            currentRaw = assignedRaw;
            if ((!currentRaw || currentRaw.length === 0) && typeof ret.eval_result === 'string') {
              currentRaw = ret.eval_result;
            }
          }

          const htmlType = (uiType === 'datetime') ? 'datetime-local' : uiType;
          ret.ui_display_value = IC.parser.canonicalizeDateInput(htmlType, currentRaw || '');
          ret.ui_input_type = htmlType;
        }
      }
    }
    catch (e) {
      console.error(e);
      ret = IC.parser.getBlankReturnObject();
    }

    return ret;
  },

  hasMismatchedParensOrBraces: function (str) {
    const stack = [];
    const openBraces = { '{': '}', '(': ')' };
    const closeBraces = { '}': '{', ')': '(' };

    for (let char of str) {
      if (openBraces[char]) {
        stack.push(char);
      } else if (closeBraces[char]) {
        if (stack.length === 0 || stack.pop() !== closeBraces[char]) {
          return char;
        }
      }
    }

    if (stack.length > 0) {
      return stack.pop();
    }

    return null;
  },

  getInputTooLongResult: function () {
    return {
      input: "",
      log: "",
      references: [],
      missing_references: [],
      assigned_references: [],
      custom_units: [],
      output_msg: "Input too long (1000 max per row)"
    };
  },

  getBlankReturnObject: function () {
    return {
      comment: "",
      title: "",
      input: "",
      eval_result: "",
      final_result: "",
      result: "",
      type: "",
      log: [],
      processed: "",
      process_debug: [],
      process_time_ms: null,
      output_msg: "",
      missing_references: [],
      assigned_references: [],
      references: [],
      custom_units: []
    }
  },

  // replaceTextBeforeComment("300 // some comment", "400") => "400 // some comment"
  replaceTextBeforeComment: function (originalText, newMainText) {
    let parts = originalText.split("//");
    let replaced = newMainText;
    if (parts.length > 1) {
      replaced += " //" + parts.slice(1).join("//");
    }
    return replaced;
  },

  // extractAssignedSnippet("x = 10 mm // comment") => "10 mm"
  // extractAssignedSnippet("42 // comment") => "42"
  extractAssignedSnippet: function (input) {
    if (typeof input !== 'string') return '';
    // Extract text before comment
    let beforeComment = input;
    const cm = input.match(/(?:\/\/|#)/);
    if (cm) beforeComment = input.substring(0, cm.index);
    // Extract RHS if there's an assignment
    const eqIdx = beforeComment.indexOf('=');
    if (eqIdx >= 0) {
      return beforeComment.substring(eqIdx + 1).trim();
    }
    return beforeComment.trim();
  },

  // Add text to the end of a line, but before the comment string (if present)
  appendTextBeforeComment(str, textToAdd) {
    // Check if there's a comment
    const hasComment = str.includes("//");
    let [beforeComment, comment] = str.split("//", 2);

    textToAdd = textToAdd.trimEnd();

    // maintaing spacing
    if (beforeComment.endsWith(" ") && textToAdd.startsWith(" ")) {
      textToAdd = textToAdd.trim() + " ";
    }

    beforeComment += textToAdd;
    return hasComment ? `${beforeComment}//${comment}` : beforeComment;
  }
,

  // Canonicalize a date/time/datetime input string for HTML inputs and storage
  canonicalizeDateInput: function (htmlType, value) {
    const stripQuotes = (s) => {
      if (typeof s !== 'string') return s;
      const t = s.trim();
      if ((t.startsWith('"') && t.endsWith('"')) || (t.startsWith("'") && t.endsWith("'"))) return t.slice(1, -1);
      return t;
    };
    const pad2 = (n) => String(n).padStart(2, '0');
    const to24h = (h, ampm) => {
      let hour = Number(h);
      const suffix = (ampm || '').toLowerCase();
      if (suffix === 'pm' && hour < 12) hour += 12;
      if (suffix === 'am' && hour === 12) hour = 0;
      return hour;
    };
    const normalizeDateLike = (raw) => {
      if (!raw || typeof raw !== 'string') return null;
      const s = raw.trim();
      let m = s.match(/^(\d{4})[-\/]?(\d{1,2})[-\/]?(\d{1,2})(?:[ T](\d{1,2}):(\d{2})(?:\s*(AM|PM))?)?$/i);
      if (m) {
        const y = Number(m[1]);
        const mo = Number(m[2]);
        const d = Number(m[3]);
        const hh = m[4] != null ? to24h(m[4], m[6]) : null;
        const mm = m[5] != null ? Number(m[5]) : null;
        return { y, mo, d, hh, mm };
      }
      m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:[ T](\d{1,2}):(\d{2})(?:\s*(AM|PM))?)?$/i);
      if (m) {
        const mo = Number(m[1]);
        const d = Number(m[2]);
        const y = Number(m[3]);
        const hh = m[4] != null ? to24h(m[4], m[6]) : null;
        const mm = m[5] != null ? Number(m[5]) : null;
        return { y, mo, d, hh, mm };
      }
      m = s.match(/^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/);
      if (m) {
        return { y: Number(m[1]), mo: Number(m[2]), d: Number(m[3]), hh: Number(m[4]), mm: Number(m[5]) };
      }
      m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (m) {
        return { y: Number(m[1]), mo: Number(m[2]), d: Number(m[3]), hh: null, mm: null };
      }
      // time-only HH:MM with optional AM/PM
      m = s.match(/^(\d{1,2}):(\d{2})(?:\s*(AM|PM))?$/i);
      if (m) {
        return { y: 1970, mo: 1, d: 1, hh: to24h(m[1], m[3]), mm: Number(m[2]) };
      }
      return null;
    };
    const formatForInput = (parts, htmlType) => {
      if (!parts) return '';
      if (htmlType === 'date') return `${parts.y}-${pad2(parts.mo)}-${pad2(parts.d)}`;
      if (htmlType === 'time') {
        const hh = parts.hh != null ? parts.hh : 0;
        const mm = parts.mm != null ? parts.mm : 0;
        return `${pad2(hh)}:${pad2(mm)}`;
      }
      const hh = parts.hh != null ? parts.hh : 0;
      const mm = parts.mm != null ? parts.mm : 0;
      return `${parts.y}-${pad2(parts.mo)}-${pad2(parts.d)}T${pad2(hh)}:${pad2(mm)}`;
    };

    const clean = stripQuotes(String(value || ''));
    const type = (htmlType === 'datetime') ? 'datetime-local' : htmlType;
    const parts = normalizeDateLike(clean);
    return formatForInput(parts, type);
  }
,

  // Convert ISO date/time format to native InstaCalc date literals
  // Used when writing UI control values back to the calc
  // e.g., "2025-11-06" → "2025/11/06", "2025-11-06T14:30" → "2025/11/06 14:30"
  dateToNativeLiteral: function (uiType, isoValue) {
    if (!isoValue || typeof isoValue !== 'string') return isoValue;

    if (uiType === 'date') {
      // Convert ISO date 2025-11-06 to 2025/11/06 (slashes for date objects, not subtraction)
      return isoValue.replace(/-/g, '/');
    } else if (uiType === 'datetime' || uiType === 'datetime-local') {
      // Convert ISO datetime 2025-11-06T14:30 to 2025/11/06 14:30
      return isoValue.replace(/-/g, '/').replace('T', ' ');
    }
    // time stays as-is: 14:30
    return isoValue;
  }
,

  // x = 123 => 123 is the "parameter" value
  getRowParameter: function (calc, row) {
    if (!calc.rows[row]?.hidden) {
      return null;
    }

    var text = calc.rows[row].text;
    // First, try direct parse
    let param = IC.parser.getRowParameterFromString(text);
    if (param != null) return param;

    // If that fails, normalize the LHS by stripping a single currency symbol
    // prefix/suffix from the identifier (e.g., "$x = 3" or "x$ = 3") and retry.
    const eqIndex = text.indexOf('=');
    if (eqIndex < 0) return null;

    let lhsRaw = (text.slice(0, eqIndex) || '').trim();
    const rhs = text.slice(eqIndex); // includes '='

    const currencies = Object.values(LIB.InstaCalc.format.currencies);
    const symbols = currencies.map(c => c.symbol).filter(Boolean);
    const escapeRegex = s => String(s).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
    const alt = symbols.map(escapeRegex).join('|');

    let lhs = lhsRaw;
    if (alt) {
      lhs = lhs.replace(new RegExp(`^\\s*[+-]?(?:${alt})\\s*`, 'u'), '');
      lhs = lhs.replace(new RegExp(`\\s*(?:${alt})\\s*$`, 'u'), '');
    }
    // Also strip normalized currency codes from currency preprocessor, e.g., (_USD)
    lhs = lhs.replace(/^\s*[+-]?\(_[A-Z]{3}\)\s*/u, '');
    lhs = lhs.replace(/\s*\(_[A-Z]{3}\)\s*$/u, '');

    const candidate = lhs + rhs;
    return IC.parser.getRowParameterFromString(candidate);
  },

  // true if input is a variable assignment without calculation
  // turns out, better to let the main text be freeform for people. 
  getRowParameterFromString: function (input) {
    let allTokens = IC.parser.tokenize(input, LEXER);
    let tokens = allTokens.filter(t => t.type != "ws").filter(t => !t.type.includes("comment"));

    const isNumericLiteral = function (token) {
      return token.type == "decimal" || token.type == "hex" || token.type == "oct" || token.type == "bin";
    }

    const isOtherLiteral = function (token) {
      return token.type == "feetAndInches" || token.type == "datestring" || token.type == "timeImpliedDate" || token.type == "timestring" || token.type == "isoTimestamp";
    }

    const allowedSuffix = function (token) {
      return token.text == "%" || token.type == "id";
    }

    // general format
    // id = [symbols]? [number] [suffix: %|type]? 
    let idx = 0;
    if (!tokens.length) {
      return null;
    }

    if (tokens[idx++]?.type != "id") {
      return null;
    }

    if (tokens[idx++]?.text != "=") {
      return null;
    }

    // if no parameter, empty string
    if (idx > tokens.length - 1) {
      return "";
    }

    // Allowed symbols before numeric literal
    let allowed = new Set(["+", "-"]);
    const currencies = Object.values(LIB.InstaCalc.format.currencies);
    currencies.forEach(c => allowed.add(c.symbol));

    // Consume allowed tokens before the numeric literal
    while (idx < tokens.length && allowed.has(tokens[idx].text)) {
      idx++;
    }

    // no more tokens -- just currency symbol
    if (idx > tokens.length - 1) {
      return tokens[idx - 1].text;
    }

    // Now, idx should be at the numeric literal, if it's the correct format
    if (!isNumericLiteral(tokens[idx]) && !isOtherLiteral(tokens[idx])) {
      return null; // No numeric literal where expected
    }
    idx += 1;

    // suffix like k, M, cm/s
    if (tokens[idx]) {
      if (!allowedSuffix(tokens[idx])) {
        return null;
      }

      idx++;
      // Check for second suffix
      if (idx < tokens.length && !allowedSuffix(tokens[idx])) {
        // check if the remaining tokens are a unit
        let remainingTokens = tokens.slice(idx - 1);
        let remainingText = remainingTokens.join('');
        if (!IC.typestringIsPossibleUnitIncludingSlash(remainingText)) {
          return null;
        }
      }
    }

    let full = IC.parser.tokenSmartJoin(allTokens, tokens);
    return full.split('=')[1]?.trimStart();
  },

  // pull variable assignment from string: "x = 3" returns "x"
  getRowParameterName: function (text) {
    // Extract LHS and normalize by stripping optional currency symbol prefix/suffix
    // so that "$x = 3" and "x$ = 3" both yield name "x".
    const eqIndex = text.indexOf('=');
    if (eqIndex < 0) return false;

    let lhsRaw = (text.slice(0, eqIndex) || '').trim();

    const currencies = Object.values(LIB.InstaCalc.format.currencies);
    const symbols = currencies.map(c => c.symbol).filter(Boolean);

    const escapeRegex = s => String(s).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
    const alt = symbols.map(escapeRegex).join('|');

    let lhs = lhsRaw;
    if (alt) {
      lhs = lhs.replace(new RegExp(`^\\s*[+-]?(?:${alt})\\s*`, 'u'), ''); // strip leading symbol
      lhs = lhs.replace(new RegExp(`\\s*(?:${alt})\\s*$`, 'u'), '');         // strip trailing symbol
    }
    // Also strip normalized currency codes from currency preprocessor, e.g., (_USD)
    lhs = lhs.replace(/^\s*[+-]?\(_[A-Z]{3}\)\s*/u, '');
    lhs = lhs.replace(/\s*\(_[A-Z]{3}\)\s*$/u, '');

    // Reconstruct a candidate line with normalized LHS for validation
    const candidate = lhs + text.slice(eqIndex);
    if (!this.getRowParameterFromString(candidate)) {
      return false;
    }

    return lhs.trim();
  },

  // inject the assigned value into the variable assignment string
  buildRowParameterText: function (text, assigned_value, result = {}) {
    // let currentVar = IC.parser.getRowParameterFromString(text);

    let commentSplit = text.split("//");

    // replace text in the 2nd half
    let ret = commentSplit[0].split("=").map((t, i) => {
      if (i == 0) {
        return t;
      }
      if (i == 1) {
        return assigned_value;
      }
    }).join('=');

    if (result.type) {
      //ret += " " + result.type + " ";
    }

    if (commentSplit.length > 1) {
      ret += "//" + commentSplit[1];
    }

    // replace multiple spaces with a single one
    ret = ret.replace(/\s+/g, " ");

    // BUGFIX: had to avoid adding extra spaces, broke ability to change row parameter text
    // Need to make that more robust.

    return ret;
  },

  stringCanBeIncremented: function (str) {
    if (!str || !str.match(/\d/)) {
      return false;
    }

    return IC.parser.incrementNumberInString(str, 1) != str;
  },

  // increment or decrement first number in input
  incrementNumberInString: function (input = "", direction = 1) {
    if (!input?.trim().length) {
      return input;
    }

    function stepSize(n) {
      let step;
      if (n === 0) {
        step = 1; // Default step if the number is exactly 0
      } else if (Math.abs(n) < 1) {
        // Find the number of decimal places of the first significant digit
        let decimalPlaces = Math.abs(n).toString().split('.')[1].search(/[1-9]/) + 1;
        step = Math.pow(10, -decimalPlaces);
      } else if (Math.abs(n) < 100) {
        step = 1; // For numbers between 1 and 99, step by 1
      } else {
        step = Math.pow(10, Math.floor(Math.log10(Math.abs(n))) - 1);
      }
      return step;
    }

    let allTokens = IC.parser.tokenize(input, LEXER);
    let sign = 1;
    let negativeSignIndex = -1;
    let skipTokenIndex = null;

    // if no decimal tokens, return input
    if (!allTokens.some(t => t.type == "decimal")) {
      return input;
    }

    let results = allTokens.map((t, index) => {
      if (t.type == "symbol" && t.text == "-") {
        sign = -1;
        negativeSignIndex = index;

        // delete this from the results; the actual value will be in changedN.toString();
        return '';
      }

      if (t.type == "decimal") {
        let n = sign * IC.makeNumber(t.text, IC.envGetSettings());
        let changedN = IC.mathAddNumbersHighPrecision(n, direction * stepSize(n));

        if (changedN === 0 && negativeSignIndex >= 0) {
          skipTokenIndex = negativeSignIndex;
        }

        // format number if it was formatted before 
        if (t.text.includes(",")) {
          let settings = IC.envGetSettings();
          return IC.parser.applyRawNumberFormatting(changedN, settings?.locale || "en-US");
        }
        return changedN.toString();
      }

      return t.text;
    });

    let processed = results.join('');
    return processed;
  },

  execute: function (input = "", i = 0, settings = {}) {
    const timeStart = performance.now();
    const ret = IC.parser.getBlankReturnObject();

    if (typeof input !== "string") {
      return ret;
    }

    // check for long input
    if (input?.length > 1000) {
      // check if input begins with comment
      if (!input.match(/^\s*\/\//)) {
        return { ...ret, ...IC.parser.getInputTooLongResult() };
      }
    }

    const startEnv = IC.envNewStartEnv(i, settings);

    const cached = IC.parser.getResultCache({ input, startEnv, settings, rowIndex: i });
    if (cached) {
      return cached;
    }

    let preprocessResult = IC.parser.phasePreprocess({ input, i, settings, startEnv });
    Object.assign(ret, preprocessResult);

    let parseResult = IC.parser.phaseParse(ret);
    Object.assign(ret, parseResult);

    let evalResult = IC.parser.phaseEval(ret);
    Object.assign(ret, evalResult);

    let postprocessResult = IC.parser.phasePostprocess(ret, settings, timeStart);
    Object.assign(ret, postprocessResult);

    IC.parser.setResultCache({ input, startEnv, settings, ret, rowIndex: i });
    return ret;
  },

  invalidResult(result) {
    return !IC.isValidEvalResult(result.eval_result) || IC.parser.invalidNumber(result.eval_result);
  },

  invalidNumber(n) {
    return typeof n === "number" && (isNaN(n) || !Number.isFinite(n));
  },

  shouldRedo(result) {
    if (result.processed === "") {
      return false;
    }

    // custom unit -- maybe be defined now
    if (result.is_custom_type) {
      return true;
    }

    return IC.parser.invalidResult(result)
      // if we are missing references and didn't eval to something useful...
      // || (result.missing_references.length && !result.eval_result)
      || result.missing_references.length;
  },

  quickEval: function (input) {
    return IC.parser.execute(input, 0)?.eval_result;
  },

  quickResult: function (input) {
    return IC.parser.execute(input, 0)?.result;
  },

  mergeRelatedLinesOld: function (rows) {
    const mergedRows = [...rows]; // Create a copy to maintain the same length

    for (let i = 1; i < rows.length; i++) {
      const trimmedRow = rows[i].trim();

      // Check if the line starts with 'else' or 'else if'
      if (/^else\b|^else if\b/.test(trimmedRow)) {
        let j = i - 1;

        // Find the previous non-empty line to merge with
        while (j >= 0 && mergedRows[j] === '') {
          j--;
        }

        if (j >= 0) {
          // Merge current line into the previous line
          mergedRows[j] += ' ' + trimmedRow;
          mergedRows[i] = ''; // Replace current line with an empty string
        }
      }
    }

    return mergedRows;
  },

  stripComment: function (line) {
    // Match // or # comments, but not inside strings
    const commentMatch = line.match(/(?:\/\/|#)/);
    if (commentMatch) {
      return line.substring(0, commentMatch.index).trim();
    }
    return line;
  },

  // Helper to extract assignment variable names from a line
  extractAssignmentsFromLine: function (line) {
    const trimmed = line.trim();

    // Skip lines that are just braces or control structures
    if (!trimmed || /^[{}]$/.test(trimmed) || /^(if|else)\s*[\({]/.test(trimmed)) {
      return [];
    }

    // Use existing tokenizer-based scanner to extract assignments
    // This handles edge cases like "2 weeks = 3" (not an assignment) properly
    const ids = IC.parser.scanAssignedIdentifiersUsingLex(trimmed);
    return ids.map(id => id.name);
  },

  mergeRelatedLines: function (rows) {
    const mergedRows = [...rows]; // Create a copy to maintain the same length
    const mergeMetadata = {}; // Track which rows were merged and their original content

    let i = 0;
    while (i < rows.length) {
      const trimmedRow = rows[i].trim();

      // Check if this line contains an if statement that opens a block
      if (/\bif\s*\(/.test(trimmedRow)) {
        let blockLines = [];
        let braceDepth = 0;
        let startIndex = i;
        let originalLines = []; // Track original content before merging

        // Process first line: strip comment, add to block
        const firstLineClean = IC.parser.stripComment(trimmedRow);
        blockLines.push(firstLineClean);
        originalLines.push({ index: i, content: rows[i].trim() });

        // Count braces in the first line (after stripping comment)
        for (let char of firstLineClean) {
          if (char === '{') braceDepth++;
          if (char === '}') braceDepth--;
        }

        // If the if statement spans multiple lines, collect them
        if (braceDepth > 0) {
          i++;
          while (i < rows.length && braceDepth > 0) {
            const currentLine = rows[i].trim();

            // Track original line before merging
            originalLines.push({ index: i, content: currentLine });

            // Strip comment from current line
            const cleanLine = IC.parser.stripComment(currentLine);
            if (cleanLine) { // Only add if not empty after stripping comment
              blockLines.push(cleanLine);
            }

            // Count braces in clean line
            for (let char of cleanLine) {
              if (char === '{') braceDepth++;
              if (char === '}') braceDepth--;
            }

            i++;
          }

          // Merge all lines into the first line
          mergedRows[startIndex] = blockLines.join('; ');

          // Store metadata about this merge
          mergeMetadata[startIndex] = {
            type: 'if-else-block',
            originalLines: originalLines,
            startIndex: startIndex,
            endIndex: i - 1
          };

          // Mark the rest as empty
          for (let j = startIndex + 1; j < i; j++) {
            mergedRows[j] = '';
          }

          // Don't increment i again, we're already at the right position
          continue;
        }
      }

      // Also handle standalone 'else' lines (from old logic)
      if (/^else\b/.test(trimmedRow)) {
        let j = i - 1;

        // Find the previous non-empty line to merge with
        while (j >= 0 && mergedRows[j] === '') {
          j--;
        }

        if (j >= 0) {
          // Merge current line into the previous line
          mergedRows[j] += ' ' + trimmedRow;
          mergedRows[i] = ''; // Replace current line with an empty string
        }
      }

      i++;
    }

    return { mergedRows, mergeMetadata };
  },

  executeRows: function (initialRows, settings = {}) {
    if (!Array.isArray(initialRows)) {
      throw new Error("Expected Array");
    }

    let rows, mergeMetadata;
    const phaseSetup = () => {
      IC.envReset();
      IC.envSetInputRows(initialRows);
      const mergeResult = IC.parser.mergeRelatedLines(initialRows);
      rows = mergeResult.mergedRows;
      mergeMetadata = mergeResult.mergeMetadata;
    }

    let results = [];

    // --- First pass: execute all rows ---
    const phaseInitialResults = () => {
      results = rows.map((row, i) => IC.parser.execute(row, i, settings));
    };

    // --- Build dependency information ---
    const assignedRefsByRow = {};   // maps row index → array of variable names assigned in that row
    const assignedRefsByName = {};  // maps variable name → set of row indices where it is assigned
    const rowDependencyGraph = {}; // row index → set of row indices it depends on
    const missingReferences = {};
    const finalRedo = new Set();
    const redoBecauseCustomUnitDefined = {}; // if an autounit is defined, mark the row for re-execution

    const phaseBuildDependencies = () => {

      // store assigned refs
      results.forEach((result, i) => {
        // Build mapping: row index → assigned variable names.
        assignedRefsByRow[i] = result.assigned_references.map(refObj => refObj?.name ?? refObj);

        // Build mapping: variable name → row indices.
        result.assigned_references.forEach(refObj => {
          let name = refObj?.name ?? refObj;
          assignedRefsByName[name] ||= new Set();
          assignedRefsByName[name].add(i);
        });
      });

      // For each row, add dependencies from missing references, custom units, and explicit references.
      results.forEach((result, currentRow) => {
        // Process missing references.
        result.missing_references.forEach(missingRef => {
          const currentRowDependsOnRows = assignedRefsByName[missingRef];
          if (currentRowDependsOnRows) {
            currentRowDependsOnRows.forEach(rowIndex => {
              (rowDependencyGraph[currentRow] ||= new Set()).add(Number(rowIndex));
            });
          } else {
            missingReferences[missingRef] ||= new Set();
            missingReferences[missingRef].add(currentRow);
            // If the missing reference isn't one of the predefined units, mark for re-evaluation.
            if (!IC.predefinedUnit(missingRef)) {
              finalRedo.add(currentRow);
            }
          }
        });

        // Process custom units.
        result.custom_units.forEach(customUnitName => {
          const currentRowDependsOnRows = assignedRefsByName[customUnitName];
          if (currentRowDependsOnRows) {
            currentRowDependsOnRows.forEach(rowIndex => {
              (rowDependencyGraph[currentRow] ||= new Set()).add(Number(rowIndex));
            });
            redoBecauseCustomUnitDefined[currentRow] = true;
            finalRedo.add(currentRow);
          }

          // Also check for singular/plural forms.
          let singular = IC.stringSingularize(customUnitName);
          let plural = IC.stringPluralize(customUnitName);
          if (assignedRefsByName[singular] || assignedRefsByName[plural]) {
            redoBecauseCustomUnitDefined[currentRow] = true;
            finalRedo.add(currentRow);
          }
        });

        // Process regular references.
        result.references.forEach(ref => {
          (assignedRefsByName[ref] || []).forEach(rowIndex => {
            if (Number(rowIndex) !== currentRow) {
              (rowDependencyGraph[currentRow] ||= new Set()).add(Number(rowIndex));
            }
          });
        });
      });
    }

    // --- Resolve broken results (missing dependencies, etc.) ---
    const phaseResolveDependencies = () => {

      function topologicalSort(graph) {
        const result = [];
        const visited = new Set();

        function dfs(node) {
          if (visited.has(node)) {
            return;
          }
          visited.add(node);
          if (graph[node]) {
            graph[node].forEach(dfs);
          }
          result.push(Number(node));
        }

        Object.keys(graph).forEach(dfs);
        return result;
      }

      // Sort and collect rows that need to be redone.
      const sortedRedos = topologicalSort(rowDependencyGraph);
      Object.keys(missingReferences).forEach(missingRef => {
        if (assignedRefsByName[missingRef]) {
          assignedRefsByName[missingRef].forEach(rowIndex => {
            finalRedo.add(rowIndex);
          });
        }
      });

      let redone = new Set();

      // --- Second pass: re-execute rows that need updating ---
      // We run up to 2 passes to handle cascading dependencies.
      // Process rows in sequential order to ensure reassignments work correctly.
      for (var pass = 0; pass < 2; pass++) {
        const rowsReexecutedThisPass = new Set();
        const varsModifiedThisPass = new Set();

        // Process rows in order to maintain sequential execution semantics
        rows.forEach((row, rowId) => {
          // Check if this row should be re-executed
          const needsRedo = IC.parser.shouldRedo(results[rowId]);

          // Check if this row uses any variables that were modified earlier in this pass
          const rowReferences = results[rowId].references || [];
          const dependsOnModifiedVars = rowReferences.some(ref =>
            varsModifiedThisPass.has(ref)
          );

          // Check if any of this row's assigned variables were modified earlier in this pass
          const assignsModifiedVars = (assignedRefsByRow[rowId] || []).some(varName =>
            varsModifiedThisPass.has(varName)
          );

          const dependsOnRedoneRow = Array.from(rowDependencyGraph[rowId] || []).some(i =>
            redone.has(i) || rowsReexecutedThisPass.has(i)
          );
          const inFinalRedo = finalRedo.has(rowId);
          const dependsOnFinalRedo = Array.from(rowDependencyGraph[rowId] || []).some(i =>
            finalRedo.has(i)
          );
          const isCustomUnitRow = redoBecauseCustomUnitDefined[rowId];

          if (needsRedo || dependsOnModifiedVars || assignsModifiedVars || dependsOnRedoneRow ||
              inFinalRedo || dependsOnFinalRedo || isCustomUnitRow) {
            rowsReexecutedThisPass.add(rowId);
            redone.add(rowId);
            results[rowId] = IC.parser.execute(rows[rowId], rowId, settings);

            // Track which variables were modified this pass
            (assignedRefsByRow[rowId] || []).forEach(varName => {
              varsModifiedThisPass.add(varName);
            });
          }
        });

        // If nothing was re-executed this pass, we're done
        if (rowsReexecutedThisPass.size === 0) {
          break;
        }
      }
    }

    // --- Goalseek solver ---
    const phaseSolveGoalseeks = () => {
      const debug = (...args) => {
        if (false && OPTION_DEBUG_INFO) {
          console.log(...args);
        }
      };

      // Find rows with goalseek commands
      const goalseekRows = results.filter(r => r?.result?.type === "goalseek").map(r => r.i);
      if (goalseekRows.length === 0) return;

      goalseekRows.forEach(gsRowIndex => {
        const savedEnv = Object.assign({}, IC.envGet()); // Save environment state

        const gsResult = results[gsRowIndex];
        const { targetVar, targetValue, vars: specifiedVars } = gsResult?.result ?? {};
        if (!gsResult?.result) return;

        // Find row that defines target variable
        const targetRowIndex = (assignedRefsByName[targetVar] ?? new Set()).values().next().value;
        if (targetRowIndex === undefined) {
          console.warn(`No row found that defines target variable ${targetVar}`);
          return;
        }

        // dependent parameters, like y = ax^2
        const paramsToRecompute = new Set();

        // Helper to check if a variable name is a row reference (e.g. "r1", "r2", etc.)
        const isNumericRowReference = ref => /^r\d+$/.test(ref);
        const findRootParameters = (rowIndex, visited = new Set()) => {
          if (visited.has(rowIndex)) {
            return new Set(); // cycle detected
          }
          visited.add(rowIndex);

          const localParams = new Set();
          const rowText = rows[rowIndex];
          const refs = (assignedRefsByRow[rowIndex] || []).filter(ref => typeof ref === 'string');
          const hasNoDependency = !rowDependencyGraph[rowIndex] || rowDependencyGraph[rowIndex].size === 0;

          // First, try to extract a proper named parameter (e.g. "x = 3000")
          const namedParam = IC.parser.getRowParameterName(rowText);
          if (hasNoDependency && namedParam) {
            debug(`Row ${rowIndex} has named parameter:`, namedParam);
            localParams.add(namedParam);
          } else {
            // extract references, add to recompute list
            const properRefs = refs.filter(ref => !isNumericRowReference(ref) && assignedRefsByName[ref] && hasNoDependency);
            if (properRefs.length > 0) {
              debug(`Row ${rowIndex} has proper references:`, properRefs);
              properRefs.forEach(ref => localParams.add(ref));
            } else {
              // Fallback: for each row reference, use the referenced row's text (adjusting for 0-index).
              refs.forEach(ref => {
                debug(`Row ${rowIndex} has row reference:`, ref);
                paramsToRecompute.add(ref);

                if (!hasNoDependency) {
                  debug(`Row ${rowIndex} has dependency, adding to recompute list:`, ref);
                  return;
                }

                // TODO: row references don't appear in our data structures, track this down
                if (isNumericRowReference(ref) && hasNoDependency) {
                  const refRowIndex = parseInt(ref.slice(1), 10) - 1; // adjust: r1 -> index 0, etc.
                  const refRowText = rows[refRowIndex];
                  const hasOtherRowReference = rowText.match(/\br\d+\b/g);
                  if (IC.parser.stringCanBeIncremented(refRowText) && !hasOtherRowReference) {
                    debug(`Row ${rowIndex} can be a param:`, ref, refRowText);
                    paramsToRecompute.delete(ref);
                    localParams.add(ref);
                  }
                }
              });
            }
          }

          // Process dependencies recursively
          const deps = rowDependencyGraph[rowIndex] || new Set();
          deps.forEach(depIndex => {
            const depParams = findRootParameters(depIndex, visited);
            depParams.forEach(p => localParams.add(p));
          });

          return localParams;
        };

        // Get parameters to vary - either specified or found by walking dependency tree
        const parameterNames = specifiedVars ?
          (Array.isArray(specifiedVars) ? specifiedVars : [specifiedVars]) :
          Array.from(findRootParameters(targetRowIndex));

        // Initialize parameter values
        const parameters = Object.fromEntries(
          parameterNames.map(name => [name, IC.envGetVariable(name)])
        );

        // debug(`Goalseek: ${targetVar} = ${targetValue}, parameters:`, parameters, 'paramsToRecompute:', paramsToRecompute);
        const originalValues = { ...parameters };

        // Solver configuration
        const solverConfig = {
          maxIterations: 30 * parameterNames.length,
          tolerance: 1.1e-6 * Math.abs(targetValue),
          tolerancePercent: 0.01,
          learningRate: Math.pow(2, -(parameterNames.length - 1))
        };

        // Helper to update a variable and its row reference
        const updateParameter = (name, value) => {
          IC.envSetVariable(name, value);
          assignedRefsByName[name]?.forEach(rowIndex => {
            IC.envSetVariable(`r${rowIndex + 1}`, value);
          });
        };

        // Helper to evaluate target with updated parameters
        const evaluateTarget = () => {
          // Get rows that need recalculation in dependency order
          const recalcRows = (() => {
            const chain = new Set();
            const visited = new Set();

            const visit = (index) => {
              if (visited.has(index)) return;
              visited.add(index);
              (rowDependencyGraph[index] ?? new Set()).forEach(visit);
              chain.add(index);
            };

            visit(targetRowIndex);
            return [...chain];
          })();

          // Only recalculate dependent rows
          recalcRows.forEach(index => {
            const hasDependentCalculation = assignedRefsByRow[index]?.filter(item => paramsToRecompute.has(item));
            if (hasDependentCalculation.length) {
              IC.parser.execute(rows[index], index, settings);
            }
          });

          return IC.val(IC.parser.execute(rows[targetRowIndex], targetRowIndex, settings).result);
        };

        // Helper to detect if a number is "nearly" a clean value
        const findCleanValue = (val) => {
          // Try rounding to nearest 0.5
          const nearestHalf = Math.round(val * 2) / 2;
          if (Math.abs(nearestHalf - val) < 0.0001) {
            return nearestHalf;
          }

          // Try rounding to nearest integer
          const nearestInt = Math.round(val);
          if (Math.abs(nearestInt - val) < 0.0001) {
            return nearestInt;
          }

          return ICLib.roundToDecimal(val, 6);
        };

        // Run solver
        let solved = false;
        let error = null;
        let iterations = 0;
        let solvedValue = null;

        for (; iterations < solverConfig.maxIterations; iterations++) {
          const currentValue = evaluateTarget();
          error = targetValue - currentValue;

          if (Math.abs(error) < solverConfig.tolerance) {
            solved = true;
            solvedValue = currentValue;
            break;
          }

          // Update each parameter using Newton-Raphson method
          const paramsToVary = Object.keys(parameters).filter(param => param !== targetVar);
          paramsToVary.forEach(param => {
            const currentParamValue = IC.val(IC.envGetVariable(param));
            const delta = 0.01 * (Math.abs(currentParamValue) + 0.001);

            // Calculate gradient using central difference
            updateParameter(param, currentParamValue + delta);
            const plusValue = evaluateTarget();

            updateParameter(param, currentParamValue - delta);
            const minusValue = evaluateTarget();

            const gradient = (plusValue - minusValue) / (2 * delta);

            // Update parameter
            const newValuePrecise = gradient === 0 ? currentParamValue :
              currentParamValue - solverConfig.learningRate * ((currentValue - targetValue) / gradient);

            let newValueRounded = findCleanValue(IC.val(newValuePrecise));

            // parameters[param] = ICLib.roundToDecimal(IC.val(newValue), 4);
            // parameters[param] = IC.val(newValue);
            parameters[param] = newValueRounded;
            updateParameter(param, parameters[param]);
          });
        }

        // Accept solution if close enough
        if (!solved && Math.abs(error ?? 0) / Math.abs(targetValue) < solverConfig.tolerancePercent) {
          solved = true;
        }

        // attempt rounded solution 
        if (solved) {
          // Save the original solution in case rounding doesn't work
          const originalSolution = { ...parameters };
          let roundedSolved = false;

          // Try rounding to different decimal places
          for (let decimals = 0; decimals <= 3 && !roundedSolved; decimals++) {
            // Round all parameters
            Object.keys(parameters).forEach(param => {
              const rounded = ICLib.roundToDecimal(parameters[param], decimals);
              parameters[param] = rounded;
              updateParameter(param, rounded);
            });

            // Check if rounded solution still works
            const roundedValue = evaluateTarget();
            const roundedError = Math.abs(targetValue - roundedValue);

            if (roundedError < solverConfig.tolerance) {
              roundedSolved = true;
            }
          }

          // If rounding didn't work, restore original solution
          if (!roundedSolved) {
            Object.entries(originalSolution).forEach(([param, value]) => {
              parameters[param] = value;
              updateParameter(param, value);
            });
          }
        }

        // Update goalseek result
        results[gsRowIndex].eval_result = results[gsRowIndex].final_result = {
          vars: parameters,
          solved,
          type: "goalseek",
          targetValue,
          targetVar,
          solvedValue,
          dependentVars: parameterNames,
          error,
          errorPct: Math.abs((error ?? 0) / targetValue),
          steps: iterations
        };

        // TODO: update rows that reference this goalseek result?

        // Restore original state
        Object.entries(originalValues).forEach(([name, value]) => {
          IC.envSetVariable(name, value);
        });
        IC.envSet(savedEnv);
      });
    };

    // chart title data may be out of sync
    function phaseResolveChartData() {
      // scan each of the reults, if it's an object with type 'chart', set the title
      // the reason is that title changes don't cause a recalc
      results.forEach((result, i) => {
        if (result?.result?.startIndex !== undefined) {
          result.result.data.forEach((data, j) => {
            data.label = results[result.result.startIndex + j - 1].title || "";
          });
        }
      });
    }

    // --- Populate assignment results for merged if/else blocks ---
    const phasePopulateMergedAssignments = () => {
      // For each merged if/else block, populate values on their original lines
      Object.keys(mergeMetadata).forEach(startIndexStr => {
        const startIndex = Number(startIndexStr);
        const metadata = mergeMetadata[startIndex];

        if (metadata.type !== 'if-else-block') return;

        // Determine which branch executed by checking assignments or re-evaluating condition
        let executedBranchStart = null;
        let executedBranchEnd = null;

        // Try to determine which branch by looking at the structure
        // Find where "} else {" appears in the original lines
        let elseIndex = null;
        for (let i = 0; i < metadata.originalLines.length; i++) {
          const trimmed = metadata.originalLines[i].content.trim();
          if (/^}\s*else\s*\{/.test(trimmed) || trimmed === '} else {') {
            elseIndex = i;
            break;
          }
        }

        // Get the variables that were assigned during execution of this block
        const assignedVars = results[startIndex].assigned_references || [];

        // Try to determine which branch executed by checking if any assignments in the if-branch match
        let ifBranchExecuted = null;

        // First try: check assignments if they exist
        if (elseIndex !== null && assignedVars.length > 0) {
          // Check if-branch (between first line and else)
          for (let i = 1; i < elseIndex; i++) {
            const { index, content } = metadata.originalLines[i];
            const lineAssignments = IC.parser.extractAssignmentsFromLine(content);

            for (const varName of lineAssignments) {
              if (assignedVars.some(ref => (ref?.name || ref) === varName)) {
                try {
                  const envBefore = Object.assign({}, IC.envGet());
                  const lineResult = IC.parseAndEval(content);
                  IC.envSet(envBefore);
                  const actualValue = IC.envGetVariable(varName);

                  if (IC.isValidEvalResult(actualValue) &&
                      IC.isValidEvalResult(lineResult) &&
                      IC.val(actualValue) === IC.val(lineResult)) {
                    ifBranchExecuted = true;
                    break;
                  }
                } catch (e) {}
              }
            }
            if (ifBranchExecuted !== null) break;
          }

          // If no if-branch assignment matched, check else-branch
          if (ifBranchExecuted === null) {
            for (let i = elseIndex + 1; i < metadata.originalLines.length; i++) {
              const { index, content } = metadata.originalLines[i];
              const lineAssignments = IC.parser.extractAssignmentsFromLine(content);

              for (const varName of lineAssignments) {
                if (assignedVars.some(ref => (ref?.name || ref) === varName)) {
                  try {
                    const envBefore = Object.assign({}, IC.envGet());
                    const lineResult = IC.parseAndEval(content);
                    IC.envSet(envBefore);
                    const actualValue = IC.envGetVariable(varName);

                    if (IC.isValidEvalResult(actualValue) &&
                        IC.isValidEvalResult(lineResult) &&
                        IC.val(actualValue) === IC.val(lineResult)) {
                      ifBranchExecuted = false;
                      break;
                    }
                  } catch (e) {}
                }
              }
              if (ifBranchExecuted !== null) break;
            }
          }
        }

        // Second try: if no assignments or couldn't determine from assignments, parse and evaluate the condition
        if (ifBranchExecuted === null) {
          try {
            // Extract the condition from the if statement
            // Original first line looks like: "if (temperature > 70) {"
            const firstLine = metadata.originalLines[0].content;
            const condMatch = firstLine.match(/if\s*\((.*?)\)\s*\{/);
            if (condMatch) {
              const condition = condMatch[1];
              const condResult = IC.parseAndEval(condition);
              ifBranchExecuted = IC.val(condResult) ? true : false;
            }
          } catch (e) {
            // If we can't evaluate the condition, we can't determine which branch
          }
        }

        // Determine branch boundaries
        if (elseIndex !== null) {
          if (ifBranchExecuted === true) {
            executedBranchStart = 1; // After "if (cond) {"
            executedBranchEnd = elseIndex - 1; // Before "} else {"
          } else if (ifBranchExecuted === false) {
            executedBranchStart = elseIndex + 1; // After "} else {"
            executedBranchEnd = metadata.originalLines.length - 2; // Before final "}"
          }
        } else {
          // No else branch - if the if executed, show the if body
          if (ifBranchExecuted === true) {
            executedBranchStart = 1; // After "if (cond) {"
            executedBranchEnd = metadata.originalLines.length - 2; // Before final "}"
          }
        }

        // Clear the result for the if statement itself
        results[startIndex] = {
          ...results[startIndex],
          eval_result: null,
          final_result: '',
          result: null
        };

        // If we determined which branch executed, populate all lines in that branch
        if (executedBranchStart !== null && executedBranchEnd !== null) {
          for (let i = executedBranchStart; i <= executedBranchEnd; i++) {
            const { index, content } = metadata.originalLines[i];
            const trimmed = content.trim();

            // Skip structural lines
            if (!trimmed || /^[{}]$/.test(trimmed)) continue;

            // Extract comment
            const { comment } = IC.parser.processComment(content);

            // Try to evaluate this line
            try {
              const envBefore = Object.assign({}, IC.envGet());
              const lineResult = IC.parseAndEval(content);
              IC.envSet(envBefore);

              if (IC.isValidEvalResult(lineResult)) {
                results[index] = {
                  ...results[index],
                  eval_result: IC.val(lineResult),
                  final_result: IC.parser.formatResult(lineResult, settings),
                  result: lineResult,
                  input: initialRows[index],
                  comment: comment
                };
              }
            } catch (e) {
              // If evaluation fails, skip this line
            }
          }
        }
      });
    };

    // -- main flow --
    phaseSetup();
    phaseInitialResults();
    phaseBuildDependencies();
    phaseResolveDependencies();
    phaseSolveGoalseeks();
    phaseResolveChartData();
    phasePopulateMergedAssignments();

    return { results: results, env: IC.envGet() };
  },

  // 2 => 2, but 2.016 => 2.02
  toFixedIfNecessary(value, dp) {
    return +parseFloat(value).toFixed(dp);
  },

  // simple parse fallback for scratchpad-style parsing: food $15 + clothes $50
  parseSimple(inputStr) {

    // conversion or function call, ignore
    if (inputStr.match(/[-]>|[(]/)) {
      return null;
    }

    // is encoded unicode string, ignore
    if (inputStr.match(/\\u/)) {
      return null;
    }

    // lex string, remove all IDs. Keep operators and numbers
    const allowedTokens = { decimal: true, oct: true, bin: true, hex: true, symbol: true, percentOp: true, ws: true, id: true };
    const tokens = IC.parser.tokenize(inputStr, LEXER);
    let str = tokens.map((token) => {
      if (!allowedTokens[token.type]) {
        return '';
      }

      if (token.type == "id") {
        let num = token.text.match(/-?\d+\.?\d*/);
        if (num && num[0]) {
          return num[0]
        } else if (!IC.predefinedUnit(token.text.trim())) {
          return '';
        }
      }
      return token.text;
    }).join(' ');
    return str;
  },

  applyNumberFormatting: function (result, calc_settings) {
    let final_result = result.final_result;

    // no change
    if (typeof final_result === "string" || !IC.isValidEvalResult(final_result)) {
      return;
    }

    if (typeof final_result == "boolean" || final_result == Infinity || final_result == -Infinity) {
      result.final_result = final_result.toString();
      return;
    }

    if (typeof final_result == "number") {
      if (isNaN(final_result)) {
        result.final_result = "Number undefined";
        return;
      }

      let skipDollarSign = result.type.toLowerCase().match(/USD/i) || (IC.hasType(result.result) && IC.typeHasUnitInCategory(result?.result?.t, "dollar"));

      let opts = {};
      if (result?.format?.code && !skipDollarSign) {
        opts = { ...opts, style: 'currency', currency: result.format.code, maximumFractionDigits: 2 };

        // TODO: move this to the code detection
        IC.log(`${result.format.symbol}: currency format ($$: no symbol)`);
      } else {
        opts.maximumFractionDigits = 8;
        if (final_result != 0 && Math.abs(final_result) < 1e-7 || Math.abs(final_result) > 1e18) {
          opts.notation = "scientific";
        }
      }

      if (result.type && LIB.InstaCalc.Unit?.currencies[result.type.toLowerCase()]) {
        // 1 VND should be a decimal number of USD
        if (Math.abs(IC.val(final_result)) > 1) {
          opts.maximumFractionDigits = 2;
        }
      } else if (result.type && Math.abs(final_result) > 1) {
        // if a unit conversion or calculation, don't show full precision; unit label takes up room too
        opts.maximumFractionDigits = 4;
      }

      if (result.format == "round2") {
        opts.maximumFractionDigits = 2;
      }

      /*
      -1: no rounding
      0: round to whole number
      1: round to .1
      2: round to .01
      */
      let rounding = calc_settings.rounding;

      if (typeof (rounding) === "number" && rounding >= 0) {
        opts.maximumFractionDigits = rounding;
        opts.minimumFractionDigits = rounding;
      }

      // format number
      let locale = calc_settings.locale || 'en-US';
      let displayString = IC.parser.applyRawNumberFormatting(final_result, locale, opts);

      if (opts.notation == "scientific") {
        displayString = displayString.replace("E", "e");
      }

      result.final_result = displayString;
      return;
    }

    return;
  },

  // number formatting for log entry
  applyLogNumberFormatting: function (n) {
    return IC.parser.applyRawNumberFormatting(n, IC.envGetSettings()?.locale || "en-US", { maximumFractionDigits: 4 });
  },

  applyRawNumberFormatting: function (result, locale, opts = {}) {
    IC._nfCache ||= {};
    let key = JSON.stringify({ locale, opts });
    let nf = IC._nfCache[key] ||= new Intl.NumberFormat(locale, opts);
    let displayString = nf.format(result);
    return displayString;
  },

  recalculate: function (calc, includeEnv = false) {
    let rows = calc.rows.map((row) => row.text || "");

    var settings = {
      rounding: calc.rounding,
      // @ts-ignore
      locale: calc.locale || "en-US",
      id: calc.id
    };

    let { results, env } = IC.parser.executeRows(rows, settings);

    let resultList = results.map((result, i) => {
      return {
        input: rows[i],
        result: result.final_result,
        comment: result.comment,
        // UI metadata (evaluated/normalized in parser)
        ui: result.ui,
        ui_comment: result.ui_comment,
        ui_input_type: result.ui_input_type,
        ui_display_value: result.ui_display_value,
        ui_write: result.ui_write,
        type: result.type,
        is_custom_type: result.is_custom_type,
        is_custom_object: result.is_custom_object,
        is_custom_function: result.is_custom_function,
        is_array: result.is_array,
        title: result.title,
        processed: result.processed,
        process_time_ms: result.process_time_ms,
        log: result.log,
        output_msg: result.output_msg
      };
    });

    return includeEnv ? { results: resultList, env } : resultList;
  },
};

// IC.api - Proxy layer for external access to IC internals
IC.api = {
  // Calculation
  recalculate: function (calc, envOnly) {
    return IC.parser.recalculate(calc, envOnly);
  },

  // Formatting
  formatValue: function (value) {
    if (IC.isICObject(value)) {
      return IC.parser.formatResultAsSingleLine(value);
    }
    return value;
  },

  formatFinance: function (value) {
    return IC.parser.formatAsFinance(value);
  },

  formatNumber: function (value) {
    let n = (typeof value === "number") ? value : IC.makeNumber(value ?? 0);
    return n.toLocaleString(undefined, { maximumFractionDigits: (Math.abs(n) > 100 ? 2 : 6) });
  },

  // Parameters
  getParameter: function (calc, rowIndex) {
    return IC.parser.getRowParameter(calc, rowIndex);
  },

  getParameterName: function (input) {
    return IC.parser.getRowParameterName(input);
  },

  getParameterNameForDisplay: function (input) {
    const name = IC.parser.getRowParameterName(input);
    return name ? IC.envNormalizeTitle(name) : name;
  },

  buildParameterText: function (text, value) {
    return IC.parser.buildRowParameterText(text, value);
  },

  findParameterRow: function (calc, varName) {
    for (let rowIndex = 0; rowIndex < calc.rows.length; rowIndex++) {
      const row = calc.rows[rowIndex];
      const parameterName = IC.parser.getRowParameterName(row.text);
      if (parameterName && IC.canonicalName(parameterName) === varName) {
        return rowIndex;
      }
    }
    return null;
  },

  // Text Processing
  processSymbols: function (text) {
    return IC.parser.processSymbols(text);
  },

  appendBeforeComment: function (text, addition) {
    return IC.parser.appendTextBeforeComment(text, addition);
  },

  replaceBeforeComment: function (text, newText) {
    return IC.parser.replaceTextBeforeComment(text, newText);
  },

  extractAssignedSnippet: function (text) {
    return IC.parser.extractAssignedSnippet(text);
  },

  // Incrementing
  canIncrement: function (text) {
    return IC.parser.stringCanBeIncremented(text);
  },

  increment: function (text, direction) {
    return IC.parser.incrementNumberInString(text, direction);
  },

  // Utilities
  isWorkerLoaded: function () {
    return IC.WORKER_LOADED;
  }
};

const OPTION_DEBUG_INFO = window?.location?.href?.includes("debug") || window?.location?.href?.includes("src/grammar/") || false;

/* extra library functions */
const OPTION_MEMO_OFF = window?.location?.href?.includes("memo") ?? false;

const memoize = (func) => {
  const cache = new Map();
  return (...args) => {
    const argsKey = JSON.stringify(args);

    if (!cache.has(argsKey)) {
      cache.set(argsKey, func(...args));
    }

    return cache.get(argsKey);
  };
};

// Row-aware memoize that includes current row index in cache key
const memoizeRowAware = (func) => {
  const cache = new Map();
  return (...args) => {
    const argsKey = JSON.stringify([IC.info.rowIndex, ...args]);

    if (!cache.has(argsKey)) {
      cache.set(argsKey, func(...args));
    }

    return cache.get(argsKey);
  };
};

function memoizeWithNewObject(func) {
  const memoizedFunc = memoize(func);
  return function (...args) {
    const result = memoizedFunc.apply(this, args);
    if (typeof result === 'object') {
      return JSON.parse(JSON.stringify(result));
    }
    return result;
  }
}

let OPTION_TIMING = false;
if (window && window?.location?.href?.includes("timing")) {
  OPTION_TIMING = true;
}

const ctime = (name) => {
  if (OPTION_TIMING) {
    console.time(name);
  }
};

const ctimeEnd = (name) => {
  if (OPTION_TIMING) {
    console.timeEnd(name);
  }
};

// UI Components metadata parsing
class UIMetadataParser {
  // Extract the leading JSON object from a comment, allowing trailing text like: { ... } some note
  static extractLeadingJSONObjectPos(s) {
    let i = s.indexOf('{');
    if (i < 0) return null;
    let depth = 0;
    let inStr = false;
    let esc = false;
    for (let j = i; j < s.length; j++) {
      const ch = s[j];
      if (inStr) {
        if (esc) { esc = false; continue; }
        if (ch === '\\') { esc = true; continue; }
        if (ch === '"') { inStr = false; }
        continue;
      }
      if (ch === '"') { inStr = true; continue; }
      if (ch === '{') depth++;
      else if (ch === '}') {
        depth--;
        if (depth === 0) {
          return { start: i, end: j };
        }
      }
    }
    return null;
  }

  // Parse function-call syntax: checkbox(), dropdown([a,b,c]), slider(0, 100, step: 5)
  static parseFunctionCall(s) {
    // Match pattern: functionName(args)
    const match = s.match(/^([a-zA-Z_][a-zA-Z0-9_]*)\s*\((.*)\)\s*$/s);
    if (!match) return null;

    const controlType = match[1];
    const argsStr = match[2].trim();

    // Map of recognized control types
    const validTypes = ['checkbox', 'dropdown', 'radio', 'slider', 'range', 'date', 'time', 'datetime', 'multiselect'];
    if (!validTypes.includes(controlType)) return null;

    // Build base result
    const result = { ui: controlType };

    // Empty args → simple control like checkbox()
    if (!argsStr) return result;

    // Parse arguments using forgiving parser
    const parsedArgs = UIMetadataParser.parseFunctionArgs(argsStr);
    if (!parsedArgs) return result;

    // Handle specific control types
    if (controlType === 'slider' || controlType === 'range') {
      // slider can be: slider(min, max, step) or slider({min, max, step}) or slider(0, 100, step: 5)
      if (parsedArgs.isObject) {
        // Object style: slider({min: 0, max: 100, step: 1})
        if ('min' in parsedArgs.obj) result.min = parsedArgs.obj.min;
        if ('max' in parsedArgs.obj) result.max = parsedArgs.obj.max;
        if ('step' in parsedArgs.obj) result.step = parsedArgs.obj.step;
      } else {
        // Positional or named params
        const { positional, named } = parsedArgs;
        if (named.min !== undefined) result.min = named.min;
        else if (positional[0] !== undefined) result.min = positional[0];

        if (named.max !== undefined) result.max = named.max;
        else if (positional[1] !== undefined) result.max = positional[1];

        if (named.step !== undefined) result.step = named.step;
        else if (positional[2] !== undefined) result.step = positional[2];
      }
    } else if (controlType === 'dropdown' || controlType === 'radio' || controlType === 'multiselect') {
      // Expect options array or object: dropdown([a,b,c]) or dropdown({Label: value})
      // OR comma-separated: dropdown(15, 20, 30)
      if (parsedArgs.isObject) {
        result.options = parsedArgs.obj;
      } else if (parsedArgs.positional.length > 0 && Array.isArray(parsedArgs.positional[0])) {
        result.options = parsedArgs.positional[0];
      } else if (parsedArgs.positional.length > 0 && typeof parsedArgs.positional[0] === 'object') {
        result.options = parsedArgs.positional[0];
      } else if (parsedArgs.positional.length > 0) {
        // Treat all positional args as options array
        result.options = parsedArgs.positional;
      }
    }

    return result;
  }

  // Parse function arguments with forgiving syntax
  // Returns: { isObject: bool, obj: {...}, positional: [...], named: {...} }
  static parseFunctionArgs(argsStr) {
    // Check if it's a single object: {key: value, ...}
    if (argsStr.trim().startsWith('{')) {
      const parsed = UIMetadataParser.parseUIMetadata(argsStr);
      if (parsed && typeof parsed === 'object') {
        return { isObject: true, obj: parsed, positional: [], named: {} };
      }
    }

    // Parse comma-separated args with optional names
    const positional = [];
    const named = {};

    // Split by top-level commas (respecting brackets and braces)
    const args = UIMetadataParser.splitArgs(argsStr);

    for (const arg of args) {
      const colonIdx = arg.indexOf(':');
      if (colonIdx > 0) {
        // Named param: name: value
        const name = arg.slice(0, colonIdx).trim();
        const valueStr = arg.slice(colonIdx + 1).trim();
        named[name] = UIMetadataParser.parseArgValue(valueStr);
      } else {
        // Positional param
        positional.push(UIMetadataParser.parseArgValue(arg.trim()));
      }
    }

    return { isObject: false, obj: {}, positional, named };
  }

  // Split comma-separated arguments respecting brackets/braces
  static splitArgs(s) {
    const parts = [];
    let current = '';
    let depth = 0;
    let inStr = false;
    let esc = false;

    for (let i = 0; i < s.length; i++) {
      const ch = s[i];

      if (inStr) {
        current += ch;
        if (esc) { esc = false; continue; }
        if (ch === '\\') { esc = true; continue; }
        if (ch === '"' || ch === "'") { inStr = false; }
        continue;
      }

      if (ch === '"' || ch === "'") {
        inStr = true;
        current += ch;
        continue;
      }

      if (ch === '{' || ch === '[' || ch === '(') {
        depth++;
        current += ch;
      } else if (ch === '}' || ch === ']' || ch === ')') {
        depth--;
        current += ch;
      } else if (ch === ',' && depth === 0) {
        parts.push(current);
        current = '';
      } else {
        current += ch;
      }
    }

    if (current) parts.push(current);
    return parts.map(p => p.trim()).filter(p => p);
  }

  // Parse a single argument value (could be number, string, array, object, or identifier)
  static parseArgValue(s) {
    s = s.trim();
    if (!s) return undefined;

    // Try number
    if (/^-?\d+(\.\d+)?$/.test(s)) {
      return Number(s);
    }

    // Try boolean
    if (s === 'true') return true;
    if (s === 'false') return false;
    if (s === 'null') return null;

    // Try array: [a, b, c]
    if (s.startsWith('[') && s.endsWith(']')) {
      const inner = s.slice(1, -1);
      const elements = UIMetadataParser.splitArgs(inner);
      return elements.map(el => UIMetadataParser.parseArgValue(el));
    }

    // Try object: {key: value}
    if (s.startsWith('{') && s.endsWith('}')) {
      return UIMetadataParser.parseUIMetadata(s);
    }

    // Try quoted string - preserve quotes for raw form so write-back matches original format
    if ((s.startsWith('"') && s.endsWith('"')) || (s.startsWith("'") && s.endsWith("'"))) {
      return s;  // Keep quotes to preserve user's formatting intent
    }

    // Bare identifier → keep as string (will be evaluated later via evalToPrimitive)
    return s;
  }

  // Parse UI metadata with multiple fallback strategies
  static parseUIMetadata(s) {
    // FIRST: Try function-call syntax: checkbox(), dropdown([a,b,c]), slider(0, 100, step: 5)
    const fnCallResult = UIMetadataParser.parseFunctionCall(s.trim());
    if (fnCallResult) return fnCallResult;

    // Skip IC.parseAndEval for UI metadata - it mangles object literals with unquoted keys
    // Go straight to JSON parsing with fallbacks

    // Try strict JSON
    try {
      return JSON.parse(s);
    } catch (_) { /* try relaxed */ }

    let t = s;
    // Quote bare keys: { ui: "checkbox" } -> { "ui": "checkbox" }
    t = t.replace(/([\{,]\s*)([A-Za-z_][A-Za-z0-9_-]*)\s*:/g, '$1"$2":');

    // Convert single-quoted strings to double-quoted
    t = t.replace(/'([^'\\]*(?:\\.[^'\\]*)*)'/g, function (_m, inner) {
      return '"' + inner.replace(/\\"/g, '"').replace(/"/g, '\\"') + '"';
    });

    // Quote bare string values (but not numbers, arrays, objects, or booleans)
    // Match: colon followed by optional whitespace, then bare identifier, then end/comma/whitespace
    t = t.replace(/:\s*([A-Za-z_][A-Za-z0-9_-]*)(\s*[,\}])/g, function(match, identifier, after) {
      // Don't quote true/false/null
      if (identifier === 'true' || identifier === 'false' || identifier === 'null') {
        return ': ' + identifier + after;
      }
      // Quote everything else
      return ': "' + identifier + '"' + after;
    });

    try {
      return JSON.parse(t);
    } catch (e) {
      // Final fallback: loose key:value parser allowing expression values
      return UIMetadataParser.looseParse(s);
    }
  }

  // Loose parser for key:value pairs with expression support
  static looseParse(block) {
    // Expect a leading { ... }
    let start = block.indexOf('{');
    let end = block.lastIndexOf('}');
    if (start < 0 || end <= start) return null;
    const inner = block.slice(start + 1, end);
    // Split by top-level commas
    const parts = [];
    let depth = 0, inStr = false, esc = false, cur = '';
    for (let i = 0; i < inner.length; i++) {
      const ch = inner[i];
      if (inStr) {
        cur += ch;
        if (esc) { esc = false; continue; }
        if (ch === '\\') { esc = true; continue; }
        if (ch === '"') inStr = false;
        continue;
      }
      if (ch === '"') { inStr = true; cur += ch; continue; }
      if (ch === '{' || ch === '[' || ch === '(') depth++;
      else if (ch === '}' || ch === ']' || ch === ')') depth--;
      if (ch === ',' && depth === 0) { parts.push(cur.trim()); cur = ''; continue; }
      cur += ch;
    }
    if (cur.trim()) parts.push(cur.trim());
    const obj = {};
    for (const p of parts) {
      // split on first colon at top level
      let d = 0, idx = -1; inStr = false; esc = false;
      for (let i = 0; i < p.length; i++) {
        const ch = p[i];
        if (inStr) {
          if (esc) { esc = false; continue; }
          if (ch === '\\') { esc = true; continue; }
          if (ch === '"') inStr = false;
          continue;
        }
        if (ch === '"') { inStr = true; continue; }
        if (ch === '{' || ch === '[' || ch === '(') d++;
        else if (ch === '}' || ch === ']' || ch === ')') d--;
        if (ch === ':' && d === 0) { idx = i; break; }
      }
      if (idx === -1) continue;
      const rawKey = p.slice(0, idx).trim();
      const rawVal = p.slice(idx + 1).trim();
      const key = rawKey.replace(/^['"]|['"]$/g, '');
      let val;
      // numeric literal
      if (/^-?\d+(?:\.\d+)?$/.test(rawVal)) {
        val = Number(rawVal);
      } else if ((rawVal.startsWith('"') && rawVal.endsWith('"')) || (rawVal.startsWith("'") && rawVal.endsWith("'"))) {
        val = rawVal.slice(1, -1);
      } else {
        // bare identifier or expression; keep as string for later evaluation if needed
        val = rawVal;
      }
      obj[key] = val;
    }
    return obj;
  }

  // Evaluate expression to primitive value
  static evalToPrimitive(raw) {
    try {
      if (typeof raw === 'string' && typeof IC?.parseAndEval === 'function') {
        const r = IC.parseAndEval(raw);
        if (r !== IC.NOPARSE && IC.isValidEvalResult(r)) {
          const v = IC.val(r);
          if (typeof v === 'number' || typeof v === 'boolean' || typeof v === 'string') return v;
        }
      }
    } catch (e) { /* ignore, fall through */ }
    return raw;
  }

  // Compute canonical raw form for option values
  static computeRawForm(rawVal, evalVal) {
    if (typeof rawVal === 'string') {
      // Keep raw value as-is for consistent matching with value_raw
      return rawVal;
    }
    // Number or boolean - keep string representation
    return String(rawVal);
  }

  // Helper to strip quotes from a string for display purposes
  static stripQuotesForDisplay(s) {
    if (typeof s !== 'string') return s;
    const str = String(s);
    if ((str.startsWith('"') && str.endsWith('"')) || (str.startsWith("'") && str.endsWith("'"))) {
      return str.slice(1, -1);
    }
    return str;
  }

  // Normalize options array/object to standard format
  static normalizeOptions(opts) {
    if (!opts) return [];
    if (Array.isArray(opts)) {
      return opts.map((opt) => {
        if (typeof opt === 'object' && opt !== null && Object.prototype.hasOwnProperty.call(opt, 'value')) {
          const rawVal = opt.value;
          const evalVal = UIMetadataParser.evalToPrimitive(rawVal);
          return {
            label: opt.label != null ? String(opt.label) : UIMetadataParser.stripQuotesForDisplay(rawVal),
            value: evalVal,
            raw: UIMetadataParser.computeRawForm(rawVal, evalVal)
          };
        }
        const rawVal = opt;
        const evalVal = UIMetadataParser.evalToPrimitive(rawVal);
        return {
          label: UIMetadataParser.stripQuotesForDisplay(rawVal),
          value: evalVal,
          raw: UIMetadataParser.computeRawForm(rawVal, evalVal)
        };
      });
    }
    if (typeof opts === 'object') {
      return Object.entries(opts).map(([label, rawVal]) => {
        const evalVal = UIMetadataParser.evalToPrimitive(rawVal);
        return {
          label,
          value: evalVal,
          raw: UIMetadataParser.computeRawForm(rawVal, evalVal)
        };
      });
    }
    return [];
  }

  // Parse and normalize UI metadata from a comment string
  static parse(rawComment) {
    const result = {
      ui: null,
      ui_comment: null
    };

    const trimmed = rawComment.trim();

    // Check for function-call syntax: checkbox(), dropdown([...]), slider(...)
    const isFunctionCall = /^(checkbox|dropdown|radio|slider|range|date|time|datetime|multiselect)\s*\(/.test(trimmed);

    // Check for JSON syntax
    const isJSONSyntax = trimmed.startsWith("{") && (
      rawComment.includes("\"ui\"") || rawComment.includes("\"type\"") || /\b(ui|type)\s*:/i.test(rawComment)
    );

    const looksLikeUIMetadata = isFunctionCall || isJSONSyntax;

    if (!looksLikeUIMetadata) {
      return result;
    }

    // For function-call syntax, parse the whole thing; for JSON, extract the leading object
    let blockToParse = trimmed;
    let pos = null;

    if (isJSONSyntax && !isFunctionCall) {
      pos = UIMetadataParser.extractLeadingJSONObjectPos(rawComment);
      blockToParse = pos ? rawComment.substring(pos.start, pos.end + 1) : rawComment;
    } else if (isFunctionCall) {
      // For function calls, extract up to the matching closing paren, then any trailing text
      const openParen = trimmed.indexOf('(');
      if (openParen > 0) {
        let depth = 0;
        let endParen = -1;
        for (let i = openParen; i < trimmed.length; i++) {
          if (trimmed[i] === '(') depth++;
          else if (trimmed[i] === ')') {
            depth--;
            if (depth === 0) {
              endParen = i;
              break;
            }
          }
        }
        if (endParen > 0) {
          blockToParse = trimmed.substring(0, endParen + 1);
          const trail = trimmed.substring(endParen + 1).trim();
          if (trail) {
            result.ui_comment = trail;
          }
        }
      }
    }

    const parsedRaw = UIMetadataParser.parseUIMetadata(blockToParse);
    if (parsedRaw && (parsedRaw.ui || parsedRaw.type)) {
      const uiType = parsedRaw.ui || parsedRaw.type;
      let normalized = { ui: uiType };
      // Copy through supported fields with evaluation as needed
      if (parsedRaw.min !== undefined) normalized.min = UIMetadataParser.evalToPrimitive(parsedRaw.min);
      if (parsedRaw.max !== undefined) normalized.max = UIMetadataParser.evalToPrimitive(parsedRaw.max);
      if (parsedRaw.step !== undefined) normalized.step = UIMetadataParser.evalToPrimitive(parsedRaw.step);
      if (parsedRaw.options !== undefined) normalized.options = UIMetadataParser.normalizeOptions(parsedRaw.options);
      if (parsedRaw.label !== undefined) normalized.label = parsedRaw.label;

      result.ui = normalized;
      // trailing comment after metadata block, preserved for UI display
      if (pos) {
        const trail = rawComment.substring(pos.end + 1).trim();
        result.ui_comment = trail || null;
      }
    }

    return result;
  }

  // Check if a comment looks like UI metadata
  static looksLikeUIMetadata(rawComment) {
    return rawComment.trim().startsWith("{") && (
      rawComment.includes("\"ui\"") || rawComment.includes("\"type\"") || /\b(ui|type)\s*:/i.test(rawComment)
    );
  }

  // Find which option is selected, using InstaCalc's own comparison logic
  // Returns the index of the selected option, or 0 if no match
  static getSelectedOptionIndex(options, result) {
    if (!options || !Array.isArray(options)) return 0;

    const valueRaw = result?.ui_write?.value_raw ?? result?.value_raw;
    const valueEval = result?.ui_write?.value_eval ?? result?.eval_result;

    if (IC.debug?.ui) {
      console.log('[getSelectedOptionIndex] valueRaw:', valueRaw, 'valueEval:', valueEval);
      console.log('[getSelectedOptionIndex] options:', options.map(o => ({label: o.label, raw: o.raw, value: o.value})));
    }

    // TWO-PASS STRATEGY (critical for units like F/C which evaluate to same number)

    // PASS 1: Try raw string match across ALL options first
    // This is ESSENTIAL for units like F/C which have same numeric value but different meanings
    if (valueRaw !== undefined) {
      const rawMatchIndex = options.findIndex((opt, idx) => {
        if (opt.raw) {
          const rawMatch = valueRaw === opt.raw;
          if (IC.debug?.ui) {
            console.log('[getSelectedOptionIndex] PASS 1 opt[' + idx + '] raw match:', rawMatch, 'valueRaw:', valueRaw, 'opt.raw:', opt.raw);
          }
          return rawMatch;
        }
        return false;
      });

      if (rawMatchIndex >= 0) {
        if (IC.debug?.ui) {
          console.log('[getSelectedOptionIndex] found raw match at index:', rawMatchIndex);
        }
        return rawMatchIndex;
      }
    }

    // PASS 2: Only if no raw match found, try eval matching
    // This handles numbers, booleans, etc. but won't work correctly for equivalent units
    if (valueEval !== undefined) {
      const evalMatchIndex = options.findIndex((opt, idx) => {
        if (opt.value !== undefined) {
          const optVal = IC.val(opt.value);
          const curVal = IC.val(valueEval);
          const evalMatch = (optVal == curVal);
          if (IC.debug?.ui) {
            console.log('[getSelectedOptionIndex] PASS 2 opt[' + idx + '] eval match:', evalMatch, 'optVal:', optVal, 'curVal:', curVal);
          }
          return evalMatch;
        }
        return false;
      });

      if (evalMatchIndex >= 0) {
        if (IC.debug?.ui) {
          console.log('[getSelectedOptionIndex] found eval match at index:', evalMatchIndex);
        }
        return evalMatchIndex;
      }
    }

    if (IC.debug?.ui) {
      console.log('[getSelectedOptionIndex] no match found, defaulting to 0');
    }
    return 0;
  }
}

// Expose UIMetadataParser for testing
IC.parser.UIMetadataParser = UIMetadataParser;

class LRUCache {
  constructor(capacity) {
    this.cache = new Map();
    this.capacity = capacity;
  }

  clear() {
    this.cache = new Map();
  }

  has(key) {
    return this.cache.has(key);
  }

  get(key) {
    if (!this.cache.has(key)) return null;

    let val = this.cache.get(key);

    this.cache.delete(key);
    this.cache.set(key, val);

    return val;
  }

  set(key, value) {
    this.cache.delete(key);

    if (this.cache.size === this.capacity) {
      this.cache.delete(this.cache.keys().next().value);
      this.cache.set(key, value);
    } else {
      this.cache.set(key, value);
    }
  }
}

IC.CACHE = new LRUCache(10000);

// @ts-ignore
if (typeof INSTACALC_GRAMMAR !== "undefined") {
  if (LIB.Calc) {
    LIB.Calc.pub();
  }
}
class TrieNode {
  constructor(value = null) {
    this.children = new Map();
    this.isEndOfWord = false;
    this.value = value;
  }
}

class Trie {
  constructor() {
    this.root = new TrieNode();
  }

  insert(word) {
    let currentNode = this.root;

    for (let i = 0; i < word.length; i++) {
      const char = word[i];
      if (!currentNode.children.has(char)) {
        currentNode.children.set(char, new TrieNode());
      }
      currentNode = currentNode.children.get(char);
    }

    currentNode.isEndOfWord = true;
  }

  search(haystack) {
    const matches = [];

    for (let i = 0; i < haystack.length; i++) {
      let currentNode = this.root;
      for (let j = i; j < haystack.length; j++) {
        const char = haystack[j];
        if (currentNode.children.has(char)) {
          currentNode = currentNode.children.get(char);
          if (currentNode.isEndOfWord) {
            const match = haystack.slice(i, j + 1);
            matches.push(match);
          }
        } else {
          break;
        }
      }
    }

    return matches;
  }

  // New methods
  insertKeyValue(key, value, caseSensitive = true) {
    let currentNode = this.root;
    if (!caseSensitive) {
      key = key.toLowerCase();
    }

    for (let i = 0; i < key.length; i++) {
      const char = key[i];
      if (!currentNode.children.has(char)) {
        currentNode.children.set(char, new TrieNode());
      }
      currentNode = currentNode.children.get(char);
    }

    currentNode.isEndOfWord = true;
    currentNode.value = value;
  }

  replaceInText(text, caseSensitive = true) {
    let replacedText = '';

    for (let i = 0; i < text.length;) {
      let currentNode = this.root;
      let found = null;
      let j = i;

      while (j < text.length && currentNode.children.has((caseSensitive) ? text[j] : text[j].toLowerCase())) {
        currentNode = currentNode.children.get((caseSensitive) ? text[j] : text[j].toLowerCase());
        j++;

        if (currentNode.isEndOfWord) {
          found = { index: j, value: currentNode.value };
        }
      }

      if (found) {
        replacedText += found.value;
        i = found.index;
      } else {
        replacedText += text[i];
        i++;
      }
    }

    return replacedText;
  }
}

const SETUP_TRIES = function () {
  CONFIG.L2_REPLACEMENTS_STRING_ONLY_TRIE = new Trie();
  for (const [find, replace] of Object.entries(CONFIG.L2_REPLACEMENTS_STRINGS)) {
    CONFIG.L2_REPLACEMENTS_STRING_ONLY_TRIE.insertKeyValue(find, replace, false);
  }

  CONFIG.PLAIN_ENGLISH_OPS_TRIE = new Trie();
  for (const [find, replace] of Object.entries(CONFIG.PLAIN_ENGLISH_OPS)) {
    CONFIG.PLAIN_ENGLISH_OPS_TRIE.insert(find);
  }

  CONFIG.PREFIX_DICT_TRIE = new Trie();
  for (const [find, replace] of Object.entries(CONFIG.PREFIX_DICT)) {
    CONFIG.PREFIX_DICT_TRIE.insert(find);
  }
}

SETUP_TRIES();

var ICLib = {};

ICLib.isRomanNumeral = function (s) {
  // Roman numeral regex pattern
  const romanRegex = /^(M{0,3})(CM|CD|D?C{0,3})(XC|XL|L?X{0,3})(IX|IV|V?I{0,3})$/;

  // Return true if the string matches the regex, false otherwise
  return romanRegex.test(s);
}

/**
 * Convert a decimal number to a Roman numeral
 * @param {number} num - The decimal number to convert
 * @returns {string} The Roman numeral representation of the input number
 */
ICLib.decimalToRoman = function (num) {
  /**
   * Map of decimal values to their corresponding Roman numerals
   * @type {{[key: number]: string}}
   */
  const romanMap = {
    1000000: 'M̄', 900000: 'C̄M̄', 500000: 'D̄', 400000: 'C̄D̄', 100000: 'C̄',
    90000: 'X̄C̄', 50000: 'L̄', 40000: 'X̄L̄', 10000: 'X̄', 9000: 'ĪX̄',
    5000: 'V̄', 4000: 'ĪV̄', 1000: 'M', 900: 'CM', 500: 'D', 400: 'CD', 100: 'C',
    90: 'XC', 50: 'L', 40: 'XL', 10: 'X', 9: 'IX',
    5: 'V', 4: 'IV', 1: 'I'
  };

  let romanNumeral = '';
  const decimalValues = Object.keys(romanMap).sort((a, b) => Number(b) - Number(a)); // sorted in descending order

  for (let i = 0; i < decimalValues.length; i++) {
    let currentNum = Number(decimalValues[i]);
    while (num >= currentNum) {
      num -= currentNum;
      romanNumeral += romanMap[decimalValues[i]];
    }
  }

  return romanNumeral;
};

ICLib.romanToDecimal = function (roman) {
  const romanNumeralMap = {
    'M̄': 1000000,
    'D̄': 500000,
    'C̄': 100000,
    'L̄': 50000,
    'X̄': 10000,
    'V̄': 5000,
    'Ī': 1000,
    'M': 1000,
    'D': 500,
    'C': 100,
    'L': 50,
    'X': 10,
    'V': 5,
    'I': 1
  };

  let total = 0;
  let current, currentValue;
  let next, nextValue;

  roman = roman.toUpperCase();

  for (let i = 0; i < roman.length; i++) {
    current = roman[i];
    currentValue = romanNumeralMap[current];

    // If the current character is not a valid Roman numeral, return null
    if (currentValue === undefined) {
      return null;
    }

    next = roman[i + 1];
    nextValue = romanNumeralMap[next];

    if (currentValue < nextValue) {
      total -= currentValue;
    } else {
      total += currentValue;
    }
  }

  return total;
}

ICLib.roundToDecimal = function (number, decimalPlaces) {
  const factor = Math.pow(10, decimalPlaces);
  return Math.round(number * factor) / factor;
};

ICLib.factorial = function (n) {

  if (n > 170) {
    return Infinity;
  }

  // check if n is not a number or negative
  if (typeof n != "number" || n < 0) {
    return undefined;
  }

  if (n === 0 || n === 1) {
    return 1;
  }

  this.factcache ||= [];

  if (this.factcache[n] > 0) {
    return this.factcache[n];
  }

  let result = 1;
  for (let i = 1; i <= n; i++) {
    result *= i;
    this.factcache[i] = result;
  }

  return result;
};

ICLib.escapeRegExpString = function (string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // $& means the whole matched string
};

ICLib.paramRate = function (params) {
  let rate = 0;
  params.forEach((param, i) => {
    if (rate || param == null) return;

    let val = IC.val(param);
    if (typeof val === "number" && val > 0 && val < 1.0) {
      rate = val;
      params[i] = null;
    }
  });
  return rate;
};

ICLib.paramMonths = function (params) {
  let months = 0;
  params.forEach((param, i) => {
    if (months || param == null) return;

    // swap y for year
    if (param?.t?.y) {
      param.t.year = param.t.y;
      delete param.t.y;
      IC.log(`treating y as year`);
    }

    if (IC.hasType(param) && IC.typeHasUnitInCategory(param.t, "second")) {
      months = IC.val(IC.semanticConvert(param, "month"));
      params[i] = null;
    }
  });

  // if months not found, find the first number > 2 and assume it is years 
  if (!months) {
    for (let i = 0; i < params.length; i++) {
      let val = IC.val(params[i]);
      if (val > 2) {
        months = val * 12;
        params[i] = null;
        break;
      }
    }
  }

  return months;
};

ICLib.paramPaymentInfo = function (params) {
  let payment = 0;
  let paymentsPerYear = 12; // default to monthly
  let isLumpSum = false;
  let paymentUnit = null;

  // Check for payment (value with time-based unit in denominator)
  params.forEach((param, i) => {
    if (payment || param == null) return;

    if (IC.hasType(param)) {
      let typeObj = param.t;

      // single-letter time shorthands that aren't automatically a unit
      // TODO: extract to unit function to convert time shorthands to longer equivalents?
      const typeMapping = {
        d: 'day',
        w: 'week',
        m: 'month',
        y: 'year',
      };

      Object.keys(typeMapping).forEach(key => {
        if (typeObj[key]) {
          typeObj[typeMapping[key]] = typeObj[key];
          delete typeObj[key];
          IC.log(`treating ${key} as ${typeMapping[key]}`);
        }
      });

      let hasTimeUnit = Object.keys(typeObj).some(unit =>
        IC.typeHasUnitInCategory({ [unit]: typeObj[unit] }, "second") && typeObj[unit] < 0
      );

      if (hasTimeUnit) {
        let timeUnit = Object.keys(typeObj).find(unit =>
          IC.typeHasUnitInCategory({ [unit]: typeObj[unit] }, "second") && typeObj[unit] < 0
        );
        let unitScale = ICUnit.getUnitScale(timeUnit);
        paymentsPerYear = ICUnit.getUnitScale("year") / unitScale;
        payment = IC.val(param);

        // Determine the payment unit (currency)
        paymentUnit = Object.keys(typeObj).find(unit => typeObj[unit] > 0);

        params[i] = null;
      }

      // regular payment type 
      paymentUnit = Object.keys(typeObj).find(unit => typeObj[unit] > 0);
      payment = IC.val(param);
      params[i] = null;
    } else {
      let val = IC.val(param);
      if (val > 100) { // check for lump sum
        payment = val;
        isLumpSum = true;
        params[i] = null;
      }
    }
  });
  return { payment, paymentUnit, paymentsPerYear, isLumpSum };
};

// automatically re-orders parameters to match the function signature
ICLib.loan = function (a, b, c) {
  let params = [a, b, c];

  let principal;
  let rate = ICLib.paramRate(params);
  let months = ICLib.paramMonths(params);
  let paymentObj = ICLib.paramPaymentInfo(params);
  principal = IC.val(paymentObj.payment);

  let payment = Math.round(Math.abs(LIB.InstaCalc.prototype.fn.PMT(rate / 12, months, principal)));

  if (params.some(p => p !== null)) {
    let msg = "";
    let missingVars = [];

    !rate && missingVars.push("rate");
    !months && missingVars.push("time");
    !principal && missingVars.push("principal");

    let missingVarsStr = missingVars.join(", ");

    msg += `missing ${missingVarsStr}, try: loan 400k for 10 years at 5%`;
    IC.log(msg);
    return null;
  }

  // calculate interest and principal for total 
  let totalPaid = payment * months;
  let totalInterest = Math.round(totalPaid - principal);
  IC.log(`total cost: ${IC.parser.formatAsFinance(totalPaid)} = ${IC.parser.formatAsFinance(totalInterest)} (interest) + ${IC.parser.formatAsFinance(principal)} (principal)`);

  return IC.makeICObject(payment, "/month");
};


ICLib.interest = function (a, b, c) {
  let params = [a, b, c];

  let principal;
  let rate = ICLib.paramRate(params);
  let months = ICLib.paramMonths(params);
  let paymentObj = ICLib.paramPaymentInfo(params);
  principal = IC.val(paymentObj.payment);

  // Calculate the monthly payment using the PMT function
  let monthlyPayment = Math.abs(LIB.InstaCalc.prototype.fn.PMT(rate / 12, months, principal));

  // Total amount paid over the loan period
  let totalPaid = monthlyPayment * months;

  // Total interest paid
  let totalInterest = Math.round(totalPaid - principal);
  IC.log(`total cost: ${IC.parser.formatAsFinance(totalPaid)} = ${IC.parser.formatAsFinance(totalPaid - principal)} (interest) + ${IC.parser.formatAsFinance(principal)} (principal)`);
  return totalInterest;
};

ICLib.presentValue = function (a, b, c) {
  let params = [a, b, c];
  let futureValue;
  let rate = ICLib.paramRate(params);
  let months = ICLib.paramMonths(params);
  let paymentObj = ICLib.paramPaymentInfo(params);
  futureValue = IC.val(paymentObj.payment);

  // Calculate the present value using the PV function
  let presentValue = LIB.InstaCalc.prototype.fn.PV(rate / 12, months, 0, -futureValue);

  // Round the present value to two decimal places
  presentValue = Math.round(presentValue);

  // Calculate the difference (potential gain)
  let potentialGain = futureValue - presentValue;

  IC.log(`present value: ${IC.parser.formatAsFinance(presentValue)} | future value: ${IC.parser.formatAsFinance(futureValue)} | gain: ${IC.parser.formatAsFinance(potentialGain)}`);

  return presentValue;
};

ICLib.totalPayment = function (a, b, c) {
  let params = [a, b, c];

  let principal;
  let rate = ICLib.paramRate(params);
  let months = ICLib.paramMonths(params);
  let paymentObj = ICLib.paramPaymentInfo(params);
  principal = IC.val(paymentObj.payment);

  // Calculate the monthly payment using the PMT function
  let monthlyPayment = Math.abs(LIB.InstaCalc.prototype.fn.PMT(rate / 12, months, principal));

  // Total amount paid over the loan period
  let totalPaid = Math.round(monthlyPayment * months);

  IC.log(`total cost: ${IC.parser.formatAsFinance(totalPaid)} = ${IC.parser.formatAsFinance(totalPaid - principal)} (interest) + ${IC.parser.formatAsFinance(principal)} (principal)`);
  return totalPaid;
};

ICLib.savingsGoal = function (a, b, c) {
  let params = [a, b, c];

  let paymentObj = ICLib.paramPaymentInfo(params);
  let futureValue = IC.val(paymentObj.payment);
  let annualRate = ICLib.paramRate(params); // annual interest rate
  let months = ICLib.paramMonths(params); // time period in months

  // Convert annual interest rate to monthly interest rate
  let monthlyRate = annualRate / 12;

  // Calculate the required monthly savings using the PMT function
  // Note: The PMT function typically calculates payments for loans (which are negative), 
  // so we use a negative future value to get a positive savings amount.
  let monthlySavings = Math.abs(LIB.InstaCalc.prototype.fn.PMT(monthlyRate, months, 0, -futureValue));

  monthlySavings = Math.round(monthlySavings);

  IC.log(`monthly savings: ${IC.parser.formatAsFinance(monthlySavings)} to reach ${IC.parser.formatAsFinance(futureValue)} in ${months} months at ${annualRate * 100}% annual interest rate`);
  return IC.makeICObject(monthlySavings, { month: -1 });
};

ICLib.invest = function (a, b, c) {
  let params = [a, b, c];

  let rate = ICLib.paramRate(params);

  let paymentObj = ICLib.paramPaymentInfo(params);
  let payment = paymentObj.payment;
  let paymentsPerYear = paymentObj.paymentsPerYear;
  let paymentUnit = paymentObj.paymentUnit;
  let isLumpSum = paymentObj.isLumpSum;

  let months = ICLib.paramMonths(params);

  if (params.some(p => p !== null)) {
    let msg = "";
    let missingVars = [];

    !rate && missingVars.push("rate");
    !months && missingVars.push("time");
    !payment && missingVars.push("payment");

    let missingVarsStr = missingVars.join(", ");

    msg += `missing ${missingVarsStr}, try: invest 1000/year for 10 years at 5%`;
    IC.log(msg);
    return null;
  }

  // Calculate future value
  let annualRate = rate;
  let periodicRate = annualRate / paymentsPerYear;
  let totalPeriods = months * (paymentsPerYear / 12);
  let futureValue = Math.round(LIB.InstaCalc.prototype.fn.FV(periodicRate, totalPeriods, -payment, 0, 1));
  let totalContribution = payment * totalPeriods;

  if (isLumpSum) {
    futureValue = Math.round(payment * Math.pow(1 + annualRate, months / 12));
    totalContribution = payment;
  }

  const totalGrowth = futureValue - totalContribution;

  IC.log(`future value: ${IC.parser.formatAsFinance(futureValue)} = ${IC.parser.formatAsFinance(totalGrowth)} (gain) + ${IC.parser.formatAsFinance(totalContribution)} (deposits)`);

  // Return the result with the same unit as the input payment
  if (paymentUnit) {
    return IC.makeICObject(futureValue, paymentUnit);
  } else {
    return futureValue;
  }
};

class ICUnit {

  static COMPOUND_UNITS = {
    "newton": { m: 1, kg: 1, s: -2 },
    "joule": { m: 2, kg: 1, s: -2 },
    "watt": { m: 2, kg: 1, s: -3 },
    "pascal": { m: -1, kg: 1, s: -2 },
    "coulomb": { a: 1, s: 1 },
    "mah": { a: 1, s: 1 },
    "volt": { m: 2, kg: 1, s: -3, a: -1 },
    "ohm": { m: 2, kg: 1, s: -3, a: -2 },
    "farad": { m: -2, kg: -1, s: 4, a: 2 },
    "weber": { m: 2, kg: 1, s: -2, a: -1 },
    "tesla": { m: 1, kg: 1, s: -2, a: -1 },
    "henry": { m: 2, kg: 1, s: -2, a: -2 },
    "siemens": { m: -2, kg: -1, s: 3, a: 2 },
    //  "hertz": { s: -1 },
    "lux": { m: -2, cd: 1, sr: 1 },
    "lumen": { cd: 1, sr: 1 },
    //"candela": { cd: 1 },
    "gray": { m: 2, s: -2 },
    "sievert": { m: 2, s: -2 },
    "katal": { mol: 1, s: -1 },
    //  "molar": { mol: 1, m: -3 },
    //  "becquerel": { s: -1 },
    //  "mole": { mol: 1 },
    // "molarity": { mol: 1 },
    "erg": { m: 2, kg: 1, s: -2 },
    "dyne": { m: 1, kg: 1, s: -2 },
    "kelvin": { k: 1 },
  }

  // units that we shouldn't simple reduce to, like bigG should not be in terms of Gray
  static COMPOUND_UNITS_AUTOCOLLAPSE_IGNORE = {
    "gray": true,
    "sievert": true,
    "erg": true,
    "dyne": true,
  }

  static SI_SYMBOLS = {
    "m": "meter",
    "kg": "kilogram",
    "s": "second",
    "a": "ampere",
    "ah": "ampere hour",
    "k": "kelvin",
    "mol": "mole",
    "cd": "candela",
    "rad": "radian",
    "sr": "steradian",
    "hz": "hertz",
    "n": "newton",
    "pa": "pascal",
    "j": "joule",
    "w": "watt",
    "c": "coulomb",
    "v": "volt",
    "f": "farad",
    "wb": "weber",
    "t": "tesla",
    "h": "henry",
    "lm": "lumen",
    "lx": "lux",
    "bq": "becquerel",
    "gy": "gray",
    "sv": "sievert",
    "kat": "katal",
  }

  static areEquivalentBaseUnits(unitObject1, unitObject2) {
    let [type1, scale1] = ICUnit.convertToBaseUnits(unitObject1);
    let [type2, scale2] = ICUnit.convertToBaseUnits(unitObject2);

    // filter out rad and sr for comparison
    type1 = Object.keys(type1).filter((key) => key != 'rad' && key != 'sr').reduce((obj, key) => {
      obj[key] = type1[key];
      return obj;
    }, {});

    type2 = Object.keys(type2).filter((key) => key != 'rad' && key != 'sr').reduce((obj, key) => {
      obj[key] = type2[key];
      return obj;
    }, {});

    return ICUnit.isSameUnitObject(type1, type2);
  }

  // return keys in mass, length, time order
  static sortUnitMLT(baseUnitObject = {}) {
    if (Object.keys(baseUnitObject).length < 2) {
      return baseUnitObject;
    }

    // create a new object in order of MLT for SI units
    let orderedBaseUnits = {};
    ["kg", "m", "a", "s", "k", "mol", "cd"].forEach(unit => {
      if (baseUnitObject.hasOwnProperty(unit)) {
        orderedBaseUnits[unit] = baseUnitObject[unit];
        delete baseUnitObject[unit];
      }
    });

    // append remaining non-SI units
    for (let unit in baseUnitObject) {
      orderedBaseUnits[unit] = baseUnitObject[unit];
    }

    return orderedBaseUnits;
  }

  // "3 months"
  static unitStringHasNumber(str) {
    return str.match(/^[0-9,._]+/);
  }

  static unitStringExtractNumber(str) {
    let unit = ICUnit.unitStringNormalize(str);
    let [numberString, ...parts] = unit.split(/[\s]+/);

    // Extract the suffix if it exists
    let scaleMatch = numberString.match(/^([0-9,._]+)([a-zA-Z]+)$/);
    if (scaleMatch) {
      let [, number, scaleSuffix] = scaleMatch;
      let scale = IC.predefinedSuffixScale(scaleSuffix) || 1;
      numberString = (parseFloat(number) * scale).toString();
    }

    let n = IC.makeNumber(numberString, IC.envGetSettings());
    let extractedName = parts.join(" ");
    return [n, extractedName];
  }


  // 2 k USD => 2k USD
  static unitStringNormalize(str) {
    if (!str) {
      return str;
    }

    let parts = str.split(" ");

    if (parts.length < 2) {
      return str;
    }

    let number = parts[0];
    let possibleScale = parts[1];

    if (possibleScale?.length == 1 && IC.isNumberStringIncludingScaleSuffix(number + possibleScale)) {
      return number + possibleScale + " " + parts.slice(2).join(" ");
    }

    return str;
  }


  // try to convert to base units (Newton = kg m / s^2)

  /**
   * Convert given units to their base units.
   * 
   * @param {ICType} type - An object where keys represent the unit type, and the values represent the power to which the unit is raised.
   * @returns {[ICType, number]} - A tuple. The first element is an object with base units as keys and their respective powers as values. The second element is the scale.
   */
  static convertToBaseUnits(type = {}) {

    function getBaseUnitNameAndScale(unitStr) {
      unitStr = unitStr.toLowerCase();
      let unitObj = ICUnit.getUnit(unitStr);
      let scale = unitObj ? unitObj[unitStr] : 1;

      // Check for scale prefixes like "billion miles"
      let parts = unitStr.split(/\s+/);
      if (parts.length > 1) {
        // Look for scale prefix in first part
        let scalePrefix = CONFIG.nearestNumberScale(parts[0]);
        if (scalePrefix) {
          // Get rest of unit name and look it up
          let restOfUnit = parts.slice(1).join(" ");
          let restUnitObj = ICUnit.getUnit(restOfUnit);
          if (restUnitObj) {
            scale = scalePrefix * (restUnitObj[restOfUnit] || 1);
            unitStr = restOfUnit; // Use base unit name
            unitObj = restUnitObj;
          }
        }
      }

      // Check for flexible unit aliases like flop/flops, hz, etc.
      const flexMatch = CONFIG.FLEX_UNIT_ALIAS[unitStr];
      if (flexMatch) {
        return [flexMatch.type, flexMatch.scale];
      }

      if (!unitObj) {
        return [unitStr, scale];
      }

      // treat "byte" as base unit, not "bit"
      if (IC.typeIsByte(unitStr)) {
        scale = ICUnit.typeConversionScale(unitStr, "byte");
        return ["byte", scale];
      }

      // currencies become USD
      if (IC.typeIsCurrency(unitStr)) {
        return ["USD", scale];
      }

      // find shortest key with value 1 in the unit object
      let shortestKey = null;
      Object.keys(unitObj).filter(key => key != "base").forEach((key) => {
        if (unitObj[key] == 1 && (!shortestKey || key.length < shortestKey.length)) {
          shortestKey = key;
        }
      });

      return [shortestKey, scale];
    }

    let scale = 1;

    let baseUnits = [];
    // TODO: support custom units here. For now, just break apart known units
    Object.keys(type).forEach((key) => {
      let power = type[key];

      let unitObj = ICUnit.getUnitCaseInsensitive(key);
      if (unitObj && unitObj.SI) {
        let baseUnitItems = Object.fromEntries(
          Object.entries(unitObj.SI).map(([k, v]) => [k, v * power])
        );

        baseUnits.push(baseUnitItems);
        let localScale = ICUnit.getUnitScale(key);

        // Kelvin is a special case, could be a function conversion
        if (typeof localScale == 'number') {
          scale *= localScale ** power;
        }
        return;
      } else {
        let keyIndex = key;

        // if we have a number... could be "6 months"
        if (ICUnit.unitStringHasNumber(key)) {
          let [n, extractedName] = ICUnit.unitStringExtractNumber(key);
          scale *= n ** power;
          keyIndex = extractedName;
        }

        keyIndex = IC.stringSingularize(keyIndex);
        let [newKey, newScale] = getBaseUnitNameAndScale(keyIndex);
        if (newScale) {
          keyIndex = newKey;
          scale *= newScale ** power;
        }

        baseUnits.push({ [keyIndex]: power });
      }
    });

    // combine values for all entries in baseUnits
    /** @type {ICType} */
    let finalBaseUnits = {};
    baseUnits.forEach((baseUnit) => {
      Object.keys(baseUnit).forEach((key) => {
        finalBaseUnits[key] = (finalBaseUnits[key] || 0) + baseUnit[key];
      });
    });

    // remove entries with 0
    /** @type {ICType} */
    let finalBaseUnitsWithoutZeros = {};
    Object.keys(finalBaseUnits).forEach((key) => {
      if (finalBaseUnits[key] !== 0) {
        finalBaseUnitsWithoutZeros[key] = finalBaseUnits[key];
      }
    });
    finalBaseUnits = finalBaseUnitsWithoutZeros;
    finalBaseUnits = ICUnit.sortUnitMLT(finalBaseUnits);

    return [finalBaseUnits, scale];
  }

  static convertToCompoundUnits(units) {

    // not enough units to compound
    if (Object.keys(units).length < 2) {
      return units;
    }

    let result = {};
    ICUnit.SORTED_COMPOUND_UNITS ||= Object.keys(ICUnit.COMPOUND_UNITS)
      .filter(unit => !ICUnit.COMPOUND_UNITS_AUTOCOLLAPSE_IGNORE[unit])
      .sort((a, b) => {
        let aCount = Object.values(ICUnit.COMPOUND_UNITS[a]).reduce((a, b) => Math.abs(a) + Math.abs(b), 0);
        let bCount = Object.values(ICUnit.COMPOUND_UNITS[b]).reduce((a, b) => Math.abs(a) + Math.abs(b), 0);
        return bCount - aCount;
      });

    for (let compound of ICUnit.SORTED_COMPOUND_UNITS) {
      while (ICUnit.canSubtract(units, ICUnit.COMPOUND_UNITS[compound])) {
        ICUnit.subtract(units, ICUnit.COMPOUND_UNITS[compound]);
        result[compound] = (result[compound] || 0) + 1;
      }
    }

    // if there are units left, merge them in
    for (let unit in units) {
      result[unit] = (result[unit] || 0) + units[unit];
    }

    for (let unit in result) {
      if (result[unit] === 0) {
        delete result[unit];
      }
    }

    return result;
  }

  static canSubtract(units, compoundUnit) {
    for (let unit in compoundUnit) {
      // Check if the unit exists and its value is greater or equal in `units` and they have the same sign
      if (!(unit in units) || Math.abs(units[unit]) < Math.abs(compoundUnit[unit]) || Math.sign(units[unit]) !== Math.sign(compoundUnit[unit])) {
        return false;
      }
    }
    return true;
  }

  static subtract(units, compoundUnit) {
    for (let unit in compoundUnit) {
      units[unit] -= compoundUnit[unit];
      if (units[unit] === 0) {
        delete units[unit];
      }
    }
  }


  static isSameUnitObject(typeObjA, typeObjB) {
    if (Object.keys(typeObjA).length != Object.keys(typeObjB).length) {
      return false;
    }

    for (let key in typeObjA) {
      if (typeObjA[key] != typeObjB[key]) {
        return false;
      }
    }
    return true;
  }

  static isInverseUnitObject(typeObjA, typeObjB) {
    if (Object.keys(typeObjA).length != Object.keys(typeObjB).length) {
      return false;
    }

    for (let key in typeObjA) {
      if (typeObjA[key] != -typeObjB[key]) {
        return false;
      }
    }
    return true;
  }

  static isCurrency(unit) {
    let unitObj = ICUnit.getUnitCaseInsensitive(unit);
    return unitObj.usd || unitObj == LIB.InstaCalc.Unit.currencies;
  }

  static makeMixedUnit(obj, ...units) {

    // change format to "mixedunits"
    return obj;
  }

  // T and S are too common for formatting
  static UNITS_WITH_CAPITAL_LETTER = new Set(
    ["N", "Pa", "J", "K", "W", "C", "V", "F", "Ohm", "Wb", "Hz", "lm", "lx", "Bq", "Gy", "Sv", "kat", "A", "Ah", "L"]
  )

  static VALID_METRIC_PREFIXES = new Set(
    ['Y', 'Z', 'E', 'P', 'T', 'G', 'M', 'k', 'h', 'da', 'd', 'c', 'm', 'µ', 'n', 'p', 'f', 'a', 'z', 'y', '']
  )

  static FORMAT_MAPPING = {
    ah: "Ah",
    wh: "Wh", // kWh, GWh, etc. are auto-formatted from formatSIUnit

    pa: "Pa", // Pascal, not pico-amp
    ev: "eV",

    ha: "ha", // hectare, not hecto-amp
    cc: "cc", // cubic centimeter, not centi-coulomb
    cf: "cf", // cubic foot, not centi-farad

    iu: "IU",
    miu: "mIU",

    watt: "watt",
    newton: "newton",
    joule: "joule",
    volt: "volt",
    ampere: "ampere",
    ohm: "ohm",
    farad: "farad",
    coulomb: "coulomb",
    tesla: "tesla",
    henry: "henry",
    hertz: "hertz",
    lumen: "lumen",
    lux: "lux",
    becquerel: "becquerel",
    gray: "gray",
    sievert: "sievert",
    katal: "katal",
    siemens: "siemens",
    weber: "weber",
  };

  static FORMAT_MAPPING_CASE_SENSITIVE = {
    "mw": "MW",
    "mpge": "MPGe"
  }

  static CUSTOM_UNIT_INFO_MESSAGE = {
    "distance/energy": "(MPGe: miles per gallon equivalent)",
    "pp": "(percentage point = 1% = .01)",
    "bp": "(basis point = .01% = .0001)",
    "basis point": "(basis point = .01% = .0001)",
    "basis points": "(basis point = .01% = .0001)",
    "pph": "(parts per hundred)",
    "pcm": "(parts per 100,000 [cent mille])",
    "ppm": "(parts per million)",
    "ppb": "(parts per billion)",
    "ppt": "(parts per trillion)",
    "ppq": "(parts per quadrillion)",
  }


  static formatSIUnit(unitStr) {

    if (unitStr in ICUnit.FORMAT_MAPPING_CASE_SENSITIVE) {
      return ICUnit.FORMAT_MAPPING_CASE_SENSITIVE[unitStr];
    }

    let lower = unitStr.toLowerCase();
    if (lower in ICUnit.FORMAT_MAPPING) {
      return ICUnit.FORMAT_MAPPING[lower];
    }

    // if the last letter is an s, remove it and check again
    if (lower.endsWith("s")) {
      let withoutS = lower.slice(0, -1);
      if (withoutS in ICUnit.FORMAT_MAPPING) {
        return ICUnit.FORMAT_MAPPING[withoutS] + "s";
      }
    }

    return unitStr.replace(/([a-z]?)([a-z]+)$/i, function (match, p1, p2) {
      let p2Lower = p2.toLowerCase();
      let p2Upper = p2.toUpperCase();

      // nw => nW
      if (ICUnit.VALID_METRIC_PREFIXES.has(p1) && ICUnit.UNITS_WITH_CAPITAL_LETTER.has(p2Upper)) {
        return p1 + p2Upper;
      }

      // npa => nPa
      if (ICUnit.VALID_METRIC_PREFIXES.has(p1) && ICUnit.FORMAT_MAPPING[p2Lower]) {
        return p1 + ICUnit.FORMAT_MAPPING[p2Lower];
      }

      // gpa => GPa
      if (ICUnit.VALID_METRIC_PREFIXES.has(p1.toUpperCase()) && ICUnit.FORMAT_MAPPING[p2Lower]) {
        return p1.toUpperCase() + ICUnit.FORMAT_MAPPING[p2Lower];
      }
      return match;
    });
  }



  // cm => cm (length: 1e-2 meter)
  static infoMessage(unitStr) {

    // timezone
    if (ICDate.getIANATimeZone(unitStr)) {
      return `(timezone ${ICDate.getIANATimeZone(unitStr)})`;
    }

    let unitObj = ICUnit.getUnitCaseInsensitive(unitStr);
    if (!unitObj) return "";

    let scale = ICUnit.getUnitScale(unitStr);

    // no scale
    if (typeof (scale) !== 'number' || unitObj.name == "temperature") {
      return `(${unitObj.name})`;
    }

    if (ICUnit.isCurrency(unitStr)) {
      return "(currency)";
    }

    // custom info message for unit category
    if (ICUnit.CUSTOM_UNIT_INFO_MESSAGE[unitObj?.name]) {
      return ICUnit.CUSTOM_UNIT_INFO_MESSAGE[unitObj?.name];
    }

    // for unit itself
    if (ICUnit.CUSTOM_UNIT_INFO_MESSAGE[unitStr]) {
      return ICUnit.CUSTOM_UNIT_INFO_MESSAGE[unitStr];
    }

    // missing SI units (currency, etc.)
    if (!unitObj.SI) return "";

    // if too big or small, use scientific notation
    let scaleStr;
    let isPowerOf10 = Math.log10(scale) % 1 === 0;

    // if too big or small, use scientific notation
    if (scale > 1e4 || scale < 1e-4) {
      scaleStr = scale.toExponential(isPowerOf10 ? 0 : 4);

      // cleanup: 123.000e+6 123e6
      scaleStr = scaleStr.replace(/e\+/, "e").replace(/\.?0+e$/, "e");
    } else {
      // if scale is not power of 10, round 
      scaleStr = isPowerOf10 || Number.isInteger(scale) ? scale.toString() : scale.toFixed(6);
    }

    let baseUnitName = IC.typestring(unitObj.SI);
    if (baseUnitName) {
      let categoryName = unitObj.name;
      return `(${categoryName}: ${scaleStr} ${baseUnitName})`;
    }

    return "";
  }


  static scaleToBestUnit(result) {
    if (IC.hasNoType(result) || typeof IC.val(result) !== "number") {
      return result;
    }

    const value = IC.val(result);
    const units = Object.keys(result.t);

    if (units.length !== 1) {
      return result;
    }

    const unit = units[0];

    const prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
    const basePrefixIndex = prefixes.indexOf("");
    const maxPrefixConfig = {
      "m": "k",  // meters should stop scaling at kilometers
      "g": "k",  // grams should stop scaling at kilograms
      "s": "",   // seconds should not scale beyond second 
      "L": "",  // liters stops scaling 
      // Add more units and their maximum prefixes as needed
    };

    const baseUnitObj = ICUnit.getUnitCaseInsensitive(unit);
    if (!baseUnitObj?.SI) {
      return result;
    }

    let baseUnitName = ICUnit.getBaseUnitName(baseUnitObj) || "";

    // check if "kg" should use "g" as actual base unit
    if (baseUnitName.length >= 2 && prefixes.includes(baseUnitName[0])) {
      // remove the first char if the rest is still a real unit
      let newBaseUnitObj = ICUnit.getUnitCaseInsensitive(baseUnitName.slice(1));
      if (newBaseUnitObj == baseUnitObj) {
        baseUnitName = baseUnitName.slice(1);
      }
    }

    const totalValue = value * ICUnit.getUnitScale(unit);
    const powersOfTenFromBase = Math.log10(totalValue / ICUnit.getUnitScale(baseUnitName));
    const prefixSteps = Math.floor(powersOfTenFromBase / 3);

    let prefixIndex = basePrefixIndex + prefixSteps;
    if (maxPrefixConfig[baseUnitName] !== undefined) {
      const maxPrefixIndex = prefixes.indexOf(maxPrefixConfig[baseUnitName]);
      prefixIndex = Math.min(prefixIndex, maxPrefixIndex);
    }

    const prefix = prefixes[prefixIndex];
    const scaledUnit = prefix + baseUnitName;

    if (!IC.predefinedUnit(scaledUnit)) {
      return result;
    }

    const scaledResult = IC.ICObjectConvertToType(result, scaledUnit);
    return scaledResult;
  }


  // TODO: get this working
  static getFriendlyFormat(result) {
    this.config = null;

    if (!result || !result.t) return null;

    const value = result.v;
    const type = Object.keys(result.t)[0];

    if (!this.config) {
      const SI_PREFIXES = [
        { prefix: 'T', factor: 1e12 },
        { prefix: 'G', factor: 1e9 },
        { prefix: 'M', factor: 1e6 },
        { prefix: 'k', factor: 1e3 },
        { prefix: '', factor: 1 },
        { prefix: 'm', factor: 1e-3 },
        { prefix: 'µ', factor: 1e-6 },
        { prefix: 'n', factor: 1e-9 },
        { prefix: 'p', factor: 1e-12 }
      ];

      const UNITS = ['watts', 'kWh', 'joules', 'newton', 'pascal'];

      this.config = {};

      UNITS.forEach(unit => {
        // @ts-ignore
        this.config[unit] = SI_PREFIXES.map(prefix => {

          return {
            threshold: prefix.factor,
            divisor: prefix.factor,
            unit: prefix.prefix + unit
          };
        });
      });
    }

    if (!this.config[type]) return `${value} ${type}`; // Default to the original format if no config exists

    for (let format of this.config[type]) {
      if (value >= format.threshold) {
        return `${value / format.divisor} ${format.unit}`;
      }
    }

    return `${value} ${type}`; // Default to the original format if no thresholds are met
  };


  static autoCollapse(result) {
    if (IC.hasNoType(result) || Object.keys(result.t).length < 2) {
      return result;
    }

    let [baseUnits, scale] = ICUnit.convertToBaseUnits(result.t);

    // for purposes of conversion, auto-collapse bits into bytes.
    // change the scale based on the bit power
    if (baseUnits.bit) {
      baseUnits.byte = baseUnits.bit;
      delete baseUnits.bit;
      scale *= 8 ** -baseUnits.byte;
    }

    let collapsedUnits = ICUnit.convertToCompoundUnits(baseUnits);

    // only collapse if it makes the units simpler...
    if (IC.typePowerCount(collapsedUnits) < IC.typePowerCount(result.t)) {
      let collapsedResult = {
        ...result,
        v: IC.mathPreciseMultiply(IC.val(result), scale),
        t: collapsedUnits
      };

      return collapsedResult;
    }

    return result;
  }

  // TODO: instead of autocollapsing, show base units but have the autocollapse result as helper log text 
  static autoCollapseIgnore(result) {
    let IGNORE_LIST = ["kwh", "wh"];
    let resultTypes = Object.keys(result.t);

    // return true if any of the result types are in the ignore list
    return resultTypes.find(type => IGNORE_LIST.includes(type.toLowerCase()));
  }

  static isCompoundUnit(unitStr) {
    if (unitStr.endsWith('s') && unitStr !== "siemens") {
      // remove last letter
      unitStr = unitStr.slice(0, -1);
    }

    let lower = unitStr.toLowerCase();
    return (ICUnit.COMPOUND_UNITS[lower] || ICUnit.COMPOUND_UNITS[ICUnit.SI_SYMBOLS[lower]]);
  }

  static isSIUnit(unitStr) {
    // Check both original and lowercased versions of the unit string
    let unitObj = ICUnit.getUnitCaseInsensitive(unitStr);

    if (!unitObj) {
      return false;
    }

    // time, charge, etc. counts as SI
    if (unitObj.second || unitObj.ah) {
      return true;
    }

    let scale = unitObj[unitStr] || unitObj[unitStr.toLowerCase()];
    let power = Math.log10(scale);

    // exact power of 10
    if (power % 1 == 0)
      return true;

    return false;
  }

  static getUnit(unitStr) {
    return IC.CALC.isUnit(unitStr);
  }

  /*
  @param {string} unitStr - unit string, like "square m" or "m^2"
  @param {Set} charSet - Set of characters, used for early exit
  */
  static getUnitNameAndPower(unitStr) {

    if (unitStr.includes("^")) {
      let [unit, power] = unitStr.split("^");
      power = Number(power);
      return [unit, power];
    }

    // replace . and underscore with space, then trim
    // sq.ft. => sq ft, sq.meter => sq meter
    unitStr = unitStr.replace(/\.|_/g, " ").trim();

    // Helper function to process unit types
    const processUnitType = (unitType, power) => {
      const combinedRegex = new RegExp("\\b(" + unitType.join('|') + ")\\b", "gi");
      const match = unitStr.match(combinedRegex);
      if (match) {
        unitStr = unitStr.replace(match[0], "").trim();
        return [unitStr, power];
      }
      return null;
    };

    let result = processUnitType(LIB.InstaCalc.Unit.area, 2);
    if (result) return result;

    result = processUnitType(LIB.InstaCalc.Unit.volume, 3);
    if (result) return result;

    // Default: same string, power of 1
    return [unitStr, 1];
  }

  static unitMatch(from, frompow, to, topow) {
    // this one is pretty fast...
    let orig = IC.CALC.unitMatch(from, frompow, to, topow);
    return orig;
  }

  // this could be arbitrary unit, like tests/day -> tests/week
  static convertKnownUnitMatch(from, to) {
    if (from == to) {
      return 1;
    }

    let numerator = ICUnit.getUnitScale(from);
    let denominator = ICUnit.getUnitScale(to);

    return numerator / denominator;
  }

  static getUnitScale(unitName) {
    let obj = ICUnit.getUnitCaseInsensitive(unitName);
    return obj[unitName] ?? obj[unitName.toLowerCase()];
  }

  static getUnitTypeAndScale(unitName) {
    let obj = ICUnit.getUnitCaseInsensitive(unitName);
    let scale = obj[unitName] ?? obj[unitName.toLowerCase()];
    return [obj, scale];
  }

  static getBaseUnitName(unitObj) {
    // get shortest key with value 1
    let shortestKey = null;
    Object.keys(unitObj).forEach((key) => {
      if (unitObj[key] == 1 && (!shortestKey || key.length < shortestKey.length)) {
        shortestKey = key;
      }
    });
    return Unit.canonicalName(shortestKey);
  }

  static processUnitName(unitName) {
    return unitName.trim().replace(CONFIG.UNIT_DIVISION_REGEX.find, CONFIG.UNIT_DIVISION_REGEX.replace);
  }

  static convert(x, unitName) {
    // 1. convert to base units
    // 2. for the leftover units, replace with the right numerator / denom scale (2 cows, 3 cows, etc.)
    //  - handle plurals
    //  - handle numeric prefixes
    // 3. multiply the scales together

    if (!IC.isValidEvalResult(x) || IC.hasNoType(x)) {
      return null;
    }

    let value = IC.val(x);

    let processedUnitName = ICUnit.processUnitName(unitName);
    let target = IC.makeICObject(1, processedUnitName);

    /*
      let varValue = IC.envGetVariable(processedUnitName) ?? IC.envGetVariable(IC.stringSingularize(processedUnitName));
      // trying to convert to a variable 
      if (varValue) {
        IC.log(`treating ${processedUnitName} as unit`);
        let divResult = IC.mathDiv(x, varValue);
        let newObj = IC.makeICObject(IC.val(divResult), processedUnitName);
        // return IC.val(divResult);
        return newObj;
      }
        */

    // Handle complex unit expressions with variables
    let result = x;
    let hasVariable = false;
    for (let unit in target.t) {
      let canonicalUnit = IC.canonicalName(unit);
      let isRealUnit = ICUnit.getUnitCaseInsensitive(canonicalUnit);

      if (IC.envIdentifierExists(canonicalUnit) ?? IC.envIdentifierExists(IC.stringSingularize(canonicalUnit))) {

        // if user is overriding "cm"
        if (ICUnit.getUnitCaseInsensitive(canonicalUnit)) {
          break;
        }

        let varValue = IC.envGetVariable(unit) ?? IC.envGetVariable(IC.stringSingularize(unit));
        if (varValue) {
          hasVariable = true;
          IC.log(`treating ${unit} as unit`);
          let divisor = IC.mathPow(varValue, target.t[unit]);
          result = IC.mathDiv(result, divisor);
          delete target.t[unit];
        }
      }
    }
    if (hasVariable) {
      // divide by remaining units in target unit
      if (Object.keys(target.t).length) {
        let divisor = IC.makeICObject(1, target.t);
        result = IC.mathDiv(result, divisor);
      }

      let scale = IC.val(result);
      if (IC.hasType(result)) {
        // ft^2 / acre gets collapsed down 
        scale = IC.val(ICUnit.autoCollapse(result));
      }

      return IC.makeICObject(scale, processedUnitName);
    }

    // lowercase just for temp conversion
    let fromStr = IC.typestring(x.t).toLowerCase();
    let toStr = IC.typestring(target.t).toLowerCase();

    // check for temperature -- if a function, apply that
    const fnObj = IC.CALC.isConversionFunction(fromStr, toStr);
    if (fnObj) {
      const [fromFn, toFn] = [fnObj[fromStr][0], fnObj[toStr][1]];
      const composite = x => toFn(fromFn(x));
      return IC.makeICObject(composite(value), target.t);
    }

    let [fromBase, fromScale] = ICUnit.convertToBaseUnits(x.t);
    let [toBase, toScale] = ICUnit.convertToBaseUnits(target.t);

    let typeSimilarity = IC.typeSimilarityByObject(fromBase, toBase);

    if (typeSimilarity == 0) {
      return null; // no conversion
    }

    // base units are same, no need to type multiply them
    let highPrecisionScale = IC.mathPreciseMultiply(value, fromScale);

    // Determine value based on typeSimilarity
    let newValue = (typeSimilarity == 1)
      ? IC.mathPreciseMultiply((1 / toScale), highPrecisionScale)
      : 1 / IC.mathPreciseMultiply(toScale, highPrecisionScale);

    let typeToAssign = target.t;

    // Inversion logic for both value and type; see "50 hertz in ms per cycle"
    if (typeSimilarity == -1 && Object.keys(x.t).length == 1 && Object.keys(target.t).length == 1) {
      newValue = IC.mathPreciseMultiply(toScale, highPrecisionScale);
      typeToAssign = IC.mathDivideTypePowers(target.t, -1);
    }

    newValue = Number(newValue.toPrecision(12));
    let tmResultObj = IC.makeICObject(newValue, typeToAssign);

    return tmResultObj;
  };

  /**
   * Convert "fuzzy" units like "oz" to "fl oz".
   * @param {string|ICType} typeObj 
   * @returns {string|ICType}
   */
  static swapFuzzyTypes(typeObj) {

    let SWAPS = {
      "oz": "fl oz",
      "ounce": "fl oz",
      "ounces": "fl oz",
      "pound": "GBP",
      "pounds": "GBP",
      "nm": "Newton meter"
    };

    if (typeof typeObj == "string") {
      if (SWAPS[typeObj.toLowerCase()]) {
        return SWAPS[typeObj.toLowerCase()];
      }
      return typeObj;
    }

    // attempt to use "dollar" for "USD" and see if that works
    let clone = IC.cloneObject(typeObj);
    // replae dollar with USD
    Object.keys(clone).forEach((key) => {
      // use swap table
      if (SWAPS[key.toLowerCase()]) {
        clone[SWAPS[key.toLowerCase()]] = clone[key];
        delete clone[key];
      }
    });

    return clone;
  }

  static convertWithUnitSwap(x, unitName) {
    let newObj = IC.cloneObject(x);
    newObj.t = ICUnit.swapFuzzyTypes(x.t);
    let result = ICUnit.convert(newObj, unitName);
    let newUnitName = ICUnit.swapFuzzyTypes(unitName);

    // try swapping the result unit name too
    if (!result && newUnitName) {
      result = ICUnit.convert(newObj, newUnitName);
    }

    return [result, newObj];
  }

  static isPredefinedUnitCaseInsensitive(unitStr = "") {
    return IC.predefinedUnit(unitStr) || IC.predefinedUnit(unitStr.toLowerCase());
  }

  static getUnitCaseInsensitive(unitStr) {
    return ICUnit.getUnit(unitStr) || ICUnit.getUnit(unitStr.toLowerCase());
  }

  static typeConversionScale(fromType, toType) {
    if (!fromType || !toType) {
      return 1;
    }

    let fromTypeStr = typeof fromType == "string" ? fromType : IC.typestring(fromType);
    let toTypeStr = typeof toType == "string" ? toType : IC.typestring(toType);

    if (IC.typestringIsSameUnitCategory(fromTypeStr, toTypeStr)) {
      return ICUnit.getUnitScale(fromTypeStr) / ICUnit.getUnitScale(toTypeStr);
    }

    let [fromBase, fromScale] = ICUnit.convertToBaseUnits(fromType);
    let [toBase, toScale] = ICUnit.convertToBaseUnits(toType);

    if (!ICUnit.isSameUnitObject(fromBase, toBase)) {
      return 1;
    }

    return fromScale / toScale;
  }

}; // end class ICUnit


if (!OPTION_MEMO_OFF) {

  ["stringSingularize",
    "predefinedUnit",
    "typestring",
    "typestringIsPossibleUnitIncludingSlash",
    "typeSimilarityByString",
    "typestringNormalize",
    "parseUnitsFromString",
    "parseWrittenNumber",
    "stringPluralize",
    "_typeMultiply",
    //"_makeICObjectTypeOnly",
    "_makeICObjectUnitType",
    "makeNumber"].forEach(fnname => {
      IC[fnname] = memoize(IC[fnname].bind(IC));
    });

  // Row-aware memoization for functions that depend on row state
  // BUG: this was getting memoized but the row state for the info formatter was not being preserved.
  //  IC.predefinedPostConvertFunction = memoizeRowAware(IC.predefinedPostConvertFunction.bind(IC));

  ["suggestFunction",
    "typestringPluralize",
    "parseSimple",
    "processComment",
    "processCurrencySymbolsAndStrings",
    "removeInvisibleUnicodeCharacters",
    "escapeUnicode",
    "processSymbols",
    "processPrefixRegex",
    "processRegexReplacements",
    "scanAssignedIdentifiersUsingLex",
    "processIdentifiers",
    "processParenUnitExpressions",
    "processPlainEnglishNumbers",
    "processPlainEnglishFunctions",
    "processPlainEnglishOp",
    "processFunctionWithExponent",
    "processUnitTypeBeforeNumber",
    "scanReferencesFromParseResult",
    "getRowParameterFromString",
    "stringCanBeIncremented"
  ].forEach(fnname => {
    if (IC.parser[fnname]) {
      IC.parser[fnname] = memoize(IC.parser[fnname].bind(IC.parser));
    }
  });

  ["areEquivalentBaseUnits",
    /*"convert", */ /* disabled because we log */
    "convertToCompoundUnits",
    "formatSIUnit",
    "getUnitNameAndPower",
    "getUnitScale",
    "infoMessage",
    "isCompoundUnit",
    "isInverseUnitObject",
    "isSIUnit",
    "isSameUnitCategory",
    "isSameUnitObject",
    "sortUnitMLT",
    "typeConversionScale",
  ].forEach(fn => {
    ICUnit[fn] = memoize(ICUnit[fn]);
  });

  ["convertToBaseUnits", "autoCollapse"].forEach(fn => {
    ICUnit[fn] = memoizeWithNewObject(ICUnit[fn]);
  });

  LIB.toFractionIterative = memoize(LIB.toFractionIterative);
}

function SETUP_INSTRUMENTATION(obj, prefix = "") {
  // Object to store function call counts
  // @ts-expect-error
  let functionCallCounts = window.functionCallCounts = window.functionCallCounts || {};

  // Utility to wrap and instrument a function
  function instrument(func, funcName) {
    // Initialize counter for this function
    functionCallCounts[funcName] = 0;

    // Return a new function that increments the counter and calls the original function
    return function (...args) {
      functionCallCounts[funcName]++;
      return func.apply(this, args);
    };
  }

  // Loop through the keys of the object
  for (let key in obj) {
    // Prepare the full function name
    let fullName = prefix ? `${prefix}.${key}` : key;

    // Check if the property is a function
    if (typeof obj[key] === 'function') {
      // If it is, instrument it
      obj[key] = instrument(obj[key], fullName);
    } else if (typeof obj[key] === 'object' && obj[key] !== null) {
      // If it's an object, recursively instrument its functions
      // SETUP_INSTRUMENTATION(obj[key], fullName);
    }
  }

  // Now, each time a function in the object or its sub-objects is called, 
  // the corresponding counter in functionCallCounts will be incremented.
}


class ICTime {
  constructor(years = 0, days = 0, hours = 0, minutes = 0, seconds = 0) {
    this.years = Number(years);
    this.days = Number(days);
    this.hours = Number(hours);
    this.minutes = Number(minutes);
    this.seconds = Number(seconds);
  }

  static makeICObject(timeString) {
    let timeObj = ICTime.parseTime(timeString);
    if (!timeObj) {
      return null;
    }

    let seconds = timeObj.toSeconds();
    let timeformat = timeString.includes(":") ? "time_compact" : "time_units";
    return IC.makeICObject(seconds, "s", timeformat);
  }

  /*
  @param {string} timeString - A string representing a time interval (3h 15m or 3:15).
  */
  static parseTime(timeString) {
    // Preprocess the time string to replace full words with abbreviations
    timeString = timeString.toLowerCase()
      .replace(/\byears?\b/g, 'y')
      .replace(/\bdays?\b/g, 'd')
      .replace(/\bhours?\b/g, 'h')
      .replace(/\bminutes?\b/g, 'm')
      .replace(/\bseconds?\b/g, 's')
      .replaceAll(" ", "");

    let parts = timeString.split(':');

    // Handle colon-separated format
    switch (parts.length) {
      case 2:
        if (parts[1].includes('.')) {
          let [minutes, seconds] = parts.map(Number);
          return new ICTime(0, 0, 0, minutes, seconds);
        }
        return new ICTime(0, 0, parts[0], parts[1]);
      case 3:
        return new ICTime(0, 0, parts[0], parts[1], parts[2]);
    }

    // Handle "XyYdZhZmZs" format
    let match = timeString.match(/(\d+(?:\.\d+)?)([ydhms])/gi);
    if (match) {
      let time = new ICTime();
      for (let part of match) {
        let value = parseFloat(part);
        let unit = part.slice(-1).toLowerCase();
        switch (unit) {
          case 'y':
            time.addYears(value);
            break;
          case 'd':
            time.addDays(value);
            break;
          case 'h':
            time.addHours(value);
            break;
          case 'm':
            time.addMinutes(value);
            break;
          case 's':
            time.addSeconds(value);
            break;
        }
      }
      return time;
    }
    return null;
  }

  /*
@param {number} seconds - The number of seconds to convert to a time string.
@param {string} format - The format to use for the time string (time_units => 3h 15m or time_compact => 3:15).
*/
  static buildTimeString(seconds, format = "time_units") {
    let time_str = LIB.InstaCalc.prototype.fn.time(seconds);

    if (format == "time_compact") {
      // Regular expression to capture years, days, hours, minutes, and seconds
      let regex = /(?:(\d+)y)?\s*(?:(\d+)d)?\s*(?:(\d+)h)?\s*(?:(\d+)m)?\s*(?:(\d+(?:\.\d+)?)s)?/;
      let match = time_str.match(regex);

      if (match) {
        let years = match[1] || "";
        let days = match[2] || "";
        let hours = match[3] || "0";
        let minutes = match[4] || "0";
        let seconds = match[5] || "0";

        // Transform hours, minutes, and seconds into HH:MM:SS format
        let compactTime = `${Number(hours) == 0 ? '00' : hours}:${minutes.padStart(2, '0')}`;
        if (seconds !== "0") {
          compactTime += `:${seconds}`;
        }

        // Reassemble the time string
        time_str = `${years ? years + "y " : ""}${days ? days + "d " : ""}${compactTime}`;
      }
    }
    return time_str.trim();
  }

  add(time) {
    if (time instanceof ICTime) {
      this.addSeconds(time.seconds);
      this.addMinutes(time.minutes);
      this.addHours(time.hours);
      this.addDays(time.days);
      this.addYears(time.years);
    } else {
      return null;
    }
  }

  addYears(years) {
    this.years += years;
  }

  addDays(days) {
    this.days += days;
  }

  addHours(hours) {
    this.days += Math.floor((this.hours + hours) / 24);
    this.hours = (this.hours + hours) % 24;
  }

  addMinutes(minutes) {
    this.addHours(Math.floor((this.minutes + minutes) / 60));
    this.minutes = (this.minutes + minutes) % 60;
  }

  addSeconds(seconds) {
    this.addMinutes(Math.floor((this.seconds + seconds) / 60));
    this.seconds = (this.seconds + seconds) % 60;
  }

  toSeconds() {
    return this.years * 31536000 + this.days * 86400 + this.hours * 3600 + this.minutes * 60 + this.seconds;
  }

  toString() {
    return `${this.years}y ${this.days}d ${this.hours}h ${this.minutes.toString().padStart(2, '0')} ${this.seconds.toString().padStart(2, '0')}`;
  }
}

class ICDate {

  static config = {
    dateSeparators: ['at', '@'],
    timePattern: '\\d{1,2}(?::\\d{2})?\\s*(?:am|pm)?',
    timezonePattern: '(?:\\s*[A-Z]{3,4})?',
    relativeDateKeywords: ['today', 'tomorrow', 'yesterday'],
  };

  static preprocessRelativeDate(input) {
    const { timePattern, timezonePattern, relativeDateKeywords, dateSeparators } = this.config;

    const relativeDatePattern = `(${relativeDateKeywords.join('|')})`;
    const timeWithOptionalTimezone = `(${timePattern}${timezonePattern})`;
    const separatorPattern = dateSeparators.length > 0 ?
      `(?:\\s+(?:${dateSeparators.join('|')})\\s+)?` : '\\s*';

    const patterns = [
      `\\b${timeWithOptionalTimezone}\\s+${relativeDatePattern}`,  // "5pm today"
      `\\b${relativeDatePattern}${separatorPattern}${timeWithOptionalTimezone}?`,  // "today", "today 5pm", "today at 5pm"
    ];

    const relativeDateRegex = new RegExp(patterns.join('|'), 'gi');

    return input.replace(relativeDateRegex, (match, time1, relativeDate1, relativeDate2, time2) => {
      const relativeDate = relativeDate1 || relativeDate2;
      const time = time1 || time2 || '';
      if (relativeDate && time) {
        const processedDate = this.processRelativeDate(relativeDate.toLowerCase(), time.trim());
        return `${processedDate.replace(/[-]/gi, "/")}`;
      }
      return match;
    });
  }

  static processRelativeDate(relativeDate, time) {
    let date = new Date();
    switch (relativeDate) {
      case 'tomorrow':
        date.setDate(date.getDate() + 1);
        break;
      case 'yesterday':
        date.setDate(date.getDate() - 1);
        break;
    }

    if (time) {
      const { timePattern, timezonePattern } = this.config;
      const timeRegex = new RegExp(`^(${timePattern})(${timezonePattern})?$`, 'i');
      const timeMatch = time.match(timeRegex);

      if (timeMatch) {
        const [, timeStr, timezone] = timeMatch;
        const [hourStr, minuteStr = '0'] = timeStr.split(':');
        let [hour, minute] = [parseInt(hourStr), parseInt(minuteStr)];

        const isPM = /pm/i.test(timeStr);
        const isAM = /am/i.test(timeStr);

        // Check if it's 12-hour format
        if (isPM || isAM) {
          // Adjust hour for 12-hour format
          if (hour > 12) {
            IC.log(`Invalid 12-hour time: ${timeStr}`);
            return date.toISOString().split('T')[0];
          }
          if (isPM && hour < 12) {
            hour += 12;
          } else if (isAM && hour === 12) {
            hour = 0;
          }
        } else {
          // 24-hour format
          if (hour >= 24) {
            IC.log(`Invalid 24-hour time: ${timeStr}`);
            return date.toISOString().split('T')[0];
          }
        }

        // Validate minute
        if (minute < 0 || minute > 59) {
          IC.log(`Invalid minutes: ${timeStr}`);
          return date.toISOString().split('T')[0];
        }

        date.setHours(hour, minute, 0, 0);

        let result = date.toISOString().split('T')[0] + ' ' +
          `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        if (timezone) {
          result += ' ' + timezone.trim();
        }
        return result;
      }
    }

    return date.toISOString().split('T')[0];
  }

  static makeICObject(dateString) {
    let dateObj = ICDate.parseDate(dateString);

    // crazy JS date check...
    if (!(dateObj instanceof Date) || isNaN(dateObj)) {
      dateObj = ICDate.parseDateWithSlashOrDotSeparator(dateString);
    }

    // still not a date: jun  
    if (!(dateObj instanceof Date) || isNaN(dateObj)) {
      // split into tokens
      let tokens = dateString.split(/[\s,]+/);
      let restOfString = "";

      // see how many combined tokens are still a valid date...
      for (let i = 1; i < tokens.length; i++) {
        let trialDateObj = ICDate.parseDate(tokens.slice(0, i).join(" "));
        if (trialDateObj instanceof Date && !isNaN(trialDateObj)) {
          dateObj = trialDateObj;
          restOfString = tokens.slice(i).join(" ");
        }
      }

      let timePart = ICDate.parseTimeImpliedDate(restOfString);
      // combine them
      if (timePart) {
        dateObj.setHours(timePart.getHours());
        dateObj.setMinutes(timePart.getMinutes());
        dateObj.setSeconds(timePart.getSeconds());

        // we need _implied to handle the hour display, otherwise 5pm PST becomes midnight and is not displayed
        return IC.makeICObject(dateObj.toISOString(), null, "datetime_ISO_implied");
      }
    }

    if (!dateObj) {
      return null;
    }

    return IC.makeICObject(dateObj.toISOString(), null, "datetime_ISO");
  }

  static convertTimeZoneToNativeDate(dateString) {
    // Extract the timezone abbreviation from the end of the string
    const match = dateString.match(/\b([A-Z]{2,4})\b$/);
    let offsetMinutes;
    let dateObj;

    if (match) {
      const abbreviation = match[1];
      offsetMinutes = ICDate.getTimezoneOffset(abbreviation);
      if (offsetMinutes !== null) {
        // Remove the timezone abbreviation since native JS Date doesn't recognize them
        dateString = dateString.replace(abbreviation, '').trim();
      }
    }

    // Detect German-style dates and convert them to ISO 8601 format
    const germanDateMatch = dateString.match(/^(\d+)\.(\d+)\.(\d+)$/);
    if (germanDateMatch) {
      let [, day, month, year] = germanDateMatch;
      if (day.length === 4) {
        [day, year] = [year, day];
      }

      if (year.length === 2) {
        year = year > 40 ? `19${year}` : `20${year}`;
      }

      if (month > 12) {
        [month, day] = [day, month];
      }

      // parse date manually: 2024.24.12 creates timezone issues
      dateObj = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    }
    else {
      //May 25, 2024 3:00PM no supported natively, add space
      dateString = dateString.replace(/(AM|PM)/i, ' $1');
      let timestamp = Date.parse(dateString);
      dateObj = new Date(timestamp);

      // safari doesn't like: 2020-1-1
      if (isNaN(timestamp) && dateString.includes("-")) {
        const [year, month, day] = dateString.split(/[-\/]/).map(Number);
        dateObj = year ? new Date(year, month - 1, day) : new Date(dateString);
      }
    }

    if (offsetMinutes) {
      dateObj.setMinutes(dateObj.getMinutes() + offsetMinutes);
    }

    return dateObj;
  }

  static makeICObjectTimeImpliedDate(dateString) {
    let dateObj = ICDate.parseTimeImpliedDate(dateString);
    if (!dateObj) {
      return null;
    }
    return IC.makeICObject(dateObj.toISOString(), null, "datetime_ISO_implied");
  }

  static parseDate(dateString) {
    let dateObj = this.convertTimeZoneToNativeDate(dateString);

    // if dateString is a short date, like [Month] [day] without a year, add the current year
    if (dateString.match(/^\w+\s*[,]?\s+\d+$/)) {
      dateObj.setFullYear(new Date().getFullYear());
    }

    return dateObj;
  }

  // example: 3/4/23 10:00:00 PM
  static parseDateWithSlashOrDotSeparator(datetimeStr) {
    // Split the datetime string into date and time parts
    const [datePart, timePart] = datetimeStr.split(' ');

    if (!datePart || !timePart) {
      return null;
    }

    // Further split the date and time parts
    const [month, day, yearPart] = datePart.split(/[./]/);
    let year = parseInt(yearPart, 10);

    // Adjust for two-digit year format
    if (year < 100) {
      if (year > 40) {
        year += 1900;
      }
      else {
        year += 2000;
      }
    }

    const timeString = timePart.slice(0, -2);
    const amPm = timePart.slice(-2).toLowerCase();
    let [hour, minute, second = '0'] = timeString.split(':').map(num => parseInt(num, 10));

    // Convert 12-hour format to 24-hour format if needed
    if (amPm === 'pm' && hour !== 12) {
      hour += 12;
    } else if (amPm === 'am' && hour === 12) {
      hour = 0;
    }

    // Construct a Date object
    const date = new Date(year, parseInt(month, 10) - 1, parseInt(day, 10), hour, minute, second);

    // Return the ISO format string
    return date;
  }

  static TIME_ZONE_FROM_MOMENT = {
    "LMT": "Africa/Nairobi",
    "GMT": "Africa/Lagos",
    "EAT": "Africa/Nairobi",
    "PMT": "Europe/Paris",
    "WET": "Europe/Madrid",
    "WEST": "Europe/Madrid",
    "CET": "Europe/Berlin",
    "CEST": "Europe/Berlin",
    "WAT": "Africa/Lagos",
    "CAT": "Africa/Maputo",
    "EET": "Africa/Cairo",
    "EEST": "Africa/Cairo",
    "SAST": "Africa/Johannesburg",
    "CAST": "Africa/Juba",
    "MMT": "Europe/Moscow",
    "WAST": "Africa/Ndjamena",
    "NST": "America/Adak",
    "NWT": "America/Adak",
    "NPT": "America/Adak",
    "BST": "Europe/London",
    "BDT": "America/Adak",
    "AHST": "America/Adak",
    "HST": "America/Adak",
    "HDT": "America/Adak",
    "AST": "America/Anchorage",
    "AWT": "America/Anchorage",
    "APT": "America/Anchorage",
    "AHDT": "America/Anchorage",
    "YST": "America/Anchorage",
    "AKST": "America/Anchorage",
    "AKDT": "America/Anchorage",
    "CMT": "America/Argentina/Buenos_Aires",
    "AMT": "Europe/Athens",
    "EST": "America/Chicago",
    "MST": "America/Denver",
    "CST": "America/Chicago",
    "MDT": "America/Denver",
    "PST": "America/Los_Angeles",
    "CDT": "America/Chicago",
    "ADT": "America/Barbados",
    "CWT": "America/Chicago",
    "CPT": "America/Chicago",
    "BMT": "America/Bogota",
    "PDT": "America/Los_Angeles",
    "MWT": "America/Denver",
    "MPT": "America/Denver",
    "EDT": "America/Toronto",
    "SJMT": "America/Costa_Rica",
    "PWT": "America/Los_Angeles",
    "PPT": "America/Los_Angeles",
    "YDT": "America/Dawson",
    "YWT": "America/Dawson",
    "YPT": "America/Dawson",
    "YDDT": "America/Dawson",
    "EWT": "America/Toronto",
    "EPT": "America/Toronto",
    "NDT": "America/Goose_Bay",
    "ADDT": "America/Goose_Bay",
    "KMT": "America/Grand_Turk",
    "QMT": "America/Guayaquil",
    "HMT": "Asia/Dhaka",
    "FFMT": "America/Martinique",
    "PPMT": "America/Port-au-Prince",
    "SMT": "Asia/Kuala_Lumpur",
    "SDMT": "America/Santo_Domingo",
    "NDDT": "America/St_Johns",
    "PMMT": "Pacific/Port_Moresby",
    "AEST": "Australia/Sydney",
    "AEDT": "Australia/Sydney",
    "NZMT": "Pacific/Auckland",
    "NZST": "Pacific/Auckland",
    "NZDT": "Pacific/Auckland",
    "CEMT": "Europe/Berlin",
    "IST": "Asia/Kolkata",
    "IDT": "Asia/Gaza",
    "PLMT": "Asia/Ho_Chi_Minh",
    "HKT": "Asia/Hong_Kong",
    "HKST": "Asia/Hong_Kong",
    "HKWT": "Asia/Hong_Kong",
    "JST": "Asia/Hong_Kong",
    "IMT": "Europe/Istanbul",
    "WIB": "Asia/Jakarta",
    "WIT": "Asia/Jayapura",
    "JMT": "Asia/Jerusalem",
    "IDDT": "Asia/Jerusalem",
    "PKT": "Asia/Karachi",
    "PKST": "Asia/Karachi",
    "WITA": "Asia/Makassar",
    "KST": "Asia/Seoul",
    "RMT": "Europe/Rome",
    "KDT": "Asia/Seoul",
    "TBMT": "Asia/Tbilisi",
    "TMT": "Asia/Tehran",
    "JDT": "Asia/Tokyo",
    "FMT": "Atlantic/Madeira",
    "ACST": "Australia/Adelaide",
    "ACDT": "Australia/Adelaide",
    "AWST": "Australia/Perth",
    "AWDT": "Australia/Perth",
    "EMT": "Pacific/Easter",
    "DMT": "Europe/Dublin",
    "UTC": "Etc/UTC",
    "BDST": "Europe/London",
    "MSK": "Europe/Moscow",
    "MSD": "Europe/Moscow",
    "WEMT": "Europe/Madrid",
    "MDST": "Europe/Moscow",
    "LST": "Europe/Riga",
    "WMT": "Europe/Warsaw",
    "GST": "Pacific/Guam",
    "GDT": "Pacific/Guam",
    "ChST": "Pacific/Guam",
    "HWT": "Pacific/Honolulu",
    "HPT": "Pacific/Honolulu",
    "SST": "Pacific/Pago_Pago"
  };

  static TIME_ZONE_MAPPING_DEFAULT = {
    // North American time zones
    'EST': 'America/New_York',      // Eastern Standard Time
    'EDT': 'America/New_York',      // Eastern Daylight Time
    'ET': 'America/New_York',       // Eastern Time
    'PST': 'America/Los_Angeles',   // Pacific Standard Time
    'PDT': 'America/Los_Angeles',   // Pacific Daylight Time
    'PT': 'America/Los_Angeles',    // Pacific Time
    'CST': 'America/Chicago',       // Central Standard Time (also China Standard Time)
    'CDT': 'America/Chicago',       // Central Daylight Time
    'CT': 'America/Chicago',        // Central Time
    'MST': 'America/Denver',        // Mountain Standard Time
    'MDT': 'America/Denver',        // Mountain Daylight Time
    'MT': 'America/Denver',         // Mountain Time
    'AST': 'America/Halifax',       // Atlantic Standard Time
    'ADT': 'America/Halifax',       // Atlantic Daylight Time
    'HST': 'Pacific/Honolulu',      // Hawaii Standard Time
    'HAST': 'Pacific/Honolulu',     // Hawaii-Aleutian Standard Time
    'HADT': 'Pacific/Honolulu',     // Hawaii-Aleutian Daylight Time
    'AKST': 'America/Anchorage',    // Alaska Standard Time
    'AKDT': 'America/Anchorage',    // Alaska Daylight Time

    // Other common time zones
    'GMT': 'Etc/GMT',               // Greenwich Mean Time
    'UTC': 'Etc/UTC',               // Coordinated Universal Time
    'BST': 'Europe/London',         // British Summer Time
    'CET': 'Europe/Paris',          // Central European Time
    'CEST': 'Europe/Paris',         // Central European Summer Time
    'IST': 'Asia/Kolkata',          // Indian Standard Time (also Israel Standard Time)
    'AEST': 'Australia/Sydney',     // Australian Eastern Standard Time
    'AEDT': 'Australia/Sydney',     // Australian Eastern Daylight Time
    'AWST': 'Australia/Perth',      // Australian Western Standard Time
    'NZST': 'Pacific/Auckland',     // New Zealand Standard Time
    'NZDT': 'Pacific/Auckland',     // New Zealand Daylight Time

    'ICT': 'Asia/Bangkok',          // Indochina Time

    'MET': 'MET',                  // Middle European Time  
    'MEST': 'MET',

    // ... add more as needed
  };

  static getIANATimeZone(abbreviation) {
    if (!abbreviation) return null;

    // Normalize the abbreviation: UTCPLUS9, UTCMINUS9
    abbreviation = abbreviation.toUpperCase().replace(/PLUS/g, '+').replace(/MINUS/g, '-');
    const match = abbreviation.match(/^(UTC|GMT)([+-][0-9]+)?$/);
    if (match) {
      let offset = match[2] || '+0';
      // For 'Etc/GMT', reverse the sign
      offset = offset.replace(/^([+-])/, (sign) => (sign === '+' ? '-' : '+'));
      return `Etc/GMT${offset}`; // IANA time zone 
    }

    return this.TIME_ZONE_MAPPING_DEFAULT[abbreviation] || this.TIME_ZONE_FROM_MOMENT[abbreviation] || null;
  }

  static getTimezoneOffset(timezone) {
    if (!timezone) {
      return null;
    }
    const localTime = new Date();

    // Check for UTC±X or GMT±X format
    const match = timezone.match(/^(UTC|GMT)([+-])(\d+)$/i);
    if (match) {
      const [, prefix, sign, hours] = match;
      const offsetMinutes = (sign === '-' ? 1 : -1) * hours * 60; // Convert hours to minutes
      const localOffset = localTime.getTimezoneOffset(); // Local offset in minutes
      return offsetMinutes - localOffset; // Adjust for local timezone
    }

    let tz = this.getIANATimeZone(timezone);
    if (tz == null) {
      return null;
    }

    const timezoneTime = new Date(localTime.toLocaleString('en-US', { timeZone: tz }));
    const difference = Math.round((localTime.getTime() - timezoneTime.getTime()) / (60 * 1000));
    return difference;
  }

  static parseTimeImpliedDate(dateString) {
    // @ts-ignore 
    const match = dateString.match(window.TIME_IMPLIED_DATE);

    const TIMEZONEREGEX = "\\s*(?:UTC[+-][0-9]+|GMT[+-][0-9]+|[A-Za-z]{2,4})"; // Timezone: PST, GMT+5, UTC+5

    //    const [_, hour, minute, second, period, timezone] = match[0].match(/(\d{1,2})(?::(\d{1,2}))?(?::(\d{1,2}))?\s*(am|pm)?\s*([A-Z]{2,4}([+-]\d+)?)?/i) || [];

    const [_, hour, minute, second, period, timezone] =
      match[0].match(new RegExp(`(\\d{1,2})(?::(\\d{1,2}))?(?::(\\d{1,2}))?\\s*(am|pm)?\\s*(${TIMEZONEREGEX})?`, 'i')) || [];


    if (!hour) {
      return null;
    }

    let parsedHour = parseInt(hour, 10);
    let parsedMinute = parseInt(minute || '0', 10);
    let parsedSecond = parseInt(second || '0', 10);

    // Convert 12-hour format to 24-hour format
    if (period && period.toLowerCase() === 'pm' && parsedHour !== 12) {
      parsedHour += 12;
    } else if (period && period.toLowerCase() === 'am' && parsedHour === 12) {
      parsedHour = 0;
    }

    const dateObj = new Date();
    dateObj.setHours(parsedHour, parsedMinute, parsedSecond, 0);

    // If timezone is provided, adjust the dateObj based on the timezone offset
    if (timezone) {
      const offsetMinutes = ICDate.getTimezoneOffset(timezone);
      if (offsetMinutes == null) {
        return null;
      }
      dateObj.setMinutes(dateObj.getMinutes() + offsetMinutes); // Add the offset
    }

    return dateObj;
  }


  // convert date to unit
  // unit: timezone, or perhaps another date (give difference)
  static convertTo(result, unit) {
    let dateObj = new Date(IC.val(result));
    let tzConversion = ICDate.toTimeZone(dateObj, unit);
    return tzConversion;
  }

  static toTimeZone(dateObj, newTimeZone) {
    let tz = this.getIANATimeZone(newTimeZone);
    if (tz == null || !dateObj) {
      return null;
    }

    // Get the current time in the provided timezone
    const timezoneTime = dateObj.toLocaleString('en-US',
      {
        timeZone: tz,
        timeZoneName: 'short',
        hour12: true,
        hour: 'numeric',
        minute: '2-digit'
      });
    return this.cleanupDateTimeString(timezoneTime);
  }

  static cleanupDateTimeString(dateString) {
    return dateString;
  }

  static isDateTimeObject(obj) {
    let val = IC.val(obj);
    let format = IC.format(obj);
    return typeof val === "string" && format.includes("datetime");
  }

  static toString(dateObj) {
    let str = IC.val(dateObj);
    let date = new Date(str);
    let format = IC.format(dateObj);

    const dateOptions = {
      weekday: 'short', // "Mon"
      year: 'numeric',  // "1994"
      month: 'short',   // "Nov"
      day: 'numeric'    // "5"
    };

    const timeOptions = {
      hour12: true,
      hour: 'numeric',
      minute: '2-digit'
    };

    // Add seconds to timeOptions only if they are non-zero
    if (date.getSeconds() !== 0) {
      timeOptions.second = '2-digit';
    }

    // show timezone if format has _implied
    if (format.includes("_implied")) {
      timeOptions.timeZoneName = 'short';
    }

    // @ts-expect-error
    const formattedDate = date.toLocaleDateString('en-US', dateOptions);
    // @ts-expect-error
    const formattedTime = date.toLocaleTimeString('en-US', timeOptions);

    let defaultRet = `${formattedDate} ${formattedTime}`;
    if (format.includes("_implied")) {
      return defaultRet;
    }

    // if date obj is T00:00:00.000Z, return just the date
    if (date.toISOString().includes("T00:00:00.000Z") || formattedTime === "12:00 AM") {
      return formattedDate;
    }

    return defaultRet;
  }

  static addDates(dateObj, timeObj) {
    // the order could be swapped
    if (IC.hasType(dateObj) && IC.typestringIsSameUnitCategory(IC.typestring(dateObj.t), "s")) {
      // swap
      let temp = dateObj;
      dateObj = timeObj;
      timeObj = temp;
    }

    let date = new Date(IC.val(dateObj));
    const originalHour = date.getUTCHours();
    const originalMinute = date.getUTCMinutes();
    const originalSecond = date.getUTCSeconds();
    const originalMillisecond = date.getUTCMilliseconds();

    // default to day addition
    if (typeof timeObj === "number") {
      timeObj = IC.makeICObject(timeObj, "days");
    }

    // convert time object to seconds
    let secondsResult = IC.ICObjectConvertToType(timeObj, "s");
    let seconds = IC.val(secondsResult);

    // TODO -- the tricky thing is dealing with time zone changes. Not sure how clever to be here.
    let typeString = IC.hasType(timeObj) ? IC.typestring(timeObj.t) : null;
    switch (typeString) {
      case "month":
      case "months":
        let months = IC.val(timeObj);
        let wholeMonths = Math.floor(months);
        let remainingDays = (months - wholeMonths) * 30; // Approximate the remaining fraction as days
        date.setMonth(date.getMonth() + wholeMonths);
        date.setDate(date.getDate() + remainingDays);
        break;

      case "year":
      case "years":
        date.setFullYear(date.getFullYear() + IC.val(timeObj))
        break;

      default:
        // add seconds to date
        date.setTime(date.getTime() + (seconds * 1000));
        if (seconds % 86400 === 0) {
          date.setUTCHours(originalHour);
          date.setUTCMinutes(originalMinute);
          date.setUTCSeconds(originalSecond);
          date.setUTCMilliseconds(originalMillisecond);
        }
    }

    // reset time component to original values only if the added seconds 
    // is a multiple of a day (i.e., 86400 seconds). Otherwise, keep the changed time.

    let clone = IC.cloneObject(dateObj);
    clone.v = date.toISOString();
    return clone;
  }

  static subDates(dateObj, otherObj) {
    let otherVal = IC.val(otherObj);

    // if other obj is a date string, find the difference
    if (this.isDateString(otherVal)) {
      let first = IC.val(dateObj)

      // get difference between dates. Sometimes there's a difference because of DST
      // @ts-expect-error
      let diff = new Date(first) - new Date(otherVal);

      // convert to an absolute number of days
      let days = Math.abs(Math.round(diff / (1000 * 60 * 60 * 24)));
      let type = days == 1 ? "day" : "days"
      return IC.makeICObject(days, type);
    }

    // assume it's a time offset
    return this.addDates(dateObj, IC.mathNegate(otherObj));
  }

  static isDateString(dateString) {
    // Check if the date string is purely numeric
    if (/^\d+$/.test(dateString)) {
      return false;
    }
    // Check if the date string is a valid date
    return !isNaN(Date.parse(dateString));
  }

  /*
  // @ts-ignore
  const timeZones = Intl.supportedValuesOf('timeZone');
 
  timeZones.forEach(timeZone => {
    const formatted = new Intl.DateTimeFormat('en-US', { timeZone: timeZone, timeZoneName: 'short' }).format(new Date());
    const match = formatted.match(/[A-Z]{2,4}$/); // Match 2 to 4 uppercase letters at the end of the string
    const abbreviation = match ? match[0] : undefined;
 
    if (abbreviation && abbreviation.length <= 4) {
      this.TIME_ZONE_MAPPING[abbreviation] ||= timeZone;
    }
  });
  */

}

/**
 * Simple Performance Logger
 *
 * Usage:
 * PerfLog.start("myTask");
 * // ... do the task ...
 * PerfLog.end("myTask", optionalDebugLogArray);
 *
 * To enable/disable, set PerfLog.enabled = true/false;
 * (Default is based on URL query param 'timing')
 */
const PerfLog = {
  // Enable logging if the URL contains "?timing" or "&timing"
  enabled: window?.location?.search?.includes('timing') || false,

  // Internal store for start times
  _startTimes: {},

  /**
   * Starts a performance timer for a given name.
   * @param {string} name - Unique identifier for the timer.
   */
  start: function (name) {
    if (this.enabled) {
      this._startTimes[name] = performance.now();
      // Optional: Log start event immediately if needed
      // console.log(`[Perf] Starting: ${name}`);
    }
  },

  /**
   * Ends a performance timer, calculates duration, and logs the result.
   * @param {string} name - Unique identifier for the timer (must match a previous start call).
   * @param {Array<[string, any] | string>} [logArray=null] - Optional array to push the log entry into.
   *                                                        If provided, the entry will be `"[Perf] name: durationMs"`.
   *                                                        If null, logs directly to console.
   * @returns {number | null} The duration in milliseconds, or null if not enabled or timer not found.
   */
  end: function (name, logArray = null) {
    if (this.enabled && this._startTimes[name] !== undefined) {
      const endTime = performance.now();
      const duration = endTime - this._startTimes[name];
      const logEntry = `[Perf] ${name}: ${duration.toFixed(2)}ms`;

      if (logArray && Array.isArray(logArray)) {
        // Find the entry for this step's result and insert timing after it,
        // Or just push if the primary entry isn't easily found by name match.
        let inserted = false;
        const stepNameWithoutCounter = name.substring(name.indexOf('_') + 1); // Try to match description without counter
        for (let i = logArray.length - 1; i >= 0; i--) {
          if (Array.isArray(logArray[i]) && logArray[i][0] === name) { // Match full numbered name
            logArray.splice(i + 1, 0, logEntry);
            inserted = true;
            break;
          }
          // Fallback: Match description part if full name not found (less precise insertion)
          if (!inserted && Array.isArray(logArray[i]) && logArray[i][0].endsWith(stepNameWithoutCounter)) {
            logArray.splice(i + 1, 0, logEntry);
            inserted = true;
            // Keep searching in case the full name appears later
          }
        }
        // If still not inserted (e.g., very first timing), just push
        if (!inserted) {
          logArray.push(logEntry);
        }
      } else {
        // Fallback to console if no array provided or not an array
        console.log(logEntry);
      }

      delete this._startTimes[name]; // Clean up the start time
      return duration;
    }
    return null; // Return null if not enabled or timer wasn't started
  },

  /**
   * Wraps a function execution with start/end timing.
   * @param {string} name - Unique identifier for the timer.
   * @param {Function} func - The function to execute and time.
   * @param {Array<[string, any] | string>} [logArray=null] - Optional array to push the log entry into.
   * @returns {Function} A new function that, when called, executes the original function,
   *                     logs its performance, and returns the original function's result.
   */
  time: function (name, func, logArray = null) {
    if (!this.enabled) {
      return func; // Return original function if not enabled
    }

    const self = this; // Capture 'this' context of PerfLog
    return function (...args) {
      self.start(name);
      let result;
      try {
        result = func.apply(this, args); // Preserve original 'this' context for func call
      } finally {
        // Ensure end is called even if func throws an error
        self.end(name, logArray);
      }
      return result;
    };
  },

  /**
   * Resets the internal start times (useful for tests or restarts).
   */
  reset: function () {
    this._startTimes = {};
  }
};

class Chart {
  static BAR = "barchart";
  static LINE = "linechart";
  static PIE = "piechart";

  static getChartData(values, type) {
    const meta = IC.envGetRowRangeMeta();

    // Assuming v is an array of values and meta has extra metadata (for example, labels)
    const data = values?.map((value, idx) => {
      return {
        label: meta[idx].title,
        value: IC.val(value)
      };
    });

    return {
      data: data,
      type: type,
      startIndex: IC.envGetTemp("startIndex"),
      endIndex: IC.envGetTemp("endIndex")
    };
  }
}

// SETUP_INSTRUMENTATION(ICUnit);
//SETUP_INSTRUMENTATION(IC);
//SETUP_INSTRUMENTATION(IC.parser);
//SETUP_INSTRUMENTATION(ICUnit);
// semicolon required, cannot end with comment
;
;
function hideTour() {
  Action.setLocalOption("hideTour", true);
}

function toggleTour() {
}

function showTour() {
  Action.setLocalOption("hideTour", false);
}

function isPWA() {
  if (window.location.href.match("pwa")) {
    return true;
  }

  return ["fullscreen", "standalone", "minimal-ui"].some(
    (displayMode) => window.matchMedia("(display-mode: " + displayMode + ")").matches
  );
}

function checkPWA() {
  // console.log("checking pwa...", new Date());
  if (isPWA()) {
    //   console.log("is PWA");
    hideTour();
  }

  if (Action.getLocalOption("hideTour")) {
    hideTour();
  }
}

var Action = window.Action;

Action.scanForEmbed = function (fn, retries = 2) {
  document.querySelectorAll("instacalc:not(.loaded)").forEach(el => {
    var embed_id = el.getAttribute("embed-id");
    if (embed_id) {
      ReactDOM.render(
        React.createElement(__ICREACT.default.Shared, {
          Action: window.Embed,
          view: "embed",
          embed_id: embed_id,
        }),
        el,
        () => {
          // Check if the calc was actually rendered
          const rowsElement = el.querySelector('rows');
          if (rowsElement && rowsElement.children.length > 0) {
            // console.log('load success', embed_id, el);
            el.classList.add("loaded");
            el.classList.remove("load-failed");
            fn && fn(embed_id);
          } else {
            // console.warn("Failed to load calc", embed_id);
            el.classList.add("load-failed");
            if (retries > 0) {
              // run this function again after 2000ms
              setTimeout(() => {
                // console.log("retrying scanForEmbed", embed_id);
                Action.scanForEmbed(fn, retries - 1);
              }, 2000);
            }
          }
        }
      );
    }
  });
};

class Store {
  constructor(data) {
    this.callbacks = [];
    this.data = data || null;
  }

  pub(data) {
    this.data = data;
    this.callbacks.forEach(fn => fn(data));
  }

  sub(fn) {
    this.callbacks.push(fn);
    if (this.data) {
      fn(this.data);
    }
  }

  data() {
    return this.data;
  }
}

class Router {

  static VIEW = {
    MISSING: -1,
    HOME: 1,
    SHARED: 2,
    SINGLE: 3,
    EMBED: 4,
    LEGACY: 5,
    DASHBOARD: 100,
    CHROME: 102
  }

  static isHome() {
    return this.getLayoutType() == this.VIEW.HOME;
  }

  static goHome() {
    window.location = "/";
  }

  static getLayoutType() {
    // example: http://bit.ly/2gPx4fs
    var query = Util.parseQuery(window.location.href);
    if (query.v) {
      return this.VIEW.LEGACY;
    }

    if (window.location.pathname == "/") {
      return this.VIEW.HOME;
    }

    // search before single calc: instacalc.com/123/embed
    if (window.location.pathname.match('/embed')) {
      return this.VIEW.EMBED;
    }

    if (window.location.pathname.match("/shared")) {
      return this.VIEW.SHARED;
    }

    if (window.location.pathname.match("/dashboard")) {
      return this.VIEW.DASHBOARD;
    }

    if (window.location.pathname.match("/chrome")) {
      return this.VIEW.CHROME;
    }

    // instacalc.com/123
    if (window.location.pathname.match(/[/]\d+/)) {
      return this.VIEW.SINGLE;
    }

    return this.VIEW.MISSING;
  }

  static getCalcIdFromURL() {
    var matchesSingleCalc = window.location.href.match(/[/]([0-9]+)/);
    return matchesSingleCalc ? matchesSingleCalc[1] : null;
  }

  static setupUserLogin() {
    // TODO: save login state in localstorage and refresh if needed? Assume localstorage has the latest...

    window.UserStore = new Store();
    UserStore.sub(user => {
      if (user?.uid) {
        document.querySelectorAll('.if-logged-in').forEach(el => el.style.display = '');
        document.querySelectorAll('.if-logged-out').forEach(el => el.style.display = 'none');
      }
      else {
        document.querySelectorAll('.if-logged-out').forEach(el => el.style.display = '');
        document.querySelectorAll('.if-logged-in').forEach(el => el.style.display = 'none');
      }
    })

    Action.checkUserLogin(user => UserStore.pub(user));
  }

  static LoadLegacy() {
    var shared_calc = Util.parseLegacyCalc(window.location.href);
    Embed.save(shared_calc);

    if (window.location.pathname.match("embed")) {
      shared_calc.name = "";
      this.LoadEmbed(shared_calc.id, { legacy: true });
    }
    else {
      this.LoadSingle(shared_calc.id, { legacy: true });
    }
  }

  static LoadHome(layout) {
    this.setupUserLogin();

    // main app - https://brettdewoody.com/accessing-component-methods-and-state-from-outside-react/
    window.App = null;
    let appComponent = React.createElement(__ICREACT.default.App, { Action: window.Action, layout: layout || "home", ref: (component) => { window.App = component } });
    let el = document.querySelector("App");
    if (el) {
      ReactDOM.render(appComponent, el);
    }
  }

  static LoadShared() {
    let el = document.querySelector('SharedGallery');

    fetch('https://gist.githubusercontent.com/kazad/615e5b87d158d5bf98508b335973ff3c/raw/instacalc.gallery.html').then(function (response) {
      return response.text();
    }).then(function (html) {
      el.innerHTML = html;
      var wrap = document.getElementById("shared-gallery-wrap");
      wrap.classList.remove("hidden");

    }).catch(function (err) {
      console.warn('Error loading Gallery HTML', err);
    });
  }

  static LoadSingle(id, opts) {
    // if trailing slash, redirect
    if (location.pathname.endsWith("/") && !opts?.legacy) {
      //console.log("redirecting...");
      window.location.href = location.pathname.slice(0, -1);
      return;
    }

    this.LoadHome('single');

    id = id || this.getCalcIdFromURL();
    window.ReactComponent = React.createElement(__ICREACT.default.Shared, { Action: window.Embed, setTitle: true, view: "public", embed_id: id });
    let el = document.querySelector("calcwrap");
    if (el) {
      ReactDOM.render(window.ReactComponent, el);
    }
  }

  static LoadEmbed(id) {
    id = id || this.getCalcIdFromURL();
    document.querySelector("instacalc[data-load-url]").setAttribute("embed-id", id);
    Action.scanForEmbed();

    // TODO: have a blank calc if you just want to embed? instacalc.com/embed should be blank
  }

  static route() {
    let view = Router.getLayoutType();

    if (view != Router.VIEW.EMBED) {
      Action.loadFirebase();
    }

    switch (view) {
      case Router.VIEW.HOME:
        Router.LoadHome();
        break;
      case Router.VIEW.SHARED:
        Router.LoadShared();
        break;
      case Router.VIEW.SINGLE:
        Router.LoadSingle();
        break;
      case Router.VIEW.EMBED:
        Router.LoadEmbed();
        break;
      case Router.VIEW.LEGACY:
        Router.LoadLegacy();
        break;
      case Router.VIEW.DASHBOARD:
        break;

      case Router.VIEW.CHROME:
        window.location.href = "/";
        break;

      default:
        console.error('unrecognized path', window.location.href);
        // window.location.href = "/";
        break;
    }

    Action.scanForEmbed();
  }
}

// Initialize Alpine store with defaults immediately to avoid race conditions
if (typeof Alpine !== 'undefined') {
  Alpine.store('view', Router.VIEW?.HOME || 'home');
}

document.addEventListener('alpine:init', () => {
  Alpine && Alpine.store('view', Router.getLayoutType());
})

document.addEventListener('DOMContentLoaded', function () {
  Router.route();
  // TODO: wait for InstaCalc, Action and IC objects
}, false);

document.addEventListener('DOMContentLoaded', function () {
  Action.registerKeyboardHandlers();
});

// drag and drop
document.addEventListener('DOMContentLoaded', function () {

  let isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0);
  if (isTouchDevice || !Router.isHome()) {
    return;
  }


  var style = document.createElement('style');
  style.innerHTML = `
/* drag and drop */
.isdragged .hs-dropdown-menu {
  display: none !important;
  visibility: hidden !important;
  z-index: -50 !important;
}

body.isdragged {
  _background: red !important;
}

.draggable {
  cursor: move;
  user-select: none;
}

.placeholder {
  background: var(--secondary-bg-color);
  border: 2px dashed var(--soft-border-color);
  border-radius: 8px;
}`;
  document.head.appendChild(style);

  let fromIndex = null;
  let toIndex = null;

  let draggingEle;
  let placeholder;
  let isDraggingStarted = false;

  // The current position of mouse relative to the dragging element
  let x = 0;
  let y = 0;

  // Swap two nodes
  const swap = function (nodeA, nodeB) {
    const parentA = nodeA.parentNode;
    const siblingA = nodeA.nextSibling === nodeB ? nodeA : nodeA.nextSibling;

    // Move `nodeA` to before the `nodeB`
    nodeB.parentNode.insertBefore(nodeA, nodeB);

    // Move `nodeB` to before the sibling of `nodeA`
    parentA.insertBefore(nodeB, siblingA);
  };

  // Check if `nodeA` is above `nodeB`
  const isAbove = function (nodeA, nodeB) {
    // Get the bounding rectangle of nodes
    const rectA = nodeA.getBoundingClientRect();
    const rectB = nodeB.getBoundingClientRect();

    return rectA.top + rectA.height / 2 < rectB.top + rectB.height / 2;
  };

  let mouseDownHandler;
  mouseDownHandler = function (e) {
    draggingEle = e.target.closest("row");
    draggingEle.setAttribute("isdragged", "true");

    fromIndex = draggingEle.getAttribute("data-index");

    // Calculate the mouse position
    x = e.clientX - draggingEle.offsetLeft;
    y = e.clientY - draggingEle.offsetTop;

    // Attach the listeners to `document`
    document.addEventListener('mousemove', mouseMoveHandler);
    document.addEventListener('mouseup', mouseUpHandler);
  };

  let mouseMoveHandler;
  mouseMoveHandler = function (e) {
    const draggingRect = draggingEle.getBoundingClientRect();

    if (!isDraggingStarted) {
      isDraggingStarted = true;
      document.body.classList.add("isdragged");

      // Let the placeholder take the height of dragging element
      // So the next element won't move up
      placeholder = document.createElement('div');
      placeholder.classList.add('placeholder');
      draggingEle.parentNode.insertBefore(placeholder, draggingEle.nextSibling);
      placeholder.style.height = `${draggingRect.height}px`;
    }

    // Set position for dragging element
    draggingEle.style.position = 'absolute';
    draggingEle.style.top = `${e.clientY - y}px`;

    draggingEle.style.left = "25px"; // vertical axis lock //`${e.pageX - x - 20}px`;
    draggingEle.style.width = "100%";


    // prevEle
    // draggingEle
    // placeholder
    // nextEle
    const prevEle = draggingEle.previousElementSibling;
    const nextEle = placeholder.nextElementSibling;

    // The dragging element is above the previous element
    // User moves the dragging element to the top
    if (prevEle && isAbove(draggingEle, prevEle)) {
      // The current order    -> The new order
      // prevEle              -> placeholder
      // draggingEle          -> draggingEle
      // placeholder          -> prevEle
      swap(placeholder, draggingEle);
      swap(placeholder, prevEle);

      toIndex = prevEle.getAttribute("data-index");
      return;
    }

    // The dragging element is below the next element
    // User moves the dragging element to the bottom
    if (nextEle && isAbove(nextEle, draggingEle)) {
      // The current order    -> The new order
      // draggingEle          -> nextEle
      // placeholder          -> placeholder
      // nextEle              -> draggingEle
      swap(nextEle, placeholder);
      swap(nextEle, draggingEle);

      toIndex = nextEle.getAttribute("data-index");
    }
  };

  let mouseUpHandler;
  mouseUpHandler = function () {

    if (fromIndex !== null && toIndex !== null) {
      // perform the swap
      Action.dragMove(fromIndex, toIndex);

      // React DOM has been manipulated
      App.renderCalc();

      fromIndex = null;
      toIndex = null;
    }

    // Remove the placeholder
    placeholder && placeholder?.parentNode?.removeChild(placeholder);

    draggingEle.style.removeProperty('top');
    draggingEle.style.removeProperty('left');
    draggingEle.style.removeProperty('position');
    draggingEle.style.removeProperty('width');

    draggingEle.removeAttribute("isdragged");
    document.body.classList.remove("isdragged");

    x = null;
    y = null;
    draggingEle = null;
    isDraggingStarted = false;

    // Remove the handlers of `mousemove` and `mouseup`
    document.removeEventListener('mousemove', mouseMoveHandler);
    document.removeEventListener('mouseup', mouseUpHandler);

  };

  document.addEventListener('mousedown', function (e) {
    if (e.target.matches('.draggable')) {
      mouseDownHandler(e);
    }
  });
});;
if (!IC) {
    throw ("IC object not found");
}

IC.WORKER = null;
IC.WORKER_LOADED = false;

if (typeof (Worker) !== "undefined") {
    let nonce = document.lastModified;
    IC.WORKER = new Worker("/dist/worker.js?" + nonce);

    // 
    IC.WORKER.postMessage({ type: "LOAD", nonce: nonce });

    IC.WORKER.onmessage = function (event) {
        if (event.data.type == "LOADED") {
            console.log("⚡⚡⚡ background worker loaded");
            IC.WORKER_LOADED = true;
        }

        if (event.data.type == "RESULT") {
            let fn = BG_REQUEST[event.data.id];
            fn(event.data.result);
        }

        if (event.data.type == "PUB") {
            Calc.pub();
        }

        if (event.data.type == "FETCH_CALC") {
            const id = event.data.id;
            const calc = Calc.all().find((c) => c.name?.toLowerCase().trim() === id.toLowerCase().trim());
            IC.WORKER.postMessage({ type: 'FETCH_CALC_RESULT', calc: calc, id_lookup: id });
        }
    };

    var BG_REQUEST = {};
    IC.WORKER_RECALCULATE = (calc, fn) => {
        if (IC.WORKER_LOADED) {
            BG_REQUEST[calc.id] = fn;
            IC.WORKER.postMessage({ calc: calc, type: "RECALCULATE", id: calc.id });
        } else {
            console.error("worker not loaded");
        }
    }
};
// External cache variable
const urlCache = new Map();

function loadHTML() {
    document.querySelectorAll('[data-load]:not(.loaded)').forEach(el => {
        el.classList.add("loaded");
        const url = el.getAttribute("data-load");

        // If this URL isn't in the cache, add it
        // This happens only once per URL, even if multiple elements request it
        if (!urlCache.has(url)) {
            urlCache.set(url, fetch(url).then(r => r.text()));
        }

        // Get the promise from the cache (whether it was just created or already existed)
        // All elements requesting the same URL will use the same promise
        urlCache.get(url).then(text => {
            el.innerHTML = text;
            if (text.includes("data-load")) loadHTML();
            Action.scanForEmbed();
            scanForConversionUI();
        });
    });

    Action.scanForEmbed();
    scanForConversionUI();
}

function processPress(event) {
    const el = event.target;
    const isButton = el.tagName === "BUTTON" || el.closest('button');

    const link = el.closest('.gallery a');
    if (link) {
        event.preventDefault();

        const preview = link.parentElement.parentElement.querySelector('.gallery-preview')
            ||
            link.parentElement.parentElement.parentElement.querySelector('.gallery-preview');
        const embedId = link.getAttribute("href").split("/").reverse()[0];

        preview.classList.remove("loaded");
        preview.setAttribute("embed-id", embedId);

        Action.scanForEmbed();
        return;
    }

    const convertButtonPad = el.closest('.convert buttonpad');
    if (convertButtonPad && isButton) {
        const selects = convertButtonPad.querySelectorAll('select');
        const str = `${selects[0].value} ${selects[1].value} in ${selects[2].value}`;

        Action.addTextToCurrentCalc(str.trim());
        return;
    }

    const buttonPad = el.closest('buttonpad');
    if (buttonPad && isButton) {
        const button = el.closest('button');
        const cmd = button.getAttribute("data-cmd") || button.textContent;

        switch (cmd) {
            case "BACKSPACE":
                Action.deleteTextFromCurrentCalc(1);
                break;

            case "DOWNARROW":
                Action.selectRelativeRow(1);
                break;

            case "UPARROW":
                Action.selectRelativeRow(-1);
                break;

            default:
                Action.addTextToCurrentCalc(cmd.trim());
        }
    }
}

// Global function - no dependency on Action object
function scanForConversionUI() {
    document.querySelectorAll('.conversion-ui:not(.loaded)').forEach(container => {
        container.classList.add("loaded");
        createConversionUI(config, container);
    });
}

document.addEventListener('DOMContentLoaded', function () {
    const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    const eventType = isTouchDevice ? 'touchstart' : 'click';
    document.addEventListener(eventType, processPress);
});

const config = {
    categories: [
        'money',
        'length', 'area', 'volume', 'mass', 'time', 'temp', 'energy', 'power',
        'data',
    ],

    categoriesAdvanced: [
        'speed',
        'angle',
        'pressure',
        'freq', 'force', 'current',
        'voltage', 'charge', 'cap', 'res',
        /*'lum intensity', 'illuminance', */ /*'radioactivity',  'absorbed dose', 'data rate' */
    ],

    defaultCategory: 'length',
    moneyflags: {
        'USD': '🇺🇸',  // United States
        'EUR': '🇪🇺',  // European Union
        'CNY': '🇨🇳',  // China
        'JPY': '🇯🇵',  // Japan
        'INR': '🇮🇳',  // India
        'MXN': '🇲🇽',  // Mexico
        'BRL': '🇧🇷',  // Brazil
        'KRW': '🇰🇷',  // South Korea
        'GBP': '🇬🇧',  // United Kingdom
        'AUD': '🇦🇺',  // Australia
        'CAD': '🇨🇦',  // Canada
        'HKD': '🇭🇰',  // Hong Kong
        'BTC': '₿',     // Bitcoin
        'AED': '🇦🇪',  // United Arab Emirates
        'AFN': '🇦🇫',  // Afghanistan
        'ALL': '🇦🇱',  // Albania
        'AMD': '🇦🇲',  // Armenia
        'ANG': '🇨🇼',  // Curaçao
        'AOA': '🇦🇴',  // Angola
        'ARS': '🇦🇷',  // Argentina
        'AWG': '🇦🇼',  // Aruba
        'AZN': '🇦🇿',  // Azerbaijan
        'BAM': '🇧🇦',  // Bosnia and Herzegovina
        'BBD': '🇧🇧',  // Barbados
        'BDT': '🇧🇩',  // Bangladesh
        'BGN': '🇧🇬',  // Bulgaria
        'BHD': '🇧🇭',  // Bahrain
        'BIF': '🇧🇮',  // Burundi
        'BMD': '🇧🇲',  // Bermuda
        'BND': '🇧🇳',  // Brunei
        'BOB': '🇧🇴',  // Bolivia
        'BSD': '🇧🇸',  // Bahamas
        'BTN': '🇧🇹',  // Bhutan
        'BWP': '🇧🇼',  // Botswana
        'BYN': '🇧🇾',  // Belarus
        'BZD': '🇧🇿',  // Belize
        'CDF': '🇨🇩',  // Democratic Republic of Congo
        'CHF': '🇨🇭',  // Switzerland
        'CLP': '🇨🇱',  // Chile
        'COP': '🇨🇴',  // Colombia
        'CRC': '🇨🇷',  // Costa Rica
        'CUC': '🇨🇺',  // Cuba
        'CVE': '🇨🇻',  // Cape Verde
        'CZK': '🇨🇿',  // Czech Republic
        'DJF': '🇩🇯',  // Djibouti
        'DKK': '🇩🇰',  // Denmark
        'DOP': '🇩🇴',  // Dominican Republic
        'DZD': '🇩🇿',  // Algeria
        'EGP': '🇪🇬',  // Egypt
        'ERN': '🇪🇷',  // Eritrea
        'ETB': '🇪🇹',  // Ethiopia
        'FJD': '🇫🇯',  // Fiji
        'FKP': '🇫🇰',  // Falkland Islands
        'GEL': '🇬🇪',  // Georgia
        'GGP': '🇬🇬',  // Guernsey
        'GHS': '🇬🇭',  // Ghana
        'GIP': '🇬🇮',  // Gibraltar
        'GMD': '🇬🇲',  // Gambia
        'GNF': '🇬🇳',  // Guinea
        'GTQ': '🇬🇹',  // Guatemala
        'GYD': '🇬🇾',  // Guyana
        'HNL': '🇭🇳',  // Honduras
        'HRK': '🇭🇷',  // Croatia
        'HTG': '🇭🇹',  // Haiti
        'HUF': '🇭🇺',  // Hungary
        'IDR': '🇮🇩',  // Indonesia
        'ILS': '🇮🇱',  // Israel
        'IMP': '🇮🇲',  // Isle of Man
        'IQD': '🇮🇶',  // Iraq
        'IRR': '🇮🇷',  // Iran
        'ISK': '🇮🇸',  // Iceland
        'JEP': '🇯🇪',  // Jersey
        'JMD': '🇯🇲',  // Jamaica
        'JOD': '🇯🇴',  // Jordan
        'KES': '🇰🇪',  // Kenya
        'KHR': '🇰🇭',  // Cambodia
        'KMF': '🇰🇲',  // Comoros
        'KPW': '🇰🇵',  // North Korea
        'KWD': '🇰🇼',  // Kuwait
        'KYD': '🇰🇾',  // Cayman Islands
        'KZT': '🇰🇿',  // Kazakhstan
        'LAK': '🇱🇦',  // Laos
        'LBP': '🇱🇧',  // Lebanon
        'LEV': '🇧🇬',  // Bulgaria (LEV is BGN)
        'LKR': '🇱🇰',  // Sri Lanka
        'LRD': '🇱🇷',  // Liberia
        'LSL': '🇱🇸',  // Lesotho
        'LYD': '🇱🇾',  // Libya
        'MAD': '🇲🇦',  // Morocco
        'MDL': '🇲🇩',  // Moldova
        'MGA': '🇲🇬',  // Madagascar
        'MKD': '🇲🇰',  // North Macedonia
        'MMK': '🇲🇲',  // Myanmar
        'MNT': '🇲🇳',  // Mongolia
        'MOP': '🇲🇴',  // Macau
        'MRU': '🇲🇷',  // Mauritania
        'MUR': '🇲🇺',  // Mauritius
        'MVR': '🇲🇻',  // Maldives
        'MWK': '🇲🇼',  // Malawi
        'MYR': '🇲🇾',  // Malaysia
        'MZN': '🇲🇿',  // Mozambique
        'NAD': '🇳🇦',  // Namibia
        'NGN': '🇳🇬',  // Nigeria
        'NIO': '🇳🇮',  // Nicaragua
        'NOK': '🇳🇴',  // Norway
        'NPR': '🇳🇵',  // Nepal
        'NZD': '🇳🇿',  // New Zealand
        'OMR': '🇴🇲',  // Oman
        'PAB': '🇵🇦',  // Panama
        'PEN': '🇵🇪',  // Peru
        'PGK': '🇵🇬',  // Papua New Guinea
        'PHP': '🇵🇭',  // Philippines
        'PKR': '🇵🇰',  // Pakistan
        'PLN': '🇵🇱',  // Poland
        'PYG': '🇵🇾',  // Paraguay
        'QAR': '🇶🇦',  // Qatar
        'RMB': '🇨🇳',  // China (RMB is CNY)
        'RON': '🇷🇴',  // Romania
        'RSD': '🇷🇸',  // Serbia
        'RUB': '🇷🇺',  // Russia
        'RWF': '🇷🇼',  // Rwanda
        'SAR': '🇸🇦',  // Saudi Arabia
        'SBD': '🇸🇧',  // Solomon Islands
        'SCR': '🇸🇨',  // Seychelles
        'SDG': '🇸🇩',  // Sudan
        'SEK': '🇸🇪',  // Sweden
        'SGD': '🇸🇬',  // Singapore
        'SHP': '🇸🇭',  // Saint Helena
        'SLL': '🇸🇱',  // Sierra Leone
        'SOS': '🇸🇴',  // Somalia
        'SRD': '🇸🇷',  // Suriname
        'SSP': '🇸🇸',  // South Sudan
        'STD': '🇸🇹',  // São Tomé and Príncipe
        'STN': '🇸🇹',  // São Tomé and Príncipe
        'SVC': '🇸🇻',  // El Salvador
        'SYP': '🇸🇾',  // Syria
        'SZL': '🇸🇿',  // Eswatini
        'THB': '🇹🇭',  // Thailand
        'TJS': '🇹🇯',  // Tajikistan
        'TMT': '🇹🇲',  // Turkmenistan
        'TND': '🇹🇳',  // Tunisia
        'TOP': '🇹🇴',  // Tonga
        'TRY': '🇹🇷',  // Turkey
        'TTD': '🇹🇹',  // Trinidad and Tobago
        'TWD': '🇹🇼',  // Taiwan
        'TZS': '🇹🇿',  // Tanzania
        'UAH': '🇺🇦',  // Ukraine
        'UGX': '🇺🇬',  // Uganda
        'UYU': '🇺🇾',  // Uruguay
        'UZS': '🇺🇿',  // Uzbekistan
        'VES': '🇻🇪',  // Venezuela
        'VND': '🇻🇳',  // Vietnam
        'VUV': '🇻🇺',  // Vanuatu
        'WON': '🇰🇷',  // South Korea (WON is KRW)
        'WST': '🇼🇸',  // Samoa
        'XAF': '🏳️',    // Central African CFA franc
        'XAG': '🥈',     // Silver
        'XAU': '🥇',     // Gold
        'XCD': '🏳️',    // East Caribbean dollar
        'XDR': '🏦',     // Special Drawing Rights
        'XOF': '🏳️',    // West African CFA franc
        'XPD': '⚪',     // Palladium
        'XPF': '🏳️',    // CFP franc
        'XPT': '⚪',     // Platinum
        'YEN': '🇯🇵',  // Japan (YEN is JPY)
        'YER': '🇾🇪',  // Yemen
        'ZAR': '🇿🇦',  // South Africa
        'ZMW': '🇿🇲',  // Zambia
        'ZWL': '🇿🇼'   // Zimbabwe
    },
    units: {
        money: ['USD', 'EUR', 'CNY', 'JPY', 'INR', 'MXN', 'BRL', 'KRW', 'GBP', 'AUD', 'CAD', 'HKD', 'BTC', "---", "AED", "AFN", "ALL", "AMD", "ANG", "AOA", "ARS", "AUD", "AWG", "AZN", "BAM", "BBD", "BDT", "BGN", "BHD", "BIF", "BMD", "BND", "BOB", "BRL", "BSD", "BTC", "BTN", "BWP", "BYN", "BZD", "CAD", "CDF", "CHF", "CLF", "CLP", "CNH", "CNY", "COP", "CRC", "CUC", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EGP", "ERN", "ETB", "EUR", "FJD", "FKP", "GBP", "GEL", "GGP", "GHS", "GIP", "GMD", "GNF", "GTQ", "GYD", "HKD", "HNL", "HRK", "HTG", "HUF", "IDR", "ILS", "IMP", "INR", "IQD", "IRR", "ISK", "JEP", "JMD", "JOD", "JPY", "KES", "KHR", "KMF", "KPW", "KRW", "KWD", "KYD", "KZT", "LAK", "LBP", "LEV", "LKR", "LRD", "LSL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MNT", "MOP", "MRU", "MUR", "MVR", "MWK", "MXN", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PGK", "PHP", "PKR", "PLN", "PYG", "QAR", "RMB", "RON", "RSD", "RUB", "RWF", "SAR", "SBD", "SCR", "SDG", "SEK", "SGD", "SHP", "SLL", "SOS", "SRD", "SSP", "STD", "STN", "SVC", "SYP", "SZL", "THB", "TJS", "TMT", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "UYU", "UZS", "VES", "VND", "VUV", "WON", "WST", "XAF", "XAG", "XAU", "XCD", "XDR", "XOF", "XPD", "XPF", "XPT", "YEN", "YER", "ZAR", "ZMW", "ZWL"],
        length: ['meter', 'kilometer', 'centimeter', 'millimeter', 'micrometer', 'nanometer', 'inch', 'foot', 'yard', 'mile', 'lightyear', 'astronomical unit', 'parsec'],
        area: ['square meter', 'square kilometer', 'square centimeter', 'square millimeter', 'square foot', 'square inch', 'square yard', 'square mile', 'acre', 'hectare'],
        volume: ['cubic meter', 'liter', 'milliliter', 'cubic centimeter', 'cubic foot', 'cubic inch', 'gallon', 'quart', 'pint', 'cup', 'fluid ounce', 'tablespoon', 'teaspoon'],
        mass: ['kilogram', 'gram', 'milligram', 'microgram', 'metric ton', 'pound', 'ounce', 'stone', 'short ton', 'long ton'],
        time: ['second', 'millisecond', 'microsecond', 'nanosecond', 'minute', 'hour', 'day', 'week', 'month', 'year', 'decade', 'century'],
        temp: ['celsius', 'fahrenheit', 'kelvin'],
        energy: ['joule', 'kilojoule', 'calorie', 'kilocalorie', 'watt hour', 'kilowatt hour', 'electronvolt', 'british thermal unit'],
        power: ['watt', 'kilowatt', 'megawatt', 'horsepower'],
        pressure: ['pascal', 'kilopascal', 'bar', 'atmosphere', 'torr', 'psi'],
        speed: ['meter per second', 'kilometer per hour', 'mile per hour', 'foot per second', 'knot'],
        data: ['bit', 'byte', 'kilobyte', 'megabyte', 'gigabyte', 'terabyte', 'petabyte'],
        'data rate': ['bit per second', 'byte per second', 'kilobit per second', 'megabit per second', 'gigabit per second'],
        angle: ['degree', 'radian', 'gradian', 'arcminute', 'arcsecond'],
        freq: ['hertz', 'kilohertz', 'megahertz', 'gigahertz'],
        force: ['newton', 'kilonewton', 'pound force', 'kilogram force'],
        'current': ['ampere', 'milliampere', 'microampere'],
        'voltage': ['volt', 'kilovolt', 'millivolt'],
        'charge': ['coulomb', 'ampere hour', 'milliampere hour'],
        'cap': ['farad', 'microfarad', 'nanofarad', 'picofarad'],
        'res': ['ohm', 'kiloohm', 'megaohm'],
        'lum intensity': ['candela', 'lumen'],
        illuminance: ['lux', 'foot candle'],
        radioactivity: ['becquerel', 'curie'],
        'absorbed dose': ['gray', 'rad', 'sievert'],
    },
    defaultUnits: {
        money: ['USD', 'EUR'],
        length: ['meter', 'foot'],
        area: ['square meter', 'square foot'],
        volume: ['liter', 'gallon'],
        mass: ['kilogram', 'pound'],
        time: ['second', 'minute'],
        temp: ['celsius', 'fahrenheit'],
        energy: ['joule', 'calorie'],
        power: ['watt', 'horsepower'],
        pressure: ['pascal', 'psi'],
        speed: ['meter per second', 'mile per hour'],
        data: ['byte', 'megabyte'],
        'data rate': ['bit per second', 'megabit per second'],
        angle: ['degree', 'radian'],
        freq: ['hertz', 'kilohertz'],
        force: ['newton', 'pound force'],
        'current': ['ampere', 'milliampere'],
        'voltage': ['volt', 'kilovolt'],
        'charge': ['coulomb', 'ampere hour'],
        'cap': ['farad', 'microfarad'],
        'res': ['ohm', 'kiloohm'],
        'lum intensity': ['candela', 'lumen'],
        illuminance: ['lux', 'foot-candle'],
        radioactivity: ['becquerel', 'curie'],
        'absorbed dose': ['gray', 'sievert'],
    }
};

// Removed: unused variable that required InstaCalc to be loaded
// const currencyList = Object.keys(InstaCalc.Unit.currencies).filter(k => k.length == 3);

function createConversionUI(config, container) {
    let currentCategory = config.defaultCategory;
    let showMore = true;

    container.innerHTML = `
        <div class="flex items-center justify-between mx-4 mt-4 mb-2">
            <input class="w-2/5 p-2 text-center border rounded input1 border-color-soft text-color-default" value="1">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="relative w-6 h-6 cursor-pointer top-6 swap-button">
                <path stroke-linecap="round" stroke-linejoin="round" d="M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
            </svg>
            <input class="w-2/5 p-2 text-center border rounded input2 border-color-soft text-color-default">
        </div>
        <div class="flex items-center justify-between mx-4 mb-4">
            <select class="w-2/5 p-2 text-center rounded unit1"></select>
            <select class="w-2/5 p-2 text-center rounded unit2"></select>
        </div>
        <div class="grid grid-flow-row grid-cols-4 gap-1 p-1 overflow-x-scroll rounded-md category-buttons"></div>
    `;

    const categoryButtons = container.querySelector('.category-buttons');
    const [input1, input2] = container.querySelectorAll('input');
    const [unit1, unit2] = container.querySelectorAll('select');
    const swapButton = container.querySelector('.swap-button');

    function renderCategories() {
        const regularCategories = config.categories.map(createCategoryButton);
        const moreButton = createMoreButton();
        const advancedCategories = showMore ? config.categoriesAdvanced.map(createCategoryButton) : [];

        categoryButtons.innerHTML = '';
        categoryButtons.append(...regularCategories, ...advancedCategories);
        //categoryButtons.append(...regularCategories, moreButton, ...advancedCategories);
    }

    function createCategoryButton(category) {
        const button = document.createElement('button');
        button.className = `p-2 h-10 lg:h-10 rounded bg-secondary capitalize text-xs font-medium${category === currentCategory ? ' active' : ''}`;
        button.dataset.category = category;

        // If an SVG exists for this category, place it to the left of the label
        if (typeof categorySVG !== 'undefined' && categorySVG[category]) {
            // Use a flex container so the icon sits left of the label
            button.innerHTML = `
                        <span class="flex items-center justify-center gap-2">
                            ${categorySVG[category]}
                            <span class="capitalize">${category}</span>
                        </span>
                    `;
        } else {
            button.textContent = category;
        }

        return button;
    }

    const categorySVG = {
        "money": `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.415.33M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg>`,

        "length": `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
  stroke-width="1.5" stroke="currentColor" class="size-4">
    <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14M5 9v6m14-6v6" />
  </svg>`,

        "area": `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
  stroke-width="1.5" stroke="currentColor" class="size-4">
    <path stroke-linecap="round" stroke-linejoin="round" d="M3 4.5h18v15H3v-15Z" />
  </svg>`,

        "volume": `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="m21 7.5-9-5.25L3 7.5m18 0-9 5.25m9-5.25v9l-9 5.25M3 7.5l9 5.25M3 7.5v9l9 5.25m0-9v9" />
</svg>`,

        "mass": `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0 0 12 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 0 1-2.031.352 5.988 5.988 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.971Zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0 2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 0 1-2.031.352 5.989 5.989 0 0 1-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.971Z" />
</svg>`,

        "time": `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v6h4.5m4.5 0a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
</svg>`,

        "temp": `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
  stroke-width="1.5" stroke="currentColor" class="size-4">
    <path stroke-linecap="round" stroke-linejoin="round" d="M12 3v10.5m0 0a3.75 3.75 0 1 0
   0 7.5 3.75 3.75 0 0 0 0-7.5ZM10.5 3h3v10.5a5.25 5.25 0 1 1-3 0V3Z" />
  </svg>`,

        "energy": `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="M21 10.5h.375c.621 0 1.125.504 1.125 1.125v2.25c0 .621-.504 1.125-1.125 1.125H21M4.5 10.5H18V15H4.5v-4.5ZM3.75 18h15A2.25 2.25 0 0 0 21 15.75v-6a2.25 2.25 0 0 0-2.25-2.25h-15A2.25 2.25 0 0 0 1.5 9.75v6A2.25 2.25 0 0 0 3.75 18Z" />
</svg>`,

        "power": `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="m3.75 13.5 10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75Z" />
</svg>`,

        "data": `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="M20.25 6.375c0 2.278-3.694 4.125-8.25 4.125S3.75 8.653 3.75 6.375m16.5 0c0-2.278-3.694-4.125-8.25-4.125S3.75 4.097 3.75 6.375m16.5 0v11.25c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125V6.375m16.5 0v3.75m-16.5-3.75v3.75m16.5 0v3.75C20.25 16.153 16.556 18 12 18s-8.25-1.847-8.25-4.125v-3.75m16.5 0c0 2.278-3.694 4.125-8.25 4.125s-8.25-1.847-8.25-4.125" />
</svg>`,

        "speed": `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-4">
  <path stroke-linecap="round" stroke-linejoin="round" d="M15.59 14.37a6 6 0 0 1-5.84 7.38v-4.8m5.84-2.58a14.98 14.98 0 0 0 6.16-12.12A14.98 14.98 0 0 0 9.631 8.41m5.96 5.96a14.926 14.926 0 0 1-5.841 2.58m-.119-8.54a6 6 0 0 0-7.381 5.84h4.8m2.581-5.84a14.927 14.927 0 0 0-2.58 5.84m2.699 2.7c-.103.021-.207.041-.311.06a15.09 15.09 0 0 1-2.448-2.448 14.9 14.9 0 0 1 .06-.312m-2.24 2.39a4.493 4.493 0 0 0-1.757 4.306 4.493 4.493 0 0 0 4.306-1.758M16.5 9a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z" />
</svg>`,

        "angle": `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
  stroke-width="1.5" stroke="currentColor" class="size-4">
    <path stroke-linecap="round" stroke-linejoin="round" d="M3 20h18M13 4L3 20h10" />
  </svg>`,

        "pressure": `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="2 2 20 20"
  stroke-width="1.5" stroke="currentColor" class="size-4">
    <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0
  5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
  </svg>`,

        "freq": `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
  stroke-width="1.5" stroke="currentColor" class="size-4">
    <path stroke-linecap="round" stroke-linejoin="round" d="M3 12h4.5l3-9 3 18 3-9H21" />
  </svg>`,

        "force": `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
  stroke-width="1.5" stroke="currentColor" class="size-4">
    <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 19.5 15-15m0 0H8.25m11.25
   0v11.25" />
  </svg>`,

        "current": `<span class="inline-flex items-center justify-center w-4 h-4 font-serif text-base italic">I</span>`,

        "voltage": `<span class="inline-flex items-center justify-center w-4 h-4 font-serif text-base italic">V</span>`,

        "charge": `<span class="inline-flex items-center justify-center w-4 h-4 font-serif text-base italic">Q</span>`,

        "cap": `<span class="inline-flex items-center justify-center w-4 h-4 font-serif text-base italic">C</span>`,

        "res": `<span class="inline-flex items-center justify-center w-4 h-4 text-base">Ω</span>`,
    };


    function createMoreButton() {
        const button = document.createElement('button');
        button.className = 'flex items-center justify-center p-2 m-1 text-xs font-medium capitalize rounded bg-secondary more-button';
        button.dataset.category = 'more';
        button.title = showMore ? 'Show less categories' : 'Show more categories';
        //button.style.width = '2rem'; // Set a fixed width
        //button.style.height = '2rem'; // Set a fixed height

        const svg = `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-4 h-4 ${showMore ? 'rotate-180' : ''}">
            <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 5.25 7.5 7.5 7.5-7.5m-15 6 7.5 7.5 7.5-7.5"></path>
        </svg>
        `;

        button.innerHTML = svg;
        return button;
    }

    function updateUnits(category) {
        const options = config.units[category].map(unit => {
            // Add flag emoji for money units if available
            if (category === 'money' && config.moneyflags[unit]) {
                return `<option value="${config.moneyflags[unit]} ${unit}">${config.moneyflags[unit]} ${unit}</option>`;
            }
            return `<option value="${unit}">${unit}</option>`;
        }).join('');
        [unit1, unit2].forEach((select, index) => {
            select.innerHTML = options;
            const defaultUnit = config.defaultUnits[category][index] || config.units[category][index];
            // For money category, add the flag to the default value
            if (category === 'money' && config.moneyflags[defaultUnit]) {
                select.value = `${config.moneyflags[defaultUnit]} ${defaultUnit}`;
            } else {
                select.value = defaultUnit;
            }
        });
    }

    function convert(e) {
        // If no event or event target isn't input2/unit2, assume input1 is the source
        const isInput2Source = e && (e.target === input2);

        const sourceInput = isInput2Source ? input2 : input1;
        const sourceUnit = isInput2Source ? unit2 : unit1;
        const targetInput = isInput2Source ? input1 : input2;
        const targetUnit = isInput2Source ? unit1 : unit2;

        const quantity = sourceInput.value;
        // Strip flag emoji from currency codes if present (e.g., "🇺🇸 USD" → "USD")
        const fromUnit = sourceUnit.value.replace(/^[^\s]+\s/, '').trim() || sourceUnit.value;
        const toUnit = targetUnit.value.replace(/^[^\s]+\s/, '').trim() || targetUnit.value;

        if (!quantity.length) {
            return;
        }

        try {
            let result = IC.parser.quickEval(`${quantity} ${fromUnit} to ${toUnit}`);

            // For money conversions, use Intl.NumberFormat for proper formatting
            if (currentCategory === 'money' && !isNaN(result)) {
                // For very small numbers (< 0.01), show more decimal places
                const maxDecimals = result < 0.01 ? 6 : 2;
                const formatter = new Intl.NumberFormat('en-US', {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: maxDecimals
                });
                result = formatter.format(result);
            }

            targetInput.value = result;
        } catch (error) {
            console.error(`Conversion error: ${error.message}`);
            targetInput.value = '';
        }
    }

    categoryButtons.addEventListener('click', e => {
        const button = e.target.closest('button');
        if (!button) return; // Click was not on a button or its contents

        const category = button.dataset.category;
        if (category === 'more') {
            showMore = !showMore;
            renderCategories();
        } else if (category) {
            currentCategory = category;
            updateUnits(currentCategory);
            convert();
            renderCategories();
        }
    });

    [input1, input2, unit1, unit2].forEach(el => el.addEventListener('input', convert));
    swapButton.addEventListener('click', () => {
        [unit1.value, unit2.value] = [unit2.value, unit1.value];
        convert();
    });

    renderCategories();
    updateUnits(currentCategory);
    convert();
}

;
// Function to decompress gzipped content
async function decompressGzip(gzippedData) {
    const decompressedStream = new Response(gzippedData).body
        .pipeThrough(new DecompressionStream('gzip'));
    return await new Response(decompressedStream).arrayBuffer();
}

// Function to convert ArrayBuffer to string
function arrayBufferToString(buffer) {
    return new TextDecoder().decode(buffer);
}

let miniSearch = null;
let loadAttempts = 0;
const MAX_LOAD_ATTEMPTS = 50; // 50 attempts * 100ms = 5 seconds

function loadRemoteCalcIndex() {
    // Check if MiniSearch is available (loaded from CDN)
    if (typeof MiniSearch === 'undefined') {
        loadAttempts++;
        if (loadAttempts >= MAX_LOAD_ATTEMPTS) {
            console.error('MiniSearch failed to load after 5 seconds. Search functionality unavailable.');
            return;
        }
        setTimeout(loadRemoteCalcIndex, 100);
        return;
    }

    const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    //const indexUrl = isLocalhost ? 'https://instacalc.com/index.json.gz?dl=1' : '/index.json.gz?dl=1';
    const indexUrl = 'https://instacalc.com/index.json.gz?dl=1'; // force remote


    fetch(indexUrl, {
        method: 'GET',
        headers: {
            'Accept': 'application/gzip',
        },
    })
        .then(response => response.arrayBuffer())
        .then(async gzippedData => {
            const decompressedBuffer = await decompressGzip(gzippedData);
            const jsonString = arrayBufferToString(decompressedBuffer);
            const indexData = JSON.parse(jsonString);
            //console.log('Loaded remote index');

            miniSearch = MiniSearch.loadJS(indexData.index, {
                fields: ['name', 'rows'],      // Include fields required for MiniSearch
                storeFields: ['name', 'updated']
            });
        })
        .catch((error) => console.error('Error:', error));
}

function calcSearch(query) {
    if (miniSearch) {
        const results = miniSearch.search(query, {
            fuzzy: 0.2,
            prefix: true,
            boost: { name: 4 }
        });
        return results.slice(0, 30);
    }
}

loadRemoteCalcIndex();

function searchUI() {
    return {
        searchQuery: '',
        searchResults: [],
        groupedResults: [],
        showResults: false,
        selectedResult: null,
        embedId: null,
        saveStatus: 'Save to my calcs',

        docResults: [],

        // Platform detection for keyboard shortcuts
        isMac: navigator.platform.toUpperCase().indexOf('MAC') >= 0 ||
            navigator.platform.toUpperCase().indexOf('IPHONE') >= 0 ||
            navigator.platform.toUpperCase().indexOf('IPAD') >= 0,

        // Computed property for keyboard shortcut display
        get keyboardShortcut() {
            return this.isMac ? '⌘K' : 'Ctrl+K';
        },

        init() {
            try {
                this.localIndex = this.buildLocalSearchIndex();
            } catch (error) {
                console.error('Error building local search index:', error);
            }
        },

        waiting: false,
        debounceTimeout: null,
        async search() {
            // Clear the previous debounce timeout
            clearTimeout(this.debounceTimeout);

            this.waiting = true;
            // Set a new debounce timeout
            this.debounceTimeout = setTimeout(async () => {
                if (this.searchQuery.length > 1) {
                    try {
                        //const response = await fetch(`/search?q=${encodeURIComponent(this.searchQuery)}`);
                        //const data = await response.json();
                        //this.searchResults = data.results;
                        this.searchResults = calcSearch(this.searchQuery);

                        // order results where "instacalc" is in the title, up top
                        this.searchResults.sort((a, b) => {
                            if (a.name.toLowerCase().includes('instacalc') && !b.name.toLowerCase().includes('instacalc')) {
                                return -1;
                            } else if (!a.name.toLowerCase().includes('instacalc') && b.name.toLowerCase().includes('instacalc')) {
                                return 1;
                            } else {
                                return 0;
                            }
                        });

                        this.groupResults();
                        if (this.searchResults.length > 0) {
                            this.selectResult(this.searchResults[0]);
                        }
                    } catch (error) {
                        console.error('Error fetching search results:', error);
                        this.searchResults = [];
                        this.groupedResults = [];
                    }
                } else {
                    this.searchResults = [];
                    this.groupedResults = [];
                }

                setTimeout(() => {
                    this.waiting = false;
                }, 100);
            }, 100);

            this.docSearch(this.searchQuery);
        },

        buildLocalSearchIndex() {
            const index = [];
            const unitGroups = new Map();

            function formatSIUnitDefinition(siDefinition) {
                if (!siDefinition) return '';

                const unitParts = [];
                for (const [unit, power] of Object.entries(siDefinition)) {
                    if (power === 1) {
                        unitParts.push(unit);
                    } else if (power !== 0) {
                        unitParts.push(`${unit}^${power}`);
                    }
                }

                return unitParts.join(' ');
            }

            // Group units from InstaCalc.Unit
            for (const unitKey in InstaCalc.Unit) {
                const unitObject = InstaCalc.Unit[unitKey];
                if (typeof unitObject === 'object' && unitObject !== null) {
                    const baseUnit = unitObject.base || 1;
                    const unitName = unitObject.name || unitKey;
                    const siDefinition = unitObject.SI ? formatSIUnitDefinition(unitObject.SI) : '';

                    for (const alias in unitObject) {
                        const conversionFactor = Number(unitObject[alias]);
                        if (alias != "base" && alias != "SI" && !isNaN(conversionFactor)) {
                            const groupKey = `${unitName}-${conversionFactor}`;

                            const absConversionFactor = Math.abs(conversionFactor);
                            const shouldUseScientific = absConversionFactor > 1000 || absConversionFactor < 0.001;

                            conversionFactorStr = shouldUseScientific
                                ? conversionFactor.toExponential()
                                : conversionFactor.toString();

                            // replace .000000e with e
                            conversionFactorStr = conversionFactorStr.replace(/\.0+e/, 'e');

                            if (!unitGroups.has(groupKey)) {
                                unitGroups.set(groupKey, {
                                    type: 'unit',
                                    name: alias,
                                    aliases: [],
                                    description: siDefinition
                                        ? `${unitName}: ${conversionFactorStr} * (${siDefinition})`
                                        : `${unitName}: ${conversionFactorStr} * base unit`,
                                    category: 'Units',
                                    baseUnit: baseUnit,
                                    conversionFactor: conversionFactor,
                                    siDefinition: siDefinition
                                });
                            }

                            unitGroups.get(groupKey).aliases.push(alias);
                        }
                    }

                    // Add SI definition if present
                    if (unitObject.SI) {
                        index.push({
                            type: 'unit_si',
                            name: unitName,
                            description: `SI definition: ${siDefinition}`,
                            category: 'SI Units',
                            siDefinition: siDefinition
                        });
                    }
                }
            }

            // Add grouped units to the index
            for (const group of unitGroups.values()) {
                index.push(group);
            }

            // Index predefined functions from CONFIG
            for (const func in CONFIG.FUNCTION_USAGE_MSG) {
                index.push({
                    type: 'function',
                    name: func,
                    description: CONFIG.FUNCTION_USAGE_MSG[func],
                    category: 'Functions'
                });
            }

            // Index predefined variables from CONFIG
            for (const variable in CONFIG.PREDEFINED) {
                const isFunction = typeof CONFIG.PREDEFINED[variable] === 'function';
                let value = null;
                if (isFunction) {
                    value = CONFIG.PREDEFINED[variable]();
                }

                index.push({
                    type: 'variable',
                    name: variable,
                    description: isFunction ? IC.ICObjectPrettyPrint(value) : JSON.stringify(CONFIG.PREDEFINED[variable]),
                    category: 'Predefined Variables'
                });
            }

            // Add FLEX_UNIT_ALIAS units
            for (const [alias, data] of Object.entries(CONFIG.FLEX_UNIT_ALIAS)) {
                index.push({
                    type: 'unit',
                    name: alias,
                    description: `${data.scale} ${data.type} `,
                    category: 'Units',
                    scale: data.scale,
                    baseType: data.type
                });
            }

            // console.log("Local search index built with", index.length, "items");
            return index;
        },

        async docSearch(query) {
            const RESULT_LIMIT = 30;
            query = query.toLowerCase().trim();
            let index = this.localIndex;
            let exactMatch = null;
            let exactMatchInDescription = [];
            let startsWithMatches = [];
            let containsMatches = [];
            let otherMatches = [];

            try {
                for (let item of index) {
                    const nameLower = item.name.toLowerCase();
                    const descriptionLower = item?.description?.toLowerCase();
                    let isStartsWithMatch = false;
                    let isContainsMatch = false;

                    // Check for exact match
                    if (nameLower === query) {
                        exactMatch = item;
                        continue;
                    }

                    // Check name
                    if (nameLower.startsWith(query)) {
                        isStartsWithMatch = true;
                    } else if (nameLower.includes(query)) {
                        isContainsMatch = true;
                    }

                    // Check aliases
                    if (item.aliases) {
                        for (let alias of item.aliases) {
                            const aliasLower = alias.toLowerCase();
                            if (aliasLower === query) {
                                exactMatch = item;
                                break;
                            } else if (aliasLower.startsWith(query)) {
                                isStartsWithMatch = true;
                                break;
                            } else if (aliasLower.includes(query)) {
                                isContainsMatch = true;
                            }
                        }
                    }

                    // Check description
                    if (descriptionLower) {
                        const descriptionWords = descriptionLower.split(' ');
                        if (descriptionWords.includes(query)) {
                            exactMatchInDescription.push(item);
                            continue;
                        }
                    }

                    // Categorize the match
                    if (isStartsWithMatch) {
                        startsWithMatches.push(item);
                    } else if (isContainsMatch) {
                        containsMatches.push(item);
                    } else if (descriptionLower?.includes(query)) {
                        otherMatches.push(item);
                    }
                }
            } catch (error) {
                console.error('Error searching docs:', error);
            }

            // Combine results with priority
            let results = [];
            if (exactMatch) {
                results.push(exactMatch);
            }
            results = results.concat(exactMatchInDescription, startsWithMatches, containsMatches, otherMatches);

            // Limit results
            this.docResults = results.slice(0, RESULT_LIMIT);
        },

        formatDocResult(result) {
            let formatted = result.name;
            if (result.description) {
                formatted += ` - ${result.description}`;
            }
            return formatted;
        },

        groupResults() {
            const groups = {};
            this.searchResults.forEach(result => {
                if (!groups[result.name]) {
                    groups[result.name] = {
                        name: result.name,
                        items: [],
                        expanded: false
                    };
                }
                groups[result.name].items.push(result);
            });

            // Convert groups to an array and sort items by date
            this.groupedResults = Object.values(groups).map(group => {
                // Sort items by date (assuming result.updated is a valid date string or Date object)
                group.items.sort((a, b) => new Date(b.updated) - new Date(a.updated)); // Sort in descending order (newest first)
                return group;
            });

            // Expand the first group
            if (this.groupedResults.length > 0) {
                this.groupedResults[0].expanded = true;
            }
        },
        toggleGroup(index) {
            this.groupedResults[index].expanded = !this.groupedResults[index].expanded;

            // if the group was collapsed, select the first item in the group
            if (this.groupedResults[index].expanded) {
                this.selectResult(this.groupedResults[index].items[0]);
            }
        },
        clearSearch() {
            this.searchQuery = '';
            this.searchResults = [];
            this.groupedResults = [];
            this.showResults = false;
            this.selectedResult = null;
            this.embedId = null;
        },
        selectResult(result) {
            this.selectedResult = result;
            this.previewItem(result);
        },
        previewItem(result) {
            this.embedId = result?.id;
            const preview = this.$el.closest('.search')?.querySelector('.search-preview');
            if (preview) {
                preview.classList.remove('loaded');
                preview.classList.remove('load-failed');
                preview.setAttribute('embed-id', this.embedId);
                Action.scanForEmbed();
            } else {
                console.error('Preview element not found');
            }
        },

        formatDate(dateString) {
            if (!dateString) {
                return '';
            }

            const date = new Date(dateString);
            const now = new Date();
            const options = { month: 'numeric', day: 'numeric', year: '2-digit' };
            return date.toLocaleDateString('en-US', options);
        },

        saveCalc() {
            Action.saveEmbedCalc(this.embedId);
            this.saveStatus = 'Saved!';
            setTimeout(() => {
                this.saveStatus = 'Save to my calcs';
            }, 2000);
        },
    }
}

// Global reference for the search input
let globalSearchInput;

// Add the event listener
document.addEventListener('keydown', function (event) {
    // Initialize the globalSearchInput if it hasn't been set yet
    if (!globalSearchInput) {
        globalSearchInput = document.querySelector('.search input.globalsearch');
    }

    // Check if Cmd-K (on Mac) or Ctrl-K (on Windows/Linux) is pressed
    if ((event.metaKey || event.ctrlKey) && event.key === 'k' && globalSearchInput) {
        event.preventDefault(); // Prevent the default action

        // Show the input box and focus on it
        globalSearchInput.style.display = 'block'; // Make it visible
        globalSearchInput.focus(); // Focus the input box
        globalSearchInput.select(); // Select the existing text (if any)
    }
});;
       function markdownToHtml(markdownText) {
            // Convert headers
            markdownText = markdownText.replace(/^# (.+)$/gm, '<h1>$1</h1>');
            markdownText = markdownText.replace(/^## (.+)$/gm, '<h2>$1</h2>');

            // Convert bold
            markdownText = markdownText.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');

            // Convert italic
            markdownText = markdownText.replace(/\*(.+?)\*/g, '<em>$1</em>');

            // Convert unordered lists
            markdownText = markdownText.replace(/^\* (.+)$/gm, '<li>$1</li>');
            markdownText = markdownText.replace(/(<li>.*<\/li>)/s, '<ul>$1</ul>');

            return markdownText;
        }

        function chatInterface() {
            return {
                open: false,
                info: 1,
                messages: [],
                newMessage: '',
                analysisMessage: '',
                waiting: 0,
                error: '',
                clearConversation() {
                    this.error = '';
                    this.waiting = 0;
                    this.messages = [];
                },

                analyzeCalc() {
                    // submit current calc to the AI

                    // ask for improvements and suggestions

                    // show the results
                    let text = Action.getTextView(Action.getCurrentCalc(), "inputs");

                    this.newMessage = "Analyze this calc and give suggestions, enhancements, and improvements. A new, improved calculator must appear inside triple backticks (```). Be friendly yet succinct in your analysis. Here is the calc to analyze:  --- \n\n " + text + " ---";
                    this.analysisMessage = this.newMessage;
                    this.sendMessage();
                },

                render(message) {
                    if (message?.parts[0]?.text?.trim() == this.analysisMessage?.trim()) {
                        return "Calcy, enhance!";
                    }

                    // Process the message parts to create the content
                    let content = message.parts.map(part => part.text).join('');

                    // replace <start> and <end> with <pre> elements
                    content = content.replace("<start>", "<pre>");
                    content = content.replace("<end>", "</pre>");

                    // Replace code blocks with <pre> elements
                    content = content.replace(/```([\s\S]*?)```/g, function (match, p1) {
                        return `<pre>${p1.trim()}</pre>`;
                    });

                    // remove text outside of the pre block
                    content = content.replace(/<pre>([\s\S]*?)<\/pre>/g, function (match, p1) {
                        return match;
                    });

                    content = this.addButtonsToPreBlocks(content);
                    content = markdownToHtml(content);

                    // Return the processed content
                    return content;
                },

                addButtonsToPreBlocks(text = "") {
                    // Parse the content as DOM
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(text, 'text/html');

                    let preBlocks = doc.querySelectorAll('pre');

                    preBlocks.forEach((pre, index) => {
                        // Create a button element
                        const button = document.createElement('button');
                        button.classList = 'inline-block w-full text-color-highlight rounded shadow-md bg-highlight create-calc-button';
                        button.textContent = '+Create Calc';

                        // Insert the button after pre element
                        pre.parentNode.insertBefore(button, pre.nextSibling);
                    });

                    // convert to HTML
                    text = doc.body.innerHTML;

                    return text;
                },

                handleClick(event) {
                    if (event.target.matches('button.create-calc-button')) {
                        // Handle the button click
                        const button = event.target;
                        const pre = button.previousElementSibling;

                        if (!pre || pre.tagName.toLowerCase() !== 'pre') return;

                        // Get rows of text from <pre> element
                        const allRows = pre.textContent.split('\n').map(text => text.trim()).filter(text => text !== '');

                        let name, rows;

                        // Check if it's a single-line calc
                        if (allRows.length === 1) {
                            name = "New Calc";
                            rows = [{ text: allRows[0] }];
                        } else {
                            name = allRows[0].replace("//", "").trim();
                            rows = allRows.slice(1).map(text => ({ text }));
                        }

                        // Create and select the new calc
                        let calc = Action.create({ name, rows });
                        Action.select(calc.id);

                        // Change the button text to 'Calc created' and set a 5 second timer to reset it
                        let origContent = button.textContent;
                        button.textContent = 'Calc created!';
                        setTimeout(() => {
                            button.textContent = origContent;
                        }, 5000);
                    }
                },

                async sendMessage() {
                    const message = this.newMessage.trim();
                    this.newMessage = '';

                    if (message) {
                        // Add user's message to the messages array
                        this.messages.push({ role: 'user', parts: [{ text: message }] });

                        let CHAT_URL = Action.CURRENCY_URL.replace('/currencies.json', '/chat');
                        const userId = Action.getCurrentUserId();
                        this.waiting = 1;

                        let response;
                        let data;

                        try {
                            response = await fetch(CHAT_URL, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({
                                    message: message,
                                    userId,
                                    messages: this.messages
                                })
                            });
                            data = await response.json();
                        } catch (error) {
                            this.error = 'Error sending message: ' + error;
                            return;
                        }

                        this.waiting = 0;

                        if (!response?.ok) {
                            console.error('Error sending message:', response.status);
                            this.error = 'Error sending message: ' + JSON.stringify(response);
                            return;
                        }


                        // Add AI's reply to the messages array
                        this.messages.push({ role: 'model', parts: [{ text: data.reply }] });

                        // Scroll to the bottom of the messages container
                        this.$nextTick(() => {
                            this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
                        });
                    }
                },
            };
        }